"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.slate = window.slate || {};
window.theme = window.theme || {};
$.code = $.code || {}; // adding privacy cookie in global var so we don't need to call it everytime

var GlobalPrivacyCookie = null;
var privacyCookieInterval = window.setInterval(checkPrivacyCookie, 5000);

function checkPrivacyCookie() {
  if (getCookie("privacy-cookie")) {
    GlobalPrivacyCookie = JSON.parse(getCookie("privacy-cookie"));
    window.clearInterval(privacyCookieInterval);
  }
}
/****************************************************************
 * Js imports
 ****************************************************************/

/* external scripts */

/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */


slate.a11y = {
  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function pageLinkFocus($element) {
    var focusClass = 'js-focus-hidden';
    $element.first().attr('tabIndex', '-1').focus().addClass(focusClass).one('blur', callback);

    function callback() {
      $element.first().removeClass(focusClass).removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function focusHash() {
    var hash = window.location.hash; // is there a hash in the url? is it an element on the page?

    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function bindInPageLinks() {
    $('a[href*=#]').on('click', function (evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function trapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();
    $(document).on(eventName, function (evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function removeTrapFocus(options) {
    var eventName = options.namespace ? 'focusin.' + options.namespace : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};
/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {
  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function cookiesEnabled() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
      document.cookie = 'testcookie';
      cookieEnabled = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
  }
};
/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {
  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function findInstance(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function removeInstance(array, key, value) {
    var i = array.length;

    while (i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function compact(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];

      if (value) {
        result[resIndex++] = value;
      }
    }

    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  }
};
/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap videos in div to force responsive layout.
 *
 * @namespace rte
 */

slate.rte = {
  wrapTable: function wrapTable() {
    $('.content-text table').wrap('<div class="rte__table-wrapper"></div>');
  },
  iframeReset: function iframeReset() {
    var $iframeVideo = $('.content-text iframe[src*="youtube.com/embed"], .content-text iframe[src*="player.vimeo"]');
    var $iframeReset = $iframeVideo.add('.content-text iframe#admin_bar_iframe');
    $iframeVideo.each(function () {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="rte__video-wrapper"></div>');
    });
    $iframeReset.each(function () {
      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];
  $(document).on('shopify:section:load', this._onSectionLoad.bind(this)).on('shopify:section:unload', this._onSectionUnload.bind(this)).on('shopify:section:select', this._onSelect.bind(this)).on('shopify:section:deselect', this._onDeselect.bind(this)).on('shopify:section:reorder', this._onReorder.bind(this)).on('shopify:block:select', this._onBlockSelect.bind(this)).on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function _createInstance(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');
    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });
    this.instances.push(instance);
  },
  _onSectionLoad: function _onSectionLoad(evt) {
    var container = $('[data-section-id]', evt.target)[0];

    if (container) {
      this._createInstance(container);
    }
  },
  _onSectionUnload: function _onSectionUnload(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },
  _onSelect: function _onSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },
  _onDeselect: function _onDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },
  _onReorder: function _onReorder(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },
  _onBlockSelect: function _onBlockSelect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },
  _onBlockDeselect: function _onBlockDeselect(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },
  register: function register(type, constructor) {
    this.constructors[type] = constructor;
    $('[data-section-type=' + type + ']').each(function (index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});
/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = function () {
  var moneyFormat = '${{amount}}';
  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }

    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;
    var moneyCentsDelimiter = theme.moneyCentsDelimiter;
    var moneyThousandsDelimiter = theme.moneyThousandsDelimiter;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, moneyThousandsDelimiter);
      decimal = slate.utils.defaultTo(decimal, moneyCentsDelimiter);

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';
      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;

      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;

      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', moneyCentsDelimiter);
        break;

      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, moneyThousandsDelimiter, moneyCentsDelimiter);
        break;

      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, moneyThousandsDelimiter, moneyCentsDelimiter);
        break;

      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
}();
/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */


slate.Image = function () {
  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */
  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }
  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */


  function loadImage(path) {
    new Image().src = path;
  }
  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */


  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }
  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */


  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];
      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
}();
/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */


slate.Variants = function () {
  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();
    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {
    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function _getCurrentOptions() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function (element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');
            $element.closest('label').addClass('checked');
            return currentOption;
          } else {
            $element.closest('label').removeClass('checked');
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');
          return currentOption;
        }
      }); // remove any unchecked input values if using radio buttons or checkboxes

      currentOptions = slate.utils.compact(currentOptions);
      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function _getVariantFromOptions() {
      var selectedValues = this._getCurrentOptions();

      var variants = this.product.variants;
      var found = false;
      variants.forEach(function (variant) {
        var satisfied = true;
        selectedValues.forEach(function (option) {
          if (satisfied) {
            satisfied = option.value === variant[option.index];
          }
        });

        if (satisfied) {
          found = variant;
        }
      });
      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function _onSelectChange() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);

      this._updateImages(variant);

      this._updatePrice(variant);

      this.currentVariant = variant;

      if (variant.compare_at_price > variant.price) {
        $('.product-images-slider-sale').find('.swiper-slide').first().find('figure').before('<span class="offer-sale" data-pdp-img-sale-badge>' + saleLabel + '</span>');
      }

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function _updateImages(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function _updatePrice(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param  {variant} variant - Currently selected variant
     * @return {k}         [description]
     */
    _updateHistoryState: function _updateHistoryState(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({
        path: newurl
      }, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param  {variant} variant - Currently selected variant
     */
    _updateMasterSelect: function _updateMasterSelect(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
      this.$container.trigger({
        type: 'masterSelectChange',
        variant: variant
      });
    }
  });
  return Variants;
}();
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */


theme.Product = function () {
  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartButton: '[data-ajax-cart-add-button]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    savingsBadge: '[data-savings-badge]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]',
    noStockMessage: '[data-product-nostock]',
    amazonMessageLink: '[data-product-nostock-amazon-link]',
    variantTitle: '[data-variant-title]',
    globalAmazonRedirectButton: '[data-global-amazon-redirect]',
    // Shop at Amazon button when redirecting all products to a.com during promo (DE)
    amazonRedirectText: '[data-amazon-redirect-text]',
    // button text for the above case
    secondaryAddToCartLink: '[data-add-to-cart-secondary]',
    // secondary ATC link under Shop at Amazon button when redirecting all products to a.com during promo (DE)
    //imgSaleBadge: '[data-pdp-img-sale-badge]'
    dualCtaAmazonButton: '[data-dual-cta-test-amazon-button]',
    // Secondary Shop at Amazon CTA for A/B test - EEC-2120/2311
    dualCtaAmazonButtonVariantUrl: '[data-dual-cta-test-variant-amazon-url]',
    preorderAmazonCta: '[data-add-to-cart-preorder]'
  };
  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */

  function Product(container) {
    this.$container = $(container); // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor

    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());
    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };
    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);
    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);
      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {
    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function updateAddToCartState(evt) {
      var variant = evt.variant;
      var variantData = $('.variant-stock > data');
      var variantinventory = '';
      var variantPolicy = '';
      var variantAmazonRedirect = false;
      var variantAmazonLink = '';
      var variantStockStatus = '';
      var variantNotify = '';
      var variantHideAtfTwisters = '';
      variantData.each(function () {
        if ($(this).data("id") == variant.id) {
          variantinventory = $(this).data("inv");
          variantPolicy = $(this).data("policy");
          variantAmazonRedirect = $(this).data("amazon-redirect");
          variantAmazonLink = $(this).data("amazon-url");
          variantStockStatus = $(this).data("stock-status");
          variantNotify = $(this).data("variant-notify");
          variantHideAtfTwisters = $(this).data("hide-atf-twisters");
        }
      });

      if (variantHideAtfTwisters == 1) {
        $('.twisters-block__multipack, .twisters-block__power-source').slideUp();
      } else {
        $('.twisters-block__multipack, .twisters-block__power-source').slideDown();
      }

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCart, this.$container).removeAttr('data-ajax-cart-add-button');
        $(selectors.addToCart, this.$container).attr('type', 'submit');
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available && variantinventory > 0) {
        // product variable is available
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCart, this.$container).removeClass('hide');
        $(selectors.addToCart, this.$container).attr('data-ajax-cart-add-button', '');
        $(selectors.addToCart, this.$container).attr('type', 'submit');
        $(selectors.addToCart, this.$container).attr('disabled', false);
        $(selectors.addToCart).removeAttr('data-amazon-link');
        $(selectors.addToCart).attr('data-ajax-cart-add-button', '');
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
        $(selectors.amazonRedirectText).html(theme.strings.shopAmazon); // Updates 'Shop at Amazon' CTA text when variant is available

        $(selectors.globalAmazonRedirectButton).attr('href', variantAmazonLink); // Updates a.com redirect link on variant change

        $(selectors.secondaryAddToCartLink).show(); // Show secondary ATC link under 'Shop At Amazon' button

        $(selectors.dualCtaAmazonButton).removeClass('hide'); // Show secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

        $(selectors.dualCtaAmazonButton).attr('href', variantAmazonLink); // Update Shop at Amazon button URL in dual CTA A/B test - EEC-2120/2311

        $(selectors.noStockMessage, this.$container).hide();

        if ($('.variant-notify').length) {
          $('.variant-notify, .newsletter-section').hide();
        }

        if ($('#variant-quantity').length) {
          inventoryQuantity = variantinventory;
        }
      } else if (variantStockStatus === 'oos' && variantinventory < 1) {
        if (variantNotify === 'notify') {
          $('.variant-notify').show();
          $('.contact-form__product-handle').val(variant.name.replaceAll(' ', '-').replaceAll(',', '').replaceAll('(', '').replaceAll(')', ''));
          $(selectors.addToCart, this.$container).addClass('hide');
        } else {
          if ($('.variant-notify').length) {
            $('.variant-notify').hide();
          } // product variable is temporarily out of stock


          $(selectors.addToCart, this.$container).removeAttr('data-ajax-cart-add-button');
          $(selectors.addToCart, this.$container).prop('disabled', true); // $(selectors.addToCart, this.$container).attr('type', 'reset');

          if (variantAmazonRedirect) {
            $(selectors.addToCartText, this.$container).html(theme.strings.shopAmazon);
            $(selectors.addToCart).removeAttr('data-ajax-cart-add-button');
            $(selectors.addToCart).attr('data-amazon-link', variantAmazonLink);
            $(selectors.addToCart, this.$container).prop('disabled', false);
            $(selectors.globalAmazonRedirectButton).attr('href', variantAmazonLink); // Updates a.com redirect link on variant change when redirecting all products to a.com during promo (DE)

            $(selectors.secondaryAddToCartLink).hide(); // Hide secondary ATC link under Shop At Amazon button

            $(selectors.dualCtaAmazonButton).addClass('hide'); // Hide secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

            $(selectors.dualCtaAmazonButton).attr('href', variantAmazonLink); // Update Shop at Amazon button URL in dual CTA A/B test - EEC-2120/2311

            $(selectors.preorderAmazonCta).attr('href', variantAmazonLink); // Add this to make sure the no stock message points to the correct variant on Amazon, otherwise it loads the current_variant from Shopify

            $(selectors.amazonMessageLink).attr('href', variantAmazonLink);
            $(selectors.variantTitle).html(variant.title); // Show the no-stock message even when redirecting to Amazon

            $(selectors.noStockMessage, this.$container).html(theme.strings.amazonOOSMessage);
            $(selectors.noStockMessage, this.$container).show();
          } else {
            $(selectors.addToCartButton, this.$container).prop('disabled', true);
            $(selectors.addToCartButton).removeAttr('data-amazon-link');
            $(selectors.addToCartButton).attr('data-ajax-cart-add-button', '');
            $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
            $(selectors.noStockMessage, this.$container).show();
            $(selectors.dualCtaAmazonButton).addClass('hide'); // Hide secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

            $(selectors.preorderAmazonCta).attr('href', variantAmazonLink);
          }
        }
      } else if (variant.available && variantinventory < 1) {
        // product variable is temporarily out of stock
        $(selectors.addToCart, this.$container).removeAttr('data-ajax-cart-add-button');
        $(selectors.addToCart, this.$container).attr('type', 'reset');

        if (variantAmazonRedirect) {
          $(selectors.addToCartText, this.$container).html(theme.strings.shopAmazon);
          $(selectors.addToCart).removeAttr('data-ajax-cart-add-button');
          $(selectors.addToCart).attr('data-amazon-link', variantAmazonLink);
          $(selectors.dualCtaAmazonButton).addClass('hide'); // Hide secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

          $(selectors.preorderAmazonCta).attr('href', variantAmazonLink); // Add this to make sure the no stock message points to the correct variant on Amazon, otherwise it loads the current_variant from Shopify

          $(selectors.amazonMessageLink).attr('href', variantAmazonLink);
          $(selectors.variantTitle).html(variant.title); // Show the no-stock message even when redirecting to Amazon

          console.log('---', $(selectors.noStockMessage, this.$container));
          $(selectors.noStockMessage, this.$container).html(theme.strings.amazonOOSMessage);
          $(selectors.noStockMessage, this.$container).show();
        } else {
          $(selectors.addToCart, this.$container).prop('disabled', true);
          $(selectors.addToCart).removeAttr('data-amazon-link');
          $(selectors.addToCart).attr('data-ajax-cart-add-button', '');
          $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
          $(selectors.noStockMessage, this.$container).show();
          $(selectors.dualCtaAmazonButton).addClass('hide'); // Hide secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

          $(selectors.preorderAmazonCta).attr('href', variantAmazonLink);
        }
      } else {
        // product variable is sold out
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
        $(selectors.noStockMessage, this.$container).hide();
        $(selectors.dualCtaAmazonButton).addClass('hide'); // Hide secondary Shop at Amazon button in dual CTA A/B test - EEC-2120/2311

        $(selectors.preorderAmazonCta).attr('href', variantAmazonLink);
      }
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function updateProductPrices(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container).add(selectors.savingsBadge);
      $(selectors.productPrice, this.$container).html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function updateProductImage(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize); // this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function onUnload() {
      this.$container.off(this.namespace);
    }
  });
  return Product;
}();

$(document).ready(function () {
  var sections = new slate.Sections();
  sections.register('product', theme.Product); // Common a11y fixes

  slate.a11y.pageLinkFocus($(window.location.hash));
  $('[data-page-link-focus]').on('click', function (evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  }); // Wrap videos in div to force responsive layout.

  slate.rte.wrapTable();
  slate.rte.iframeReset(); // Apply a specific class to the html element for browser support of cookies.

  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }
});
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.AOS = t() : e.AOS = t();
}(this, function () {
  return function (e) {
    function t(o) {
      if (n[o]) return n[o].exports;
      var i = n[o] = {
        exports: {},
        id: o,
        loaded: !1
      };
      return e[o].call(i.exports, i, i.exports, t), i.loaded = !0, i.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.p = "dist/", t(0);
  }([function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    var i = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var o in n) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    },
        r = n(1),
        a = (o(r), n(6)),
        u = o(a),
        c = n(7),
        f = o(c),
        s = n(8),
        d = o(s),
        l = n(9),
        p = o(l),
        m = n(10),
        b = o(m),
        v = n(11),
        y = o(v),
        g = n(14),
        h = o(g),
        w = [],
        k = !1,
        x = document.all && !window.atob,
        j = {
      offset: 120,
      delay: 0,
      easing: "ease",
      duration: 400,
      disable: !1,
      once: !1,
      startEvent: "DOMContentLoaded",
      throttleDelay: 99,
      debounceDelay: 50,
      disableMutationObserver: !1
    },
        O = function O() {
      var e = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
      if (e && (k = !0), k) return w = (0, y.default)(w, j), (0, b.default)(w, j.once), w;
    },
        _ = function _() {
      w = (0, h.default)(), O();
    },
        S = function S() {
      w.forEach(function (e, t) {
        e.node.removeAttribute("data-aos"), e.node.removeAttribute("data-aos-easing"), e.node.removeAttribute("data-aos-duration"), e.node.removeAttribute("data-aos-delay");
      });
    },
        z = function z(e) {
      return e === !0 || "mobile" === e && p.default.mobile() || "phone" === e && p.default.phone() || "tablet" === e && p.default.tablet() || "function" == typeof e && e() === !0;
    },
        A = function A(e) {
      return j = i(j, e), w = (0, h.default)(), z(j.disable) || x ? S() : (document.querySelector("body").setAttribute("data-aos-easing", j.easing), document.querySelector("body").setAttribute("data-aos-duration", j.duration), document.querySelector("body").setAttribute("data-aos-delay", j.delay), "DOMContentLoaded" === j.startEvent && ["complete", "interactive"].indexOf(document.readyState) > -1 ? O(!0) : "load" === j.startEvent ? window.addEventListener(j.startEvent, function () {
        O(!0);
      }) : document.addEventListener(j.startEvent, function () {
        O(!0);
      }), window.addEventListener("resize", (0, f.default)(O, j.debounceDelay, !0)), window.addEventListener("orientationchange", (0, f.default)(O, j.debounceDelay, !0)), window.addEventListener("scroll", (0, u.default)(function () {
        (0, b.default)(w, j.once);
      }, j.throttleDelay)), j.disableMutationObserver || (0, d.default)("[data-aos]", _), w);
    };

    e.exports = {
      init: A,
      refresh: O,
      refreshHard: _
    };
  }, function (e, t) {},,,,, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function o(t) {
          var n = b,
              o = v;
          return b = v = void 0, k = t, g = e.apply(o, n);
        }

        function r(e) {
          return k = e, h = setTimeout(s, t), _ ? o(e) : g;
        }

        function a(e) {
          var n = e - w,
              o = e - k,
              i = t - n;
          return S ? j(i, y - o) : i;
        }

        function c(e) {
          var n = e - w,
              o = e - k;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }

        function s() {
          var e = O();
          return c(e) ? d(e) : void (h = setTimeout(s, a(e)));
        }

        function d(e) {
          return h = void 0, z && b ? o(e) : (b = v = void 0, g);
        }

        function l() {
          void 0 !== h && clearTimeout(h), k = 0, b = w = v = h = void 0;
        }

        function p() {
          return void 0 === h ? g : d(O());
        }

        function m() {
          var e = O(),
              n = c(e);

          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(s, t), o(w);
          }

          return void 0 === h && (h = setTimeout(s, t)), g;
        }

        var b,
            v,
            y,
            g,
            h,
            w,
            k = 0,
            _ = !1,
            S = !1,
            z = !0;

        if ("function" != typeof e) throw new TypeError(f);
        return t = u(t) || 0, i(n) && (_ = !!n.leading, S = "maxWait" in n, y = S ? x(u(n.maxWait) || 0, t) : y, z = "trailing" in n ? !!n.trailing : z), m.cancel = l, m.flush = p, m;
      }

      function o(e, t, o) {
        var r = !0,
            a = !0;
        if ("function" != typeof e) throw new TypeError(f);
        return i(o) && (r = "leading" in o ? !!o.leading : r, a = "trailing" in o ? !!o.trailing : a), n(e, t, {
          leading: r,
          maxWait: t,
          trailing: a
        });
      }

      function i(e) {
        var t = "undefined" == typeof e ? "undefined" : c(e);
        return !!e && ("object" == t || "function" == t);
      }

      function r(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : c(e));
      }

      function a(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : c(e)) || r(e) && k.call(e) == d;
      }

      function u(e) {
        if ("number" == typeof e) return e;
        if (a(e)) return s;

        if (i(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = i(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(l, "");
        var n = m.test(e);
        return n || b.test(e) ? v(e.slice(2), n ? 2 : 8) : p.test(e) ? s : +e;
      }

      var c = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      },
          f = "Expected a function",
          s = NaN,
          d = "[object Symbol]",
          l = /^\s+|\s+$/g,
          p = /^[-+]0x[0-9a-f]+$/i,
          m = /^0b[01]+$/i,
          b = /^0o[0-7]+$/i,
          v = parseInt,
          y = "object" == ("undefined" == typeof t ? "undefined" : c(t)) && t && t.Object === Object && t,
          g = "object" == ("undefined" == typeof self ? "undefined" : c(self)) && self && self.Object === Object && self,
          h = y || g || Function("return this")(),
          w = Object.prototype,
          k = w.toString,
          x = Math.max,
          j = Math.min,
          O = function O() {
        return h.Date.now();
      };

      e.exports = o;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    (function (t) {
      "use strict";

      function n(e, t, n) {
        function i(t) {
          var n = b,
              o = v;
          return b = v = void 0, O = t, g = e.apply(o, n);
        }

        function r(e) {
          return O = e, h = setTimeout(s, t), _ ? i(e) : g;
        }

        function u(e) {
          var n = e - w,
              o = e - O,
              i = t - n;
          return S ? x(i, y - o) : i;
        }

        function f(e) {
          var n = e - w,
              o = e - O;
          return void 0 === w || n >= t || n < 0 || S && o >= y;
        }

        function s() {
          var e = j();
          return f(e) ? d(e) : void (h = setTimeout(s, u(e)));
        }

        function d(e) {
          return h = void 0, z && b ? i(e) : (b = v = void 0, g);
        }

        function l() {
          void 0 !== h && clearTimeout(h), O = 0, b = w = v = h = void 0;
        }

        function p() {
          return void 0 === h ? g : d(j());
        }

        function m() {
          var e = j(),
              n = f(e);

          if (b = arguments, v = this, w = e, n) {
            if (void 0 === h) return r(w);
            if (S) return h = setTimeout(s, t), i(w);
          }

          return void 0 === h && (h = setTimeout(s, t)), g;
        }

        var b,
            v,
            y,
            g,
            h,
            w,
            O = 0,
            _ = !1,
            S = !1,
            z = !0;

        if ("function" != typeof e) throw new TypeError(c);
        return t = a(t) || 0, o(n) && (_ = !!n.leading, S = "maxWait" in n, y = S ? k(a(n.maxWait) || 0, t) : y, z = "trailing" in n ? !!n.trailing : z), m.cancel = l, m.flush = p, m;
      }

      function o(e) {
        var t = "undefined" == typeof e ? "undefined" : u(e);
        return !!e && ("object" == t || "function" == t);
      }

      function i(e) {
        return !!e && "object" == ("undefined" == typeof e ? "undefined" : u(e));
      }

      function r(e) {
        return "symbol" == ("undefined" == typeof e ? "undefined" : u(e)) || i(e) && w.call(e) == s;
      }

      function a(e) {
        if ("number" == typeof e) return e;
        if (r(e)) return f;

        if (o(e)) {
          var t = "function" == typeof e.valueOf ? e.valueOf() : e;
          e = o(t) ? t + "" : t;
        }

        if ("string" != typeof e) return 0 === e ? e : +e;
        e = e.replace(d, "");
        var n = p.test(e);
        return n || m.test(e) ? b(e.slice(2), n ? 2 : 8) : l.test(e) ? f : +e;
      }

      var u = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
        return _typeof(e);
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
      },
          c = "Expected a function",
          f = NaN,
          s = "[object Symbol]",
          d = /^\s+|\s+$/g,
          l = /^[-+]0x[0-9a-f]+$/i,
          p = /^0b[01]+$/i,
          m = /^0o[0-7]+$/i,
          b = parseInt,
          v = "object" == ("undefined" == typeof t ? "undefined" : u(t)) && t && t.Object === Object && t,
          y = "object" == ("undefined" == typeof self ? "undefined" : u(self)) && self && self.Object === Object && self,
          g = v || y || Function("return this")(),
          h = Object.prototype,
          w = h.toString,
          k = Math.max,
          x = Math.min,
          j = function j() {
        return g.Date.now();
      };

      e.exports = n;
    }).call(t, function () {
      return this;
    }());
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      var n = new r(o);
      a = t, n.observe(i.documentElement, {
        childList: !0,
        subtree: !0,
        removedNodes: !0
      });
    }

    function o(e) {
      e && e.forEach(function (e) {
        var t = Array.prototype.slice.call(e.addedNodes),
            n = Array.prototype.slice.call(e.removedNodes),
            o = t.concat(n).filter(function (e) {
          return e.hasAttribute && e.hasAttribute("data-aos");
        }).length;
        o && a();
      });
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = window.document,
        r = window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver,
        a = function a() {};

    t.default = n;
  }, function (e, t) {
    "use strict";

    function n(e, t) {
      if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
    }

    function o() {
      return navigator.userAgent || navigator.vendor || window.opera || "";
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = function () {
      function e(e, t) {
        for (var n = 0; n < t.length; n++) {
          var o = t[n];
          o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, o.key, o);
        }
      }

      return function (t, n, o) {
        return n && e(t.prototype, n), o && e(t, o), t;
      };
    }(),
        r = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        a = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        u = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,
        c = /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        f = function () {
      function e() {
        n(this, e);
      }

      return i(e, [{
        key: "phone",
        value: function value() {
          var e = o();
          return !(!r.test(e) && !a.test(e.substr(0, 4)));
        }
      }, {
        key: "mobile",
        value: function value() {
          var e = o();
          return !(!u.test(e) && !c.test(e.substr(0, 4)));
        }
      }, {
        key: "tablet",
        value: function value() {
          return this.mobile() && !this.phone();
        }
      }]), e;
    }();

    t.default = new f();
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function n(e, t, _n) {
      var o = e.node.getAttribute("data-aos-once");
      t > e.position ? e.node.classList.add("aos-animate") : "undefined" != typeof o && ("false" === o || !_n && "true" !== o) && e.node.classList.remove("aos-animate");
    },
        o = function o(e, t) {
      var o = window.pageYOffset,
          i = window.innerHeight;
      e.forEach(function (e, r) {
        n(e, i + o, t);
      });
    };

    t.default = o;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(12),
        r = o(i),
        a = function a(e, t) {
      return e.forEach(function (e, n) {
        e.node.classList.add("aos-init"), e.position = (0, r.default)(e.node, t.offset);
      }), e;
    };

    t.default = a;
  }, function (e, t, n) {
    "use strict";

    function o(e) {
      return e && e.__esModule ? e : {
        default: e
      };
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var i = n(13),
        r = o(i),
        a = function a(e, t) {
      var n = 0,
          o = 0,
          i = window.innerHeight,
          a = {
        offset: e.getAttribute("data-aos-offset"),
        anchor: e.getAttribute("data-aos-anchor"),
        anchorPlacement: e.getAttribute("data-aos-anchor-placement")
      };

      switch (a.offset && !isNaN(a.offset) && (o = parseInt(a.offset)), a.anchor && document.querySelectorAll(a.anchor) && (e = document.querySelectorAll(a.anchor)[0]), n = (0, r.default)(e).top, a.anchorPlacement) {
        case "top-bottom":
          break;

        case "center-bottom":
          n += e.offsetHeight / 2;
          break;

        case "bottom-bottom":
          n += e.offsetHeight;
          break;

        case "top-center":
          n += i / 2;
          break;

        case "bottom-center":
          n += i / 2 + e.offsetHeight;
          break;

        case "center-center":
          n += i / 2 + e.offsetHeight / 2;
          break;

        case "top-top":
          n += i;
          break;

        case "bottom-top":
          n += e.offsetHeight + i;
          break;

        case "center-top":
          n += e.offsetHeight / 2 + i;
      }

      return a.anchorPlacement || a.offset || isNaN(t) || (o = t), n + o;
    };

    t.default = a;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function n(e) {
      for (var t = 0, n = 0; e && !isNaN(e.offsetLeft) && !isNaN(e.offsetTop);) {
        t += e.offsetLeft - ("BODY" != e.tagName ? e.scrollLeft : 0), n += e.offsetTop - ("BODY" != e.tagName ? e.scrollTop : 0), e = e.offsetParent;
      }

      return {
        top: n,
        left: t
      };
    };

    t.default = n;
  }, function (e, t) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function n(e) {
      return e = e || document.querySelectorAll("[data-aos]"), Array.prototype.map.call(e, function (e) {
        return {
          node: e
        };
      });
    };

    t.default = n;
  }]);
});
/*!
 * @name        easyzoom
 * @author       <>
 * @modified    Thursday, November 22nd, 2018
 * @version     2.5.2
 */

!function (t, e) {
  "use strict";

  "function" == typeof define && define.amd ? define(["jquery"], function (t) {
    e(t);
  }) : "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = t.EasyZoom = e(require("jquery")) : t.EasyZoom = e(t.jQuery);
}(this, function (i) {
  "use strict";

  var c,
      d,
      l,
      p,
      u,
      f,
      o = {
    loadingNotice: "Loading image",
    errorNotice: "The image could not be loaded",
    errorDuration: 2500,
    linkAttribute: "href",
    preventClicks: !0,
    beforeShow: i.noop,
    beforeHide: i.noop,
    onShow: i.noop,
    onHide: i.noop,
    onMove: i.noop
  };

  function s(t, e) {
    this.$target = i(t), this.opts = i.extend({}, o, e, this.$target.data()), void 0 === this.isOpen && this._init();
  }

  return s.prototype._init = function () {
    this.$link = this.$target.find("a"), this.$image = this.$target.find("img"), this.$flyout = i('<div class="easyzoom-flyout" />'), this.$notice = i('<div class="easyzoom-notice" />'), this.$target.on({
      "mousemove.easyzoom touchmove.easyzoom": i.proxy(this._onMove, this),
      "mouseleave.easyzoom touchend.easyzoom": i.proxy(this._onLeave, this),
      "mouseenter.easyzoom touchstart.easyzoom": i.proxy(this._onEnter, this)
    }), this.opts.preventClicks && this.$target.on("click.easyzoom", function (t) {
      t.preventDefault();
    });
  }, s.prototype.show = function (t, e) {
    var o = this;

    if (!1 !== this.opts.beforeShow.call(this)) {
      if (!this.isReady) return this._loadImage(this.$link.attr(this.opts.linkAttribute), function () {
        !o.isMouseOver && e || o.show(t);
      });
      this.$target.append(this.$flyout);
      var i = this.$target.outerWidth(),
          s = this.$target.outerHeight(),
          h = this.$flyout.width(),
          n = this.$flyout.height(),
          a = this.$zoom.width(),
          r = this.$zoom.height();
      (c = a - h) < 0 && (c = 0), (d = r - n) < 0 && (d = 0), l = c / i, p = d / s, this.isOpen = !0, this.opts.onShow.call(this), t && this._move(t);
    }
  }, s.prototype._onEnter = function (t) {
    var e = t.originalEvent.touches;
    this.isMouseOver = !0, e && 1 != e.length || (t.preventDefault(), this.show(t, !0));
  }, s.prototype._onMove = function (t) {
    this.isOpen && (t.preventDefault(), this._move(t));
  }, s.prototype._onLeave = function () {
    this.isMouseOver = !1, this.isOpen && this.hide();
  }, s.prototype._onLoad = function (t) {
    t.currentTarget.width && (this.isReady = !0, this.$notice.detach(), this.$flyout.html(this.$zoom), this.$target.removeClass("is-loading").addClass("is-ready"), t.data.call && t.data());
  }, s.prototype._onError = function () {
    var t = this;
    this.$notice.text(this.opts.errorNotice), this.$target.removeClass("is-loading").addClass("is-error"), this.detachNotice = setTimeout(function () {
      t.$notice.detach(), t.detachNotice = null;
    }, this.opts.errorDuration);
  }, s.prototype._loadImage = function (t, e) {
    var o = new Image();
    this.$target.addClass("is-loading").append(this.$notice.text(this.opts.loadingNotice)), this.$zoom = i(o).on("error", i.proxy(this._onError, this)).on("load", e, i.proxy(this._onLoad, this)), o.style.position = "absolute", o.src = t;
  }, s.prototype._move = function (t) {
    if (0 === t.type.indexOf("touch")) {
      var e = t.touches || t.originalEvent.touches;
      u = e[0].pageX, f = e[0].pageY;
    } else u = t.pageX || u, f = t.pageY || f;

    var o = this.$target.offset(),
        i = f - o.top,
        s = u - o.left,
        h = Math.ceil(i * p),
        n = Math.ceil(s * l);
    if (n < 0 || h < 0 || c < n || d < h) this.hide();else {
      var a = -1 * h,
          r = -1 * n;
      this.$zoom.css({
        top: a,
        left: r
      }), this.opts.onMove.call(this, a, r);
    }
  }, s.prototype.hide = function () {
    this.isOpen && !1 !== this.opts.beforeHide.call(this) && (this.$flyout.detach(), this.isOpen = !1, this.opts.onHide.call(this));
  }, s.prototype.swap = function (t, e, o) {
    this.hide(), this.isReady = !1, this.detachNotice && clearTimeout(this.detachNotice), this.$notice.parent().length && this.$notice.detach(), this.$target.removeClass("is-loading is-ready is-error"), this.$image.attr({
      src: t,
      srcset: i.isArray(o) ? o.join() : o
    }), this.$link.attr(this.opts.linkAttribute, e);
  }, s.prototype.teardown = function () {
    this.hide(), this.$target.off(".easyzoom").removeClass("is-loading is-ready is-error"), this.detachNotice && clearTimeout(this.detachNotice), delete this.$link, delete this.$zoom, delete this.$image, delete this.$notice, delete this.$flyout, delete this.isOpen, delete this.isReady;
  }, i.fn.easyZoom = function (e) {
    return this.each(function () {
      var t = i.data(this, "easyZoom");
      t ? void 0 === t.isOpen && t._init() : i.data(this, "easyZoom", new s(this, e));
    });
  }, s;
});
/*!
 * getParameterByName.min.js
 */

function getParameterByName(e, n) {
  n || (n = window.location.href), e = e.replace(/[\[\]]/g, "\\$&");
  var r = new RegExp("[?&]" + e + "(=([^&#]*)|&|#|$)").exec(n);
  return r ? r[2] ? decodeURIComponent(r[2].replace(/\+/g, " ")) : "" : null;
} // Generated by CoffeeScript 1.9.3


(function () {
  var e;
  e = function () {
    function e(e, t) {
      var n, r;
      this.options = {
        target: "instafeed",
        get: "popular",
        resolution: "thumbnail",
        sortBy: "none",
        links: !0,
        mock: !1,
        useHttp: !1
      };
      if (_typeof(e) == "object") for (n in e) {
        r = e[n], this.options[n] = r;
      }
      this.context = t != null ? t : this, this.unique = this._genKey();
    }

    return e.prototype.hasNext = function () {
      return typeof this.context.nextUrl == "string" && this.context.nextUrl.length > 0;
    }, e.prototype.next = function () {
      return this.hasNext() ? this.run(this.context.nextUrl) : !1;
    }, e.prototype.run = function (t) {
      var n, r, i;
      if (typeof this.options.clientId != "string" && typeof this.options.accessToken != "string") throw new Error("Missing clientId or accessToken.");
      if (typeof this.options.accessToken != "string" && typeof this.options.clientId != "string") throw new Error("Missing clientId or accessToken.");
      return this.options.before != null && typeof this.options.before == "function" && this.options.before.call(this), typeof document != "undefined" && document !== null && (i = document.createElement("script"), i.id = "instafeed-fetcher", i.src = t || this._buildUrl(), n = document.getElementsByTagName("head"), n[0].appendChild(i), r = "instafeedCache" + this.unique, window[r] = new e(this.options, this), window[r].unique = this.unique), !0;
    }, e.prototype.parse = function (e) {
      var t, n, r, i, s, o, u, a, f, l, c, h, p, d, v, m, g, y, b, w, E, S, x, T, N, C, k, L, A, O, M, _, D;

      if (_typeof(e) != "object") {
        if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, "Invalid JSON data"), !1;
        throw new Error("Invalid JSON response");
      }

      if (e.meta.code !== 200) {
        if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, e.meta.error_message), !1;
        throw new Error("Error from Instagram: " + e.meta.error_message);
      }

      if (e.data.length === 0) {
        if (this.options.error != null && typeof this.options.error == "function") return this.options.error.call(this, "No images were returned from Instagram"), !1;
        throw new Error("No images were returned from Instagram");
      }

      this.options.success != null && typeof this.options.success == "function" && this.options.success.call(this, e), this.context.nextUrl = "", e.pagination != null && (this.context.nextUrl = e.pagination.next_url);

      if (this.options.sortBy !== "none") {
        this.options.sortBy === "random" ? M = ["", "random"] : M = this.options.sortBy.split("-"), O = M[0] === "least" ? !0 : !1;

        switch (M[1]) {
          case "random":
            e.data.sort(function () {
              return .5 - Math.random();
            });
            break;

          case "recent":
            e.data = this._sortBy(e.data, "created_time", O);
            break;

          case "liked":
            e.data = this._sortBy(e.data, "likes.count", O);
            break;

          case "commented":
            e.data = this._sortBy(e.data, "comments.count", O);
            break;

          default:
            throw new Error("Invalid option for sortBy: '" + this.options.sortBy + "'.");
        }
      }

      if (typeof document != "undefined" && document !== null && this.options.mock === !1) {
        m = e.data, A = parseInt(this.options.limit, 10), this.options.limit != null && m.length > A && (m = m.slice(0, A)), u = document.createDocumentFragment(), this.options.filter != null && typeof this.options.filter == "function" && (m = this._filter(m, this.options.filter));

        if (this.options.template != null && typeof this.options.template == "string") {
          f = "", d = "", w = "", D = document.createElement("div");

          for (c = 0, N = m.length; c < N; c++) {
            h = m[c], p = h.images[this.options.resolution];
            if (_typeof(p) != "object") throw o = "No image found for resolution: " + this.options.resolution + ".", new Error(o);
            E = p.width, y = p.height, b = "square", E > y && (b = "landscape"), E < y && (b = "portrait"), v = p.url, l = window.location.protocol.indexOf("http") >= 0, l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")), d = this._makeTemplate(this.options.template, {
              model: h,
              id: h.id,
              link: h.link,
              type: h.type,
              image: v,
              width: E,
              height: y,
              orientation: b,
              caption: this._getObjectProperty(h, "caption.text"),
              likes: h.likes.count,
              comments: h.comments.count,
              location: this._getObjectProperty(h, "location.name")
            }), f += d;
          }

          D.innerHTML = f, i = [], r = 0, n = D.childNodes.length;

          while (r < n) {
            i.push(D.childNodes[r]), r += 1;
          }

          for (x = 0, C = i.length; x < C; x++) {
            L = i[x], u.appendChild(L);
          }
        } else for (T = 0, k = m.length; T < k; T++) {
          h = m[T], g = document.createElement("img"), p = h.images[this.options.resolution];
          if (_typeof(p) != "object") throw o = "No image found for resolution: " + this.options.resolution + ".", new Error(o);
          v = p.url, l = window.location.protocol.indexOf("http") >= 0, l && !this.options.useHttp && (v = v.replace(/https?:\/\//, "//")), g.src = v, this.options.links === !0 ? (t = document.createElement("a"), t.href = h.link, t.appendChild(g), u.appendChild(t)) : u.appendChild(g);
        }

        _ = this.options.target, typeof _ == "string" && (_ = document.getElementById(_));
        if (_ == null) throw o = 'No element with id="' + this.options.target + '" on page.', new Error(o);
        _.appendChild(u), a = document.getElementsByTagName("head")[0], a.removeChild(document.getElementById("instafeed-fetcher")), S = "instafeedCache" + this.unique, window[S] = void 0;

        try {
          delete window[S];
        } catch (P) {
          s = P;
        }
      }

      return this.options.after != null && typeof this.options.after == "function" && this.options.after.call(this), !0;
    }, e.prototype._buildUrl = function () {
      var e, t, n;
      e = "https://api.instagram.com/v1";

      switch (this.options.get) {
        case "popular":
          t = "media/popular";
          break;

        case "tagged":
          if (!this.options.tagName) throw new Error("No tag name specified. Use the 'tagName' option.");
          t = "tags/" + this.options.tagName + "/media/recent";
          break;

        case "location":
          if (!this.options.locationId) throw new Error("No location specified. Use the 'locationId' option.");
          t = "locations/" + this.options.locationId + "/media/recent";
          break;

        case "user":
          if (!this.options.userId) throw new Error("No user specified. Use the 'userId' option.");
          t = "users/" + this.options.userId + "/media/recent";
          break;

        default:
          throw new Error("Invalid option for get: '" + this.options.get + "'.");
      }

      return n = e + "/" + t, this.options.accessToken != null ? n += "?access_token=" + this.options.accessToken : n += "?client_id=" + this.options.clientId, this.options.limit != null && (n += "&count=" + this.options.limit), n += "&callback=instafeedCache" + this.unique + ".parse", n;
    }, e.prototype._genKey = function () {
      var e;
      return e = function e() {
        return ((1 + Math.random()) * 65536 | 0).toString(16).substring(1);
      }, "" + e() + e() + e() + e();
    }, e.prototype._makeTemplate = function (e, t) {
      var n, r, i, s, o;
      r = /(?:\{{2})([\w\[\]\.]+)(?:\}{2})/, n = e;

      while (r.test(n)) {
        s = n.match(r)[1], o = (i = this._getObjectProperty(t, s)) != null ? i : "", n = n.replace(r, function () {
          return "" + o;
        });
      }

      return n;
    }, e.prototype._getObjectProperty = function (e, t) {
      var n, r;
      t = t.replace(/\[(\w+)\]/g, ".$1"), r = t.split(".");

      while (r.length) {
        n = r.shift();
        if (!(e != null && n in e)) return null;
        e = e[n];
      }

      return e;
    }, e.prototype._sortBy = function (e, t, n) {
      var r;
      return r = function r(e, _r) {
        var i, s;
        return i = this._getObjectProperty(e, t), s = this._getObjectProperty(_r, t), n ? i > s ? 1 : -1 : i < s ? 1 : -1;
      }, e.sort(r.bind(this)), e;
    }, e.prototype._filter = function (e, t) {
      var n, r, i, s, o;
      n = [], r = function r(e) {
        if (t(e)) return n.push(e);
      };

      for (i = 0, o = e.length; i < o; i++) {
        s = e[i], r(s);
      }

      return n;
    }, e;
  }(), function (e, t) {
    return typeof define == "function" && define.amd ? define([], t) : (typeof module === "undefined" ? "undefined" : _typeof(module)) == "object" && module.exports ? module.exports = t() : e.Instafeed = t();
  }(this, function () {
    return e;
  });
}).call(this);
/* jQuery elevateZoom 3.0.8 - Demo's and documentation: - www.elevateweb.co.uk/image-zoom - Copyright (c) 2013 Andrew Eades - www.elevateweb.co.uk - Dual licensed under the LGPL licenses. - http://en.wikipedia.org/wiki/MIT_License - http://en.wikipedia.org/wiki/GNU_General_Public_License */

"function" !== typeof Object.create && (Object.create = function (d) {
  function h() {}

  h.prototype = d;
  return new h();
});

(function (d, h, l, m) {
  var k = {
    init: function init(b, a) {
      var c = this;
      c.elem = a;
      c.$elem = d(a);
      c.imageSrc = c.$elem.data("zoom-image") ? c.$elem.data("zoom-image") : c.$elem.attr("src");
      c.options = d.extend({}, d.fn.elevateZoom.options, b);
      c.options.tint && (c.options.lensColour = "none", c.options.lensOpacity = "1");
      "inner" == c.options.zoomType && (c.options.showLens = !1);
      c.$elem.parent().removeAttr("title").removeAttr("alt");
      c.zoomImage = c.imageSrc;
      c.refresh(1);
      d("#" + c.options.gallery + " a").click(function (a) {
        c.options.galleryActiveClass && (d("#" + c.options.gallery + " a").removeClass(c.options.galleryActiveClass), d(this).addClass(c.options.galleryActiveClass));
        a.preventDefault();
        d(this).data("zoom-image") ? c.zoomImagePre = d(this).data("zoom-image") : c.zoomImagePre = d(this).data("image");
        c.swaptheimage(d(this).data("image"), c.zoomImagePre);
        return !1;
      });
    },
    refresh: function refresh(b) {
      var a = this;
      setTimeout(function () {
        a.fetch(a.imageSrc);
      }, b || a.options.refresh);
    },
    fetch: function fetch(b) {
      var a = this,
          c = new Image();

      c.onload = function () {
        a.largeWidth = c.width;
        a.largeHeight = c.height;
        a.startZoom();
        a.currentImage = a.imageSrc;
        a.options.onZoomedImageLoaded(a.$elem);
      };

      c.src = b;
    },
    startZoom: function startZoom() {
      var b = this;
      b.nzWidth = b.$elem.width();
      b.nzHeight = b.$elem.height();
      b.isWindowActive = !1;
      b.isLensActive = !1;
      b.isTintActive = !1;
      b.overWindow = !1;
      b.options.imageCrossfade && (b.zoomWrap = b.$elem.wrap('<div style="height:' + b.nzHeight + "px;width:" + b.nzWidth + 'px;" class="zoomWrapper" />'), b.$elem.css("position", "absolute"));
      b.zoomLock = 1;
      b.scrollingLock = !1;
      b.changeBgSize = !1;
      b.currentZoomLevel = b.options.zoomLevel;
      b.nzOffset = b.$elem.offset();
      b.widthRatio = b.largeWidth / b.currentZoomLevel / b.nzWidth;
      b.heightRatio = b.largeHeight / b.currentZoomLevel / b.nzHeight;
      "window" == b.options.zoomType && (b.zoomWindowStyle = "overflow: hidden;background-position: 0px 0px;text-align:center;background-color: " + String(b.options.zoomWindowBgColour) + ";width: " + String(b.options.zoomWindowWidth) + "px;height: " + String(b.options.zoomWindowHeight) + "px;float: left;background-size: " + b.largeWidth / b.currentZoomLevel + "px " + b.largeHeight / b.currentZoomLevel + "px;display: none;z-index:100;border: " + String(b.options.borderSize) + "px solid " + b.options.borderColour + ";background-repeat: no-repeat;position: absolute;");

      if ("inner" == b.options.zoomType) {
        var a = b.$elem.css("border-left-width");
        b.zoomWindowStyle = "overflow: hidden;margin-left: " + String(a) + ";margin-top: " + String(a) + ";background-position: 0px 0px;width: " + String(b.nzWidth) + "px;height: " + String(b.nzHeight) + "px;float: left;display: none;cursor:" + b.options.cursor + ";px solid " + b.options.borderColour + ";background-repeat: no-repeat;position: absolute;";
      }

      "window" == b.options.zoomType && (lensHeight = b.nzHeight < b.options.zoomWindowWidth / b.widthRatio ? b.nzHeight : String(b.options.zoomWindowHeight / b.heightRatio), lensWidth = b.largeWidth < b.options.zoomWindowWidth ? b.nzWidth : b.options.zoomWindowWidth / b.widthRatio, b.lensStyle = "background-position: 0px 0px;width: " + String(b.options.zoomWindowWidth / b.widthRatio) + "px;height: " + String(b.options.zoomWindowHeight / b.heightRatio) + "px;float: right;display: none;overflow: hidden;z-index: 999;-webkit-transform: translateZ(0);opacity:" + b.options.lensOpacity + ";filter: alpha(opacity = " + 100 * b.options.lensOpacity + "); zoom:1;width:" + lensWidth + "px;height:" + lensHeight + "px;background-color:" + b.options.lensColour + ";cursor:" + b.options.cursor + ";border: " + b.options.lensBorderSize + "px solid " + b.options.lensBorderColour + ";background-repeat: no-repeat;position: absolute;");
      b.tintStyle = "display: block;position: absolute;background-color: " + b.options.tintColour + ";filter:alpha(opacity=0);opacity: 0;width: " + b.nzWidth + "px;height: " + b.nzHeight + "px;";
      b.lensRound = "";
      "lens" == b.options.zoomType && (b.lensStyle = "background-position: 0px 0px;float: left;display: none;border: " + String(b.options.borderSize) + "px solid " + b.options.borderColour + ";width:" + String(b.options.lensSize) + "px;height:" + String(b.options.lensSize) + "px;background-repeat: no-repeat;position: absolute;");
      "round" == b.options.lensShape && (b.lensRound = "border-top-left-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-top-right-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-bottom-left-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;border-bottom-right-radius: " + String(b.options.lensSize / 2 + b.options.borderSize) + "px;");
      b.zoomContainer = d('<div class="zoomContainer" style="-webkit-transform: translateZ(0);position:absolute;left:' + b.nzOffset.left + "px;top:" + b.nzOffset.top + "px;height:" + b.nzHeight + "px;width:" + b.nzWidth + 'px;"></div>');
      d("body").append(b.zoomContainer);
      b.options.containLensZoom && "lens" == b.options.zoomType && b.zoomContainer.css("overflow", "hidden");
      "inner" != b.options.zoomType && (b.zoomLens = d("<div class='zoomLens' style='" + b.lensStyle + b.lensRound + "'>&nbsp;</div>").appendTo(b.zoomContainer).click(function () {
        b.$elem.trigger("click");
      }), b.options.tint && (b.tintContainer = d("<div/>").addClass("tintContainer"), b.zoomTint = d("<div class='zoomTint' style='" + b.tintStyle + "'></div>"), b.zoomLens.wrap(b.tintContainer), b.zoomTintcss = b.zoomLens.after(b.zoomTint), b.zoomTintImage = d('<img style="position: absolute; left: 0px; top: 0px; max-width: none; width: ' + b.nzWidth + "px; height: " + b.nzHeight + 'px;" src="' + b.imageSrc + '">').appendTo(b.zoomLens).click(function () {
        b.$elem.trigger("click");
      })));
      isNaN(b.options.zoomWindowPosition) ? b.zoomWindow = d("<div style='z-index:999;left:" + b.windowOffsetLeft + "px;top:" + b.windowOffsetTop + "px;" + b.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo("body").click(function () {
        b.$elem.trigger("click");
      }) : b.zoomWindow = d("<div style='z-index:999;left:" + b.windowOffsetLeft + "px;top:" + b.windowOffsetTop + "px;" + b.zoomWindowStyle + "' class='zoomWindow'>&nbsp;</div>").appendTo(b.zoomContainer).click(function () {
        b.$elem.trigger("click");
      });
      b.zoomWindowContainer = d("<div/>").addClass("zoomWindowContainer").css("width", b.options.zoomWindowWidth);
      b.zoomWindow.wrap(b.zoomWindowContainer);
      "lens" == b.options.zoomType && b.zoomLens.css({
        backgroundImage: "url('" + b.imageSrc + "')"
      });
      "window" == b.options.zoomType && b.zoomWindow.css({
        backgroundImage: "url('" + b.imageSrc + "')"
      });
      "inner" == b.options.zoomType && b.zoomWindow.css({
        backgroundImage: "url('" + b.imageSrc + "')"
      });
      b.$elem.bind("touchmove", function (a) {
        a.preventDefault();
        b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0]);
      });
      b.zoomContainer.bind("touchmove", function (a) {
        "inner" == b.options.zoomType && b.showHideWindow("show");
        a.preventDefault();
        b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0]);
      });
      b.zoomContainer.bind("touchend", function (a) {
        b.showHideWindow("hide");
        b.options.showLens && b.showHideLens("hide");
        b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide");
      });
      b.$elem.bind("touchend", function (a) {
        b.showHideWindow("hide");
        b.options.showLens && b.showHideLens("hide");
        b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide");
      });
      b.options.showLens && (b.zoomLens.bind("touchmove", function (a) {
        a.preventDefault();
        b.setPosition(a.originalEvent.touches[0] || a.originalEvent.changedTouches[0]);
      }), b.zoomLens.bind("touchend", function (a) {
        b.showHideWindow("hide");
        b.options.showLens && b.showHideLens("hide");
        b.options.tint && "inner" != b.options.zoomType && b.showHideTint("hide");
      }));
      b.$elem.bind("mousemove", function (a) {
        !1 == b.overWindow && b.setElements("show");
        if (b.lastX !== a.clientX || b.lastY !== a.clientY) b.setPosition(a), b.currentLoc = a;
        b.lastX = a.clientX;
        b.lastY = a.clientY;
      });
      b.zoomContainer.bind("mousemove", function (a) {
        !1 == b.overWindow && b.setElements("show");
        if (b.lastX !== a.clientX || b.lastY !== a.clientY) b.setPosition(a), b.currentLoc = a;
        b.lastX = a.clientX;
        b.lastY = a.clientY;
      });
      "inner" != b.options.zoomType && b.zoomLens.bind("mousemove", function (a) {
        if (b.lastX !== a.clientX || b.lastY !== a.clientY) b.setPosition(a), b.currentLoc = a;
        b.lastX = a.clientX;
        b.lastY = a.clientY;
      });
      b.options.tint && "inner" != b.options.zoomType && b.zoomTint.bind("mousemove", function (a) {
        if (b.lastX !== a.clientX || b.lastY !== a.clientY) b.setPosition(a), b.currentLoc = a;
        b.lastX = a.clientX;
        b.lastY = a.clientY;
      });
      "inner" == b.options.zoomType && b.zoomWindow.bind("mousemove", function (a) {
        if (b.lastX !== a.clientX || b.lastY !== a.clientY) b.setPosition(a), b.currentLoc = a;
        b.lastX = a.clientX;
        b.lastY = a.clientY;
      });
      b.zoomContainer.add(b.$elem).mouseenter(function () {
        !1 == b.overWindow && b.setElements("show");
      }).mouseleave(function () {
        b.scrollLock || b.setElements("hide");
      });
      "inner" != b.options.zoomType && b.zoomWindow.mouseenter(function () {
        b.overWindow = !0;
        b.setElements("hide");
      }).mouseleave(function () {
        b.overWindow = !1;
      });
      b.minZoomLevel = b.options.minZoomLevel ? b.options.minZoomLevel : 2 * b.options.scrollZoomIncrement;
      b.options.scrollZoom && b.zoomContainer.add(b.$elem).bind("mousewheel DOMMouseScroll MozMousePixelScroll", function (a) {
        b.scrollLock = !0;
        clearTimeout(d.data(this, "timer"));
        d.data(this, "timer", setTimeout(function () {
          b.scrollLock = !1;
        }, 250));
        var e = a.originalEvent.wheelDelta || -1 * a.originalEvent.detail;
        a.stopImmediatePropagation();
        a.stopPropagation();
        a.preventDefault();
        0 < e / 120 ? b.currentZoomLevel >= b.minZoomLevel && b.changeZoomLevel(b.currentZoomLevel - b.options.scrollZoomIncrement) : b.options.maxZoomLevel ? b.currentZoomLevel <= b.options.maxZoomLevel && b.changeZoomLevel(parseFloat(b.currentZoomLevel) + b.options.scrollZoomIncrement) : b.changeZoomLevel(parseFloat(b.currentZoomLevel) + b.options.scrollZoomIncrement);
        return !1;
      });
    },
    setElements: function setElements(b) {
      if (!this.options.zoomEnabled) return !1;
      "show" == b && this.isWindowSet && ("inner" == this.options.zoomType && this.showHideWindow("show"), "window" == this.options.zoomType && this.showHideWindow("show"), this.options.showLens && this.showHideLens("show"), this.options.tint && "inner" != this.options.zoomType && this.showHideTint("show"));
      "hide" == b && ("window" == this.options.zoomType && this.showHideWindow("hide"), this.options.tint || this.showHideWindow("hide"), this.options.showLens && this.showHideLens("hide"), this.options.tint && this.showHideTint("hide"));
    },
    setPosition: function setPosition(b) {
      if (!this.options.zoomEnabled) return !1;
      this.nzHeight = this.$elem.height();
      this.nzWidth = this.$elem.width();
      this.nzOffset = this.$elem.offset();
      this.options.tint && "inner" != this.options.zoomType && (this.zoomTint.css({
        top: 0
      }), this.zoomTint.css({
        left: 0
      }));
      this.options.responsive && !this.options.scrollZoom && this.options.showLens && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.largeWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.widthRatio = this.largeWidth / this.nzWidth, this.heightRatio = this.largeHeight / this.nzHeight, "lens" != this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight), this.options.tint && (this.zoomTintImage.css("width", this.nzWidth), this.zoomTintImage.css("height", this.nzHeight))), "lens" == this.options.zoomType && this.zoomLens.css({
        width: String(this.options.lensSize) + "px",
        height: String(this.options.lensSize) + "px"
      }));
      this.zoomContainer.css({
        top: this.nzOffset.top
      });
      this.zoomContainer.css({
        left: this.nzOffset.left
      });
      this.mouseLeft = parseInt(b.pageX - this.nzOffset.left);
      this.mouseTop = parseInt(b.pageY - this.nzOffset.top);
      "window" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.zoomLens.height() / 2, this.Eboppos = this.mouseTop > this.nzHeight - this.zoomLens.height() / 2 - 2 * this.options.lensBorderSize, this.Eloppos = this.mouseLeft < 0 + this.zoomLens.width() / 2, this.Eroppos = this.mouseLeft > this.nzWidth - this.zoomLens.width() / 2 - 2 * this.options.lensBorderSize);
      "inner" == this.options.zoomType && (this.Etoppos = this.mouseTop < this.nzHeight / 2 / this.heightRatio, this.Eboppos = this.mouseTop > this.nzHeight - this.nzHeight / 2 / this.heightRatio, this.Eloppos = this.mouseLeft < 0 + this.nzWidth / 2 / this.widthRatio, this.Eroppos = this.mouseLeft > this.nzWidth - this.nzWidth / 2 / this.widthRatio - 2 * this.options.lensBorderSize);
      0 >= this.mouseLeft || 0 > this.mouseTop || this.mouseLeft > this.nzWidth || this.mouseTop > this.nzHeight ? this.setElements("hide") : (this.options.showLens && (this.lensLeftPos = String(this.mouseLeft - this.zoomLens.width() / 2), this.lensTopPos = String(this.mouseTop - this.zoomLens.height() / 2)), this.Etoppos && (this.lensTopPos = 0), this.Eloppos && (this.tintpos = this.lensLeftPos = this.windowLeftPos = 0), "window" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize)), "inner" == this.options.zoomType && (this.Eboppos && (this.lensTopPos = Math.max(this.nzHeight - 2 * this.options.lensBorderSize, 0)), this.Eroppos && (this.lensLeftPos = this.nzWidth - this.nzWidth - 2 * this.options.lensBorderSize)), "lens" == this.options.zoomType && (this.windowLeftPos = String(-1 * ((b.pageX - this.nzOffset.left) * this.widthRatio - this.zoomLens.width() / 2)), this.windowTopPos = String(-1 * ((b.pageY - this.nzOffset.top) * this.heightRatio - this.zoomLens.height() / 2)), this.zoomLens.css({
        backgroundPosition: this.windowLeftPos + "px " + this.windowTopPos + "px"
      }), this.changeBgSize && (this.nzHeight > this.nzWidth ? ("lens" == this.options.zoomType && this.zoomLens.css({
        "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
      }), this.zoomWindow.css({
        "background-size": this.largeWidth / this.newvalueheight + "px " + this.largeHeight / this.newvalueheight + "px"
      })) : ("lens" == this.options.zoomType && this.zoomLens.css({
        "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
      }), this.zoomWindow.css({
        "background-size": this.largeWidth / this.newvaluewidth + "px " + this.largeHeight / this.newvaluewidth + "px"
      })), this.changeBgSize = !1), this.setWindowPostition(b)), this.options.tint && "inner" != this.options.zoomType && this.setTintPosition(b), "window" == this.options.zoomType && this.setWindowPostition(b), "inner" == this.options.zoomType && this.setWindowPostition(b), this.options.showLens && (this.fullwidth && "lens" != this.options.zoomType && (this.lensLeftPos = 0), this.zoomLens.css({
        left: this.lensLeftPos + "px",
        top: this.lensTopPos + "px"
      })));
    },
    showHideWindow: function showHideWindow(b) {
      "show" != b || this.isWindowActive || (this.options.zoomWindowFadeIn ? this.zoomWindow.stop(!0, !0, !1).fadeIn(this.options.zoomWindowFadeIn) : this.zoomWindow.show(), this.isWindowActive = !0);
      "hide" == b && this.isWindowActive && (this.options.zoomWindowFadeOut ? this.zoomWindow.stop(!0, !0).fadeOut(this.options.zoomWindowFadeOut) : this.zoomWindow.hide(), this.isWindowActive = !1);
    },
    showHideLens: function showHideLens(b) {
      "show" != b || this.isLensActive || (this.options.lensFadeIn ? this.zoomLens.stop(!0, !0, !1).fadeIn(this.options.lensFadeIn) : this.zoomLens.show(), this.isLensActive = !0);
      "hide" == b && this.isLensActive && (this.options.lensFadeOut ? this.zoomLens.stop(!0, !0).fadeOut(this.options.lensFadeOut) : this.zoomLens.hide(), this.isLensActive = !1);
    },
    showHideTint: function showHideTint(b) {
      "show" != b || this.isTintActive || (this.options.zoomTintFadeIn ? this.zoomTint.css({
        opacity: this.options.tintOpacity
      }).animate().stop(!0, !0).fadeIn("slow") : (this.zoomTint.css({
        opacity: this.options.tintOpacity
      }).animate(), this.zoomTint.show()), this.isTintActive = !0);
      "hide" == b && this.isTintActive && (this.options.zoomTintFadeOut ? this.zoomTint.stop(!0, !0).fadeOut(this.options.zoomTintFadeOut) : this.zoomTint.hide(), this.isTintActive = !1);
    },
    setLensPostition: function setLensPostition(b) {},
    setWindowPostition: function setWindowPostition(b) {
      var a = this;
      if (isNaN(a.options.zoomWindowPosition)) a.externalContainer = d("#" + a.options.zoomWindowPosition), a.externalContainerWidth = a.externalContainer.width(), a.externalContainerHeight = a.externalContainer.height(), a.externalContainerOffset = a.externalContainer.offset(), a.windowOffsetTop = a.externalContainerOffset.top, a.windowOffsetLeft = a.externalContainerOffset.left;else switch (a.options.zoomWindowPosition) {
        case 1:
          a.windowOffsetTop = a.options.zoomWindowOffety;
          a.windowOffsetLeft = +a.nzWidth;
          break;

        case 2:
          a.options.zoomWindowHeight > a.nzHeight && (a.windowOffsetTop = -1 * (a.options.zoomWindowHeight / 2 - a.nzHeight / 2), a.windowOffsetLeft = a.nzWidth);
          break;

        case 3:
          a.windowOffsetTop = a.nzHeight - a.zoomWindow.height() - 2 * a.options.borderSize;
          a.windowOffsetLeft = a.nzWidth;
          break;

        case 4:
          a.windowOffsetTop = a.nzHeight;
          a.windowOffsetLeft = a.nzWidth;
          break;

        case 5:
          a.windowOffsetTop = a.nzHeight;
          a.windowOffsetLeft = a.nzWidth - a.zoomWindow.width() - 2 * a.options.borderSize;
          break;

        case 6:
          a.options.zoomWindowHeight > a.nzHeight && (a.windowOffsetTop = a.nzHeight, a.windowOffsetLeft = -1 * (a.options.zoomWindowWidth / 2 - a.nzWidth / 2 + 2 * a.options.borderSize));
          break;

        case 7:
          a.windowOffsetTop = a.nzHeight;
          a.windowOffsetLeft = 0;
          break;

        case 8:
          a.windowOffsetTop = a.nzHeight;
          a.windowOffsetLeft = -1 * (a.zoomWindow.width() + 2 * a.options.borderSize);
          break;

        case 9:
          a.windowOffsetTop = a.nzHeight - a.zoomWindow.height() - 2 * a.options.borderSize;
          a.windowOffsetLeft = -1 * (a.zoomWindow.width() + 2 * a.options.borderSize);
          break;

        case 10:
          a.options.zoomWindowHeight > a.nzHeight && (a.windowOffsetTop = -1 * (a.options.zoomWindowHeight / 2 - a.nzHeight / 2), a.windowOffsetLeft = -1 * (a.zoomWindow.width() + 2 * a.options.borderSize));
          break;

        case 11:
          a.windowOffsetTop = a.options.zoomWindowOffety;
          a.windowOffsetLeft = -1 * (a.zoomWindow.width() + 2 * a.options.borderSize);
          break;

        case 12:
          a.windowOffsetTop = -1 * (a.zoomWindow.height() + 2 * a.options.borderSize);
          a.windowOffsetLeft = -1 * (a.zoomWindow.width() + 2 * a.options.borderSize);
          break;

        case 13:
          a.windowOffsetTop = -1 * (a.zoomWindow.height() + 2 * a.options.borderSize);
          a.windowOffsetLeft = 0;
          break;

        case 14:
          a.options.zoomWindowHeight > a.nzHeight && (a.windowOffsetTop = -1 * (a.zoomWindow.height() + 2 * a.options.borderSize), a.windowOffsetLeft = -1 * (a.options.zoomWindowWidth / 2 - a.nzWidth / 2 + 2 * a.options.borderSize));
          break;

        case 15:
          a.windowOffsetTop = -1 * (a.zoomWindow.height() + 2 * a.options.borderSize);
          a.windowOffsetLeft = a.nzWidth - a.zoomWindow.width() - 2 * a.options.borderSize;
          break;

        case 16:
          a.windowOffsetTop = -1 * (a.zoomWindow.height() + 2 * a.options.borderSize);
          a.windowOffsetLeft = a.nzWidth;
          break;

        default:
          a.windowOffsetTop = a.options.zoomWindowOffety, a.windowOffsetLeft = a.nzWidth;
      }
      a.isWindowSet = !0;
      a.windowOffsetTop += a.options.zoomWindowOffety;
      a.windowOffsetLeft += a.options.zoomWindowOffetx;
      a.zoomWindow.css({
        top: a.windowOffsetTop
      });
      a.zoomWindow.css({
        left: a.windowOffsetLeft
      });
      "inner" == a.options.zoomType && (a.zoomWindow.css({
        top: 0
      }), a.zoomWindow.css({
        left: 0
      }));
      a.windowLeftPos = String(-1 * ((b.pageX - a.nzOffset.left) * a.widthRatio - a.zoomWindow.width() / 2));
      a.windowTopPos = String(-1 * ((b.pageY - a.nzOffset.top) * a.heightRatio - a.zoomWindow.height() / 2));
      a.Etoppos && (a.windowTopPos = 0);
      a.Eloppos && (a.windowLeftPos = 0);
      a.Eboppos && (a.windowTopPos = -1 * (a.largeHeight / a.currentZoomLevel - a.zoomWindow.height()));
      a.Eroppos && (a.windowLeftPos = -1 * (a.largeWidth / a.currentZoomLevel - a.zoomWindow.width()));
      a.fullheight && (a.windowTopPos = 0);
      a.fullwidth && (a.windowLeftPos = 0);
      if ("window" == a.options.zoomType || "inner" == a.options.zoomType) 1 == a.zoomLock && (1 >= a.widthRatio && (a.windowLeftPos = 0), 1 >= a.heightRatio && (a.windowTopPos = 0)), a.largeHeight < a.options.zoomWindowHeight && (a.windowTopPos = 0), a.largeWidth < a.options.zoomWindowWidth && (a.windowLeftPos = 0), a.options.easing ? (a.xp || (a.xp = 0), a.yp || (a.yp = 0), a.loop || (a.loop = setInterval(function () {
        a.xp += (a.windowLeftPos - a.xp) / a.options.easingAmount;
        a.yp += (a.windowTopPos - a.yp) / a.options.easingAmount;
        a.scrollingLock ? (clearInterval(a.loop), a.xp = a.windowLeftPos, a.yp = a.windowTopPos, a.xp = -1 * ((b.pageX - a.nzOffset.left) * a.widthRatio - a.zoomWindow.width() / 2), a.yp = -1 * ((b.pageY - a.nzOffset.top) * a.heightRatio - a.zoomWindow.height() / 2), a.changeBgSize && (a.nzHeight > a.nzWidth ? ("lens" == a.options.zoomType && a.zoomLens.css({
          "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
        }), a.zoomWindow.css({
          "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
        })) : ("lens" != a.options.zoomType && a.zoomLens.css({
          "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvalueheight + "px"
        }), a.zoomWindow.css({
          "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvaluewidth + "px"
        })), a.changeBgSize = !1), a.zoomWindow.css({
          backgroundPosition: a.windowLeftPos + "px " + a.windowTopPos + "px"
        }), a.scrollingLock = !1, a.loop = !1) : (a.changeBgSize && (a.nzHeight > a.nzWidth ? ("lens" == a.options.zoomType && a.zoomLens.css({
          "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
        }), a.zoomWindow.css({
          "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
        })) : ("lens" != a.options.zoomType && a.zoomLens.css({
          "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvaluewidth + "px"
        }), a.zoomWindow.css({
          "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvaluewidth + "px"
        })), a.changeBgSize = !1), a.zoomWindow.css({
          backgroundPosition: a.xp + "px " + a.yp + "px"
        }));
      }, 16))) : (a.changeBgSize && (a.nzHeight > a.nzWidth ? ("lens" == a.options.zoomType && a.zoomLens.css({
        "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
      }), a.zoomWindow.css({
        "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
      })) : ("lens" == a.options.zoomType && a.zoomLens.css({
        "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvaluewidth + "px"
      }), a.largeHeight / a.newvaluewidth < a.options.zoomWindowHeight ? a.zoomWindow.css({
        "background-size": a.largeWidth / a.newvaluewidth + "px " + a.largeHeight / a.newvaluewidth + "px"
      }) : a.zoomWindow.css({
        "background-size": a.largeWidth / a.newvalueheight + "px " + a.largeHeight / a.newvalueheight + "px"
      })), a.changeBgSize = !1), a.zoomWindow.css({
        backgroundPosition: a.windowLeftPos + "px " + a.windowTopPos + "px"
      }));
    },
    setTintPosition: function setTintPosition(b) {
      this.nzOffset = this.$elem.offset();
      this.tintpos = String(-1 * (b.pageX - this.nzOffset.left - this.zoomLens.width() / 2));
      this.tintposy = String(-1 * (b.pageY - this.nzOffset.top - this.zoomLens.height() / 2));
      this.Etoppos && (this.tintposy = 0);
      this.Eloppos && (this.tintpos = 0);
      this.Eboppos && (this.tintposy = -1 * (this.nzHeight - this.zoomLens.height() - 2 * this.options.lensBorderSize));
      this.Eroppos && (this.tintpos = -1 * (this.nzWidth - this.zoomLens.width() - 2 * this.options.lensBorderSize));
      this.options.tint && (this.fullheight && (this.tintposy = 0), this.fullwidth && (this.tintpos = 0), this.zoomTintImage.css({
        left: this.tintpos + "px"
      }), this.zoomTintImage.css({
        top: this.tintposy + "px"
      }));
    },
    swaptheimage: function swaptheimage(b, a) {
      var c = this,
          e = new Image();
      c.options.loadingIcon && (c.spinner = d("<div style=\"background: url('" + c.options.loadingIcon + "') no-repeat center;height:" + c.nzHeight + "px;width:" + c.nzWidth + 'px;z-index: 2000;position: absolute; background-position: center center;"></div>'), c.$elem.after(c.spinner));
      c.options.onImageSwap(c.$elem);

      e.onload = function () {
        c.largeWidth = e.width;
        c.largeHeight = e.height;
        c.zoomImage = a;
        c.zoomWindow.css({
          "background-size": c.largeWidth + "px " + c.largeHeight + "px"
        });
        c.zoomWindow.css({
          "background-size": c.largeWidth + "px " + c.largeHeight + "px"
        });
        c.swapAction(b, a);
      };

      e.src = a;
    },
    swapAction: function swapAction(b, a) {
      var c = this,
          e = new Image();

      e.onload = function () {
        c.nzHeight = e.height;
        c.nzWidth = e.width;
        c.options.onImageSwapComplete(c.$elem);
        c.doneCallback();
      };

      e.src = b;
      c.currentZoomLevel = c.options.zoomLevel;
      c.options.maxZoomLevel = !1;
      "lens" == c.options.zoomType && c.zoomLens.css({
        backgroundImage: "url('" + a + "')"
      });
      "window" == c.options.zoomType && c.zoomWindow.css({
        backgroundImage: "url('" + a + "')"
      });
      "inner" == c.options.zoomType && c.zoomWindow.css({
        backgroundImage: "url('" + a + "')"
      });
      c.currentImage = a;

      if (c.options.imageCrossfade) {
        var f = c.$elem,
            g = f.clone();
        c.$elem.attr("src", b);
        c.$elem.after(g);
        g.stop(!0).fadeOut(c.options.imageCrossfade, function () {
          d(this).remove();
        });
        c.$elem.width("auto").removeAttr("width");
        c.$elem.height("auto").removeAttr("height");
        f.fadeIn(c.options.imageCrossfade);
        c.options.tint && "inner" != c.options.zoomType && (f = c.zoomTintImage, g = f.clone(), c.zoomTintImage.attr("src", a), c.zoomTintImage.after(g), g.stop(!0).fadeOut(c.options.imageCrossfade, function () {
          d(this).remove();
        }), f.fadeIn(c.options.imageCrossfade), c.zoomTint.css({
          height: c.$elem.height()
        }), c.zoomTint.css({
          width: c.$elem.width()
        }));
        c.zoomContainer.css("height", c.$elem.height());
        c.zoomContainer.css("width", c.$elem.width());
        "inner" != c.options.zoomType || c.options.constrainType || (c.zoomWrap.parent().css("height", c.$elem.height()), c.zoomWrap.parent().css("width", c.$elem.width()), c.zoomWindow.css("height", c.$elem.height()), c.zoomWindow.css("width", c.$elem.width()));
      } else c.$elem.attr("src", b), c.options.tint && (c.zoomTintImage.attr("src", a), c.zoomTintImage.attr("height", c.$elem.height()), c.zoomTintImage.css({
        height: c.$elem.height()
      }), c.zoomTint.css({
        height: c.$elem.height()
      })), c.zoomContainer.css("height", c.$elem.height()), c.zoomContainer.css("width", c.$elem.width());

      c.options.imageCrossfade && (c.zoomWrap.css("height", c.$elem.height()), c.zoomWrap.css("width", c.$elem.width()));
      c.options.constrainType && ("height" == c.options.constrainType && (c.zoomContainer.css("height", c.options.constrainSize), c.zoomContainer.css("width", "auto"), c.options.imageCrossfade ? (c.zoomWrap.css("height", c.options.constrainSize), c.zoomWrap.css("width", "auto"), c.constwidth = c.zoomWrap.width()) : (c.$elem.css("height", c.options.constrainSize), c.$elem.css("width", "auto"), c.constwidth = c.$elem.width()), "inner" == c.options.zoomType && (c.zoomWrap.parent().css("height", c.options.constrainSize), c.zoomWrap.parent().css("width", c.constwidth), c.zoomWindow.css("height", c.options.constrainSize), c.zoomWindow.css("width", c.constwidth)), c.options.tint && (c.tintContainer.css("height", c.options.constrainSize), c.tintContainer.css("width", c.constwidth), c.zoomTint.css("height", c.options.constrainSize), c.zoomTint.css("width", c.constwidth), c.zoomTintImage.css("height", c.options.constrainSize), c.zoomTintImage.css("width", c.constwidth))), "width" == c.options.constrainType && (c.zoomContainer.css("height", "auto"), c.zoomContainer.css("width", c.options.constrainSize), c.options.imageCrossfade ? (c.zoomWrap.css("height", "auto"), c.zoomWrap.css("width", c.options.constrainSize), c.constheight = c.zoomWrap.height()) : (c.$elem.css("height", "auto"), c.$elem.css("width", c.options.constrainSize), c.constheight = c.$elem.height()), "inner" == c.options.zoomType && (c.zoomWrap.parent().css("height", c.constheight), c.zoomWrap.parent().css("width", c.options.constrainSize), c.zoomWindow.css("height", c.constheight), c.zoomWindow.css("width", c.options.constrainSize)), c.options.tint && (c.tintContainer.css("height", c.constheight), c.tintContainer.css("width", c.options.constrainSize), c.zoomTint.css("height", c.constheight), c.zoomTint.css("width", c.options.constrainSize), c.zoomTintImage.css("height", c.constheight), c.zoomTintImage.css("width", c.options.constrainSize))));
    },
    doneCallback: function doneCallback() {
      this.options.loadingIcon && this.spinner.hide();
      this.nzOffset = this.$elem.offset();
      this.nzWidth = this.$elem.width();
      this.nzHeight = this.$elem.height();
      this.currentZoomLevel = this.options.zoomLevel;
      this.widthRatio = this.largeWidth / this.nzWidth;
      this.heightRatio = this.largeHeight / this.nzHeight;
      "window" == this.options.zoomType && (lensHeight = this.nzHeight < this.options.zoomWindowWidth / this.widthRatio ? this.nzHeight : String(this.options.zoomWindowHeight / this.heightRatio), lensWidth = this.options.zoomWindowWidth < this.options.zoomWindowWidth ? this.nzWidth : this.options.zoomWindowWidth / this.widthRatio, this.zoomLens && (this.zoomLens.css("width", lensWidth), this.zoomLens.css("height", lensHeight)));
    },
    getCurrentImage: function getCurrentImage() {
      return this.zoomImage;
    },
    getGalleryList: function getGalleryList() {
      var b = this;
      b.gallerylist = [];
      b.options.gallery ? d("#" + b.options.gallery + " a").each(function () {
        var a = "";
        d(this).data("zoom-image") ? a = d(this).data("zoom-image") : d(this).data("image") && (a = d(this).data("image"));
        a == b.zoomImage ? b.gallerylist.unshift({
          href: "" + a + "",
          title: d(this).find("img").attr("title")
        }) : b.gallerylist.push({
          href: "" + a + "",
          title: d(this).find("img").attr("title")
        });
      }) : b.gallerylist.push({
        href: "" + b.zoomImage + "",
        title: d(this).find("img").attr("title")
      });
      return b.gallerylist;
    },
    changeZoomLevel: function changeZoomLevel(b) {
      this.scrollingLock = !0;
      this.newvalue = parseFloat(b).toFixed(2);
      newvalue = parseFloat(b).toFixed(2);
      maxheightnewvalue = this.largeHeight / (this.options.zoomWindowHeight / this.nzHeight * this.nzHeight);
      maxwidthtnewvalue = this.largeWidth / (this.options.zoomWindowWidth / this.nzWidth * this.nzWidth);
      "inner" != this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / maxheightnewvalue / this.nzHeight, this.newvalueheight = maxheightnewvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / maxwidthtnewvalue / this.nzWidth, this.newvaluewidth = maxwidthtnewvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1), "lens" == this.options.zoomType && (maxheightnewvalue <= newvalue ? (this.fullwidth = !0, this.newvaluewidth = maxheightnewvalue) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1)));
      "inner" == this.options.zoomType && (maxheightnewvalue = parseFloat(this.largeHeight / this.nzHeight).toFixed(2), maxwidthtnewvalue = parseFloat(this.largeWidth / this.nzWidth).toFixed(2), newvalue > maxheightnewvalue && (newvalue = maxheightnewvalue), newvalue > maxwidthtnewvalue && (newvalue = maxwidthtnewvalue), maxheightnewvalue <= newvalue ? (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !0) : (this.heightRatio = this.largeHeight / newvalue / this.nzHeight, this.newvalueheight = newvalue > maxheightnewvalue ? maxheightnewvalue : newvalue, this.fullheight = !1), maxwidthtnewvalue <= newvalue ? (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue > maxwidthtnewvalue ? maxwidthtnewvalue : newvalue, this.fullwidth = !0) : (this.widthRatio = this.largeWidth / newvalue / this.nzWidth, this.newvaluewidth = newvalue, this.fullwidth = !1));
      scrcontinue = !1;
      "inner" == this.options.zoomType && (this.nzWidth > this.nzHeight && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0)), this.nzHeight > this.nzWidth && (this.newvaluewidth <= maxwidthtnewvalue ? scrcontinue = !0 : (scrcontinue = !1, this.fullwidth = this.fullheight = !0)));
      "inner" != this.options.zoomType && (scrcontinue = !0);
      scrcontinue && (this.zoomLock = 0, this.changeZoom = !0, this.options.zoomWindowHeight / this.heightRatio <= this.nzHeight && (this.currentZoomLevel = this.newvalueheight, "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
        height: String(this.options.zoomWindowHeight / this.heightRatio) + "px"
      })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), this.options.zoomWindowWidth / this.widthRatio <= this.nzWidth && ("inner" != this.options.zoomType && this.newvaluewidth > this.newvalueheight && (this.currentZoomLevel = this.newvaluewidth), "lens" != this.options.zoomType && "inner" != this.options.zoomType && (this.changeBgSize = !0, this.zoomLens.css({
        width: String(this.options.zoomWindowWidth / this.widthRatio) + "px"
      })), "lens" == this.options.zoomType || "inner" == this.options.zoomType) && (this.changeBgSize = !0), "inner" == this.options.zoomType && (this.changeBgSize = !0, this.nzWidth > this.nzHeight && (this.currentZoomLevel = this.newvaluewidth), this.nzHeight > this.nzWidth && (this.currentZoomLevel = this.newvaluewidth)));
      this.setPosition(this.currentLoc);
    },
    closeAll: function closeAll() {
      self.zoomWindow && self.zoomWindow.hide();
      self.zoomLens && self.zoomLens.hide();
      self.zoomTint && self.zoomTint.hide();
    },
    changeState: function changeState(b) {
      "enable" == b && (this.options.zoomEnabled = !0);
      "disable" == b && (this.options.zoomEnabled = !1);
    }
  };

  d.fn.elevateZoom = function (b) {
    return this.each(function () {
      var a = Object.create(k);
      a.init(b, this);
      d.data(this, "elevateZoom", a);
    });
  };

  d.fn.elevateZoom.options = {
    zoomActivation: "hover",
    zoomEnabled: !0,
    preloading: 1,
    zoomLevel: 1,
    scrollZoom: !1,
    scrollZoomIncrement: 0.1,
    minZoomLevel: !1,
    maxZoomLevel: !1,
    easing: !1,
    easingAmount: 12,
    lensSize: 200,
    zoomWindowWidth: 400,
    zoomWindowHeight: 400,
    zoomWindowOffetx: 0,
    zoomWindowOffety: 0,
    zoomWindowPosition: 1,
    zoomWindowBgColour: "#fff",
    lensFadeIn: !1,
    lensFadeOut: !1,
    debug: !1,
    zoomWindowFadeIn: !1,
    zoomWindowFadeOut: !1,
    zoomWindowAlwaysShow: !1,
    zoomTintFadeIn: !1,
    zoomTintFadeOut: !1,
    borderSize: 4,
    showLens: !0,
    borderColour: "#888",
    lensBorderSize: 1,
    lensBorderColour: "#000",
    lensShape: "square",
    zoomType: "window",
    containLensZoom: !1,
    lensColour: "white",
    lensOpacity: 0.4,
    lenszoom: !1,
    tint: !1,
    tintColour: "#333",
    tintOpacity: 0.4,
    gallery: !1,
    galleryActiveClass: "zoomGalleryActive",
    imageCrossfade: !1,
    constrainType: !1,
    constrainSize: !1,
    loadingIcon: !1,
    cursor: "default",
    responsive: !0,
    onComplete: d.noop,
    onZoomedImageLoaded: function onZoomedImageLoaded() {},
    onImageSwap: d.noop,
    onImageSwapComplete: d.noop
  };
})(jQuery, window, document); // ==================================================
// fancyBox v3.5.6
//
// Licensed GPLv3 for open source use
// or fancyBox Commercial License for commercial use
//
// http://fancyapps.com/fancybox/
// Copyright 2018 fancyApps
//
// ==================================================


!function (t, e, n, o) {
  "use strict";

  function i(t, e) {
    var o,
        i,
        a,
        s = [],
        r = 0;
    t && t.isDefaultPrevented() || (t.preventDefault(), e = e || {}, t && t.data && (e = h(t.data.options, e)), o = e.$target || n(t.currentTarget).trigger("blur"), (a = n.fancybox.getInstance()) && a.$trigger && a.$trigger.is(o) || (e.selector ? s = n(e.selector) : (i = o.attr("data-fancybox") || "", i ? (s = t.data ? t.data.items : [], s = s.length ? s.filter('[data-fancybox="' + i + '"]') : n('[data-fancybox="' + i + '"]')) : s = [o]), r = n(s).index(o), r < 0 && (r = 0), a = n.fancybox.open(s, e, r), a.$trigger = o));
  }

  if (t.console = t.console || {
    info: function info(t) {}
  }, n) {
    if (n.fn.fancybox) return void console.info("fancyBox already initialized");

    var a = {
      closeExisting: !1,
      loop: !1,
      gutter: 50,
      keyboard: !0,
      preventCaptionOverlap: !0,
      arrows: !0,
      infobar: !0,
      smallBtn: "auto",
      toolbar: "auto",
      buttons: ["zoom", "slideShow", "thumbs", "close"],
      idleTime: 3,
      protect: !1,
      modal: !1,
      image: {
        preload: !1
      },
      ajax: {
        settings: {
          data: {
            fancybox: !0
          }
        }
      },
      iframe: {
        tpl: '<iframe sandbox id="fancybox-frame{rnd}" name="fancybox-frame{rnd}" class="fancybox-iframe" allowfullscreen="allowfullscreen" allow="autoplay; fullscreen" src=""></iframe>',
        preload: !0,
        css: {},
        attr: {
          scrolling: "auto"
        }
      },
      video: {
        tpl: '<video class="fancybox-video" controls controlsList="nodownload" poster="{{poster}}"><source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!</video>',
        format: "",
        autoStart: !0
      },
      defaultType: "image",
      animationEffect: "zoom",
      animationDuration: 366,
      zoomOpacity: "auto",
      transitionEffect: "fade",
      transitionDuration: 366,
      slideClass: "",
      baseClass: "",
      baseTpl: '<div class="fancybox-container" role="dialog" tabindex="-1"><div class="fancybox-bg"></div><div class="fancybox-inner"><div class="fancybox-infobar"><span data-fancybox-index></span>&nbsp;/&nbsp;<span data-fancybox-count></span></div><div class="fancybox-toolbar">{{buttons}}</div><div class="fancybox-navigation">{{arrows}}</div><div class="fancybox-stage"></div><div class="fancybox-caption"><div class="fancybox-caption__body"></div></div></div></div>',
      spinnerTpl: '<div class="fancybox-loading"></div>',
      errorTpl: '<div class="fancybox-error"><p>{{ERROR}}</p></div>',
      btnTpl: {
        download: '<a download data-fancybox-download class="fancybox-button fancybox-button--download" title="{{DOWNLOAD}}" href="javascript:;"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.62 17.09V19H5.38v-1.91zm-2.97-6.96L17 11.45l-5 4.87-5-4.87 1.36-1.32 2.68 2.64V5h1.92v7.77z"/></svg></a>',
        zoom: '<button data-fancybox-zoom class="fancybox-button fancybox-button--zoom" title="{{ZOOM}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.7 17.3l-3-3a5.9 5.9 0 0 0-.6-7.6 5.9 5.9 0 0 0-8.4 0 5.9 5.9 0 0 0 0 8.4 5.9 5.9 0 0 0 7.7.7l3 3a1 1 0 0 0 1.3 0c.4-.5.4-1 0-1.5zM8.1 13.8a4 4 0 0 1 0-5.7 4 4 0 0 1 5.7 0 4 4 0 0 1 0 5.7 4 4 0 0 1-5.7 0z"/></svg></button>',
        close: '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 10.6L6.6 5.2 5.2 6.6l5.4 5.4-5.4 5.4 1.4 1.4 5.4-5.4 5.4 5.4 1.4-1.4-5.4-5.4 5.4-5.4-1.4-1.4-5.4 5.4z"/></svg></button>',
        arrowLeft: '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.28 15.7l-1.34 1.37L5 12l4.94-5.07 1.34 1.38-2.68 2.72H19v1.94H8.6z"/></svg></div></button>',
        arrowRight: '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}"><div><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M15.4 12.97l-2.68 2.72 1.34 1.38L19 12l-4.94-5.07-1.34 1.38 2.68 2.72H5v1.94z"/></svg></div></button>',
        smallBtn: '<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}"><svg xmlns="http://www.w3.org/2000/svg" version="1" viewBox="0 0 24 24"><path d="M13 12l5-5-1-1-5 5-5-5-1 1 5 5-5 5 1 1 5-5 5 5 1-1z"/></svg></button>'
      },
      parentEl: "body",
      hideScrollbar: !0,
      autoFocus: !0,
      backFocus: !0,
      trapFocus: !0,
      fullScreen: {
        autoStart: !1
      },
      touch: {
        vertical: !0,
        momentum: !0
      },
      hash: null,
      media: {},
      slideShow: {
        autoStart: !1,
        speed: 3e3
      },
      thumbs: {
        autoStart: !1,
        hideOnClose: !0,
        parentEl: ".fancybox-container",
        axis: "y"
      },
      wheel: "auto",
      onInit: n.noop,
      beforeLoad: n.noop,
      afterLoad: n.noop,
      beforeShow: n.noop,
      afterShow: n.noop,
      beforeClose: n.noop,
      afterClose: n.noop,
      onActivate: n.noop,
      onDeactivate: n.noop,
      clickContent: function clickContent(t, e) {
        return "image" === t.type && "zoom";
      },
      clickSlide: "close",
      clickOutside: "close",
      dblclickContent: !1,
      dblclickSlide: !1,
      dblclickOutside: !1,
      mobile: {
        preventCaptionOverlap: !1,
        idleTime: !1,
        clickContent: function clickContent(t, e) {
          return "image" === t.type && "toggleControls";
        },
        clickSlide: function clickSlide(t, e) {
          return "image" === t.type ? "toggleControls" : "close";
        },
        dblclickContent: function dblclickContent(t, e) {
          return "image" === t.type && "zoom";
        },
        dblclickSlide: function dblclickSlide(t, e) {
          return "image" === t.type && "zoom";
        }
      },
      lang: "en",
      i18n: {
        en: {
          CLOSE: "Close",
          NEXT: "Next",
          PREV: "Previous",
          ERROR: "The requested content cannot be loaded. <br/> Please try again later.",
          PLAY_START: "Start slideshow",
          PLAY_STOP: "Pause slideshow",
          FULL_SCREEN: "Full screen",
          THUMBS: "Thumbnails",
          DOWNLOAD: "Download",
          SHARE: "Share",
          ZOOM: "Zoom"
        },
        de: {
          CLOSE: "Schlie&szlig;en",
          NEXT: "Weiter",
          PREV: "Zur&uuml;ck",
          ERROR: "Die angeforderten Daten konnten nicht geladen werden. <br/> Bitte versuchen Sie es sp&auml;ter nochmal.",
          PLAY_START: "Diaschau starten",
          PLAY_STOP: "Diaschau beenden",
          FULL_SCREEN: "Vollbild",
          THUMBS: "Vorschaubilder",
          DOWNLOAD: "Herunterladen",
          SHARE: "Teilen",
          ZOOM: "Vergr&ouml;&szlig;ern"
        }
      }
    },
        s = n(t),
        r = n(e),
        c = 0,
        l = function l(t) {
      return t && t.hasOwnProperty && t instanceof n;
    },
        d = function () {
      return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function (e) {
        return t.setTimeout(e, 1e3 / 60);
      };
    }(),
        u = function () {
      return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function (e) {
        t.clearTimeout(e);
      };
    }(),
        f = function () {
      var t,
          n = e.createElement("fakeelement"),
          o = {
        transition: "transitionend",
        OTransition: "oTransitionEnd",
        MozTransition: "transitionend",
        WebkitTransition: "webkitTransitionEnd"
      };

      for (t in o) {
        if (void 0 !== n.style[t]) return o[t];
      }

      return "transitionend";
    }(),
        p = function p(t) {
      return t && t.length && t[0].offsetHeight;
    },
        h = function h(t, e) {
      var o = n.extend(!0, {}, t, e);
      return n.each(e, function (t, e) {
        n.isArray(e) && (o[t] = e);
      }), o;
    },
        g = function g(t) {
      var o, i;
      return !(!t || t.ownerDocument !== e) && (n(".fancybox-container").css("pointer-events", "none"), o = {
        x: t.getBoundingClientRect().left + t.offsetWidth / 2,
        y: t.getBoundingClientRect().top + t.offsetHeight / 2
      }, i = e.elementFromPoint(o.x, o.y) === t, n(".fancybox-container").css("pointer-events", ""), i);
    },
        b = function b(t, e, o) {
      var i = this;
      i.opts = h({
        index: o
      }, n.fancybox.defaults), n.isPlainObject(e) && (i.opts = h(i.opts, e)), n.fancybox.isMobile && (i.opts = h(i.opts, i.opts.mobile)), i.id = i.opts.id || ++c, i.currIndex = parseInt(i.opts.index, 10) || 0, i.prevIndex = null, i.prevPos = null, i.currPos = 0, i.firstRun = !0, i.group = [], i.slides = {}, i.addContent(t), i.group.length && i.init();
    };

    n.extend(b.prototype, {
      init: function init() {
        var o,
            i,
            a = this,
            s = a.group[a.currIndex],
            r = s.opts;
        r.closeExisting && n.fancybox.close(!0), n("body").addClass("fancybox-active"), !n.fancybox.getInstance() && !1 !== r.hideScrollbar && !n.fancybox.isMobile && e.body.scrollHeight > t.innerHeight && (n("head").append('<style id="fancybox-style-noscroll" type="text/css">.compensate-for-scrollbar{margin-right:' + (t.innerWidth - e.documentElement.clientWidth) + "px;}</style>"), n("body").addClass("compensate-for-scrollbar")), i = "", n.each(r.buttons, function (t, e) {
          i += r.btnTpl[e] || "";
        }), o = n(a.translate(a, r.baseTpl.replace("{{buttons}}", i).replace("{{arrows}}", r.btnTpl.arrowLeft + r.btnTpl.arrowRight))).attr("id", "fancybox-container-" + a.id).addClass(r.baseClass).data("FancyBox", a).appendTo(r.parentEl), a.$refs = {
          container: o
        }, ["bg", "inner", "infobar", "toolbar", "stage", "caption", "navigation"].forEach(function (t) {
          a.$refs[t] = o.find(".fancybox-" + t);
        }), a.trigger("onInit"), a.activate(), a.jumpTo(a.currIndex);
      },
      translate: function translate(t, e) {
        var n = t.opts.i18n[t.opts.lang] || t.opts.i18n.en;
        return e.replace(/\{\{(\w+)\}\}/g, function (t, e) {
          return void 0 === n[e] ? t : n[e];
        });
      },
      addContent: function addContent(t) {
        var e,
            o = this,
            i = n.makeArray(t);
        n.each(i, function (t, e) {
          var i,
              a,
              s,
              r,
              c,
              l = {},
              d = {};
          n.isPlainObject(e) ? (l = e, d = e.opts || e) : "object" === n.type(e) && n(e).length ? (i = n(e), d = i.data() || {}, d = n.extend(!0, {}, d, d.options), d.$orig = i, l.src = o.opts.src || d.src || i.attr("href"), l.type || l.src || (l.type = "inline", l.src = e)) : l = {
            type: "html",
            src: e + ""
          }, l.opts = n.extend(!0, {}, o.opts, d), n.isArray(d.buttons) && (l.opts.buttons = d.buttons), n.fancybox.isMobile && l.opts.mobile && (l.opts = h(l.opts, l.opts.mobile)), a = l.type || l.opts.type, r = l.src || "", !a && r && ((s = r.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i)) ? (a = "video", l.opts.video.format || (l.opts.video.format = "video/" + ("ogv" === s[1] ? "ogg" : s[1]))) : r.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg|ico)((\?|#).*)?$)/i) ? a = "image" : r.match(/\.(pdf)((\?|#).*)?$/i) ? (a = "iframe", l = n.extend(!0, l, {
            contentType: "pdf",
            opts: {
              iframe: {
                preload: !1
              }
            }
          })) : "#" === r.charAt(0) && (a = "inline")), a ? l.type = a : o.trigger("objectNeedsType", l), l.contentType || (l.contentType = n.inArray(l.type, ["html", "inline", "ajax"]) > -1 ? "html" : l.type), l.index = o.group.length, "auto" == l.opts.smallBtn && (l.opts.smallBtn = n.inArray(l.type, ["html", "inline", "ajax"]) > -1), "auto" === l.opts.toolbar && (l.opts.toolbar = !l.opts.smallBtn), l.$thumb = l.opts.$thumb || null, l.opts.$trigger && l.index === o.opts.index && (l.$thumb = l.opts.$trigger.find("img:first"), l.$thumb.length && (l.opts.$orig = l.opts.$trigger)), l.$thumb && l.$thumb.length || !l.opts.$orig || (l.$thumb = l.opts.$orig.find("img:first")), l.$thumb && !l.$thumb.length && (l.$thumb = null), l.thumb = l.opts.thumb || (l.$thumb ? l.$thumb[0].src : null), "function" === n.type(l.opts.caption) && (l.opts.caption = l.opts.caption.apply(e, [o, l])), "function" === n.type(o.opts.caption) && (l.opts.caption = o.opts.caption.apply(e, [o, l])), l.opts.caption instanceof n || (l.opts.caption = void 0 === l.opts.caption ? "" : l.opts.caption + ""), "ajax" === l.type && (c = r.split(/\s+/, 2), c.length > 1 && (l.src = c.shift(), l.opts.filter = c.shift())), l.opts.modal && (l.opts = n.extend(!0, l.opts, {
            trapFocus: !0,
            infobar: 0,
            toolbar: 0,
            smallBtn: 0,
            keyboard: 0,
            slideShow: 0,
            fullScreen: 0,
            thumbs: 0,
            touch: 0,
            clickContent: !1,
            clickSlide: !1,
            clickOutside: !1,
            dblclickContent: !1,
            dblclickSlide: !1,
            dblclickOutside: !1
          })), o.group.push(l);
        }), Object.keys(o.slides).length && (o.updateControls(), (e = o.Thumbs) && e.isActive && (e.create(), e.focus()));
      },
      addEvents: function addEvents() {
        var e = this;
        e.removeEvents(), e.$refs.container.on("click.fb-close", "[data-fancybox-close]", function (t) {
          t.stopPropagation(), t.preventDefault(), e.close(t);
        }).on("touchstart.fb-prev click.fb-prev", "[data-fancybox-prev]", function (t) {
          t.stopPropagation(), t.preventDefault(), e.previous();
        }).on("touchstart.fb-next click.fb-next", "[data-fancybox-next]", function (t) {
          t.stopPropagation(), t.preventDefault(), e.next();
        }).on("click.fb", "[data-fancybox-zoom]", function (t) {
          e[e.isScaledDown() ? "scaleToActual" : "scaleToFit"]();
        }), s.on("orientationchange.fb resize.fb", function (t) {
          t && t.originalEvent && "resize" === t.originalEvent.type ? (e.requestId && u(e.requestId), e.requestId = d(function () {
            e.update(t);
          })) : (e.current && "iframe" === e.current.type && e.$refs.stage.hide(), setTimeout(function () {
            e.$refs.stage.show(), e.update(t);
          }, n.fancybox.isMobile ? 600 : 250));
        }), r.on("keydown.fb", function (t) {
          var o = n.fancybox ? n.fancybox.getInstance() : null,
              i = o.current,
              a = t.keyCode || t.which;
          if (9 == a) return void (i.opts.trapFocus && e.focus(t));
          if (!(!i.opts.keyboard || t.ctrlKey || t.altKey || t.shiftKey || n(t.target).is("input,textarea,video,audio"))) return 8 === a || 27 === a ? (t.preventDefault(), void e.close(t)) : 37 === a || 38 === a ? (t.preventDefault(), void e.previous()) : 39 === a || 40 === a ? (t.preventDefault(), void e.next()) : void e.trigger("afterKeydown", t, a);
        }), e.group[e.currIndex].opts.idleTime && (e.idleSecondsCounter = 0, r.on("mousemove.fb-idle mouseleave.fb-idle mousedown.fb-idle touchstart.fb-idle touchmove.fb-idle scroll.fb-idle keydown.fb-idle", function (t) {
          e.idleSecondsCounter = 0, e.isIdle && e.showControls(), e.isIdle = !1;
        }), e.idleInterval = t.setInterval(function () {
          ++e.idleSecondsCounter >= e.group[e.currIndex].opts.idleTime && !e.isDragging && (e.isIdle = !0, e.idleSecondsCounter = 0, e.hideControls());
        }, 1e3));
      },
      removeEvents: function removeEvents() {
        var e = this;
        s.off("orientationchange.fb resize.fb"), r.off("keydown.fb .fb-idle"), this.$refs.container.off(".fb-close .fb-prev .fb-next"), e.idleInterval && (t.clearInterval(e.idleInterval), e.idleInterval = null);
      },
      previous: function previous(t) {
        return this.jumpTo(this.currPos - 1, t);
      },
      next: function next(t) {
        return this.jumpTo(this.currPos + 1, t);
      },
      jumpTo: function jumpTo(t, e) {
        var o,
            i,
            a,
            s,
            r,
            c,
            l,
            d,
            u,
            f = this,
            h = f.group.length;

        if (!(f.isDragging || f.isClosing || f.isAnimating && f.firstRun)) {
          if (t = parseInt(t, 10), !(a = f.current ? f.current.opts.loop : f.opts.loop) && (t < 0 || t >= h)) return !1;
          if (o = f.firstRun = !Object.keys(f.slides).length, r = f.current, f.prevIndex = f.currIndex, f.prevPos = f.currPos, s = f.createSlide(t), h > 1 && ((a || s.index < h - 1) && f.createSlide(t + 1), (a || s.index > 0) && f.createSlide(t - 1)), f.current = s, f.currIndex = s.index, f.currPos = s.pos, f.trigger("beforeShow", o), f.updateControls(), s.forcedDuration = void 0, n.isNumeric(e) ? s.forcedDuration = e : e = s.opts[o ? "animationDuration" : "transitionDuration"], e = parseInt(e, 10), i = f.isMoved(s), s.$slide.addClass("fancybox-slide--current"), o) return s.opts.animationEffect && e && f.$refs.container.css("transition-duration", e + "ms"), f.$refs.container.addClass("fancybox-is-open").trigger("focus"), f.loadSlide(s), void f.preload("image");
          c = n.fancybox.getTranslate(r.$slide), l = n.fancybox.getTranslate(f.$refs.stage), n.each(f.slides, function (t, e) {
            n.fancybox.stop(e.$slide, !0);
          }), r.pos !== s.pos && (r.isComplete = !1), r.$slide.removeClass("fancybox-slide--complete fancybox-slide--current"), i ? (u = c.left - (r.pos * c.width + r.pos * r.opts.gutter), n.each(f.slides, function (t, o) {
            o.$slide.removeClass("fancybox-animated").removeClass(function (t, e) {
              return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
            });
            var i = o.pos * c.width + o.pos * o.opts.gutter;
            n.fancybox.setTranslate(o.$slide, {
              top: 0,
              left: i - l.left + u
            }), o.pos !== s.pos && o.$slide.addClass("fancybox-slide--" + (o.pos > s.pos ? "next" : "previous")), p(o.$slide), n.fancybox.animate(o.$slide, {
              top: 0,
              left: (o.pos - s.pos) * c.width + (o.pos - s.pos) * o.opts.gutter
            }, e, function () {
              o.$slide.css({
                transform: "",
                opacity: ""
              }).removeClass("fancybox-slide--next fancybox-slide--previous"), o.pos === f.currPos && f.complete();
            });
          })) : e && s.opts.transitionEffect && (d = "fancybox-animated fancybox-fx-" + s.opts.transitionEffect, r.$slide.addClass("fancybox-slide--" + (r.pos > s.pos ? "next" : "previous")), n.fancybox.animate(r.$slide, d, e, function () {
            r.$slide.removeClass(d).removeClass("fancybox-slide--next fancybox-slide--previous");
          }, !1)), s.isLoaded ? f.revealContent(s) : f.loadSlide(s), f.preload("image");
        }
      },
      createSlide: function createSlide(t) {
        var e,
            o,
            i = this;
        return o = t % i.group.length, o = o < 0 ? i.group.length + o : o, !i.slides[t] && i.group[o] && (e = n('<div class="fancybox-slide"></div>').appendTo(i.$refs.stage), i.slides[t] = n.extend(!0, {}, i.group[o], {
          pos: t,
          $slide: e,
          isLoaded: !1
        }), i.updateSlide(i.slides[t])), i.slides[t];
      },
      scaleToActual: function scaleToActual(t, e, o) {
        var i,
            a,
            s,
            r,
            c,
            l = this,
            d = l.current,
            u = d.$content,
            f = n.fancybox.getTranslate(d.$slide).width,
            p = n.fancybox.getTranslate(d.$slide).height,
            h = d.width,
            g = d.height;
        l.isAnimating || l.isMoved() || !u || "image" != d.type || !d.isLoaded || d.hasError || (l.isAnimating = !0, n.fancybox.stop(u), t = void 0 === t ? .5 * f : t, e = void 0 === e ? .5 * p : e, i = n.fancybox.getTranslate(u), i.top -= n.fancybox.getTranslate(d.$slide).top, i.left -= n.fancybox.getTranslate(d.$slide).left, r = h / i.width, c = g / i.height, a = .5 * f - .5 * h, s = .5 * p - .5 * g, h > f && (a = i.left * r - (t * r - t), a > 0 && (a = 0), a < f - h && (a = f - h)), g > p && (s = i.top * c - (e * c - e), s > 0 && (s = 0), s < p - g && (s = p - g)), l.updateCursor(h, g), n.fancybox.animate(u, {
          top: s,
          left: a,
          scaleX: r,
          scaleY: c
        }, o || 366, function () {
          l.isAnimating = !1;
        }), l.SlideShow && l.SlideShow.isActive && l.SlideShow.stop());
      },
      scaleToFit: function scaleToFit(t) {
        var e,
            o = this,
            i = o.current,
            a = i.$content;
        o.isAnimating || o.isMoved() || !a || "image" != i.type || !i.isLoaded || i.hasError || (o.isAnimating = !0, n.fancybox.stop(a), e = o.getFitPos(i), o.updateCursor(e.width, e.height), n.fancybox.animate(a, {
          top: e.top,
          left: e.left,
          scaleX: e.width / a.width(),
          scaleY: e.height / a.height()
        }, t || 366, function () {
          o.isAnimating = !1;
        }));
      },
      getFitPos: function getFitPos(t) {
        var e,
            o,
            i,
            a,
            s = this,
            r = t.$content,
            c = t.$slide,
            l = t.width || t.opts.width,
            d = t.height || t.opts.height,
            u = {};
        return !!(t.isLoaded && r && r.length) && (e = n.fancybox.getTranslate(s.$refs.stage).width, o = n.fancybox.getTranslate(s.$refs.stage).height, e -= parseFloat(c.css("paddingLeft")) + parseFloat(c.css("paddingRight")) + parseFloat(r.css("marginLeft")) + parseFloat(r.css("marginRight")), o -= parseFloat(c.css("paddingTop")) + parseFloat(c.css("paddingBottom")) + parseFloat(r.css("marginTop")) + parseFloat(r.css("marginBottom")), l && d || (l = e, d = o), i = Math.min(1, e / l, o / d), l *= i, d *= i, l > e - .5 && (l = e), d > o - .5 && (d = o), "image" === t.type ? (u.top = Math.floor(.5 * (o - d)) + parseFloat(c.css("paddingTop")), u.left = Math.floor(.5 * (e - l)) + parseFloat(c.css("paddingLeft"))) : "video" === t.contentType && (a = t.opts.width && t.opts.height ? l / d : t.opts.ratio || 16 / 9, d > l / a ? d = l / a : l > d * a && (l = d * a)), u.width = l, u.height = d, u);
      },
      update: function update(t) {
        var e = this;
        n.each(e.slides, function (n, o) {
          e.updateSlide(o, t);
        });
      },
      updateSlide: function updateSlide(t, e) {
        var o = this,
            i = t && t.$content,
            a = t.width || t.opts.width,
            s = t.height || t.opts.height,
            r = t.$slide;
        o.adjustCaption(t), i && (a || s || "video" === t.contentType) && !t.hasError && (n.fancybox.stop(i), n.fancybox.setTranslate(i, o.getFitPos(t)), t.pos === o.currPos && (o.isAnimating = !1, o.updateCursor())), o.adjustLayout(t), r.length && (r.trigger("refresh"), t.pos === o.currPos && o.$refs.toolbar.add(o.$refs.navigation.find(".fancybox-button--arrow_right")).toggleClass("compensate-for-scrollbar", r.get(0).scrollHeight > r.get(0).clientHeight)), o.trigger("onUpdate", t, e);
      },
      centerSlide: function centerSlide(t) {
        var e = this,
            o = e.current,
            i = o.$slide;
        !e.isClosing && o && (i.siblings().css({
          transform: "",
          opacity: ""
        }), i.parent().children().removeClass("fancybox-slide--previous fancybox-slide--next"), n.fancybox.animate(i, {
          top: 0,
          left: 0,
          opacity: 1
        }, void 0 === t ? 0 : t, function () {
          i.css({
            transform: "",
            opacity: ""
          }), o.isComplete || e.complete();
        }, !1));
      },
      isMoved: function isMoved(t) {
        var e,
            o,
            i = t || this.current;
        return !!i && (o = n.fancybox.getTranslate(this.$refs.stage), e = n.fancybox.getTranslate(i.$slide), !i.$slide.hasClass("fancybox-animated") && (Math.abs(e.top - o.top) > .5 || Math.abs(e.left - o.left) > .5));
      },
      updateCursor: function updateCursor(t, e) {
        var o,
            i,
            a = this,
            s = a.current,
            r = a.$refs.container;
        s && !a.isClosing && a.Guestures && (r.removeClass("fancybox-is-zoomable fancybox-can-zoomIn fancybox-can-zoomOut fancybox-can-swipe fancybox-can-pan"), o = a.canPan(t, e), i = !!o || a.isZoomable(), r.toggleClass("fancybox-is-zoomable", i), n("[data-fancybox-zoom]").prop("disabled", !i), o ? r.addClass("fancybox-can-pan") : i && ("zoom" === s.opts.clickContent || n.isFunction(s.opts.clickContent) && "zoom" == s.opts.clickContent(s)) ? r.addClass("fancybox-can-zoomIn") : s.opts.touch && (s.opts.touch.vertical || a.group.length > 1) && "video" !== s.contentType && r.addClass("fancybox-can-swipe"));
      },
      isZoomable: function isZoomable() {
        var t,
            e = this,
            n = e.current;

        if (n && !e.isClosing && "image" === n.type && !n.hasError) {
          if (!n.isLoaded) return !0;
          if ((t = e.getFitPos(n)) && (n.width > t.width || n.height > t.height)) return !0;
        }

        return !1;
      },
      isScaledDown: function isScaledDown(t, e) {
        var o = this,
            i = !1,
            a = o.current,
            s = a.$content;
        return void 0 !== t && void 0 !== e ? i = t < a.width && e < a.height : s && (i = n.fancybox.getTranslate(s), i = i.width < a.width && i.height < a.height), i;
      },
      canPan: function canPan(t, e) {
        var o = this,
            i = o.current,
            a = null,
            s = !1;
        return "image" === i.type && (i.isComplete || t && e) && !i.hasError && (s = o.getFitPos(i), void 0 !== t && void 0 !== e ? a = {
          width: t,
          height: e
        } : i.isComplete && (a = n.fancybox.getTranslate(i.$content)), a && s && (s = Math.abs(a.width - s.width) > 1.5 || Math.abs(a.height - s.height) > 1.5)), s;
      },
      loadSlide: function loadSlide(t) {
        var e,
            o,
            i,
            a = this;

        if (!t.isLoading && !t.isLoaded) {
          if (t.isLoading = !0, !1 === a.trigger("beforeLoad", t)) return t.isLoading = !1, !1;

          switch (e = t.type, o = t.$slide, o.off("refresh").trigger("onReset").addClass(t.opts.slideClass), e) {
            case "image":
              a.setImage(t);
              break;

            case "iframe":
              a.setIframe(t);
              break;

            case "html":
              a.setContent(t, t.src || t.content);
              break;

            case "video":
              a.setContent(t, t.opts.video.tpl.replace(/\{\{src\}\}/gi, t.src).replace("{{format}}", t.opts.videoFormat || t.opts.video.format || "").replace("{{poster}}", t.thumb || ""));
              break;

            case "inline":
              n(t.src).length ? a.setContent(t, n(t.src)) : a.setError(t);
              break;

            case "ajax":
              a.showLoading(t), i = n.ajax(n.extend({}, t.opts.ajax.settings, {
                url: t.src,
                success: function success(e, n) {
                  "success" === n && a.setContent(t, e);
                },
                error: function error(e, n) {
                  e && "abort" !== n && a.setError(t);
                }
              })), o.one("onReset", function () {
                i.abort();
              });
              break;

            default:
              a.setError(t);
          }

          return !0;
        }
      },
      setImage: function setImage(t) {
        var o,
            i = this;
        setTimeout(function () {
          var e = t.$image;
          i.isClosing || !t.isLoading || e && e.length && e[0].complete || t.hasError || i.showLoading(t);
        }, 50), i.checkSrcset(t), t.$content = n('<div class="fancybox-content"></div>').addClass("fancybox-is-hidden").appendTo(t.$slide.addClass("fancybox-slide--image")), !1 !== t.opts.preload && t.opts.width && t.opts.height && t.thumb && (t.width = t.opts.width, t.height = t.opts.height, o = e.createElement("img"), o.onerror = function () {
          n(this).remove(), t.$ghost = null;
        }, o.onload = function () {
          i.afterLoad(t);
        }, t.$ghost = n(o).addClass("fancybox-image").appendTo(t.$content).attr("src", t.thumb)), i.setBigImage(t);
      },
      checkSrcset: function checkSrcset(e) {
        var n,
            o,
            i,
            a,
            s = e.opts.srcset || e.opts.image.srcset;

        if (s) {
          i = t.devicePixelRatio || 1, a = t.innerWidth * i, o = s.split(",").map(function (t) {
            var e = {};
            return t.trim().split(/\s+/).forEach(function (t, n) {
              var o = parseInt(t.substring(0, t.length - 1), 10);
              if (0 === n) return e.url = t;
              o && (e.value = o, e.postfix = t[t.length - 1]);
            }), e;
          }), o.sort(function (t, e) {
            return t.value - e.value;
          });

          for (var r = 0; r < o.length; r++) {
            var c = o[r];

            if ("w" === c.postfix && c.value >= a || "x" === c.postfix && c.value >= i) {
              n = c;
              break;
            }
          }

          !n && o.length && (n = o[o.length - 1]), n && (e.src = n.url, e.width && e.height && "w" == n.postfix && (e.height = e.width / e.height * n.value, e.width = n.value), e.opts.srcset = s);
        }
      },
      setBigImage: function setBigImage(t) {
        var o = this,
            i = e.createElement("img"),
            a = n(i);
        t.$image = a.one("error", function () {
          o.setError(t);
        }).one("load", function () {
          var e;
          t.$ghost || (o.resolveImageSlideSize(t, this.naturalWidth, this.naturalHeight), o.afterLoad(t)), o.isClosing || (t.opts.srcset && (e = t.opts.sizes, e && "auto" !== e || (e = (t.width / t.height > 1 && s.width() / s.height() > 1 ? "100" : Math.round(t.width / t.height * 100)) + "vw"), a.attr("sizes", e).attr("srcset", t.opts.srcset)), t.$ghost && setTimeout(function () {
            t.$ghost && !o.isClosing && t.$ghost.hide();
          }, Math.min(300, Math.max(1e3, t.height / 1600))), o.hideLoading(t));
        }).addClass("fancybox-image").attr("src", t.src).appendTo(t.$content), (i.complete || "complete" == i.readyState) && a.naturalWidth && a.naturalHeight ? a.trigger("load") : i.error && a.trigger("error");
      },
      resolveImageSlideSize: function resolveImageSlideSize(t, e, n) {
        var o = parseInt(t.opts.width, 10),
            i = parseInt(t.opts.height, 10);
        t.width = e, t.height = n, o > 0 && (t.width = o, t.height = Math.floor(o * n / e)), i > 0 && (t.width = Math.floor(i * e / n), t.height = i);
      },
      setIframe: function setIframe(t) {
        var e,
            o = this,
            i = t.opts.iframe,
            a = t.$slide;
        t.$content = n('<div class="fancybox-content' + (i.preload ? " fancybox-is-hidden" : "") + '"></div>').css(i.css).appendTo(a), a.addClass("fancybox-slide--" + t.contentType), t.$iframe = e = n(i.tpl.replace(/\{rnd\}/g, new Date().getTime())).attr(i.attr).appendTo(t.$content), i.preload ? (o.showLoading(t), e.on("load.fb error.fb", function (e) {
          this.isReady = 1, t.$slide.trigger("refresh"), o.afterLoad(t);
        }), a.on("refresh.fb", function () {
          var n,
              o,
              s = t.$content,
              r = i.css.width,
              c = i.css.height;

          if (1 === e[0].isReady) {
            try {
              n = e.contents(), o = n.find("body");
            } catch (t) {}

            o && o.length && o.children().length && (a.css("overflow", "visible"), s.css({
              width: "100%",
              "max-width": "100%",
              height: "9999px"
            }), void 0 === r && (r = Math.ceil(Math.max(o[0].clientWidth, o.outerWidth(!0)))), s.css("width", r || "").css("max-width", ""), void 0 === c && (c = Math.ceil(Math.max(o[0].clientHeight, o.outerHeight(!0)))), s.css("height", c || ""), a.css("overflow", "auto")), s.removeClass("fancybox-is-hidden");
          }
        })) : o.afterLoad(t), e.attr("src", t.src), a.one("onReset", function () {
          try {
            n(this).find("iframe").hide().unbind().attr("src", "//about:blank");
          } catch (t) {}

          n(this).off("refresh.fb").empty(), t.isLoaded = !1, t.isRevealed = !1;
        });
      },
      setContent: function setContent(t, e) {
        var o = this;
        o.isClosing || (o.hideLoading(t), t.$content && n.fancybox.stop(t.$content), t.$slide.empty(), l(e) && e.parent().length ? ((e.hasClass("fancybox-content") || e.parent().hasClass("fancybox-content")) && e.parents(".fancybox-slide").trigger("onReset"), t.$placeholder = n("<div>").hide().insertAfter(e), e.css("display", "inline-block")) : t.hasError || ("string" === n.type(e) && (e = n("<div>").append(n.trim(e)).contents()), t.opts.filter && (e = n("<div>").html(e).find(t.opts.filter))), t.$slide.one("onReset", function () {
          n(this).find("video,audio").trigger("pause"), t.$placeholder && (t.$placeholder.after(e.removeClass("fancybox-content").hide()).remove(), t.$placeholder = null), t.$smallBtn && (t.$smallBtn.remove(), t.$smallBtn = null), t.hasError || (n(this).empty(), t.isLoaded = !1, t.isRevealed = !1);
        }), n(e).appendTo(t.$slide), n(e).is("video,audio") && (n(e).addClass("fancybox-video"), n(e).wrap("<div></div>"), t.contentType = "video", t.opts.width = t.opts.width || n(e).attr("width"), t.opts.height = t.opts.height || n(e).attr("height")), t.$content = t.$slide.children().filter("div,form,main,video,audio,article,.fancybox-content").first(), t.$content.siblings().hide(), t.$content.length || (t.$content = t.$slide.wrapInner("<div></div>").children().first()), t.$content.addClass("fancybox-content"), t.$slide.addClass("fancybox-slide--" + t.contentType), o.afterLoad(t));
      },
      setError: function setError(t) {
        t.hasError = !0, t.$slide.trigger("onReset").removeClass("fancybox-slide--" + t.contentType).addClass("fancybox-slide--error"), t.contentType = "html", this.setContent(t, this.translate(t, t.opts.errorTpl)), t.pos === this.currPos && (this.isAnimating = !1);
      },
      showLoading: function showLoading(t) {
        var e = this;
        (t = t || e.current) && !t.$spinner && (t.$spinner = n(e.translate(e, e.opts.spinnerTpl)).appendTo(t.$slide).hide().fadeIn("fast"));
      },
      hideLoading: function hideLoading(t) {
        var e = this;
        (t = t || e.current) && t.$spinner && (t.$spinner.stop().remove(), delete t.$spinner);
      },
      afterLoad: function afterLoad(t) {
        var e = this;
        e.isClosing || (t.isLoading = !1, t.isLoaded = !0, e.trigger("afterLoad", t), e.hideLoading(t), !t.opts.smallBtn || t.$smallBtn && t.$smallBtn.length || (t.$smallBtn = n(e.translate(t, t.opts.btnTpl.smallBtn)).appendTo(t.$content)), t.opts.protect && t.$content && !t.hasError && (t.$content.on("contextmenu.fb", function (t) {
          return 2 == t.button && t.preventDefault(), !0;
        }), "image" === t.type && n('<div class="fancybox-spaceball"></div>').appendTo(t.$content)), e.adjustCaption(t), e.adjustLayout(t), t.pos === e.currPos && e.updateCursor(), e.revealContent(t));
      },
      adjustCaption: function adjustCaption(t) {
        var e,
            n = this,
            o = t || n.current,
            i = o.opts.caption,
            a = o.opts.preventCaptionOverlap,
            s = n.$refs.caption,
            r = !1;
        s.toggleClass("fancybox-caption--separate", a), a && i && i.length && (o.pos !== n.currPos ? (e = s.clone().appendTo(s.parent()), e.children().eq(0).empty().html(i), r = e.outerHeight(!0), e.empty().remove()) : n.$caption && (r = n.$caption.outerHeight(!0)), o.$slide.css("padding-bottom", r || ""));
      },
      adjustLayout: function adjustLayout(t) {
        var e,
            n,
            o,
            i,
            a = this,
            s = t || a.current;
        s.isLoaded && !0 !== s.opts.disableLayoutFix && (s.$content.css("margin-bottom", ""), s.$content.outerHeight() > s.$slide.height() + .5 && (o = s.$slide[0].style["padding-bottom"], i = s.$slide.css("padding-bottom"), parseFloat(i) > 0 && (e = s.$slide[0].scrollHeight, s.$slide.css("padding-bottom", 0), Math.abs(e - s.$slide[0].scrollHeight) < 1 && (n = i), s.$slide.css("padding-bottom", o))), s.$content.css("margin-bottom", n));
      },
      revealContent: function revealContent(t) {
        var e,
            o,
            i,
            a,
            s = this,
            r = t.$slide,
            c = !1,
            l = !1,
            d = s.isMoved(t),
            u = t.isRevealed;
        return t.isRevealed = !0, e = t.opts[s.firstRun ? "animationEffect" : "transitionEffect"], i = t.opts[s.firstRun ? "animationDuration" : "transitionDuration"], i = parseInt(void 0 === t.forcedDuration ? i : t.forcedDuration, 10), !d && t.pos === s.currPos && i || (e = !1), "zoom" === e && (t.pos === s.currPos && i && "image" === t.type && !t.hasError && (l = s.getThumbPos(t)) ? c = s.getFitPos(t) : e = "fade"), "zoom" === e ? (s.isAnimating = !0, c.scaleX = c.width / l.width, c.scaleY = c.height / l.height, a = t.opts.zoomOpacity, "auto" == a && (a = Math.abs(t.width / t.height - l.width / l.height) > .1), a && (l.opacity = .1, c.opacity = 1), n.fancybox.setTranslate(t.$content.removeClass("fancybox-is-hidden"), l), p(t.$content), void n.fancybox.animate(t.$content, c, i, function () {
          s.isAnimating = !1, s.complete();
        })) : (s.updateSlide(t), e ? (n.fancybox.stop(r), o = "fancybox-slide--" + (t.pos >= s.prevPos ? "next" : "previous") + " fancybox-animated fancybox-fx-" + e, r.addClass(o).removeClass("fancybox-slide--current"), t.$content.removeClass("fancybox-is-hidden"), p(r), "image" !== t.type && t.$content.hide().show(0), void n.fancybox.animate(r, "fancybox-slide--current", i, function () {
          r.removeClass(o).css({
            transform: "",
            opacity: ""
          }), t.pos === s.currPos && s.complete();
        }, !0)) : (t.$content.removeClass("fancybox-is-hidden"), u || !d || "image" !== t.type || t.hasError || t.$content.hide().fadeIn("fast"), void (t.pos === s.currPos && s.complete())));
      },
      getThumbPos: function getThumbPos(t) {
        var e,
            o,
            i,
            a,
            s,
            r = !1,
            c = t.$thumb;
        return !(!c || !g(c[0])) && (e = n.fancybox.getTranslate(c), o = parseFloat(c.css("border-top-width") || 0), i = parseFloat(c.css("border-right-width") || 0), a = parseFloat(c.css("border-bottom-width") || 0), s = parseFloat(c.css("border-left-width") || 0), r = {
          top: e.top + o,
          left: e.left + s,
          width: e.width - i - s,
          height: e.height - o - a,
          scaleX: 1,
          scaleY: 1
        }, e.width > 0 && e.height > 0 && r);
      },
      complete: function complete() {
        var t,
            e = this,
            o = e.current,
            i = {};
        !e.isMoved() && o.isLoaded && (o.isComplete || (o.isComplete = !0, o.$slide.siblings().trigger("onReset"), e.preload("inline"), p(o.$slide), o.$slide.addClass("fancybox-slide--complete"), n.each(e.slides, function (t, o) {
          o.pos >= e.currPos - 1 && o.pos <= e.currPos + 1 ? i[o.pos] = o : o && (n.fancybox.stop(o.$slide), o.$slide.off().remove());
        }), e.slides = i), e.isAnimating = !1, e.updateCursor(), e.trigger("afterShow"), o.opts.video.autoStart && o.$slide.find("video,audio").filter(":visible:first").trigger("play").one("ended", function () {
          this.webkitExitFullscreen && this.webkitExitFullscreen(), e.next();
        }), o.opts.autoFocus && "html" === o.contentType && (t = o.$content.find("input[autofocus]:enabled:visible:first"), t.length ? t.trigger("focus") : e.focus(null, !0)), o.$slide.scrollTop(0).scrollLeft(0));
      },
      preload: function preload(t) {
        var e,
            n,
            o = this;
        o.group.length < 2 || (n = o.slides[o.currPos + 1], e = o.slides[o.currPos - 1], e && e.type === t && o.loadSlide(e), n && n.type === t && o.loadSlide(n));
      },
      focus: function focus(t, o) {
        var i,
            a,
            s = this,
            r = ["a[href]", "area[href]", 'input:not([disabled]):not([type="hidden"]):not([aria-hidden])', "select:not([disabled]):not([aria-hidden])", "textarea:not([disabled]):not([aria-hidden])", "button:not([disabled]):not([aria-hidden])", "iframe", "object", "embed", "video", "audio", "[contenteditable]", '[tabindex]:not([tabindex^="-"])'].join(",");
        s.isClosing || (i = !t && s.current && s.current.isComplete ? s.current.$slide.find("*:visible" + (o ? ":not(.fancybox-close-small)" : "")) : s.$refs.container.find("*:visible"), i = i.filter(r).filter(function () {
          return "hidden" !== n(this).css("visibility") && !n(this).hasClass("disabled");
        }), i.length ? (a = i.index(e.activeElement), t && t.shiftKey ? (a < 0 || 0 == a) && (t.preventDefault(), i.eq(i.length - 1).trigger("focus")) : (a < 0 || a == i.length - 1) && (t && t.preventDefault(), i.eq(0).trigger("focus"))) : s.$refs.container.trigger("focus"));
      },
      activate: function activate() {
        var t = this;
        n(".fancybox-container").each(function () {
          var e = n(this).data("FancyBox");
          e && e.id !== t.id && !e.isClosing && (e.trigger("onDeactivate"), e.removeEvents(), e.isVisible = !1);
        }), t.isVisible = !0, (t.current || t.isIdle) && (t.update(), t.updateControls()), t.trigger("onActivate"), t.addEvents();
      },
      close: function close(t, e) {
        var o,
            i,
            a,
            s,
            r,
            c,
            l,
            u = this,
            f = u.current,
            h = function h() {
          u.cleanUp(t);
        };

        return !u.isClosing && (u.isClosing = !0, !1 === u.trigger("beforeClose", t) ? (u.isClosing = !1, d(function () {
          u.update();
        }), !1) : (u.removeEvents(), a = f.$content, o = f.opts.animationEffect, i = n.isNumeric(e) ? e : o ? f.opts.animationDuration : 0, f.$slide.removeClass("fancybox-slide--complete fancybox-slide--next fancybox-slide--previous fancybox-animated"), !0 !== t ? n.fancybox.stop(f.$slide) : o = !1, f.$slide.siblings().trigger("onReset").remove(), i && u.$refs.container.removeClass("fancybox-is-open").addClass("fancybox-is-closing").css("transition-duration", i + "ms"), u.hideLoading(f), u.hideControls(!0), u.updateCursor(), "zoom" !== o || a && i && "image" === f.type && !u.isMoved() && !f.hasError && (l = u.getThumbPos(f)) || (o = "fade"), "zoom" === o ? (n.fancybox.stop(a), s = n.fancybox.getTranslate(a), c = {
          top: s.top,
          left: s.left,
          scaleX: s.width / l.width,
          scaleY: s.height / l.height,
          width: l.width,
          height: l.height
        }, r = f.opts.zoomOpacity, "auto" == r && (r = Math.abs(f.width / f.height - l.width / l.height) > .1), r && (l.opacity = 0), n.fancybox.setTranslate(a, c), p(a), n.fancybox.animate(a, l, i, h), !0) : (o && i ? n.fancybox.animate(f.$slide.addClass("fancybox-slide--previous").removeClass("fancybox-slide--current"), "fancybox-animated fancybox-fx-" + o, i, h) : !0 === t ? setTimeout(h, i) : h(), !0)));
      },
      cleanUp: function cleanUp(e) {
        var o,
            i,
            a,
            s = this,
            r = s.current.opts.$orig;
        s.current.$slide.trigger("onReset"), s.$refs.container.empty().remove(), s.trigger("afterClose", e), s.current.opts.backFocus && (r && r.length && r.is(":visible") || (r = s.$trigger), r && r.length && (i = t.scrollX, a = t.scrollY, r.trigger("focus"), n("html, body").scrollTop(a).scrollLeft(i))), s.current = null, o = n.fancybox.getInstance(), o ? o.activate() : (n("body").removeClass("fancybox-active compensate-for-scrollbar"), n("#fancybox-style-noscroll").remove());
      },
      trigger: function trigger(t, e) {
        var o,
            i = Array.prototype.slice.call(arguments, 1),
            a = this,
            s = e && e.opts ? e : a.current;
        if (s ? i.unshift(s) : s = a, i.unshift(a), n.isFunction(s.opts[t]) && (o = s.opts[t].apply(s, i)), !1 === o) return o;
        "afterClose" !== t && a.$refs ? a.$refs.container.trigger(t + ".fb", i) : r.trigger(t + ".fb", i);
      },
      updateControls: function updateControls() {
        var t = this,
            o = t.current,
            i = o.index,
            a = t.$refs.container,
            s = t.$refs.caption,
            r = o.opts.caption;
        o.$slide.trigger("refresh"), r && r.length ? (t.$caption = s, s.children().eq(0).html(r)) : t.$caption = null, t.hasHiddenControls || t.isIdle || t.showControls(), a.find("[data-fancybox-count]").html(t.group.length), a.find("[data-fancybox-index]").html(i + 1), a.find("[data-fancybox-prev]").prop("disabled", !o.opts.loop && i <= 0), a.find("[data-fancybox-next]").prop("disabled", !o.opts.loop && i >= t.group.length - 1), "image" === o.type ? a.find("[data-fancybox-zoom]").show().end().find("[data-fancybox-download]").attr("href", o.opts.image.src || o.src).show() : o.opts.toolbar && a.find("[data-fancybox-download],[data-fancybox-zoom]").hide(), n(e.activeElement).is(":hidden,[disabled]") && t.$refs.container.trigger("focus");
      },
      hideControls: function hideControls(t) {
        var e = this,
            n = ["infobar", "toolbar", "nav"];
        !t && e.current.opts.preventCaptionOverlap || n.push("caption"), this.$refs.container.removeClass(n.map(function (t) {
          return "fancybox-show-" + t;
        }).join(" ")), this.hasHiddenControls = !0;
      },
      showControls: function showControls() {
        var t = this,
            e = t.current ? t.current.opts : t.opts,
            n = t.$refs.container;
        t.hasHiddenControls = !1, t.idleSecondsCounter = 0, n.toggleClass("fancybox-show-toolbar", !(!e.toolbar || !e.buttons)).toggleClass("fancybox-show-infobar", !!(e.infobar && t.group.length > 1)).toggleClass("fancybox-show-caption", !!t.$caption).toggleClass("fancybox-show-nav", !!(e.arrows && t.group.length > 1)).toggleClass("fancybox-is-modal", !!e.modal);
      },
      toggleControls: function toggleControls() {
        this.hasHiddenControls ? this.showControls() : this.hideControls();
      }
    }), n.fancybox = {
      version: "3.5.6",
      defaults: a,
      getInstance: function getInstance(t) {
        var e = n('.fancybox-container:not(".fancybox-is-closing"):last').data("FancyBox"),
            o = Array.prototype.slice.call(arguments, 1);
        return e instanceof b && ("string" === n.type(t) ? e[t].apply(e, o) : "function" === n.type(t) && t.apply(e, o), e);
      },
      open: function open(t, e, n) {
        return new b(t, e, n);
      },
      close: function close(t) {
        var e = this.getInstance();
        e && (e.close(), !0 === t && this.close(t));
      },
      destroy: function destroy() {
        this.close(!0), r.add("body").off("click.fb-start", "**");
      },
      isMobile: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
      use3d: function () {
        var n = e.createElement("div");
        return t.getComputedStyle && t.getComputedStyle(n) && t.getComputedStyle(n).getPropertyValue("transform") && !(e.documentMode && e.documentMode < 11);
      }(),
      getTranslate: function getTranslate(t) {
        var e;
        return !(!t || !t.length) && (e = t[0].getBoundingClientRect(), {
          top: e.top || 0,
          left: e.left || 0,
          width: e.width,
          height: e.height,
          opacity: parseFloat(t.css("opacity"))
        });
      },
      setTranslate: function setTranslate(t, e) {
        var n = "",
            o = {};
        if (t && e) return void 0 === e.left && void 0 === e.top || (n = (void 0 === e.left ? t.position().left : e.left) + "px, " + (void 0 === e.top ? t.position().top : e.top) + "px", n = this.use3d ? "translate3d(" + n + ", 0px)" : "translate(" + n + ")"), void 0 !== e.scaleX && void 0 !== e.scaleY ? n += " scale(" + e.scaleX + ", " + e.scaleY + ")" : void 0 !== e.scaleX && (n += " scaleX(" + e.scaleX + ")"), n.length && (o.transform = n), void 0 !== e.opacity && (o.opacity = e.opacity), void 0 !== e.width && (o.width = e.width), void 0 !== e.height && (o.height = e.height), t.css(o);
      },
      animate: function animate(t, e, o, i, a) {
        var s,
            r = this;
        n.isFunction(o) && (i = o, o = null), r.stop(t), s = r.getTranslate(t), t.on(f, function (c) {
          (!c || !c.originalEvent || t.is(c.originalEvent.target) && "z-index" != c.originalEvent.propertyName) && (r.stop(t), n.isNumeric(o) && t.css("transition-duration", ""), n.isPlainObject(e) ? void 0 !== e.scaleX && void 0 !== e.scaleY && r.setTranslate(t, {
            top: e.top,
            left: e.left,
            width: s.width * e.scaleX,
            height: s.height * e.scaleY,
            scaleX: 1,
            scaleY: 1
          }) : !0 !== a && t.removeClass(e), n.isFunction(i) && i(c));
        }), n.isNumeric(o) && t.css("transition-duration", o + "ms"), n.isPlainObject(e) ? (void 0 !== e.scaleX && void 0 !== e.scaleY && (delete e.width, delete e.height, t.parent().hasClass("fancybox-slide--image") && t.parent().addClass("fancybox-is-scaling")), n.fancybox.setTranslate(t, e)) : t.addClass(e), t.data("timer", setTimeout(function () {
          t.trigger(f);
        }, o + 33));
      },
      stop: function stop(t, e) {
        t && t.length && (clearTimeout(t.data("timer")), e && t.trigger(f), t.off(f).css("transition-duration", ""), t.parent().removeClass("fancybox-is-scaling"));
      }
    }, n.fn.fancybox = function (t) {
      var e;
      return t = t || {}, e = t.selector || !1, e ? n("body").off("click.fb-start", e).on("click.fb-start", e, {
        options: t
      }, i) : this.off("click.fb-start").on("click.fb-start", {
        items: this,
        options: t
      }, i), this;
    }, r.on("click.fb-start", "[data-fancybox]", i), r.on("click.fb-start", "[data-fancybox-trigger]", function (t) {
      n('[data-fancybox="' + n(this).attr("data-fancybox-trigger") + '"]').eq(n(this).attr("data-fancybox-index") || 0).trigger("click.fb-start", {
        $trigger: n(this)
      });
    }), function () {
      var t = null;
      r.on("mousedown mouseup focus blur", ".fancybox-button", function (e) {
        switch (e.type) {
          case "mousedown":
            t = n(this);
            break;

          case "mouseup":
            t = null;
            break;

          case "focusin":
            n(".fancybox-button").removeClass("fancybox-focus"), n(this).is(t) || n(this).is("[disabled]") || n(this).addClass("fancybox-focus");
            break;

          case "focusout":
            n(".fancybox-button").removeClass("fancybox-focus");
        }
      });
    }();
  }
}(window, document, jQuery), function (t) {
  "use strict";

  var e = {
    youtube: {
      matcher: /(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(watch\?(.*&)?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*))(.*)/i,
      params: {
        autoplay: 1,
        autohide: 1,
        fs: 1,
        rel: 0,
        hd: 1,
        wmode: "transparent",
        enablejsapi: 1,
        html5: 1
      },
      paramPlace: 8,
      type: "iframe",
      url: "https://www.youtube-nocookie.com/embed/$4",
      thumb: "https://img.youtube.com/vi/$4/hqdefault.jpg"
    },
    vimeo: {
      matcher: /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/,
      params: {
        autoplay: 1,
        hd: 1,
        show_title: 1,
        show_byline: 1,
        show_portrait: 0,
        fullscreen: 1
      },
      paramPlace: 3,
      type: "iframe",
      url: "//player.vimeo.com/video/$2"
    },
    instagram: {
      matcher: /(instagr\.am|instagram\.com)\/p\/([a-zA-Z0-9_\-]+)\/?/i,
      type: "image",
      url: "//$1/p/$2/media/?size=l"
    },
    gmap_place: {
      matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(((maps\/(place\/(.*)\/)?\@(.*),(\d+.?\d+?)z))|(\?ll=))(.*)?/i,
      type: "iframe",
      url: function url(t) {
        return "//maps.google." + t[2] + "/?ll=" + (t[9] ? t[9] + "&z=" + Math.floor(t[10]) + (t[12] ? t[12].replace(/^\//, "&") : "") : t[12] + "").replace(/\?/, "&") + "&output=" + (t[12] && t[12].indexOf("layer=c") > 0 ? "svembed" : "embed");
      }
    },
    gmap_search: {
      matcher: /(maps\.)?google\.([a-z]{2,3}(\.[a-z]{2})?)\/(maps\/search\/)(.*)/i,
      type: "iframe",
      url: function url(t) {
        return "//maps.google." + t[2] + "/maps?q=" + t[5].replace("query=", "q=").replace("api=1", "") + "&output=embed";
      }
    }
  },
      n = function n(e, _n2, o) {
    if (e) return o = o || "", "object" === t.type(o) && (o = t.param(o, !0)), t.each(_n2, function (t, n) {
      e = e.replace("$" + t, n || "");
    }), o.length && (e += (e.indexOf("?") > 0 ? "&" : "?") + o), e;
  };

  t(document).on("objectNeedsType.fb", function (o, i, a) {
    var s,
        r,
        c,
        l,
        d,
        u,
        f,
        p = a.src || "",
        h = !1;
    s = t.extend(!0, {}, e, a.opts.media), t.each(s, function (e, o) {
      if (c = p.match(o.matcher)) {
        if (h = o.type, f = e, u = {}, o.paramPlace && c[o.paramPlace]) {
          d = c[o.paramPlace], "?" == d[0] && (d = d.substring(1)), d = d.split("&");

          for (var i = 0; i < d.length; ++i) {
            var s = d[i].split("=", 2);
            2 == s.length && (u[s[0]] = decodeURIComponent(s[1].replace(/\+/g, " ")));
          }
        }

        return l = t.extend(!0, {}, o.params, a.opts[e], u), p = "function" === t.type(o.url) ? o.url.call(this, c, l, a) : n(o.url, c, l), r = "function" === t.type(o.thumb) ? o.thumb.call(this, c, l, a) : n(o.thumb, c), "youtube" === e ? p = p.replace(/&t=((\d+)m)?(\d+)s/, function (t, e, n, o) {
          return "&start=" + ((n ? 60 * parseInt(n, 10) : 0) + parseInt(o, 10));
        }) : "vimeo" === e && (p = p.replace("&%23", "#")), !1;
      }
    }), h ? (a.opts.thumb || a.opts.$thumb && a.opts.$thumb.length || (a.opts.thumb = r), "iframe" === h && (a.opts = t.extend(!0, a.opts, {
      iframe: {
        preload: !1,
        attr: {
          scrolling: "no"
        }
      }
    })), t.extend(a, {
      type: h,
      src: p,
      origSrc: a.src,
      contentSource: f,
      contentType: "image" === h ? "image" : "gmap_place" == f || "gmap_search" == f ? "map" : "video"
    })) : p && (a.type = a.opts.defaultType);
  });
  var o = {
    youtube: {
      src: "https://www.youtube.com/iframe_api",
      class: "YT",
      loading: !1,
      loaded: !1
    },
    vimeo: {
      src: "https://player.vimeo.com/api/player.js",
      class: "Vimeo",
      loading: !1,
      loaded: !1
    },
    load: function load(t) {
      var e,
          n = this;
      if (this[t].loaded) return void setTimeout(function () {
        n.done(t);
      });
      this[t].loading || (this[t].loading = !0, e = document.createElement("script"), e.type = "text/javascript", e.src = this[t].src, "youtube" === t ? window.onYouTubeIframeAPIReady = function () {
        n[t].loaded = !0, n.done(t);
      } : e.onload = function () {
        n[t].loaded = !0, n.done(t);
      }, document.body.appendChild(e));
    },
    done: function done(e) {
      var n, o, i;
      "youtube" === e && delete window.onYouTubeIframeAPIReady, (n = t.fancybox.getInstance()) && (o = n.current.$content.find("iframe"), "youtube" === e && void 0 !== YT && YT ? i = new YT.Player(o.attr("id"), {
        events: {
          onStateChange: function onStateChange(t) {
            0 == t.data && n.next();
          }
        }
      }) : "vimeo" === e && void 0 !== Vimeo && Vimeo && (i = new Vimeo.Player(o), i.on("ended", function () {
        n.next();
      })));
    }
  };
  t(document).on({
    "afterShow.fb": function afterShowFb(t, e, n) {
      e.group.length > 1 && ("youtube" === n.contentSource || "vimeo" === n.contentSource) && o.load(n.contentSource);
    }
  });
}(jQuery), function (t, e, n) {
  "use strict";

  var o = function () {
    return t.requestAnimationFrame || t.webkitRequestAnimationFrame || t.mozRequestAnimationFrame || t.oRequestAnimationFrame || function (e) {
      return t.setTimeout(e, 1e3 / 60);
    };
  }(),
      i = function () {
    return t.cancelAnimationFrame || t.webkitCancelAnimationFrame || t.mozCancelAnimationFrame || t.oCancelAnimationFrame || function (e) {
      t.clearTimeout(e);
    };
  }(),
      a = function a(e) {
    var n = [];
    e = e.originalEvent || e || t.e, e = e.touches && e.touches.length ? e.touches : e.changedTouches && e.changedTouches.length ? e.changedTouches : [e];

    for (var o in e) {
      e[o].pageX ? n.push({
        x: e[o].pageX,
        y: e[o].pageY
      }) : e[o].clientX && n.push({
        x: e[o].clientX,
        y: e[o].clientY
      });
    }

    return n;
  },
      s = function s(t, e, n) {
    return e && t ? "x" === n ? t.x - e.x : "y" === n ? t.y - e.y : Math.sqrt(Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)) : 0;
  },
      r = function r(t) {
    if (t.is('a,area,button,[role="button"],input,label,select,summary,textarea,video,audio,iframe') || n.isFunction(t.get(0).onclick) || t.data("selectable")) return !0;

    for (var e = 0, o = t[0].attributes, i = o.length; e < i; e++) {
      if ("data-fancybox-" === o[e].nodeName.substr(0, 14)) return !0;
    }

    return !1;
  },
      c = function c(e) {
    var n = t.getComputedStyle(e)["overflow-y"],
        o = t.getComputedStyle(e)["overflow-x"],
        i = ("scroll" === n || "auto" === n) && e.scrollHeight > e.clientHeight,
        a = ("scroll" === o || "auto" === o) && e.scrollWidth > e.clientWidth;
    return i || a;
  },
      l = function l(t) {
    for (var e = !1;;) {
      if (e = c(t.get(0))) break;
      if (t = t.parent(), !t.length || t.hasClass("fancybox-stage") || t.is("body")) break;
    }

    return e;
  },
      d = function d(t) {
    var e = this;
    e.instance = t, e.$bg = t.$refs.bg, e.$stage = t.$refs.stage, e.$container = t.$refs.container, e.destroy(), e.$container.on("touchstart.fb.touch mousedown.fb.touch", n.proxy(e, "ontouchstart"));
  };

  d.prototype.destroy = function () {
    var t = this;
    t.$container.off(".fb.touch"), n(e).off(".fb.touch"), t.requestId && (i(t.requestId), t.requestId = null), t.tapped && (clearTimeout(t.tapped), t.tapped = null);
  }, d.prototype.ontouchstart = function (o) {
    var i = this,
        c = n(o.target),
        d = i.instance,
        u = d.current,
        f = u.$slide,
        p = u.$content,
        h = "touchstart" == o.type;

    if (h && i.$container.off("mousedown.fb.touch"), (!o.originalEvent || 2 != o.originalEvent.button) && f.length && c.length && !r(c) && !r(c.parent()) && (c.is("img") || !(o.originalEvent.clientX > c[0].clientWidth + c.offset().left))) {
      if (!u || d.isAnimating || u.$slide.hasClass("fancybox-animated")) return o.stopPropagation(), void o.preventDefault();
      i.realPoints = i.startPoints = a(o), i.startPoints.length && (u.touch && o.stopPropagation(), i.startEvent = o, i.canTap = !0, i.$target = c, i.$content = p, i.opts = u.opts.touch, i.isPanning = !1, i.isSwiping = !1, i.isZooming = !1, i.isScrolling = !1, i.canPan = d.canPan(), i.startTime = new Date().getTime(), i.distanceX = i.distanceY = i.distance = 0, i.canvasWidth = Math.round(f[0].clientWidth), i.canvasHeight = Math.round(f[0].clientHeight), i.contentLastPos = null, i.contentStartPos = n.fancybox.getTranslate(i.$content) || {
        top: 0,
        left: 0
      }, i.sliderStartPos = n.fancybox.getTranslate(f), i.stagePos = n.fancybox.getTranslate(d.$refs.stage), i.sliderStartPos.top -= i.stagePos.top, i.sliderStartPos.left -= i.stagePos.left, i.contentStartPos.top -= i.stagePos.top, i.contentStartPos.left -= i.stagePos.left, n(e).off(".fb.touch").on(h ? "touchend.fb.touch touchcancel.fb.touch" : "mouseup.fb.touch mouseleave.fb.touch", n.proxy(i, "ontouchend")).on(h ? "touchmove.fb.touch" : "mousemove.fb.touch", n.proxy(i, "ontouchmove")), n.fancybox.isMobile && e.addEventListener("scroll", i.onscroll, !0), ((i.opts || i.canPan) && (c.is(i.$stage) || i.$stage.find(c).length) || (c.is(".fancybox-image") && o.preventDefault(), n.fancybox.isMobile && c.parents(".fancybox-caption").length)) && (i.isScrollable = l(c) || l(c.parent()), n.fancybox.isMobile && i.isScrollable || o.preventDefault(), (1 === i.startPoints.length || u.hasError) && (i.canPan ? (n.fancybox.stop(i.$content), i.isPanning = !0) : i.isSwiping = !0, i.$container.addClass("fancybox-is-grabbing")), 2 === i.startPoints.length && "image" === u.type && (u.isLoaded || u.$ghost) && (i.canTap = !1, i.isSwiping = !1, i.isPanning = !1, i.isZooming = !0, n.fancybox.stop(i.$content), i.centerPointStartX = .5 * (i.startPoints[0].x + i.startPoints[1].x) - n(t).scrollLeft(), i.centerPointStartY = .5 * (i.startPoints[0].y + i.startPoints[1].y) - n(t).scrollTop(), i.percentageOfImageAtPinchPointX = (i.centerPointStartX - i.contentStartPos.left) / i.contentStartPos.width, i.percentageOfImageAtPinchPointY = (i.centerPointStartY - i.contentStartPos.top) / i.contentStartPos.height, i.startDistanceBetweenFingers = s(i.startPoints[0], i.startPoints[1]))));
    }
  }, d.prototype.onscroll = function (t) {
    var n = this;
    n.isScrolling = !0, e.removeEventListener("scroll", n.onscroll, !0);
  }, d.prototype.ontouchmove = function (t) {
    var e = this;
    return void 0 !== t.originalEvent.buttons && 0 === t.originalEvent.buttons ? void e.ontouchend(t) : e.isScrolling ? void (e.canTap = !1) : (e.newPoints = a(t), void ((e.opts || e.canPan) && e.newPoints.length && e.newPoints.length && (e.isSwiping && !0 === e.isSwiping || t.preventDefault(), e.distanceX = s(e.newPoints[0], e.startPoints[0], "x"), e.distanceY = s(e.newPoints[0], e.startPoints[0], "y"), e.distance = s(e.newPoints[0], e.startPoints[0]), e.distance > 0 && (e.isSwiping ? e.onSwipe(t) : e.isPanning ? e.onPan() : e.isZooming && e.onZoom()))));
  }, d.prototype.onSwipe = function (e) {
    var a,
        s = this,
        r = s.instance,
        c = s.isSwiping,
        l = s.sliderStartPos.left || 0;
    if (!0 !== c) "x" == c && (s.distanceX > 0 && (s.instance.group.length < 2 || 0 === s.instance.current.index && !s.instance.current.opts.loop) ? l += Math.pow(s.distanceX, .8) : s.distanceX < 0 && (s.instance.group.length < 2 || s.instance.current.index === s.instance.group.length - 1 && !s.instance.current.opts.loop) ? l -= Math.pow(-s.distanceX, .8) : l += s.distanceX), s.sliderLastPos = {
      top: "x" == c ? 0 : s.sliderStartPos.top + s.distanceY,
      left: l
    }, s.requestId && (i(s.requestId), s.requestId = null), s.requestId = o(function () {
      s.sliderLastPos && (n.each(s.instance.slides, function (t, e) {
        var o = e.pos - s.instance.currPos;
        n.fancybox.setTranslate(e.$slide, {
          top: s.sliderLastPos.top,
          left: s.sliderLastPos.left + o * s.canvasWidth + o * e.opts.gutter
        });
      }), s.$container.addClass("fancybox-is-sliding"));
    });else if (Math.abs(s.distance) > 10) {
      if (s.canTap = !1, r.group.length < 2 && s.opts.vertical ? s.isSwiping = "y" : r.isDragging || !1 === s.opts.vertical || "auto" === s.opts.vertical && n(t).width() > 800 ? s.isSwiping = "x" : (a = Math.abs(180 * Math.atan2(s.distanceY, s.distanceX) / Math.PI), s.isSwiping = a > 45 && a < 135 ? "y" : "x"), "y" === s.isSwiping && n.fancybox.isMobile && s.isScrollable) return void (s.isScrolling = !0);
      r.isDragging = s.isSwiping, s.startPoints = s.newPoints, n.each(r.slides, function (t, e) {
        var o, i;
        n.fancybox.stop(e.$slide), o = n.fancybox.getTranslate(e.$slide), i = n.fancybox.getTranslate(r.$refs.stage), e.$slide.css({
          transform: "",
          opacity: "",
          "transition-duration": ""
        }).removeClass("fancybox-animated").removeClass(function (t, e) {
          return (e.match(/(^|\s)fancybox-fx-\S+/g) || []).join(" ");
        }), e.pos === r.current.pos && (s.sliderStartPos.top = o.top - i.top, s.sliderStartPos.left = o.left - i.left), n.fancybox.setTranslate(e.$slide, {
          top: o.top - i.top,
          left: o.left - i.left
        });
      }), r.SlideShow && r.SlideShow.isActive && r.SlideShow.stop();
    }
  }, d.prototype.onPan = function () {
    var t = this;
    if (s(t.newPoints[0], t.realPoints[0]) < (n.fancybox.isMobile ? 10 : 5)) return void (t.startPoints = t.newPoints);
    t.canTap = !1, t.contentLastPos = t.limitMovement(), t.requestId && i(t.requestId), t.requestId = o(function () {
      n.fancybox.setTranslate(t.$content, t.contentLastPos);
    });
  }, d.prototype.limitMovement = function () {
    var t,
        e,
        n,
        o,
        i,
        a,
        s = this,
        r = s.canvasWidth,
        c = s.canvasHeight,
        l = s.distanceX,
        d = s.distanceY,
        u = s.contentStartPos,
        f = u.left,
        p = u.top,
        h = u.width,
        g = u.height;
    return i = h > r ? f + l : f, a = p + d, t = Math.max(0, .5 * r - .5 * h), e = Math.max(0, .5 * c - .5 * g), n = Math.min(r - h, .5 * r - .5 * h), o = Math.min(c - g, .5 * c - .5 * g), l > 0 && i > t && (i = t - 1 + Math.pow(-t + f + l, .8) || 0), l < 0 && i < n && (i = n + 1 - Math.pow(n - f - l, .8) || 0), d > 0 && a > e && (a = e - 1 + Math.pow(-e + p + d, .8) || 0), d < 0 && a < o && (a = o + 1 - Math.pow(o - p - d, .8) || 0), {
      top: a,
      left: i
    };
  }, d.prototype.limitPosition = function (t, e, n, o) {
    var i = this,
        a = i.canvasWidth,
        s = i.canvasHeight;
    return n > a ? (t = t > 0 ? 0 : t, t = t < a - n ? a - n : t) : t = Math.max(0, a / 2 - n / 2), o > s ? (e = e > 0 ? 0 : e, e = e < s - o ? s - o : e) : e = Math.max(0, s / 2 - o / 2), {
      top: e,
      left: t
    };
  }, d.prototype.onZoom = function () {
    var e = this,
        a = e.contentStartPos,
        r = a.width,
        c = a.height,
        l = a.left,
        d = a.top,
        u = s(e.newPoints[0], e.newPoints[1]),
        f = u / e.startDistanceBetweenFingers,
        p = Math.floor(r * f),
        h = Math.floor(c * f),
        g = (r - p) * e.percentageOfImageAtPinchPointX,
        b = (c - h) * e.percentageOfImageAtPinchPointY,
        m = (e.newPoints[0].x + e.newPoints[1].x) / 2 - n(t).scrollLeft(),
        v = (e.newPoints[0].y + e.newPoints[1].y) / 2 - n(t).scrollTop(),
        y = m - e.centerPointStartX,
        x = v - e.centerPointStartY,
        w = l + (g + y),
        $ = d + (b + x),
        S = {
      top: $,
      left: w,
      scaleX: f,
      scaleY: f
    };
    e.canTap = !1, e.newWidth = p, e.newHeight = h, e.contentLastPos = S, e.requestId && i(e.requestId), e.requestId = o(function () {
      n.fancybox.setTranslate(e.$content, e.contentLastPos);
    });
  }, d.prototype.ontouchend = function (t) {
    var o = this,
        s = o.isSwiping,
        r = o.isPanning,
        c = o.isZooming,
        l = o.isScrolling;
    if (o.endPoints = a(t), o.dMs = Math.max(new Date().getTime() - o.startTime, 1), o.$container.removeClass("fancybox-is-grabbing"), n(e).off(".fb.touch"), e.removeEventListener("scroll", o.onscroll, !0), o.requestId && (i(o.requestId), o.requestId = null), o.isSwiping = !1, o.isPanning = !1, o.isZooming = !1, o.isScrolling = !1, o.instance.isDragging = !1, o.canTap) return o.onTap(t);
    o.speed = 100, o.velocityX = o.distanceX / o.dMs * .5, o.velocityY = o.distanceY / o.dMs * .5, r ? o.endPanning() : c ? o.endZooming() : o.endSwiping(s, l);
  }, d.prototype.endSwiping = function (t, e) {
    var o = this,
        i = !1,
        a = o.instance.group.length,
        s = Math.abs(o.distanceX),
        r = "x" == t && a > 1 && (o.dMs > 130 && s > 10 || s > 50);
    o.sliderLastPos = null, "y" == t && !e && Math.abs(o.distanceY) > 50 ? (n.fancybox.animate(o.instance.current.$slide, {
      top: o.sliderStartPos.top + o.distanceY + 150 * o.velocityY,
      opacity: 0
    }, 200), i = o.instance.close(!0, 250)) : r && o.distanceX > 0 ? i = o.instance.previous(300) : r && o.distanceX < 0 && (i = o.instance.next(300)), !1 !== i || "x" != t && "y" != t || o.instance.centerSlide(200), o.$container.removeClass("fancybox-is-sliding");
  }, d.prototype.endPanning = function () {
    var t,
        e,
        o,
        i = this;
    i.contentLastPos && (!1 === i.opts.momentum || i.dMs > 350 ? (t = i.contentLastPos.left, e = i.contentLastPos.top) : (t = i.contentLastPos.left + 500 * i.velocityX, e = i.contentLastPos.top + 500 * i.velocityY), o = i.limitPosition(t, e, i.contentStartPos.width, i.contentStartPos.height), o.width = i.contentStartPos.width, o.height = i.contentStartPos.height, n.fancybox.animate(i.$content, o, 366));
  }, d.prototype.endZooming = function () {
    var t,
        e,
        o,
        i,
        a = this,
        s = a.instance.current,
        r = a.newWidth,
        c = a.newHeight;
    a.contentLastPos && (t = a.contentLastPos.left, e = a.contentLastPos.top, i = {
      top: e,
      left: t,
      width: r,
      height: c,
      scaleX: 1,
      scaleY: 1
    }, n.fancybox.setTranslate(a.$content, i), r < a.canvasWidth && c < a.canvasHeight ? a.instance.scaleToFit(150) : r > s.width || c > s.height ? a.instance.scaleToActual(a.centerPointStartX, a.centerPointStartY, 150) : (o = a.limitPosition(t, e, r, c), n.fancybox.animate(a.$content, o, 150)));
  }, d.prototype.onTap = function (e) {
    var o,
        i = this,
        s = n(e.target),
        r = i.instance,
        c = r.current,
        l = e && a(e) || i.startPoints,
        d = l[0] ? l[0].x - n(t).scrollLeft() - i.stagePos.left : 0,
        u = l[0] ? l[0].y - n(t).scrollTop() - i.stagePos.top : 0,
        f = function f(t) {
      var o = c.opts[t];
      if (n.isFunction(o) && (o = o.apply(r, [c, e])), o) switch (o) {
        case "close":
          r.close(i.startEvent);
          break;

        case "toggleControls":
          r.toggleControls();
          break;

        case "next":
          r.next();
          break;

        case "nextOrClose":
          r.group.length > 1 ? r.next() : r.close(i.startEvent);
          break;

        case "zoom":
          "image" == c.type && (c.isLoaded || c.$ghost) && (r.canPan() ? r.scaleToFit() : r.isScaledDown() ? r.scaleToActual(d, u) : r.group.length < 2 && r.close(i.startEvent));
      }
    };

    if ((!e.originalEvent || 2 != e.originalEvent.button) && (s.is("img") || !(d > s[0].clientWidth + s.offset().left))) {
      if (s.is(".fancybox-bg,.fancybox-inner,.fancybox-outer,.fancybox-container")) o = "Outside";else if (s.is(".fancybox-slide")) o = "Slide";else {
        if (!r.current.$content || !r.current.$content.find(s).addBack().filter(s).length) return;
        o = "Content";
      }

      if (i.tapped) {
        if (clearTimeout(i.tapped), i.tapped = null, Math.abs(d - i.tapX) > 50 || Math.abs(u - i.tapY) > 50) return this;
        f("dblclick" + o);
      } else i.tapX = d, i.tapY = u, c.opts["dblclick" + o] && c.opts["dblclick" + o] !== c.opts["click" + o] ? i.tapped = setTimeout(function () {
        i.tapped = null, r.isAnimating || f("click" + o);
      }, 500) : f("click" + o);

      return this;
    }
  }, n(e).on("onActivate.fb", function (t, e) {
    e && !e.Guestures && (e.Guestures = new d(e));
  }).on("beforeClose.fb", function (t, e) {
    e && e.Guestures && e.Guestures.destroy();
  });
}(window, document, jQuery), function (t, e) {
  "use strict";

  e.extend(!0, e.fancybox.defaults, {
    btnTpl: {
      slideShow: '<button data-fancybox-play class="fancybox-button fancybox-button--play" title="{{PLAY_START}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M6.5 5.4v13.2l11-6.6z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M8.33 5.75h2.2v12.5h-2.2V5.75zm5.15 0h2.2v12.5h-2.2V5.75z"/></svg></button>'
    },
    slideShow: {
      autoStart: !1,
      speed: 3e3,
      progress: !0
    }
  });

  var n = function n(t) {
    this.instance = t, this.init();
  };

  e.extend(n.prototype, {
    timer: null,
    isActive: !1,
    $button: null,
    init: function init() {
      var t = this,
          n = t.instance,
          o = n.group[n.currIndex].opts.slideShow;
      t.$button = n.$refs.toolbar.find("[data-fancybox-play]").on("click", function () {
        t.toggle();
      }), n.group.length < 2 || !o ? t.$button.hide() : o.progress && (t.$progress = e('<div class="fancybox-progress"></div>').appendTo(n.$refs.inner));
    },
    set: function set(t) {
      var n = this,
          o = n.instance,
          i = o.current;
      i && (!0 === t || i.opts.loop || o.currIndex < o.group.length - 1) ? n.isActive && "video" !== i.contentType && (n.$progress && e.fancybox.animate(n.$progress.show(), {
        scaleX: 1
      }, i.opts.slideShow.speed), n.timer = setTimeout(function () {
        o.current.opts.loop || o.current.index != o.group.length - 1 ? o.next() : o.jumpTo(0);
      }, i.opts.slideShow.speed)) : (n.stop(), o.idleSecondsCounter = 0, o.showControls());
    },
    clear: function clear() {
      var t = this;
      clearTimeout(t.timer), t.timer = null, t.$progress && t.$progress.removeAttr("style").hide();
    },
    start: function start() {
      var t = this,
          e = t.instance.current;
      e && (t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_STOP).removeClass("fancybox-button--play").addClass("fancybox-button--pause"), t.isActive = !0, e.isComplete && t.set(!0), t.instance.trigger("onSlideShowChange", !0));
    },
    stop: function stop() {
      var t = this,
          e = t.instance.current;
      t.clear(), t.$button.attr("title", (e.opts.i18n[e.opts.lang] || e.opts.i18n.en).PLAY_START).removeClass("fancybox-button--pause").addClass("fancybox-button--play"), t.isActive = !1, t.instance.trigger("onSlideShowChange", !1), t.$progress && t.$progress.removeAttr("style").hide();
    },
    toggle: function toggle() {
      var t = this;
      t.isActive ? t.stop() : t.start();
    }
  }), e(t).on({
    "onInit.fb": function onInitFb(t, e) {
      e && !e.SlideShow && (e.SlideShow = new n(e));
    },
    "beforeShow.fb": function beforeShowFb(t, e, n, o) {
      var i = e && e.SlideShow;
      o ? i && n.opts.slideShow.autoStart && i.start() : i && i.isActive && i.clear();
    },
    "afterShow.fb": function afterShowFb(t, e, n) {
      var o = e && e.SlideShow;
      o && o.isActive && o.set();
    },
    "afterKeydown.fb": function afterKeydownFb(n, o, i, a, s) {
      var r = o && o.SlideShow;
      !r || !i.opts.slideShow || 80 !== s && 32 !== s || e(t.activeElement).is("button,a,input") || (a.preventDefault(), r.toggle());
    },
    "beforeClose.fb onDeactivate.fb": function beforeCloseFbOnDeactivateFb(t, e) {
      var n = e && e.SlideShow;
      n && n.stop();
    }
  }), e(t).on("visibilitychange", function () {
    var n = e.fancybox.getInstance(),
        o = n && n.SlideShow;
    o && o.isActive && (t.hidden ? o.clear() : o.set());
  });
}(document, jQuery), function (t, e) {
  "use strict";

  var n = function () {
    for (var e = [["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"], ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"], ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"], ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"], ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]], n = {}, o = 0; o < e.length; o++) {
      var i = e[o];

      if (i && i[1] in t) {
        for (var a = 0; a < i.length; a++) {
          n[e[0][a]] = i[a];
        }

        return n;
      }
    }

    return !1;
  }();

  if (n) {
    var o = {
      request: function request(e) {
        e = e || t.documentElement, e[n.requestFullscreen](e.ALLOW_KEYBOARD_INPUT);
      },
      exit: function exit() {
        t[n.exitFullscreen]();
      },
      toggle: function toggle(e) {
        e = e || t.documentElement, this.isFullscreen() ? this.exit() : this.request(e);
      },
      isFullscreen: function isFullscreen() {
        return Boolean(t[n.fullscreenElement]);
      },
      enabled: function enabled() {
        return Boolean(t[n.fullscreenEnabled]);
      }
    };
    e.extend(!0, e.fancybox.defaults, {
      btnTpl: {
        fullScreen: '<button data-fancybox-fullscreen class="fancybox-button fancybox-button--fsenter" title="{{FULL_SCREEN}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"/></svg><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5 16h3v3h2v-5H5zm3-8H5v2h5V5H8zm6 11h2v-3h3v-2h-5zm2-11V5h-2v5h5V8z"/></svg></button>'
      },
      fullScreen: {
        autoStart: !1
      }
    }), e(t).on(n.fullscreenchange, function () {
      var t = o.isFullscreen(),
          n = e.fancybox.getInstance();
      n && (n.current && "image" === n.current.type && n.isAnimating && (n.isAnimating = !1, n.update(!0, !0, 0), n.isComplete || n.complete()), n.trigger("onFullscreenChange", t), n.$refs.container.toggleClass("fancybox-is-fullscreen", t), n.$refs.toolbar.find("[data-fancybox-fullscreen]").toggleClass("fancybox-button--fsenter", !t).toggleClass("fancybox-button--fsexit", t));
    });
  }

  e(t).on({
    "onInit.fb": function onInitFb(t, e) {
      var i;
      if (!n) return void e.$refs.toolbar.find("[data-fancybox-fullscreen]").remove();
      e && e.group[e.currIndex].opts.fullScreen ? (i = e.$refs.container, i.on("click.fb-fullscreen", "[data-fancybox-fullscreen]", function (t) {
        t.stopPropagation(), t.preventDefault(), o.toggle();
      }), e.opts.fullScreen && !0 === e.opts.fullScreen.autoStart && o.request(), e.FullScreen = o) : e && e.$refs.toolbar.find("[data-fancybox-fullscreen]").hide();
    },
    "afterKeydown.fb": function afterKeydownFb(t, e, n, o, i) {
      e && e.FullScreen && 70 === i && (o.preventDefault(), e.FullScreen.toggle());
    },
    "beforeClose.fb": function beforeCloseFb(t, e) {
      e && e.FullScreen && e.$refs.container.hasClass("fancybox-is-fullscreen") && o.exit();
    }
  });
}(document, jQuery), function (t, e) {
  "use strict";

  var n = "fancybox-thumbs";
  e.fancybox.defaults = e.extend(!0, {
    btnTpl: {
      thumbs: '<button data-fancybox-thumbs class="fancybox-button fancybox-button--thumbs" title="{{THUMBS}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M14.59 14.59h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76h-3.76v-3.76zm-4.47 0h3.76v3.76H5.65v-3.76zm8.94-4.47h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76h-3.76V5.65zm-4.47 0h3.76v3.76H5.65V5.65z"/></svg></button>'
    },
    thumbs: {
      autoStart: !1,
      hideOnClose: !0,
      parentEl: ".fancybox-container",
      axis: "y"
    }
  }, e.fancybox.defaults);

  var o = function o(t) {
    this.init(t);
  };

  e.extend(o.prototype, {
    $button: null,
    $grid: null,
    $list: null,
    isVisible: !1,
    isActive: !1,
    init: function init(t) {
      var e = this,
          n = t.group,
          o = 0;
      e.instance = t, e.opts = n[t.currIndex].opts.thumbs, t.Thumbs = e, e.$button = t.$refs.toolbar.find("[data-fancybox-thumbs]");

      for (var i = 0, a = n.length; i < a && (n[i].thumb && o++, !(o > 1)); i++) {
        ;
      }

      o > 1 && e.opts ? (e.$button.removeAttr("style").on("click", function () {
        e.toggle();
      }), e.isActive = !0) : e.$button.hide();
    },
    create: function create() {
      var t,
          o = this,
          i = o.instance,
          a = o.opts.parentEl,
          s = [];
      o.$grid || (o.$grid = e('<div class="' + n + " " + n + "-" + o.opts.axis + '"></div>').appendTo(i.$refs.container.find(a).addBack().filter(a)), o.$grid.on("click", "a", function () {
        i.jumpTo(e(this).attr("data-index"));
      })), o.$list || (o.$list = e('<div class="' + n + '__list">').appendTo(o.$grid)), e.each(i.group, function (e, n) {
        t = n.thumb, t || "image" !== n.type || (t = n.src), s.push('<a href="javascript:;" tabindex="0" data-index="' + e + '"' + (t && t.length ? ' style="background-image:url(' + t + ')"' : 'class="fancybox-thumbs-missing"') + "></a>");
      }), o.$list[0].innerHTML = s.join(""), "x" === o.opts.axis && o.$list.width(parseInt(o.$grid.css("padding-right"), 10) + i.group.length * o.$list.children().eq(0).outerWidth(!0));
    },
    focus: function focus(t) {
      var e,
          n,
          o = this,
          i = o.$list,
          a = o.$grid;
      o.instance.current && (e = i.children().removeClass("fancybox-thumbs-active").filter('[data-index="' + o.instance.current.index + '"]').addClass("fancybox-thumbs-active"), n = e.position(), "y" === o.opts.axis && (n.top < 0 || n.top > i.height() - e.outerHeight()) ? i.stop().animate({
        scrollTop: i.scrollTop() + n.top
      }, t) : "x" === o.opts.axis && (n.left < a.scrollLeft() || n.left > a.scrollLeft() + (a.width() - e.outerWidth())) && i.parent().stop().animate({
        scrollLeft: n.left
      }, t));
    },
    update: function update() {
      var t = this;
      t.instance.$refs.container.toggleClass("fancybox-show-thumbs", this.isVisible), t.isVisible ? (t.$grid || t.create(), t.instance.trigger("onThumbsShow"), t.focus(0)) : t.$grid && t.instance.trigger("onThumbsHide"), t.instance.update();
    },
    hide: function hide() {
      this.isVisible = !1, this.update();
    },
    show: function show() {
      this.isVisible = !0, this.update();
    },
    toggle: function toggle() {
      this.isVisible = !this.isVisible, this.update();
    }
  }), e(t).on({
    "onInit.fb": function onInitFb(t, e) {
      var n;
      e && !e.Thumbs && (n = new o(e), n.isActive && !0 === n.opts.autoStart && n.show());
    },
    "beforeShow.fb": function beforeShowFb(t, e, n, o) {
      var i = e && e.Thumbs;
      i && i.isVisible && i.focus(o ? 0 : 250);
    },
    "afterKeydown.fb": function afterKeydownFb(t, e, n, o, i) {
      var a = e && e.Thumbs;
      a && a.isActive && 71 === i && (o.preventDefault(), a.toggle());
    },
    "beforeClose.fb": function beforeCloseFb(t, e) {
      var n = e && e.Thumbs;
      n && n.isVisible && !1 !== n.opts.hideOnClose && n.$grid.hide();
    }
  });
}(document, jQuery), function (t, e) {
  "use strict";

  function n(t) {
    var e = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
      "/": "&#x2F;",
      "`": "&#x60;",
      "=": "&#x3D;"
    };
    return String(t).replace(/[&<>"'`=\/]/g, function (t) {
      return e[t];
    });
  }

  e.extend(!0, e.fancybox.defaults, {
    btnTpl: {
      share: '<button data-fancybox-share class="fancybox-button fancybox-button--share" title="{{SHARE}}"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.55 19c1.4-8.4 9.1-9.8 11.9-9.8V5l7 7-7 6.3v-3.5c-2.8 0-10.5 2.1-11.9 4.2z"/></svg></button>'
    },
    share: {
      url: function url(t, e) {
        return !t.currentHash && "inline" !== e.type && "html" !== e.type && (e.origSrc || e.src) || window.location;
      },
      tpl: '<div class="fancybox-share"><h1>{{SHARE}}</h1><p><a class="fancybox-share__button fancybox-share__button--fb" href="https://www.facebook.com/sharer/sharer.php?u={{url}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m287 456v-299c0-21 6-35 35-35h38v-63c-7-1-29-3-55-3-54 0-91 33-91 94v306m143-254h-205v72h196" /></svg><span>Facebook</span></a><a class="fancybox-share__button fancybox-share__button--tw" href="https://twitter.com/intent/tweet?url={{url}}&text={{descr}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m456 133c-14 7-31 11-47 13 17-10 30-27 37-46-15 10-34 16-52 20-61-62-157-7-141 75-68-3-129-35-169-85-22 37-11 86 26 109-13 0-26-4-37-9 0 39 28 72 65 80-12 3-25 4-37 2 10 33 41 57 77 57-42 30-77 38-122 34 170 111 378-32 359-208 16-11 30-25 41-42z" /></svg><span>Twitter</span></a><a class="fancybox-share__button fancybox-share__button--pt" href="https://www.pinterest.com/pin/create/button/?url={{url}}&description={{descr}}&media={{media}}"><svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m265 56c-109 0-164 78-164 144 0 39 15 74 47 87 5 2 10 0 12-5l4-19c2-6 1-8-3-13-9-11-15-25-15-45 0-58 43-110 113-110 62 0 96 38 96 88 0 67-30 122-73 122-24 0-42-19-36-44 6-29 20-60 20-81 0-19-10-35-31-35-25 0-44 26-44 60 0 21 7 36 7 36l-30 125c-8 37-1 83 0 87 0 3 4 4 5 2 2-3 32-39 42-75l16-64c8 16 31 29 56 29 74 0 124-67 124-157 0-69-58-132-146-132z" fill="#fff"/></svg><span>Pinterest</span></a></p><p><input class="fancybox-share__input" type="text" value="{{url_raw}}" onclick="select()" /></p></div>'
    }
  }), e(t).on("click", "[data-fancybox-share]", function () {
    var t,
        o,
        i = e.fancybox.getInstance(),
        a = i.current || null;
    a && ("function" === e.type(a.opts.share.url) && (t = a.opts.share.url.apply(a, [i, a])), o = a.opts.share.tpl.replace(/\{\{media\}\}/g, "image" === a.type ? encodeURIComponent(a.src) : "").replace(/\{\{url\}\}/g, encodeURIComponent(t)).replace(/\{\{url_raw\}\}/g, n(t)).replace(/\{\{descr\}\}/g, i.$caption ? encodeURIComponent(i.$caption.text()) : ""), e.fancybox.open({
      src: i.translate(i, o),
      type: "html",
      opts: {
        touch: !1,
        animationEffect: !1,
        afterLoad: function afterLoad(t, e) {
          i.$refs.container.one("beforeClose.fb", function () {
            t.close(null, 0);
          }), e.$content.find(".fancybox-share__button").click(function () {
            return window.open(this.href, "Share", "width=550, height=450"), !1;
          });
        },
        mobile: {
          autoFocus: !1
        }
      }
    }));
  });
}(document, jQuery), function (t, e, n) {
  "use strict";

  function o() {
    var e = t.location.hash.substr(1),
        n = e.split("-"),
        o = n.length > 1 && /^\+?\d+$/.test(n[n.length - 1]) ? parseInt(n.pop(-1), 10) || 1 : 1,
        i = n.join("-");
    return {
      hash: e,
      index: o < 1 ? 1 : o,
      gallery: i
    };
  }

  function i(t) {
    "" !== t.gallery && n("[data-fancybox='" + n.escapeSelector(t.gallery) + "']").eq(t.index - 1).focus().trigger("click.fb-start");
  }

  function a(t) {
    var e, n;
    return !!t && (e = t.current ? t.current.opts : t.opts, "" !== (n = e.hash || (e.$orig ? e.$orig.data("fancybox") || e.$orig.data("fancybox-trigger") : "")) && n);
  }

  n.escapeSelector || (n.escapeSelector = function (t) {
    return (t + "").replace(/([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g, function (t, e) {
      return e ? "\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " " : "\\" + t;
    });
  }), n(function () {
    !1 !== n.fancybox.defaults.hash && (n(e).on({
      "onInit.fb": function onInitFb(t, e) {
        var n, i;
        !1 !== e.group[e.currIndex].opts.hash && (n = o(), (i = a(e)) && n.gallery && i == n.gallery && (e.currIndex = n.index - 1));
      },
      "beforeShow.fb": function beforeShowFb(n, o, i, s) {
        var r;
        i && !1 !== i.opts.hash && (r = a(o)) && (o.currentHash = r + (o.group.length > 1 ? "-" + (i.index + 1) : ""), t.location.hash !== "#" + o.currentHash && (s && !o.origHash && (o.origHash = t.location.hash), o.hashTimer && clearTimeout(o.hashTimer), o.hashTimer = setTimeout(function () {
          "replaceState" in t.history ? (t.history[s ? "pushState" : "replaceState"]({}, e.title, t.location.pathname + t.location.search + "#" + o.currentHash), s && (o.hasCreatedHistory = !0)) : t.location.hash = o.currentHash, o.hashTimer = null;
        }, 300)));
      },
      "beforeClose.fb": function beforeCloseFb(n, o, i) {
        i && !1 !== i.opts.hash && (clearTimeout(o.hashTimer), o.currentHash && o.hasCreatedHistory ? t.history.back() : o.currentHash && ("replaceState" in t.history ? t.history.replaceState({}, e.title, t.location.pathname + t.location.search + (o.origHash || "")) : t.location.hash = o.origHash), o.currentHash = null);
      }
    }), n(t).on("hashchange.fb", function () {
      var t = o(),
          e = null;
      n.each(n(".fancybox-container").get().reverse(), function (t, o) {
        var i = n(o).data("FancyBox");
        if (i && i.currentHash) return e = i, !1;
      }), e ? e.currentHash === t.gallery + "-" + t.index || 1 === t.index && e.currentHash == t.gallery || (e.currentHash = null, e.close()) : "" !== t.gallery && i(t);
    }), setTimeout(function () {
      n.fancybox.getInstance() || i(o());
    }, 50));
  });
}(window, document, jQuery), function (t, e) {
  "use strict";

  var n = new Date().getTime();
  e(t).on({
    "onInit.fb": function onInitFb(t, e, o) {
      e.$refs.stage.on("mousewheel DOMMouseScroll wheel MozMousePixelScroll", function (t) {
        var o = e.current,
            i = new Date().getTime();
        e.group.length < 2 || !1 === o.opts.wheel || "auto" === o.opts.wheel && "image" !== o.type || (t.preventDefault(), t.stopPropagation(), o.$slide.hasClass("fancybox-animated") || (t = t.originalEvent || t, i - n < 250 || (n = i, e[(-t.deltaY || -t.deltaX || t.wheelDelta || -t.detail) < 0 ? "next" : "previous"]())));
      });
    }
  });
}(document, jQuery);
/*! lazysizes - v4.1.5 */

!function (a, b) {
  var c = b(a, a.document);
  a.lazySizes = c, "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports && (module.exports = c);
}(window, function (a, b) {
  "use strict";

  if (b.getElementsByClassName) {
    var c,
        d,
        e = b.documentElement,
        f = a.Date,
        g = a.HTMLPictureElement,
        h = "addEventListener",
        i = "getAttribute",
        j = a[h],
        k = a.setTimeout,
        l = a.requestAnimationFrame || k,
        m = a.requestIdleCallback,
        n = /^picture$/i,
        o = ["load", "error", "lazyincluded", "_lazyloaded"],
        p = {},
        q = Array.prototype.forEach,
        r = function r(a, b) {
      return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b];
    },
        s = function s(a, b) {
      r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b);
    },
        t = function t(a, b) {
      var c;
      (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " "));
    },
        u = function u(a, b, c) {
      var d = c ? h : "removeEventListener";
      c && u(a, b), o.forEach(function (c) {
        a[d](c, b);
      });
    },
        v = function v(a, d, e, f, g) {
      var h = b.createEvent("Event");
      return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h;
    },
        w = function w(b, c) {
      var e;
      !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({
        reevaluate: !0,
        elements: [b]
      })) : c && c.src && (b.src = c.src);
    },
        x = function x(a, b) {
      return (getComputedStyle(a, null) || {})[b];
    },
        y = function y(a, b, c) {
      for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;) {
        c = b.offsetWidth, b = b.parentNode;
      }

      return c;
    },
        z = function () {
      var a,
          c,
          d = [],
          e = [],
          f = d,
          g = function g() {
        var b = f;

        for (f = d.length ? e : d, a = !0, c = !1; b.length;) {
          b.shift()();
        }

        a = !1;
      },
          h = function h(d, e) {
        a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g)));
      };

      return h._lsFlush = g, h;
    }(),
        A = function A(a, b) {
      return b ? function () {
        z(a);
      } : function () {
        var b = this,
            c = arguments;
        z(function () {
          a.apply(b, c);
        });
      };
    },
        B = function B(a) {
      var b,
          c = 0,
          e = d.throttleDelay,
          g = d.ricTimeout,
          h = function h() {
        b = !1, c = f.now(), a();
      },
          i = m && g > 49 ? function () {
        m(h, {
          timeout: g
        }), g !== d.ricTimeout && (g = d.ricTimeout);
      } : A(function () {
        k(h);
      }, !0);

      return function (a) {
        var d;
        (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d));
      };
    },
        C = function C(a) {
      var b,
          c,
          d = 99,
          e = function e() {
        b = null, a();
      },
          g = function g() {
        var a = f.now() - c;
        a < d ? k(g, d - a) : (m || e)(e);
      };

      return function () {
        c = f.now(), b || (b = k(g, d));
      };
    };

    !function () {
      var b,
          c = {
        lazyClass: "lazyload",
        loadedClass: "lazyloaded",
        loadingClass: "lazyloading",
        preloadClass: "lazypreload",
        errorClass: "lazyerror",
        autosizesClass: "lazyautosizes",
        srcAttr: "data-src",
        srcsetAttr: "data-srcset",
        sizesAttr: "data-sizes",
        minSize: 40,
        customMedia: {},
        init: !0,
        expFactor: 1.5,
        hFac: .8,
        loadMode: 2,
        loadHidden: !0,
        ricTimeout: 0,
        throttleDelay: 125
      };
      d = a.lazySizesConfig || a.lazysizesConfig || {};

      for (b in c) {
        b in d || (d[b] = c[b]);
      }

      a.lazySizesConfig = d, k(function () {
        d.init && F();
      });
    }();

    var D = function () {
      var g,
          l,
          m,
          o,
          p,
          y,
          D,
          F,
          G,
          H,
          I,
          J = /^img$/i,
          K = /^iframe$/i,
          L = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent),
          M = 0,
          N = 0,
          O = 0,
          P = -1,
          Q = function Q(a) {
        O--, a && a.target && u(a.target, Q), (!a || O < 0 || !a.target) && (O = 0);
      },
          R = function R(a, c) {
        var d,
            f = a,
            g = "hidden" == x(b.body, "visibility") || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility");

        for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;) {
          (g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1);
        }

        return g;
      },
          S = function S() {
        var a,
            f,
            h,
            j,
            k,
            m,
            n,
            p,
            q,
            r,
            s,
            t,
            u = c.elements;

        if ((o = d.loadMode) && O < 8 && (a = u.length)) {
          for (f = 0, P++, r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, s = r * d.expFactor, t = d.hFac, N < s && O < 1 && P > 2 && o > 2 && !b.hidden ? (N = s, P = 0) : N = o > 1 && P > 1 && O < 6 ? r : M; f < a; f++) {
            if (u[f] && !u[f]._lazyRace) if (L) {
              if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || "hidden" != x(u[f], "visibility")) && (l && O < 3 && !p && (o < 3 || P < 4) || R(u[f], m))) {
                if ($(u[f]), k = !0, O > 9) break;
              } else !k && l && !j && O < 4 && P < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]);
            } else $(u[f]);
          }

          j && !k && $(j);
        }
      },
          T = B(S),
          U = function U(a) {
        s(a.target, d.loadedClass), t(a.target, d.loadingClass), u(a.target, W), v(a.target, "lazyloaded");
      },
          V = A(U),
          W = function W(a) {
        V({
          target: a.target
        });
      },
          X = function X(a, b) {
        try {
          a.contentWindow.location.replace(b);
        } catch (c) {
          a.src = b;
        }
      },
          Y = function Y(a) {
        var b,
            c = a[i](d.srcsetAttr);
        (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c);
      },
          Z = A(function (a, b, c, e, f) {
        var g, h, j, l, o, p;
        (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = {
          target: a
        }, p && (u(a, Q, !0), clearTimeout(m), m = k(Q, 2500), s(a, d.loadingClass), u(a, W, !0)), l && q.call(j.getElementsByTagName("source"), Y), h ? a.setAttribute("srcset", h) : g && !l && (K.test(a.nodeName) ? X(a, g) : a.src = g), f && (h || l) && w(a, {
          src: g
        })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () {
          (!p || a.complete && a.naturalWidth > 1) && (p ? Q(o) : O--, U(o));
        }, !0);
      }),
          $ = function $(a) {
        var b,
            c = J.test(a.nodeName),
            e = c && (a[i](d.sizesAttr) || a[i]("sizes")),
            f = "auto" == e;
        (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, O++, Z(a, b, f, e, c));
      },
          _2 = function _() {
        if (!l) {
          if (f.now() - p < 999) return void k(_2, 999);
          var a = C(function () {
            d.loadMode = 3, T();
          });
          l = !0, d.loadMode = 3, T(), j("scroll", function () {
            3 == d.loadMode && (d.loadMode = 2), a();
          }, !0);
        }
      };

      return {
        _: function _() {
          p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", T, !0), j("resize", T, !0), a.MutationObserver ? new MutationObserver(T).observe(e, {
            childList: !0,
            subtree: !0,
            attributes: !0
          }) : (e[h]("DOMNodeInserted", T, !0), e[h]("DOMAttrModified", T, !0), setInterval(T, 999)), j("hashchange", T, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) {
            b[h](a, T, !0);
          }), /d$|^c/.test(b.readyState) ? _2() : (j("load", _2), b[h]("DOMContentLoaded", T), k(_2, 2e4)), c.elements.length ? (S(), z._lsFlush()) : T();
        },
        checkElems: T,
        unveil: $
      };
    }(),
        E = function () {
      var a,
          c = A(function (a, b, c, d) {
        var e, f, g;
        if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++) {
          e[f].setAttribute("sizes", d);
        }
        c.detail.dataAttr || w(a, c.detail);
      }),
          e = function e(a, b, d) {
        var e,
            f = a.parentNode;
        f && (d = y(a, f, d), e = v(a, "lazybeforesizes", {
          width: d,
          dataAttr: !!b
        }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d));
      },
          f = function f() {
        var b,
            c = a.length;
        if (c) for (b = 0; b < c; b++) {
          e(a[b]);
        }
      },
          g = C(f);

      return {
        _: function _() {
          a = b.getElementsByClassName(d.autosizesClass), j("resize", g);
        },
        checkElems: g,
        updateElem: e
      };
    }(),
        F = function F() {
      F.i || (F.i = !0, E._(), D._());
    };

    return c = {
      cfg: d,
      autoSizer: E,
      loader: D,
      init: F,
      uP: w,
      aC: s,
      rC: t,
      hC: r,
      fire: v,
      gW: y,
      rAF: z
    };
  }
});
!function (t) {
  var i = t(window);

  t.fn.visible = function (t, e, o) {
    if (!(this.length < 1)) {
      var r = this.length > 1 ? this.eq(0) : this,
          n = r.get(0),
          f = i.width(),
          h = i.height(),
          o = o ? o : "both",
          l = e === !0 ? n.offsetWidth * n.offsetHeight : !0;

      if ("function" == typeof n.getBoundingClientRect) {
        var g = n.getBoundingClientRect(),
            u = g.top >= 0 && g.top < h,
            s = g.bottom > 0 && g.bottom <= h,
            c = g.left >= 0 && g.left < f,
            a = g.right > 0 && g.right <= f,
            v = t ? u || s : u && s,
            b = t ? c || a : c && a;
        if ("both" === o) return l && v && b;
        if ("vertical" === o) return l && v;
        if ("horizontal" === o) return l && b;
      } else {
        var d = i.scrollTop(),
            p = d + h,
            w = i.scrollLeft(),
            m = w + f,
            y = r.offset(),
            z = y.top,
            B = z + r.height(),
            C = y.left,
            R = C + r.width(),
            j = t === !0 ? B : z,
            q = t === !0 ? z : B,
            H = t === !0 ? R : C,
            L = t === !0 ? C : R;
        if ("both" === o) return !!l && p >= q && j >= d && m >= L && H >= w;
        if ("vertical" === o) return !!l && p >= q && j >= d;
        if ("horizontal" === o) return !!l && m >= L && H >= w;
      }
    }
  };
}(jQuery);
/*!
 * replaceUrlParam.min.js
 */

function replaceUrlParam(t, e, n) {
  var i = new RegExp("(" + e + "=).*?(&|$)"),
      o = t;
  return o = t.search(i) >= 0 ? t.replace(i, "$1" + n + "$2") : o + (o.indexOf("?") > 0 ? "&" : "?") + e + "=" + n;
}
/**
 * Swiper 4.5.0
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://www.idangero.us/swiper/
 *
 * Copyright 2014-2019 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: February 22, 2019
 */


!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e = e || self).Swiper = t();
}(this, function () {
  "use strict";

  var f = "undefined" == typeof document ? {
    body: {},
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    activeElement: {
      blur: function blur() {},
      nodeName: ""
    },
    querySelector: function querySelector() {
      return null;
    },
    querySelectorAll: function querySelectorAll() {
      return [];
    },
    getElementById: function getElementById() {
      return null;
    },
    createEvent: function createEvent() {
      return {
        initEvent: function initEvent() {}
      };
    },
    createElement: function createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute: function setAttribute() {},
        getElementsByTagName: function getElementsByTagName() {
          return [];
        }
      };
    },
    location: {
      hash: ""
    }
  } : document,
      J = "undefined" == typeof window ? {
    document: f,
    navigator: {
      userAgent: ""
    },
    location: {},
    history: {},
    CustomEvent: function CustomEvent() {
      return this;
    },
    addEventListener: function addEventListener() {},
    removeEventListener: function removeEventListener() {},
    getComputedStyle: function getComputedStyle() {
      return {
        getPropertyValue: function getPropertyValue() {
          return "";
        }
      };
    },
    Image: function Image() {},
    Date: function Date() {},
    screen: {},
    setTimeout: function setTimeout() {},
    clearTimeout: function clearTimeout() {}
  } : window,
      l = function l(e) {
    for (var t = 0; t < e.length; t += 1) {
      this[t] = e[t];
    }

    return this.length = e.length, this;
  };

  function L(e, t) {
    var a = [],
        i = 0;
    if (e && !t && e instanceof l) return e;
    if (e) if ("string" == typeof e) {
      var s,
          r,
          n = e.trim();

      if (0 <= n.indexOf("<") && 0 <= n.indexOf(">")) {
        var o = "div";

        for (0 === n.indexOf("<li") && (o = "ul"), 0 === n.indexOf("<tr") && (o = "tbody"), 0 !== n.indexOf("<td") && 0 !== n.indexOf("<th") || (o = "tr"), 0 === n.indexOf("<tbody") && (o = "table"), 0 === n.indexOf("<option") && (o = "select"), (r = f.createElement(o)).innerHTML = n, i = 0; i < r.childNodes.length; i += 1) {
          a.push(r.childNodes[i]);
        }
      } else for (s = t || "#" !== e[0] || e.match(/[ .<>:~]/) ? (t || f).querySelectorAll(e.trim()) : [f.getElementById(e.trim().split("#")[1])], i = 0; i < s.length; i += 1) {
        s[i] && a.push(s[i]);
      }
    } else if (e.nodeType || e === J || e === f) a.push(e);else if (0 < e.length && e[0].nodeType) for (i = 0; i < e.length; i += 1) {
      a.push(e[i]);
    }
    return new l(a);
  }

  function r(e) {
    for (var t = [], a = 0; a < e.length; a += 1) {
      -1 === t.indexOf(e[a]) && t.push(e[a]);
    }

    return t;
  }

  L.fn = l.prototype, L.Class = l, L.Dom7 = l;
  var t = {
    addClass: function addClass(e) {
      if (void 0 === e) return this;

      for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
        for (var i = 0; i < this.length; i += 1) {
          void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.add(t[a]);
        }
      }

      return this;
    },
    removeClass: function removeClass(e) {
      for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
        for (var i = 0; i < this.length; i += 1) {
          void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.remove(t[a]);
        }
      }

      return this;
    },
    hasClass: function hasClass(e) {
      return !!this[0] && this[0].classList.contains(e);
    },
    toggleClass: function toggleClass(e) {
      for (var t = e.split(" "), a = 0; a < t.length; a += 1) {
        for (var i = 0; i < this.length; i += 1) {
          void 0 !== this[i] && void 0 !== this[i].classList && this[i].classList.toggle(t[a]);
        }
      }

      return this;
    },
    attr: function attr(e, t) {
      var a = arguments;
      if (1 === arguments.length && "string" == typeof e) return this[0] ? this[0].getAttribute(e) : void 0;

      for (var i = 0; i < this.length; i += 1) {
        if (2 === a.length) this[i].setAttribute(e, t);else for (var s in e) {
          this[i][s] = e[s], this[i].setAttribute(s, e[s]);
        }
      }

      return this;
    },
    removeAttr: function removeAttr(e) {
      for (var t = 0; t < this.length; t += 1) {
        this[t].removeAttribute(e);
      }

      return this;
    },
    data: function data(e, t) {
      var a;

      if (void 0 !== t) {
        for (var i = 0; i < this.length; i += 1) {
          (a = this[i]).dom7ElementDataStorage || (a.dom7ElementDataStorage = {}), a.dom7ElementDataStorage[e] = t;
        }

        return this;
      }

      if (a = this[0]) {
        if (a.dom7ElementDataStorage && e in a.dom7ElementDataStorage) return a.dom7ElementDataStorage[e];
        var s = a.getAttribute("data-" + e);
        return s || void 0;
      }
    },
    transform: function transform(e) {
      for (var t = 0; t < this.length; t += 1) {
        var a = this[t].style;
        a.webkitTransform = e, a.transform = e;
      }

      return this;
    },
    transition: function transition(e) {
      "string" != typeof e && (e += "ms");

      for (var t = 0; t < this.length; t += 1) {
        var a = this[t].style;
        a.webkitTransitionDuration = e, a.transitionDuration = e;
      }

      return this;
    },
    on: function on() {
      for (var e, t = [], a = arguments.length; a--;) {
        t[a] = arguments[a];
      }

      var i = t[0],
          r = t[1],
          n = t[2],
          s = t[3];

      function o(e) {
        var t = e.target;

        if (t) {
          var a = e.target.dom7EventData || [];
          if (a.indexOf(e) < 0 && a.unshift(e), L(t).is(r)) n.apply(t, a);else for (var i = L(t).parents(), s = 0; s < i.length; s += 1) {
            L(i[s]).is(r) && n.apply(i[s], a);
          }
        }
      }

      function l(e) {
        var t = e && e.target && e.target.dom7EventData || [];
        t.indexOf(e) < 0 && t.unshift(e), n.apply(this, t);
      }

      "function" == typeof t[1] && (i = (e = t)[0], n = e[1], s = e[2], r = void 0), s || (s = !1);

      for (var d, p = i.split(" "), c = 0; c < this.length; c += 1) {
        var u = this[c];
        if (r) for (d = 0; d < p.length; d += 1) {
          var h = p[d];
          u.dom7LiveListeners || (u.dom7LiveListeners = {}), u.dom7LiveListeners[h] || (u.dom7LiveListeners[h] = []), u.dom7LiveListeners[h].push({
            listener: n,
            proxyListener: o
          }), u.addEventListener(h, o, s);
        } else for (d = 0; d < p.length; d += 1) {
          var v = p[d];
          u.dom7Listeners || (u.dom7Listeners = {}), u.dom7Listeners[v] || (u.dom7Listeners[v] = []), u.dom7Listeners[v].push({
            listener: n,
            proxyListener: l
          }), u.addEventListener(v, l, s);
        }
      }

      return this;
    },
    off: function off() {
      for (var e, t = [], a = arguments.length; a--;) {
        t[a] = arguments[a];
      }

      var i = t[0],
          s = t[1],
          r = t[2],
          n = t[3];
      "function" == typeof t[1] && (i = (e = t)[0], r = e[1], n = e[2], s = void 0), n || (n = !1);

      for (var o = i.split(" "), l = 0; l < o.length; l += 1) {
        for (var d = o[l], p = 0; p < this.length; p += 1) {
          var c = this[p],
              u = void 0;
          if (!s && c.dom7Listeners ? u = c.dom7Listeners[d] : s && c.dom7LiveListeners && (u = c.dom7LiveListeners[d]), u && u.length) for (var h = u.length - 1; 0 <= h; h -= 1) {
            var v = u[h];
            r && v.listener === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r && v.listener && v.listener.dom7proxy && v.listener.dom7proxy === r ? (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1)) : r || (c.removeEventListener(d, v.proxyListener, n), u.splice(h, 1));
          }
        }
      }

      return this;
    },
    trigger: function trigger() {
      for (var e = [], t = arguments.length; t--;) {
        e[t] = arguments[t];
      }

      for (var a = e[0].split(" "), i = e[1], s = 0; s < a.length; s += 1) {
        for (var r = a[s], n = 0; n < this.length; n += 1) {
          var o = this[n],
              l = void 0;

          try {
            l = new J.CustomEvent(r, {
              detail: i,
              bubbles: !0,
              cancelable: !0
            });
          } catch (e) {
            (l = f.createEvent("Event")).initEvent(r, !0, !0), l.detail = i;
          }

          o.dom7EventData = e.filter(function (e, t) {
            return 0 < t;
          }), o.dispatchEvent(l), o.dom7EventData = [], delete o.dom7EventData;
        }
      }

      return this;
    },
    transitionEnd: function transitionEnd(t) {
      var a,
          i = ["webkitTransitionEnd", "transitionend"],
          s = this;

      function r(e) {
        if (e.target === this) for (t.call(this, e), a = 0; a < i.length; a += 1) {
          s.off(i[a], r);
        }
      }

      if (t) for (a = 0; a < i.length; a += 1) {
        s.on(i[a], r);
      }
      return this;
    },
    outerWidth: function outerWidth(e) {
      if (0 < this.length) {
        if (e) {
          var t = this.styles();
          return this[0].offsetWidth + parseFloat(t.getPropertyValue("margin-right")) + parseFloat(t.getPropertyValue("margin-left"));
        }

        return this[0].offsetWidth;
      }

      return null;
    },
    outerHeight: function outerHeight(e) {
      if (0 < this.length) {
        if (e) {
          var t = this.styles();
          return this[0].offsetHeight + parseFloat(t.getPropertyValue("margin-top")) + parseFloat(t.getPropertyValue("margin-bottom"));
        }

        return this[0].offsetHeight;
      }

      return null;
    },
    offset: function offset() {
      if (0 < this.length) {
        var e = this[0],
            t = e.getBoundingClientRect(),
            a = f.body,
            i = e.clientTop || a.clientTop || 0,
            s = e.clientLeft || a.clientLeft || 0,
            r = e === J ? J.scrollY : e.scrollTop,
            n = e === J ? J.scrollX : e.scrollLeft;
        return {
          top: t.top + r - i,
          left: t.left + n - s
        };
      }

      return null;
    },
    css: function css(e, t) {
      var a;

      if (1 === arguments.length) {
        if ("string" != typeof e) {
          for (a = 0; a < this.length; a += 1) {
            for (var i in e) {
              this[a].style[i] = e[i];
            }
          }

          return this;
        }

        if (this[0]) return J.getComputedStyle(this[0], null).getPropertyValue(e);
      }

      if (2 === arguments.length && "string" == typeof e) {
        for (a = 0; a < this.length; a += 1) {
          this[a].style[e] = t;
        }

        return this;
      }

      return this;
    },
    each: function each(e) {
      if (!e) return this;

      for (var t = 0; t < this.length; t += 1) {
        if (!1 === e.call(this[t], t, this[t])) return this;
      }

      return this;
    },
    html: function html(e) {
      if (void 0 === e) return this[0] ? this[0].innerHTML : void 0;

      for (var t = 0; t < this.length; t += 1) {
        this[t].innerHTML = e;
      }

      return this;
    },
    text: function text(e) {
      if (void 0 === e) return this[0] ? this[0].textContent.trim() : null;

      for (var t = 0; t < this.length; t += 1) {
        this[t].textContent = e;
      }

      return this;
    },
    is: function is(e) {
      var t,
          a,
          i = this[0];
      if (!i || void 0 === e) return !1;

      if ("string" == typeof e) {
        if (i.matches) return i.matches(e);
        if (i.webkitMatchesSelector) return i.webkitMatchesSelector(e);
        if (i.msMatchesSelector) return i.msMatchesSelector(e);

        for (t = L(e), a = 0; a < t.length; a += 1) {
          if (t[a] === i) return !0;
        }

        return !1;
      }

      if (e === f) return i === f;
      if (e === J) return i === J;

      if (e.nodeType || e instanceof l) {
        for (t = e.nodeType ? [e] : e, a = 0; a < t.length; a += 1) {
          if (t[a] === i) return !0;
        }

        return !1;
      }

      return !1;
    },
    index: function index() {
      var e,
          t = this[0];

      if (t) {
        for (e = 0; null !== (t = t.previousSibling);) {
          1 === t.nodeType && (e += 1);
        }

        return e;
      }
    },
    eq: function eq(e) {
      if (void 0 === e) return this;
      var t,
          a = this.length;
      return new l(a - 1 < e ? [] : e < 0 ? (t = a + e) < 0 ? [] : [this[t]] : [this[e]]);
    },
    append: function append() {
      for (var e, t = [], a = arguments.length; a--;) {
        t[a] = arguments[a];
      }

      for (var i = 0; i < t.length; i += 1) {
        e = t[i];

        for (var s = 0; s < this.length; s += 1) {
          if ("string" == typeof e) {
            var r = f.createElement("div");

            for (r.innerHTML = e; r.firstChild;) {
              this[s].appendChild(r.firstChild);
            }
          } else if (e instanceof l) for (var n = 0; n < e.length; n += 1) {
            this[s].appendChild(e[n]);
          } else this[s].appendChild(e);
        }
      }

      return this;
    },
    prepend: function prepend(e) {
      var t, a;

      for (t = 0; t < this.length; t += 1) {
        if ("string" == typeof e) {
          var i = f.createElement("div");

          for (i.innerHTML = e, a = i.childNodes.length - 1; 0 <= a; a -= 1) {
            this[t].insertBefore(i.childNodes[a], this[t].childNodes[0]);
          }
        } else if (e instanceof l) for (a = 0; a < e.length; a += 1) {
          this[t].insertBefore(e[a], this[t].childNodes[0]);
        } else this[t].insertBefore(e, this[t].childNodes[0]);
      }

      return this;
    },
    next: function next(e) {
      return 0 < this.length ? e ? this[0].nextElementSibling && L(this[0].nextElementSibling).is(e) ? new l([this[0].nextElementSibling]) : new l([]) : this[0].nextElementSibling ? new l([this[0].nextElementSibling]) : new l([]) : new l([]);
    },
    nextAll: function nextAll(e) {
      var t = [],
          a = this[0];
      if (!a) return new l([]);

      for (; a.nextElementSibling;) {
        var i = a.nextElementSibling;
        e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
      }

      return new l(t);
    },
    prev: function prev(e) {
      if (0 < this.length) {
        var t = this[0];
        return e ? t.previousElementSibling && L(t.previousElementSibling).is(e) ? new l([t.previousElementSibling]) : new l([]) : t.previousElementSibling ? new l([t.previousElementSibling]) : new l([]);
      }

      return new l([]);
    },
    prevAll: function prevAll(e) {
      var t = [],
          a = this[0];
      if (!a) return new l([]);

      for (; a.previousElementSibling;) {
        var i = a.previousElementSibling;
        e ? L(i).is(e) && t.push(i) : t.push(i), a = i;
      }

      return new l(t);
    },
    parent: function parent(e) {
      for (var t = [], a = 0; a < this.length; a += 1) {
        null !== this[a].parentNode && (e ? L(this[a].parentNode).is(e) && t.push(this[a].parentNode) : t.push(this[a].parentNode));
      }

      return L(r(t));
    },
    parents: function parents(e) {
      for (var t = [], a = 0; a < this.length; a += 1) {
        for (var i = this[a].parentNode; i;) {
          e ? L(i).is(e) && t.push(i) : t.push(i), i = i.parentNode;
        }
      }

      return L(r(t));
    },
    closest: function closest(e) {
      var t = this;
      return void 0 === e ? new l([]) : (t.is(e) || (t = t.parents(e).eq(0)), t);
    },
    find: function find(e) {
      for (var t = [], a = 0; a < this.length; a += 1) {
        for (var i = this[a].querySelectorAll(e), s = 0; s < i.length; s += 1) {
          t.push(i[s]);
        }
      }

      return new l(t);
    },
    children: function children(e) {
      for (var t = [], a = 0; a < this.length; a += 1) {
        for (var i = this[a].childNodes, s = 0; s < i.length; s += 1) {
          e ? 1 === i[s].nodeType && L(i[s]).is(e) && t.push(i[s]) : 1 === i[s].nodeType && t.push(i[s]);
        }
      }

      return new l(r(t));
    },
    remove: function remove() {
      for (var e = 0; e < this.length; e += 1) {
        this[e].parentNode && this[e].parentNode.removeChild(this[e]);
      }

      return this;
    },
    add: function add() {
      for (var e = [], t = arguments.length; t--;) {
        e[t] = arguments[t];
      }

      var a, i;

      for (a = 0; a < e.length; a += 1) {
        var s = L(e[a]);

        for (i = 0; i < s.length; i += 1) {
          this[this.length] = s[i], this.length += 1;
        }
      }

      return this;
    },
    styles: function styles() {
      return this[0] ? J.getComputedStyle(this[0], null) : {};
    }
  };
  Object.keys(t).forEach(function (e) {
    L.fn[e] = t[e];
  });

  var e,
      a,
      i,
      s,
      ee = {
    deleteProps: function deleteProps(e) {
      var t = e;
      Object.keys(t).forEach(function (e) {
        try {
          t[e] = null;
        } catch (e) {}

        try {
          delete t[e];
        } catch (e) {}
      });
    },
    nextTick: function nextTick(e, t) {
      return void 0 === t && (t = 0), setTimeout(e, t);
    },
    now: function now() {
      return Date.now();
    },
    getTranslate: function getTranslate(e, t) {
      var a, i, s;
      void 0 === t && (t = "x");
      var r = J.getComputedStyle(e, null);
      return J.WebKitCSSMatrix ? (6 < (i = r.transform || r.webkitTransform).split(",").length && (i = i.split(", ").map(function (e) {
        return e.replace(",", ".");
      }).join(", ")), s = new J.WebKitCSSMatrix("none" === i ? "" : i)) : a = (s = r.MozTransform || r.OTransform || r.MsTransform || r.msTransform || r.transform || r.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,")).toString().split(","), "x" === t && (i = J.WebKitCSSMatrix ? s.m41 : 16 === a.length ? parseFloat(a[12]) : parseFloat(a[4])), "y" === t && (i = J.WebKitCSSMatrix ? s.m42 : 16 === a.length ? parseFloat(a[13]) : parseFloat(a[5])), i || 0;
    },
    parseUrlQuery: function parseUrlQuery(e) {
      var t,
          a,
          i,
          s,
          r = {},
          n = e || J.location.href;
      if ("string" == typeof n && n.length) for (s = (a = (n = -1 < n.indexOf("?") ? n.replace(/\S*\?/, "") : "").split("&").filter(function (e) {
        return "" !== e;
      })).length, t = 0; t < s; t += 1) {
        i = a[t].replace(/#\S+/g, "").split("="), r[decodeURIComponent(i[0])] = void 0 === i[1] ? void 0 : decodeURIComponent(i[1]) || "";
      }
      return r;
    },
    isObject: function isObject(e) {
      return "object" == _typeof(e) && null !== e && e.constructor && e.constructor === Object;
    },
    extend: function extend() {
      for (var e = [], t = arguments.length; t--;) {
        e[t] = arguments[t];
      }

      for (var a = Object(e[0]), i = 1; i < e.length; i += 1) {
        var s = e[i];
        if (null != s) for (var r = Object.keys(Object(s)), n = 0, o = r.length; n < o; n += 1) {
          var l = r[n],
              d = Object.getOwnPropertyDescriptor(s, l);
          void 0 !== d && d.enumerable && (ee.isObject(a[l]) && ee.isObject(s[l]) ? ee.extend(a[l], s[l]) : !ee.isObject(a[l]) && ee.isObject(s[l]) ? (a[l] = {}, ee.extend(a[l], s[l])) : a[l] = s[l]);
        }
      }

      return a;
    }
  },
      te = (i = f.createElement("div"), {
    touch: J.Modernizr && !0 === J.Modernizr.touch || !!(0 < J.navigator.maxTouchPoints || "ontouchstart" in J || J.DocumentTouch && f instanceof J.DocumentTouch),
    pointerEvents: !!(J.navigator.pointerEnabled || J.PointerEvent || "maxTouchPoints" in J.navigator && 0 < J.navigator.maxTouchPoints),
    prefixedPointerEvents: !!J.navigator.msPointerEnabled,
    transition: (a = i.style, "transition" in a || "webkitTransition" in a || "MozTransition" in a),
    transforms3d: J.Modernizr && !0 === J.Modernizr.csstransforms3d || (e = i.style, "webkitPerspective" in e || "MozPerspective" in e || "OPerspective" in e || "MsPerspective" in e || "perspective" in e),
    flexbox: function () {
      for (var e = i.style, t = "alignItems webkitAlignItems webkitBoxAlign msFlexAlign mozBoxAlign webkitFlexDirection msFlexDirection mozBoxDirection mozBoxOrient webkitBoxDirection webkitBoxOrient".split(" "), a = 0; a < t.length; a += 1) {
        if (t[a] in e) return !0;
      }

      return !1;
    }(),
    observer: "MutationObserver" in J || "WebkitMutationObserver" in J,
    passiveListener: function () {
      var e = !1;

      try {
        var t = Object.defineProperty({}, "passive", {
          get: function get() {
            e = !0;
          }
        });
        J.addEventListener("testPassiveListener", null, t);
      } catch (e) {}

      return e;
    }(),
    gestures: "ongesturestart" in J
  }),
      I = {
    isIE: !!J.navigator.userAgent.match(/Trident/g) || !!J.navigator.userAgent.match(/MSIE/g),
    isEdge: !!J.navigator.userAgent.match(/Edge/g),
    isSafari: (s = J.navigator.userAgent.toLowerCase(), 0 <= s.indexOf("safari") && s.indexOf("chrome") < 0 && s.indexOf("android") < 0),
    isUiWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(J.navigator.userAgent)
  },
      n = function n(e) {
    void 0 === e && (e = {});
    var t = this;
    t.params = e, t.eventsListeners = {}, t.params && t.params.on && Object.keys(t.params.on).forEach(function (e) {
      t.on(e, t.params.on[e]);
    });
  },
      o = {
    components: {
      configurable: !0
    }
  };

  n.prototype.on = function (e, t, a) {
    var i = this;
    if ("function" != typeof t) return i;
    var s = a ? "unshift" : "push";
    return e.split(" ").forEach(function (e) {
      i.eventsListeners[e] || (i.eventsListeners[e] = []), i.eventsListeners[e][s](t);
    }), i;
  }, n.prototype.once = function (a, i, e) {
    var s = this;
    if ("function" != typeof i) return s;

    function r() {
      for (var e = [], t = arguments.length; t--;) {
        e[t] = arguments[t];
      }

      i.apply(s, e), s.off(a, r), r.f7proxy && delete r.f7proxy;
    }

    return r.f7proxy = i, s.on(a, r, e);
  }, n.prototype.off = function (e, i) {
    var s = this;
    return s.eventsListeners && e.split(" ").forEach(function (a) {
      void 0 === i ? s.eventsListeners[a] = [] : s.eventsListeners[a] && s.eventsListeners[a].length && s.eventsListeners[a].forEach(function (e, t) {
        (e === i || e.f7proxy && e.f7proxy === i) && s.eventsListeners[a].splice(t, 1);
      });
    }), s;
  }, n.prototype.emit = function () {
    for (var e = [], t = arguments.length; t--;) {
      e[t] = arguments[t];
    }

    var a,
        i,
        s,
        r = this;
    return r.eventsListeners && ("string" == typeof e[0] || Array.isArray(e[0]) ? (a = e[0], i = e.slice(1, e.length), s = r) : (a = e[0].events, i = e[0].data, s = e[0].context || r), (Array.isArray(a) ? a : a.split(" ")).forEach(function (e) {
      if (r.eventsListeners && r.eventsListeners[e]) {
        var t = [];
        r.eventsListeners[e].forEach(function (e) {
          t.push(e);
        }), t.forEach(function (e) {
          e.apply(s, i);
        });
      }
    })), r;
  }, n.prototype.useModulesParams = function (a) {
    var i = this;
    i.modules && Object.keys(i.modules).forEach(function (e) {
      var t = i.modules[e];
      t.params && ee.extend(a, t.params);
    });
  }, n.prototype.useModules = function (i) {
    void 0 === i && (i = {});
    var s = this;
    s.modules && Object.keys(s.modules).forEach(function (e) {
      var a = s.modules[e],
          t = i[e] || {};
      a.instance && Object.keys(a.instance).forEach(function (e) {
        var t = a.instance[e];
        s[e] = "function" == typeof t ? t.bind(s) : t;
      }), a.on && s.on && Object.keys(a.on).forEach(function (e) {
        s.on(e, a.on[e]);
      }), a.create && a.create.bind(s)(t);
    });
  }, o.components.set = function (e) {
    this.use && this.use(e);
  }, n.installModule = function (t) {
    for (var e = [], a = arguments.length - 1; 0 < a--;) {
      e[a] = arguments[a + 1];
    }

    var i = this;
    i.prototype.modules || (i.prototype.modules = {});
    var s = t.name || Object.keys(i.prototype.modules).length + "_" + ee.now();
    return (i.prototype.modules[s] = t).proto && Object.keys(t.proto).forEach(function (e) {
      i.prototype[e] = t.proto[e];
    }), t.static && Object.keys(t.static).forEach(function (e) {
      i[e] = t.static[e];
    }), t.install && t.install.apply(i, e), i;
  }, n.use = function (e) {
    for (var t = [], a = arguments.length - 1; 0 < a--;) {
      t[a] = arguments[a + 1];
    }

    var i = this;
    return Array.isArray(e) ? (e.forEach(function (e) {
      return i.installModule(e);
    }), i) : i.installModule.apply(i, [e].concat(t));
  }, Object.defineProperties(n, o);
  var d = {
    updateSize: function updateSize() {
      var e,
          t,
          a = this,
          i = a.$el;
      e = void 0 !== a.params.width ? a.params.width : i[0].clientWidth, t = void 0 !== a.params.height ? a.params.height : i[0].clientHeight, 0 === e && a.isHorizontal() || 0 === t && a.isVertical() || (e = e - parseInt(i.css("padding-left"), 10) - parseInt(i.css("padding-right"), 10), t = t - parseInt(i.css("padding-top"), 10) - parseInt(i.css("padding-bottom"), 10), ee.extend(a, {
        width: e,
        height: t,
        size: a.isHorizontal() ? e : t
      }));
    },
    updateSlides: function updateSlides() {
      var e = this,
          t = e.params,
          a = e.$wrapperEl,
          i = e.size,
          s = e.rtlTranslate,
          r = e.wrongRTL,
          n = e.virtual && t.virtual.enabled,
          o = n ? e.virtual.slides.length : e.slides.length,
          l = a.children("." + e.params.slideClass),
          d = n ? e.virtual.slides.length : l.length,
          p = [],
          c = [],
          u = [],
          h = t.slidesOffsetBefore;
      "function" == typeof h && (h = t.slidesOffsetBefore.call(e));
      var v = t.slidesOffsetAfter;
      "function" == typeof v && (v = t.slidesOffsetAfter.call(e));
      var f = e.snapGrid.length,
          m = e.snapGrid.length,
          g = t.spaceBetween,
          b = -h,
          w = 0,
          y = 0;

      if (void 0 !== i) {
        var x, T;
        "string" == typeof g && 0 <= g.indexOf("%") && (g = parseFloat(g.replace("%", "")) / 100 * i), e.virtualSize = -g, s ? l.css({
          marginLeft: "",
          marginTop: ""
        }) : l.css({
          marginRight: "",
          marginBottom: ""
        }), 1 < t.slidesPerColumn && (x = Math.floor(d / t.slidesPerColumn) === d / e.params.slidesPerColumn ? d : Math.ceil(d / t.slidesPerColumn) * t.slidesPerColumn, "auto" !== t.slidesPerView && "row" === t.slidesPerColumnFill && (x = Math.max(x, t.slidesPerView * t.slidesPerColumn)));

        for (var E, S = t.slidesPerColumn, C = x / S, M = Math.floor(d / t.slidesPerColumn), z = 0; z < d; z += 1) {
          T = 0;
          var P = l.eq(z);

          if (1 < t.slidesPerColumn) {
            var k = void 0,
                $ = void 0,
                L = void 0;
            "column" === t.slidesPerColumnFill ? (L = z - ($ = Math.floor(z / S)) * S, (M < $ || $ === M && L === S - 1) && S <= (L += 1) && (L = 0, $ += 1), k = $ + L * x / S, P.css({
              "-webkit-box-ordinal-group": k,
              "-moz-box-ordinal-group": k,
              "-ms-flex-order": k,
              "-webkit-order": k,
              order: k
            })) : $ = z - (L = Math.floor(z / C)) * C, P.css("margin-" + (e.isHorizontal() ? "top" : "left"), 0 !== L && t.spaceBetween && t.spaceBetween + "px").attr("data-swiper-column", $).attr("data-swiper-row", L);
          }

          if ("none" !== P.css("display")) {
            if ("auto" === t.slidesPerView) {
              var I = J.getComputedStyle(P[0], null),
                  D = P[0].style.transform,
                  O = P[0].style.webkitTransform;
              if (D && (P[0].style.transform = "none"), O && (P[0].style.webkitTransform = "none"), t.roundLengths) T = e.isHorizontal() ? P.outerWidth(!0) : P.outerHeight(!0);else if (e.isHorizontal()) {
                var A = parseFloat(I.getPropertyValue("width")),
                    H = parseFloat(I.getPropertyValue("padding-left")),
                    N = parseFloat(I.getPropertyValue("padding-right")),
                    G = parseFloat(I.getPropertyValue("margin-left")),
                    B = parseFloat(I.getPropertyValue("margin-right")),
                    X = I.getPropertyValue("box-sizing");
                T = X && "border-box" === X ? A + G + B : A + H + N + G + B;
              } else {
                var Y = parseFloat(I.getPropertyValue("height")),
                    V = parseFloat(I.getPropertyValue("padding-top")),
                    F = parseFloat(I.getPropertyValue("padding-bottom")),
                    R = parseFloat(I.getPropertyValue("margin-top")),
                    q = parseFloat(I.getPropertyValue("margin-bottom")),
                    W = I.getPropertyValue("box-sizing");
                T = W && "border-box" === W ? Y + R + q : Y + V + F + R + q;
              }
              D && (P[0].style.transform = D), O && (P[0].style.webkitTransform = O), t.roundLengths && (T = Math.floor(T));
            } else T = (i - (t.slidesPerView - 1) * g) / t.slidesPerView, t.roundLengths && (T = Math.floor(T)), l[z] && (e.isHorizontal() ? l[z].style.width = T + "px" : l[z].style.height = T + "px");

            l[z] && (l[z].swiperSlideSize = T), u.push(T), t.centeredSlides ? (b = b + T / 2 + w / 2 + g, 0 === w && 0 !== z && (b = b - i / 2 - g), 0 === z && (b = b - i / 2 - g), Math.abs(b) < .001 && (b = 0), t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b)) : (t.roundLengths && (b = Math.floor(b)), y % t.slidesPerGroup == 0 && p.push(b), c.push(b), b = b + T + g), e.virtualSize += T + g, w = T, y += 1;
          }
        }

        if (e.virtualSize = Math.max(e.virtualSize, i) + v, s && r && ("slide" === t.effect || "coverflow" === t.effect) && a.css({
          width: e.virtualSize + t.spaceBetween + "px"
        }), te.flexbox && !t.setWrapperSize || (e.isHorizontal() ? a.css({
          width: e.virtualSize + t.spaceBetween + "px"
        }) : a.css({
          height: e.virtualSize + t.spaceBetween + "px"
        })), 1 < t.slidesPerColumn && (e.virtualSize = (T + t.spaceBetween) * x, e.virtualSize = Math.ceil(e.virtualSize / t.slidesPerColumn) - t.spaceBetween, e.isHorizontal() ? a.css({
          width: e.virtualSize + t.spaceBetween + "px"
        }) : a.css({
          height: e.virtualSize + t.spaceBetween + "px"
        }), t.centeredSlides)) {
          E = [];

          for (var j = 0; j < p.length; j += 1) {
            var U = p[j];
            t.roundLengths && (U = Math.floor(U)), p[j] < e.virtualSize + p[0] && E.push(U);
          }

          p = E;
        }

        if (!t.centeredSlides) {
          E = [];

          for (var K = 0; K < p.length; K += 1) {
            var _ = p[K];
            t.roundLengths && (_ = Math.floor(_)), p[K] <= e.virtualSize - i && E.push(_);
          }

          p = E, 1 < Math.floor(e.virtualSize - i) - Math.floor(p[p.length - 1]) && p.push(e.virtualSize - i);
        }

        if (0 === p.length && (p = [0]), 0 !== t.spaceBetween && (e.isHorizontal() ? s ? l.css({
          marginLeft: g + "px"
        }) : l.css({
          marginRight: g + "px"
        }) : l.css({
          marginBottom: g + "px"
        })), t.centerInsufficientSlides) {
          var Z = 0;

          if (u.forEach(function (e) {
            Z += e + (t.spaceBetween ? t.spaceBetween : 0);
          }), (Z -= t.spaceBetween) < i) {
            var Q = (i - Z) / 2;
            p.forEach(function (e, t) {
              p[t] = e - Q;
            }), c.forEach(function (e, t) {
              c[t] = e + Q;
            });
          }
        }

        ee.extend(e, {
          slides: l,
          snapGrid: p,
          slidesGrid: c,
          slidesSizesGrid: u
        }), d !== o && e.emit("slidesLengthChange"), p.length !== f && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), c.length !== m && e.emit("slidesGridLengthChange"), (t.watchSlidesProgress || t.watchSlidesVisibility) && e.updateSlidesOffset();
      }
    },
    updateAutoHeight: function updateAutoHeight(e) {
      var t,
          a = this,
          i = [],
          s = 0;
      if ("number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed), "auto" !== a.params.slidesPerView && 1 < a.params.slidesPerView) for (t = 0; t < Math.ceil(a.params.slidesPerView); t += 1) {
        var r = a.activeIndex + t;
        if (r > a.slides.length) break;
        i.push(a.slides.eq(r)[0]);
      } else i.push(a.slides.eq(a.activeIndex)[0]);

      for (t = 0; t < i.length; t += 1) {
        if (void 0 !== i[t]) {
          var n = i[t].offsetHeight;
          s = s < n ? n : s;
        }
      }

      s && a.$wrapperEl.css("height", s + "px");
    },
    updateSlidesOffset: function updateSlidesOffset() {
      for (var e = this.slides, t = 0; t < e.length; t += 1) {
        e[t].swiperSlideOffset = this.isHorizontal() ? e[t].offsetLeft : e[t].offsetTop;
      }
    },
    updateSlidesProgress: function updateSlidesProgress(e) {
      void 0 === e && (e = this && this.translate || 0);
      var t = this,
          a = t.params,
          i = t.slides,
          s = t.rtlTranslate;

      if (0 !== i.length) {
        void 0 === i[0].swiperSlideOffset && t.updateSlidesOffset();
        var r = -e;
        s && (r = e), i.removeClass(a.slideVisibleClass), t.visibleSlidesIndexes = [], t.visibleSlides = [];

        for (var n = 0; n < i.length; n += 1) {
          var o = i[n],
              l = (r + (a.centeredSlides ? t.minTranslate() : 0) - o.swiperSlideOffset) / (o.swiperSlideSize + a.spaceBetween);

          if (a.watchSlidesVisibility) {
            var d = -(r - o.swiperSlideOffset),
                p = d + t.slidesSizesGrid[n];
            (0 <= d && d < t.size || 0 < p && p <= t.size || d <= 0 && p >= t.size) && (t.visibleSlides.push(o), t.visibleSlidesIndexes.push(n), i.eq(n).addClass(a.slideVisibleClass));
          }

          o.progress = s ? -l : l;
        }

        t.visibleSlides = L(t.visibleSlides);
      }
    },
    updateProgress: function updateProgress(e) {
      void 0 === e && (e = this && this.translate || 0);
      var t = this,
          a = t.params,
          i = t.maxTranslate() - t.minTranslate(),
          s = t.progress,
          r = t.isBeginning,
          n = t.isEnd,
          o = r,
          l = n;
      0 === i ? n = r = !(s = 0) : (r = (s = (e - t.minTranslate()) / i) <= 0, n = 1 <= s), ee.extend(t, {
        progress: s,
        isBeginning: r,
        isEnd: n
      }), (a.watchSlidesProgress || a.watchSlidesVisibility) && t.updateSlidesProgress(e), r && !o && t.emit("reachBeginning toEdge"), n && !l && t.emit("reachEnd toEdge"), (o && !r || l && !n) && t.emit("fromEdge"), t.emit("progress", s);
    },
    updateSlidesClasses: function updateSlidesClasses() {
      var e,
          t = this,
          a = t.slides,
          i = t.params,
          s = t.$wrapperEl,
          r = t.activeIndex,
          n = t.realIndex,
          o = t.virtual && i.virtual.enabled;
      a.removeClass(i.slideActiveClass + " " + i.slideNextClass + " " + i.slidePrevClass + " " + i.slideDuplicateActiveClass + " " + i.slideDuplicateNextClass + " " + i.slideDuplicatePrevClass), (e = o ? t.$wrapperEl.find("." + i.slideClass + '[data-swiper-slide-index="' + r + '"]') : a.eq(r)).addClass(i.slideActiveClass), i.loop && (e.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + n + '"]').addClass(i.slideDuplicateActiveClass));
      var l = e.nextAll("." + i.slideClass).eq(0).addClass(i.slideNextClass);
      i.loop && 0 === l.length && (l = a.eq(0)).addClass(i.slideNextClass);
      var d = e.prevAll("." + i.slideClass).eq(0).addClass(i.slidePrevClass);
      i.loop && 0 === d.length && (d = a.eq(-1)).addClass(i.slidePrevClass), i.loop && (l.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + l.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicateNextClass), d.hasClass(i.slideDuplicateClass) ? s.children("." + i.slideClass + ":not(." + i.slideDuplicateClass + ')[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass) : s.children("." + i.slideClass + "." + i.slideDuplicateClass + '[data-swiper-slide-index="' + d.attr("data-swiper-slide-index") + '"]').addClass(i.slideDuplicatePrevClass));
    },
    updateActiveIndex: function updateActiveIndex(e) {
      var t,
          a = this,
          i = a.rtlTranslate ? a.translate : -a.translate,
          s = a.slidesGrid,
          r = a.snapGrid,
          n = a.params,
          o = a.activeIndex,
          l = a.realIndex,
          d = a.snapIndex,
          p = e;

      if (void 0 === p) {
        for (var c = 0; c < s.length; c += 1) {
          void 0 !== s[c + 1] ? i >= s[c] && i < s[c + 1] - (s[c + 1] - s[c]) / 2 ? p = c : i >= s[c] && i < s[c + 1] && (p = c + 1) : i >= s[c] && (p = c);
        }

        n.normalizeSlideIndex && (p < 0 || void 0 === p) && (p = 0);
      }

      if ((t = 0 <= r.indexOf(i) ? r.indexOf(i) : Math.floor(p / n.slidesPerGroup)) >= r.length && (t = r.length - 1), p !== o) {
        var u = parseInt(a.slides.eq(p).attr("data-swiper-slide-index") || p, 10);
        ee.extend(a, {
          snapIndex: t,
          realIndex: u,
          previousIndex: o,
          activeIndex: p
        }), a.emit("activeIndexChange"), a.emit("snapIndexChange"), l !== u && a.emit("realIndexChange"), a.emit("slideChange");
      } else t !== d && (a.snapIndex = t, a.emit("snapIndexChange"));
    },
    updateClickedSlide: function updateClickedSlide(e) {
      var t = this,
          a = t.params,
          i = L(e.target).closest("." + a.slideClass)[0],
          s = !1;
      if (i) for (var r = 0; r < t.slides.length; r += 1) {
        t.slides[r] === i && (s = !0);
      }
      if (!i || !s) return t.clickedSlide = void 0, void (t.clickedIndex = void 0);
      t.clickedSlide = i, t.virtual && t.params.virtual.enabled ? t.clickedIndex = parseInt(L(i).attr("data-swiper-slide-index"), 10) : t.clickedIndex = L(i).index(), a.slideToClickedSlide && void 0 !== t.clickedIndex && t.clickedIndex !== t.activeIndex && t.slideToClickedSlide();
    }
  };
  var p = {
    getTranslate: function getTranslate(e) {
      void 0 === e && (e = this.isHorizontal() ? "x" : "y");
      var t = this.params,
          a = this.rtlTranslate,
          i = this.translate,
          s = this.$wrapperEl;
      if (t.virtualTranslate) return a ? -i : i;
      var r = ee.getTranslate(s[0], e);
      return a && (r = -r), r || 0;
    },
    setTranslate: function setTranslate(e, t) {
      var a = this,
          i = a.rtlTranslate,
          s = a.params,
          r = a.$wrapperEl,
          n = a.progress,
          o = 0,
          l = 0;
      a.isHorizontal() ? o = i ? -e : e : l = e, s.roundLengths && (o = Math.floor(o), l = Math.floor(l)), s.virtualTranslate || (te.transforms3d ? r.transform("translate3d(" + o + "px, " + l + "px, 0px)") : r.transform("translate(" + o + "px, " + l + "px)")), a.previousTranslate = a.translate, a.translate = a.isHorizontal() ? o : l;
      var d = a.maxTranslate() - a.minTranslate();
      (0 === d ? 0 : (e - a.minTranslate()) / d) !== n && a.updateProgress(e), a.emit("setTranslate", a.translate, t);
    },
    minTranslate: function minTranslate() {
      return -this.snapGrid[0];
    },
    maxTranslate: function maxTranslate() {
      return -this.snapGrid[this.snapGrid.length - 1];
    }
  };
  var c = {
    setTransition: function setTransition(e, t) {
      this.$wrapperEl.transition(e), this.emit("setTransition", e, t);
    },
    transitionStart: function transitionStart(e, t) {
      void 0 === e && (e = !0);
      var a = this,
          i = a.activeIndex,
          s = a.params,
          r = a.previousIndex;
      s.autoHeight && a.updateAutoHeight();
      var n = t;

      if (n || (n = r < i ? "next" : i < r ? "prev" : "reset"), a.emit("transitionStart"), e && i !== r) {
        if ("reset" === n) return void a.emit("slideResetTransitionStart");
        a.emit("slideChangeTransitionStart"), "next" === n ? a.emit("slideNextTransitionStart") : a.emit("slidePrevTransitionStart");
      }
    },
    transitionEnd: function transitionEnd(e, t) {
      void 0 === e && (e = !0);
      var a = this,
          i = a.activeIndex,
          s = a.previousIndex;
      a.animating = !1, a.setTransition(0);
      var r = t;

      if (r || (r = s < i ? "next" : i < s ? "prev" : "reset"), a.emit("transitionEnd"), e && i !== s) {
        if ("reset" === r) return void a.emit("slideResetTransitionEnd");
        a.emit("slideChangeTransitionEnd"), "next" === r ? a.emit("slideNextTransitionEnd") : a.emit("slidePrevTransitionEnd");
      }
    }
  };
  var u = {
    slideTo: function slideTo(e, t, a, i) {
      void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
      var s = this,
          r = e;
      r < 0 && (r = 0);
      var n = s.params,
          o = s.snapGrid,
          l = s.slidesGrid,
          d = s.previousIndex,
          p = s.activeIndex,
          c = s.rtlTranslate;
      if (s.animating && n.preventInteractionOnTransition) return !1;
      var u = Math.floor(r / n.slidesPerGroup);
      u >= o.length && (u = o.length - 1), (p || n.initialSlide || 0) === (d || 0) && a && s.emit("beforeSlideChangeStart");
      var h,
          v = -o[u];
      if (s.updateProgress(v), n.normalizeSlideIndex) for (var f = 0; f < l.length; f += 1) {
        -Math.floor(100 * v) >= Math.floor(100 * l[f]) && (r = f);
      }

      if (s.initialized && r !== p) {
        if (!s.allowSlideNext && v < s.translate && v < s.minTranslate()) return !1;
        if (!s.allowSlidePrev && v > s.translate && v > s.maxTranslate() && (p || 0) !== r) return !1;
      }

      return h = p < r ? "next" : r < p ? "prev" : "reset", c && -v === s.translate || !c && v === s.translate ? (s.updateActiveIndex(r), n.autoHeight && s.updateAutoHeight(), s.updateSlidesClasses(), "slide" !== n.effect && s.setTranslate(v), "reset" !== h && (s.transitionStart(a, h), s.transitionEnd(a, h)), !1) : (0 !== t && te.transition ? (s.setTransition(t), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.animating || (s.animating = !0, s.onSlideToWrapperTransitionEnd || (s.onSlideToWrapperTransitionEnd = function (e) {
        s && !s.destroyed && e.target === this && (s.$wrapperEl[0].removeEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].removeEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd), s.onSlideToWrapperTransitionEnd = null, delete s.onSlideToWrapperTransitionEnd, s.transitionEnd(a, h));
      }), s.$wrapperEl[0].addEventListener("transitionend", s.onSlideToWrapperTransitionEnd), s.$wrapperEl[0].addEventListener("webkitTransitionEnd", s.onSlideToWrapperTransitionEnd))) : (s.setTransition(0), s.setTranslate(v), s.updateActiveIndex(r), s.updateSlidesClasses(), s.emit("beforeTransitionStart", t, i), s.transitionStart(a, h), s.transitionEnd(a, h)), !0);
    },
    slideToLoop: function slideToLoop(e, t, a, i) {
      void 0 === e && (e = 0), void 0 === t && (t = this.params.speed), void 0 === a && (a = !0);
      var s = e;
      return this.params.loop && (s += this.loopedSlides), this.slideTo(s, t, a, i);
    },
    slideNext: function slideNext(e, t, a) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      var i = this,
          s = i.params,
          r = i.animating;
      return s.loop ? !r && (i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft, i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a)) : i.slideTo(i.activeIndex + s.slidesPerGroup, e, t, a);
    },
    slidePrev: function slidePrev(e, t, a) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      var i = this,
          s = i.params,
          r = i.animating,
          n = i.snapGrid,
          o = i.slidesGrid,
          l = i.rtlTranslate;

      if (s.loop) {
        if (r) return !1;
        i.loopFix(), i._clientLeft = i.$wrapperEl[0].clientLeft;
      }

      function d(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
      }

      var p,
          c = d(l ? i.translate : -i.translate),
          u = n.map(function (e) {
        return d(e);
      }),
          h = (o.map(function (e) {
        return d(e);
      }), n[u.indexOf(c)], n[u.indexOf(c) - 1]);
      return void 0 !== h && (p = o.indexOf(h)) < 0 && (p = i.activeIndex - 1), i.slideTo(p, e, t, a);
    },
    slideReset: function slideReset(e, t, a) {
      return void 0 === e && (e = this.params.speed), void 0 === t && (t = !0), this.slideTo(this.activeIndex, e, t, a);
    },
    slideToClosest: function slideToClosest(e, t, a) {
      void 0 === e && (e = this.params.speed), void 0 === t && (t = !0);
      var i = this,
          s = i.activeIndex,
          r = Math.floor(s / i.params.slidesPerGroup);

      if (r < i.snapGrid.length - 1) {
        var n = i.rtlTranslate ? i.translate : -i.translate,
            o = i.snapGrid[r];
        (i.snapGrid[r + 1] - o) / 2 < n - o && (s = i.params.slidesPerGroup);
      }

      return i.slideTo(s, e, t, a);
    },
    slideToClickedSlide: function slideToClickedSlide() {
      var e,
          t = this,
          a = t.params,
          i = t.$wrapperEl,
          s = "auto" === a.slidesPerView ? t.slidesPerViewDynamic() : a.slidesPerView,
          r = t.clickedIndex;

      if (a.loop) {
        if (t.animating) return;
        e = parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10), a.centeredSlides ? r < t.loopedSlides - s / 2 || r > t.slides.length - t.loopedSlides + s / 2 ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
          t.slideTo(r);
        })) : t.slideTo(r) : r > t.slides.length - s ? (t.loopFix(), r = i.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]:not(.' + a.slideDuplicateClass + ")").eq(0).index(), ee.nextTick(function () {
          t.slideTo(r);
        })) : t.slideTo(r);
      } else t.slideTo(r);
    }
  };
  var h = {
    loopCreate: function loopCreate() {
      var i = this,
          e = i.params,
          t = i.$wrapperEl;
      t.children("." + e.slideClass + "." + e.slideDuplicateClass).remove();
      var s = t.children("." + e.slideClass);

      if (e.loopFillGroupWithBlank) {
        var a = e.slidesPerGroup - s.length % e.slidesPerGroup;

        if (a !== e.slidesPerGroup) {
          for (var r = 0; r < a; r += 1) {
            var n = L(f.createElement("div")).addClass(e.slideClass + " " + e.slideBlankClass);
            t.append(n);
          }

          s = t.children("." + e.slideClass);
        }
      }

      "auto" !== e.slidesPerView || e.loopedSlides || (e.loopedSlides = s.length), i.loopedSlides = parseInt(e.loopedSlides || e.slidesPerView, 10), i.loopedSlides += e.loopAdditionalSlides, i.loopedSlides > s.length && (i.loopedSlides = s.length);
      var o = [],
          l = [];
      s.each(function (e, t) {
        var a = L(t);
        e < i.loopedSlides && l.push(t), e < s.length && e >= s.length - i.loopedSlides && o.push(t), a.attr("data-swiper-slide-index", e);
      });

      for (var d = 0; d < l.length; d += 1) {
        t.append(L(l[d].cloneNode(!0)).addClass(e.slideDuplicateClass));
      }

      for (var p = o.length - 1; 0 <= p; p -= 1) {
        t.prepend(L(o[p].cloneNode(!0)).addClass(e.slideDuplicateClass));
      }
    },
    loopFix: function loopFix() {
      var e,
          t = this,
          a = t.params,
          i = t.activeIndex,
          s = t.slides,
          r = t.loopedSlides,
          n = t.allowSlidePrev,
          o = t.allowSlideNext,
          l = t.snapGrid,
          d = t.rtlTranslate;
      t.allowSlidePrev = !0, t.allowSlideNext = !0;
      var p = -l[i] - t.getTranslate();
      i < r ? (e = s.length - 3 * r + i, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p)) : ("auto" === a.slidesPerView && 2 * r <= i || i >= s.length - r) && (e = -s.length + i + r, e += r, t.slideTo(e, 0, !1, !0) && 0 !== p && t.setTranslate((d ? -t.translate : t.translate) - p));
      t.allowSlidePrev = n, t.allowSlideNext = o;
    },
    loopDestroy: function loopDestroy() {
      var e = this.$wrapperEl,
          t = this.params,
          a = this.slides;
      e.children("." + t.slideClass + "." + t.slideDuplicateClass + ",." + t.slideClass + "." + t.slideBlankClass).remove(), a.removeAttr("data-swiper-slide-index");
    }
  };
  var v = {
    setGrabCursor: function setGrabCursor(e) {
      if (!(te.touch || !this.params.simulateTouch || this.params.watchOverflow && this.isLocked)) {
        var t = this.el;
        t.style.cursor = "move", t.style.cursor = e ? "-webkit-grabbing" : "-webkit-grab", t.style.cursor = e ? "-moz-grabbin" : "-moz-grab", t.style.cursor = e ? "grabbing" : "grab";
      }
    },
    unsetGrabCursor: function unsetGrabCursor() {
      te.touch || this.params.watchOverflow && this.isLocked || (this.el.style.cursor = "");
    }
  };

  var m = {
    appendSlide: function appendSlide(e) {
      var t = this,
          a = t.$wrapperEl,
          i = t.params;
      if (i.loop && t.loopDestroy(), "object" == _typeof(e) && "length" in e) for (var s = 0; s < e.length; s += 1) {
        e[s] && a.append(e[s]);
      } else a.append(e);
      i.loop && t.loopCreate(), i.observer && te.observer || t.update();
    },
    prependSlide: function prependSlide(e) {
      var t = this,
          a = t.params,
          i = t.$wrapperEl,
          s = t.activeIndex;
      a.loop && t.loopDestroy();
      var r = s + 1;

      if ("object" == _typeof(e) && "length" in e) {
        for (var n = 0; n < e.length; n += 1) {
          e[n] && i.prepend(e[n]);
        }

        r = s + e.length;
      } else i.prepend(e);

      a.loop && t.loopCreate(), a.observer && te.observer || t.update(), t.slideTo(r, 0, !1);
    },
    addSlide: function addSlide(e, t) {
      var a = this,
          i = a.$wrapperEl,
          s = a.params,
          r = a.activeIndex;
      s.loop && (r -= a.loopedSlides, a.loopDestroy(), a.slides = i.children("." + s.slideClass));
      var n = a.slides.length;
      if (e <= 0) a.prependSlide(t);else if (n <= e) a.appendSlide(t);else {
        for (var o = e < r ? r + 1 : r, l = [], d = n - 1; e <= d; d -= 1) {
          var p = a.slides.eq(d);
          p.remove(), l.unshift(p);
        }

        if ("object" == _typeof(t) && "length" in t) {
          for (var c = 0; c < t.length; c += 1) {
            t[c] && i.append(t[c]);
          }

          o = e < r ? r + t.length : r;
        } else i.append(t);

        for (var u = 0; u < l.length; u += 1) {
          i.append(l[u]);
        }

        s.loop && a.loopCreate(), s.observer && te.observer || a.update(), s.loop ? a.slideTo(o + a.loopedSlides, 0, !1) : a.slideTo(o, 0, !1);
      }
    },
    removeSlide: function removeSlide(e) {
      var t = this,
          a = t.params,
          i = t.$wrapperEl,
          s = t.activeIndex;
      a.loop && (s -= t.loopedSlides, t.loopDestroy(), t.slides = i.children("." + a.slideClass));
      var r,
          n = s;

      if ("object" == _typeof(e) && "length" in e) {
        for (var o = 0; o < e.length; o += 1) {
          r = e[o], t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1);
        }

        n = Math.max(n, 0);
      } else r = e, t.slides[r] && t.slides.eq(r).remove(), r < n && (n -= 1), n = Math.max(n, 0);

      a.loop && t.loopCreate(), a.observer && te.observer || t.update(), a.loop ? t.slideTo(n + t.loopedSlides, 0, !1) : t.slideTo(n, 0, !1);
    },
    removeAllSlides: function removeAllSlides() {
      for (var e = [], t = 0; t < this.slides.length; t += 1) {
        e.push(t);
      }

      this.removeSlide(e);
    }
  },
      g = function () {
    var e = J.navigator.userAgent,
        t = {
      ios: !1,
      android: !1,
      androidChrome: !1,
      desktop: !1,
      windows: !1,
      iphone: !1,
      ipod: !1,
      ipad: !1,
      cordova: J.cordova || J.phonegap,
      phonegap: J.cordova || J.phonegap
    },
        a = e.match(/(Windows Phone);?[\s\/]+([\d.]+)?/),
        i = e.match(/(Android);?[\s\/]+([\d.]+)?/),
        s = e.match(/(iPad).*OS\s([\d_]+)/),
        r = e.match(/(iPod)(.*OS\s([\d_]+))?/),
        n = !s && e.match(/(iPhone\sOS|iOS)\s([\d_]+)/);

    if (a && (t.os = "windows", t.osVersion = a[2], t.windows = !0), i && !a && (t.os = "android", t.osVersion = i[2], t.android = !0, t.androidChrome = 0 <= e.toLowerCase().indexOf("chrome")), (s || n || r) && (t.os = "ios", t.ios = !0), n && !r && (t.osVersion = n[2].replace(/_/g, "."), t.iphone = !0), s && (t.osVersion = s[2].replace(/_/g, "."), t.ipad = !0), r && (t.osVersion = r[3] ? r[3].replace(/_/g, ".") : null, t.iphone = !0), t.ios && t.osVersion && 0 <= e.indexOf("Version/") && "10" === t.osVersion.split(".")[0] && (t.osVersion = e.toLowerCase().split("version/")[1].split(" ")[0]), t.desktop = !(t.os || t.android || t.webView), t.webView = (n || s || r) && e.match(/.*AppleWebKit(?!.*Safari)/i), t.os && "ios" === t.os) {
      var o = t.osVersion.split("."),
          l = f.querySelector('meta[name="viewport"]');
      t.minimalUi = !t.webView && (r || n) && (1 * o[0] == 7 ? 1 <= 1 * o[1] : 7 < 1 * o[0]) && l && 0 <= l.getAttribute("content").indexOf("minimal-ui");
    }

    return t.pixelRatio = J.devicePixelRatio || 1, t;
  }();

  function b() {
    var e = this,
        t = e.params,
        a = e.el;

    if (!a || 0 !== a.offsetWidth) {
      t.breakpoints && e.setBreakpoint();
      var i = e.allowSlideNext,
          s = e.allowSlidePrev,
          r = e.snapGrid;

      if (e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), t.freeMode) {
        var n = Math.min(Math.max(e.translate, e.maxTranslate()), e.minTranslate());
        e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses(), t.autoHeight && e.updateAutoHeight();
      } else e.updateSlidesClasses(), ("auto" === t.slidesPerView || 1 < t.slidesPerView) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);

      e.allowSlidePrev = s, e.allowSlideNext = i, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow();
    }
  }

  var w = {
    init: !0,
    direction: "horizontal",
    touchEventsTarget: "container",
    initialSlide: 0,
    speed: 300,
    preventInteractionOnTransition: !1,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    freeMode: !1,
    freeModeMomentum: !0,
    freeModeMomentumRatio: 1,
    freeModeMomentumBounce: !0,
    freeModeMomentumBounceRatio: 1,
    freeModeMomentumVelocityRatio: 1,
    freeModeSticky: !1,
    freeModeMinimumVelocity: .02,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsInverse: !1,
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerColumn: 1,
    slidesPerColumnFill: "column",
    slidesPerGroup: 1,
    centeredSlides: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    watchOverflow: !1,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 0,
    touchMoveStopPropagation: !0,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    watchSlidesVisibility: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    preloadImages: !0,
    updateOnImagesReady: !0,
    loop: !1,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopFillGroupWithBlank: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    containerModifierClass: "swiper-container-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-invisible-blank",
    slideActiveClass: "swiper-slide-active",
    slideDuplicateActiveClass: "swiper-slide-duplicate-active",
    slideVisibleClass: "swiper-slide-visible",
    slideDuplicateClass: "swiper-slide-duplicate",
    slideNextClass: "swiper-slide-next",
    slideDuplicateNextClass: "swiper-slide-duplicate-next",
    slidePrevClass: "swiper-slide-prev",
    slideDuplicatePrevClass: "swiper-slide-duplicate-prev",
    wrapperClass: "swiper-wrapper",
    runCallbacksOnInit: !0
  },
      y = {
    update: d,
    translate: p,
    transition: c,
    slide: u,
    loop: h,
    grabCursor: v,
    manipulation: m,
    events: {
      attachEvents: function attachEvents() {
        var e = this,
            t = e.params,
            a = e.touchEvents,
            i = e.el,
            s = e.wrapperEl;
        e.onTouchStart = function (e) {
          var t = this,
              a = t.touchEventsData,
              i = t.params,
              s = t.touches;

          if (!t.animating || !i.preventInteractionOnTransition) {
            var r = e;
            if (r.originalEvent && (r = r.originalEvent), a.isTouchEvent = "touchstart" === r.type, (a.isTouchEvent || !("which" in r) || 3 !== r.which) && !(!a.isTouchEvent && "button" in r && 0 < r.button || a.isTouched && a.isMoved)) if (i.noSwiping && L(r.target).closest(i.noSwipingSelector ? i.noSwipingSelector : "." + i.noSwipingClass)[0]) t.allowClick = !0;else if (!i.swipeHandler || L(r).closest(i.swipeHandler)[0]) {
              s.currentX = "touchstart" === r.type ? r.targetTouches[0].pageX : r.pageX, s.currentY = "touchstart" === r.type ? r.targetTouches[0].pageY : r.pageY;
              var n = s.currentX,
                  o = s.currentY,
                  l = i.edgeSwipeDetection || i.iOSEdgeSwipeDetection,
                  d = i.edgeSwipeThreshold || i.iOSEdgeSwipeThreshold;

              if (!l || !(n <= d || n >= J.screen.width - d)) {
                if (ee.extend(a, {
                  isTouched: !0,
                  isMoved: !1,
                  allowTouchCallbacks: !0,
                  isScrolling: void 0,
                  startMoving: void 0
                }), s.startX = n, s.startY = o, a.touchStartTime = ee.now(), t.allowClick = !0, t.updateSize(), t.swipeDirection = void 0, 0 < i.threshold && (a.allowThresholdMove = !1), "touchstart" !== r.type) {
                  var p = !0;
                  L(r.target).is(a.formElements) && (p = !1), f.activeElement && L(f.activeElement).is(a.formElements) && f.activeElement !== r.target && f.activeElement.blur();
                  var c = p && t.allowTouchMove && i.touchStartPreventDefault;
                  (i.touchStartForcePreventDefault || c) && r.preventDefault();
                }

                t.emit("touchStart", r);
              }
            }
          }
        }.bind(e), e.onTouchMove = function (e) {
          var t = this,
              a = t.touchEventsData,
              i = t.params,
              s = t.touches,
              r = t.rtlTranslate,
              n = e;

          if (n.originalEvent && (n = n.originalEvent), a.isTouched) {
            if (!a.isTouchEvent || "mousemove" !== n.type) {
              var o = "touchmove" === n.type ? n.targetTouches[0].pageX : n.pageX,
                  l = "touchmove" === n.type ? n.targetTouches[0].pageY : n.pageY;
              if (n.preventedByNestedSwiper) return s.startX = o, void (s.startY = l);
              if (!t.allowTouchMove) return t.allowClick = !1, void (a.isTouched && (ee.extend(s, {
                startX: o,
                startY: l,
                currentX: o,
                currentY: l
              }), a.touchStartTime = ee.now()));
              if (a.isTouchEvent && i.touchReleaseOnEdges && !i.loop) if (t.isVertical()) {
                if (l < s.startY && t.translate <= t.maxTranslate() || l > s.startY && t.translate >= t.minTranslate()) return a.isTouched = !1, void (a.isMoved = !1);
              } else if (o < s.startX && t.translate <= t.maxTranslate() || o > s.startX && t.translate >= t.minTranslate()) return;
              if (a.isTouchEvent && f.activeElement && n.target === f.activeElement && L(n.target).is(a.formElements)) return a.isMoved = !0, void (t.allowClick = !1);

              if (a.allowTouchCallbacks && t.emit("touchMove", n), !(n.targetTouches && 1 < n.targetTouches.length)) {
                s.currentX = o, s.currentY = l;
                var d,
                    p = s.currentX - s.startX,
                    c = s.currentY - s.startY;
                if (!(t.params.threshold && Math.sqrt(Math.pow(p, 2) + Math.pow(c, 2)) < t.params.threshold)) if (void 0 === a.isScrolling && (t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? a.isScrolling = !1 : 25 <= p * p + c * c && (d = 180 * Math.atan2(Math.abs(c), Math.abs(p)) / Math.PI, a.isScrolling = t.isHorizontal() ? d > i.touchAngle : 90 - d > i.touchAngle)), a.isScrolling && t.emit("touchMoveOpposite", n), void 0 === a.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (a.startMoving = !0)), a.isScrolling) a.isTouched = !1;else if (a.startMoving) {
                  t.allowClick = !1, n.preventDefault(), i.touchMoveStopPropagation && !i.nested && n.stopPropagation(), a.isMoved || (i.loop && t.loopFix(), a.startTranslate = t.getTranslate(), t.setTransition(0), t.animating && t.$wrapperEl.trigger("webkitTransitionEnd transitionend"), a.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit("sliderFirstMove", n)), t.emit("sliderMove", n), a.isMoved = !0;
                  var u = t.isHorizontal() ? p : c;
                  s.diff = u, u *= i.touchRatio, r && (u = -u), t.swipeDirection = 0 < u ? "prev" : "next", a.currentTranslate = u + a.startTranslate;
                  var h = !0,
                      v = i.resistanceRatio;

                  if (i.touchReleaseOnEdges && (v = 0), 0 < u && a.currentTranslate > t.minTranslate() ? (h = !1, i.resistance && (a.currentTranslate = t.minTranslate() - 1 + Math.pow(-t.minTranslate() + a.startTranslate + u, v))) : u < 0 && a.currentTranslate < t.maxTranslate() && (h = !1, i.resistance && (a.currentTranslate = t.maxTranslate() + 1 - Math.pow(t.maxTranslate() - a.startTranslate - u, v))), h && (n.preventedByNestedSwiper = !0), !t.allowSlideNext && "next" === t.swipeDirection && a.currentTranslate < a.startTranslate && (a.currentTranslate = a.startTranslate), !t.allowSlidePrev && "prev" === t.swipeDirection && a.currentTranslate > a.startTranslate && (a.currentTranslate = a.startTranslate), 0 < i.threshold) {
                    if (!(Math.abs(u) > i.threshold || a.allowThresholdMove)) return void (a.currentTranslate = a.startTranslate);
                    if (!a.allowThresholdMove) return a.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, a.currentTranslate = a.startTranslate, void (s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY);
                  }

                  i.followFinger && ((i.freeMode || i.watchSlidesProgress || i.watchSlidesVisibility) && (t.updateActiveIndex(), t.updateSlidesClasses()), i.freeMode && (0 === a.velocities.length && a.velocities.push({
                    position: s[t.isHorizontal() ? "startX" : "startY"],
                    time: a.touchStartTime
                  }), a.velocities.push({
                    position: s[t.isHorizontal() ? "currentX" : "currentY"],
                    time: ee.now()
                  })), t.updateProgress(a.currentTranslate), t.setTranslate(a.currentTranslate));
                }
              }
            }
          } else a.startMoving && a.isScrolling && t.emit("touchMoveOpposite", n);
        }.bind(e), e.onTouchEnd = function (e) {
          var t = this,
              a = t.touchEventsData,
              i = t.params,
              s = t.touches,
              r = t.rtlTranslate,
              n = t.$wrapperEl,
              o = t.slidesGrid,
              l = t.snapGrid,
              d = e;
          if (d.originalEvent && (d = d.originalEvent), a.allowTouchCallbacks && t.emit("touchEnd", d), a.allowTouchCallbacks = !1, !a.isTouched) return a.isMoved && i.grabCursor && t.setGrabCursor(!1), a.isMoved = !1, void (a.startMoving = !1);
          i.grabCursor && a.isMoved && a.isTouched && (!0 === t.allowSlideNext || !0 === t.allowSlidePrev) && t.setGrabCursor(!1);
          var p,
              c = ee.now(),
              u = c - a.touchStartTime;
          if (t.allowClick && (t.updateClickedSlide(d), t.emit("tap", d), u < 300 && 300 < c - a.lastClickTime && (a.clickTimeout && clearTimeout(a.clickTimeout), a.clickTimeout = ee.nextTick(function () {
            t && !t.destroyed && t.emit("click", d);
          }, 300)), u < 300 && c - a.lastClickTime < 300 && (a.clickTimeout && clearTimeout(a.clickTimeout), t.emit("doubleTap", d))), a.lastClickTime = ee.now(), ee.nextTick(function () {
            t.destroyed || (t.allowClick = !0);
          }), !a.isTouched || !a.isMoved || !t.swipeDirection || 0 === s.diff || a.currentTranslate === a.startTranslate) return a.isTouched = !1, a.isMoved = !1, void (a.startMoving = !1);

          if (a.isTouched = !1, a.isMoved = !1, a.startMoving = !1, p = i.followFinger ? r ? t.translate : -t.translate : -a.currentTranslate, i.freeMode) {
            if (p < -t.minTranslate()) return void t.slideTo(t.activeIndex);
            if (p > -t.maxTranslate()) return void (t.slides.length < l.length ? t.slideTo(l.length - 1) : t.slideTo(t.slides.length - 1));

            if (i.freeModeMomentum) {
              if (1 < a.velocities.length) {
                var h = a.velocities.pop(),
                    v = a.velocities.pop(),
                    f = h.position - v.position,
                    m = h.time - v.time;
                t.velocity = f / m, t.velocity /= 2, Math.abs(t.velocity) < i.freeModeMinimumVelocity && (t.velocity = 0), (150 < m || 300 < ee.now() - h.time) && (t.velocity = 0);
              } else t.velocity = 0;

              t.velocity *= i.freeModeMomentumVelocityRatio, a.velocities.length = 0;
              var g = 1e3 * i.freeModeMomentumRatio,
                  b = t.velocity * g,
                  w = t.translate + b;
              r && (w = -w);
              var y,
                  x,
                  T = !1,
                  E = 20 * Math.abs(t.velocity) * i.freeModeMomentumBounceRatio;
              if (w < t.maxTranslate()) i.freeModeMomentumBounce ? (w + t.maxTranslate() < -E && (w = t.maxTranslate() - E), y = t.maxTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.maxTranslate(), i.loop && i.centeredSlides && (x = !0);else if (w > t.minTranslate()) i.freeModeMomentumBounce ? (w - t.minTranslate() > E && (w = t.minTranslate() + E), y = t.minTranslate(), T = !0, a.allowMomentumBounce = !0) : w = t.minTranslate(), i.loop && i.centeredSlides && (x = !0);else if (i.freeModeSticky) {
                for (var S, C = 0; C < l.length; C += 1) {
                  if (l[C] > -w) {
                    S = C;
                    break;
                  }
                }

                w = -(w = Math.abs(l[S] - w) < Math.abs(l[S - 1] - w) || "next" === t.swipeDirection ? l[S] : l[S - 1]);
              }
              if (x && t.once("transitionEnd", function () {
                t.loopFix();
              }), 0 !== t.velocity) g = r ? Math.abs((-w - t.translate) / t.velocity) : Math.abs((w - t.translate) / t.velocity);else if (i.freeModeSticky) return void t.slideToClosest();
              i.freeModeMomentumBounce && T ? (t.updateProgress(y), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating = !0, n.transitionEnd(function () {
                t && !t.destroyed && a.allowMomentumBounce && (t.emit("momentumBounce"), t.setTransition(i.speed), t.setTranslate(y), n.transitionEnd(function () {
                  t && !t.destroyed && t.transitionEnd();
                }));
              })) : t.velocity ? (t.updateProgress(w), t.setTransition(g), t.setTranslate(w), t.transitionStart(!0, t.swipeDirection), t.animating || (t.animating = !0, n.transitionEnd(function () {
                t && !t.destroyed && t.transitionEnd();
              }))) : t.updateProgress(w), t.updateActiveIndex(), t.updateSlidesClasses();
            } else if (i.freeModeSticky) return void t.slideToClosest();

            (!i.freeModeMomentum || u >= i.longSwipesMs) && (t.updateProgress(), t.updateActiveIndex(), t.updateSlidesClasses());
          } else {
            for (var M = 0, z = t.slidesSizesGrid[0], P = 0; P < o.length; P += i.slidesPerGroup) {
              void 0 !== o[P + i.slidesPerGroup] ? p >= o[P] && p < o[P + i.slidesPerGroup] && (z = o[(M = P) + i.slidesPerGroup] - o[P]) : p >= o[P] && (M = P, z = o[o.length - 1] - o[o.length - 2]);
            }

            var k = (p - o[M]) / z;

            if (u > i.longSwipesMs) {
              if (!i.longSwipes) return void t.slideTo(t.activeIndex);
              "next" === t.swipeDirection && (k >= i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M)), "prev" === t.swipeDirection && (k > 1 - i.longSwipesRatio ? t.slideTo(M + i.slidesPerGroup) : t.slideTo(M));
            } else {
              if (!i.shortSwipes) return void t.slideTo(t.activeIndex);
              "next" === t.swipeDirection && t.slideTo(M + i.slidesPerGroup), "prev" === t.swipeDirection && t.slideTo(M);
            }
          }
        }.bind(e), e.onClick = function (e) {
          this.allowClick || (this.params.preventClicks && e.preventDefault(), this.params.preventClicksPropagation && this.animating && (e.stopPropagation(), e.stopImmediatePropagation()));
        }.bind(e);
        var r = "container" === t.touchEventsTarget ? i : s,
            n = !!t.nested;

        if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
          if (te.touch) {
            var o = !("touchstart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
              passive: !0,
              capture: !1
            };
            r.addEventListener(a.start, e.onTouchStart, o), r.addEventListener(a.move, e.onTouchMove, te.passiveListener ? {
              passive: !1,
              capture: n
            } : n), r.addEventListener(a.end, e.onTouchEnd, o);
          }

          (t.simulateTouch && !g.ios && !g.android || t.simulateTouch && !te.touch && g.ios) && (r.addEventListener("mousedown", e.onTouchStart, !1), f.addEventListener("mousemove", e.onTouchMove, n), f.addEventListener("mouseup", e.onTouchEnd, !1));
        } else r.addEventListener(a.start, e.onTouchStart, !1), f.addEventListener(a.move, e.onTouchMove, n), f.addEventListener(a.end, e.onTouchEnd, !1);

        (t.preventClicks || t.preventClicksPropagation) && r.addEventListener("click", e.onClick, !0), e.on(g.ios || g.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", b, !0);
      },
      detachEvents: function detachEvents() {
        var e = this,
            t = e.params,
            a = e.touchEvents,
            i = e.el,
            s = e.wrapperEl,
            r = "container" === t.touchEventsTarget ? i : s,
            n = !!t.nested;

        if (te.touch || !te.pointerEvents && !te.prefixedPointerEvents) {
          if (te.touch) {
            var o = !("onTouchStart" !== a.start || !te.passiveListener || !t.passiveListeners) && {
              passive: !0,
              capture: !1
            };
            r.removeEventListener(a.start, e.onTouchStart, o), r.removeEventListener(a.move, e.onTouchMove, n), r.removeEventListener(a.end, e.onTouchEnd, o);
          }

          (t.simulateTouch && !g.ios && !g.android || t.simulateTouch && !te.touch && g.ios) && (r.removeEventListener("mousedown", e.onTouchStart, !1), f.removeEventListener("mousemove", e.onTouchMove, n), f.removeEventListener("mouseup", e.onTouchEnd, !1));
        } else r.removeEventListener(a.start, e.onTouchStart, !1), f.removeEventListener(a.move, e.onTouchMove, n), f.removeEventListener(a.end, e.onTouchEnd, !1);

        (t.preventClicks || t.preventClicksPropagation) && r.removeEventListener("click", e.onClick, !0), e.off(g.ios || g.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", b);
      }
    },
    breakpoints: {
      setBreakpoint: function setBreakpoint() {
        var e = this,
            t = e.activeIndex,
            a = e.initialized,
            i = e.loopedSlides;
        void 0 === i && (i = 0);
        var s = e.params,
            r = s.breakpoints;

        if (r && (!r || 0 !== Object.keys(r).length)) {
          var n = e.getBreakpoint(r);

          if (n && e.currentBreakpoint !== n) {
            var o = n in r ? r[n] : void 0;
            o && ["slidesPerView", "spaceBetween", "slidesPerGroup"].forEach(function (e) {
              var t = o[e];
              void 0 !== t && (o[e] = "slidesPerView" !== e || "AUTO" !== t && "auto" !== t ? "slidesPerView" === e ? parseFloat(t) : parseInt(t, 10) : "auto");
            });
            var l = o || e.originalParams,
                d = l.direction && l.direction !== s.direction,
                p = s.loop && (l.slidesPerView !== s.slidesPerView || d);
            d && a && e.changeDirection(), ee.extend(e.params, l), ee.extend(e, {
              allowTouchMove: e.params.allowTouchMove,
              allowSlideNext: e.params.allowSlideNext,
              allowSlidePrev: e.params.allowSlidePrev
            }), e.currentBreakpoint = n, p && a && (e.loopDestroy(), e.loopCreate(), e.updateSlides(), e.slideTo(t - i + e.loopedSlides, 0, !1)), e.emit("breakpoint", l);
          }
        }
      },
      getBreakpoint: function getBreakpoint(e) {
        if (e) {
          var t = !1,
              a = [];
          Object.keys(e).forEach(function (e) {
            a.push(e);
          }), a.sort(function (e, t) {
            return parseInt(e, 10) - parseInt(t, 10);
          });

          for (var i = 0; i < a.length; i += 1) {
            var s = a[i];
            this.params.breakpointsInverse ? s <= J.innerWidth && (t = s) : s >= J.innerWidth && !t && (t = s);
          }

          return t || "max";
        }
      }
    },
    checkOverflow: {
      checkOverflow: function checkOverflow() {
        var e = this,
            t = e.isLocked;
        e.isLocked = 1 === e.snapGrid.length, e.allowSlideNext = !e.isLocked, e.allowSlidePrev = !e.isLocked, t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock"), t && t !== e.isLocked && (e.isEnd = !1, e.navigation.update());
      }
    },
    classes: {
      addClasses: function addClasses() {
        var t = this.classNames,
            a = this.params,
            e = this.rtl,
            i = this.$el,
            s = [];
        s.push("initialized"), s.push(a.direction), a.freeMode && s.push("free-mode"), te.flexbox || s.push("no-flexbox"), a.autoHeight && s.push("autoheight"), e && s.push("rtl"), 1 < a.slidesPerColumn && s.push("multirow"), g.android && s.push("android"), g.ios && s.push("ios"), (I.isIE || I.isEdge) && (te.pointerEvents || te.prefixedPointerEvents) && s.push("wp8-" + a.direction), s.forEach(function (e) {
          t.push(a.containerModifierClass + e);
        }), i.addClass(t.join(" "));
      },
      removeClasses: function removeClasses() {
        var e = this.$el,
            t = this.classNames;
        e.removeClass(t.join(" "));
      }
    },
    images: {
      loadImage: function loadImage(e, t, a, i, s, r) {
        var n;

        function o() {
          r && r();
        }

        e.complete && s ? o() : t ? ((n = new J.Image()).onload = o, n.onerror = o, i && (n.sizes = i), a && (n.srcset = a), t && (n.src = t)) : o();
      },
      preloadImages: function preloadImages() {
        var e = this;

        function t() {
          null != e && e && !e.destroyed && (void 0 !== e.imagesLoaded && (e.imagesLoaded += 1), e.imagesLoaded === e.imagesToLoad.length && (e.params.updateOnImagesReady && e.update(), e.emit("imagesReady")));
        }

        e.imagesToLoad = e.$el.find("img");

        for (var a = 0; a < e.imagesToLoad.length; a += 1) {
          var i = e.imagesToLoad[a];
          e.loadImage(i, i.currentSrc || i.getAttribute("src"), i.srcset || i.getAttribute("srcset"), i.sizes || i.getAttribute("sizes"), !0, t);
        }
      }
    }
  },
      x = {},
      T = function (u) {
    function h() {
      for (var e, t, s, a = [], i = arguments.length; i--;) {
        a[i] = arguments[i];
      }

      1 === a.length && a[0].constructor && a[0].constructor === Object ? s = a[0] : (t = (e = a)[0], s = e[1]), s || (s = {}), s = ee.extend({}, s), t && !s.el && (s.el = t), u.call(this, s), Object.keys(y).forEach(function (t) {
        Object.keys(y[t]).forEach(function (e) {
          h.prototype[e] || (h.prototype[e] = y[t][e]);
        });
      });
      var r = this;
      void 0 === r.modules && (r.modules = {}), Object.keys(r.modules).forEach(function (e) {
        var t = r.modules[e];

        if (t.params) {
          var a = Object.keys(t.params)[0],
              i = t.params[a];
          if ("object" != _typeof(i) || null === i) return;
          if (!(a in s && "enabled" in i)) return;
          !0 === s[a] && (s[a] = {
            enabled: !0
          }), "object" != _typeof(s[a]) || "enabled" in s[a] || (s[a].enabled = !0), s[a] || (s[a] = {
            enabled: !1
          });
        }
      });
      var n = ee.extend({}, w);
      r.useModulesParams(n), r.params = ee.extend({}, n, x, s), r.originalParams = ee.extend({}, r.params), r.passedParams = ee.extend({}, s);
      var o = (r.$ = L)(r.params.el);

      if (t = o[0]) {
        if (1 < o.length) {
          var l = [];
          return o.each(function (e, t) {
            var a = ee.extend({}, s, {
              el: t
            });
            l.push(new h(a));
          }), l;
        }

        t.swiper = r, o.data("swiper", r);
        var d,
            p,
            c = o.children("." + r.params.wrapperClass);
        return ee.extend(r, {
          $el: o,
          el: t,
          $wrapperEl: c,
          wrapperEl: c[0],
          classNames: [],
          slides: L(),
          slidesGrid: [],
          snapGrid: [],
          slidesSizesGrid: [],
          isHorizontal: function isHorizontal() {
            return "horizontal" === r.params.direction;
          },
          isVertical: function isVertical() {
            return "vertical" === r.params.direction;
          },
          rtl: "rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction"),
          rtlTranslate: "horizontal" === r.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === o.css("direction")),
          wrongRTL: "-webkit-box" === c.css("display"),
          activeIndex: 0,
          realIndex: 0,
          isBeginning: !0,
          isEnd: !1,
          translate: 0,
          previousTranslate: 0,
          progress: 0,
          velocity: 0,
          animating: !1,
          allowSlideNext: r.params.allowSlideNext,
          allowSlidePrev: r.params.allowSlidePrev,
          touchEvents: (d = ["touchstart", "touchmove", "touchend"], p = ["mousedown", "mousemove", "mouseup"], te.pointerEvents ? p = ["pointerdown", "pointermove", "pointerup"] : te.prefixedPointerEvents && (p = ["MSPointerDown", "MSPointerMove", "MSPointerUp"]), r.touchEventsTouch = {
            start: d[0],
            move: d[1],
            end: d[2]
          }, r.touchEventsDesktop = {
            start: p[0],
            move: p[1],
            end: p[2]
          }, te.touch || !r.params.simulateTouch ? r.touchEventsTouch : r.touchEventsDesktop),
          touchEventsData: {
            isTouched: void 0,
            isMoved: void 0,
            allowTouchCallbacks: void 0,
            touchStartTime: void 0,
            isScrolling: void 0,
            currentTranslate: void 0,
            startTranslate: void 0,
            allowThresholdMove: void 0,
            formElements: "input, select, option, textarea, button, video",
            lastClickTime: ee.now(),
            clickTimeout: void 0,
            velocities: [],
            allowMomentumBounce: void 0,
            isTouchEvent: void 0,
            startMoving: void 0
          },
          allowClick: !0,
          allowTouchMove: r.params.allowTouchMove,
          touches: {
            startX: 0,
            startY: 0,
            currentX: 0,
            currentY: 0,
            diff: 0
          },
          imagesToLoad: [],
          imagesLoaded: 0
        }), r.useModules(), r.params.init && r.init(), r;
      }
    }

    u && (h.__proto__ = u);
    var e = {
      extendedDefaults: {
        configurable: !0
      },
      defaults: {
        configurable: !0
      },
      Class: {
        configurable: !0
      },
      $: {
        configurable: !0
      }
    };
    return ((h.prototype = Object.create(u && u.prototype)).constructor = h).prototype.slidesPerViewDynamic = function () {
      var e = this,
          t = e.params,
          a = e.slides,
          i = e.slidesGrid,
          s = e.size,
          r = e.activeIndex,
          n = 1;

      if (t.centeredSlides) {
        for (var o, l = a[r].swiperSlideSize, d = r + 1; d < a.length; d += 1) {
          a[d] && !o && (n += 1, s < (l += a[d].swiperSlideSize) && (o = !0));
        }

        for (var p = r - 1; 0 <= p; p -= 1) {
          a[p] && !o && (n += 1, s < (l += a[p].swiperSlideSize) && (o = !0));
        }
      } else for (var c = r + 1; c < a.length; c += 1) {
        i[c] - i[r] < s && (n += 1);
      }

      return n;
    }, h.prototype.update = function () {
      var a = this;

      if (a && !a.destroyed) {
        var e = a.snapGrid,
            t = a.params;
        t.breakpoints && a.setBreakpoint(), a.updateSize(), a.updateSlides(), a.updateProgress(), a.updateSlidesClasses(), a.params.freeMode ? (i(), a.params.autoHeight && a.updateAutoHeight()) : (("auto" === a.params.slidesPerView || 1 < a.params.slidesPerView) && a.isEnd && !a.params.centeredSlides ? a.slideTo(a.slides.length - 1, 0, !1, !0) : a.slideTo(a.activeIndex, 0, !1, !0)) || i(), t.watchOverflow && e !== a.snapGrid && a.checkOverflow(), a.emit("update");
      }

      function i() {
        var e = a.rtlTranslate ? -1 * a.translate : a.translate,
            t = Math.min(Math.max(e, a.maxTranslate()), a.minTranslate());
        a.setTranslate(t), a.updateActiveIndex(), a.updateSlidesClasses();
      }
    }, h.prototype.changeDirection = function (a, e) {
      void 0 === e && (e = !0);
      var t = this,
          i = t.params.direction;
      return a || (a = "horizontal" === i ? "vertical" : "horizontal"), a === i || "horizontal" !== a && "vertical" !== a || ("vertical" === i && (t.$el.removeClass(t.params.containerModifierClass + "vertical wp8-vertical").addClass("" + t.params.containerModifierClass + a), (I.isIE || I.isEdge) && (te.pointerEvents || te.prefixedPointerEvents) && t.$el.addClass(t.params.containerModifierClass + "wp8-" + a)), "horizontal" === i && (t.$el.removeClass(t.params.containerModifierClass + "horizontal wp8-horizontal").addClass("" + t.params.containerModifierClass + a), (I.isIE || I.isEdge) && (te.pointerEvents || te.prefixedPointerEvents) && t.$el.addClass(t.params.containerModifierClass + "wp8-" + a)), t.params.direction = a, t.slides.each(function (e, t) {
        "vertical" === a ? t.style.width = "" : t.style.height = "";
      }), t.emit("changeDirection"), e && t.update()), t;
    }, h.prototype.init = function () {
      var e = this;
      e.initialized || (e.emit("beforeInit"), e.params.breakpoints && e.setBreakpoint(), e.addClasses(), e.params.loop && e.loopCreate(), e.updateSize(), e.updateSlides(), e.params.watchOverflow && e.checkOverflow(), e.params.grabCursor && e.setGrabCursor(), e.params.preloadImages && e.preloadImages(), e.params.loop ? e.slideTo(e.params.initialSlide + e.loopedSlides, 0, e.params.runCallbacksOnInit) : e.slideTo(e.params.initialSlide, 0, e.params.runCallbacksOnInit), e.attachEvents(), e.initialized = !0, e.emit("init"));
    }, h.prototype.destroy = function (e, t) {
      void 0 === e && (e = !0), void 0 === t && (t = !0);
      var a = this,
          i = a.params,
          s = a.$el,
          r = a.$wrapperEl,
          n = a.slides;
      return void 0 === a.params || a.destroyed || (a.emit("beforeDestroy"), a.initialized = !1, a.detachEvents(), i.loop && a.loopDestroy(), t && (a.removeClasses(), s.removeAttr("style"), r.removeAttr("style"), n && n.length && n.removeClass([i.slideVisibleClass, i.slideActiveClass, i.slideNextClass, i.slidePrevClass].join(" ")).removeAttr("style").removeAttr("data-swiper-slide-index").removeAttr("data-swiper-column").removeAttr("data-swiper-row")), a.emit("destroy"), Object.keys(a.eventsListeners).forEach(function (e) {
        a.off(e);
      }), !1 !== e && (a.$el[0].swiper = null, a.$el.data("swiper", null), ee.deleteProps(a)), a.destroyed = !0), null;
    }, h.extendDefaults = function (e) {
      ee.extend(x, e);
    }, e.extendedDefaults.get = function () {
      return x;
    }, e.defaults.get = function () {
      return w;
    }, e.Class.get = function () {
      return u;
    }, e.$.get = function () {
      return L;
    }, Object.defineProperties(h, e), h;
  }(n),
      E = {
    name: "device",
    proto: {
      device: g
    },
    static: {
      device: g
    }
  },
      S = {
    name: "support",
    proto: {
      support: te
    },
    static: {
      support: te
    }
  },
      C = {
    name: "browser",
    proto: {
      browser: I
    },
    static: {
      browser: I
    }
  },
      M = {
    name: "resize",
    create: function create() {
      var e = this;
      ee.extend(e, {
        resize: {
          resizeHandler: function resizeHandler() {
            e && !e.destroyed && e.initialized && (e.emit("beforeResize"), e.emit("resize"));
          },
          orientationChangeHandler: function orientationChangeHandler() {
            e && !e.destroyed && e.initialized && e.emit("orientationchange");
          }
        }
      });
    },
    on: {
      init: function init() {
        J.addEventListener("resize", this.resize.resizeHandler), J.addEventListener("orientationchange", this.resize.orientationChangeHandler);
      },
      destroy: function destroy() {
        J.removeEventListener("resize", this.resize.resizeHandler), J.removeEventListener("orientationchange", this.resize.orientationChangeHandler);
      }
    }
  },
      z = {
    func: J.MutationObserver || J.WebkitMutationObserver,
    attach: function attach(e, t) {
      void 0 === t && (t = {});
      var a = this,
          i = new z.func(function (e) {
        if (1 !== e.length) {
          var t = function t() {
            a.emit("observerUpdate", e[0]);
          };

          J.requestAnimationFrame ? J.requestAnimationFrame(t) : J.setTimeout(t, 0);
        } else a.emit("observerUpdate", e[0]);
      });
      i.observe(e, {
        attributes: void 0 === t.attributes || t.attributes,
        childList: void 0 === t.childList || t.childList,
        characterData: void 0 === t.characterData || t.characterData
      }), a.observer.observers.push(i);
    },
    init: function init() {
      var e = this;

      if (te.observer && e.params.observer) {
        if (e.params.observeParents) for (var t = e.$el.parents(), a = 0; a < t.length; a += 1) {
          e.observer.attach(t[a]);
        }
        e.observer.attach(e.$el[0], {
          childList: e.params.observeSlideChildren
        }), e.observer.attach(e.$wrapperEl[0], {
          attributes: !1
        });
      }
    },
    destroy: function destroy() {
      this.observer.observers.forEach(function (e) {
        e.disconnect();
      }), this.observer.observers = [];
    }
  },
      P = {
    name: "observer",
    params: {
      observer: !1,
      observeParents: !1,
      observeSlideChildren: !1
    },
    create: function create() {
      ee.extend(this, {
        observer: {
          init: z.init.bind(this),
          attach: z.attach.bind(this),
          destroy: z.destroy.bind(this),
          observers: []
        }
      });
    },
    on: {
      init: function init() {
        this.observer.init();
      },
      destroy: function destroy() {
        this.observer.destroy();
      }
    }
  },
      k = {
    update: function update(e) {
      var t = this,
          a = t.params,
          i = a.slidesPerView,
          s = a.slidesPerGroup,
          r = a.centeredSlides,
          n = t.params.virtual,
          o = n.addSlidesBefore,
          l = n.addSlidesAfter,
          d = t.virtual,
          p = d.from,
          c = d.to,
          u = d.slides,
          h = d.slidesGrid,
          v = d.renderSlide,
          f = d.offset;
      t.updateActiveIndex();
      var m,
          g,
          b,
          w = t.activeIndex || 0;
      m = t.rtlTranslate ? "right" : t.isHorizontal() ? "left" : "top", r ? (g = Math.floor(i / 2) + s + o, b = Math.floor(i / 2) + s + l) : (g = i + (s - 1) + o, b = s + l);
      var y = Math.max((w || 0) - b, 0),
          x = Math.min((w || 0) + g, u.length - 1),
          T = (t.slidesGrid[y] || 0) - (t.slidesGrid[0] || 0);

      function E() {
        t.updateSlides(), t.updateProgress(), t.updateSlidesClasses(), t.lazy && t.params.lazy.enabled && t.lazy.load();
      }

      if (ee.extend(t.virtual, {
        from: y,
        to: x,
        offset: T,
        slidesGrid: t.slidesGrid
      }), p === y && c === x && !e) return t.slidesGrid !== h && T !== f && t.slides.css(m, T + "px"), void t.updateProgress();
      if (t.params.virtual.renderExternal) return t.params.virtual.renderExternal.call(t, {
        offset: T,
        from: y,
        to: x,
        slides: function () {
          for (var e = [], t = y; t <= x; t += 1) {
            e.push(u[t]);
          }

          return e;
        }()
      }), void E();
      var S = [],
          C = [];
      if (e) t.$wrapperEl.find("." + t.params.slideClass).remove();else for (var M = p; M <= c; M += 1) {
        (M < y || x < M) && t.$wrapperEl.find("." + t.params.slideClass + '[data-swiper-slide-index="' + M + '"]').remove();
      }

      for (var z = 0; z < u.length; z += 1) {
        y <= z && z <= x && (void 0 === c || e ? C.push(z) : (c < z && C.push(z), z < p && S.push(z)));
      }

      C.forEach(function (e) {
        t.$wrapperEl.append(v(u[e], e));
      }), S.sort(function (e, t) {
        return t - e;
      }).forEach(function (e) {
        t.$wrapperEl.prepend(v(u[e], e));
      }), t.$wrapperEl.children(".swiper-slide").css(m, T + "px"), E();
    },
    renderSlide: function renderSlide(e, t) {
      var a = this,
          i = a.params.virtual;
      if (i.cache && a.virtual.cache[t]) return a.virtual.cache[t];
      var s = i.renderSlide ? L(i.renderSlide.call(a, e, t)) : L('<div class="' + a.params.slideClass + '" data-swiper-slide-index="' + t + '">' + e + "</div>");
      return s.attr("data-swiper-slide-index") || s.attr("data-swiper-slide-index", t), i.cache && (a.virtual.cache[t] = s), s;
    },
    appendSlide: function appendSlide(e) {
      if ("object" == _typeof(e) && "length" in e) for (var t = 0; t < e.length; t += 1) {
        e[t] && this.virtual.slides.push(e[t]);
      } else this.virtual.slides.push(e);
      this.virtual.update(!0);
    },
    prependSlide: function prependSlide(e) {
      var t = this,
          a = t.activeIndex,
          i = a + 1,
          s = 1;

      if (Array.isArray(e)) {
        for (var r = 0; r < e.length; r += 1) {
          e[r] && t.virtual.slides.unshift(e[r]);
        }

        i = a + e.length, s = e.length;
      } else t.virtual.slides.unshift(e);

      if (t.params.virtual.cache) {
        var n = t.virtual.cache,
            o = {};
        Object.keys(n).forEach(function (e) {
          o[parseInt(e, 10) + s] = n[e];
        }), t.virtual.cache = o;
      }

      t.virtual.update(!0), t.slideTo(i, 0);
    },
    removeSlide: function removeSlide(e) {
      var t = this;

      if (null != e) {
        var a = t.activeIndex;
        if (Array.isArray(e)) for (var i = e.length - 1; 0 <= i; i -= 1) {
          t.virtual.slides.splice(e[i], 1), t.params.virtual.cache && delete t.virtual.cache[e[i]], e[i] < a && (a -= 1), a = Math.max(a, 0);
        } else t.virtual.slides.splice(e, 1), t.params.virtual.cache && delete t.virtual.cache[e], e < a && (a -= 1), a = Math.max(a, 0);
        t.virtual.update(!0), t.slideTo(a, 0);
      }
    },
    removeAllSlides: function removeAllSlides() {
      var e = this;
      e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), e.virtual.update(!0), e.slideTo(0, 0);
    }
  },
      $ = {
    name: "virtual",
    params: {
      virtual: {
        enabled: !1,
        slides: [],
        cache: !0,
        renderSlide: null,
        renderExternal: null,
        addSlidesBefore: 0,
        addSlidesAfter: 0
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        virtual: {
          update: k.update.bind(e),
          appendSlide: k.appendSlide.bind(e),
          prependSlide: k.prependSlide.bind(e),
          removeSlide: k.removeSlide.bind(e),
          removeAllSlides: k.removeAllSlides.bind(e),
          renderSlide: k.renderSlide.bind(e),
          slides: e.params.virtual.slides,
          cache: {}
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this;

        if (e.params.virtual.enabled) {
          e.classNames.push(e.params.containerModifierClass + "virtual");
          var t = {
            watchSlidesProgress: !0
          };
          ee.extend(e.params, t), ee.extend(e.originalParams, t), e.params.initialSlide || e.virtual.update();
        }
      },
      setTranslate: function setTranslate() {
        this.params.virtual.enabled && this.virtual.update();
      }
    }
  },
      D = {
    handle: function handle(e) {
      var t = this,
          a = t.rtlTranslate,
          i = e;
      i.originalEvent && (i = i.originalEvent);
      var s = i.keyCode || i.charCode;
      if (!t.allowSlideNext && (t.isHorizontal() && 39 === s || t.isVertical() && 40 === s)) return !1;
      if (!t.allowSlidePrev && (t.isHorizontal() && 37 === s || t.isVertical() && 38 === s)) return !1;

      if (!(i.shiftKey || i.altKey || i.ctrlKey || i.metaKey || f.activeElement && f.activeElement.nodeName && ("input" === f.activeElement.nodeName.toLowerCase() || "textarea" === f.activeElement.nodeName.toLowerCase()))) {
        if (t.params.keyboard.onlyInViewport && (37 === s || 39 === s || 38 === s || 40 === s)) {
          var r = !1;
          if (0 < t.$el.parents("." + t.params.slideClass).length && 0 === t.$el.parents("." + t.params.slideActiveClass).length) return;
          var n = J.innerWidth,
              o = J.innerHeight,
              l = t.$el.offset();
          a && (l.left -= t.$el[0].scrollLeft);

          for (var d = [[l.left, l.top], [l.left + t.width, l.top], [l.left, l.top + t.height], [l.left + t.width, l.top + t.height]], p = 0; p < d.length; p += 1) {
            var c = d[p];
            0 <= c[0] && c[0] <= n && 0 <= c[1] && c[1] <= o && (r = !0);
          }

          if (!r) return;
        }

        t.isHorizontal() ? (37 !== s && 39 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), (39 === s && !a || 37 === s && a) && t.slideNext(), (37 === s && !a || 39 === s && a) && t.slidePrev()) : (38 !== s && 40 !== s || (i.preventDefault ? i.preventDefault() : i.returnValue = !1), 40 === s && t.slideNext(), 38 === s && t.slidePrev()), t.emit("keyPress", s);
      }
    },
    enable: function enable() {
      this.keyboard.enabled || (L(f).on("keydown", this.keyboard.handle), this.keyboard.enabled = !0);
    },
    disable: function disable() {
      this.keyboard.enabled && (L(f).off("keydown", this.keyboard.handle), this.keyboard.enabled = !1);
    }
  },
      O = {
    name: "keyboard",
    params: {
      keyboard: {
        enabled: !1,
        onlyInViewport: !0
      }
    },
    create: function create() {
      ee.extend(this, {
        keyboard: {
          enabled: !1,
          enable: D.enable.bind(this),
          disable: D.disable.bind(this),
          handle: D.handle.bind(this)
        }
      });
    },
    on: {
      init: function init() {
        this.params.keyboard.enabled && this.keyboard.enable();
      },
      destroy: function destroy() {
        this.keyboard.enabled && this.keyboard.disable();
      }
    }
  };

  var A = {
    lastScrollTime: ee.now(),
    event: -1 < J.navigator.userAgent.indexOf("firefox") ? "DOMMouseScroll" : function () {
      var e = "onwheel",
          t = (e in f);

      if (!t) {
        var a = f.createElement("div");
        a.setAttribute(e, "return;"), t = "function" == typeof a[e];
      }

      return !t && f.implementation && f.implementation.hasFeature && !0 !== f.implementation.hasFeature("", "") && (t = f.implementation.hasFeature("Events.wheel", "3.0")), t;
    }() ? "wheel" : "mousewheel",
    normalize: function normalize(e) {
      var t = 0,
          a = 0,
          i = 0,
          s = 0;
      return "detail" in e && (a = e.detail), "wheelDelta" in e && (a = -e.wheelDelta / 120), "wheelDeltaY" in e && (a = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (t = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (t = a, a = 0), i = 10 * t, s = 10 * a, "deltaY" in e && (s = e.deltaY), "deltaX" in e && (i = e.deltaX), (i || s) && e.deltaMode && (1 === e.deltaMode ? (i *= 40, s *= 40) : (i *= 800, s *= 800)), i && !t && (t = i < 1 ? -1 : 1), s && !a && (a = s < 1 ? -1 : 1), {
        spinX: t,
        spinY: a,
        pixelX: i,
        pixelY: s
      };
    },
    handleMouseEnter: function handleMouseEnter() {
      this.mouseEntered = !0;
    },
    handleMouseLeave: function handleMouseLeave() {
      this.mouseEntered = !1;
    },
    handle: function handle(e) {
      var t = e,
          a = this,
          i = a.params.mousewheel;
      if (!a.mouseEntered && !i.releaseOnEdges) return !0;
      t.originalEvent && (t = t.originalEvent);
      var s = 0,
          r = a.rtlTranslate ? -1 : 1,
          n = A.normalize(t);
      if (i.forceToAxis) {
        if (a.isHorizontal()) {
          if (!(Math.abs(n.pixelX) > Math.abs(n.pixelY))) return !0;
          s = n.pixelX * r;
        } else {
          if (!(Math.abs(n.pixelY) > Math.abs(n.pixelX))) return !0;
          s = n.pixelY;
        }
      } else s = Math.abs(n.pixelX) > Math.abs(n.pixelY) ? -n.pixelX * r : -n.pixelY;
      if (0 === s) return !0;

      if (i.invert && (s = -s), a.params.freeMode) {
        a.params.loop && a.loopFix();
        var o = a.getTranslate() + s * i.sensitivity,
            l = a.isBeginning,
            d = a.isEnd;
        if (o >= a.minTranslate() && (o = a.minTranslate()), o <= a.maxTranslate() && (o = a.maxTranslate()), a.setTransition(0), a.setTranslate(o), a.updateProgress(), a.updateActiveIndex(), a.updateSlidesClasses(), (!l && a.isBeginning || !d && a.isEnd) && a.updateSlidesClasses(), a.params.freeModeSticky && (clearTimeout(a.mousewheel.timeout), a.mousewheel.timeout = ee.nextTick(function () {
          a.slideToClosest();
        }, 300)), a.emit("scroll", t), a.params.autoplay && a.params.autoplayDisableOnInteraction && a.autoplay.stop(), o === a.minTranslate() || o === a.maxTranslate()) return !0;
      } else {
        if (60 < ee.now() - a.mousewheel.lastScrollTime) if (s < 0) {
          if (a.isEnd && !a.params.loop || a.animating) {
            if (i.releaseOnEdges) return !0;
          } else a.slideNext(), a.emit("scroll", t);
        } else if (a.isBeginning && !a.params.loop || a.animating) {
          if (i.releaseOnEdges) return !0;
        } else a.slidePrev(), a.emit("scroll", t);
        a.mousewheel.lastScrollTime = new J.Date().getTime();
      }

      return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1;
    },
    enable: function enable() {
      var e = this;
      if (!A.event) return !1;
      if (e.mousewheel.enabled) return !1;
      var t = e.$el;
      return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.on("mouseenter", e.mousewheel.handleMouseEnter), t.on("mouseleave", e.mousewheel.handleMouseLeave), t.on(A.event, e.mousewheel.handle), e.mousewheel.enabled = !0;
    },
    disable: function disable() {
      var e = this;
      if (!A.event) return !1;
      if (!e.mousewheel.enabled) return !1;
      var t = e.$el;
      return "container" !== e.params.mousewheel.eventsTarged && (t = L(e.params.mousewheel.eventsTarged)), t.off(A.event, e.mousewheel.handle), !(e.mousewheel.enabled = !1);
    }
  },
      H = {
    update: function update() {
      var e = this,
          t = e.params.navigation;

      if (!e.params.loop) {
        var a = e.navigation,
            i = a.$nextEl,
            s = a.$prevEl;
        s && 0 < s.length && (e.isBeginning ? s.addClass(t.disabledClass) : s.removeClass(t.disabledClass), s[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass)), i && 0 < i.length && (e.isEnd ? i.addClass(t.disabledClass) : i.removeClass(t.disabledClass), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](t.lockClass));
      }
    },
    onPrevClick: function onPrevClick(e) {
      e.preventDefault(), this.isBeginning && !this.params.loop || this.slidePrev();
    },
    onNextClick: function onNextClick(e) {
      e.preventDefault(), this.isEnd && !this.params.loop || this.slideNext();
    },
    init: function init() {
      var e,
          t,
          a = this,
          i = a.params.navigation;
      (i.nextEl || i.prevEl) && (i.nextEl && (e = L(i.nextEl), a.params.uniqueNavElements && "string" == typeof i.nextEl && 1 < e.length && 1 === a.$el.find(i.nextEl).length && (e = a.$el.find(i.nextEl))), i.prevEl && (t = L(i.prevEl), a.params.uniqueNavElements && "string" == typeof i.prevEl && 1 < t.length && 1 === a.$el.find(i.prevEl).length && (t = a.$el.find(i.prevEl))), e && 0 < e.length && e.on("click", a.navigation.onNextClick), t && 0 < t.length && t.on("click", a.navigation.onPrevClick), ee.extend(a.navigation, {
        $nextEl: e,
        nextEl: e && e[0],
        $prevEl: t,
        prevEl: t && t[0]
      }));
    },
    destroy: function destroy() {
      var e = this,
          t = e.navigation,
          a = t.$nextEl,
          i = t.$prevEl;
      a && a.length && (a.off("click", e.navigation.onNextClick), a.removeClass(e.params.navigation.disabledClass)), i && i.length && (i.off("click", e.navigation.onPrevClick), i.removeClass(e.params.navigation.disabledClass));
    }
  },
      N = {
    update: function update() {
      var e = this,
          t = e.rtl,
          s = e.params.pagination;

      if (s.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
        var r,
            a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
            i = e.pagination.$el,
            n = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length;

        if (e.params.loop ? ((r = Math.ceil((e.activeIndex - e.loopedSlides) / e.params.slidesPerGroup)) > a - 1 - 2 * e.loopedSlides && (r -= a - 2 * e.loopedSlides), n - 1 < r && (r -= n), r < 0 && "bullets" !== e.params.paginationType && (r = n + r)) : r = void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === s.type && e.pagination.bullets && 0 < e.pagination.bullets.length) {
          var o,
              l,
              d,
              p = e.pagination.bullets;
          if (s.dynamicBullets && (e.pagination.bulletSize = p.eq(0)[e.isHorizontal() ? "outerWidth" : "outerHeight"](!0), i.css(e.isHorizontal() ? "width" : "height", e.pagination.bulletSize * (s.dynamicMainBullets + 4) + "px"), 1 < s.dynamicMainBullets && void 0 !== e.previousIndex && (e.pagination.dynamicBulletIndex += r - e.previousIndex, e.pagination.dynamicBulletIndex > s.dynamicMainBullets - 1 ? e.pagination.dynamicBulletIndex = s.dynamicMainBullets - 1 : e.pagination.dynamicBulletIndex < 0 && (e.pagination.dynamicBulletIndex = 0)), o = r - e.pagination.dynamicBulletIndex, d = ((l = o + (Math.min(p.length, s.dynamicMainBullets) - 1)) + o) / 2), p.removeClass(s.bulletActiveClass + " " + s.bulletActiveClass + "-next " + s.bulletActiveClass + "-next-next " + s.bulletActiveClass + "-prev " + s.bulletActiveClass + "-prev-prev " + s.bulletActiveClass + "-main"), 1 < i.length) p.each(function (e, t) {
            var a = L(t),
                i = a.index();
            i === r && a.addClass(s.bulletActiveClass), s.dynamicBullets && (o <= i && i <= l && a.addClass(s.bulletActiveClass + "-main"), i === o && a.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), i === l && a.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next"));
          });else if (p.eq(r).addClass(s.bulletActiveClass), s.dynamicBullets) {
            for (var c = p.eq(o), u = p.eq(l), h = o; h <= l; h += 1) {
              p.eq(h).addClass(s.bulletActiveClass + "-main");
            }

            c.prev().addClass(s.bulletActiveClass + "-prev").prev().addClass(s.bulletActiveClass + "-prev-prev"), u.next().addClass(s.bulletActiveClass + "-next").next().addClass(s.bulletActiveClass + "-next-next");
          }

          if (s.dynamicBullets) {
            var v = Math.min(p.length, s.dynamicMainBullets + 4),
                f = (e.pagination.bulletSize * v - e.pagination.bulletSize) / 2 - d * e.pagination.bulletSize,
                m = t ? "right" : "left";
            p.css(e.isHorizontal() ? m : "top", f + "px");
          }
        }

        if ("fraction" === s.type && (i.find("." + s.currentClass).text(s.formatFractionCurrent(r + 1)), i.find("." + s.totalClass).text(s.formatFractionTotal(n))), "progressbar" === s.type) {
          var g;
          g = s.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
          var b = (r + 1) / n,
              w = 1,
              y = 1;
          "horizontal" === g ? w = b : y = b, i.find("." + s.progressbarFillClass).transform("translate3d(0,0,0) scaleX(" + w + ") scaleY(" + y + ")").transition(e.params.speed);
        }

        "custom" === s.type && s.renderCustom ? (i.html(s.renderCustom(e, r + 1, n)), e.emit("paginationRender", e, i[0])) : e.emit("paginationUpdate", e, i[0]), i[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](s.lockClass);
      }
    },
    render: function render() {
      var e = this,
          t = e.params.pagination;

      if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
        var a = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
            i = e.pagination.$el,
            s = "";

        if ("bullets" === t.type) {
          for (var r = e.params.loop ? Math.ceil((a - 2 * e.loopedSlides) / e.params.slidesPerGroup) : e.snapGrid.length, n = 0; n < r; n += 1) {
            t.renderBullet ? s += t.renderBullet.call(e, n, t.bulletClass) : s += "<" + t.bulletElement + ' class="' + t.bulletClass + '"></' + t.bulletElement + ">";
          }

          i.html(s), e.pagination.bullets = i.find("." + t.bulletClass);
        }

        "fraction" === t.type && (s = t.renderFraction ? t.renderFraction.call(e, t.currentClass, t.totalClass) : '<span class="' + t.currentClass + '"></span> / <span class="' + t.totalClass + '"></span>', i.html(s)), "progressbar" === t.type && (s = t.renderProgressbar ? t.renderProgressbar.call(e, t.progressbarFillClass) : '<span class="' + t.progressbarFillClass + '"></span>', i.html(s)), "custom" !== t.type && e.emit("paginationRender", e.pagination.$el[0]);
      }
    },
    init: function init() {
      var a = this,
          e = a.params.pagination;

      if (e.el) {
        var t = L(e.el);
        0 !== t.length && (a.params.uniqueNavElements && "string" == typeof e.el && 1 < t.length && 1 === a.$el.find(e.el).length && (t = a.$el.find(e.el)), "bullets" === e.type && e.clickable && t.addClass(e.clickableClass), t.addClass(e.modifierClass + e.type), "bullets" === e.type && e.dynamicBullets && (t.addClass("" + e.modifierClass + e.type + "-dynamic"), a.pagination.dynamicBulletIndex = 0, e.dynamicMainBullets < 1 && (e.dynamicMainBullets = 1)), "progressbar" === e.type && e.progressbarOpposite && t.addClass(e.progressbarOppositeClass), e.clickable && t.on("click", "." + e.bulletClass, function (e) {
          e.preventDefault();
          var t = L(this).index() * a.params.slidesPerGroup;
          a.params.loop && (t += a.loopedSlides), a.slideTo(t);
        }), ee.extend(a.pagination, {
          $el: t,
          el: t[0]
        }));
      }
    },
    destroy: function destroy() {
      var e = this,
          t = e.params.pagination;

      if (t.el && e.pagination.el && e.pagination.$el && 0 !== e.pagination.$el.length) {
        var a = e.pagination.$el;
        a.removeClass(t.hiddenClass), a.removeClass(t.modifierClass + t.type), e.pagination.bullets && e.pagination.bullets.removeClass(t.bulletActiveClass), t.clickable && a.off("click", "." + t.bulletClass);
      }
    }
  },
      G = {
    setTranslate: function setTranslate() {
      var e = this;

      if (e.params.scrollbar.el && e.scrollbar.el) {
        var t = e.scrollbar,
            a = e.rtlTranslate,
            i = e.progress,
            s = t.dragSize,
            r = t.trackSize,
            n = t.$dragEl,
            o = t.$el,
            l = e.params.scrollbar,
            d = s,
            p = (r - s) * i;
        a ? 0 < (p = -p) ? (d = s - p, p = 0) : r < -p + s && (d = r + p) : p < 0 ? (d = s + p, p = 0) : r < p + s && (d = r - p), e.isHorizontal() ? (te.transforms3d ? n.transform("translate3d(" + p + "px, 0, 0)") : n.transform("translateX(" + p + "px)"), n[0].style.width = d + "px") : (te.transforms3d ? n.transform("translate3d(0px, " + p + "px, 0)") : n.transform("translateY(" + p + "px)"), n[0].style.height = d + "px"), l.hide && (clearTimeout(e.scrollbar.timeout), o[0].style.opacity = 1, e.scrollbar.timeout = setTimeout(function () {
          o[0].style.opacity = 0, o.transition(400);
        }, 1e3));
      }
    },
    setTransition: function setTransition(e) {
      this.params.scrollbar.el && this.scrollbar.el && this.scrollbar.$dragEl.transition(e);
    },
    updateSize: function updateSize() {
      var e = this;

      if (e.params.scrollbar.el && e.scrollbar.el) {
        var t = e.scrollbar,
            a = t.$dragEl,
            i = t.$el;
        a[0].style.width = "", a[0].style.height = "";
        var s,
            r = e.isHorizontal() ? i[0].offsetWidth : i[0].offsetHeight,
            n = e.size / e.virtualSize,
            o = n * (r / e.size);
        s = "auto" === e.params.scrollbar.dragSize ? r * n : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? a[0].style.width = s + "px" : a[0].style.height = s + "px", i[0].style.display = 1 <= n ? "none" : "", e.params.scrollbar.hide && (i[0].style.opacity = 0), ee.extend(t, {
          trackSize: r,
          divider: n,
          moveDivider: o,
          dragSize: s
        }), t.$el[e.params.watchOverflow && e.isLocked ? "addClass" : "removeClass"](e.params.scrollbar.lockClass);
      }
    },
    setDragPosition: function setDragPosition(e) {
      var t,
          a = this,
          i = a.scrollbar,
          s = a.rtlTranslate,
          r = i.$el,
          n = i.dragSize,
          o = i.trackSize;
      t = ((a.isHorizontal() ? "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX || e.clientX : "touchstart" === e.type || "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY || e.clientY) - r.offset()[a.isHorizontal() ? "left" : "top"] - n / 2) / (o - n), t = Math.max(Math.min(t, 1), 0), s && (t = 1 - t);
      var l = a.minTranslate() + (a.maxTranslate() - a.minTranslate()) * t;
      a.updateProgress(l), a.setTranslate(l), a.updateActiveIndex(), a.updateSlidesClasses();
    },
    onDragStart: function onDragStart(e) {
      var t = this,
          a = t.params.scrollbar,
          i = t.scrollbar,
          s = t.$wrapperEl,
          r = i.$el,
          n = i.$dragEl;
      t.scrollbar.isTouched = !0, e.preventDefault(), e.stopPropagation(), s.transition(100), n.transition(100), i.setDragPosition(e), clearTimeout(t.scrollbar.dragTimeout), r.transition(0), a.hide && r.css("opacity", 1), t.emit("scrollbarDragStart", e);
    },
    onDragMove: function onDragMove(e) {
      var t = this.scrollbar,
          a = this.$wrapperEl,
          i = t.$el,
          s = t.$dragEl;
      this.scrollbar.isTouched && (e.preventDefault ? e.preventDefault() : e.returnValue = !1, t.setDragPosition(e), a.transition(0), i.transition(0), s.transition(0), this.emit("scrollbarDragMove", e));
    },
    onDragEnd: function onDragEnd(e) {
      var t = this,
          a = t.params.scrollbar,
          i = t.scrollbar.$el;
      t.scrollbar.isTouched && (t.scrollbar.isTouched = !1, a.hide && (clearTimeout(t.scrollbar.dragTimeout), t.scrollbar.dragTimeout = ee.nextTick(function () {
        i.css("opacity", 0), i.transition(400);
      }, 1e3)), t.emit("scrollbarDragEnd", e), a.snapOnRelease && t.slideToClosest());
    },
    enableDraggable: function enableDraggable() {
      var e = this;

      if (e.params.scrollbar.el) {
        var t = e.scrollbar,
            a = e.touchEventsTouch,
            i = e.touchEventsDesktop,
            s = e.params,
            r = t.$el[0],
            n = !(!te.passiveListener || !s.passiveListeners) && {
          passive: !1,
          capture: !1
        },
            o = !(!te.passiveListener || !s.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        te.touch ? (r.addEventListener(a.start, e.scrollbar.onDragStart, n), r.addEventListener(a.move, e.scrollbar.onDragMove, n), r.addEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.addEventListener(i.start, e.scrollbar.onDragStart, n), f.addEventListener(i.move, e.scrollbar.onDragMove, n), f.addEventListener(i.end, e.scrollbar.onDragEnd, o));
      }
    },
    disableDraggable: function disableDraggable() {
      var e = this;

      if (e.params.scrollbar.el) {
        var t = e.scrollbar,
            a = e.touchEventsTouch,
            i = e.touchEventsDesktop,
            s = e.params,
            r = t.$el[0],
            n = !(!te.passiveListener || !s.passiveListeners) && {
          passive: !1,
          capture: !1
        },
            o = !(!te.passiveListener || !s.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        te.touch ? (r.removeEventListener(a.start, e.scrollbar.onDragStart, n), r.removeEventListener(a.move, e.scrollbar.onDragMove, n), r.removeEventListener(a.end, e.scrollbar.onDragEnd, o)) : (r.removeEventListener(i.start, e.scrollbar.onDragStart, n), f.removeEventListener(i.move, e.scrollbar.onDragMove, n), f.removeEventListener(i.end, e.scrollbar.onDragEnd, o));
      }
    },
    init: function init() {
      var e = this;

      if (e.params.scrollbar.el) {
        var t = e.scrollbar,
            a = e.$el,
            i = e.params.scrollbar,
            s = L(i.el);
        e.params.uniqueNavElements && "string" == typeof i.el && 1 < s.length && 1 === a.find(i.el).length && (s = a.find(i.el));
        var r = s.find("." + e.params.scrollbar.dragClass);
        0 === r.length && (r = L('<div class="' + e.params.scrollbar.dragClass + '"></div>'), s.append(r)), ee.extend(t, {
          $el: s,
          el: s[0],
          $dragEl: r,
          dragEl: r[0]
        }), i.draggable && t.enableDraggable();
      }
    },
    destroy: function destroy() {
      this.scrollbar.disableDraggable();
    }
  },
      B = {
    setTransform: function setTransform(e, t) {
      var a = this.rtl,
          i = L(e),
          s = a ? -1 : 1,
          r = i.attr("data-swiper-parallax") || "0",
          n = i.attr("data-swiper-parallax-x"),
          o = i.attr("data-swiper-parallax-y"),
          l = i.attr("data-swiper-parallax-scale"),
          d = i.attr("data-swiper-parallax-opacity");

      if (n || o ? (n = n || "0", o = o || "0") : this.isHorizontal() ? (n = r, o = "0") : (o = r, n = "0"), n = 0 <= n.indexOf("%") ? parseInt(n, 10) * t * s + "%" : n * t * s + "px", o = 0 <= o.indexOf("%") ? parseInt(o, 10) * t + "%" : o * t + "px", null != d) {
        var p = d - (d - 1) * (1 - Math.abs(t));
        i[0].style.opacity = p;
      }

      if (null == l) i.transform("translate3d(" + n + ", " + o + ", 0px)");else {
        var c = l - (l - 1) * (1 - Math.abs(t));
        i.transform("translate3d(" + n + ", " + o + ", 0px) scale(" + c + ")");
      }
    },
    setTranslate: function setTranslate() {
      var i = this,
          e = i.$el,
          t = i.slides,
          s = i.progress,
          r = i.snapGrid;
      e.children("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
        i.parallax.setTransform(t, s);
      }), t.each(function (e, t) {
        var a = t.progress;
        1 < i.params.slidesPerGroup && "auto" !== i.params.slidesPerView && (a += Math.ceil(e / 2) - s * (r.length - 1)), a = Math.min(Math.max(a, -1), 1), L(t).find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
          i.parallax.setTransform(t, a);
        });
      });
    },
    setTransition: function setTransition(s) {
      void 0 === s && (s = this.params.speed);
      this.$el.find("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y]").each(function (e, t) {
        var a = L(t),
            i = parseInt(a.attr("data-swiper-parallax-duration"), 10) || s;
        0 === s && (i = 0), a.transition(i);
      });
    }
  },
      X = {
    getDistanceBetweenTouches: function getDistanceBetweenTouches(e) {
      if (e.targetTouches.length < 2) return 1;
      var t = e.targetTouches[0].pageX,
          a = e.targetTouches[0].pageY,
          i = e.targetTouches[1].pageX,
          s = e.targetTouches[1].pageY;
      return Math.sqrt(Math.pow(i - t, 2) + Math.pow(s - a, 2));
    },
    onGestureStart: function onGestureStart(e) {
      var t = this,
          a = t.params.zoom,
          i = t.zoom,
          s = i.gesture;

      if (i.fakeGestureTouched = !1, i.fakeGestureMoved = !1, !te.gestures) {
        if ("touchstart" !== e.type || "touchstart" === e.type && e.targetTouches.length < 2) return;
        i.fakeGestureTouched = !0, s.scaleStart = X.getDistanceBetweenTouches(e);
      }

      s.$slideEl && s.$slideEl.length || (s.$slideEl = L(e.target).closest(".swiper-slide"), 0 === s.$slideEl.length && (s.$slideEl = t.slides.eq(t.activeIndex)), s.$imageEl = s.$slideEl.find("img, svg, canvas"), s.$imageWrapEl = s.$imageEl.parent("." + a.containerClass), s.maxRatio = s.$imageWrapEl.attr("data-swiper-zoom") || a.maxRatio, 0 !== s.$imageWrapEl.length) ? (s.$imageEl.transition(0), t.zoom.isScaling = !0) : s.$imageEl = void 0;
    },
    onGestureChange: function onGestureChange(e) {
      var t = this.params.zoom,
          a = this.zoom,
          i = a.gesture;

      if (!te.gestures) {
        if ("touchmove" !== e.type || "touchmove" === e.type && e.targetTouches.length < 2) return;
        a.fakeGestureMoved = !0, i.scaleMove = X.getDistanceBetweenTouches(e);
      }

      i.$imageEl && 0 !== i.$imageEl.length && (a.scale = te.gestures ? e.scale * a.currentScale : i.scaleMove / i.scaleStart * a.currentScale, a.scale > i.maxRatio && (a.scale = i.maxRatio - 1 + Math.pow(a.scale - i.maxRatio + 1, .5)), a.scale < t.minRatio && (a.scale = t.minRatio + 1 - Math.pow(t.minRatio - a.scale + 1, .5)), i.$imageEl.transform("translate3d(0,0,0) scale(" + a.scale + ")"));
    },
    onGestureEnd: function onGestureEnd(e) {
      var t = this.params.zoom,
          a = this.zoom,
          i = a.gesture;

      if (!te.gestures) {
        if (!a.fakeGestureTouched || !a.fakeGestureMoved) return;
        if ("touchend" !== e.type || "touchend" === e.type && e.changedTouches.length < 2 && !g.android) return;
        a.fakeGestureTouched = !1, a.fakeGestureMoved = !1;
      }

      i.$imageEl && 0 !== i.$imageEl.length && (a.scale = Math.max(Math.min(a.scale, i.maxRatio), t.minRatio), i.$imageEl.transition(this.params.speed).transform("translate3d(0,0,0) scale(" + a.scale + ")"), a.currentScale = a.scale, a.isScaling = !1, 1 === a.scale && (i.$slideEl = void 0));
    },
    onTouchStart: function onTouchStart(e) {
      var t = this.zoom,
          a = t.gesture,
          i = t.image;
      a.$imageEl && 0 !== a.$imageEl.length && (i.isTouched || (g.android && e.preventDefault(), i.isTouched = !0, i.touchesStart.x = "touchstart" === e.type ? e.targetTouches[0].pageX : e.pageX, i.touchesStart.y = "touchstart" === e.type ? e.targetTouches[0].pageY : e.pageY));
    },
    onTouchMove: function onTouchMove(e) {
      var t = this,
          a = t.zoom,
          i = a.gesture,
          s = a.image,
          r = a.velocity;

      if (i.$imageEl && 0 !== i.$imageEl.length && (t.allowClick = !1, s.isTouched && i.$slideEl)) {
        s.isMoved || (s.width = i.$imageEl[0].offsetWidth, s.height = i.$imageEl[0].offsetHeight, s.startX = ee.getTranslate(i.$imageWrapEl[0], "x") || 0, s.startY = ee.getTranslate(i.$imageWrapEl[0], "y") || 0, i.slideWidth = i.$slideEl[0].offsetWidth, i.slideHeight = i.$slideEl[0].offsetHeight, i.$imageWrapEl.transition(0), t.rtl && (s.startX = -s.startX, s.startY = -s.startY));
        var n = s.width * a.scale,
            o = s.height * a.scale;

        if (!(n < i.slideWidth && o < i.slideHeight)) {
          if (s.minX = Math.min(i.slideWidth / 2 - n / 2, 0), s.maxX = -s.minX, s.minY = Math.min(i.slideHeight / 2 - o / 2, 0), s.maxY = -s.minY, s.touchesCurrent.x = "touchmove" === e.type ? e.targetTouches[0].pageX : e.pageX, s.touchesCurrent.y = "touchmove" === e.type ? e.targetTouches[0].pageY : e.pageY, !s.isMoved && !a.isScaling) {
            if (t.isHorizontal() && (Math.floor(s.minX) === Math.floor(s.startX) && s.touchesCurrent.x < s.touchesStart.x || Math.floor(s.maxX) === Math.floor(s.startX) && s.touchesCurrent.x > s.touchesStart.x)) return void (s.isTouched = !1);
            if (!t.isHorizontal() && (Math.floor(s.minY) === Math.floor(s.startY) && s.touchesCurrent.y < s.touchesStart.y || Math.floor(s.maxY) === Math.floor(s.startY) && s.touchesCurrent.y > s.touchesStart.y)) return void (s.isTouched = !1);
          }

          e.preventDefault(), e.stopPropagation(), s.isMoved = !0, s.currentX = s.touchesCurrent.x - s.touchesStart.x + s.startX, s.currentY = s.touchesCurrent.y - s.touchesStart.y + s.startY, s.currentX < s.minX && (s.currentX = s.minX + 1 - Math.pow(s.minX - s.currentX + 1, .8)), s.currentX > s.maxX && (s.currentX = s.maxX - 1 + Math.pow(s.currentX - s.maxX + 1, .8)), s.currentY < s.minY && (s.currentY = s.minY + 1 - Math.pow(s.minY - s.currentY + 1, .8)), s.currentY > s.maxY && (s.currentY = s.maxY - 1 + Math.pow(s.currentY - s.maxY + 1, .8)), r.prevPositionX || (r.prevPositionX = s.touchesCurrent.x), r.prevPositionY || (r.prevPositionY = s.touchesCurrent.y), r.prevTime || (r.prevTime = Date.now()), r.x = (s.touchesCurrent.x - r.prevPositionX) / (Date.now() - r.prevTime) / 2, r.y = (s.touchesCurrent.y - r.prevPositionY) / (Date.now() - r.prevTime) / 2, Math.abs(s.touchesCurrent.x - r.prevPositionX) < 2 && (r.x = 0), Math.abs(s.touchesCurrent.y - r.prevPositionY) < 2 && (r.y = 0), r.prevPositionX = s.touchesCurrent.x, r.prevPositionY = s.touchesCurrent.y, r.prevTime = Date.now(), i.$imageWrapEl.transform("translate3d(" + s.currentX + "px, " + s.currentY + "px,0)");
        }
      }
    },
    onTouchEnd: function onTouchEnd() {
      var e = this.zoom,
          t = e.gesture,
          a = e.image,
          i = e.velocity;

      if (t.$imageEl && 0 !== t.$imageEl.length) {
        if (!a.isTouched || !a.isMoved) return a.isTouched = !1, void (a.isMoved = !1);
        a.isTouched = !1, a.isMoved = !1;
        var s = 300,
            r = 300,
            n = i.x * s,
            o = a.currentX + n,
            l = i.y * r,
            d = a.currentY + l;
        0 !== i.x && (s = Math.abs((o - a.currentX) / i.x)), 0 !== i.y && (r = Math.abs((d - a.currentY) / i.y));
        var p = Math.max(s, r);
        a.currentX = o, a.currentY = d;
        var c = a.width * e.scale,
            u = a.height * e.scale;
        a.minX = Math.min(t.slideWidth / 2 - c / 2, 0), a.maxX = -a.minX, a.minY = Math.min(t.slideHeight / 2 - u / 2, 0), a.maxY = -a.minY, a.currentX = Math.max(Math.min(a.currentX, a.maxX), a.minX), a.currentY = Math.max(Math.min(a.currentY, a.maxY), a.minY), t.$imageWrapEl.transition(p).transform("translate3d(" + a.currentX + "px, " + a.currentY + "px,0)");
      }
    },
    onTransitionEnd: function onTransitionEnd() {
      var e = this.zoom,
          t = e.gesture;
      t.$slideEl && this.previousIndex !== this.activeIndex && (t.$imageEl.transform("translate3d(0,0,0) scale(1)"), t.$imageWrapEl.transform("translate3d(0,0,0)"), e.scale = 1, e.currentScale = 1, t.$slideEl = void 0, t.$imageEl = void 0, t.$imageWrapEl = void 0);
    },
    toggle: function toggle(e) {
      var t = this.zoom;
      t.scale && 1 !== t.scale ? t.out() : t.in(e);
    },
    in: function _in(e) {
      var t,
          a,
          i,
          s,
          r,
          n,
          o,
          l,
          d,
          p,
          c,
          u,
          h,
          v,
          f,
          m,
          g = this,
          b = g.zoom,
          w = g.params.zoom,
          y = b.gesture,
          x = b.image;
      (y.$slideEl || (y.$slideEl = g.clickedSlide ? L(g.clickedSlide) : g.slides.eq(g.activeIndex), y.$imageEl = y.$slideEl.find("img, svg, canvas"), y.$imageWrapEl = y.$imageEl.parent("." + w.containerClass)), y.$imageEl && 0 !== y.$imageEl.length) && (y.$slideEl.addClass("" + w.zoomedSlideClass), void 0 === x.touchesStart.x && e ? (t = "touchend" === e.type ? e.changedTouches[0].pageX : e.pageX, a = "touchend" === e.type ? e.changedTouches[0].pageY : e.pageY) : (t = x.touchesStart.x, a = x.touchesStart.y), b.scale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, b.currentScale = y.$imageWrapEl.attr("data-swiper-zoom") || w.maxRatio, e ? (f = y.$slideEl[0].offsetWidth, m = y.$slideEl[0].offsetHeight, i = y.$slideEl.offset().left + f / 2 - t, s = y.$slideEl.offset().top + m / 2 - a, o = y.$imageEl[0].offsetWidth, l = y.$imageEl[0].offsetHeight, d = o * b.scale, p = l * b.scale, h = -(c = Math.min(f / 2 - d / 2, 0)), v = -(u = Math.min(m / 2 - p / 2, 0)), (r = i * b.scale) < c && (r = c), h < r && (r = h), (n = s * b.scale) < u && (n = u), v < n && (n = v)) : n = r = 0, y.$imageWrapEl.transition(300).transform("translate3d(" + r + "px, " + n + "px,0)"), y.$imageEl.transition(300).transform("translate3d(0,0,0) scale(" + b.scale + ")"));
    },
    out: function out() {
      var e = this,
          t = e.zoom,
          a = e.params.zoom,
          i = t.gesture;
      i.$slideEl || (i.$slideEl = e.clickedSlide ? L(e.clickedSlide) : e.slides.eq(e.activeIndex), i.$imageEl = i.$slideEl.find("img, svg, canvas"), i.$imageWrapEl = i.$imageEl.parent("." + a.containerClass)), i.$imageEl && 0 !== i.$imageEl.length && (t.scale = 1, t.currentScale = 1, i.$imageWrapEl.transition(300).transform("translate3d(0,0,0)"), i.$imageEl.transition(300).transform("translate3d(0,0,0) scale(1)"), i.$slideEl.removeClass("" + a.zoomedSlideClass), i.$slideEl = void 0);
    },
    enable: function enable() {
      var e = this,
          t = e.zoom;

      if (!t.enabled) {
        t.enabled = !0;
        var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        te.gestures ? (e.$wrapperEl.on("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.on(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.on(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.on(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.on(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
      }
    },
    disable: function disable() {
      var e = this,
          t = e.zoom;

      if (t.enabled) {
        e.zoom.enabled = !1;
        var a = !("touchstart" !== e.touchEvents.start || !te.passiveListener || !e.params.passiveListeners) && {
          passive: !0,
          capture: !1
        };
        te.gestures ? (e.$wrapperEl.off("gesturestart", ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off("gesturechange", ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off("gestureend", ".swiper-slide", t.onGestureEnd, a)) : "touchstart" === e.touchEvents.start && (e.$wrapperEl.off(e.touchEvents.start, ".swiper-slide", t.onGestureStart, a), e.$wrapperEl.off(e.touchEvents.move, ".swiper-slide", t.onGestureChange, a), e.$wrapperEl.off(e.touchEvents.end, ".swiper-slide", t.onGestureEnd, a)), e.$wrapperEl.off(e.touchEvents.move, "." + e.params.zoom.containerClass, t.onTouchMove);
      }
    }
  },
      Y = {
    loadInSlide: function loadInSlide(e, l) {
      void 0 === l && (l = !0);
      var d = this,
          p = d.params.lazy;

      if (void 0 !== e && 0 !== d.slides.length) {
        var c = d.virtual && d.params.virtual.enabled ? d.$wrapperEl.children("." + d.params.slideClass + '[data-swiper-slide-index="' + e + '"]') : d.slides.eq(e),
            t = c.find("." + p.elementClass + ":not(." + p.loadedClass + "):not(." + p.loadingClass + ")");
        !c.hasClass(p.elementClass) || c.hasClass(p.loadedClass) || c.hasClass(p.loadingClass) || (t = t.add(c[0])), 0 !== t.length && t.each(function (e, t) {
          var i = L(t);
          i.addClass(p.loadingClass);
          var s = i.attr("data-background"),
              r = i.attr("data-src"),
              n = i.attr("data-srcset"),
              o = i.attr("data-sizes");
          d.loadImage(i[0], r || s, n, o, !1, function () {
            if (null != d && d && (!d || d.params) && !d.destroyed) {
              if (s ? (i.css("background-image", 'url("' + s + '")'), i.removeAttr("data-background")) : (n && (i.attr("srcset", n), i.removeAttr("data-srcset")), o && (i.attr("sizes", o), i.removeAttr("data-sizes")), r && (i.attr("src", r), i.removeAttr("data-src"))), i.addClass(p.loadedClass).removeClass(p.loadingClass), c.find("." + p.preloaderClass).remove(), d.params.loop && l) {
                var e = c.attr("data-swiper-slide-index");

                if (c.hasClass(d.params.slideDuplicateClass)) {
                  var t = d.$wrapperEl.children('[data-swiper-slide-index="' + e + '"]:not(.' + d.params.slideDuplicateClass + ")");
                  d.lazy.loadInSlide(t.index(), !1);
                } else {
                  var a = d.$wrapperEl.children("." + d.params.slideDuplicateClass + '[data-swiper-slide-index="' + e + '"]');
                  d.lazy.loadInSlide(a.index(), !1);
                }
              }

              d.emit("lazyImageReady", c[0], i[0]);
            }
          }), d.emit("lazyImageLoad", c[0], i[0]);
        });
      }
    },
    load: function load() {
      var i = this,
          t = i.$wrapperEl,
          a = i.params,
          s = i.slides,
          e = i.activeIndex,
          r = i.virtual && a.virtual.enabled,
          n = a.lazy,
          o = a.slidesPerView;

      function l(e) {
        if (r) {
          if (t.children("." + a.slideClass + '[data-swiper-slide-index="' + e + '"]').length) return !0;
        } else if (s[e]) return !0;

        return !1;
      }

      function d(e) {
        return r ? L(e).attr("data-swiper-slide-index") : L(e).index();
      }

      if ("auto" === o && (o = 0), i.lazy.initialImageLoaded || (i.lazy.initialImageLoaded = !0), i.params.watchSlidesVisibility) t.children("." + a.slideVisibleClass).each(function (e, t) {
        var a = r ? L(t).attr("data-swiper-slide-index") : L(t).index();
        i.lazy.loadInSlide(a);
      });else if (1 < o) for (var p = e; p < e + o; p += 1) {
        l(p) && i.lazy.loadInSlide(p);
      } else i.lazy.loadInSlide(e);
      if (n.loadPrevNext) if (1 < o || n.loadPrevNextAmount && 1 < n.loadPrevNextAmount) {
        for (var c = n.loadPrevNextAmount, u = o, h = Math.min(e + u + Math.max(c, u), s.length), v = Math.max(e - Math.max(u, c), 0), f = e + o; f < h; f += 1) {
          l(f) && i.lazy.loadInSlide(f);
        }

        for (var m = v; m < e; m += 1) {
          l(m) && i.lazy.loadInSlide(m);
        }
      } else {
        var g = t.children("." + a.slideNextClass);
        0 < g.length && i.lazy.loadInSlide(d(g));
        var b = t.children("." + a.slidePrevClass);
        0 < b.length && i.lazy.loadInSlide(d(b));
      }
    }
  },
      V = {
    LinearSpline: function LinearSpline(e, t) {
      var a,
          i,
          s,
          r,
          n,
          o = function o(e, t) {
        for (i = -1, a = e.length; 1 < a - i;) {
          e[s = a + i >> 1] <= t ? i = s : a = s;
        }

        return a;
      };

      return this.x = e, this.y = t, this.lastIndex = e.length - 1, this.interpolate = function (e) {
        return e ? (n = o(this.x, e), r = n - 1, (e - this.x[r]) * (this.y[n] - this.y[r]) / (this.x[n] - this.x[r]) + this.y[r]) : 0;
      }, this;
    },
    getInterpolateFunction: function getInterpolateFunction(e) {
      var t = this;
      t.controller.spline || (t.controller.spline = t.params.loop ? new V.LinearSpline(t.slidesGrid, e.slidesGrid) : new V.LinearSpline(t.snapGrid, e.snapGrid));
    },
    setTranslate: function setTranslate(e, t) {
      var a,
          i,
          s = this,
          r = s.controller.control;

      function n(e) {
        var t = s.rtlTranslate ? -s.translate : s.translate;
        "slide" === s.params.controller.by && (s.controller.getInterpolateFunction(e), i = -s.controller.spline.interpolate(-t)), i && "container" !== s.params.controller.by || (a = (e.maxTranslate() - e.minTranslate()) / (s.maxTranslate() - s.minTranslate()), i = (t - s.minTranslate()) * a + e.minTranslate()), s.params.controller.inverse && (i = e.maxTranslate() - i), e.updateProgress(i), e.setTranslate(i, s), e.updateActiveIndex(), e.updateSlidesClasses();
      }

      if (Array.isArray(r)) for (var o = 0; o < r.length; o += 1) {
        r[o] !== t && r[o] instanceof T && n(r[o]);
      } else r instanceof T && t !== r && n(r);
    },
    setTransition: function setTransition(t, e) {
      var a,
          i = this,
          s = i.controller.control;

      function r(e) {
        e.setTransition(t, i), 0 !== t && (e.transitionStart(), e.params.autoHeight && ee.nextTick(function () {
          e.updateAutoHeight();
        }), e.$wrapperEl.transitionEnd(function () {
          s && (e.params.loop && "slide" === i.params.controller.by && e.loopFix(), e.transitionEnd());
        }));
      }

      if (Array.isArray(s)) for (a = 0; a < s.length; a += 1) {
        s[a] !== e && s[a] instanceof T && r(s[a]);
      } else s instanceof T && e !== s && r(s);
    }
  },
      F = {
    makeElFocusable: function makeElFocusable(e) {
      return e.attr("tabIndex", "0"), e;
    },
    addElRole: function addElRole(e, t) {
      return e.attr("role", t), e;
    },
    addElLabel: function addElLabel(e, t) {
      return e.attr("aria-label", t), e;
    },
    disableEl: function disableEl(e) {
      return e.attr("aria-disabled", !0), e;
    },
    enableEl: function enableEl(e) {
      return e.attr("aria-disabled", !1), e;
    },
    onEnterKey: function onEnterKey(e) {
      var t = this,
          a = t.params.a11y;

      if (13 === e.keyCode) {
        var i = L(e.target);
        t.navigation && t.navigation.$nextEl && i.is(t.navigation.$nextEl) && (t.isEnd && !t.params.loop || t.slideNext(), t.isEnd ? t.a11y.notify(a.lastSlideMessage) : t.a11y.notify(a.nextSlideMessage)), t.navigation && t.navigation.$prevEl && i.is(t.navigation.$prevEl) && (t.isBeginning && !t.params.loop || t.slidePrev(), t.isBeginning ? t.a11y.notify(a.firstSlideMessage) : t.a11y.notify(a.prevSlideMessage)), t.pagination && i.is("." + t.params.pagination.bulletClass) && i[0].click();
      }
    },
    notify: function notify(e) {
      var t = this.a11y.liveRegion;
      0 !== t.length && (t.html(""), t.html(e));
    },
    updateNavigation: function updateNavigation() {
      var e = this;

      if (!e.params.loop) {
        var t = e.navigation,
            a = t.$nextEl,
            i = t.$prevEl;
        i && 0 < i.length && (e.isBeginning ? e.a11y.disableEl(i) : e.a11y.enableEl(i)), a && 0 < a.length && (e.isEnd ? e.a11y.disableEl(a) : e.a11y.enableEl(a));
      }
    },
    updatePagination: function updatePagination() {
      var i = this,
          s = i.params.a11y;
      i.pagination && i.params.pagination.clickable && i.pagination.bullets && i.pagination.bullets.length && i.pagination.bullets.each(function (e, t) {
        var a = L(t);
        i.a11y.makeElFocusable(a), i.a11y.addElRole(a, "button"), i.a11y.addElLabel(a, s.paginationBulletMessage.replace(/{{index}}/, a.index() + 1));
      });
    },
    init: function init() {
      var e = this;
      e.$el.append(e.a11y.liveRegion);
      var t,
          a,
          i = e.params.a11y;
      e.navigation && e.navigation.$nextEl && (t = e.navigation.$nextEl), e.navigation && e.navigation.$prevEl && (a = e.navigation.$prevEl), t && (e.a11y.makeElFocusable(t), e.a11y.addElRole(t, "button"), e.a11y.addElLabel(t, i.nextSlideMessage), t.on("keydown", e.a11y.onEnterKey)), a && (e.a11y.makeElFocusable(a), e.a11y.addElRole(a, "button"), e.a11y.addElLabel(a, i.prevSlideMessage), a.on("keydown", e.a11y.onEnterKey)), e.pagination && e.params.pagination.clickable && e.pagination.bullets && e.pagination.bullets.length && e.pagination.$el.on("keydown", "." + e.params.pagination.bulletClass, e.a11y.onEnterKey);
    },
    destroy: function destroy() {
      var e,
          t,
          a = this;
      a.a11y.liveRegion && 0 < a.a11y.liveRegion.length && a.a11y.liveRegion.remove(), a.navigation && a.navigation.$nextEl && (e = a.navigation.$nextEl), a.navigation && a.navigation.$prevEl && (t = a.navigation.$prevEl), e && e.off("keydown", a.a11y.onEnterKey), t && t.off("keydown", a.a11y.onEnterKey), a.pagination && a.params.pagination.clickable && a.pagination.bullets && a.pagination.bullets.length && a.pagination.$el.off("keydown", "." + a.params.pagination.bulletClass, a.a11y.onEnterKey);
    }
  },
      R = {
    init: function init() {
      var e = this;

      if (e.params.history) {
        if (!J.history || !J.history.pushState) return e.params.history.enabled = !1, void (e.params.hashNavigation.enabled = !0);
        var t = e.history;
        t.initialized = !0, t.paths = R.getPathValues(), (t.paths.key || t.paths.value) && (t.scrollToSlide(0, t.paths.value, e.params.runCallbacksOnInit), e.params.history.replaceState || J.addEventListener("popstate", e.history.setHistoryPopState));
      }
    },
    destroy: function destroy() {
      this.params.history.replaceState || J.removeEventListener("popstate", this.history.setHistoryPopState);
    },
    setHistoryPopState: function setHistoryPopState() {
      this.history.paths = R.getPathValues(), this.history.scrollToSlide(this.params.speed, this.history.paths.value, !1);
    },
    getPathValues: function getPathValues() {
      var e = J.location.pathname.slice(1).split("/").filter(function (e) {
        return "" !== e;
      }),
          t = e.length;
      return {
        key: e[t - 2],
        value: e[t - 1]
      };
    },
    setHistory: function setHistory(e, t) {
      if (this.history.initialized && this.params.history.enabled) {
        var a = this.slides.eq(t),
            i = R.slugify(a.attr("data-history"));
        J.location.pathname.includes(e) || (i = e + "/" + i);
        var s = J.history.state;
        s && s.value === i || (this.params.history.replaceState ? J.history.replaceState({
          value: i
        }, null, i) : J.history.pushState({
          value: i
        }, null, i));
      }
    },
    slugify: function slugify(e) {
      return e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    },
    scrollToSlide: function scrollToSlide(e, t, a) {
      var i = this;
      if (t) for (var s = 0, r = i.slides.length; s < r; s += 1) {
        var n = i.slides.eq(s);

        if (R.slugify(n.attr("data-history")) === t && !n.hasClass(i.params.slideDuplicateClass)) {
          var o = n.index();
          i.slideTo(o, e, a);
        }
      } else i.slideTo(0, e, a);
    }
  },
      q = {
    onHashCange: function onHashCange() {
      var e = this,
          t = f.location.hash.replace("#", "");

      if (t !== e.slides.eq(e.activeIndex).attr("data-hash")) {
        var a = e.$wrapperEl.children("." + e.params.slideClass + '[data-hash="' + t + '"]').index();
        if (void 0 === a) return;
        e.slideTo(a);
      }
    },
    setHash: function setHash() {
      var e = this;
      if (e.hashNavigation.initialized && e.params.hashNavigation.enabled) if (e.params.hashNavigation.replaceState && J.history && J.history.replaceState) J.history.replaceState(null, null, "#" + e.slides.eq(e.activeIndex).attr("data-hash") || "");else {
        var t = e.slides.eq(e.activeIndex),
            a = t.attr("data-hash") || t.attr("data-history");
        f.location.hash = a || "";
      }
    },
    init: function init() {
      var e = this;

      if (!(!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled)) {
        e.hashNavigation.initialized = !0;
        var t = f.location.hash.replace("#", "");
        if (t) for (var a = 0, i = e.slides.length; a < i; a += 1) {
          var s = e.slides.eq(a);

          if ((s.attr("data-hash") || s.attr("data-history")) === t && !s.hasClass(e.params.slideDuplicateClass)) {
            var r = s.index();
            e.slideTo(r, 0, e.params.runCallbacksOnInit, !0);
          }
        }
        e.params.hashNavigation.watchState && L(J).on("hashchange", e.hashNavigation.onHashCange);
      }
    },
    destroy: function destroy() {
      this.params.hashNavigation.watchState && L(J).off("hashchange", this.hashNavigation.onHashCange);
    }
  },
      W = {
    run: function run() {
      var e = this,
          t = e.slides.eq(e.activeIndex),
          a = e.params.autoplay.delay;
      t.attr("data-swiper-autoplay") && (a = t.attr("data-swiper-autoplay") || e.params.autoplay.delay), e.autoplay.timeout = ee.nextTick(function () {
        e.params.autoplay.reverseDirection ? e.params.loop ? (e.loopFix(), e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.isBeginning ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(e.slides.length - 1, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slidePrev(e.params.speed, !0, !0), e.emit("autoplay")) : e.params.loop ? (e.loopFix(), e.slideNext(e.params.speed, !0, !0), e.emit("autoplay")) : e.isEnd ? e.params.autoplay.stopOnLastSlide ? e.autoplay.stop() : (e.slideTo(0, e.params.speed, !0, !0), e.emit("autoplay")) : (e.slideNext(e.params.speed, !0, !0), e.emit("autoplay"));
      }, a);
    },
    start: function start() {
      var e = this;
      return void 0 === e.autoplay.timeout && !e.autoplay.running && (e.autoplay.running = !0, e.emit("autoplayStart"), e.autoplay.run(), !0);
    },
    stop: function stop() {
      var e = this;
      return !!e.autoplay.running && void 0 !== e.autoplay.timeout && (e.autoplay.timeout && (clearTimeout(e.autoplay.timeout), e.autoplay.timeout = void 0), e.autoplay.running = !1, e.emit("autoplayStop"), !0);
    },
    pause: function pause(e) {
      var t = this;
      t.autoplay.running && (t.autoplay.paused || (t.autoplay.timeout && clearTimeout(t.autoplay.timeout), t.autoplay.paused = !0, 0 !== e && t.params.autoplay.waitForTransition ? (t.$wrapperEl[0].addEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].addEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd)) : (t.autoplay.paused = !1, t.autoplay.run())));
    }
  },
      j = {
    setTranslate: function setTranslate() {
      for (var e = this, t = e.slides, a = 0; a < t.length; a += 1) {
        var i = e.slides.eq(a),
            s = -i[0].swiperSlideOffset;
        e.params.virtualTranslate || (s -= e.translate);
        var r = 0;
        e.isHorizontal() || (r = s, s = 0);
        var n = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(i[0].progress), 0) : 1 + Math.min(Math.max(i[0].progress, -1), 0);
        i.css({
          opacity: n
        }).transform("translate3d(" + s + "px, " + r + "px, 0px)");
      }
    },
    setTransition: function setTransition(e) {
      var a = this,
          t = a.slides,
          i = a.$wrapperEl;

      if (t.transition(e), a.params.virtualTranslate && 0 !== e) {
        var s = !1;
        t.transitionEnd(function () {
          if (!s && a && !a.destroyed) {
            s = !0, a.animating = !1;

            for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
              i.trigger(e[t]);
            }
          }
        });
      }
    }
  },
      U = {
    setTranslate: function setTranslate() {
      var e,
          t = this,
          a = t.$el,
          i = t.$wrapperEl,
          s = t.slides,
          r = t.width,
          n = t.height,
          o = t.rtlTranslate,
          l = t.size,
          d = t.params.cubeEffect,
          p = t.isHorizontal(),
          c = t.virtual && t.params.virtual.enabled,
          u = 0;
      d.shadow && (p ? (0 === (e = i.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), i.append(e)), e.css({
        height: r + "px"
      })) : 0 === (e = a.find(".swiper-cube-shadow")).length && (e = L('<div class="swiper-cube-shadow"></div>'), a.append(e)));

      for (var h = 0; h < s.length; h += 1) {
        var v = s.eq(h),
            f = h;
        c && (f = parseInt(v.attr("data-swiper-slide-index"), 10));
        var m = 90 * f,
            g = Math.floor(m / 360);
        o && (m = -m, g = Math.floor(-m / 360));
        var b = Math.max(Math.min(v[0].progress, 1), -1),
            w = 0,
            y = 0,
            x = 0;
        f % 4 == 0 ? (w = 4 * -g * l, x = 0) : (f - 1) % 4 == 0 ? (w = 0, x = 4 * -g * l) : (f - 2) % 4 == 0 ? (w = l + 4 * g * l, x = l) : (f - 3) % 4 == 0 && (w = -l, x = 3 * l + 4 * l * g), o && (w = -w), p || (y = w, w = 0);
        var T = "rotateX(" + (p ? 0 : -m) + "deg) rotateY(" + (p ? m : 0) + "deg) translate3d(" + w + "px, " + y + "px, " + x + "px)";

        if (b <= 1 && -1 < b && (u = 90 * f + 90 * b, o && (u = 90 * -f - 90 * b)), v.transform(T), d.slideShadows) {
          var E = p ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
              S = p ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
          0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (p ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (p ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = Math.max(-b, 0)), S.length && (S[0].style.opacity = Math.max(b, 0));
        }
      }

      if (i.css({
        "-webkit-transform-origin": "50% 50% -" + l / 2 + "px",
        "-moz-transform-origin": "50% 50% -" + l / 2 + "px",
        "-ms-transform-origin": "50% 50% -" + l / 2 + "px",
        "transform-origin": "50% 50% -" + l / 2 + "px"
      }), d.shadow) if (p) e.transform("translate3d(0px, " + (r / 2 + d.shadowOffset) + "px, " + -r / 2 + "px) rotateX(90deg) rotateZ(0deg) scale(" + d.shadowScale + ")");else {
        var C = Math.abs(u) - 90 * Math.floor(Math.abs(u) / 90),
            M = 1.5 - (Math.sin(2 * C * Math.PI / 360) / 2 + Math.cos(2 * C * Math.PI / 360) / 2),
            z = d.shadowScale,
            P = d.shadowScale / M,
            k = d.shadowOffset;
        e.transform("scale3d(" + z + ", 1, " + P + ") translate3d(0px, " + (n / 2 + k) + "px, " + -n / 2 / P + "px) rotateX(-90deg)");
      }
      var $ = I.isSafari || I.isUiWebView ? -l / 2 : 0;
      i.transform("translate3d(0px,0," + $ + "px) rotateX(" + (t.isHorizontal() ? 0 : u) + "deg) rotateY(" + (t.isHorizontal() ? -u : 0) + "deg)");
    },
    setTransition: function setTransition(e) {
      var t = this.$el;
      this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), this.params.cubeEffect.shadow && !this.isHorizontal() && t.find(".swiper-cube-shadow").transition(e);
    }
  },
      K = {
    setTranslate: function setTranslate() {
      for (var e = this, t = e.slides, a = e.rtlTranslate, i = 0; i < t.length; i += 1) {
        var s = t.eq(i),
            r = s[0].progress;
        e.params.flipEffect.limitRotation && (r = Math.max(Math.min(s[0].progress, 1), -1));
        var n = -180 * r,
            o = 0,
            l = -s[0].swiperSlideOffset,
            d = 0;

        if (e.isHorizontal() ? a && (n = -n) : (d = l, o = -n, n = l = 0), s[0].style.zIndex = -Math.abs(Math.round(r)) + t.length, e.params.flipEffect.slideShadows) {
          var p = e.isHorizontal() ? s.find(".swiper-slide-shadow-left") : s.find(".swiper-slide-shadow-top"),
              c = e.isHorizontal() ? s.find(".swiper-slide-shadow-right") : s.find(".swiper-slide-shadow-bottom");
          0 === p.length && (p = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "left" : "top") + '"></div>'), s.append(p)), 0 === c.length && (c = L('<div class="swiper-slide-shadow-' + (e.isHorizontal() ? "right" : "bottom") + '"></div>'), s.append(c)), p.length && (p[0].style.opacity = Math.max(-r, 0)), c.length && (c[0].style.opacity = Math.max(r, 0));
        }

        s.transform("translate3d(" + l + "px, " + d + "px, 0px) rotateX(" + o + "deg) rotateY(" + n + "deg)");
      }
    },
    setTransition: function setTransition(e) {
      var a = this,
          t = a.slides,
          i = a.activeIndex,
          s = a.$wrapperEl;

      if (t.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e), a.params.virtualTranslate && 0 !== e) {
        var r = !1;
        t.eq(i).transitionEnd(function () {
          if (!r && a && !a.destroyed) {
            r = !0, a.animating = !1;

            for (var e = ["webkitTransitionEnd", "transitionend"], t = 0; t < e.length; t += 1) {
              s.trigger(e[t]);
            }
          }
        });
      }
    }
  },
      _ = {
    setTranslate: function setTranslate() {
      for (var e = this, t = e.width, a = e.height, i = e.slides, s = e.$wrapperEl, r = e.slidesSizesGrid, n = e.params.coverflowEffect, o = e.isHorizontal(), l = e.translate, d = o ? t / 2 - l : a / 2 - l, p = o ? n.rotate : -n.rotate, c = n.depth, u = 0, h = i.length; u < h; u += 1) {
        var v = i.eq(u),
            f = r[u],
            m = (d - v[0].swiperSlideOffset - f / 2) / f * n.modifier,
            g = o ? p * m : 0,
            b = o ? 0 : p * m,
            w = -c * Math.abs(m),
            y = o ? 0 : n.stretch * m,
            x = o ? n.stretch * m : 0;
        Math.abs(x) < .001 && (x = 0), Math.abs(y) < .001 && (y = 0), Math.abs(w) < .001 && (w = 0), Math.abs(g) < .001 && (g = 0), Math.abs(b) < .001 && (b = 0);
        var T = "translate3d(" + x + "px," + y + "px," + w + "px)  rotateX(" + b + "deg) rotateY(" + g + "deg)";

        if (v.transform(T), v[0].style.zIndex = 1 - Math.abs(Math.round(m)), n.slideShadows) {
          var E = o ? v.find(".swiper-slide-shadow-left") : v.find(".swiper-slide-shadow-top"),
              S = o ? v.find(".swiper-slide-shadow-right") : v.find(".swiper-slide-shadow-bottom");
          0 === E.length && (E = L('<div class="swiper-slide-shadow-' + (o ? "left" : "top") + '"></div>'), v.append(E)), 0 === S.length && (S = L('<div class="swiper-slide-shadow-' + (o ? "right" : "bottom") + '"></div>'), v.append(S)), E.length && (E[0].style.opacity = 0 < m ? m : 0), S.length && (S[0].style.opacity = 0 < -m ? -m : 0);
        }
      }

      (te.pointerEvents || te.prefixedPointerEvents) && (s[0].style.perspectiveOrigin = d + "px 50%");
    },
    setTransition: function setTransition(e) {
      this.slides.transition(e).find(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").transition(e);
    }
  },
      Z = {
    init: function init() {
      var e = this,
          t = e.params.thumbs,
          a = e.constructor;
      t.swiper instanceof a ? (e.thumbs.swiper = t.swiper, ee.extend(e.thumbs.swiper.originalParams, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      }), ee.extend(e.thumbs.swiper.params, {
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      })) : ee.isObject(t.swiper) && (e.thumbs.swiper = new a(ee.extend({}, t.swiper, {
        watchSlidesVisibility: !0,
        watchSlidesProgress: !0,
        slideToClickedSlide: !1
      })), e.thumbs.swiperCreated = !0), e.thumbs.swiper.$el.addClass(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", e.thumbs.onThumbClick);
    },
    onThumbClick: function onThumbClick() {
      var e = this,
          t = e.thumbs.swiper;

      if (t) {
        var a = t.clickedIndex,
            i = t.clickedSlide;

        if (!(i && L(i).hasClass(e.params.thumbs.slideThumbActiveClass) || null == a)) {
          var s;

          if (s = t.params.loop ? parseInt(L(t.clickedSlide).attr("data-swiper-slide-index"), 10) : a, e.params.loop) {
            var r = e.activeIndex;
            e.slides.eq(r).hasClass(e.params.slideDuplicateClass) && (e.loopFix(), e._clientLeft = e.$wrapperEl[0].clientLeft, r = e.activeIndex);
            var n = e.slides.eq(r).prevAll('[data-swiper-slide-index="' + s + '"]').eq(0).index(),
                o = e.slides.eq(r).nextAll('[data-swiper-slide-index="' + s + '"]').eq(0).index();
            s = void 0 === n ? o : void 0 === o ? n : o - r < r - n ? o : n;
          }

          e.slideTo(s);
        }
      }
    },
    update: function update(e) {
      var t = this,
          a = t.thumbs.swiper;

      if (a) {
        var i = "auto" === a.params.slidesPerView ? a.slidesPerViewDynamic() : a.params.slidesPerView;

        if (t.realIndex !== a.realIndex) {
          var s,
              r = a.activeIndex;

          if (a.params.loop) {
            a.slides.eq(r).hasClass(a.params.slideDuplicateClass) && (a.loopFix(), a._clientLeft = a.$wrapperEl[0].clientLeft, r = a.activeIndex);
            var n = a.slides.eq(r).prevAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index(),
                o = a.slides.eq(r).nextAll('[data-swiper-slide-index="' + t.realIndex + '"]').eq(0).index();
            s = void 0 === n ? o : void 0 === o ? n : o - r == r - n ? r : o - r < r - n ? o : n;
          } else s = t.realIndex;

          a.visibleSlidesIndexes.indexOf(s) < 0 && (a.params.centeredSlides ? s = r < s ? s - Math.floor(i / 2) + 1 : s + Math.floor(i / 2) - 1 : r < s && (s = s - i + 1), a.slideTo(s, e ? 0 : void 0));
        }

        var l = 1,
            d = t.params.thumbs.slideThumbActiveClass;
        if (1 < t.params.slidesPerView && !t.params.centeredSlides && (l = t.params.slidesPerView), a.slides.removeClass(d), a.params.loop) for (var p = 0; p < l; p += 1) {
          a.$wrapperEl.children('[data-swiper-slide-index="' + (t.realIndex + p) + '"]').addClass(d);
        } else for (var c = 0; c < l; c += 1) {
          a.slides.eq(t.realIndex + c).addClass(d);
        }
      }
    }
  },
      Q = [E, S, C, M, P, $, O, {
    name: "mousewheel",
    params: {
      mousewheel: {
        enabled: !1,
        releaseOnEdges: !1,
        invert: !1,
        forceToAxis: !1,
        sensitivity: 1,
        eventsTarged: "container"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        mousewheel: {
          enabled: !1,
          enable: A.enable.bind(e),
          disable: A.disable.bind(e),
          handle: A.handle.bind(e),
          handleMouseEnter: A.handleMouseEnter.bind(e),
          handleMouseLeave: A.handleMouseLeave.bind(e),
          lastScrollTime: ee.now()
        }
      });
    },
    on: {
      init: function init() {
        this.params.mousewheel.enabled && this.mousewheel.enable();
      },
      destroy: function destroy() {
        this.mousewheel.enabled && this.mousewheel.disable();
      }
    }
  }, {
    name: "navigation",
    params: {
      navigation: {
        nextEl: null,
        prevEl: null,
        hideOnClick: !1,
        disabledClass: "swiper-button-disabled",
        hiddenClass: "swiper-button-hidden",
        lockClass: "swiper-button-lock"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        navigation: {
          init: H.init.bind(e),
          update: H.update.bind(e),
          destroy: H.destroy.bind(e),
          onNextClick: H.onNextClick.bind(e),
          onPrevClick: H.onPrevClick.bind(e)
        }
      });
    },
    on: {
      init: function init() {
        this.navigation.init(), this.navigation.update();
      },
      toEdge: function toEdge() {
        this.navigation.update();
      },
      fromEdge: function fromEdge() {
        this.navigation.update();
      },
      destroy: function destroy() {
        this.navigation.destroy();
      },
      click: function click(e) {
        var t,
            a = this,
            i = a.navigation,
            s = i.$nextEl,
            r = i.$prevEl;
        !a.params.navigation.hideOnClick || L(e.target).is(r) || L(e.target).is(s) || (s ? t = s.hasClass(a.params.navigation.hiddenClass) : r && (t = r.hasClass(a.params.navigation.hiddenClass)), !0 === t ? a.emit("navigationShow", a) : a.emit("navigationHide", a), s && s.toggleClass(a.params.navigation.hiddenClass), r && r.toggleClass(a.params.navigation.hiddenClass));
      }
    }
  }, {
    name: "pagination",
    params: {
      pagination: {
        el: null,
        bulletElement: "span",
        clickable: !1,
        hideOnClick: !1,
        renderBullet: null,
        renderProgressbar: null,
        renderFraction: null,
        renderCustom: null,
        progressbarOpposite: !1,
        type: "bullets",
        dynamicBullets: !1,
        dynamicMainBullets: 1,
        formatFractionCurrent: function formatFractionCurrent(e) {
          return e;
        },
        formatFractionTotal: function formatFractionTotal(e) {
          return e;
        },
        bulletClass: "swiper-pagination-bullet",
        bulletActiveClass: "swiper-pagination-bullet-active",
        modifierClass: "swiper-pagination-",
        currentClass: "swiper-pagination-current",
        totalClass: "swiper-pagination-total",
        hiddenClass: "swiper-pagination-hidden",
        progressbarFillClass: "swiper-pagination-progressbar-fill",
        progressbarOppositeClass: "swiper-pagination-progressbar-opposite",
        clickableClass: "swiper-pagination-clickable",
        lockClass: "swiper-pagination-lock"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        pagination: {
          init: N.init.bind(e),
          render: N.render.bind(e),
          update: N.update.bind(e),
          destroy: N.destroy.bind(e),
          dynamicBulletIndex: 0
        }
      });
    },
    on: {
      init: function init() {
        this.pagination.init(), this.pagination.render(), this.pagination.update();
      },
      activeIndexChange: function activeIndexChange() {
        this.params.loop ? this.pagination.update() : void 0 === this.snapIndex && this.pagination.update();
      },
      snapIndexChange: function snapIndexChange() {
        this.params.loop || this.pagination.update();
      },
      slidesLengthChange: function slidesLengthChange() {
        this.params.loop && (this.pagination.render(), this.pagination.update());
      },
      snapGridLengthChange: function snapGridLengthChange() {
        this.params.loop || (this.pagination.render(), this.pagination.update());
      },
      destroy: function destroy() {
        this.pagination.destroy();
      },
      click: function click(e) {
        var t = this;
        t.params.pagination.el && t.params.pagination.hideOnClick && 0 < t.pagination.$el.length && !L(e.target).hasClass(t.params.pagination.bulletClass) && (!0 === t.pagination.$el.hasClass(t.params.pagination.hiddenClass) ? t.emit("paginationShow", t) : t.emit("paginationHide", t), t.pagination.$el.toggleClass(t.params.pagination.hiddenClass));
      }
    }
  }, {
    name: "scrollbar",
    params: {
      scrollbar: {
        el: null,
        dragSize: "auto",
        hide: !1,
        draggable: !1,
        snapOnRelease: !0,
        lockClass: "swiper-scrollbar-lock",
        dragClass: "swiper-scrollbar-drag"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        scrollbar: {
          init: G.init.bind(e),
          destroy: G.destroy.bind(e),
          updateSize: G.updateSize.bind(e),
          setTranslate: G.setTranslate.bind(e),
          setTransition: G.setTransition.bind(e),
          enableDraggable: G.enableDraggable.bind(e),
          disableDraggable: G.disableDraggable.bind(e),
          setDragPosition: G.setDragPosition.bind(e),
          onDragStart: G.onDragStart.bind(e),
          onDragMove: G.onDragMove.bind(e),
          onDragEnd: G.onDragEnd.bind(e),
          isTouched: !1,
          timeout: null,
          dragTimeout: null
        }
      });
    },
    on: {
      init: function init() {
        this.scrollbar.init(), this.scrollbar.updateSize(), this.scrollbar.setTranslate();
      },
      update: function update() {
        this.scrollbar.updateSize();
      },
      resize: function resize() {
        this.scrollbar.updateSize();
      },
      observerUpdate: function observerUpdate() {
        this.scrollbar.updateSize();
      },
      setTranslate: function setTranslate() {
        this.scrollbar.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.scrollbar.setTransition(e);
      },
      destroy: function destroy() {
        this.scrollbar.destroy();
      }
    }
  }, {
    name: "parallax",
    params: {
      parallax: {
        enabled: !1
      }
    },
    create: function create() {
      ee.extend(this, {
        parallax: {
          setTransform: B.setTransform.bind(this),
          setTranslate: B.setTranslate.bind(this),
          setTransition: B.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        this.params.parallax.enabled && (this.params.watchSlidesProgress = !0, this.originalParams.watchSlidesProgress = !0);
      },
      init: function init() {
        this.params.parallax.enabled && this.parallax.setTranslate();
      },
      setTranslate: function setTranslate() {
        this.params.parallax.enabled && this.parallax.setTranslate();
      },
      setTransition: function setTransition(e) {
        this.params.parallax.enabled && this.parallax.setTransition(e);
      }
    }
  }, {
    name: "zoom",
    params: {
      zoom: {
        enabled: !1,
        maxRatio: 3,
        minRatio: 1,
        toggle: !0,
        containerClass: "swiper-zoom-container",
        zoomedSlideClass: "swiper-slide-zoomed"
      }
    },
    create: function create() {
      var i = this,
          t = {
        enabled: !1,
        scale: 1,
        currentScale: 1,
        isScaling: !1,
        gesture: {
          $slideEl: void 0,
          slideWidth: void 0,
          slideHeight: void 0,
          $imageEl: void 0,
          $imageWrapEl: void 0,
          maxRatio: 3
        },
        image: {
          isTouched: void 0,
          isMoved: void 0,
          currentX: void 0,
          currentY: void 0,
          minX: void 0,
          minY: void 0,
          maxX: void 0,
          maxY: void 0,
          width: void 0,
          height: void 0,
          startX: void 0,
          startY: void 0,
          touchesStart: {},
          touchesCurrent: {}
        },
        velocity: {
          x: void 0,
          y: void 0,
          prevPositionX: void 0,
          prevPositionY: void 0,
          prevTime: void 0
        }
      };
      "onGestureStart onGestureChange onGestureEnd onTouchStart onTouchMove onTouchEnd onTransitionEnd toggle enable disable in out".split(" ").forEach(function (e) {
        t[e] = X[e].bind(i);
      }), ee.extend(i, {
        zoom: t
      });
      var s = 1;
      Object.defineProperty(i.zoom, "scale", {
        get: function get() {
          return s;
        },
        set: function set(e) {
          if (s !== e) {
            var t = i.zoom.gesture.$imageEl ? i.zoom.gesture.$imageEl[0] : void 0,
                a = i.zoom.gesture.$slideEl ? i.zoom.gesture.$slideEl[0] : void 0;
            i.emit("zoomChange", e, t, a);
          }

          s = e;
        }
      });
    },
    on: {
      init: function init() {
        this.params.zoom.enabled && this.zoom.enable();
      },
      destroy: function destroy() {
        this.zoom.disable();
      },
      touchStart: function touchStart(e) {
        this.zoom.enabled && this.zoom.onTouchStart(e);
      },
      touchEnd: function touchEnd(e) {
        this.zoom.enabled && this.zoom.onTouchEnd(e);
      },
      doubleTap: function doubleTap(e) {
        this.params.zoom.enabled && this.zoom.enabled && this.params.zoom.toggle && this.zoom.toggle(e);
      },
      transitionEnd: function transitionEnd() {
        this.zoom.enabled && this.params.zoom.enabled && this.zoom.onTransitionEnd();
      }
    }
  }, {
    name: "lazy",
    params: {
      lazy: {
        enabled: !1,
        loadPrevNext: !1,
        loadPrevNextAmount: 1,
        loadOnTransitionStart: !1,
        elementClass: "swiper-lazy",
        loadingClass: "swiper-lazy-loading",
        loadedClass: "swiper-lazy-loaded",
        preloaderClass: "swiper-lazy-preloader"
      }
    },
    create: function create() {
      ee.extend(this, {
        lazy: {
          initialImageLoaded: !1,
          load: Y.load.bind(this),
          loadInSlide: Y.loadInSlide.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        this.params.lazy.enabled && this.params.preloadImages && (this.params.preloadImages = !1);
      },
      init: function init() {
        this.params.lazy.enabled && !this.params.loop && 0 === this.params.initialSlide && this.lazy.load();
      },
      scroll: function scroll() {
        this.params.freeMode && !this.params.freeModeSticky && this.lazy.load();
      },
      resize: function resize() {
        this.params.lazy.enabled && this.lazy.load();
      },
      scrollbarDragMove: function scrollbarDragMove() {
        this.params.lazy.enabled && this.lazy.load();
      },
      transitionStart: function transitionStart() {
        var e = this;
        e.params.lazy.enabled && (e.params.lazy.loadOnTransitionStart || !e.params.lazy.loadOnTransitionStart && !e.lazy.initialImageLoaded) && e.lazy.load();
      },
      transitionEnd: function transitionEnd() {
        this.params.lazy.enabled && !this.params.lazy.loadOnTransitionStart && this.lazy.load();
      }
    }
  }, {
    name: "controller",
    params: {
      controller: {
        control: void 0,
        inverse: !1,
        by: "slide"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        controller: {
          control: e.params.controller.control,
          getInterpolateFunction: V.getInterpolateFunction.bind(e),
          setTranslate: V.setTranslate.bind(e),
          setTransition: V.setTransition.bind(e)
        }
      });
    },
    on: {
      update: function update() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      resize: function resize() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      observerUpdate: function observerUpdate() {
        this.controller.control && this.controller.spline && (this.controller.spline = void 0, delete this.controller.spline);
      },
      setTranslate: function setTranslate(e, t) {
        this.controller.control && this.controller.setTranslate(e, t);
      },
      setTransition: function setTransition(e, t) {
        this.controller.control && this.controller.setTransition(e, t);
      }
    }
  }, {
    name: "a11y",
    params: {
      a11y: {
        enabled: !0,
        notificationClass: "swiper-notification",
        prevSlideMessage: "Previous slide",
        nextSlideMessage: "Next slide",
        firstSlideMessage: "This is the first slide",
        lastSlideMessage: "This is the last slide",
        paginationBulletMessage: "Go to slide {{index}}"
      }
    },
    create: function create() {
      var t = this;
      ee.extend(t, {
        a11y: {
          liveRegion: L('<span class="' + t.params.a11y.notificationClass + '" aria-live="assertive" aria-atomic="true"></span>')
        }
      }), Object.keys(F).forEach(function (e) {
        t.a11y[e] = F[e].bind(t);
      });
    },
    on: {
      init: function init() {
        this.params.a11y.enabled && (this.a11y.init(), this.a11y.updateNavigation());
      },
      toEdge: function toEdge() {
        this.params.a11y.enabled && this.a11y.updateNavigation();
      },
      fromEdge: function fromEdge() {
        this.params.a11y.enabled && this.a11y.updateNavigation();
      },
      paginationUpdate: function paginationUpdate() {
        this.params.a11y.enabled && this.a11y.updatePagination();
      },
      destroy: function destroy() {
        this.params.a11y.enabled && this.a11y.destroy();
      }
    }
  }, {
    name: "history",
    params: {
      history: {
        enabled: !1,
        replaceState: !1,
        key: "slides"
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        history: {
          init: R.init.bind(e),
          setHistory: R.setHistory.bind(e),
          setHistoryPopState: R.setHistoryPopState.bind(e),
          scrollToSlide: R.scrollToSlide.bind(e),
          destroy: R.destroy.bind(e)
        }
      });
    },
    on: {
      init: function init() {
        this.params.history.enabled && this.history.init();
      },
      destroy: function destroy() {
        this.params.history.enabled && this.history.destroy();
      },
      transitionEnd: function transitionEnd() {
        this.history.initialized && this.history.setHistory(this.params.history.key, this.activeIndex);
      }
    }
  }, {
    name: "hash-navigation",
    params: {
      hashNavigation: {
        enabled: !1,
        replaceState: !1,
        watchState: !1
      }
    },
    create: function create() {
      var e = this;
      ee.extend(e, {
        hashNavigation: {
          initialized: !1,
          init: q.init.bind(e),
          destroy: q.destroy.bind(e),
          setHash: q.setHash.bind(e),
          onHashCange: q.onHashCange.bind(e)
        }
      });
    },
    on: {
      init: function init() {
        this.params.hashNavigation.enabled && this.hashNavigation.init();
      },
      destroy: function destroy() {
        this.params.hashNavigation.enabled && this.hashNavigation.destroy();
      },
      transitionEnd: function transitionEnd() {
        this.hashNavigation.initialized && this.hashNavigation.setHash();
      }
    }
  }, {
    name: "autoplay",
    params: {
      autoplay: {
        enabled: !1,
        delay: 3e3,
        waitForTransition: !0,
        disableOnInteraction: !0,
        stopOnLastSlide: !1,
        reverseDirection: !1
      }
    },
    create: function create() {
      var t = this;
      ee.extend(t, {
        autoplay: {
          running: !1,
          paused: !1,
          run: W.run.bind(t),
          start: W.start.bind(t),
          stop: W.stop.bind(t),
          pause: W.pause.bind(t),
          onTransitionEnd: function onTransitionEnd(e) {
            t && !t.destroyed && t.$wrapperEl && e.target === this && (t.$wrapperEl[0].removeEventListener("transitionend", t.autoplay.onTransitionEnd), t.$wrapperEl[0].removeEventListener("webkitTransitionEnd", t.autoplay.onTransitionEnd), t.autoplay.paused = !1, t.autoplay.running ? t.autoplay.run() : t.autoplay.stop());
          }
        }
      });
    },
    on: {
      init: function init() {
        this.params.autoplay.enabled && this.autoplay.start();
      },
      beforeTransitionStart: function beforeTransitionStart(e, t) {
        this.autoplay.running && (t || !this.params.autoplay.disableOnInteraction ? this.autoplay.pause(e) : this.autoplay.stop());
      },
      sliderFirstMove: function sliderFirstMove() {
        this.autoplay.running && (this.params.autoplay.disableOnInteraction ? this.autoplay.stop() : this.autoplay.pause());
      },
      destroy: function destroy() {
        this.autoplay.running && this.autoplay.stop();
      }
    }
  }, {
    name: "effect-fade",
    params: {
      fadeEffect: {
        crossFade: !1
      }
    },
    create: function create() {
      ee.extend(this, {
        fadeEffect: {
          setTranslate: j.setTranslate.bind(this),
          setTransition: j.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this;

        if ("fade" === e.params.effect) {
          e.classNames.push(e.params.containerModifierClass + "fade");
          var t = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !0
          };
          ee.extend(e.params, t), ee.extend(e.originalParams, t);
        }
      },
      setTranslate: function setTranslate() {
        "fade" === this.params.effect && this.fadeEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        "fade" === this.params.effect && this.fadeEffect.setTransition(e);
      }
    }
  }, {
    name: "effect-cube",
    params: {
      cubeEffect: {
        slideShadows: !0,
        shadow: !0,
        shadowOffset: 20,
        shadowScale: .94
      }
    },
    create: function create() {
      ee.extend(this, {
        cubeEffect: {
          setTranslate: U.setTranslate.bind(this),
          setTransition: U.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this;

        if ("cube" === e.params.effect) {
          e.classNames.push(e.params.containerModifierClass + "cube"), e.classNames.push(e.params.containerModifierClass + "3d");
          var t = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            resistanceRatio: 0,
            spaceBetween: 0,
            centeredSlides: !1,
            virtualTranslate: !0
          };
          ee.extend(e.params, t), ee.extend(e.originalParams, t);
        }
      },
      setTranslate: function setTranslate() {
        "cube" === this.params.effect && this.cubeEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        "cube" === this.params.effect && this.cubeEffect.setTransition(e);
      }
    }
  }, {
    name: "effect-flip",
    params: {
      flipEffect: {
        slideShadows: !0,
        limitRotation: !0
      }
    },
    create: function create() {
      ee.extend(this, {
        flipEffect: {
          setTranslate: K.setTranslate.bind(this),
          setTransition: K.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this;

        if ("flip" === e.params.effect) {
          e.classNames.push(e.params.containerModifierClass + "flip"), e.classNames.push(e.params.containerModifierClass + "3d");
          var t = {
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerGroup: 1,
            watchSlidesProgress: !0,
            spaceBetween: 0,
            virtualTranslate: !0
          };
          ee.extend(e.params, t), ee.extend(e.originalParams, t);
        }
      },
      setTranslate: function setTranslate() {
        "flip" === this.params.effect && this.flipEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        "flip" === this.params.effect && this.flipEffect.setTransition(e);
      }
    }
  }, {
    name: "effect-coverflow",
    params: {
      coverflowEffect: {
        rotate: 50,
        stretch: 0,
        depth: 100,
        modifier: 1,
        slideShadows: !0
      }
    },
    create: function create() {
      ee.extend(this, {
        coverflowEffect: {
          setTranslate: _.setTranslate.bind(this),
          setTransition: _.setTransition.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this;
        "coverflow" === e.params.effect && (e.classNames.push(e.params.containerModifierClass + "coverflow"), e.classNames.push(e.params.containerModifierClass + "3d"), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0);
      },
      setTranslate: function setTranslate() {
        "coverflow" === this.params.effect && this.coverflowEffect.setTranslate();
      },
      setTransition: function setTransition(e) {
        "coverflow" === this.params.effect && this.coverflowEffect.setTransition(e);
      }
    }
  }, {
    name: "thumbs",
    params: {
      thumbs: {
        swiper: null,
        slideThumbActiveClass: "swiper-slide-thumb-active",
        thumbsContainerClass: "swiper-container-thumbs"
      }
    },
    create: function create() {
      ee.extend(this, {
        thumbs: {
          swiper: null,
          init: Z.init.bind(this),
          update: Z.update.bind(this),
          onThumbClick: Z.onThumbClick.bind(this)
        }
      });
    },
    on: {
      beforeInit: function beforeInit() {
        var e = this.params.thumbs;
        e && e.swiper && (this.thumbs.init(), this.thumbs.update(!0));
      },
      slideChange: function slideChange() {
        this.thumbs.swiper && this.thumbs.update();
      },
      update: function update() {
        this.thumbs.swiper && this.thumbs.update();
      },
      resize: function resize() {
        this.thumbs.swiper && this.thumbs.update();
      },
      observerUpdate: function observerUpdate() {
        this.thumbs.swiper && this.thumbs.update();
      },
      setTransition: function setTransition(e) {
        var t = this.thumbs.swiper;
        t && t.setTransition(e);
      },
      beforeDestroy: function beforeDestroy() {
        var e = this.thumbs.swiper;
        e && this.thumbs.swiperCreated && e && e.destroy();
      }
    }
  }];
  return void 0 === T.use && (T.use = T.Class.use, T.installModule = T.Class.installModule), T.use(Q), T;
});
/*!
 * VERSION: 2.1.3
 * DATE: 2019-05-17
 * UPDATES AND DOCS AT: http://greensock.com
 * 
 * Includes all of the following: TweenLite, TweenMax, TimelineLite, TimelineMax, EasePack, CSSPlugin, RoundPropsPlugin, BezierPlugin, AttrPlugin, DirectionalRotationPlugin
 *
 * @license Copyright (c) 2008-2019, GreenSock. All rights reserved.
 * This work is subject to the terms at http://greensock.com/standard-license or for
 * Club GreenSock members, the software agreement that was issued with your membership.
 * 
 * @author: Jack Doyle, jack@greensock.com
 **/

var _gsScope = "undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window;

(_gsScope._gsQueue || (_gsScope._gsQueue = [])).push(function () {
  "use strict";

  _gsScope._gsDefine("TweenMax", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (a, b, c) {
    var d = function d(a) {
      var b,
          c = [],
          d = a.length;

      for (b = 0; b !== d; c.push(a[b++])) {
        ;
      }

      return c;
    },
        e = function e(a, b, c) {
      var d,
          e,
          f = a.cycle;

      for (d in f) {
        e = f[d], a[d] = "function" == typeof e ? e(c, b[c], b) : e[c % e.length];
      }

      delete a.cycle;
    },
        f = function f(a) {
      if ("function" == typeof a) return a;
      var b = "object" == _typeof(a) ? a : {
        each: a
      },
          c = b.ease,
          d = b.from || 0,
          e = b.base || 0,
          f = {},
          g = isNaN(d),
          h = b.axis,
          i = {
        center: .5,
        end: 1
      }[d] || 0;
      return function (a, j, k) {
        var l,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u = (k || b).length,
            v = f[u];

        if (!v) {
          if (t = "auto" === b.grid ? 0 : (b.grid || [1 / 0])[0], !t) {
            for (r = -(1 / 0); r < (r = k[t++].getBoundingClientRect().left) && u > t;) {
              ;
            }

            t--;
          }

          for (v = f[u] = [], l = g ? Math.min(t, u) * i - .5 : d % t, m = g ? u * i / t - .5 : d / t | 0, r = 0, s = 1 / 0, q = 0; u > q; q++) {
            n = q % t - l, o = m - (q / t | 0), v[q] = p = h ? Math.abs("y" === h ? o : n) : Math.sqrt(n * n + o * o), p > r && (r = p), s > p && (s = p);
          }

          v.max = r - s, v.min = s, v.v = u = b.amount || b.each * (t > u ? u - 1 : h ? "y" === h ? u / t : t : Math.max(t, u / t)) || 0, v.b = 0 > u ? e - u : e;
        }

        return u = (v[a] - v.min) / v.max, v.b + (c ? c.getRatio(u) : u) * v.v;
      };
    },
        g = function g(a, b, d) {
      c.call(this, a, b, d), this._cycle = 0, this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._repeat && this._uncache(!0), this.render = g.prototype.render;
    },
        h = 1e-8,
        i = c._internals,
        j = i.isSelector,
        k = i.isArray,
        l = g.prototype = c.to({}, .1, {}),
        m = [];

    g.version = "2.1.3", l.constructor = g, l.kill()._gc = !1, g.killTweensOf = g.killDelayedCallsTo = c.killTweensOf, g.getTweensOf = c.getTweensOf, g.lagSmoothing = c.lagSmoothing, g.ticker = c.ticker, g.render = c.render, g.distribute = f, l.invalidate = function () {
      return this._yoyo = this.vars.yoyo === !0 || !!this.vars.yoyoEase, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._yoyoEase = null, this._uncache(!0), c.prototype.invalidate.call(this);
    }, l.updateTo = function (a, b) {
      var d,
          e = this,
          f = e.ratio,
          g = e.vars.immediateRender || a.immediateRender;
      b && e._startTime < e._timeline._time && (e._startTime = e._timeline._time, e._uncache(!1), e._gc ? e._enabled(!0, !1) : e._timeline.insert(e, e._startTime - e._delay));

      for (d in a) {
        e.vars[d] = a[d];
      }

      if (e._initted || g) if (b) e._initted = !1, g && e.render(0, !0, !0);else if (e._gc && e._enabled(!0, !1), e._notifyPluginsOfEnabled && e._firstPT && c._onPluginEvent("_onDisable", e), e._time / e._duration > .998) {
        var h = e._totalTime;
        e.render(0, !0, !1), e._initted = !1, e.render(h, !0, !1);
      } else if (e._initted = !1, e._init(), e._time > 0 || g) for (var i, j = 1 / (1 - f), k = e._firstPT; k;) {
        i = k.s + k.c, k.c *= j, k.s = i - k.c, k = k._next;
      }
      return e;
    }, l.render = function (a, b, d) {
      this._initted || 0 === this._duration && this.vars.repeat && this.invalidate();
      var e,
          f,
          g,
          j,
          k,
          l,
          m,
          n,
          o,
          p = this,
          q = p._dirty ? p.totalDuration() : p._totalDuration,
          r = p._time,
          s = p._totalTime,
          t = p._cycle,
          u = p._duration,
          v = p._rawPrevTime;
      if (a >= q - h && a >= 0 ? (p._totalTime = q, p._cycle = p._repeat, p._yoyo && 0 !== (1 & p._cycle) ? (p._time = 0, p.ratio = p._ease._calcEnd ? p._ease.getRatio(0) : 0) : (p._time = u, p.ratio = p._ease._calcEnd ? p._ease.getRatio(1) : 1), p._reversed || (e = !0, f = "onComplete", d = d || p._timeline.autoRemoveChildren), 0 === u && (p._initted || !p.vars.lazy || d) && (p._startTime === p._timeline._duration && (a = 0), (0 > v || 0 >= a && a >= -h || v === h && "isPause" !== p.data) && v !== a && (d = !0, v > h && (f = "onReverseComplete")), p._rawPrevTime = n = !b || a || v === a ? a : h)) : h > a ? (p._totalTime = p._time = p._cycle = 0, p.ratio = p._ease._calcEnd ? p._ease.getRatio(0) : 0, (0 !== s || 0 === u && v > 0) && (f = "onReverseComplete", e = p._reversed), a > -h ? a = 0 : 0 > a && (p._active = !1, 0 === u && (p._initted || !p.vars.lazy || d) && (v >= 0 && (d = !0), p._rawPrevTime = n = !b || a || v === a ? a : h)), p._initted || (d = !0)) : (p._totalTime = p._time = a, 0 !== p._repeat && (j = u + p._repeatDelay, p._cycle = p._totalTime / j >> 0, 0 !== p._cycle && p._cycle === p._totalTime / j && a >= s && p._cycle--, p._time = p._totalTime - p._cycle * j, p._yoyo && 0 !== (1 & p._cycle) && (p._time = u - p._time, o = p._yoyoEase || p.vars.yoyoEase, o && (p._yoyoEase || (o !== !0 || p._initted ? p._yoyoEase = o = o === !0 ? p._ease : o instanceof Ease ? o : Ease.map[o] : (o = p.vars.ease, p._yoyoEase = o = o ? o instanceof Ease ? o : "function" == typeof o ? new Ease(o, p.vars.easeParams) : Ease.map[o] || c.defaultEase : c.defaultEase)), p.ratio = o ? 1 - o.getRatio((u - p._time) / u) : 0)), p._time > u ? p._time = u : p._time < 0 && (p._time = 0)), p._easeType && !o ? (k = p._time / u, l = p._easeType, m = p._easePower, (1 === l || 3 === l && k >= .5) && (k = 1 - k), 3 === l && (k *= 2), 1 === m ? k *= k : 2 === m ? k *= k * k : 3 === m ? k *= k * k * k : 4 === m && (k *= k * k * k * k), p.ratio = 1 === l ? 1 - k : 2 === l ? k : p._time / u < .5 ? k / 2 : 1 - k / 2) : o || (p.ratio = p._ease.getRatio(p._time / u))), r === p._time && !d && t === p._cycle) return void (s !== p._totalTime && p._onUpdate && (b || p._callback("onUpdate")));

      if (!p._initted) {
        if (p._init(), !p._initted || p._gc) return;
        if (!d && p._firstPT && (p.vars.lazy !== !1 && p._duration || p.vars.lazy && !p._duration)) return p._time = r, p._totalTime = s, p._rawPrevTime = v, p._cycle = t, i.lazyTweens.push(p), void (p._lazy = [a, b]);
        !p._time || e || o ? e && this._ease._calcEnd && !o && (p.ratio = p._ease.getRatio(0 === p._time ? 0 : 1)) : p.ratio = p._ease.getRatio(p._time / u);
      }

      for (p._lazy !== !1 && (p._lazy = !1), p._active || !p._paused && p._time !== r && a >= 0 && (p._active = !0), 0 === s && (2 === p._initted && a > 0 && p._init(), p._startAt && (a >= 0 ? p._startAt.render(a, !0, d) : f || (f = "_dummyGS")), p.vars.onStart && (0 !== p._totalTime || 0 === u) && (b || p._callback("onStart"))), g = p._firstPT; g;) {
        g.f ? g.t[g.p](g.c * p.ratio + g.s) : g.t[g.p] = g.c * p.ratio + g.s, g = g._next;
      }

      p._onUpdate && (0 > a && p._startAt && p._startTime && p._startAt.render(a, !0, d), b || (p._totalTime !== s || f) && p._callback("onUpdate")), p._cycle !== t && (b || p._gc || p.vars.onRepeat && p._callback("onRepeat")), f && (!p._gc || d) && (0 > a && p._startAt && !p._onUpdate && p._startTime && p._startAt.render(a, !0, d), e && (p._timeline.autoRemoveChildren && p._enabled(!1, !1), p._active = !1), !b && p.vars[f] && p._callback(f), 0 === u && p._rawPrevTime === h && n !== h && (p._rawPrevTime = 0));
    }, g.to = function (a, b, c) {
      return new g(a, b, c);
    }, g.from = function (a, b, c) {
      return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, new g(a, b, c);
    }, g.fromTo = function (a, b, c, d) {
      return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, new g(a, b, d);
    }, g.staggerTo = g.allTo = function (a, b, h, i, l, n, o) {
      var p,
          q,
          r,
          s,
          t = [],
          u = f(h.stagger || i),
          v = h.cycle,
          w = (h.startAt || m).cycle;

      for (k(a) || ("string" == typeof a && (a = c.selector(a) || a), j(a) && (a = d(a))), a = a || [], p = a.length - 1, r = 0; p >= r; r++) {
        q = {};

        for (s in h) {
          q[s] = h[s];
        }

        if (v && (e(q, a, r), null != q.duration && (b = q.duration, delete q.duration)), w) {
          w = q.startAt = {};

          for (s in h.startAt) {
            w[s] = h.startAt[s];
          }

          e(q.startAt, a, r);
        }

        q.delay = u(r, a[r], a) + (q.delay || 0), r === p && l && (q.onComplete = function () {
          h.onComplete && h.onComplete.apply(h.onCompleteScope || this, arguments), l.apply(o || h.callbackScope || this, n || m);
        }), t[r] = new g(a[r], b, q);
      }

      return t;
    }, g.staggerFrom = g.allFrom = function (a, b, c, d, e, f, h) {
      return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, g.staggerTo(a, b, c, d, e, f, h);
    }, g.staggerFromTo = g.allFromTo = function (a, b, c, d, e, f, h, i) {
      return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, g.staggerTo(a, b, d, e, f, h, i);
    }, g.delayedCall = function (a, b, c, d, e) {
      return new g(b, 0, {
        delay: a,
        onComplete: b,
        onCompleteParams: c,
        callbackScope: d,
        onReverseComplete: b,
        onReverseCompleteParams: c,
        immediateRender: !1,
        useFrames: e,
        overwrite: 0
      });
    }, g.set = function (a, b) {
      return new g(a, 0, b);
    }, g.isTweening = function (a) {
      return c.getTweensOf(a, !0).length > 0;
    };

    var n = function n(a, b) {
      for (var d = [], e = 0, f = a._first; f;) {
        f instanceof c ? d[e++] = f : (b && (d[e++] = f), d = d.concat(n(f, b)), e = d.length), f = f._next;
      }

      return d;
    },
        o = g.getAllTweens = function (b) {
      return n(a._rootTimeline, b).concat(n(a._rootFramesTimeline, b));
    };

    g.killAll = function (a, c, d, e) {
      null == c && (c = !0), null == d && (d = !0);
      var f,
          g,
          h,
          i = o(0 != e),
          j = i.length,
          k = c && d && e;

      for (h = 0; j > h; h++) {
        g = i[h], (k || g instanceof b || (f = g.target === g.vars.onComplete) && d || c && !f) && (a ? g.totalTime(g._reversed ? 0 : g.totalDuration()) : g._enabled(!1, !1));
      }
    }, g.killChildTweensOf = function (a, b) {
      if (null != a) {
        var e,
            f,
            h,
            l,
            m,
            n = i.tweenLookup;
        if ("string" == typeof a && (a = c.selector(a) || a), j(a) && (a = d(a)), k(a)) for (l = a.length; --l > -1;) {
          g.killChildTweensOf(a[l], b);
        } else {
          e = [];

          for (h in n) {
            for (f = n[h].target.parentNode; f;) {
              f === a && (e = e.concat(n[h].tweens)), f = f.parentNode;
            }
          }

          for (m = e.length, l = 0; m > l; l++) {
            b && e[l].totalTime(e[l].totalDuration()), e[l]._enabled(!1, !1);
          }
        }
      }
    };

    var p = function p(a, c, d, e) {
      c = c !== !1, d = d !== !1, e = e !== !1;

      for (var f, g, h = o(e), i = c && d && e, j = h.length; --j > -1;) {
        g = h[j], (i || g instanceof b || (f = g.target === g.vars.onComplete) && d || c && !f) && g.paused(a);
      }
    };

    return g.pauseAll = function (a, b, c) {
      p(!0, a, b, c);
    }, g.resumeAll = function (a, b, c) {
      p(!1, a, b, c);
    }, g.globalTimeScale = function (b) {
      var d = a._rootTimeline,
          e = c.ticker.time;
      return arguments.length ? (b = b || h, d._startTime = e - (e - d._startTime) * d._timeScale / b, d = a._rootFramesTimeline, e = c.ticker.frame, d._startTime = e - (e - d._startTime) * d._timeScale / b, d._timeScale = a._rootTimeline._timeScale = b, b) : d._timeScale;
    }, l.progress = function (a, b) {
      return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this.duration() ? this._time / this._duration : this.ratio;
    }, l.totalProgress = function (a, b) {
      return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration();
    }, l.time = function (a, b) {
      if (!arguments.length) return this._time;
      this._dirty && this.totalDuration();
      var c = this._duration,
          d = this._cycle,
          e = d * (c + this._repeatDelay);
      return a > c && (a = c), this.totalTime(this._yoyo && 1 & d ? c - a + e : this._repeat ? a + e : a, b);
    }, l.duration = function (b) {
      return arguments.length ? a.prototype.duration.call(this, b) : this._duration;
    }, l.totalDuration = function (a) {
      return arguments.length ? -1 === this._repeat ? this : this.duration((a - this._repeat * this._repeatDelay) / (this._repeat + 1)) : (this._dirty && (this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat, this._dirty = !1), this._totalDuration);
    }, l.repeat = function (a) {
      return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat;
    }, l.repeatDelay = function (a) {
      return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay;
    }, l.yoyo = function (a) {
      return arguments.length ? (this._yoyo = a, this) : this._yoyo;
    }, g;
  }, !0), _gsScope._gsDefine("TimelineLite", ["core.Animation", "core.SimpleTimeline", "TweenLite"], function (a, b, c) {
    var d = function d(a) {
      b.call(this, a);
      var c,
          d,
          e = this,
          f = e.vars;
      e._labels = {}, e.autoRemoveChildren = !!f.autoRemoveChildren, e.smoothChildTiming = !!f.smoothChildTiming, e._sortChildren = !0, e._onUpdate = f.onUpdate;

      for (d in f) {
        c = f[d], i(c) && -1 !== c.join("").indexOf("{self}") && (f[d] = e._swapSelfInParams(c));
      }

      i(f.tweens) && e.add(f.tweens, 0, f.align, f.stagger);
    },
        e = 1e-8,
        f = c._internals,
        g = d._internals = {},
        h = f.isSelector,
        i = f.isArray,
        j = f.lazyTweens,
        k = f.lazyRender,
        l = _gsScope._gsDefine.globals,
        m = function m(a) {
      var b,
          c = {};

      for (b in a) {
        c[b] = a[b];
      }

      return c;
    },
        n = function n(a, b, c) {
      var d,
          e,
          f = a.cycle;

      for (d in f) {
        e = f[d], a[d] = "function" == typeof e ? e(c, b[c], b) : e[c % e.length];
      }

      delete a.cycle;
    },
        o = g.pauseCallback = function () {},
        p = function p(a) {
      var b,
          c = [],
          d = a.length;

      for (b = 0; b !== d; c.push(a[b++])) {
        ;
      }

      return c;
    },
        q = function q(a, b, c, d) {
      var e = "immediateRender";
      return e in b || (b[e] = !(c && c[e] === !1 || d)), b;
    },
        r = function r(a) {
      if ("function" == typeof a) return a;
      var b = "object" == _typeof(a) ? a : {
        each: a
      },
          c = b.ease,
          d = b.from || 0,
          e = b.base || 0,
          f = {},
          g = isNaN(d),
          h = b.axis,
          i = {
        center: .5,
        end: 1
      }[d] || 0;
      return function (a, j, k) {
        var l,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u = (k || b).length,
            v = f[u];

        if (!v) {
          if (t = "auto" === b.grid ? 0 : (b.grid || [1 / 0])[0], !t) {
            for (r = -(1 / 0); r < (r = k[t++].getBoundingClientRect().left) && u > t;) {
              ;
            }

            t--;
          }

          for (v = f[u] = [], l = g ? Math.min(t, u) * i - .5 : d % t, m = g ? u * i / t - .5 : d / t | 0, r = 0, s = 1 / 0, q = 0; u > q; q++) {
            n = q % t - l, o = m - (q / t | 0), v[q] = p = h ? Math.abs("y" === h ? o : n) : Math.sqrt(n * n + o * o), p > r && (r = p), s > p && (s = p);
          }

          v.max = r - s, v.min = s, v.v = u = b.amount || b.each * (t > u ? u - 1 : h ? "y" === h ? u / t : t : Math.max(t, u / t)) || 0, v.b = 0 > u ? e - u : e;
        }

        return u = (v[a] - v.min) / v.max, v.b + (c ? c.getRatio(u) : u) * v.v;
      };
    },
        s = d.prototype = new b();

    return d.version = "2.1.3", d.distribute = r, s.constructor = d, s.kill()._gc = s._forcingPlayhead = s._hasPause = !1, s.to = function (a, b, d, e) {
      var f = d.repeat && l.TweenMax || c;
      return b ? this.add(new f(a, b, d), e) : this.set(a, d, e);
    }, s.from = function (a, b, d, e) {
      return this.add((d.repeat && l.TweenMax || c).from(a, b, q(this, d)), e);
    }, s.fromTo = function (a, b, d, e, f) {
      var g = e.repeat && l.TweenMax || c;
      return e = q(this, e, d), b ? this.add(g.fromTo(a, b, d, e), f) : this.set(a, e, f);
    }, s.staggerTo = function (a, b, e, f, g, i, j, k) {
      var l,
          o,
          q = new d({
        onComplete: i,
        onCompleteParams: j,
        callbackScope: k,
        smoothChildTiming: this.smoothChildTiming
      }),
          s = r(e.stagger || f),
          t = e.startAt,
          u = e.cycle;

      for ("string" == typeof a && (a = c.selector(a) || a), a = a || [], h(a) && (a = p(a)), o = 0; o < a.length; o++) {
        l = m(e), t && (l.startAt = m(t), t.cycle && n(l.startAt, a, o)), u && (n(l, a, o), null != l.duration && (b = l.duration, delete l.duration)), q.to(a[o], b, l, s(o, a[o], a));
      }

      return this.add(q, g);
    }, s.staggerFrom = function (a, b, c, d, e, f, g, h) {
      return c.runBackwards = !0, this.staggerTo(a, b, q(this, c), d, e, f, g, h);
    }, s.staggerFromTo = function (a, b, c, d, e, f, g, h, i) {
      return d.startAt = c, this.staggerTo(a, b, q(this, d, c), e, f, g, h, i);
    }, s.call = function (a, b, d, e) {
      return this.add(c.delayedCall(0, a, b, d), e);
    }, s.set = function (a, b, d) {
      return this.add(new c(a, 0, q(this, b, null, !0)), d);
    }, d.exportRoot = function (a, b) {
      a = a || {}, null == a.smoothChildTiming && (a.smoothChildTiming = !0);
      var e,
          f,
          g,
          h,
          i = new d(a),
          j = i._timeline;

      for (null == b && (b = !0), j._remove(i, !0), i._startTime = 0, i._rawPrevTime = i._time = i._totalTime = j._time, g = j._first; g;) {
        h = g._next, b && g instanceof c && g.target === g.vars.onComplete || (f = g._startTime - g._delay, 0 > f && (e = 1), i.add(g, f)), g = h;
      }

      return j.add(i, 0), e && i.totalDuration(), i;
    }, s.add = function (e, f, g, h) {
      var j,
          k,
          l,
          m,
          n,
          o,
          p = this;

      if ("number" != typeof f && (f = p._parseTimeOrLabel(f, 0, !0, e)), !(e instanceof a)) {
        if (e instanceof Array || e && e.push && i(e)) {
          for (g = g || "normal", h = h || 0, j = f, k = e.length, l = 0; k > l; l++) {
            i(m = e[l]) && (m = new d({
              tweens: m
            })), p.add(m, j), "string" != typeof m && "function" != typeof m && ("sequence" === g ? j = m._startTime + m.totalDuration() / m._timeScale : "start" === g && (m._startTime -= m.delay())), j += h;
          }

          return p._uncache(!0);
        }

        if ("string" == typeof e) return p.addLabel(e, f);
        if ("function" != typeof e) throw "Cannot add " + e + " into the timeline; it is not a tween, timeline, function, or string.";
        e = c.delayedCall(0, e);
      }

      if (b.prototype.add.call(p, e, f), (e._time || !e._duration && e._initted) && (j = (p.rawTime() - e._startTime) * e._timeScale, (!e._duration || Math.abs(Math.max(0, Math.min(e.totalDuration(), j))) - e._totalTime > 1e-5) && e.render(j, !1, !1)), (p._gc || p._time === p._duration) && !p._paused && p._duration < p.duration()) for (n = p, o = n.rawTime() > e._startTime; n._timeline;) {
        o && n._timeline.smoothChildTiming ? n.totalTime(n._totalTime, !0) : n._gc && n._enabled(!0, !1), n = n._timeline;
      }
      return p;
    }, s.remove = function (b) {
      if (b instanceof a) {
        this._remove(b, !1);

        var c = b._timeline = b.vars.useFrames ? a._rootFramesTimeline : a._rootTimeline;
        return b._startTime = (b._paused ? b._pauseTime : c._time) - (b._reversed ? b.totalDuration() - b._totalTime : b._totalTime) / b._timeScale, this;
      }

      if (b instanceof Array || b && b.push && i(b)) {
        for (var d = b.length; --d > -1;) {
          this.remove(b[d]);
        }

        return this;
      }

      return "string" == typeof b ? this.removeLabel(b) : this.kill(null, b);
    }, s._remove = function (a, c) {
      b.prototype._remove.call(this, a, c);

      var d = this._last;
      return d ? this._time > this.duration() && (this._time = this._duration, this._totalTime = this._totalDuration) : this._time = this._totalTime = this._duration = this._totalDuration = 0, this;
    }, s.append = function (a, b) {
      return this.add(a, this._parseTimeOrLabel(null, b, !0, a));
    }, s.insert = s.insertMultiple = function (a, b, c, d) {
      return this.add(a, b || 0, c, d);
    }, s.appendMultiple = function (a, b, c, d) {
      return this.add(a, this._parseTimeOrLabel(null, b, !0, a), c, d);
    }, s.addLabel = function (a, b) {
      return this._labels[a] = this._parseTimeOrLabel(b), this;
    }, s.addPause = function (a, b, d, e) {
      var f = c.delayedCall(0, o, d, e || this);
      return f.vars.onComplete = f.vars.onReverseComplete = b, f.data = "isPause", this._hasPause = !0, this.add(f, a);
    }, s.removeLabel = function (a) {
      return delete this._labels[a], this;
    }, s.getLabelTime = function (a) {
      return null != this._labels[a] ? this._labels[a] : -1;
    }, s._parseTimeOrLabel = function (b, c, d, e) {
      var f, g;
      if (e instanceof a && e.timeline === this) this.remove(e);else if (e && (e instanceof Array || e.push && i(e))) for (g = e.length; --g > -1;) {
        e[g] instanceof a && e[g].timeline === this && this.remove(e[g]);
      }
      if (f = "number" != typeof b || c ? this.duration() > 99999999999 ? this.recent().endTime(!1) : this._duration : 0, "string" == typeof c) return this._parseTimeOrLabel(c, d && "number" == typeof b && null == this._labels[c] ? b - f : 0, d);
      if (c = c || 0, "string" != typeof b || !isNaN(b) && null == this._labels[b]) null == b && (b = f);else {
        if (g = b.indexOf("="), -1 === g) return null == this._labels[b] ? d ? this._labels[b] = f + c : c : this._labels[b] + c;
        c = parseInt(b.charAt(g - 1) + "1", 10) * Number(b.substr(g + 1)), b = g > 1 ? this._parseTimeOrLabel(b.substr(0, g - 1), 0, d) : f;
      }
      return Number(b) + c;
    }, s.seek = function (a, b) {
      return this.totalTime("number" == typeof a ? a : this._parseTimeOrLabel(a), b !== !1);
    }, s.stop = function () {
      return this.paused(!0);
    }, s.gotoAndPlay = function (a, b) {
      return this.play(a, b);
    }, s.gotoAndStop = function (a, b) {
      return this.pause(a, b);
    }, s.render = function (a, b, c) {
      this._gc && this._enabled(!0, !1);
      var d,
          f,
          g,
          h,
          i,
          l,
          m,
          n,
          o = this,
          p = o._time,
          q = o._dirty ? o.totalDuration() : o._totalDuration,
          r = o._startTime,
          s = o._timeScale,
          t = o._paused;

      if (p !== o._time && (a += o._time - p), o._hasPause && !o._forcingPlayhead && !b) {
        if (a > p) for (d = o._first; d && d._startTime <= a && !l;) {
          d._duration || "isPause" !== d.data || d.ratio || 0 === d._startTime && 0 === o._rawPrevTime || (l = d), d = d._next;
        } else for (d = o._last; d && d._startTime >= a && !l;) {
          d._duration || "isPause" === d.data && d._rawPrevTime > 0 && (l = d), d = d._prev;
        }
        l && (o._time = o._totalTime = a = l._startTime, n = o._startTime + (o._reversed ? o._duration - a : a) / o._timeScale);
      }

      if (a >= q - e && a >= 0) o._totalTime = o._time = q, o._reversed || o._hasPausedChild() || (f = !0, h = "onComplete", i = !!o._timeline.autoRemoveChildren, 0 === o._duration && (0 >= a && a >= -e || o._rawPrevTime < 0 || o._rawPrevTime === e) && o._rawPrevTime !== a && o._first && (i = !0, o._rawPrevTime > e && (h = "onReverseComplete"))), o._rawPrevTime = o._duration || !b || a || o._rawPrevTime === a ? a : e, a = q + 1e-4;else if (e > a) {
        if (o._totalTime = o._time = 0, a > -e && (a = 0), (0 !== p || 0 === o._duration && o._rawPrevTime !== e && (o._rawPrevTime > 0 || 0 > a && o._rawPrevTime >= 0)) && (h = "onReverseComplete", f = o._reversed), 0 > a) o._active = !1, o._timeline.autoRemoveChildren && o._reversed ? (i = f = !0, h = "onReverseComplete") : o._rawPrevTime >= 0 && o._first && (i = !0), o._rawPrevTime = a;else {
          if (o._rawPrevTime = o._duration || !b || a || o._rawPrevTime === a ? a : e, 0 === a && f) for (d = o._first; d && 0 === d._startTime;) {
            d._duration || (f = !1), d = d._next;
          }
          a = 0, o._initted || (i = !0);
        }
      } else o._totalTime = o._time = o._rawPrevTime = a;

      if (o._time !== p && o._first || c || i || l) {
        if (o._initted || (o._initted = !0), o._active || !o._paused && o._time !== p && a > 0 && (o._active = !0), 0 === p && o.vars.onStart && (0 === o._time && o._duration || b || o._callback("onStart")), m = o._time, m >= p) for (d = o._first; d && (g = d._next, m === o._time && (!o._paused || t));) {
          (d._active || d._startTime <= m && !d._paused && !d._gc) && (l === d && (o.pause(), o._pauseTime = n), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)), d = g;
        } else for (d = o._last; d && (g = d._prev, m === o._time && (!o._paused || t));) {
          if (d._active || d._startTime <= p && !d._paused && !d._gc) {
            if (l === d) {
              for (l = d._prev; l && l.endTime() > o._time;) {
                l.render(l._reversed ? l.totalDuration() - (a - l._startTime) * l._timeScale : (a - l._startTime) * l._timeScale, b, c), l = l._prev;
              }

              l = null, o.pause(), o._pauseTime = n;
            }

            d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
          }

          d = g;
        }
        o._onUpdate && (b || (j.length && k(), o._callback("onUpdate"))), h && (o._gc || (r === o._startTime || s !== o._timeScale) && (0 === o._time || q >= o.totalDuration()) && (f && (j.length && k(), o._timeline.autoRemoveChildren && o._enabled(!1, !1), o._active = !1), !b && o.vars[h] && o._callback(h)));
      }
    }, s._hasPausedChild = function () {
      for (var a = this._first; a;) {
        if (a._paused || a instanceof d && a._hasPausedChild()) return !0;
        a = a._next;
      }

      return !1;
    }, s.getChildren = function (a, b, d, e) {
      e = e || -9999999999;

      for (var f = [], g = this._first, h = 0; g;) {
        g._startTime < e || (g instanceof c ? b !== !1 && (f[h++] = g) : (d !== !1 && (f[h++] = g), a !== !1 && (f = f.concat(g.getChildren(!0, b, d)), h = f.length))), g = g._next;
      }

      return f;
    }, s.getTweensOf = function (a, b) {
      var d,
          e,
          f = this._gc,
          g = [],
          h = 0;

      for (f && this._enabled(!0, !0), d = c.getTweensOf(a), e = d.length; --e > -1;) {
        (d[e].timeline === this || b && this._contains(d[e])) && (g[h++] = d[e]);
      }

      return f && this._enabled(!1, !0), g;
    }, s.recent = function () {
      return this._recent;
    }, s._contains = function (a) {
      for (var b = a.timeline; b;) {
        if (b === this) return !0;
        b = b.timeline;
      }

      return !1;
    }, s.shiftChildren = function (a, b, c) {
      c = c || 0;

      for (var d, e = this._first, f = this._labels; e;) {
        e._startTime >= c && (e._startTime += a), e = e._next;
      }

      if (b) for (d in f) {
        f[d] >= c && (f[d] += a);
      }
      return this._uncache(!0);
    }, s._kill = function (a, b) {
      if (!a && !b) return this._enabled(!1, !1);

      for (var c = b ? this.getTweensOf(b) : this.getChildren(!0, !0, !1), d = c.length, e = !1; --d > -1;) {
        c[d]._kill(a, b) && (e = !0);
      }

      return e;
    }, s.clear = function (a) {
      var b = this.getChildren(!1, !0, !0),
          c = b.length;

      for (this._time = this._totalTime = 0; --c > -1;) {
        b[c]._enabled(!1, !1);
      }

      return a !== !1 && (this._labels = {}), this._uncache(!0);
    }, s.invalidate = function () {
      for (var b = this._first; b;) {
        b.invalidate(), b = b._next;
      }

      return a.prototype.invalidate.call(this);
    }, s._enabled = function (a, c) {
      if (a === this._gc) for (var d = this._first; d;) {
        d._enabled(a, !0), d = d._next;
      }
      return b.prototype._enabled.call(this, a, c);
    }, s.totalTime = function (b, c, d) {
      this._forcingPlayhead = !0;
      var e = a.prototype.totalTime.apply(this, arguments);
      return this._forcingPlayhead = !1, e;
    }, s.duration = function (a) {
      return arguments.length ? (0 !== this.duration() && 0 !== a && this.timeScale(this._duration / a), this) : (this._dirty && this.totalDuration(), this._duration);
    }, s.totalDuration = function (a) {
      if (!arguments.length) {
        if (this._dirty) {
          for (var b, c, d = 0, e = this, f = e._last, g = 999999999999; f;) {
            b = f._prev, f._dirty && f.totalDuration(), f._startTime > g && e._sortChildren && !f._paused && !e._calculatingDuration ? (e._calculatingDuration = 1, e.add(f, f._startTime - f._delay), e._calculatingDuration = 0) : g = f._startTime, f._startTime < 0 && !f._paused && (d -= f._startTime, e._timeline.smoothChildTiming && (e._startTime += f._startTime / e._timeScale, e._time -= f._startTime, e._totalTime -= f._startTime, e._rawPrevTime -= f._startTime), e.shiftChildren(-f._startTime, !1, -9999999999), g = 0), c = f._startTime + f._totalDuration / f._timeScale, c > d && (d = c), f = b;
          }

          e._duration = e._totalDuration = d, e._dirty = !1;
        }

        return this._totalDuration;
      }

      return a && this.totalDuration() ? this.timeScale(this._totalDuration / a) : this;
    }, s.paused = function (b) {
      if (b === !1 && this._paused) for (var c = this._first; c;) {
        c._startTime === this._time && "isPause" === c.data && (c._rawPrevTime = 0), c = c._next;
      }
      return a.prototype.paused.apply(this, arguments);
    }, s.usesFrames = function () {
      for (var b = this._timeline; b._timeline;) {
        b = b._timeline;
      }

      return b === a._rootFramesTimeline;
    }, s.rawTime = function (a) {
      return a && (this._paused || this._repeat && this.time() > 0 && this.totalProgress() < 1) ? this._totalTime % (this._duration + this._repeatDelay) : this._paused ? this._totalTime : (this._timeline.rawTime(a) - this._startTime) * this._timeScale;
    }, d;
  }, !0), _gsScope._gsDefine("TimelineMax", ["TimelineLite", "TweenLite", "easing.Ease"], function (a, b, c) {
    var d = function d(b) {
      a.call(this, b), this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._cycle = 0, this._yoyo = !!this.vars.yoyo, this._dirty = !0;
    },
        e = 1e-8,
        f = b._internals,
        g = f.lazyTweens,
        h = f.lazyRender,
        i = _gsScope._gsDefine.globals,
        j = new c(null, null, 1, 0),
        k = d.prototype = new a();

    return k.constructor = d, k.kill()._gc = !1, d.version = "2.1.3", k.invalidate = function () {
      return this._yoyo = !!this.vars.yoyo, this._repeat = this.vars.repeat || 0, this._repeatDelay = this.vars.repeatDelay || 0, this._uncache(!0), a.prototype.invalidate.call(this);
    }, k.addCallback = function (a, c, d, e) {
      return this.add(b.delayedCall(0, a, d, e), c);
    }, k.removeCallback = function (a, b) {
      if (a) if (null == b) this._kill(null, a);else for (var c = this.getTweensOf(a, !1), d = c.length, e = this._parseTimeOrLabel(b); --d > -1;) {
        c[d]._startTime === e && c[d]._enabled(!1, !1);
      }
      return this;
    }, k.removePause = function (b) {
      return this.removeCallback(a._internals.pauseCallback, b);
    }, k.tweenTo = function (a, c) {
      c = c || {};
      var d,
          e,
          f,
          g = {
        ease: j,
        useFrames: this.usesFrames(),
        immediateRender: !1,
        lazy: !1
      },
          h = c.repeat && i.TweenMax || b;

      for (e in c) {
        g[e] = c[e];
      }

      return g.time = this._parseTimeOrLabel(a), d = Math.abs(Number(g.time) - this._time) / this._timeScale || .001, f = new h(this, d, g), g.onStart = function () {
        f.target.paused(!0), f.vars.time === f.target.time() || d !== f.duration() || f.isFromTo || f.duration(Math.abs(f.vars.time - f.target.time()) / f.target._timeScale).render(f.time(), !0, !0), c.onStart && c.onStart.apply(c.onStartScope || c.callbackScope || f, c.onStartParams || []);
      }, f;
    }, k.tweenFromTo = function (a, b, c) {
      c = c || {}, a = this._parseTimeOrLabel(a), c.startAt = {
        onComplete: this.seek,
        onCompleteParams: [a],
        callbackScope: this
      }, c.immediateRender = c.immediateRender !== !1;
      var d = this.tweenTo(b, c);
      return d.isFromTo = 1, d.duration(Math.abs(d.vars.time - a) / this._timeScale || .001);
    }, k.render = function (a, b, c) {
      this._gc && this._enabled(!0, !1);
      var d,
          f,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p = this,
          q = p._time,
          r = p._dirty ? p.totalDuration() : p._totalDuration,
          s = p._duration,
          t = p._totalTime,
          u = p._startTime,
          v = p._timeScale,
          w = p._rawPrevTime,
          x = p._paused,
          y = p._cycle;
      if (q !== p._time && (a += p._time - q), a >= r - e && a >= 0) p._locked || (p._totalTime = r, p._cycle = p._repeat), p._reversed || p._hasPausedChild() || (f = !0, j = "onComplete", k = !!p._timeline.autoRemoveChildren, 0 === p._duration && (0 >= a && a >= -e || 0 > w || w === e) && w !== a && p._first && (k = !0, w > e && (j = "onReverseComplete"))), p._rawPrevTime = p._duration || !b || a || p._rawPrevTime === a ? a : e, p._yoyo && 1 & p._cycle ? p._time = a = 0 : (p._time = s, a = s + 1e-4);else if (e > a) {
        if (p._locked || (p._totalTime = p._cycle = 0), p._time = 0, a > -e && (a = 0), (0 !== q || 0 === s && w !== e && (w > 0 || 0 > a && w >= 0) && !p._locked) && (j = "onReverseComplete", f = p._reversed), 0 > a) p._active = !1, p._timeline.autoRemoveChildren && p._reversed ? (k = f = !0, j = "onReverseComplete") : w >= 0 && p._first && (k = !0), p._rawPrevTime = a;else {
          if (p._rawPrevTime = s || !b || a || p._rawPrevTime === a ? a : e, 0 === a && f) for (d = p._first; d && 0 === d._startTime;) {
            d._duration || (f = !1), d = d._next;
          }
          a = 0, p._initted || (k = !0);
        }
      } else 0 === s && 0 > w && (k = !0), p._time = p._rawPrevTime = a, p._locked || (p._totalTime = a, 0 !== p._repeat && (l = s + p._repeatDelay, p._cycle = p._totalTime / l >> 0, p._cycle && p._cycle === p._totalTime / l && a >= t && p._cycle--, p._time = p._totalTime - p._cycle * l, p._yoyo && 1 & p._cycle && (p._time = s - p._time), p._time > s ? (p._time = s, a = s + 1e-4) : p._time < 0 ? p._time = a = 0 : a = p._time));

      if (p._hasPause && !p._forcingPlayhead && !b) {
        if (a = p._time, a > q || p._repeat && y !== p._cycle) for (d = p._first; d && d._startTime <= a && !m;) {
          d._duration || "isPause" !== d.data || d.ratio || 0 === d._startTime && 0 === p._rawPrevTime || (m = d), d = d._next;
        } else for (d = p._last; d && d._startTime >= a && !m;) {
          d._duration || "isPause" === d.data && d._rawPrevTime > 0 && (m = d), d = d._prev;
        }
        m && (o = p._startTime + (p._reversed ? p._duration - m._startTime : m._startTime) / p._timeScale, m._startTime < s && (p._time = p._rawPrevTime = a = m._startTime, p._totalTime = a + p._cycle * (p._totalDuration + p._repeatDelay)));
      }

      if (p._cycle !== y && !p._locked) {
        var z = p._yoyo && 0 !== (1 & y),
            A = z === (p._yoyo && 0 !== (1 & p._cycle)),
            B = p._totalTime,
            C = p._cycle,
            D = p._rawPrevTime,
            E = p._time;
        if (p._totalTime = y * s, p._cycle < y ? z = !z : p._totalTime += s, p._time = q, p._rawPrevTime = 0 === s ? w - 1e-4 : w, p._cycle = y, p._locked = !0, q = z ? 0 : s, p.render(q, b, 0 === s), b || p._gc || p.vars.onRepeat && (p._cycle = C, p._locked = !1, p._callback("onRepeat")), q !== p._time) return;
        if (A && (p._cycle = y, p._locked = !0, q = z ? s + 1e-4 : -1e-4, p.render(q, !0, !1)), p._locked = !1, p._paused && !x) return;
        p._time = E, p._totalTime = B, p._cycle = C, p._rawPrevTime = D;
      }

      if (!(p._time !== q && p._first || c || k || m)) return void (t !== p._totalTime && p._onUpdate && (b || p._callback("onUpdate")));
      if (p._initted || (p._initted = !0), p._active || !p._paused && p._totalTime !== t && a > 0 && (p._active = !0), 0 === t && p.vars.onStart && (0 === p._totalTime && p._totalDuration || b || p._callback("onStart")), n = p._time, n >= q) for (d = p._first; d && (i = d._next, n === p._time && (!p._paused || x));) {
        (d._active || d._startTime <= p._time && !d._paused && !d._gc) && (m === d && (p.pause(), p._pauseTime = o), d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c)), d = i;
      } else for (d = p._last; d && (i = d._prev, n === p._time && (!p._paused || x));) {
        if (d._active || d._startTime <= q && !d._paused && !d._gc) {
          if (m === d) {
            for (m = d._prev; m && m.endTime() > p._time;) {
              m.render(m._reversed ? m.totalDuration() - (a - m._startTime) * m._timeScale : (a - m._startTime) * m._timeScale, b, c), m = m._prev;
            }

            m = null, p.pause(), p._pauseTime = o;
          }

          d._reversed ? d.render((d._dirty ? d.totalDuration() : d._totalDuration) - (a - d._startTime) * d._timeScale, b, c) : d.render((a - d._startTime) * d._timeScale, b, c);
        }

        d = i;
      }
      p._onUpdate && (b || (g.length && h(), p._callback("onUpdate"))), j && (p._locked || p._gc || (u === p._startTime || v !== p._timeScale) && (0 === p._time || r >= p.totalDuration()) && (f && (g.length && h(), p._timeline.autoRemoveChildren && p._enabled(!1, !1), p._active = !1), !b && p.vars[j] && p._callback(j)));
    }, k.getActive = function (a, b, c) {
      var d,
          e,
          f = [],
          g = this.getChildren(a || null == a, b || null == a, !!c),
          h = 0,
          i = g.length;

      for (d = 0; i > d; d++) {
        e = g[d], e.isActive() && (f[h++] = e);
      }

      return f;
    }, k.getLabelAfter = function (a) {
      a || 0 !== a && (a = this._time);
      var b,
          c = this.getLabelsArray(),
          d = c.length;

      for (b = 0; d > b; b++) {
        if (c[b].time > a) return c[b].name;
      }

      return null;
    }, k.getLabelBefore = function (a) {
      null == a && (a = this._time);

      for (var b = this.getLabelsArray(), c = b.length; --c > -1;) {
        if (b[c].time < a) return b[c].name;
      }

      return null;
    }, k.getLabelsArray = function () {
      var a,
          b = [],
          c = 0;

      for (a in this._labels) {
        b[c++] = {
          time: this._labels[a],
          name: a
        };
      }

      return b.sort(function (a, b) {
        return a.time - b.time;
      }), b;
    }, k.invalidate = function () {
      return this._locked = !1, a.prototype.invalidate.call(this);
    }, k.progress = function (a, b) {
      return arguments.length ? this.totalTime(this.duration() * (this._yoyo && 0 !== (1 & this._cycle) ? 1 - a : a) + this._cycle * (this._duration + this._repeatDelay), b) : this._time / this.duration() || 0;
    }, k.totalProgress = function (a, b) {
      return arguments.length ? this.totalTime(this.totalDuration() * a, b) : this._totalTime / this.totalDuration() || 0;
    }, k.totalDuration = function (b) {
      return arguments.length ? -1 !== this._repeat && b ? this.timeScale(this.totalDuration() / b) : this : (this._dirty && (a.prototype.totalDuration.call(this), this._totalDuration = -1 === this._repeat ? 999999999999 : this._duration * (this._repeat + 1) + this._repeatDelay * this._repeat), this._totalDuration);
    }, k.time = function (a, b) {
      if (!arguments.length) return this._time;
      this._dirty && this.totalDuration();
      var c = this._duration,
          d = this._cycle,
          e = d * (c + this._repeatDelay);
      return a > c && (a = c), this.totalTime(this._yoyo && 1 & d ? c - a + e : this._repeat ? a + e : a, b);
    }, k.repeat = function (a) {
      return arguments.length ? (this._repeat = a, this._uncache(!0)) : this._repeat;
    }, k.repeatDelay = function (a) {
      return arguments.length ? (this._repeatDelay = a, this._uncache(!0)) : this._repeatDelay;
    }, k.yoyo = function (a) {
      return arguments.length ? (this._yoyo = a, this) : this._yoyo;
    }, k.currentLabel = function (a) {
      return arguments.length ? this.seek(a, !0) : this.getLabelBefore(this._time + e);
    }, d;
  }, !0), function () {
    var a = 180 / Math.PI,
        b = [],
        c = [],
        d = [],
        e = {},
        f = _gsScope._gsDefine.globals,
        g = function g(a, b, c, d) {
      c === d && (c = d - (d - b) / 1e6), a === b && (b = a + (c - a) / 1e6), this.a = a, this.b = b, this.c = c, this.d = d, this.da = d - a, this.ca = c - a, this.ba = b - a;
    },
        h = ",x,y,z,left,top,right,bottom,marginTop,marginLeft,marginRight,marginBottom,paddingLeft,paddingTop,paddingRight,paddingBottom,backgroundPosition,backgroundPosition_y,",
        i = function i(a, b, c, d) {
      var e = {
        a: a
      },
          f = {},
          g = {},
          h = {
        c: d
      },
          i = (a + b) / 2,
          j = (b + c) / 2,
          k = (c + d) / 2,
          l = (i + j) / 2,
          m = (j + k) / 2,
          n = (m - l) / 8;
      return e.b = i + (a - i) / 4, f.b = l + n, e.c = f.a = (e.b + f.b) / 2, f.c = g.a = (l + m) / 2, g.b = m - n, h.b = k + (d - k) / 4, g.c = h.a = (g.b + h.b) / 2, [e, f, g, h];
    },
        j = function j(a, e, f, g, h) {
      var j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w = a.length - 1,
          x = 0,
          y = a[0].a;

      for (j = 0; w > j; j++) {
        n = a[x], k = n.a, l = n.d, m = a[x + 1].d, h ? (t = b[j], u = c[j], v = (u + t) * e * .25 / (g ? .5 : d[j] || .5), o = l - (l - k) * (g ? .5 * e : 0 !== t ? v / t : 0), p = l + (m - l) * (g ? .5 * e : 0 !== u ? v / u : 0), q = l - (o + ((p - o) * (3 * t / (t + u) + .5) / 4 || 0))) : (o = l - (l - k) * e * .5, p = l + (m - l) * e * .5, q = l - (o + p) / 2), o += q, p += q, n.c = r = o, 0 !== j ? n.b = y : n.b = y = n.a + .6 * (n.c - n.a), n.da = l - k, n.ca = r - k, n.ba = y - k, f ? (s = i(k, y, r, l), a.splice(x, 1, s[0], s[1], s[2], s[3]), x += 4) : x++, y = p;
      }

      n = a[x], n.b = y, n.c = y + .4 * (n.d - y), n.da = n.d - n.a, n.ca = n.c - n.a, n.ba = y - n.a, f && (s = i(n.a, y, n.c, n.d), a.splice(x, 1, s[0], s[1], s[2], s[3]));
    },
        k = function k(a, d, e, f) {
      var h,
          i,
          j,
          k,
          l,
          m,
          n = [];
      if (f) for (a = [f].concat(a), i = a.length; --i > -1;) {
        "string" == typeof (m = a[i][d]) && "=" === m.charAt(1) && (a[i][d] = f[d] + Number(m.charAt(0) + m.substr(2)));
      }
      if (h = a.length - 2, 0 > h) return n[0] = new g(a[0][d], 0, 0, a[0][d]), n;

      for (i = 0; h > i; i++) {
        j = a[i][d], k = a[i + 1][d], n[i] = new g(j, 0, 0, k), e && (l = a[i + 2][d], b[i] = (b[i] || 0) + (k - j) * (k - j), c[i] = (c[i] || 0) + (l - k) * (l - k));
      }

      return n[i] = new g(a[i][d], 0, 0, a[i + 1][d]), n;
    },
        l = function (_l) {
      function l(_x, _x2, _x3, _x4, _x5, _x6) {
        return _l.apply(this, arguments);
      }

      l.toString = function () {
        return _l.toString();
      };

      return l;
    }(function (a, f, g, i, l, m) {
      var n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v = {},
          w = [],
          x = m || a[0];
      l = "string" == typeof l ? "," + l + "," : h, null == f && (f = 1);

      for (o in a[0]) {
        w.push(o);
      }

      if (a.length > 1) {
        for (u = a[a.length - 1], t = !0, n = w.length; --n > -1;) {
          if (o = w[n], Math.abs(x[o] - u[o]) > .05) {
            t = !1;
            break;
          }
        }

        t && (a = a.concat(), m && a.unshift(m), a.push(a[1]), m = a[a.length - 3]);
      }

      for (b.length = c.length = d.length = 0, n = w.length; --n > -1;) {
        o = w[n], e[o] = -1 !== l.indexOf("," + o + ","), v[o] = k(a, o, e[o], m);
      }

      for (n = b.length; --n > -1;) {
        b[n] = Math.sqrt(b[n]), c[n] = Math.sqrt(c[n]);
      }

      if (!i) {
        for (n = w.length; --n > -1;) {
          if (e[o]) for (p = v[w[n]], s = p.length - 1, q = 0; s > q; q++) {
            r = p[q + 1].da / c[q] + p[q].da / b[q] || 0, d[q] = (d[q] || 0) + r * r;
          }
        }

        for (n = d.length; --n > -1;) {
          d[n] = Math.sqrt(d[n]);
        }
      }

      for (n = w.length, q = g ? 4 : 1; --n > -1;) {
        o = w[n], p = v[o], j(p, f, g, i, e[o]), t && (p.splice(0, q), p.splice(p.length - q, q));
      }

      return v;
    }),
        m = function m(a, b, c) {
      b = b || "soft";
      var d,
          e,
          f,
          h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p = {},
          q = "cubic" === b ? 3 : 2,
          r = "soft" === b,
          s = [];
      if (r && c && (a = [c].concat(a)), null == a || a.length < q + 1) throw "invalid Bezier data";

      for (m in a[0]) {
        s.push(m);
      }

      for (j = s.length; --j > -1;) {
        for (m = s[j], p[m] = i = [], n = 0, l = a.length, k = 0; l > k; k++) {
          d = null == c ? a[k][m] : "string" == typeof (o = a[k][m]) && "=" === o.charAt(1) ? c[m] + Number(o.charAt(0) + o.substr(2)) : Number(o), r && k > 1 && l - 1 > k && (i[n++] = (d + i[n - 2]) / 2), i[n++] = d;
        }

        for (l = n - q + 1, n = 0, k = 0; l > k; k += q) {
          d = i[k], e = i[k + 1], f = i[k + 2], h = 2 === q ? 0 : i[k + 3], i[n++] = o = 3 === q ? new g(d, e, f, h) : new g(d, (2 * e + d) / 3, (2 * e + f) / 3, f);
        }

        i.length = n;
      }

      return p;
    },
        n = function n(a, b, c) {
      for (var d, e, f, g, h, i, j, k, l, m, n, o = 1 / c, p = a.length; --p > -1;) {
        for (m = a[p], f = m.a, g = m.d - f, h = m.c - f, i = m.b - f, d = e = 0, k = 1; c >= k; k++) {
          j = o * k, l = 1 - j, d = e - (e = (j * j * g + 3 * l * (j * h + l * i)) * j), n = p * c + k - 1, b[n] = (b[n] || 0) + d * d;
        }
      }
    },
        o = function o(a, b) {
      b = b >> 0 || 6;
      var c,
          d,
          e,
          f,
          g = [],
          h = [],
          i = 0,
          j = 0,
          k = b - 1,
          l = [],
          m = [];

      for (c in a) {
        n(a[c], g, b);
      }

      for (e = g.length, d = 0; e > d; d++) {
        i += Math.sqrt(g[d]), f = d % b, m[f] = i, f === k && (j += i, f = d / b >> 0, l[f] = m, h[f] = j, i = 0, m = []);
      }

      return {
        length: j,
        lengths: h,
        segments: l
      };
    },
        p = _gsScope._gsDefine.plugin({
      propName: "bezier",
      priority: -1,
      version: "1.3.9",
      API: 2,
      global: !0,
      init: function init(a, b, c) {
        this._target = a, b instanceof Array && (b = {
          values: b
        }), this._func = {}, this._mod = {}, this._props = [], this._timeRes = null == b.timeResolution ? 6 : parseInt(b.timeResolution, 10);
        var d,
            e,
            f,
            g,
            h,
            i = b.values || [],
            j = {},
            k = i[0],
            n = b.autoRotate || c.vars.orientToBezier;
        this._autoRotate = n ? n instanceof Array ? n : [["x", "y", "rotation", n === !0 ? 0 : Number(n) || 0]] : null;

        for (d in k) {
          this._props.push(d);
        }

        for (f = this._props.length; --f > -1;) {
          d = this._props[f], this._overwriteProps.push(d), e = this._func[d] = "function" == typeof a[d], j[d] = e ? a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)]() : parseFloat(a[d]), h || j[d] !== i[0][d] && (h = j);
        }

        if (this._beziers = "cubic" !== b.type && "quadratic" !== b.type && "soft" !== b.type ? l(i, isNaN(b.curviness) ? 1 : b.curviness, !1, "thruBasic" === b.type, b.correlate, h) : m(i, b.type, j), this._segCount = this._beziers[d].length, this._timeRes) {
          var p = o(this._beziers, this._timeRes);
          this._length = p.length, this._lengths = p.lengths, this._segments = p.segments, this._l1 = this._li = this._s1 = this._si = 0, this._l2 = this._lengths[0], this._curSeg = this._segments[0], this._s2 = this._curSeg[0], this._prec = 1 / this._curSeg.length;
        }

        if (n = this._autoRotate) for (this._initialRotations = [], n[0] instanceof Array || (this._autoRotate = n = [n]), f = n.length; --f > -1;) {
          for (g = 0; 3 > g; g++) {
            d = n[f][g], this._func[d] = "function" == typeof a[d] ? a[d.indexOf("set") || "function" != typeof a["get" + d.substr(3)] ? d : "get" + d.substr(3)] : !1;
          }

          d = n[f][2], this._initialRotations[f] = (this._func[d] ? this._func[d].call(this._target) : this._target[d]) || 0, this._overwriteProps.push(d);
        }
        return this._startRatio = c.vars.runBackwards ? 1 : 0, !0;
      },
      set: function set(b) {
        var c,
            d,
            e,
            f,
            g,
            h,
            i,
            j,
            k,
            l,
            m,
            n = this._segCount,
            o = this._func,
            p = this._target,
            q = b !== this._startRatio;

        if (this._timeRes) {
          if (k = this._lengths, l = this._curSeg, m = b * this._length, e = this._li, m > this._l2 && n - 1 > e) {
            for (j = n - 1; j > e && (this._l2 = k[++e]) <= m;) {
              ;
            }

            this._l1 = k[e - 1], this._li = e, this._curSeg = l = this._segments[e], this._s2 = l[this._s1 = this._si = 0];
          } else if (m < this._l1 && e > 0) {
            for (; e > 0 && (this._l1 = k[--e]) >= m;) {
              ;
            }

            0 === e && m < this._l1 ? this._l1 = 0 : e++, this._l2 = k[e], this._li = e, this._curSeg = l = this._segments[e], this._s1 = l[(this._si = l.length - 1) - 1] || 0, this._s2 = l[this._si];
          }

          if (c = e, m -= this._l1, e = this._si, m > this._s2 && e < l.length - 1) {
            for (j = l.length - 1; j > e && (this._s2 = l[++e]) <= m;) {
              ;
            }

            this._s1 = l[e - 1], this._si = e;
          } else if (m < this._s1 && e > 0) {
            for (; e > 0 && (this._s1 = l[--e]) >= m;) {
              ;
            }

            0 === e && m < this._s1 ? this._s1 = 0 : e++, this._s2 = l[e], this._si = e;
          }

          h = 1 === b ? 1 : (e + (m - this._s1) / (this._s2 - this._s1)) * this._prec || 0;
        } else c = 0 > b ? 0 : b >= 1 ? n - 1 : n * b >> 0, h = (b - c * (1 / n)) * n;

        for (d = 1 - h, e = this._props.length; --e > -1;) {
          f = this._props[e], g = this._beziers[f][c], i = (h * h * g.da + 3 * d * (h * g.ca + d * g.ba)) * h + g.a, this._mod[f] && (i = this._mod[f](i, p)), o[f] ? p[f](i) : p[f] = i;
        }

        if (this._autoRotate) {
          var r,
              s,
              t,
              u,
              v,
              w,
              x,
              y = this._autoRotate;

          for (e = y.length; --e > -1;) {
            f = y[e][2], w = y[e][3] || 0, x = y[e][4] === !0 ? 1 : a, g = this._beziers[y[e][0]], r = this._beziers[y[e][1]], g && r && (g = g[c], r = r[c], s = g.a + (g.b - g.a) * h, u = g.b + (g.c - g.b) * h, s += (u - s) * h, u += (g.c + (g.d - g.c) * h - u) * h, t = r.a + (r.b - r.a) * h, v = r.b + (r.c - r.b) * h, t += (v - t) * h, v += (r.c + (r.d - r.c) * h - v) * h, i = q ? Math.atan2(v - t, u - s) * x + w : this._initialRotations[e], this._mod[f] && (i = this._mod[f](i, p)), o[f] ? p[f](i) : p[f] = i);
          }
        }
      }
    }),
        q = p.prototype;

    p.bezierThrough = l, p.cubicToQuadratic = i, p._autoCSS = !0, p.quadraticToCubic = function (a, b, c) {
      return new g(a, (2 * b + a) / 3, (2 * b + c) / 3, c);
    }, p._cssRegister = function () {
      var a = f.CSSPlugin;

      if (a) {
        var b = a._internals,
            c = b._parseToProxy,
            d = b._setPluginRatio,
            e = b.CSSPropTween;

        b._registerComplexSpecialProp("bezier", {
          parser: function parser(a, b, f, g, h, i) {
            b instanceof Array && (b = {
              values: b
            }), i = new p();
            var j,
                k,
                l,
                m = b.values,
                n = m.length - 1,
                o = [],
                q = {};
            if (0 > n) return h;

            for (j = 0; n >= j; j++) {
              l = c(a, m[j], g, h, i, n !== j), o[j] = l.end;
            }

            for (k in b) {
              q[k] = b[k];
            }

            return q.values = o, h = new e(a, "bezier", 0, 0, l.pt, 2), h.data = l, h.plugin = i, h.setRatio = d, 0 === q.autoRotate && (q.autoRotate = !0), !q.autoRotate || q.autoRotate instanceof Array || (j = q.autoRotate === !0 ? 0 : Number(q.autoRotate), q.autoRotate = null != l.end.left ? [["left", "top", "rotation", j, !1]] : null != l.end.x ? [["x", "y", "rotation", j, !1]] : !1), q.autoRotate && (g._transform || g._enableTransforms(!1), l.autoRotate = g._target._gsTransform, l.proxy.rotation = l.autoRotate.rotation || 0, g._overwriteProps.push("rotation")), i._onInitTween(l.proxy, q, g._tween), h;
          }
        });
      }
    }, q._mod = function (a) {
      for (var b, c = this._overwriteProps, d = c.length; --d > -1;) {
        b = a[c[d]], b && "function" == typeof b && (this._mod[c[d]] = b);
      }
    }, q._kill = function (a) {
      var b,
          c,
          d = this._props;

      for (b in this._beziers) {
        if (b in a) for (delete this._beziers[b], delete this._func[b], c = d.length; --c > -1;) {
          d[c] === b && d.splice(c, 1);
        }
      }

      if (d = this._autoRotate) for (c = d.length; --c > -1;) {
        a[d[c][2]] && d.splice(c, 1);
      }
      return this._super._kill.call(this, a);
    };
  }(), _gsScope._gsDefine("plugins.CSSPlugin", ["plugins.TweenPlugin", "TweenLite"], function (a, b) {
    var c,
        d,
        e,
        f,
        g = function g() {
      a.call(this, "css"), this._overwriteProps.length = 0, this.setRatio = g.prototype.setRatio;
    },
        h = _gsScope._gsDefine.globals,
        i = {},
        j = g.prototype = new a("css");

    j.constructor = g, g.version = "2.1.3", g.API = 2, g.defaultTransformPerspective = 0, g.defaultSkewType = "compensated", g.defaultSmoothOrigin = !0, j = "px", g.suffixMap = {
      top: j,
      right: j,
      bottom: j,
      left: j,
      width: j,
      height: j,
      fontSize: j,
      padding: j,
      margin: j,
      perspective: j,
      lineHeight: ""
    };

    var k,
        l,
        m,
        n,
        o,
        p,
        q,
        r,
        s = /(?:\-|\.|\b)(\d|\.|e\-)+/g,
        t = /(?:\d|\-\d|\.\d|\-\.\d|\+=\d|\-=\d|\+=.\d|\-=\.\d)+/g,
        u = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b)/gi,
        v = /(?:\+=|\-=|\-|\b)[\d\-\.]+[a-zA-Z0-9]*(?:%|\b),?/gi,
        w = /(?![+-]?\d*\.?\d+|[+-]|e[+-]\d+)[^0-9]/g,
        x = /(?:\d|\-|\+|=|#|\.)*/g,
        y = /opacity *= *([^)]*)/i,
        z = /opacity:([^;]*)/i,
        A = /alpha\(opacity *=.+?\)/i,
        B = /^(rgb|hsl)/,
        C = /([A-Z])/g,
        D = /-([a-z])/gi,
        E = /(^(?:url\(\"|url\())|(?:(\"\))$|\)$)/gi,
        F = function F(a, b) {
      return b.toUpperCase();
    },
        G = /(?:Left|Right|Width)/i,
        H = /(M11|M12|M21|M22)=[\d\-\.e]+/gi,
        I = /progid\:DXImageTransform\.Microsoft\.Matrix\(.+?\)/i,
        J = /,(?=[^\)]*(?:\(|$))/gi,
        K = /[\s,\(]/i,
        L = Math.PI / 180,
        M = 180 / Math.PI,
        N = {},
        O = {
      style: {}
    },
        P = _gsScope.document || {
      createElement: function createElement() {
        return O;
      }
    },
        Q = function Q(a, b) {
      var c = P.createElementNS ? P.createElementNS(b || "http://www.w3.org/1999/xhtml", a) : P.createElement(a);
      return c.style ? c : P.createElement(a);
    },
        R = Q("div"),
        S = Q("img"),
        T = g._internals = {
      _specialProps: i
    },
        U = (_gsScope.navigator || {}).userAgent || "",
        V = function () {
      var a = U.indexOf("Android"),
          b = Q("a");
      return m = -1 !== U.indexOf("Safari") && -1 === U.indexOf("Chrome") && (-1 === a || parseFloat(U.substr(a + 8, 2)) > 3), o = m && parseFloat(U.substr(U.indexOf("Version/") + 8, 2)) < 6, n = -1 !== U.indexOf("Firefox"), (/MSIE ([0-9]{1,}[\.0-9]{0,})/.exec(U) || /Trident\/.*rv:([0-9]{1,}[\.0-9]{0,})/.exec(U)) && (p = parseFloat(RegExp.$1)), b ? (b.style.cssText = "top:1px;opacity:.55;", /^0.55/.test(b.style.opacity)) : !1;
    }(),
        W = function W(a) {
      return y.test("string" == typeof a ? a : (a.currentStyle ? a.currentStyle.filter : a.style.filter) || "") ? parseFloat(RegExp.$1) / 100 : 1;
    },
        X = function X(a) {
      _gsScope.console && console.log(a);
    },
        Y = "",
        Z = "",
        $ = function $(a, b) {
      b = b || R;
      var c,
          d,
          e = b.style;
      if (void 0 !== e[a]) return a;

      for (a = a.charAt(0).toUpperCase() + a.substr(1), c = ["O", "Moz", "ms", "Ms", "Webkit"], d = 5; --d > -1 && void 0 === e[c[d] + a];) {
        ;
      }

      return d >= 0 ? (Z = 3 === d ? "ms" : c[d], Y = "-" + Z.toLowerCase() + "-", Z + a) : null;
    },
        _ = "undefined" != typeof window ? window : P.defaultView || {
      getComputedStyle: function getComputedStyle() {}
    },
        aa = function aa(a) {
      return _.getComputedStyle(a);
    },
        ba = g.getStyle = function (a, b, c, d, e) {
      var f;
      return V || "opacity" !== b ? (!d && a.style[b] ? f = a.style[b] : (c = c || aa(a)) ? f = c[b] || c.getPropertyValue(b) || c.getPropertyValue(b.replace(C, "-$1").toLowerCase()) : a.currentStyle && (f = a.currentStyle[b]), null == e || f && "none" !== f && "auto" !== f && "auto auto" !== f ? f : e) : W(a);
    },
        ca = T.convertToPixels = function (a, c, d, e, f) {
      if ("px" === e || !e && "lineHeight" !== c) return d;
      if ("auto" === e || !d) return 0;
      var h,
          i,
          j,
          k = G.test(c),
          l = a,
          m = R.style,
          n = 0 > d,
          o = 1 === d;
      if (n && (d = -d), o && (d *= 100), "lineHeight" !== c || e) {
        if ("%" === e && -1 !== c.indexOf("border")) h = d / 100 * (k ? a.clientWidth : a.clientHeight);else {
          if (m.cssText = "border:0 solid red;position:" + ba(a, "position") + ";line-height:0;", "%" !== e && l.appendChild && "v" !== e.charAt(0) && "rem" !== e) m[k ? "borderLeftWidth" : "borderTopWidth"] = d + e;else {
            if (l = a.parentNode || P.body, -1 !== ba(l, "display").indexOf("flex") && (m.position = "absolute"), i = l._gsCache, j = b.ticker.frame, i && k && i.time === j) return i.width * d / 100;
            m[k ? "width" : "height"] = d + e;
          }
          l.appendChild(R), h = parseFloat(R[k ? "offsetWidth" : "offsetHeight"]), l.removeChild(R), k && "%" === e && g.cacheWidths !== !1 && (i = l._gsCache = l._gsCache || {}, i.time = j, i.width = h / d * 100), 0 !== h || f || (h = ca(a, c, d, e, !0));
        }
      } else i = aa(a).lineHeight, a.style.lineHeight = d, h = parseFloat(aa(a).lineHeight), a.style.lineHeight = i;
      return o && (h /= 100), n ? -h : h;
    },
        da = T.calculateOffset = function (a, b, c) {
      if ("absolute" !== ba(a, "position", c)) return 0;
      var d = "left" === b ? "Left" : "Top",
          e = ba(a, "margin" + d, c);
      return a["offset" + d] - (ca(a, b, parseFloat(e), e.replace(x, "")) || 0);
    },
        ea = function ea(a, b) {
      var c,
          d,
          e,
          f = {};
      if (b = b || aa(a, null)) {
        if (c = b.length) for (; --c > -1;) {
          e = b[c], (-1 === e.indexOf("-transform") || Fa === e) && (f[e.replace(D, F)] = b.getPropertyValue(e));
        } else for (c in b) {
          (-1 === c.indexOf("Transform") || Ea === c) && (f[c] = b[c]);
        }
      } else if (b = a.currentStyle || a.style) for (c in b) {
        "string" == typeof c && void 0 === f[c] && (f[c.replace(D, F)] = b[c]);
      }
      return V || (f.opacity = W(a)), d = Ta(a, b, !1), f.rotation = d.rotation, f.skewX = d.skewX, f.scaleX = d.scaleX, f.scaleY = d.scaleY, f.x = d.x, f.y = d.y, Ha && (f.z = d.z, f.rotationX = d.rotationX, f.rotationY = d.rotationY, f.scaleZ = d.scaleZ), f.filters && delete f.filters, f;
    },
        fa = function fa(a, b, c, d, e) {
      var f,
          g,
          h,
          i = {},
          j = a.style;

      for (g in c) {
        "cssText" !== g && "length" !== g && isNaN(g) && (b[g] !== (f = c[g]) || e && e[g]) && -1 === g.indexOf("Origin") && ("number" == typeof f || "string" == typeof f) && (i[g] = "auto" !== f || "left" !== g && "top" !== g ? "" !== f && "auto" !== f && "none" !== f || "string" != typeof b[g] || "" === b[g].replace(w, "") ? f : 0 : da(a, g), void 0 !== j[g] && (h = new ua(j, g, j[g], h)));
      }

      if (d) for (g in d) {
        "className" !== g && (i[g] = d[g]);
      }
      return {
        difs: i,
        firstMPT: h
      };
    },
        ga = {
      width: ["Left", "Right"],
      height: ["Top", "Bottom"]
    },
        ha = ["marginLeft", "marginRight", "marginTop", "marginBottom"],
        ia = function ia(a, b, c) {
      if ("svg" === (a.nodeName + "").toLowerCase()) return (c || aa(a))[b] || 0;
      if (a.getCTM && Qa(a)) return a.getBBox()[b] || 0;
      var d = parseFloat("width" === b ? a.offsetWidth : a.offsetHeight),
          e = ga[b],
          f = e.length;

      for (c = c || aa(a, null); --f > -1;) {
        d -= parseFloat(ba(a, "padding" + e[f], c, !0)) || 0, d -= parseFloat(ba(a, "border" + e[f] + "Width", c, !0)) || 0;
      }

      return d;
    },
        ja = function ja(a, b) {
      if ("contain" === a || "auto" === a || "auto auto" === a) return a + " ";
      (null == a || "" === a) && (a = "0 0");
      var c,
          d = a.split(" "),
          e = -1 !== a.indexOf("left") ? "0%" : -1 !== a.indexOf("right") ? "100%" : d[0],
          f = -1 !== a.indexOf("top") ? "0%" : -1 !== a.indexOf("bottom") ? "100%" : d[1];

      if (d.length > 3 && !b) {
        for (d = a.split(", ").join(",").split(","), a = [], c = 0; c < d.length; c++) {
          a.push(ja(d[c]));
        }

        return a.join(",");
      }

      return null == f ? f = "center" === e ? "50%" : "0" : "center" === f && (f = "50%"), ("center" === e || isNaN(parseFloat(e)) && -1 === (e + "").indexOf("=")) && (e = "50%"), a = e + " " + f + (d.length > 2 ? " " + d[2] : ""), b && (b.oxp = -1 !== e.indexOf("%"), b.oyp = -1 !== f.indexOf("%"), b.oxr = "=" === e.charAt(1), b.oyr = "=" === f.charAt(1), b.ox = parseFloat(e.replace(w, "")), b.oy = parseFloat(f.replace(w, "")), b.v = a), b || a;
    },
        ka = function ka(a, b) {
      return "function" == typeof a && (a = a(r, q)), "string" == typeof a && "=" === a.charAt(1) ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) : parseFloat(a) - parseFloat(b) || 0;
    },
        la = function la(a, b) {
      "function" == typeof a && (a = a(r, q));
      var c = "string" == typeof a && "=" === a.charAt(1);
      return "string" == typeof a && "v" === a.charAt(a.length - 2) && (a = (c ? a.substr(0, 2) : 0) + window["inner" + ("vh" === a.substr(-2) ? "Height" : "Width")] * (parseFloat(c ? a.substr(2) : a) / 100)), null == a ? b : c ? parseInt(a.charAt(0) + "1", 10) * parseFloat(a.substr(2)) + b : parseFloat(a) || 0;
    },
        ma = function ma(a, b, c, d) {
      var e,
          f,
          g,
          h,
          i,
          j = 1e-6;
      return "function" == typeof a && (a = a(r, q)), null == a ? h = b : "number" == typeof a ? h = a : (e = 360, f = a.split("_"), i = "=" === a.charAt(1), g = (i ? parseInt(a.charAt(0) + "1", 10) * parseFloat(f[0].substr(2)) : parseFloat(f[0])) * (-1 === a.indexOf("rad") ? 1 : M) - (i ? 0 : b), f.length && (d && (d[c] = b + g), -1 !== a.indexOf("short") && (g %= e, g !== g % (e / 2) && (g = 0 > g ? g + e : g - e)), -1 !== a.indexOf("_cw") && 0 > g ? g = (g + 9999999999 * e) % e - (g / e | 0) * e : -1 !== a.indexOf("ccw") && g > 0 && (g = (g - 9999999999 * e) % e - (g / e | 0) * e)), h = b + g), j > h && h > -j && (h = 0), h;
    },
        na = {
      aqua: [0, 255, 255],
      lime: [0, 255, 0],
      silver: [192, 192, 192],
      black: [0, 0, 0],
      maroon: [128, 0, 0],
      teal: [0, 128, 128],
      blue: [0, 0, 255],
      navy: [0, 0, 128],
      white: [255, 255, 255],
      fuchsia: [255, 0, 255],
      olive: [128, 128, 0],
      yellow: [255, 255, 0],
      orange: [255, 165, 0],
      gray: [128, 128, 128],
      purple: [128, 0, 128],
      green: [0, 128, 0],
      red: [255, 0, 0],
      pink: [255, 192, 203],
      cyan: [0, 255, 255],
      transparent: [255, 255, 255, 0]
    },
        oa = function oa(a, b, c) {
      return a = 0 > a ? a + 1 : a > 1 ? a - 1 : a, 255 * (1 > 6 * a ? b + (c - b) * a * 6 : .5 > a ? c : 2 > 3 * a ? b + (c - b) * (2 / 3 - a) * 6 : b) + .5 | 0;
    },
        pa = g.parseColor = function (a, b) {
      var c, d, e, f, g, h, i, j, k, l, m;
      if (a) {
        if ("number" == typeof a) c = [a >> 16, a >> 8 & 255, 255 & a];else {
          if ("," === a.charAt(a.length - 1) && (a = a.substr(0, a.length - 1)), na[a]) c = na[a];else if ("#" === a.charAt(0)) 4 === a.length && (d = a.charAt(1), e = a.charAt(2), f = a.charAt(3), a = "#" + d + d + e + e + f + f), a = parseInt(a.substr(1), 16), c = [a >> 16, a >> 8 & 255, 255 & a];else if ("hsl" === a.substr(0, 3)) {
            if (c = m = a.match(s), b) {
              if (-1 !== a.indexOf("=")) return a.match(t);
            } else g = Number(c[0]) % 360 / 360, h = Number(c[1]) / 100, i = Number(c[2]) / 100, e = .5 >= i ? i * (h + 1) : i + h - i * h, d = 2 * i - e, c.length > 3 && (c[3] = Number(c[3])), c[0] = oa(g + 1 / 3, d, e), c[1] = oa(g, d, e), c[2] = oa(g - 1 / 3, d, e);
          } else c = a.match(s) || na.transparent;
          c[0] = Number(c[0]), c[1] = Number(c[1]), c[2] = Number(c[2]), c.length > 3 && (c[3] = Number(c[3]));
        }
      } else c = na.black;
      return b && !m && (d = c[0] / 255, e = c[1] / 255, f = c[2] / 255, j = Math.max(d, e, f), k = Math.min(d, e, f), i = (j + k) / 2, j === k ? g = h = 0 : (l = j - k, h = i > .5 ? l / (2 - j - k) : l / (j + k), g = j === d ? (e - f) / l + (f > e ? 6 : 0) : j === e ? (f - d) / l + 2 : (d - e) / l + 4, g *= 60), c[0] = g + .5 | 0, c[1] = 100 * h + .5 | 0, c[2] = 100 * i + .5 | 0), c;
    },
        qa = function qa(a, b) {
      var c,
          d,
          e,
          f = a.match(ra) || [],
          g = 0,
          h = "";
      if (!f.length) return a;

      for (c = 0; c < f.length; c++) {
        d = f[c], e = a.substr(g, a.indexOf(d, g) - g), g += e.length + d.length, d = pa(d, b), 3 === d.length && d.push(1), h += e + (b ? "hsla(" + d[0] + "," + d[1] + "%," + d[2] + "%," + d[3] : "rgba(" + d.join(",")) + ")";
      }

      return h + a.substr(g);
    },
        ra = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3}){1,2}\\b";

    for (j in na) {
      ra += "|" + j + "\\b";
    }

    ra = new RegExp(ra + ")", "gi"), g.colorStringFilter = function (a) {
      var b,
          c = a[0] + " " + a[1];
      ra.test(c) && (b = -1 !== c.indexOf("hsl(") || -1 !== c.indexOf("hsla("), a[0] = qa(a[0], b), a[1] = qa(a[1], b)), ra.lastIndex = 0;
    }, b.defaultStringFilter || (b.defaultStringFilter = g.colorStringFilter);

    var sa = function sa(a, b, c, d) {
      if (null == a) return function (a) {
        return a;
      };
      var e,
          f = b ? (a.match(ra) || [""])[0] : "",
          g = a.split(f).join("").match(u) || [],
          h = a.substr(0, a.indexOf(g[0])),
          i = ")" === a.charAt(a.length - 1) ? ")" : "",
          j = -1 !== a.indexOf(" ") ? " " : ",",
          k = g.length,
          l = k > 0 ? g[0].replace(s, "") : "";
      return k ? e = b ? function (a) {
        var b, m, n, o;
        if ("number" == typeof a) a += l;else if (d && J.test(a)) {
          for (o = a.replace(J, "|").split("|"), n = 0; n < o.length; n++) {
            o[n] = e(o[n]);
          }

          return o.join(",");
        }
        if (b = (a.match(ra) || [f])[0], m = a.split(b).join("").match(u) || [], n = m.length, k > n--) for (; ++n < k;) {
          m[n] = c ? m[(n - 1) / 2 | 0] : g[n];
        }
        return h + m.join(j) + j + b + i + (-1 !== a.indexOf("inset") ? " inset" : "");
      } : function (a) {
        var b, f, m;
        if ("number" == typeof a) a += l;else if (d && J.test(a)) {
          for (f = a.replace(J, "|").split("|"), m = 0; m < f.length; m++) {
            f[m] = e(f[m]);
          }

          return f.join(",");
        }
        if (b = a.match("," === j ? u : v) || [], m = b.length, k > m--) for (; ++m < k;) {
          b[m] = c ? b[(m - 1) / 2 | 0] : g[m];
        }
        return (h && "none" !== a ? a.substr(0, a.indexOf(b[0])) || h : h) + b.join(j) + i;
      } : function (a) {
        return a;
      };
    },
        ta = function ta(a) {
      return a = a.split(","), function (b, c, d, e, f, g, h) {
        var i,
            j = (c + "").split(" ");

        for (h = {}, i = 0; 4 > i; i++) {
          h[a[i]] = j[i] = j[i] || j[(i - 1) / 2 >> 0];
        }

        return e.parse(b, h, f, g);
      };
    },
        ua = (T._setPluginRatio = function (a) {
      this.plugin.setRatio(a);

      for (var b, c, d, e, f, g = this.data, h = g.proxy, i = g.firstMPT, j = 1e-6; i;) {
        b = h[i.v], i.r ? b = i.r(b) : j > b && b > -j && (b = 0), i.t[i.p] = b, i = i._next;
      }

      if (g.autoRotate && (g.autoRotate.rotation = g.mod ? g.mod.call(this._tween, h.rotation, this.t, this._tween) : h.rotation), 1 === a || 0 === a) for (i = g.firstMPT, f = 1 === a ? "e" : "b"; i;) {
        if (c = i.t, c.type) {
          if (1 === c.type) {
            for (e = c.xs0 + c.s + c.xs1, d = 1; d < c.l; d++) {
              e += c["xn" + d] + c["xs" + (d + 1)];
            }

            c[f] = e;
          }
        } else c[f] = c.s + c.xs0;

        i = i._next;
      }
    }, function (a, b, c, d, e) {
      this.t = a, this.p = b, this.v = c, this.r = e, d && (d._prev = this, this._next = d);
    }),
        va = (T._parseToProxy = function (a, b, c, d, e, f) {
      var g,
          h,
          i,
          j,
          k,
          l = d,
          m = {},
          n = {},
          o = c._transform,
          p = N;

      for (c._transform = null, N = b, d = k = c.parse(a, b, d, e), N = p, f && (c._transform = o, l && (l._prev = null, l._prev && (l._prev._next = null))); d && d !== l;) {
        if (d.type <= 1 && (h = d.p, n[h] = d.s + d.c, m[h] = d.s, f || (j = new ua(d, "s", h, j, d.r), d.c = 0), 1 === d.type)) for (g = d.l; --g > 0;) {
          i = "xn" + g, h = d.p + "_" + i, n[h] = d.data[i], m[h] = d[i], f || (j = new ua(d, i, h, j, d.rxp[i]));
        }
        d = d._next;
      }

      return {
        proxy: m,
        end: n,
        firstMPT: j,
        pt: k
      };
    }, T.CSSPropTween = function (a, b, d, e, g, h, i, j, k, l, m) {
      this.t = a, this.p = b, this.s = d, this.c = e, this.n = i || b, a instanceof va || f.push(this.n), this.r = j ? "function" == typeof j ? j : Math.round : j, this.type = h || 0, k && (this.pr = k, c = !0), this.b = void 0 === l ? d : l, this.e = void 0 === m ? d + e : m, g && (this._next = g, g._prev = this);
    }),
        wa = function wa(a, b, c, d, e, f) {
      var g = new va(a, b, c, d - c, e, -1, f);
      return g.b = c, g.e = g.xs0 = d, g;
    },
        xa = g.parseComplex = function (a, b, c, d, e, f, h, i, j, l) {
      c = c || f || "", "function" == typeof d && (d = d(r, q)), h = new va(a, b, 0, 0, h, l ? 2 : 1, null, !1, i, c, d), d += "", e && ra.test(d + c) && (d = [c, d], g.colorStringFilter(d), c = d[0], d = d[1]);
      var m,
          n,
          o,
          p,
          u,
          v,
          w,
          x,
          y,
          z,
          A,
          B,
          C,
          D = c.split(", ").join(",").split(" "),
          E = d.split(", ").join(",").split(" "),
          F = D.length,
          G = k !== !1;

      for ((-1 !== d.indexOf(",") || -1 !== c.indexOf(",")) && (-1 !== (d + c).indexOf("rgb") || -1 !== (d + c).indexOf("hsl") ? (D = D.join(" ").replace(J, ", ").split(" "), E = E.join(" ").replace(J, ", ").split(" ")) : (D = D.join(" ").split(",").join(", ").split(" "), E = E.join(" ").split(",").join(", ").split(" ")), F = D.length), F !== E.length && (D = (f || "").split(" "), F = D.length), h.plugin = j, h.setRatio = l, ra.lastIndex = 0, m = 0; F > m; m++) {
        if (p = D[m], u = E[m] + "", x = parseFloat(p), x || 0 === x) h.appendXtra("", x, ka(u, x), u.replace(t, ""), G && -1 !== u.indexOf("px") ? Math.round : !1, !0);else if (e && ra.test(p)) B = u.indexOf(")") + 1, B = ")" + (B ? u.substr(B) : ""), C = -1 !== u.indexOf("hsl") && V, z = u, p = pa(p, C), u = pa(u, C), y = p.length + u.length > 6, y && !V && 0 === u[3] ? (h["xs" + h.l] += h.l ? " transparent" : "transparent", h.e = h.e.split(E[m]).join("transparent")) : (V || (y = !1), C ? h.appendXtra(z.substr(0, z.indexOf("hsl")) + (y ? "hsla(" : "hsl("), p[0], ka(u[0], p[0]), ",", !1, !0).appendXtra("", p[1], ka(u[1], p[1]), "%,", !1).appendXtra("", p[2], ka(u[2], p[2]), y ? "%," : "%" + B, !1) : h.appendXtra(z.substr(0, z.indexOf("rgb")) + (y ? "rgba(" : "rgb("), p[0], u[0] - p[0], ",", Math.round, !0).appendXtra("", p[1], u[1] - p[1], ",", Math.round).appendXtra("", p[2], u[2] - p[2], y ? "," : B, Math.round), y && (p = p.length < 4 ? 1 : p[3], h.appendXtra("", p, (u.length < 4 ? 1 : u[3]) - p, B, !1))), ra.lastIndex = 0;else if (v = p.match(s)) {
          if (w = u.match(t), !w || w.length !== v.length) return h;

          for (o = 0, n = 0; n < v.length; n++) {
            A = v[n], z = p.indexOf(A, o), h.appendXtra(p.substr(o, z - o), Number(A), ka(w[n], A), "", G && "px" === p.substr(z + A.length, 2) ? Math.round : !1, 0 === n), o = z + A.length;
          }

          h["xs" + h.l] += p.substr(o);
        } else h["xs" + h.l] += h.l || h["xs" + h.l] ? " " + u : u;
      }

      if (-1 !== d.indexOf("=") && h.data) {
        for (B = h.xs0 + h.data.s, m = 1; m < h.l; m++) {
          B += h["xs" + m] + h.data["xn" + m];
        }

        h.e = B + h["xs" + m];
      }

      return h.l || (h.type = -1, h.xs0 = h.e), h.xfirst || h;
    },
        ya = 9;

    for (j = va.prototype, j.l = j.pr = 0; --ya > 0;) {
      j["xn" + ya] = 0, j["xs" + ya] = "";
    }

    j.xs0 = "", j._next = j._prev = j.xfirst = j.data = j.plugin = j.setRatio = j.rxp = null, j.appendXtra = function (a, b, c, d, e, f) {
      var g = this,
          h = g.l;
      return g["xs" + h] += f && (h || g["xs" + h]) ? " " + a : a || "", c || 0 === h || g.plugin ? (g.l++, g.type = g.setRatio ? 2 : 1, g["xs" + g.l] = d || "", h > 0 ? (g.data["xn" + h] = b + c, g.rxp["xn" + h] = e, g["xn" + h] = b, g.plugin || (g.xfirst = new va(g, "xn" + h, b, c, g.xfirst || g, 0, g.n, e, g.pr), g.xfirst.xs0 = 0), g) : (g.data = {
        s: b + c
      }, g.rxp = {}, g.s = b, g.c = c, g.r = e, g)) : (g["xs" + h] += b + (d || ""), g);
    };

    var za = function za(a, b) {
      b = b || {}, this.p = b.prefix ? $(a) || a : a, i[a] = i[this.p] = this, this.format = b.formatter || sa(b.defaultValue, b.color, b.collapsible, b.multi), b.parser && (this.parse = b.parser), this.clrs = b.color, this.multi = b.multi, this.keyword = b.keyword, this.dflt = b.defaultValue, this.allowFunc = b.allowFunc, this.pr = b.priority || 0;
    },
        Aa = T._registerComplexSpecialProp = function (a, b, c) {
      "object" != _typeof(b) && (b = {
        parser: c
      });
      var d,
          e,
          f = a.split(","),
          g = b.defaultValue;

      for (c = c || [g], d = 0; d < f.length; d++) {
        b.prefix = 0 === d && b.prefix, b.defaultValue = c[d] || g, e = new za(f[d], b);
      }
    },
        Ba = T._registerPluginProp = function (a) {
      if (!i[a]) {
        var b = a.charAt(0).toUpperCase() + a.substr(1) + "Plugin";
        Aa(a, {
          parser: function parser(a, c, d, e, f, g, j) {
            var k = h.com.greensock.plugins[b];
            return k ? (k._cssRegister(), i[d].parse(a, c, d, e, f, g, j)) : (X("Error: " + b + " js file not loaded."), f);
          }
        });
      }
    };

    j = za.prototype, j.parseComplex = function (a, b, c, d, e, f) {
      var g,
          h,
          i,
          j,
          k,
          l,
          m = this.keyword;

      if (this.multi && (J.test(c) || J.test(b) ? (h = b.replace(J, "|").split("|"), i = c.replace(J, "|").split("|")) : m && (h = [b], i = [c])), i) {
        for (j = i.length > h.length ? i.length : h.length, g = 0; j > g; g++) {
          b = h[g] = h[g] || this.dflt, c = i[g] = i[g] || this.dflt, m && (k = b.indexOf(m), l = c.indexOf(m), k !== l && (-1 === l ? h[g] = h[g].split(m).join("") : -1 === k && (h[g] += " " + m)));
        }

        b = h.join(", "), c = i.join(", ");
      }

      return xa(a, this.p, b, c, this.clrs, this.dflt, d, this.pr, e, f);
    }, j.parse = function (a, b, c, d, f, g, h) {
      return this.parseComplex(a.style, this.format(ba(a, this.p, e, !1, this.dflt)), this.format(b), f, g);
    }, g.registerSpecialProp = function (a, b, c) {
      Aa(a, {
        parser: function parser(a, d, e, f, g, h, i) {
          var j = new va(a, e, 0, 0, g, 2, e, !1, c);
          return j.plugin = h, j.setRatio = b(a, d, f._tween, e), j;
        },
        priority: c
      });
    }, g.useSVGTransformAttr = !0;

    var Ca,
        Da = "scaleX,scaleY,scaleZ,x,y,z,skewX,skewY,rotation,rotationX,rotationY,perspective,xPercent,yPercent".split(","),
        Ea = $("transform"),
        Fa = Y + "transform",
        Ga = $("transformOrigin"),
        Ha = null !== $("perspective"),
        Ia = T.Transform = function () {
      this.perspective = parseFloat(g.defaultTransformPerspective) || 0, this.force3D = g.defaultForce3D !== !1 && Ha ? g.defaultForce3D || "auto" : !1;
    },
        Ja = _gsScope.SVGElement,
        Ka = function Ka(a, b, c) {
      var d,
          e = P.createElementNS("http://www.w3.org/2000/svg", a),
          f = /([a-z])([A-Z])/g;

      for (d in c) {
        e.setAttributeNS(null, d.replace(f, "$1-$2").toLowerCase(), c[d]);
      }

      return b.appendChild(e), e;
    },
        La = P.documentElement || {},
        Ma = function () {
      var a,
          b,
          c,
          d = p || /Android/i.test(U) && !_gsScope.chrome;
      return P.createElementNS && La.appendChild && !d && (a = Ka("svg", La), b = Ka("rect", a, {
        width: 100,
        height: 50,
        x: 100
      }), c = b.getBoundingClientRect().width, b.style[Ga] = "50% 50%", b.style[Ea] = "scaleX(0.5)", d = c === b.getBoundingClientRect().width && !(n && Ha), La.removeChild(a)), d;
    }(),
        Na = function Na(a, b, c, d, e, f) {
      var h,
          i,
          j,
          k,
          l,
          m,
          n,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v = a._gsTransform,
          w = Sa(a, !0);
      v && (t = v.xOrigin, u = v.yOrigin), (!d || (h = d.split(" ")).length < 2) && (n = a.getBBox(), 0 === n.x && 0 === n.y && n.width + n.height === 0 && (n = {
        x: parseFloat(a.hasAttribute("x") ? a.getAttribute("x") : a.hasAttribute("cx") ? a.getAttribute("cx") : 0) || 0,
        y: parseFloat(a.hasAttribute("y") ? a.getAttribute("y") : a.hasAttribute("cy") ? a.getAttribute("cy") : 0) || 0,
        width: 0,
        height: 0
      }), b = ja(b).split(" "), h = [(-1 !== b[0].indexOf("%") ? parseFloat(b[0]) / 100 * n.width : parseFloat(b[0])) + n.x, (-1 !== b[1].indexOf("%") ? parseFloat(b[1]) / 100 * n.height : parseFloat(b[1])) + n.y]), c.xOrigin = k = parseFloat(h[0]), c.yOrigin = l = parseFloat(h[1]), d && w !== Ra && (m = w[0], n = w[1], o = w[2], p = w[3], q = w[4], r = w[5], s = m * p - n * o, s && (i = k * (p / s) + l * (-o / s) + (o * r - p * q) / s, j = k * (-n / s) + l * (m / s) - (m * r - n * q) / s, k = c.xOrigin = h[0] = i, l = c.yOrigin = h[1] = j)), v && (f && (c.xOffset = v.xOffset, c.yOffset = v.yOffset, v = c), e || e !== !1 && g.defaultSmoothOrigin !== !1 ? (i = k - t, j = l - u, v.xOffset += i * w[0] + j * w[2] - i, v.yOffset += i * w[1] + j * w[3] - j) : v.xOffset = v.yOffset = 0), f || a.setAttribute("data-svg-origin", h.join(" "));
    },
        Oa = function Oa(a) {
      var b,
          c = Q("svg", this.ownerSVGElement && this.ownerSVGElement.getAttribute("xmlns") || "http://www.w3.org/2000/svg"),
          d = this.parentNode,
          e = this.nextSibling,
          f = this.style.cssText;
      if (La.appendChild(c), c.appendChild(this), this.style.display = "block", a) try {
        b = this.getBBox(), this._originalGetBBox = this.getBBox, this.getBBox = Oa;
      } catch (g) {} else this._originalGetBBox && (b = this._originalGetBBox());
      return e ? d.insertBefore(this, e) : d.appendChild(this), La.removeChild(c), this.style.cssText = f, b;
    },
        Pa = function Pa(a) {
      try {
        return a.getBBox();
      } catch (b) {
        return Oa.call(a, !0);
      }
    },
        Qa = function Qa(a) {
      return !(!Ja || !a.getCTM || a.parentNode && !a.ownerSVGElement || !Pa(a));
    },
        Ra = [1, 0, 0, 1, 0, 0],
        Sa = function Sa(a, b) {
      var c,
          d,
          e,
          f,
          g,
          h,
          i,
          j = a._gsTransform || new Ia(),
          k = 1e5,
          l = a.style;
      if (Ea ? d = ba(a, Fa, null, !0) : a.currentStyle && (d = a.currentStyle.filter.match(H), d = d && 4 === d.length ? [d[0].substr(4), Number(d[2].substr(4)), Number(d[1].substr(4)), d[3].substr(4), j.x || 0, j.y || 0].join(",") : ""), c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d, Ea && c && !a.offsetParent && a !== La && (f = l.display, l.display = "block", i = a.parentNode, i && a.offsetParent || (g = 1, h = a.nextSibling, La.appendChild(a)), d = ba(a, Fa, null, !0), c = !d || "none" === d || "matrix(1, 0, 0, 1, 0, 0)" === d, f ? l.display = f : Xa(l, "display"), g && (h ? i.insertBefore(a, h) : i ? i.appendChild(a) : La.removeChild(a))), (j.svg || a.getCTM && Qa(a)) && (c && -1 !== (l[Ea] + "").indexOf("matrix") && (d = l[Ea], c = 0), e = a.getAttribute("transform"), c && e && (e = a.transform.baseVal.consolidate().matrix, d = "matrix(" + e.a + "," + e.b + "," + e.c + "," + e.d + "," + e.e + "," + e.f + ")", c = 0)), c) return Ra;

      for (e = (d || "").match(s) || [], ya = e.length; --ya > -1;) {
        f = Number(e[ya]), e[ya] = (g = f - (f |= 0)) ? (g * k + (0 > g ? -.5 : .5) | 0) / k + f : f;
      }

      return b && e.length > 6 ? [e[0], e[1], e[4], e[5], e[12], e[13]] : e;
    },
        Ta = T.getTransform = function (a, c, d, e) {
      if (a._gsTransform && d && !e) return a._gsTransform;
      var f,
          h,
          i,
          j,
          k,
          l,
          m = d ? a._gsTransform || new Ia() : new Ia(),
          n = m.scaleX < 0,
          o = 2e-5,
          p = 1e5,
          q = Ha ? parseFloat(ba(a, Ga, c, !1, "0 0 0").split(" ")[2]) || m.zOrigin || 0 : 0,
          r = parseFloat(g.defaultTransformPerspective) || 0;

      if (m.svg = !(!a.getCTM || !Qa(a)), m.svg && (Na(a, ba(a, Ga, c, !1, "50% 50%") + "", m, a.getAttribute("data-svg-origin")), Ca = g.useSVGTransformAttr || Ma), f = Sa(a), f !== Ra) {
        if (16 === f.length) {
          var s,
              t,
              u,
              v,
              w,
              x = f[0],
              y = f[1],
              z = f[2],
              A = f[3],
              B = f[4],
              C = f[5],
              D = f[6],
              E = f[7],
              F = f[8],
              G = f[9],
              H = f[10],
              I = f[12],
              J = f[13],
              K = f[14],
              L = f[11],
              N = Math.atan2(D, H);
          m.zOrigin && (K = -m.zOrigin, I = F * K - f[12], J = G * K - f[13], K = H * K + m.zOrigin - f[14]), m.rotationX = N * M, N && (v = Math.cos(-N), w = Math.sin(-N), s = B * v + F * w, t = C * v + G * w, u = D * v + H * w, F = B * -w + F * v, G = C * -w + G * v, H = D * -w + H * v, L = E * -w + L * v, B = s, C = t, D = u), N = Math.atan2(-z, H), m.rotationY = N * M, N && (v = Math.cos(-N), w = Math.sin(-N), s = x * v - F * w, t = y * v - G * w, u = z * v - H * w, G = y * w + G * v, H = z * w + H * v, L = A * w + L * v, x = s, y = t, z = u), N = Math.atan2(y, x), m.rotation = N * M, N && (v = Math.cos(N), w = Math.sin(N), s = x * v + y * w, t = B * v + C * w, u = F * v + G * w, y = y * v - x * w, C = C * v - B * w, G = G * v - F * w, x = s, B = t, F = u), m.rotationX && Math.abs(m.rotationX) + Math.abs(m.rotation) > 359.9 && (m.rotationX = m.rotation = 0, m.rotationY = 180 - m.rotationY), N = Math.atan2(B, C), m.scaleX = (Math.sqrt(x * x + y * y + z * z) * p + .5 | 0) / p, m.scaleY = (Math.sqrt(C * C + D * D) * p + .5 | 0) / p, m.scaleZ = (Math.sqrt(F * F + G * G + H * H) * p + .5 | 0) / p, x /= m.scaleX, B /= m.scaleY, y /= m.scaleX, C /= m.scaleY, Math.abs(N) > o ? (m.skewX = N * M, B = 0, "simple" !== m.skewType && (m.scaleY *= 1 / Math.cos(N))) : m.skewX = 0, m.perspective = L ? 1 / (0 > L ? -L : L) : 0, m.x = I, m.y = J, m.z = K, m.svg && (m.x -= m.xOrigin - (m.xOrigin * x - m.yOrigin * B), m.y -= m.yOrigin - (m.yOrigin * y - m.xOrigin * C));
        } else if (!Ha || e || !f.length || m.x !== f[4] || m.y !== f[5] || !m.rotationX && !m.rotationY) {
          var O = f.length >= 6,
              P = O ? f[0] : 1,
              Q = f[1] || 0,
              R = f[2] || 0,
              S = O ? f[3] : 1;
          m.x = f[4] || 0, m.y = f[5] || 0, i = Math.sqrt(P * P + Q * Q), j = Math.sqrt(S * S + R * R), k = P || Q ? Math.atan2(Q, P) * M : m.rotation || 0, l = R || S ? Math.atan2(R, S) * M + k : m.skewX || 0, m.scaleX = i, m.scaleY = j, m.rotation = k, m.skewX = l, Ha && (m.rotationX = m.rotationY = m.z = 0, m.perspective = r, m.scaleZ = 1), m.svg && (m.x -= m.xOrigin - (m.xOrigin * P + m.yOrigin * R), m.y -= m.yOrigin - (m.xOrigin * Q + m.yOrigin * S));
        }

        Math.abs(m.skewX) > 90 && Math.abs(m.skewX) < 270 && (n ? (m.scaleX *= -1, m.skewX += m.rotation <= 0 ? 180 : -180, m.rotation += m.rotation <= 0 ? 180 : -180) : (m.scaleY *= -1, m.skewX += m.skewX <= 0 ? 180 : -180)), m.zOrigin = q;

        for (h in m) {
          m[h] < o && m[h] > -o && (m[h] = 0);
        }
      }

      return d && (a._gsTransform = m, m.svg && (Ca && a.style[Ea] ? b.delayedCall(.001, function () {
        Xa(a.style, Ea);
      }) : !Ca && a.getAttribute("transform") && b.delayedCall(.001, function () {
        a.removeAttribute("transform");
      }))), m;
    },
        Ua = function Ua(a) {
      var b,
          c,
          d = this.data,
          e = -d.rotation * L,
          f = e + d.skewX * L,
          g = 1e5,
          h = (Math.cos(e) * d.scaleX * g | 0) / g,
          i = (Math.sin(e) * d.scaleX * g | 0) / g,
          j = (Math.sin(f) * -d.scaleY * g | 0) / g,
          k = (Math.cos(f) * d.scaleY * g | 0) / g,
          l = this.t.style,
          m = this.t.currentStyle;

      if (m) {
        c = i, i = -j, j = -c, b = m.filter, l.filter = "";
        var n,
            o,
            q = this.t.offsetWidth,
            r = this.t.offsetHeight,
            s = "absolute" !== m.position,
            t = "progid:DXImageTransform.Microsoft.Matrix(M11=" + h + ", M12=" + i + ", M21=" + j + ", M22=" + k,
            u = d.x + q * d.xPercent / 100,
            v = d.y + r * d.yPercent / 100;

        if (null != d.ox && (n = (d.oxp ? q * d.ox * .01 : d.ox) - q / 2, o = (d.oyp ? r * d.oy * .01 : d.oy) - r / 2, u += n - (n * h + o * i), v += o - (n * j + o * k)), s ? (n = q / 2, o = r / 2, t += ", Dx=" + (n - (n * h + o * i) + u) + ", Dy=" + (o - (n * j + o * k) + v) + ")") : t += ", sizingMethod='auto expand')", -1 !== b.indexOf("DXImageTransform.Microsoft.Matrix(") ? l.filter = b.replace(I, t) : l.filter = t + " " + b, (0 === a || 1 === a) && 1 === h && 0 === i && 0 === j && 1 === k && (s && -1 === t.indexOf("Dx=0, Dy=0") || y.test(b) && 100 !== parseFloat(RegExp.$1) || -1 === b.indexOf(b.indexOf("Alpha")) && l.removeAttribute("filter")), !s) {
          var w,
              z,
              A,
              B = 8 > p ? 1 : -1;

          for (n = d.ieOffsetX || 0, o = d.ieOffsetY || 0, d.ieOffsetX = Math.round((q - ((0 > h ? -h : h) * q + (0 > i ? -i : i) * r)) / 2 + u), d.ieOffsetY = Math.round((r - ((0 > k ? -k : k) * r + (0 > j ? -j : j) * q)) / 2 + v), ya = 0; 4 > ya; ya++) {
            z = ha[ya], w = m[z], c = -1 !== w.indexOf("px") ? parseFloat(w) : ca(this.t, z, parseFloat(w), w.replace(x, "")) || 0, A = c !== d[z] ? 2 > ya ? -d.ieOffsetX : -d.ieOffsetY : 2 > ya ? n - d.ieOffsetX : o - d.ieOffsetY, l[z] = (d[z] = Math.round(c - A * (0 === ya || 2 === ya ? 1 : B))) + "px";
          }
        }
      }
    },
        Va = T.set3DTransformRatio = T.setTransformRatio = function (a) {
      var b,
          c,
          d,
          e,
          f,
          g,
          h,
          i,
          j,
          k,
          l,
          m,
          o,
          p,
          q,
          r,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          z = this.data,
          A = this.t.style,
          B = z.rotation,
          C = z.rotationX,
          D = z.rotationY,
          E = z.scaleX,
          F = z.scaleY,
          G = z.scaleZ,
          H = z.x,
          I = z.y,
          J = z.z,
          K = z.svg,
          M = z.perspective,
          N = z.force3D,
          O = z.skewY,
          P = z.skewX;
      if (O && (P += O, B += O), ((1 === a || 0 === a) && "auto" === N && (this.tween._totalTime === this.tween._totalDuration || !this.tween._totalTime) || !N) && !J && !M && !D && !C && 1 === G || Ca && K || !Ha) return void (B || P || K ? (B *= L, x = P * L, y = 1e5, c = Math.cos(B) * E, f = Math.sin(B) * E, d = Math.sin(B - x) * -F, g = Math.cos(B - x) * F, x && "simple" === z.skewType && (b = Math.tan(x - O * L), b = Math.sqrt(1 + b * b), d *= b, g *= b, O && (b = Math.tan(O * L), b = Math.sqrt(1 + b * b), c *= b, f *= b)), K && (H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset, I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset, Ca && (z.xPercent || z.yPercent) && (q = this.t.getBBox(), H += .01 * z.xPercent * q.width, I += .01 * z.yPercent * q.height), q = 1e-6, q > H && H > -q && (H = 0), q > I && I > -q && (I = 0)), u = (c * y | 0) / y + "," + (f * y | 0) / y + "," + (d * y | 0) / y + "," + (g * y | 0) / y + "," + H + "," + I + ")", K && Ca ? this.t.setAttribute("transform", "matrix(" + u) : A[Ea] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + u) : A[Ea] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix(" : "matrix(") + E + ",0,0," + F + "," + H + "," + I + ")");
      if (n && (q = 1e-4, q > E && E > -q && (E = G = 2e-5), q > F && F > -q && (F = G = 2e-5), !M || z.z || z.rotationX || z.rotationY || (M = 0)), B || P) B *= L, r = c = Math.cos(B), s = f = Math.sin(B), P && (B -= P * L, r = Math.cos(B), s = Math.sin(B), "simple" === z.skewType && (b = Math.tan((P - O) * L), b = Math.sqrt(1 + b * b), r *= b, s *= b, z.skewY && (b = Math.tan(O * L), b = Math.sqrt(1 + b * b), c *= b, f *= b))), d = -s, g = r;else {
        if (!(D || C || 1 !== G || M || K)) return void (A[Ea] = (z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) translate3d(" : "translate3d(") + H + "px," + I + "px," + J + "px)" + (1 !== E || 1 !== F ? " scale(" + E + "," + F + ")" : ""));
        c = g = 1, d = f = 0;
      }
      k = 1, e = h = i = j = l = m = 0, o = M ? -1 / M : 0, p = z.zOrigin, q = 1e-6, v = ",", w = "0", B = D * L, B && (r = Math.cos(B), s = Math.sin(B), i = -s, l = o * -s, e = c * s, h = f * s, k = r, o *= r, c *= r, f *= r), B = C * L, B && (r = Math.cos(B), s = Math.sin(B), b = d * r + e * s, t = g * r + h * s, j = k * s, m = o * s, e = d * -s + e * r, h = g * -s + h * r, k *= r, o *= r, d = b, g = t), 1 !== G && (e *= G, h *= G, k *= G, o *= G), 1 !== F && (d *= F, g *= F, j *= F, m *= F), 1 !== E && (c *= E, f *= E, i *= E, l *= E), (p || K) && (p && (H += e * -p, I += h * -p, J += k * -p + p), K && (H += z.xOrigin - (z.xOrigin * c + z.yOrigin * d) + z.xOffset, I += z.yOrigin - (z.xOrigin * f + z.yOrigin * g) + z.yOffset), q > H && H > -q && (H = w), q > I && I > -q && (I = w), q > J && J > -q && (J = 0)), u = z.xPercent || z.yPercent ? "translate(" + z.xPercent + "%," + z.yPercent + "%) matrix3d(" : "matrix3d(", u += (q > c && c > -q ? w : c) + v + (q > f && f > -q ? w : f) + v + (q > i && i > -q ? w : i), u += v + (q > l && l > -q ? w : l) + v + (q > d && d > -q ? w : d) + v + (q > g && g > -q ? w : g), C || D || 1 !== G ? (u += v + (q > j && j > -q ? w : j) + v + (q > m && m > -q ? w : m) + v + (q > e && e > -q ? w : e), u += v + (q > h && h > -q ? w : h) + v + (q > k && k > -q ? w : k) + v + (q > o && o > -q ? w : o) + v) : u += ",0,0,0,0,1,0,", u += H + v + I + v + J + v + (M ? 1 + -J / M : 1) + ")", A[Ea] = u;
    };

    j = Ia.prototype, j.x = j.y = j.z = j.skewX = j.skewY = j.rotation = j.rotationX = j.rotationY = j.zOrigin = j.xPercent = j.yPercent = j.xOffset = j.yOffset = 0, j.scaleX = j.scaleY = j.scaleZ = 1, Aa("transform,scale,scaleX,scaleY,scaleZ,x,y,z,rotation,rotationX,rotationY,rotationZ,skewX,skewY,shortRotation,shortRotationX,shortRotationY,shortRotationZ,transformOrigin,svgOrigin,transformPerspective,directionalRotation,parseTransform,force3D,skewType,xPercent,yPercent,smoothOrigin", {
      parser: function parser(a, b, c, d, f, h, i) {
        if (d._lastParsedTransform === i) return f;
        d._lastParsedTransform = i;
        var j = i.scale && "function" == typeof i.scale ? i.scale : 0;
        j && (i.scale = j(r, a));
        var k,
            l,
            m,
            n,
            o,
            p,
            s,
            t,
            u,
            v = a._gsTransform,
            w = a.style,
            x = 1e-6,
            y = Da.length,
            z = i,
            A = {},
            B = "transformOrigin",
            C = Ta(a, e, !0, z.parseTransform),
            D = z.transform && ("function" == typeof z.transform ? z.transform(r, q) : z.transform);
        if (C.skewType = z.skewType || C.skewType || g.defaultSkewType, d._transform = C, "rotationZ" in z && (z.rotation = z.rotationZ), D && "string" == typeof D && Ea) l = R.style, l[Ea] = D, l.display = "block", l.position = "absolute", -1 !== D.indexOf("%") && (l.width = ba(a, "width"), l.height = ba(a, "height")), P.body.appendChild(R), k = Ta(R, null, !1), "simple" === C.skewType && (k.scaleY *= Math.cos(k.skewX * L)), C.svg && (p = C.xOrigin, s = C.yOrigin, k.x -= C.xOffset, k.y -= C.yOffset, (z.transformOrigin || z.svgOrigin) && (D = {}, Na(a, ja(z.transformOrigin), D, z.svgOrigin, z.smoothOrigin, !0), p = D.xOrigin, s = D.yOrigin, k.x -= D.xOffset - C.xOffset, k.y -= D.yOffset - C.yOffset), (p || s) && (t = Sa(R, !0), k.x -= p - (p * t[0] + s * t[2]), k.y -= s - (p * t[1] + s * t[3]))), P.body.removeChild(R), k.perspective || (k.perspective = C.perspective), null != z.xPercent && (k.xPercent = la(z.xPercent, C.xPercent)), null != z.yPercent && (k.yPercent = la(z.yPercent, C.yPercent));else if ("object" == _typeof(z)) {
          if (k = {
            scaleX: la(null != z.scaleX ? z.scaleX : z.scale, C.scaleX),
            scaleY: la(null != z.scaleY ? z.scaleY : z.scale, C.scaleY),
            scaleZ: la(z.scaleZ, C.scaleZ),
            x: la(z.x, C.x),
            y: la(z.y, C.y),
            z: la(z.z, C.z),
            xPercent: la(z.xPercent, C.xPercent),
            yPercent: la(z.yPercent, C.yPercent),
            perspective: la(z.transformPerspective, C.perspective)
          }, o = z.directionalRotation, null != o) if ("object" == _typeof(o)) for (l in o) {
            z[l] = o[l];
          } else z.rotation = o;
          "string" == typeof z.x && -1 !== z.x.indexOf("%") && (k.x = 0, k.xPercent = la(z.x, C.xPercent)), "string" == typeof z.y && -1 !== z.y.indexOf("%") && (k.y = 0, k.yPercent = la(z.y, C.yPercent)), k.rotation = ma("rotation" in z ? z.rotation : "shortRotation" in z ? z.shortRotation + "_short" : C.rotation, C.rotation, "rotation", A), Ha && (k.rotationX = ma("rotationX" in z ? z.rotationX : "shortRotationX" in z ? z.shortRotationX + "_short" : C.rotationX || 0, C.rotationX, "rotationX", A), k.rotationY = ma("rotationY" in z ? z.rotationY : "shortRotationY" in z ? z.shortRotationY + "_short" : C.rotationY || 0, C.rotationY, "rotationY", A)), k.skewX = ma(z.skewX, C.skewX), k.skewY = ma(z.skewY, C.skewY);
        }

        for (Ha && null != z.force3D && (C.force3D = z.force3D, n = !0), m = C.force3D || C.z || C.rotationX || C.rotationY || k.z || k.rotationX || k.rotationY || k.perspective, m || null == z.scale || (k.scaleZ = 1); --y > -1;) {
          u = Da[y], D = k[u] - C[u], (D > x || -x > D || null != z[u] || null != N[u]) && (n = !0, f = new va(C, u, C[u], D, f), u in A && (f.e = A[u]), f.xs0 = 0, f.plugin = h, d._overwriteProps.push(f.n));
        }

        return D = "function" == typeof z.transformOrigin ? z.transformOrigin(r, q) : z.transformOrigin, C.svg && (D || z.svgOrigin) && (p = C.xOffset, s = C.yOffset, Na(a, ja(D), k, z.svgOrigin, z.smoothOrigin), f = wa(C, "xOrigin", (v ? C : k).xOrigin, k.xOrigin, f, B), f = wa(C, "yOrigin", (v ? C : k).yOrigin, k.yOrigin, f, B), (p !== C.xOffset || s !== C.yOffset) && (f = wa(C, "xOffset", v ? p : C.xOffset, C.xOffset, f, B), f = wa(C, "yOffset", v ? s : C.yOffset, C.yOffset, f, B)), D = "0px 0px"), (D || Ha && m && C.zOrigin) && (Ea ? (n = !0, u = Ga, D || (D = (ba(a, u, e, !1, "50% 50%") + "").split(" "), D = D[0] + " " + D[1] + " " + C.zOrigin + "px"), D += "", f = new va(w, u, 0, 0, f, -1, B), f.b = w[u], f.plugin = h, Ha ? (l = C.zOrigin, D = D.split(" "), C.zOrigin = (D.length > 2 ? parseFloat(D[2]) : l) || 0, f.xs0 = f.e = D[0] + " " + (D[1] || "50%") + " 0px", f = new va(C, "zOrigin", 0, 0, f, -1, f.n), f.b = l, f.xs0 = f.e = C.zOrigin) : f.xs0 = f.e = D) : ja(D + "", C)), n && (d._transformType = C.svg && Ca || !m && 3 !== this._transformType ? 2 : 3), j && (i.scale = j), f;
      },
      allowFunc: !0,
      prefix: !0
    }), Aa("boxShadow", {
      defaultValue: "0px 0px 0px 0px #999",
      prefix: !0,
      color: !0,
      multi: !0,
      keyword: "inset"
    }), Aa("clipPath", {
      defaultValue: "inset(0%)",
      prefix: !0,
      multi: !0,
      formatter: sa("inset(0% 0% 0% 0%)", !1, !0)
    }), Aa("borderRadius", {
      defaultValue: "0px",
      parser: function parser(a, b, c, f, g, h) {
        b = this.format(b);
        var i,
            j,
            k,
            l,
            m,
            n,
            o,
            p,
            q,
            r,
            s,
            t,
            u,
            v,
            w,
            x,
            y = ["borderTopLeftRadius", "borderTopRightRadius", "borderBottomRightRadius", "borderBottomLeftRadius"],
            z = a.style;

        for (q = parseFloat(a.offsetWidth), r = parseFloat(a.offsetHeight), i = b.split(" "), j = 0; j < y.length; j++) {
          this.p.indexOf("border") && (y[j] = $(y[j])), m = l = ba(a, y[j], e, !1, "0px"), -1 !== m.indexOf(" ") && (l = m.split(" "), m = l[0], l = l[1]), n = k = i[j], o = parseFloat(m), t = m.substr((o + "").length), u = "=" === n.charAt(1), u ? (p = parseInt(n.charAt(0) + "1", 10), n = n.substr(2), p *= parseFloat(n), s = n.substr((p + "").length - (0 > p ? 1 : 0)) || "") : (p = parseFloat(n), s = n.substr((p + "").length)), "" === s && (s = d[c] || t), s !== t && (v = ca(a, "borderLeft", o, t), w = ca(a, "borderTop", o, t), "%" === s ? (m = v / q * 100 + "%", l = w / r * 100 + "%") : "em" === s ? (x = ca(a, "borderLeft", 1, "em"), m = v / x + "em", l = w / x + "em") : (m = v + "px", l = w + "px"), u && (n = parseFloat(m) + p + s, k = parseFloat(l) + p + s)), g = xa(z, y[j], m + " " + l, n + " " + k, !1, "0px", g);
        }

        return g;
      },
      prefix: !0,
      formatter: sa("0px 0px 0px 0px", !1, !0)
    }), Aa("borderBottomLeftRadius,borderBottomRightRadius,borderTopLeftRadius,borderTopRightRadius", {
      defaultValue: "0px",
      parser: function parser(a, b, c, d, f, g) {
        return xa(a.style, c, this.format(ba(a, c, e, !1, "0px 0px")), this.format(b), !1, "0px", f);
      },
      prefix: !0,
      formatter: sa("0px 0px", !1, !0)
    }), Aa("backgroundPosition", {
      defaultValue: "0 0",
      parser: function parser(a, b, c, d, f, g) {
        var h,
            i,
            j,
            k,
            l,
            m,
            n = "background-position",
            o = e || aa(a, null),
            q = this.format((o ? p ? o.getPropertyValue(n + "-x") + " " + o.getPropertyValue(n + "-y") : o.getPropertyValue(n) : a.currentStyle.backgroundPositionX + " " + a.currentStyle.backgroundPositionY) || "0 0"),
            r = this.format(b);

        if (-1 !== q.indexOf("%") != (-1 !== r.indexOf("%")) && r.split(",").length < 2 && (m = ba(a, "backgroundImage").replace(E, ""), m && "none" !== m)) {
          for (h = q.split(" "), i = r.split(" "), S.setAttribute("src", m), j = 2; --j > -1;) {
            q = h[j], k = -1 !== q.indexOf("%"), k !== (-1 !== i[j].indexOf("%")) && (l = 0 === j ? a.offsetWidth - S.width : a.offsetHeight - S.height, h[j] = k ? parseFloat(q) / 100 * l + "px" : parseFloat(q) / l * 100 + "%");
          }

          q = h.join(" ");
        }

        return this.parseComplex(a.style, q, r, f, g);
      },
      formatter: ja
    }), Aa("backgroundSize", {
      defaultValue: "0 0",
      formatter: function formatter(a) {
        return a += "", "co" === a.substr(0, 2) ? a : ja(-1 === a.indexOf(" ") ? a + " " + a : a);
      }
    }), Aa("perspective", {
      defaultValue: "0px",
      prefix: !0
    }), Aa("perspectiveOrigin", {
      defaultValue: "50% 50%",
      prefix: !0
    }), Aa("transformStyle", {
      prefix: !0
    }), Aa("backfaceVisibility", {
      prefix: !0
    }), Aa("userSelect", {
      prefix: !0
    }), Aa("margin", {
      parser: ta("marginTop,marginRight,marginBottom,marginLeft")
    }), Aa("padding", {
      parser: ta("paddingTop,paddingRight,paddingBottom,paddingLeft")
    }), Aa("clip", {
      defaultValue: "rect(0px,0px,0px,0px)",
      parser: function parser(a, b, c, d, f, g) {
        var h, i, j;
        return 9 > p ? (i = a.currentStyle, j = 8 > p ? " " : ",", h = "rect(" + i.clipTop + j + i.clipRight + j + i.clipBottom + j + i.clipLeft + ")", b = this.format(b).split(",").join(j)) : (h = this.format(ba(a, this.p, e, !1, this.dflt)), b = this.format(b)), this.parseComplex(a.style, h, b, f, g);
      }
    }), Aa("textShadow", {
      defaultValue: "0px 0px 0px #999",
      color: !0,
      multi: !0
    }), Aa("autoRound,strictUnits", {
      parser: function parser(a, b, c, d, e) {
        return e;
      }
    }), Aa("border", {
      defaultValue: "0px solid #000",
      parser: function parser(a, b, c, d, f, g) {
        var h = ba(a, "borderTopWidth", e, !1, "0px"),
            i = this.format(b).split(" "),
            j = i[0].replace(x, "");
        return "px" !== j && (h = parseFloat(h) / ca(a, "borderTopWidth", 1, j) + j), this.parseComplex(a.style, this.format(h + " " + ba(a, "borderTopStyle", e, !1, "solid") + " " + ba(a, "borderTopColor", e, !1, "#000")), i.join(" "), f, g);
      },
      color: !0,
      formatter: function formatter(a) {
        var b = a.split(" ");
        return b[0] + " " + (b[1] || "solid") + " " + (a.match(ra) || ["#000"])[0];
      }
    }), Aa("borderWidth", {
      parser: ta("borderTopWidth,borderRightWidth,borderBottomWidth,borderLeftWidth")
    }), Aa("float,cssFloat,styleFloat", {
      parser: function parser(a, b, c, d, e, f) {
        var g = a.style,
            h = "cssFloat" in g ? "cssFloat" : "styleFloat";
        return new va(g, h, 0, 0, e, -1, c, !1, 0, g[h], b);
      }
    });

    var Wa = function Wa(a) {
      var b,
          c = this.t,
          d = c.filter || ba(this.data, "filter") || "",
          e = this.s + this.c * a | 0;
      100 === e && (-1 === d.indexOf("atrix(") && -1 === d.indexOf("radient(") && -1 === d.indexOf("oader(") ? (c.removeAttribute("filter"), b = !ba(this.data, "filter")) : (c.filter = d.replace(A, ""), b = !0)), b || (this.xn1 && (c.filter = d = d || "alpha(opacity=" + e + ")"), -1 === d.indexOf("pacity") ? 0 === e && this.xn1 || (c.filter = d + " alpha(opacity=" + e + ")") : c.filter = d.replace(y, "opacity=" + e));
    };

    Aa("opacity,alpha,autoAlpha", {
      defaultValue: "1",
      parser: function parser(a, b, c, d, f, g) {
        var h = parseFloat(ba(a, "opacity", e, !1, "1")),
            i = a.style,
            j = "autoAlpha" === c;
        return "string" == typeof b && "=" === b.charAt(1) && (b = ("-" === b.charAt(0) ? -1 : 1) * parseFloat(b.substr(2)) + h), j && 1 === h && "hidden" === ba(a, "visibility", e) && 0 !== b && (h = 0), V ? f = new va(i, "opacity", h, b - h, f) : (f = new va(i, "opacity", 100 * h, 100 * (b - h), f), f.xn1 = j ? 1 : 0, i.zoom = 1, f.type = 2, f.b = "alpha(opacity=" + f.s + ")", f.e = "alpha(opacity=" + (f.s + f.c) + ")", f.data = a, f.plugin = g, f.setRatio = Wa), j && (f = new va(i, "visibility", 0, 0, f, -1, null, !1, 0, 0 !== h ? "inherit" : "hidden", 0 === b ? "hidden" : "inherit"), f.xs0 = "inherit", d._overwriteProps.push(f.n), d._overwriteProps.push(c)), f;
      }
    });

    var Xa = function Xa(a, b) {
      b && (a.removeProperty ? (("ms" === b.substr(0, 2) || "webkit" === b.substr(0, 6)) && (b = "-" + b), a.removeProperty(b.replace(C, "-$1").toLowerCase())) : a.removeAttribute(b));
    },
        Ya = function Ya(a) {
      if (this.t._gsClassPT = this, 1 === a || 0 === a) {
        this.t.setAttribute("class", 0 === a ? this.b : this.e);

        for (var b = this.data, c = this.t.style; b;) {
          b.v ? c[b.p] = b.v : Xa(c, b.p), b = b._next;
        }

        1 === a && this.t._gsClassPT === this && (this.t._gsClassPT = null);
      } else this.t.getAttribute("class") !== this.e && this.t.setAttribute("class", this.e);
    };

    Aa("className", {
      parser: function parser(a, b, d, f, g, h, i) {
        var j,
            k,
            l,
            m,
            n,
            o = a.getAttribute("class") || "",
            p = a.style.cssText;

        if (g = f._classNamePT = new va(a, d, 0, 0, g, 2), g.setRatio = Ya, g.pr = -11, c = !0, g.b = o, k = ea(a, e), l = a._gsClassPT) {
          for (m = {}, n = l.data; n;) {
            m[n.p] = 1, n = n._next;
          }

          l.setRatio(1);
        }

        return a._gsClassPT = g, g.e = "=" !== b.charAt(1) ? b : o.replace(new RegExp("(?:\\s|^)" + b.substr(2) + "(?![\\w-])"), "") + ("+" === b.charAt(0) ? " " + b.substr(2) : ""), a.setAttribute("class", g.e), j = fa(a, k, ea(a), i, m), a.setAttribute("class", o), g.data = j.firstMPT, a.style.cssText !== p && (a.style.cssText = p), g = g.xfirst = f.parse(a, j.difs, g, h);
      }
    });

    var Za = function Za(a) {
      if ((1 === a || 0 === a) && this.data._totalTime === this.data._totalDuration && "isFromStart" !== this.data.data) {
        var b,
            c,
            d,
            e,
            f,
            g = this.t.style,
            h = i.transform.parse;
        if ("all" === this.e) g.cssText = "", e = !0;else for (b = this.e.split(" ").join("").split(","), d = b.length; --d > -1;) {
          c = b[d], i[c] && (i[c].parse === h ? e = !0 : c = "transformOrigin" === c ? Ga : i[c].p), Xa(g, c);
        }
        e && (Xa(g, Ea), f = this.t._gsTransform, f && (f.svg && (this.t.removeAttribute("data-svg-origin"), this.t.removeAttribute("transform")), delete this.t._gsTransform));
      }
    };

    for (Aa("clearProps", {
      parser: function parser(a, b, d, e, f) {
        return f = new va(a, d, 0, 0, f, 2), f.setRatio = Za, f.e = b, f.pr = -10, f.data = e._tween, c = !0, f;
      }
    }), j = "bezier,throwProps,physicsProps,physics2D".split(","), ya = j.length; ya--;) {
      Ba(j[ya]);
    }

    j = g.prototype, j._firstPT = j._lastParsedTransform = j._transform = null, j._onInitTween = function (a, b, h, j) {
      if (!a.nodeType) return !1;
      this._target = q = a, this._tween = h, this._vars = b, r = j, k = b.autoRound, c = !1, d = b.suffixMap || g.suffixMap, e = aa(a, ""), f = this._overwriteProps;
      var n,
          p,
          s,
          t,
          u,
          v,
          w,
          x,
          y,
          A = a.style;

      if (l && "" === A.zIndex && (n = ba(a, "zIndex", e), ("auto" === n || "" === n) && this._addLazySet(A, "zIndex", 0)), "string" == typeof b && (t = A.cssText, n = ea(a, e), A.cssText = t + ";" + b, n = fa(a, n, ea(a)).difs, !V && z.test(b) && (n.opacity = parseFloat(RegExp.$1)), b = n, A.cssText = t), b.className ? this._firstPT = p = i.className.parse(a, b.className, "className", this, null, null, b) : this._firstPT = p = this.parse(a, b, null), this._transformType) {
        for (y = 3 === this._transformType, Ea ? m && (l = !0, "" === A.zIndex && (w = ba(a, "zIndex", e), ("auto" === w || "" === w) && this._addLazySet(A, "zIndex", 0)), o && this._addLazySet(A, "WebkitBackfaceVisibility", this._vars.WebkitBackfaceVisibility || (y ? "visible" : "hidden"))) : A.zoom = 1, s = p; s && s._next;) {
          s = s._next;
        }

        x = new va(a, "transform", 0, 0, null, 2), this._linkCSSP(x, null, s), x.setRatio = Ea ? Va : Ua, x.data = this._transform || Ta(a, e, !0), x.tween = h, x.pr = -1, f.pop();
      }

      if (c) {
        for (; p;) {
          for (v = p._next, s = t; s && s.pr > p.pr;) {
            s = s._next;
          }

          (p._prev = s ? s._prev : u) ? p._prev._next = p : t = p, (p._next = s) ? s._prev = p : u = p, p = v;
        }

        this._firstPT = t;
      }

      return !0;
    }, j.parse = function (a, b, c, f) {
      var g,
          h,
          j,
          l,
          m,
          n,
          o,
          p,
          s,
          t,
          u = a.style;

      for (g in b) {
        if (n = b[g], h = i[g], "function" != typeof n || h && h.allowFunc || (n = n(r, q)), h) c = h.parse(a, n, g, this, c, f, b);else {
          if ("--" === g.substr(0, 2)) {
            this._tween._propLookup[g] = this._addTween.call(this._tween, a.style, "setProperty", aa(a).getPropertyValue(g) + "", n + "", g, !1, g);
            continue;
          }

          m = ba(a, g, e) + "", s = "string" == typeof n, "color" === g || "fill" === g || "stroke" === g || -1 !== g.indexOf("Color") || s && B.test(n) ? (s || (n = pa(n), n = (n.length > 3 ? "rgba(" : "rgb(") + n.join(",") + ")"), c = xa(u, g, m, n, !0, "transparent", c, 0, f)) : s && K.test(n) ? c = xa(u, g, m, n, !0, null, c, 0, f) : (j = parseFloat(m), o = j || 0 === j ? m.substr((j + "").length) : "", ("" === m || "auto" === m) && ("width" === g || "height" === g ? (j = ia(a, g, e), o = "px") : "left" === g || "top" === g ? (j = da(a, g, e), o = "px") : (j = "opacity" !== g ? 0 : 1, o = "")), t = s && "=" === n.charAt(1), t ? (l = parseInt(n.charAt(0) + "1", 10), n = n.substr(2), l *= parseFloat(n), p = n.replace(x, "")) : (l = parseFloat(n), p = s ? n.replace(x, "") : ""), "" === p && (p = g in d ? d[g] : o), n = l || 0 === l ? (t ? l + j : l) + p : b[g], o !== p && ("" !== p || "lineHeight" === g) && (l || 0 === l) && j && (j = ca(a, g, j, o), "%" === p ? (j /= ca(a, g, 100, "%") / 100, b.strictUnits !== !0 && (m = j + "%")) : "em" === p || "rem" === p || "vw" === p || "vh" === p ? j /= ca(a, g, 1, p) : "px" !== p && (l = ca(a, g, l, p), p = "px"), t && (l || 0 === l) && (n = l + j + p)), t && (l += j), !j && 0 !== j || !l && 0 !== l ? void 0 !== u[g] && (n || n + "" != "NaN" && null != n) ? (c = new va(u, g, l || j || 0, 0, c, -1, g, !1, 0, m, n), c.xs0 = "none" !== n || "display" !== g && -1 === g.indexOf("Style") ? n : m) : X("invalid " + g + " tween value: " + b[g]) : (c = new va(u, g, j, l - j, c, 0, g, k !== !1 && ("px" === p || "zIndex" === g), 0, m, n), c.xs0 = p));
        }
        f && c && !c.plugin && (c.plugin = f);
      }

      return c;
    }, j.setRatio = function (a) {
      var b,
          c,
          d,
          e = this._firstPT,
          f = 1e-6;
      if (1 !== a || this._tween._time !== this._tween._duration && 0 !== this._tween._time) {
        if (a || this._tween._time !== this._tween._duration && 0 !== this._tween._time || this._tween._rawPrevTime === -1e-6) for (; e;) {
          if (b = e.c * a + e.s, e.r ? b = e.r(b) : f > b && b > -f && (b = 0), e.type) {
            if (1 === e.type) {
              if (d = e.l, 2 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2;else if (3 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3;else if (4 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4;else if (5 === d) e.t[e.p] = e.xs0 + b + e.xs1 + e.xn1 + e.xs2 + e.xn2 + e.xs3 + e.xn3 + e.xs4 + e.xn4 + e.xs5;else {
                for (c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) {
                  c += e["xn" + d] + e["xs" + (d + 1)];
                }

                e.t[e.p] = c;
              }
            } else -1 === e.type ? e.t[e.p] = e.xs0 : e.setRatio && e.setRatio(a);
          } else e.t[e.p] = b + e.xs0;
          e = e._next;
        } else for (; e;) {
          2 !== e.type ? e.t[e.p] = e.b : e.setRatio(a), e = e._next;
        }
      } else for (; e;) {
        if (2 !== e.type) {
          if (e.r && -1 !== e.type) {
            if (b = e.r(e.s + e.c), e.type) {
              if (1 === e.type) {
                for (d = e.l, c = e.xs0 + b + e.xs1, d = 1; d < e.l; d++) {
                  c += e["xn" + d] + e["xs" + (d + 1)];
                }

                e.t[e.p] = c;
              }
            } else e.t[e.p] = b + e.xs0;
          } else e.t[e.p] = e.e;
        } else e.setRatio(a);
        e = e._next;
      }
    }, j._enableTransforms = function (a) {
      this._transform = this._transform || Ta(this._target, e, !0), this._transformType = this._transform.svg && Ca || !a && 3 !== this._transformType ? 2 : 3;
    };

    var $a = function $a(a) {
      this.t[this.p] = this.e, this.data._linkCSSP(this, this._next, null, !0);
    };

    j._addLazySet = function (a, b, c) {
      var d = this._firstPT = new va(a, b, 0, 0, this._firstPT, 2);
      d.e = c, d.setRatio = $a, d.data = this;
    }, j._linkCSSP = function (a, b, c, d) {
      return a && (b && (b._prev = a), a._next && (a._next._prev = a._prev), a._prev ? a._prev._next = a._next : this._firstPT === a && (this._firstPT = a._next, d = !0), c ? c._next = a : d || null !== this._firstPT || (this._firstPT = a), a._next = b, a._prev = c), a;
    }, j._mod = function (a) {
      for (var b = this._firstPT; b;) {
        "function" == typeof a[b.p] && (b.r = a[b.p]), b = b._next;
      }
    }, j._kill = function (b) {
      var c,
          d,
          e,
          f = b;

      if (b.autoAlpha || b.alpha) {
        f = {};

        for (d in b) {
          f[d] = b[d];
        }

        f.opacity = 1, f.autoAlpha && (f.visibility = 1);
      }

      for (b.className && (c = this._classNamePT) && (e = c.xfirst, e && e._prev ? this._linkCSSP(e._prev, c._next, e._prev._prev) : e === this._firstPT && (this._firstPT = c._next), c._next && this._linkCSSP(c._next, c._next._next, e._prev), this._classNamePT = null), c = this._firstPT; c;) {
        c.plugin && c.plugin !== d && c.plugin._kill && (c.plugin._kill(b), d = c.plugin), c = c._next;
      }

      return a.prototype._kill.call(this, f);
    };

    var _a = function _a(a, b, c) {
      var d, e, f, g;
      if (a.slice) for (e = a.length; --e > -1;) {
        _a(a[e], b, c);
      } else for (d = a.childNodes, e = d.length; --e > -1;) {
        f = d[e], g = f.type, f.style && (b.push(ea(f)), c && c.push(f)), 1 !== g && 9 !== g && 11 !== g || !f.childNodes.length || _a(f, b, c);
      }
    };

    return g.cascadeTo = function (a, c, d) {
      var e,
          f,
          g,
          h,
          i = b.to(a, c, d),
          j = [i],
          k = [],
          l = [],
          m = [],
          n = b._internals.reservedProps;

      for (a = i._targets || i.target, _a(a, k, m), i.render(c, !0, !0), _a(a, l), i.render(0, !0, !0), i._enabled(!0), e = m.length; --e > -1;) {
        if (f = fa(m[e], k[e], l[e]), f.firstMPT) {
          f = f.difs;

          for (g in d) {
            n[g] && (f[g] = d[g]);
          }

          h = {};

          for (g in f) {
            h[g] = k[e][g];
          }

          j.push(b.fromTo(m[e], c, h, f));
        }
      }

      return j;
    }, a.activate([g]), g;
  }, !0), function () {
    var a = _gsScope._gsDefine.plugin({
      propName: "roundProps",
      version: "1.7.0",
      priority: -1,
      API: 2,
      init: function init(a, b, c) {
        return this._tween = c, !0;
      }
    }),
        b = function b(a) {
      var b = 1 > a ? Math.pow(10, (a + "").length - 2) : 1;
      return function (c) {
        return (Math.round(c / a) * a * b | 0) / b;
      };
    },
        c = function c(a, b) {
      for (; a;) {
        a.f || a.blob || (a.m = b || Math.round), a = a._next;
      }
    },
        d = a.prototype;

    d._onInitAllProps = function () {
      var a,
          d,
          e,
          f,
          g = this._tween,
          h = g.vars.roundProps,
          i = {},
          j = g._propLookup.roundProps;
      if ("object" != _typeof(h) || h.push) for ("string" == typeof h && (h = h.split(",")), e = h.length; --e > -1;) {
        i[h[e]] = Math.round;
      } else for (f in h) {
        i[f] = b(h[f]);
      }

      for (f in i) {
        for (a = g._firstPT; a;) {
          d = a._next, a.pg ? a.t._mod(i) : a.n === f && (2 === a.f && a.t ? c(a.t._firstPT, i[f]) : (this._add(a.t, f, a.s, a.c, i[f]), d && (d._prev = a._prev), a._prev ? a._prev._next = d : g._firstPT === a && (g._firstPT = d), a._next = a._prev = null, g._propLookup[f] = j)), a = d;
        }
      }

      return !1;
    }, d._add = function (a, b, c, d, e) {
      this._addTween(a, b, c, c + d, b, e || Math.round), this._overwriteProps.push(b);
    };
  }(), function () {
    _gsScope._gsDefine.plugin({
      propName: "attr",
      API: 2,
      version: "0.6.1",
      init: function init(a, b, c, d) {
        var e, f;
        if ("function" != typeof a.setAttribute) return !1;

        for (e in b) {
          f = b[e], "function" == typeof f && (f = f(d, a)), this._addTween(a, "setAttribute", a.getAttribute(e) + "", f + "", e, !1, e), this._overwriteProps.push(e);
        }

        return !0;
      }
    });
  }(), _gsScope._gsDefine.plugin({
    propName: "directionalRotation",
    version: "0.3.1",
    API: 2,
    init: function init(a, b, c, d) {
      "object" != _typeof(b) && (b = {
        rotation: b
      }), this.finals = {};
      var e,
          f,
          g,
          h,
          i,
          j,
          k = b.useRadians === !0 ? 2 * Math.PI : 360,
          l = 1e-6;

      for (e in b) {
        "useRadians" !== e && (h = b[e], "function" == typeof h && (h = h(d, a)), j = (h + "").split("_"), f = j[0], g = parseFloat("function" != typeof a[e] ? a[e] : a[e.indexOf("set") || "function" != typeof a["get" + e.substr(3)] ? e : "get" + e.substr(3)]()), h = this.finals[e] = "string" == typeof f && "=" === f.charAt(1) ? g + parseInt(f.charAt(0) + "1", 10) * Number(f.substr(2)) : Number(f) || 0, i = h - g, j.length && (f = j.join("_"), -1 !== f.indexOf("short") && (i %= k, i !== i % (k / 2) && (i = 0 > i ? i + k : i - k)), -1 !== f.indexOf("_cw") && 0 > i ? i = (i + 9999999999 * k) % k - (i / k | 0) * k : -1 !== f.indexOf("ccw") && i > 0 && (i = (i - 9999999999 * k) % k - (i / k | 0) * k)), (i > l || -l > i) && (this._addTween(a, e, g, g + i, e), this._overwriteProps.push(e)));
      }

      return !0;
    },
    set: function set(a) {
      var b;
      if (1 !== a) this._super.setRatio.call(this, a);else for (b = this._firstPT; b;) {
        b.f ? b.t[b.p](this.finals[b.p]) : b.t[b.p] = this.finals[b.p], b = b._next;
      }
    }
  })._autoCSS = !0, _gsScope._gsDefine("easing.Back", ["easing.Ease"], function (a) {
    var b,
        c,
        d,
        e,
        f = _gsScope.GreenSockGlobals || _gsScope,
        g = f.com.greensock,
        h = 2 * Math.PI,
        i = Math.PI / 2,
        j = g._class,
        k = function k(b, c) {
      var d = j("easing." + b, function () {}, !0),
          e = d.prototype = new a();
      return e.constructor = d, e.getRatio = c, d;
    },
        l = a.register || function () {},
        m = function m(a, b, c, d, e) {
      var f = j("easing." + a, {
        easeOut: new b(),
        easeIn: new c(),
        easeInOut: new d()
      }, !0);
      return l(f, a), f;
    },
        n = function n(a, b, c) {
      this.t = a, this.v = b, c && (this.next = c, c.prev = this, this.c = c.v - b, this.gap = c.t - a);
    },
        o = function o(b, c) {
      var d = j("easing." + b, function (a) {
        this._p1 = a || 0 === a ? a : 1.70158, this._p2 = 1.525 * this._p1;
      }, !0),
          e = d.prototype = new a();
      return e.constructor = d, e.getRatio = c, e.config = function (a) {
        return new d(a);
      }, d;
    },
        p = m("Back", o("BackOut", function (a) {
      return (a -= 1) * a * ((this._p1 + 1) * a + this._p1) + 1;
    }), o("BackIn", function (a) {
      return a * a * ((this._p1 + 1) * a - this._p1);
    }), o("BackInOut", function (a) {
      return (a *= 2) < 1 ? .5 * a * a * ((this._p2 + 1) * a - this._p2) : .5 * ((a -= 2) * a * ((this._p2 + 1) * a + this._p2) + 2);
    })),
        q = j("easing.SlowMo", function (a, b, c) {
      b = b || 0 === b ? b : .7, null == a ? a = .7 : a > 1 && (a = 1), this._p = 1 !== a ? b : 0, this._p1 = (1 - a) / 2, this._p2 = a, this._p3 = this._p1 + this._p2, this._calcEnd = c === !0;
    }, !0),
        r = q.prototype = new a();

    return r.constructor = q, r.getRatio = function (a) {
      var b = a + (.5 - a) * this._p;
      return a < this._p1 ? this._calcEnd ? 1 - (a = 1 - a / this._p1) * a : b - (a = 1 - a / this._p1) * a * a * a * b : a > this._p3 ? this._calcEnd ? 1 === a ? 0 : 1 - (a = (a - this._p3) / this._p1) * a : b + (a - b) * (a = (a - this._p3) / this._p1) * a * a * a : this._calcEnd ? 1 : b;
    }, q.ease = new q(.7, .7), r.config = q.config = function (a, b, c) {
      return new q(a, b, c);
    }, b = j("easing.SteppedEase", function (a, b) {
      a = a || 1, this._p1 = 1 / a, this._p2 = a + (b ? 0 : 1), this._p3 = b ? 1 : 0;
    }, !0), r = b.prototype = new a(), r.constructor = b, r.getRatio = function (a) {
      return 0 > a ? a = 0 : a >= 1 && (a = .999999999), ((this._p2 * a | 0) + this._p3) * this._p1;
    }, r.config = b.config = function (a, c) {
      return new b(a, c);
    }, c = j("easing.ExpoScaleEase", function (a, b, c) {
      this._p1 = Math.log(b / a), this._p2 = b - a, this._p3 = a, this._ease = c;
    }, !0), r = c.prototype = new a(), r.constructor = c, r.getRatio = function (a) {
      return this._ease && (a = this._ease.getRatio(a)), (this._p3 * Math.exp(this._p1 * a) - this._p3) / this._p2;
    }, r.config = c.config = function (a, b, d) {
      return new c(a, b, d);
    }, d = j("easing.RoughEase", function (b) {
      b = b || {};

      for (var c, d, e, f, g, h, i = b.taper || "none", j = [], k = 0, l = 0 | (b.points || 20), m = l, o = b.randomize !== !1, p = b.clamp === !0, q = b.template instanceof a ? b.template : null, r = "number" == typeof b.strength ? .4 * b.strength : .4; --m > -1;) {
        c = o ? Math.random() : 1 / l * m, d = q ? q.getRatio(c) : c, "none" === i ? e = r : "out" === i ? (f = 1 - c, e = f * f * r) : "in" === i ? e = c * c * r : .5 > c ? (f = 2 * c, e = f * f * .5 * r) : (f = 2 * (1 - c), e = f * f * .5 * r), o ? d += Math.random() * e - .5 * e : m % 2 ? d += .5 * e : d -= .5 * e, p && (d > 1 ? d = 1 : 0 > d && (d = 0)), j[k++] = {
          x: c,
          y: d
        };
      }

      for (j.sort(function (a, b) {
        return a.x - b.x;
      }), h = new n(1, 1, null), m = l; --m > -1;) {
        g = j[m], h = new n(g.x, g.y, h);
      }

      this._prev = new n(0, 0, 0 !== h.t ? h : h.next);
    }, !0), r = d.prototype = new a(), r.constructor = d, r.getRatio = function (a) {
      var b = this._prev;

      if (a > b.t) {
        for (; b.next && a >= b.t;) {
          b = b.next;
        }

        b = b.prev;
      } else for (; b.prev && a <= b.t;) {
        b = b.prev;
      }

      return this._prev = b, b.v + (a - b.t) / b.gap * b.c;
    }, r.config = function (a) {
      return new d(a);
    }, d.ease = new d(), m("Bounce", k("BounceOut", function (a) {
      return 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375;
    }), k("BounceIn", function (a) {
      return (a = 1 - a) < 1 / 2.75 ? 1 - 7.5625 * a * a : 2 / 2.75 > a ? 1 - (7.5625 * (a -= 1.5 / 2.75) * a + .75) : 2.5 / 2.75 > a ? 1 - (7.5625 * (a -= 2.25 / 2.75) * a + .9375) : 1 - (7.5625 * (a -= 2.625 / 2.75) * a + .984375);
    }), k("BounceInOut", function (a) {
      var b = .5 > a;
      return a = b ? 1 - 2 * a : 2 * a - 1, a = 1 / 2.75 > a ? 7.5625 * a * a : 2 / 2.75 > a ? 7.5625 * (a -= 1.5 / 2.75) * a + .75 : 2.5 / 2.75 > a ? 7.5625 * (a -= 2.25 / 2.75) * a + .9375 : 7.5625 * (a -= 2.625 / 2.75) * a + .984375, b ? .5 * (1 - a) : .5 * a + .5;
    })), m("Circ", k("CircOut", function (a) {
      return Math.sqrt(1 - (a -= 1) * a);
    }), k("CircIn", function (a) {
      return -(Math.sqrt(1 - a * a) - 1);
    }), k("CircInOut", function (a) {
      return (a *= 2) < 1 ? -.5 * (Math.sqrt(1 - a * a) - 1) : .5 * (Math.sqrt(1 - (a -= 2) * a) + 1);
    })), e = function e(b, c, d) {
      var e = j("easing." + b, function (a, b) {
        this._p1 = a >= 1 ? a : 1, this._p2 = (b || d) / (1 > a ? a : 1), this._p3 = this._p2 / h * (Math.asin(1 / this._p1) || 0), this._p2 = h / this._p2;
      }, !0),
          f = e.prototype = new a();
      return f.constructor = e, f.getRatio = c, f.config = function (a, b) {
        return new e(a, b);
      }, e;
    }, m("Elastic", e("ElasticOut", function (a) {
      return this._p1 * Math.pow(2, -10 * a) * Math.sin((a - this._p3) * this._p2) + 1;
    }, .3), e("ElasticIn", function (a) {
      return -(this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2));
    }, .3), e("ElasticInOut", function (a) {
      return (a *= 2) < 1 ? -.5 * (this._p1 * Math.pow(2, 10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2)) : this._p1 * Math.pow(2, -10 * (a -= 1)) * Math.sin((a - this._p3) * this._p2) * .5 + 1;
    }, .45)), m("Expo", k("ExpoOut", function (a) {
      return 1 - Math.pow(2, -10 * a);
    }), k("ExpoIn", function (a) {
      return Math.pow(2, 10 * (a - 1)) - .001;
    }), k("ExpoInOut", function (a) {
      return (a *= 2) < 1 ? .5 * Math.pow(2, 10 * (a - 1)) : .5 * (2 - Math.pow(2, -10 * (a - 1)));
    })), m("Sine", k("SineOut", function (a) {
      return Math.sin(a * i);
    }), k("SineIn", function (a) {
      return -Math.cos(a * i) + 1;
    }), k("SineInOut", function (a) {
      return -.5 * (Math.cos(Math.PI * a) - 1);
    })), j("easing.EaseLookup", {
      find: function find(b) {
        return a.map[b];
      }
    }, !0), l(f.SlowMo, "SlowMo", "ease,"), l(d, "RoughEase", "ease,"), l(b, "SteppedEase", "ease,"), p;
  }, !0);
}), _gsScope._gsDefine && _gsScope._gsQueue.pop()(), function (a, b) {
  "use strict";

  var c = {},
      d = a.document,
      e = a.GreenSockGlobals = a.GreenSockGlobals || a,
      f = e[b];
  if (f) return "undefined" != typeof module && module.exports && (module.exports = f), f;

  var g,
      h,
      i,
      j,
      k,
      l = function l(a) {
    var b,
        c = a.split("."),
        d = e;

    for (b = 0; b < c.length; b++) {
      d[c[b]] = d = d[c[b]] || {};
    }

    return d;
  },
      m = l("com.greensock"),
      n = 1e-8,
      o = function o(a) {
    var b,
        c = [],
        d = a.length;

    for (b = 0; b !== d; c.push(a[b++])) {
      ;
    }

    return c;
  },
      p = function p() {},
      q = function () {
    var a = Object.prototype.toString,
        b = a.call([]);
    return function (c) {
      return null != c && (c instanceof Array || "object" == _typeof(c) && !!c.push && a.call(c) === b);
    };
  }(),
      r = {},
      s = function s(d, f, g, h) {
    this.sc = r[d] ? r[d].sc : [], r[d] = this, this.gsClass = null, this.func = g;
    var i = [];
    this.check = function (j) {
      for (var k, m, n, o, p = f.length, q = p; --p > -1;) {
        (k = r[f[p]] || new s(f[p], [])).gsClass ? (i[p] = k.gsClass, q--) : j && k.sc.push(this);
      }

      if (0 === q && g) {
        if (m = ("com.greensock." + d).split("."), n = m.pop(), o = l(m.join("."))[n] = this.gsClass = g.apply(g, i), h) if (e[n] = c[n] = o, "undefined" != typeof module && module.exports) {
          if (d === b) {
            module.exports = c[b] = o;

            for (p in c) {
              o[p] = c[p];
            }
          } else c[b] && (c[b][n] = o);
        } else "function" == typeof define && define.amd && define((a.GreenSockAMDPath ? a.GreenSockAMDPath + "/" : "") + d.split(".").pop(), [], function () {
          return o;
        });

        for (p = 0; p < this.sc.length; p++) {
          this.sc[p].check();
        }
      }
    }, this.check(!0);
  },
      t = a._gsDefine = function (a, b, c, d) {
    return new s(a, b, c, d);
  },
      u = m._class = function (a, b, c) {
    return b = b || function () {}, t(a, [], function () {
      return b;
    }, c), b;
  };

  t.globals = e;

  var v = [0, 0, 1, 1],
      w = u("easing.Ease", function (a, b, c, d) {
    this._func = a, this._type = c || 0, this._power = d || 0, this._params = b ? v.concat(b) : v;
  }, !0),
      x = w.map = {},
      y = w.register = function (a, b, c, d) {
    for (var e, f, g, h, i = b.split(","), j = i.length, k = (c || "easeIn,easeOut,easeInOut").split(","); --j > -1;) {
      for (f = i[j], e = d ? u("easing." + f, null, !0) : m.easing[f] || {}, g = k.length; --g > -1;) {
        h = k[g], x[f + "." + h] = x[h + f] = e[h] = a.getRatio ? a : a[h] || new a();
      }
    }
  };

  for (i = w.prototype, i._calcEnd = !1, i.getRatio = function (a) {
    if (this._func) return this._params[0] = a, this._func.apply(null, this._params);
    var b = this._type,
        c = this._power,
        d = 1 === b ? 1 - a : 2 === b ? a : .5 > a ? 2 * a : 2 * (1 - a);
    return 1 === c ? d *= d : 2 === c ? d *= d * d : 3 === c ? d *= d * d * d : 4 === c && (d *= d * d * d * d), 1 === b ? 1 - d : 2 === b ? d : .5 > a ? d / 2 : 1 - d / 2;
  }, g = ["Linear", "Quad", "Cubic", "Quart", "Quint,Strong"], h = g.length; --h > -1;) {
    i = g[h] + ",Power" + h, y(new w(null, null, 1, h), i, "easeOut", !0), y(new w(null, null, 2, h), i, "easeIn" + (0 === h ? ",easeNone" : "")), y(new w(null, null, 3, h), i, "easeInOut");
  }

  x.linear = m.easing.Linear.easeIn, x.swing = m.easing.Quad.easeInOut;
  var z = u("events.EventDispatcher", function (a) {
    this._listeners = {}, this._eventTarget = a || this;
  });
  i = z.prototype, i.addEventListener = function (a, b, c, d, e) {
    e = e || 0;
    var f,
        g,
        h = this._listeners[a],
        i = 0;

    for (this !== j || k || j.wake(), null == h && (this._listeners[a] = h = []), g = h.length; --g > -1;) {
      f = h[g], f.c === b && f.s === c ? h.splice(g, 1) : 0 === i && f.pr < e && (i = g + 1);
    }

    h.splice(i, 0, {
      c: b,
      s: c,
      up: d,
      pr: e
    });
  }, i.removeEventListener = function (a, b) {
    var c,
        d = this._listeners[a];
    if (d) for (c = d.length; --c > -1;) {
      if (d[c].c === b) return void d.splice(c, 1);
    }
  }, i.dispatchEvent = function (a) {
    var b,
        c,
        d,
        e = this._listeners[a];
    if (e) for (b = e.length, b > 1 && (e = e.slice(0)), c = this._eventTarget; --b > -1;) {
      d = e[b], d && (d.up ? d.c.call(d.s || c, {
        type: a,
        target: c
      }) : d.c.call(d.s || c));
    }
  };

  var A = a.requestAnimationFrame,
      B = a.cancelAnimationFrame,
      C = Date.now || function () {
    return new Date().getTime();
  },
      D = C();

  for (g = ["ms", "moz", "webkit", "o"], h = g.length; --h > -1 && !A;) {
    A = a[g[h] + "RequestAnimationFrame"], B = a[g[h] + "CancelAnimationFrame"] || a[g[h] + "CancelRequestAnimationFrame"];
  }

  u("Ticker", function (a, b) {
    var c,
        e,
        f,
        g,
        h,
        i = this,
        l = C(),
        m = b !== !1 && A ? "auto" : !1,
        o = 500,
        q = 33,
        r = "tick",
        s = function s(a) {
      var b,
          d,
          j = C() - D;
      j > o && (l += j - q), D += j, i.time = (D - l) / 1e3, b = i.time - h, (!c || b > 0 || a === !0) && (i.frame++, h += b + (b >= g ? .004 : g - b), d = !0), a !== !0 && (f = e(s)), d && i.dispatchEvent(r);
    };

    z.call(i), i.time = i.frame = 0, i.tick = function () {
      s(!0);
    }, i.lagSmoothing = function (a, b) {
      return arguments.length ? (o = a || 1 / n, void (q = Math.min(b, o, 0))) : 1 / n > o;
    }, i.sleep = function () {
      null != f && (m && B ? B(f) : clearTimeout(f), e = p, f = null, i === j && (k = !1));
    }, i.wake = function (a) {
      null !== f ? i.sleep() : a ? l += -D + (D = C()) : i.frame > 10 && (D = C() - o + 5), e = 0 === c ? p : m && A ? A : function (a) {
        return setTimeout(a, 1e3 * (h - i.time) + 1 | 0);
      }, i === j && (k = !0), s(2);
    }, i.fps = function (a) {
      return arguments.length ? (c = a, g = 1 / (c || 60), h = this.time + g, void i.wake()) : c;
    }, i.useRAF = function (a) {
      return arguments.length ? (i.sleep(), m = a, void i.fps(c)) : m;
    }, i.fps(a), setTimeout(function () {
      "auto" === m && i.frame < 5 && "hidden" !== (d || {}).visibilityState && i.useRAF(!1);
    }, 1500);
  }), i = m.Ticker.prototype = new m.events.EventDispatcher(), i.constructor = m.Ticker;
  var E = u("core.Animation", function (a, b) {
    if (this.vars = b = b || {}, this._duration = this._totalDuration = a || 0, this._delay = Number(b.delay) || 0, this._timeScale = 1, this._active = !!b.immediateRender, this.data = b.data, this._reversed = !!b.reversed, Z) {
      k || j.wake();
      var c = this.vars.useFrames ? Y : Z;
      c.add(this, c._time), this.vars.paused && this.paused(!0);
    }
  });
  j = E.ticker = new m.Ticker(), i = E.prototype, i._dirty = i._gc = i._initted = i._paused = !1, i._totalTime = i._time = 0, i._rawPrevTime = -1, i._next = i._last = i._onUpdate = i._timeline = i.timeline = null, i._paused = !1;

  var F = function F() {
    k && C() - D > 2e3 && ("hidden" !== (d || {}).visibilityState || !j.lagSmoothing()) && j.wake();
    var a = setTimeout(F, 2e3);
    a.unref && a.unref();
  };

  F(), i.play = function (a, b) {
    return null != a && this.seek(a, b), this.reversed(!1).paused(!1);
  }, i.pause = function (a, b) {
    return null != a && this.seek(a, b), this.paused(!0);
  }, i.resume = function (a, b) {
    return null != a && this.seek(a, b), this.paused(!1);
  }, i.seek = function (a, b) {
    return this.totalTime(Number(a), b !== !1);
  }, i.restart = function (a, b) {
    return this.reversed(!1).paused(!1).totalTime(a ? -this._delay : 0, b !== !1, !0);
  }, i.reverse = function (a, b) {
    return null != a && this.seek(a || this.totalDuration(), b), this.reversed(!0).paused(!1);
  }, i.render = function (a, b, c) {}, i.invalidate = function () {
    return this._time = this._totalTime = 0, this._initted = this._gc = !1, this._rawPrevTime = -1, (this._gc || !this.timeline) && this._enabled(!0), this;
  }, i.isActive = function () {
    var a,
        b = this._timeline,
        c = this._startTime;
    return !b || !this._gc && !this._paused && b.isActive() && (a = b.rawTime(!0)) >= c && a < c + this.totalDuration() / this._timeScale - n;
  }, i._enabled = function (a, b) {
    return k || j.wake(), this._gc = !a, this._active = this.isActive(), b !== !0 && (a && !this.timeline ? this._timeline.add(this, this._startTime - this._delay) : !a && this.timeline && this._timeline._remove(this, !0)), !1;
  }, i._kill = function (a, b) {
    return this._enabled(!1, !1);
  }, i.kill = function (a, b) {
    return this._kill(a, b), this;
  }, i._uncache = function (a) {
    for (var b = a ? this : this.timeline; b;) {
      b._dirty = !0, b = b.timeline;
    }

    return this;
  }, i._swapSelfInParams = function (a) {
    for (var b = a.length, c = a.concat(); --b > -1;) {
      "{self}" === a[b] && (c[b] = this);
    }

    return c;
  }, i._callback = function (a) {
    var b = this.vars,
        c = b[a],
        d = b[a + "Params"],
        e = b[a + "Scope"] || b.callbackScope || this,
        f = d ? d.length : 0;

    switch (f) {
      case 0:
        c.call(e);
        break;

      case 1:
        c.call(e, d[0]);
        break;

      case 2:
        c.call(e, d[0], d[1]);
        break;

      default:
        c.apply(e, d);
    }
  }, i.eventCallback = function (a, b, c, d) {
    if ("on" === (a || "").substr(0, 2)) {
      var e = this.vars;
      if (1 === arguments.length) return e[a];
      null == b ? delete e[a] : (e[a] = b, e[a + "Params"] = q(c) && -1 !== c.join("").indexOf("{self}") ? this._swapSelfInParams(c) : c, e[a + "Scope"] = d), "onUpdate" === a && (this._onUpdate = b);
    }

    return this;
  }, i.delay = function (a) {
    return arguments.length ? (this._timeline.smoothChildTiming && this.startTime(this._startTime + a - this._delay), this._delay = a, this) : this._delay;
  }, i.duration = function (a) {
    return arguments.length ? (this._duration = this._totalDuration = a, this._uncache(!0), this._timeline.smoothChildTiming && this._time > 0 && this._time < this._duration && 0 !== a && this.totalTime(this._totalTime * (a / this._duration), !0), this) : (this._dirty = !1, this._duration);
  }, i.totalDuration = function (a) {
    return this._dirty = !1, arguments.length ? this.duration(a) : this._totalDuration;
  }, i.time = function (a, b) {
    return arguments.length ? (this._dirty && this.totalDuration(), this.totalTime(a > this._duration ? this._duration : a, b)) : this._time;
  }, i.totalTime = function (a, b, c) {
    if (k || j.wake(), !arguments.length) return this._totalTime;

    if (this._timeline) {
      if (0 > a && !c && (a += this.totalDuration()), this._timeline.smoothChildTiming) {
        this._dirty && this.totalDuration();
        var d = this._totalDuration,
            e = this._timeline;
        if (a > d && !c && (a = d), this._startTime = (this._paused ? this._pauseTime : e._time) - (this._reversed ? d - a : a) / this._timeScale, e._dirty || this._uncache(!1), e._timeline) for (; e._timeline;) {
          e._timeline._time !== (e._startTime + e._totalTime) / e._timeScale && e.totalTime(e._totalTime, !0), e = e._timeline;
        }
      }

      this._gc && this._enabled(!0, !1), (this._totalTime !== a || 0 === this._duration) && (K.length && _(), this.render(a, b, !1), K.length && _());
    }

    return this;
  }, i.progress = i.totalProgress = function (a, b) {
    var c = this.duration();
    return arguments.length ? this.totalTime(c * a, b) : c ? this._time / c : this.ratio;
  }, i.startTime = function (a) {
    return arguments.length ? (a !== this._startTime && (this._startTime = a, this.timeline && this.timeline._sortChildren && this.timeline.add(this, a - this._delay)), this) : this._startTime;
  }, i.endTime = function (a) {
    return this._startTime + (0 != a ? this.totalDuration() : this.duration()) / this._timeScale;
  }, i.timeScale = function (a) {
    if (!arguments.length) return this._timeScale;
    var b, c;

    for (a = a || n, this._timeline && this._timeline.smoothChildTiming && (b = this._pauseTime, c = b || 0 === b ? b : this._timeline.totalTime(), this._startTime = c - (c - this._startTime) * this._timeScale / a), this._timeScale = a, c = this.timeline; c && c.timeline;) {
      c._dirty = !0, c.totalDuration(), c = c.timeline;
    }

    return this;
  }, i.reversed = function (a) {
    return arguments.length ? (a != this._reversed && (this._reversed = a, this.totalTime(this._timeline && !this._timeline.smoothChildTiming ? this.totalDuration() - this._totalTime : this._totalTime, !0)), this) : this._reversed;
  }, i.paused = function (a) {
    if (!arguments.length) return this._paused;
    var b,
        c,
        d = this._timeline;
    return a != this._paused && d && (k || a || j.wake(), b = d.rawTime(), c = b - this._pauseTime, !a && d.smoothChildTiming && (this._startTime += c, this._uncache(!1)), this._pauseTime = a ? b : null, this._paused = a, this._active = this.isActive(), !a && 0 !== c && this._initted && this.duration() && (b = d.smoothChildTiming ? this._totalTime : (b - this._startTime) / this._timeScale, this.render(b, b === this._totalTime, !0))), this._gc && !a && this._enabled(!0, !1), this;
  };
  var G = u("core.SimpleTimeline", function (a) {
    E.call(this, 0, a), this.autoRemoveChildren = this.smoothChildTiming = !0;
  });
  i = G.prototype = new E(), i.constructor = G, i.kill()._gc = !1, i._first = i._last = i._recent = null, i._sortChildren = !1, i.add = i.insert = function (a, b, c, d) {
    var e, f;
    if (a._startTime = Number(b || 0) + a._delay, a._paused && this !== a._timeline && (a._pauseTime = this.rawTime() - (a._timeline.rawTime() - a._pauseTime)), a.timeline && a.timeline._remove(a, !0), a.timeline = a._timeline = this, a._gc && a._enabled(!0, !0), e = this._last, this._sortChildren) for (f = a._startTime; e && e._startTime > f;) {
      e = e._prev;
    }
    return e ? (a._next = e._next, e._next = a) : (a._next = this._first, this._first = a), a._next ? a._next._prev = a : this._last = a, a._prev = e, this._recent = a, this._timeline && this._uncache(!0), this;
  }, i._remove = function (a, b) {
    return a.timeline === this && (b || a._enabled(!1, !0), a._prev ? a._prev._next = a._next : this._first === a && (this._first = a._next), a._next ? a._next._prev = a._prev : this._last === a && (this._last = a._prev), a._next = a._prev = a.timeline = null, a === this._recent && (this._recent = this._last), this._timeline && this._uncache(!0)), this;
  }, i.render = function (a, b, c) {
    var d,
        e = this._first;

    for (this._totalTime = this._time = this._rawPrevTime = a; e;) {
      d = e._next, (e._active || a >= e._startTime && !e._paused && !e._gc) && (e._reversed ? e.render((e._dirty ? e.totalDuration() : e._totalDuration) - (a - e._startTime) * e._timeScale, b, c) : e.render((a - e._startTime) * e._timeScale, b, c)), e = d;
    }
  }, i.rawTime = function () {
    return k || j.wake(), this._totalTime;
  };

  var H = u("TweenLite", function (b, c, d) {
    if (E.call(this, c, d), this.render = H.prototype.render, null == b) throw "Cannot tween a null target.";
    this.target = b = "string" != typeof b ? b : H.selector(b) || b;
    var e,
        f,
        g,
        h = b.jquery || b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType),
        i = this.vars.overwrite;
    if (this._overwrite = i = null == i ? X[H.defaultOverwrite] : "number" == typeof i ? i >> 0 : X[i], (h || b instanceof Array || b.push && q(b)) && "number" != typeof b[0]) for (this._targets = g = o(b), this._propLookup = [], this._siblings = [], e = 0; e < g.length; e++) {
      f = g[e], f ? "string" != typeof f ? f.length && f !== a && f[0] && (f[0] === a || f[0].nodeType && f[0].style && !f.nodeType) ? (g.splice(e--, 1), this._targets = g = g.concat(o(f))) : (this._siblings[e] = aa(f, this, !1), 1 === i && this._siblings[e].length > 1 && ca(f, this, null, 1, this._siblings[e])) : (f = g[e--] = H.selector(f), "string" == typeof f && g.splice(e + 1, 1)) : g.splice(e--, 1);
    } else this._propLookup = {}, this._siblings = aa(b, this, !1), 1 === i && this._siblings.length > 1 && ca(b, this, null, 1, this._siblings);
    (this.vars.immediateRender || 0 === c && 0 === this._delay && this.vars.immediateRender !== !1) && (this._time = -n, this.render(Math.min(0, -this._delay)));
  }, !0),
      I = function I(b) {
    return b && b.length && b !== a && b[0] && (b[0] === a || b[0].nodeType && b[0].style && !b.nodeType);
  },
      J = function J(a, b) {
    var c,
        d = {};

    for (c in a) {
      W[c] || c in b && "transform" !== c && "x" !== c && "y" !== c && "width" !== c && "height" !== c && "className" !== c && "border" !== c || !(!T[c] || T[c] && T[c]._autoCSS) || (d[c] = a[c], delete a[c]);
    }

    a.css = d;
  };

  i = H.prototype = new E(), i.constructor = H, i.kill()._gc = !1, i.ratio = 0, i._firstPT = i._targets = i._overwrittenProps = i._startAt = null, i._notifyPluginsOfEnabled = i._lazy = !1, H.version = "2.1.3", H.defaultEase = i._ease = new w(null, null, 1, 1), H.defaultOverwrite = "auto", H.ticker = j, H.autoSleep = 120, H.lagSmoothing = function (a, b) {
    j.lagSmoothing(a, b);
  }, H.selector = a.$ || a.jQuery || function (b) {
    var c = a.$ || a.jQuery;
    return c ? (H.selector = c, c(b)) : (d || (d = a.document), d ? d.querySelectorAll ? d.querySelectorAll(b) : d.getElementById("#" === b.charAt(0) ? b.substr(1) : b) : b);
  };

  var K = [],
      L = {},
      M = /(?:(-|-=|\+=)?\d*\.?\d*(?:e[\-+]?\d+)?)[0-9]/gi,
      N = /[\+-]=-?[\.\d]/,
      O = function O(a) {
    for (var b, c = this._firstPT, d = 1e-6; c;) {
      b = c.blob ? 1 === a && null != this.end ? this.end : a ? this.join("") : this.start : c.c * a + c.s, c.m ? b = c.m.call(this._tween, b, this._target || c.t, this._tween) : d > b && b > -d && !c.blob && (b = 0), c.f ? c.fp ? c.t[c.p](c.fp, b) : c.t[c.p](b) : c.t[c.p] = b, c = c._next;
    }
  },
      P = function P(a) {
    return (1e3 * a | 0) / 1e3 + "";
  },
      Q = function Q(a, b, c, d) {
    var e,
        f,
        g,
        h,
        i,
        j,
        k,
        l = [],
        m = 0,
        n = "",
        o = 0;

    for (l.start = a, l.end = b, a = l[0] = a + "", b = l[1] = b + "", c && (c(l), a = l[0], b = l[1]), l.length = 0, e = a.match(M) || [], f = b.match(M) || [], d && (d._next = null, d.blob = 1, l._firstPT = l._applyPT = d), i = f.length, h = 0; i > h; h++) {
      k = f[h], j = b.substr(m, b.indexOf(k, m) - m), n += j || !h ? j : ",", m += j.length, o ? o = (o + 1) % 5 : "rgba(" === j.substr(-5) && (o = 1), k === e[h] || e.length <= h ? n += k : (n && (l.push(n), n = ""), g = parseFloat(e[h]), l.push(g), l._firstPT = {
        _next: l._firstPT,
        t: l,
        p: l.length - 1,
        s: g,
        c: ("=" === k.charAt(1) ? parseInt(k.charAt(0) + "1", 10) * parseFloat(k.substr(2)) : parseFloat(k) - g) || 0,
        f: 0,
        m: o && 4 > o ? Math.round : P
      }), m += k.length;
    }

    return n += b.substr(m), n && l.push(n), l.setRatio = O, N.test(b) && (l.end = null), l;
  },
      R = function R(a, b, c, d, e, f, g, h, i) {
    "function" == typeof d && (d = d(i || 0, a));

    var j,
        k = _typeof(a[b]),
        l = "function" !== k ? "" : b.indexOf("set") || "function" != typeof a["get" + b.substr(3)] ? b : "get" + b.substr(3),
        m = "get" !== c ? c : l ? g ? a[l](g) : a[l]() : a[b],
        n = "string" == typeof d && "=" === d.charAt(1),
        o = {
      t: a,
      p: b,
      s: m,
      f: "function" === k,
      pg: 0,
      n: e || b,
      m: f ? "function" == typeof f ? f : Math.round : 0,
      pr: 0,
      c: n ? parseInt(d.charAt(0) + "1", 10) * parseFloat(d.substr(2)) : parseFloat(d) - m || 0
    };

    return ("number" != typeof m || "number" != typeof d && !n) && (g || isNaN(m) || !n && isNaN(d) || "boolean" == typeof m || "boolean" == typeof d ? (o.fp = g, j = Q(m, n ? parseFloat(o.s) + o.c + (o.s + "").replace(/[0-9\-\.]/g, "") : d, h || H.defaultStringFilter, o), o = {
      t: j,
      p: "setRatio",
      s: 0,
      c: 1,
      f: 2,
      pg: 0,
      n: e || b,
      pr: 0,
      m: 0
    }) : (o.s = parseFloat(m), n || (o.c = parseFloat(d) - o.s || 0))), o.c ? ((o._next = this._firstPT) && (o._next._prev = o), this._firstPT = o, o) : void 0;
  },
      S = H._internals = {
    isArray: q,
    isSelector: I,
    lazyTweens: K,
    blobDif: Q
  },
      T = H._plugins = {},
      U = S.tweenLookup = {},
      V = 0,
      W = S.reservedProps = {
    ease: 1,
    delay: 1,
    overwrite: 1,
    onComplete: 1,
    onCompleteParams: 1,
    onCompleteScope: 1,
    useFrames: 1,
    runBackwards: 1,
    startAt: 1,
    onUpdate: 1,
    onUpdateParams: 1,
    onUpdateScope: 1,
    onStart: 1,
    onStartParams: 1,
    onStartScope: 1,
    onReverseComplete: 1,
    onReverseCompleteParams: 1,
    onReverseCompleteScope: 1,
    onRepeat: 1,
    onRepeatParams: 1,
    onRepeatScope: 1,
    easeParams: 1,
    yoyo: 1,
    immediateRender: 1,
    repeat: 1,
    repeatDelay: 1,
    data: 1,
    paused: 1,
    reversed: 1,
    autoCSS: 1,
    lazy: 1,
    onOverwrite: 1,
    callbackScope: 1,
    stringFilter: 1,
    id: 1,
    yoyoEase: 1,
    stagger: 1
  },
      X = {
    none: 0,
    all: 1,
    auto: 2,
    concurrent: 3,
    allOnStart: 4,
    preexisting: 5,
    "true": 1,
    "false": 0
  },
      Y = E._rootFramesTimeline = new G(),
      Z = E._rootTimeline = new G(),
      $ = 30,
      _ = S.lazyRender = function () {
    var a,
        b,
        c = K.length;

    for (L = {}, a = 0; c > a; a++) {
      b = K[a], b && b._lazy !== !1 && (b.render(b._lazy[0], b._lazy[1], !0), b._lazy = !1);
    }

    K.length = 0;
  };

  Z._startTime = j.time, Y._startTime = j.frame, Z._active = Y._active = !0, setTimeout(_, 1), E._updateRoot = H.render = function () {
    var a, b, c;

    if (K.length && _(), Z.render((j.time - Z._startTime) * Z._timeScale, !1, !1), Y.render((j.frame - Y._startTime) * Y._timeScale, !1, !1), K.length && _(), j.frame >= $) {
      $ = j.frame + (parseInt(H.autoSleep, 10) || 120);

      for (c in U) {
        for (b = U[c].tweens, a = b.length; --a > -1;) {
          b[a]._gc && b.splice(a, 1);
        }

        0 === b.length && delete U[c];
      }

      if (c = Z._first, (!c || c._paused) && H.autoSleep && !Y._first && 1 === j._listeners.tick.length) {
        for (; c && c._paused;) {
          c = c._next;
        }

        c || j.sleep();
      }
    }
  }, j.addEventListener("tick", E._updateRoot);

  var aa = function aa(a, b, c) {
    var d,
        e,
        f = a._gsTweenID;
    if (U[f || (a._gsTweenID = f = "t" + V++)] || (U[f] = {
      target: a,
      tweens: []
    }), b && (d = U[f].tweens, d[e = d.length] = b, c)) for (; --e > -1;) {
      d[e] === b && d.splice(e, 1);
    }
    return U[f].tweens;
  },
      ba = function ba(a, b, c, d) {
    var e,
        f,
        g = a.vars.onOverwrite;
    return g && (e = g(a, b, c, d)), g = H.onOverwrite, g && (f = g(a, b, c, d)), e !== !1 && f !== !1;
  },
      ca = function ca(a, b, c, d, e) {
    var f, g, h, i;

    if (1 === d || d >= 4) {
      for (i = e.length, f = 0; i > f; f++) {
        if ((h = e[f]) !== b) h._gc || h._kill(null, a, b) && (g = !0);else if (5 === d) break;
      }

      return g;
    }

    var j,
        k = b._startTime + n,
        l = [],
        m = 0,
        o = 0 === b._duration;

    for (f = e.length; --f > -1;) {
      (h = e[f]) === b || h._gc || h._paused || (h._timeline !== b._timeline ? (j = j || da(b, 0, o), 0 === da(h, j, o) && (l[m++] = h)) : h._startTime <= k && h._startTime + h.totalDuration() / h._timeScale > k && ((o || !h._initted) && k - h._startTime <= 2 * n || (l[m++] = h)));
    }

    for (f = m; --f > -1;) {
      if (h = l[f], i = h._firstPT, 2 === d && h._kill(c, a, b) && (g = !0), 2 !== d || !h._firstPT && h._initted && i) {
        if (2 !== d && !ba(h, b)) continue;
        h._enabled(!1, !1) && (g = !0);
      }
    }

    return g;
  },
      da = function da(a, b, c) {
    for (var d = a._timeline, e = d._timeScale, f = a._startTime; d._timeline;) {
      if (f += d._startTime, e *= d._timeScale, d._paused) return -100;
      d = d._timeline;
    }

    return f /= e, f > b ? f - b : c && f === b || !a._initted && 2 * n > f - b ? n : (f += a.totalDuration() / a._timeScale / e) > b + n ? 0 : f - b - n;
  };

  i._init = function () {
    var a,
        b,
        c,
        d,
        e,
        f,
        g = this.vars,
        h = this._overwrittenProps,
        i = this._duration,
        j = !!g.immediateRender,
        k = g.ease,
        l = this._startAt;

    if (g.startAt) {
      l && (l.render(-1, !0), l.kill()), e = {};

      for (d in g.startAt) {
        e[d] = g.startAt[d];
      }

      if (e.data = "isStart", e.overwrite = !1, e.immediateRender = !0, e.lazy = j && g.lazy !== !1, e.startAt = e.delay = null, e.onUpdate = g.onUpdate, e.onUpdateParams = g.onUpdateParams, e.onUpdateScope = g.onUpdateScope || g.callbackScope || this, this._startAt = H.to(this.target || {}, 0, e), j) if (this._time > 0) this._startAt = null;else if (0 !== i) return;
    } else if (g.runBackwards && 0 !== i) if (l) l.render(-1, !0), l.kill(), this._startAt = null;else {
      0 !== this._time && (j = !1), c = {};

      for (d in g) {
        W[d] && "autoCSS" !== d || (c[d] = g[d]);
      }

      if (c.overwrite = 0, c.data = "isFromStart", c.lazy = j && g.lazy !== !1, c.immediateRender = j, this._startAt = H.to(this.target, 0, c), j) {
        if (0 === this._time) return;
      } else this._startAt._init(), this._startAt._enabled(!1), this.vars.immediateRender && (this._startAt = null);
    }

    if (this._ease = k = k ? k instanceof w ? k : "function" == typeof k ? new w(k, g.easeParams) : x[k] || H.defaultEase : H.defaultEase, g.easeParams instanceof Array && k.config && (this._ease = k.config.apply(k, g.easeParams)), this._easeType = this._ease._type, this._easePower = this._ease._power, this._firstPT = null, this._targets) for (f = this._targets.length, a = 0; f > a; a++) {
      this._initProps(this._targets[a], this._propLookup[a] = {}, this._siblings[a], h ? h[a] : null, a) && (b = !0);
    } else b = this._initProps(this.target, this._propLookup, this._siblings, h, 0);
    if (b && H._onPluginEvent("_onInitAllProps", this), h && (this._firstPT || "function" != typeof this.target && this._enabled(!1, !1)), g.runBackwards) for (c = this._firstPT; c;) {
      c.s += c.c, c.c = -c.c, c = c._next;
    }
    this._onUpdate = g.onUpdate, this._initted = !0;
  }, i._initProps = function (b, c, d, e, f) {
    var g, h, i, j, k, l;
    if (null == b) return !1;
    L[b._gsTweenID] && _(), this.vars.css || b.style && b !== a && b.nodeType && T.css && this.vars.autoCSS !== !1 && J(this.vars, b);

    for (g in this.vars) {
      if (l = this.vars[g], W[g]) l && (l instanceof Array || l.push && q(l)) && -1 !== l.join("").indexOf("{self}") && (this.vars[g] = l = this._swapSelfInParams(l, this));else if (T[g] && (j = new T[g]())._onInitTween(b, this.vars[g], this, f)) {
        for (this._firstPT = k = {
          _next: this._firstPT,
          t: j,
          p: "setRatio",
          s: 0,
          c: 1,
          f: 1,
          n: g,
          pg: 1,
          pr: j._priority,
          m: 0
        }, h = j._overwriteProps.length; --h > -1;) {
          c[j._overwriteProps[h]] = this._firstPT;
        }

        (j._priority || j._onInitAllProps) && (i = !0), (j._onDisable || j._onEnable) && (this._notifyPluginsOfEnabled = !0), k._next && (k._next._prev = k);
      } else c[g] = R.call(this, b, g, "get", l, g, 0, null, this.vars.stringFilter, f);
    }

    return e && this._kill(e, b) ? this._initProps(b, c, d, e, f) : this._overwrite > 1 && this._firstPT && d.length > 1 && ca(b, this, c, this._overwrite, d) ? (this._kill(c, b), this._initProps(b, c, d, e, f)) : (this._firstPT && (this.vars.lazy !== !1 && this._duration || this.vars.lazy && !this._duration) && (L[b._gsTweenID] = !0), i);
  }, i.render = function (a, b, c) {
    var d,
        e,
        f,
        g,
        h = this,
        i = h._time,
        j = h._duration,
        k = h._rawPrevTime;
    if (a >= j - n && a >= 0) h._totalTime = h._time = j, h.ratio = h._ease._calcEnd ? h._ease.getRatio(1) : 1, h._reversed || (d = !0, e = "onComplete", c = c || h._timeline.autoRemoveChildren), 0 === j && (h._initted || !h.vars.lazy || c) && (h._startTime === h._timeline._duration && (a = 0), (0 > k || 0 >= a && a >= -n || k === n && "isPause" !== h.data) && k !== a && (c = !0, k > n && (e = "onReverseComplete")), h._rawPrevTime = g = !b || a || k === a ? a : n);else if (n > a) h._totalTime = h._time = 0, h.ratio = h._ease._calcEnd ? h._ease.getRatio(0) : 0, (0 !== i || 0 === j && k > 0) && (e = "onReverseComplete", d = h._reversed), a > -n ? a = 0 : 0 > a && (h._active = !1, 0 === j && (h._initted || !h.vars.lazy || c) && (k >= 0 && (k !== n || "isPause" !== h.data) && (c = !0), h._rawPrevTime = g = !b || a || k === a ? a : n)), (!h._initted || h._startAt && h._startAt.progress()) && (c = !0);else if (h._totalTime = h._time = a, h._easeType) {
      var l = a / j,
          m = h._easeType,
          o = h._easePower;
      (1 === m || 3 === m && l >= .5) && (l = 1 - l), 3 === m && (l *= 2), 1 === o ? l *= l : 2 === o ? l *= l * l : 3 === o ? l *= l * l * l : 4 === o && (l *= l * l * l * l), h.ratio = 1 === m ? 1 - l : 2 === m ? l : .5 > a / j ? l / 2 : 1 - l / 2;
    } else h.ratio = h._ease.getRatio(a / j);

    if (h._time !== i || c) {
      if (!h._initted) {
        if (h._init(), !h._initted || h._gc) return;
        if (!c && h._firstPT && (h.vars.lazy !== !1 && h._duration || h.vars.lazy && !h._duration)) return h._time = h._totalTime = i, h._rawPrevTime = k, K.push(h), void (h._lazy = [a, b]);
        h._time && !d ? h.ratio = h._ease.getRatio(h._time / j) : d && h._ease._calcEnd && (h.ratio = h._ease.getRatio(0 === h._time ? 0 : 1));
      }

      for (h._lazy !== !1 && (h._lazy = !1), h._active || !h._paused && h._time !== i && a >= 0 && (h._active = !0), 0 === i && (h._startAt && (a >= 0 ? h._startAt.render(a, !0, c) : e || (e = "_dummyGS")), h.vars.onStart && (0 !== h._time || 0 === j) && (b || h._callback("onStart"))), f = h._firstPT; f;) {
        f.f ? f.t[f.p](f.c * h.ratio + f.s) : f.t[f.p] = f.c * h.ratio + f.s, f = f._next;
      }

      h._onUpdate && (0 > a && h._startAt && a !== -1e-4 && h._startAt.render(a, !0, c), b || (h._time !== i || d || c) && h._callback("onUpdate")), e && (!h._gc || c) && (0 > a && h._startAt && !h._onUpdate && a !== -1e-4 && h._startAt.render(a, !0, c), d && (h._timeline.autoRemoveChildren && h._enabled(!1, !1), h._active = !1), !b && h.vars[e] && h._callback(e), 0 === j && h._rawPrevTime === n && g !== n && (h._rawPrevTime = 0));
    }
  }, i._kill = function (a, b, c) {
    if ("all" === a && (a = null), null == a && (null == b || b === this.target)) return this._lazy = !1, this._enabled(!1, !1);
    b = "string" != typeof b ? b || this._targets || this.target : H.selector(b) || b;
    var d,
        e,
        f,
        g,
        h,
        i,
        j,
        k,
        l,
        m = c && this._time && c._startTime === this._startTime && this._timeline === c._timeline,
        n = this._firstPT;
    if ((q(b) || I(b)) && "number" != typeof b[0]) for (d = b.length; --d > -1;) {
      this._kill(a, b[d], c) && (i = !0);
    } else {
      if (this._targets) {
        for (d = this._targets.length; --d > -1;) {
          if (b === this._targets[d]) {
            h = this._propLookup[d] || {}, this._overwrittenProps = this._overwrittenProps || [], e = this._overwrittenProps[d] = a ? this._overwrittenProps[d] || {} : "all";
            break;
          }
        }
      } else {
        if (b !== this.target) return !1;
        h = this._propLookup, e = this._overwrittenProps = a ? this._overwrittenProps || {} : "all";
      }

      if (h) {
        if (j = a || h, k = a !== e && "all" !== e && a !== h && ("object" != _typeof(a) || !a._tempKill), c && (H.onOverwrite || this.vars.onOverwrite)) {
          for (f in j) {
            h[f] && (l || (l = []), l.push(f));
          }

          if ((l || !a) && !ba(this, c, b, l)) return !1;
        }

        for (f in j) {
          (g = h[f]) && (m && (g.f ? g.t[g.p](g.s) : g.t[g.p] = g.s, i = !0), g.pg && g.t._kill(j) && (i = !0), g.pg && 0 !== g.t._overwriteProps.length || (g._prev ? g._prev._next = g._next : g === this._firstPT && (this._firstPT = g._next), g._next && (g._next._prev = g._prev), g._next = g._prev = null), delete h[f]), k && (e[f] = 1);
        }

        !this._firstPT && this._initted && n && this._enabled(!1, !1);
      }
    }
    return i;
  }, i.invalidate = function () {
    this._notifyPluginsOfEnabled && H._onPluginEvent("_onDisable", this);
    var a = this._time;
    return this._firstPT = this._overwrittenProps = this._startAt = this._onUpdate = null, this._notifyPluginsOfEnabled = this._active = this._lazy = !1, this._propLookup = this._targets ? {} : [], E.prototype.invalidate.call(this), this.vars.immediateRender && (this._time = -n, this.render(a, !1, this.vars.lazy !== !1)), this;
  }, i._enabled = function (a, b) {
    if (k || j.wake(), a && this._gc) {
      var c,
          d = this._targets;
      if (d) for (c = d.length; --c > -1;) {
        this._siblings[c] = aa(d[c], this, !0);
      } else this._siblings = aa(this.target, this, !0);
    }

    return E.prototype._enabled.call(this, a, b), this._notifyPluginsOfEnabled && this._firstPT ? H._onPluginEvent(a ? "_onEnable" : "_onDisable", this) : !1;
  }, H.to = function (a, b, c) {
    return new H(a, b, c);
  }, H.from = function (a, b, c) {
    return c.runBackwards = !0, c.immediateRender = 0 != c.immediateRender, new H(a, b, c);
  }, H.fromTo = function (a, b, c, d) {
    return d.startAt = c, d.immediateRender = 0 != d.immediateRender && 0 != c.immediateRender, new H(a, b, d);
  }, H.delayedCall = function (a, b, c, d, e) {
    return new H(b, 0, {
      delay: a,
      onComplete: b,
      onCompleteParams: c,
      callbackScope: d,
      onReverseComplete: b,
      onReverseCompleteParams: c,
      immediateRender: !1,
      lazy: !1,
      useFrames: e,
      overwrite: 0
    });
  }, H.set = function (a, b) {
    return new H(a, 0, b);
  }, H.getTweensOf = function (a, b) {
    if (null == a) return [];
    a = "string" != typeof a ? a : H.selector(a) || a;
    var c, d, e, f;

    if ((q(a) || I(a)) && "number" != typeof a[0]) {
      for (c = a.length, d = []; --c > -1;) {
        d = d.concat(H.getTweensOf(a[c], b));
      }

      for (c = d.length; --c > -1;) {
        for (f = d[c], e = c; --e > -1;) {
          f === d[e] && d.splice(c, 1);
        }
      }
    } else if (a._gsTweenID) for (d = aa(a).concat(), c = d.length; --c > -1;) {
      (d[c]._gc || b && !d[c].isActive()) && d.splice(c, 1);
    }

    return d || [];
  }, H.killTweensOf = H.killDelayedCallsTo = function (a, b, c) {
    "object" == _typeof(b) && (c = b, b = !1);

    for (var d = H.getTweensOf(a, b), e = d.length; --e > -1;) {
      d[e]._kill(c, a);
    }
  };
  var ea = u("plugins.TweenPlugin", function (a, b) {
    this._overwriteProps = (a || "").split(","), this._propName = this._overwriteProps[0], this._priority = b || 0, this._super = ea.prototype;
  }, !0);

  if (i = ea.prototype, ea.version = "1.19.0", ea.API = 2, i._firstPT = null, i._addTween = R, i.setRatio = O, i._kill = function (a) {
    var b,
        c = this._overwriteProps,
        d = this._firstPT;
    if (null != a[this._propName]) this._overwriteProps = [];else for (b = c.length; --b > -1;) {
      null != a[c[b]] && c.splice(b, 1);
    }

    for (; d;) {
      null != a[d.n] && (d._next && (d._next._prev = d._prev), d._prev ? (d._prev._next = d._next, d._prev = null) : this._firstPT === d && (this._firstPT = d._next)), d = d._next;
    }

    return !1;
  }, i._mod = i._roundProps = function (a) {
    for (var b, c = this._firstPT; c;) {
      b = a[this._propName] || null != c.n && a[c.n.split(this._propName + "_").join("")], b && "function" == typeof b && (2 === c.f ? c.t._applyPT.m = b : c.m = b), c = c._next;
    }
  }, H._onPluginEvent = function (a, b) {
    var c,
        d,
        e,
        f,
        g,
        h = b._firstPT;

    if ("_onInitAllProps" === a) {
      for (; h;) {
        for (g = h._next, d = e; d && d.pr > h.pr;) {
          d = d._next;
        }

        (h._prev = d ? d._prev : f) ? h._prev._next = h : e = h, (h._next = d) ? d._prev = h : f = h, h = g;
      }

      h = b._firstPT = e;
    }

    for (; h;) {
      h.pg && "function" == typeof h.t[a] && h.t[a]() && (c = !0), h = h._next;
    }

    return c;
  }, ea.activate = function (a) {
    for (var b = a.length; --b > -1;) {
      a[b].API === ea.API && (T[new a[b]()._propName] = a[b]);
    }

    return !0;
  }, t.plugin = function (a) {
    if (!(a && a.propName && a.init && a.API)) throw "illegal plugin definition.";
    var b,
        c = a.propName,
        d = a.priority || 0,
        e = a.overwriteProps,
        f = {
      init: "_onInitTween",
      set: "setRatio",
      kill: "_kill",
      round: "_mod",
      mod: "_mod",
      initAll: "_onInitAllProps"
    },
        g = u("plugins." + c.charAt(0).toUpperCase() + c.substr(1) + "Plugin", function () {
      ea.call(this, c, d), this._overwriteProps = e || [];
    }, a.global === !0),
        h = g.prototype = new ea(c);
    h.constructor = g, g.API = a.API;

    for (b in f) {
      "function" == typeof a[b] && (h[f[b]] = a[b]);
    }

    return g.version = a.version, ea.activate([g]), g;
  }, g = a._gsQueue) {
    for (h = 0; h < g.length; h++) {
      g[h]();
    }

    for (i in r) {
      r[i].func || a.console.log("GSAP encountered missing dependency: " + i);
    }
  }

  k = !1;
}("undefined" != typeof module && module.exports && "undefined" != typeof global ? global : this || window, "TweenMax");
/*!
 * ScrollMagic v2.0.6 (2018-10-08)
 * The javascript library for magical scroll interactions.
 * (c) 2018 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.6
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic main library.
 */

/**
 * @namespace ScrollMagic
 */

(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    module.exports = factory();
  } else {
    // Browser global
    root.ScrollMagic = factory();
  }
})(this, function () {
  "use strict";

  var ScrollMagic = function ScrollMagic() {
    _util.log(2, '(COMPATIBILITY NOTICE) -> As of ScrollMagic 2.0.0 you need to use \'new ScrollMagic.Controller()\' to create a new controller instance. Use \'new ScrollMagic.Scene()\' to instance a scene.');
  };

  ScrollMagic.version = "2.0.6"; // TODO: temporary workaround for chrome's scroll jitter bug

  window.addEventListener("mousewheel", function () {}); // global const

  var PIN_SPACER_ATTRIBUTE = "data-scrollmagic-pin-spacer";
  /**
   * The main class that is needed once per scroll container.
   *
   * @class
   *
   * @example
   * // basic initialization
   * var controller = new ScrollMagic.Controller();
   *
   * // passing options
   * var controller = new ScrollMagic.Controller({container: "#myContainer", loglevel: 3});
   *
   * @param {object} [options] - An object containing one or more options for the controller.
   * @param {(string|object)} [options.container=window] - A selector, DOM object that references the main container for scrolling.
   * @param {boolean} [options.vertical=true] - Sets the scroll mode to vertical (`true`) or horizontal (`false`) scrolling.
   * @param {object} [options.globalSceneOptions={}] - These options will be passed to every Scene that is added to the controller using the addScene method. For more information on Scene options see {@link ScrollMagic.Scene}.
   * @param {number} [options.loglevel=2] Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
   ** `0` => silent
   ** `1` => errors
   ** `2` => errors, warnings
   ** `3` => errors, warnings, debuginfo
   * @param {boolean} [options.refreshInterval=100] - Some changes don't call events by default, like changing the container size or moving a scene trigger element.  
   This interval polls these parameters to fire the necessary events.  
   If you don't use custom containers, trigger elements or have static layouts, where the positions of the trigger elements don't change, you can set this to 0 disable interval checking and improve performance.
   *
   */

  ScrollMagic.Controller = function (options) {
    /*
    	 * ----------------------------------------------------------------
    	 * settings
    	 * ----------------------------------------------------------------
    	 */
    var NAMESPACE = 'ScrollMagic.Controller',
        SCROLL_DIRECTION_FORWARD = 'FORWARD',
        SCROLL_DIRECTION_REVERSE = 'REVERSE',
        SCROLL_DIRECTION_PAUSED = 'PAUSED',
        DEFAULT_OPTIONS = CONTROLLER_OPTIONS.defaults;
    /*
    	 * ----------------------------------------------------------------
    	 * private vars
    	 * ----------------------------------------------------------------
    	 */

    var Controller = this,
        _options = _util.extend({}, DEFAULT_OPTIONS, options),
        _sceneObjects = [],
        _updateScenesOnNextCycle = false,
        // can be boolean (true => all scenes) or an array of scenes to be updated
    _scrollPos = 0,
        _scrollDirection = SCROLL_DIRECTION_PAUSED,
        _isDocument = true,
        _viewPortSize = 0,
        _enabled = true,
        _updateTimeout,
        _refreshTimeout;
    /*
    	 * ----------------------------------------------------------------
    	 * private functions
    	 * ----------------------------------------------------------------
    	 */

    /**
     * Internal constructor function of the ScrollMagic Controller
     * @private
     */


    var construct = function construct() {
      for (var key in _options) {
        if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
          log(2, "WARNING: Unknown option \"" + key + "\"");
          delete _options[key];
        }
      }

      _options.container = _util.get.elements(_options.container)[0]; // check ScrollContainer

      if (!_options.container) {
        log(1, "ERROR creating object " + NAMESPACE + ": No valid scroll container supplied");
        throw NAMESPACE + " init failed."; // cancel
      }

      _isDocument = _options.container === window || _options.container === document.body || !document.body.contains(_options.container); // normalize to window

      if (_isDocument) {
        _options.container = window;
      } // update container size immediately


      _viewPortSize = getViewportSize(); // set event handlers

      _options.container.addEventListener("resize", onChange);

      _options.container.addEventListener("scroll", onChange);

      var ri = parseInt(_options.refreshInterval, 10);
      _options.refreshInterval = _util.type.Number(ri) ? ri : DEFAULT_OPTIONS.refreshInterval;
      scheduleRefresh();
      log(3, "added new " + NAMESPACE + " controller (v" + ScrollMagic.version + ")");
    };
    /**
     * Schedule the next execution of the refresh function
     * @private
     */


    var scheduleRefresh = function scheduleRefresh() {
      if (_options.refreshInterval > 0) {
        _refreshTimeout = window.setTimeout(refresh, _options.refreshInterval);
      }
    };
    /**
     * Default function to get scroll pos - overwriteable using `Controller.scrollPos(newFunction)`
     * @private
     */


    var getScrollPos = function getScrollPos() {
      return _options.vertical ? _util.get.scrollTop(_options.container) : _util.get.scrollLeft(_options.container);
    };
    /**
     * Returns the current viewport Size (width vor horizontal, height for vertical)
     * @private
     */


    var getViewportSize = function getViewportSize() {
      return _options.vertical ? _util.get.height(_options.container) : _util.get.width(_options.container);
    };
    /**
     * Default function to set scroll pos - overwriteable using `Controller.scrollTo(newFunction)`
     * Make available publicly for pinned mousewheel workaround.
     * @private
     */


    var setScrollPos = this._setScrollPos = function (pos) {
      if (_options.vertical) {
        if (_isDocument) {
          window.scrollTo(_util.get.scrollLeft(), pos);
        } else {
          _options.container.scrollTop = pos;
        }
      } else {
        if (_isDocument) {
          window.scrollTo(pos, _util.get.scrollTop());
        } else {
          _options.container.scrollLeft = pos;
        }
      }
    };
    /**
     * Handle updates in cycles instead of on scroll (performance)
     * @private
     */


    var updateScenes = function updateScenes() {
      if (_enabled && _updateScenesOnNextCycle) {
        // determine scenes to update
        var scenesToUpdate = _util.type.Array(_updateScenesOnNextCycle) ? _updateScenesOnNextCycle : _sceneObjects.slice(0); // reset scenes

        _updateScenesOnNextCycle = false;
        var oldScrollPos = _scrollPos; // update scroll pos now instead of onChange, as it might have changed since scheduling (i.e. in-browser smooth scroll)

        _scrollPos = Controller.scrollPos();
        var deltaScroll = _scrollPos - oldScrollPos;

        if (deltaScroll !== 0) {
          // scroll position changed?
          _scrollDirection = deltaScroll > 0 ? SCROLL_DIRECTION_FORWARD : SCROLL_DIRECTION_REVERSE;
        } // reverse order of scenes if scrolling reverse


        if (_scrollDirection === SCROLL_DIRECTION_REVERSE) {
          scenesToUpdate.reverse();
        } // update scenes


        scenesToUpdate.forEach(function (scene, index) {
          log(3, "updating Scene " + (index + 1) + "/" + scenesToUpdate.length + " (" + _sceneObjects.length + " total)");
          scene.update(true);
        });

        if (scenesToUpdate.length === 0 && _options.loglevel >= 3) {
          log(3, "updating 0 Scenes (nothing added to controller)");
        }
      }
    };
    /**
     * Initializes rAF callback
     * @private
     */


    var debounceUpdate = function debounceUpdate() {
      _updateTimeout = _util.rAF(updateScenes);
    };
    /**
     * Handles Container changes
     * @private
     */


    var onChange = function onChange(e) {
      log(3, "event fired causing an update:", e.type);

      if (e.type == "resize") {
        // resize
        _viewPortSize = getViewportSize();
        _scrollDirection = SCROLL_DIRECTION_PAUSED;
      } // schedule update


      if (_updateScenesOnNextCycle !== true) {
        _updateScenesOnNextCycle = true;
        debounceUpdate();
      }
    };

    var refresh = function refresh() {
      if (!_isDocument) {
        // simulate resize event. Only works for viewport relevant param (performance)
        if (_viewPortSize != getViewportSize()) {
          var resizeEvent;

          try {
            resizeEvent = new Event('resize', {
              bubbles: false,
              cancelable: false
            });
          } catch (e) {
            // stupid IE
            resizeEvent = document.createEvent("Event");
            resizeEvent.initEvent("resize", false, false);
          }

          _options.container.dispatchEvent(resizeEvent);
        }
      }

      _sceneObjects.forEach(function (scene, index) {
        // refresh all scenes
        scene.refresh();
      });

      scheduleRefresh();
    };
    /**
     * Send a debug message to the console.
     * provided publicly with _log for plugins
     * @private
     *
     * @param {number} loglevel - The loglevel required to initiate output for the message.
     * @param {...mixed} output - One or more variables that should be passed to the console.
     */


    var log = this._log = function (loglevel, output) {
      if (_options.loglevel >= loglevel) {
        Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");

        _util.log.apply(window, arguments);
      }
    }; // for scenes we have getters for each option, but for the controller we don't, so we need to make it available externally for plugins


    this._options = _options;
    /**
     * Sort scenes in ascending order of their start offset.
     * @private
     *
     * @param {array} ScenesArray - an array of ScrollMagic Scenes that should be sorted
     * @return {array} The sorted array of Scenes.
     */

    var sortScenes = function sortScenes(ScenesArray) {
      if (ScenesArray.length <= 1) {
        return ScenesArray;
      } else {
        var scenes = ScenesArray.slice(0);
        scenes.sort(function (a, b) {
          return a.scrollOffset() > b.scrollOffset() ? 1 : -1;
        });
        return scenes;
      }
    };
    /**
     * ----------------------------------------------------------------
     * public functions
     * ----------------------------------------------------------------
     */

    /**
     * Add one ore more scene(s) to the controller.  
     * This is the equivalent to `Scene.addTo(controller)`.
     * @public
     * @example
     * // with a previously defined scene
     * controller.addScene(scene);
     *
     * // with a newly created scene.
     * controller.addScene(new ScrollMagic.Scene({duration : 0}));
     *
     * // adding multiple scenes
     * controller.addScene([scene, scene2, new ScrollMagic.Scene({duration : 0})]);
     *
     * @param {(ScrollMagic.Scene|array)} newScene - ScrollMagic Scene or Array of Scenes to be added to the controller.
     * @return {Controller} Parent object for chaining.
     */


    this.addScene = function (newScene) {
      if (_util.type.Array(newScene)) {
        newScene.forEach(function (scene, index) {
          Controller.addScene(scene);
        });
      } else if (newScene instanceof ScrollMagic.Scene) {
        if (newScene.controller() !== Controller) {
          newScene.addTo(Controller);
        } else if (_sceneObjects.indexOf(newScene) < 0) {
          // new scene
          _sceneObjects.push(newScene); // add to array


          _sceneObjects = sortScenes(_sceneObjects); // sort

          newScene.on("shift.controller_sort", function () {
            // resort whenever scene moves
            _sceneObjects = sortScenes(_sceneObjects);
          }); // insert Global defaults.

          for (var key in _options.globalSceneOptions) {
            if (newScene[key]) {
              newScene[key].call(newScene, _options.globalSceneOptions[key]);
            }
          }

          log(3, "adding Scene (now " + _sceneObjects.length + " total)");
        }
      } else {
        log(1, "ERROR: invalid argument supplied for '.addScene()'");
      }

      return Controller;
    };
    /**
     * Remove one ore more scene(s) from the controller.  
     * This is the equivalent to `Scene.remove()`.
     * @public
     * @example
     * // remove a scene from the controller
     * controller.removeScene(scene);
     *
     * // remove multiple scenes from the controller
     * controller.removeScene([scene, scene2, scene3]);
     *
     * @param {(ScrollMagic.Scene|array)} Scene - ScrollMagic Scene or Array of Scenes to be removed from the controller.
     * @returns {Controller} Parent object for chaining.
     */


    this.removeScene = function (Scene) {
      if (_util.type.Array(Scene)) {
        Scene.forEach(function (scene, index) {
          Controller.removeScene(scene);
        });
      } else {
        var index = _sceneObjects.indexOf(Scene);

        if (index > -1) {
          Scene.off("shift.controller_sort");

          _sceneObjects.splice(index, 1);

          log(3, "removing Scene (now " + _sceneObjects.length + " left)");
          Scene.remove();
        }
      }

      return Controller;
    };
    /**
     * Update one ore more scene(s) according to the scroll position of the container.  
     * This is the equivalent to `Scene.update()`.  
     * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
     * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.  
     * _**Note:** This method gets called constantly whenever Controller detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
     * @public
     * @example
     * // update a specific scene on next cycle
     * controller.updateScene(scene);
     *
     * // update a specific scene immediately
     * controller.updateScene(scene, true);
     *
     * // update multiple scenes scene on next cycle
     * controller.updateScene([scene1, scene2, scene3]);
     *
     * @param {ScrollMagic.Scene} Scene - ScrollMagic Scene or Array of Scenes that is/are supposed to be updated.
     * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle.  
     This is useful when changing multiple properties of the scene - this way it will only be updated once all new properties are set (updateScenes).
     * @return {Controller} Parent object for chaining.
     */


    this.updateScene = function (Scene, immediately) {
      if (_util.type.Array(Scene)) {
        Scene.forEach(function (scene, index) {
          Controller.updateScene(scene, immediately);
        });
      } else {
        if (immediately) {
          Scene.update(true);
        } else if (_updateScenesOnNextCycle !== true && Scene instanceof ScrollMagic.Scene) {
          // if _updateScenesOnNextCycle is true, all connected scenes are already scheduled for update
          // prep array for next update cycle
          _updateScenesOnNextCycle = _updateScenesOnNextCycle || [];

          if (_updateScenesOnNextCycle.indexOf(Scene) == -1) {
            _updateScenesOnNextCycle.push(Scene);
          }

          _updateScenesOnNextCycle = sortScenes(_updateScenesOnNextCycle); // sort

          debounceUpdate();
        }
      }

      return Controller;
    };
    /**
     * Updates the controller params and calls updateScene on every scene, that is attached to the controller.  
     * See `Controller.updateScene()` for more information about what this means.  
     * In most cases you will not need this function, as it is called constantly, whenever ScrollMagic detects a state change event, like resize or scroll.  
     * The only application for this method is when ScrollMagic fails to detect these events.  
     * One application is with some external scroll libraries (like iScroll) that move an internal container to a negative offset instead of actually scrolling. In this case the update on the controller needs to be called whenever the child container's position changes.
     * For this case there will also be the need to provide a custom function to calculate the correct scroll position. See `Controller.scrollPos()` for details.
     * @public
     * @example
     * // update the controller on next cycle (saves performance due to elimination of redundant updates)
     * controller.update();
     *
     * // update the controller immediately
     * controller.update(true);
     *
     * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance)
     * @return {Controller} Parent object for chaining.
     */


    this.update = function (immediately) {
      onChange({
        type: "resize"
      }); // will update size and set _updateScenesOnNextCycle to true

      if (immediately) {
        updateScenes();
      }

      return Controller;
    };
    /**
     * Scroll to a numeric scroll offset, a DOM element, the start of a scene or provide an alternate method for scrolling.  
     * For vertical controllers it will change the top scroll offset and for horizontal applications it will change the left offset.
     * @public
     *
     * @since 1.1.0
     * @example
     * // scroll to an offset of 100
     * controller.scrollTo(100);
     *
     * // scroll to a DOM element
     * controller.scrollTo("#anchor");
     *
     * // scroll to the beginning of a scene
     * var scene = new ScrollMagic.Scene({offset: 200});
     * controller.scrollTo(scene);
     *
     * // define a new scroll position modification function (jQuery animate instead of jump)
     * controller.scrollTo(function (newScrollPos) {
     *	$("html, body").animate({scrollTop: newScrollPos});
     * });
     * controller.scrollTo(100); // call as usual, but the new function will be used instead
     *
     * // define a new scroll function with an additional parameter
     * controller.scrollTo(function (newScrollPos, message) {
     *  console.log(message);
     *	$(this).animate({scrollTop: newScrollPos});
     * });
     * // call as usual, but supply an extra parameter to the defined custom function
     * controller.scrollTo(100, "my message");
     *
     * // define a new scroll function with an additional parameter containing multiple variables
     * controller.scrollTo(function (newScrollPos, options) {
     *  someGlobalVar = options.a + options.b;
     *	$(this).animate({scrollTop: newScrollPos});
     * });
     * // call as usual, but supply an extra parameter containing multiple options
     * controller.scrollTo(100, {a: 1, b: 2});
     *
     * // define a new scroll function with a callback supplied as an additional parameter
     * controller.scrollTo(function (newScrollPos, callback) {
     *	$(this).animate({scrollTop: newScrollPos}, 400, "swing", callback);
     * });
     * // call as usual, but supply an extra parameter, which is used as a callback in the previously defined custom scroll function
     * controller.scrollTo(100, function() {
     *	console.log("scroll has finished.");
     * });
     *
     * @param {mixed} scrollTarget - The supplied argument can be one of these types:
     * 1. `number` -> The container will scroll to this new scroll offset.
     * 2. `string` or `object` -> Can be a selector or a DOM object.  
     *  The container will scroll to the position of this element.
     * 3. `ScrollMagic Scene` -> The container will scroll to the start of this scene.
     * 4. `function` -> This function will be used for future scroll position modifications.  
     *  This provides a way for you to change the behaviour of scrolling and adding new behaviour like animation. The function receives the new scroll position as a parameter and a reference to the container element using `this`.  
     *  It may also optionally receive an optional additional parameter (see below)  
     *  _**NOTE:**  
     *  All other options will still work as expected, using the new function to scroll._
     * @param {mixed} [additionalParameter] - If a custom scroll function was defined (see above 4.), you may want to supply additional parameters to it, when calling it. You can do this using this parameter – see examples for details. Please note, that this parameter will have no effect, if you use the default scrolling function.
     * @returns {Controller} Parent object for chaining.
     */


    this.scrollTo = function (scrollTarget, additionalParameter) {
      if (_util.type.Number(scrollTarget)) {
        // excecute
        setScrollPos.call(_options.container, scrollTarget, additionalParameter);
      } else if (scrollTarget instanceof ScrollMagic.Scene) {
        // scroll to scene
        if (scrollTarget.controller() === Controller) {
          // check if the controller is associated with this scene
          Controller.scrollTo(scrollTarget.scrollOffset(), additionalParameter);
        } else {
          log(2, "scrollTo(): The supplied scene does not belong to this controller. Scroll cancelled.", scrollTarget);
        }
      } else if (_util.type.Function(scrollTarget)) {
        // assign new scroll function
        setScrollPos = scrollTarget;
      } else {
        // scroll to element
        var elem = _util.get.elements(scrollTarget)[0];

        if (elem) {
          // if parent is pin spacer, use spacer position instead so correct start position is returned for pinned elements.
          while (elem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
            elem = elem.parentNode;
          }

          var param = _options.vertical ? "top" : "left",
              // which param is of interest ?
          containerOffset = _util.get.offset(_options.container),
              // container position is needed because element offset is returned in relation to document, not in relation to container.
          elementOffset = _util.get.offset(elem);

          if (!_isDocument) {
            // container is not the document root, so substract scroll Position to get correct trigger element position relative to scrollcontent
            containerOffset[param] -= Controller.scrollPos();
          }

          Controller.scrollTo(elementOffset[param] - containerOffset[param], additionalParameter);
        } else {
          log(2, "scrollTo(): The supplied argument is invalid. Scroll cancelled.", scrollTarget);
        }
      }

      return Controller;
    };
    /**
     * **Get** the current scrollPosition or **Set** a new method to calculate it.  
     * -> **GET**:
     * When used as a getter this function will return the current scroll position.  
     * To get a cached value use Controller.info("scrollPos"), which will be updated in the update cycle.  
     * For vertical controllers it will return the top scroll offset and for horizontal applications it will return the left offset.
     *
     * -> **SET**:
     * When used as a setter this method prodes a way to permanently overwrite the controller's scroll position calculation.  
     * A typical usecase is when the scroll position is not reflected by the containers scrollTop or scrollLeft values, but for example by the inner offset of a child container.  
     * Moving a child container inside a parent is a commonly used method for several scrolling frameworks, including iScroll.  
     * By providing an alternate calculation function you can make sure ScrollMagic receives the correct scroll position.  
     * Please also bear in mind that your function should return y values for vertical scrolls an x for horizontals.
     *
     * To change the current scroll position please use `Controller.scrollTo()`.
     * @public
     *
     * @example
     * // get the current scroll Position
     * var scrollPos = controller.scrollPos();
     *
     * // set a new scroll position calculation method
     * controller.scrollPos(function () {
     *	return this.info("vertical") ? -mychildcontainer.y : -mychildcontainer.x
     * });
     *
     * @param {function} [scrollPosMethod] - The function to be used for the scroll position calculation of the container.
     * @returns {(number|Controller)} Current scroll position or parent object for chaining.
     */


    this.scrollPos = function (scrollPosMethod) {
      if (!arguments.length) {
        // get
        return getScrollPos.call(Controller);
      } else {
        // set
        if (_util.type.Function(scrollPosMethod)) {
          getScrollPos = scrollPosMethod;
        } else {
          log(2, "Provided value for method 'scrollPos' is not a function. To change the current scroll position use 'scrollTo()'.");
        }
      }

      return Controller;
    };
    /**
     * **Get** all infos or one in particular about the controller.
     * @public
     * @example
     * // returns the current scroll position (number)
     * var scrollPos = controller.info("scrollPos");
     *
     * // returns all infos as an object
     * var infos = controller.info();
     *
     * @param {string} [about] - If passed only this info will be returned instead of an object containing all.  
     Valid options are:
     ** `"size"` => the current viewport size of the container
     ** `"vertical"` => true if vertical scrolling, otherwise false
     ** `"scrollPos"` => the current scroll position
     ** `"scrollDirection"` => the last known direction of the scroll
     ** `"container"` => the container element
     ** `"isDocument"` => true if container element is the document.
     * @returns {(mixed|object)} The requested info(s).
     */


    this.info = function (about) {
      var values = {
        size: _viewPortSize,
        // contains height or width (in regard to orientation);
        vertical: _options.vertical,
        scrollPos: _scrollPos,
        scrollDirection: _scrollDirection,
        container: _options.container,
        isDocument: _isDocument
      };

      if (!arguments.length) {
        // get all as an object
        return values;
      } else if (values[about] !== undefined) {
        return values[about];
      } else {
        log(1, "ERROR: option \"" + about + "\" is not available");
        return;
      }
    };
    /**
     * **Get** or **Set** the current loglevel option value.
     * @public
     *
     * @example
     * // get the current value
     * var loglevel = controller.loglevel();
     *
     * // set a new value
     * controller.loglevel(3);
     *
     * @param {number} [newLoglevel] - The new loglevel setting of the Controller. `[0-3]`
     * @returns {(number|Controller)} Current loglevel or parent object for chaining.
     */


    this.loglevel = function (newLoglevel) {
      if (!arguments.length) {
        // get
        return _options.loglevel;
      } else if (_options.loglevel != newLoglevel) {
        // set
        _options.loglevel = newLoglevel;
      }

      return Controller;
    };
    /**
     * **Get** or **Set** the current enabled state of the controller.  
     * This can be used to disable all Scenes connected to the controller without destroying or removing them.
     * @public
     *
     * @example
     * // get the current value
     * var enabled = controller.enabled();
     *
     * // disable the controller
     * controller.enabled(false);
     *
     * @param {boolean} [newState] - The new enabled state of the controller `true` or `false`.
     * @returns {(boolean|Controller)} Current enabled state or parent object for chaining.
     */


    this.enabled = function (newState) {
      if (!arguments.length) {
        // get
        return _enabled;
      } else if (_enabled != newState) {
        // set
        _enabled = !!newState;
        Controller.updateScene(_sceneObjects, true);
      }

      return Controller;
    };
    /**
     * Destroy the Controller, all Scenes and everything.
     * @public
     *
     * @example
     * // without resetting the scenes
     * controller = controller.destroy();
     *
     * // with scene reset
     * controller = controller.destroy(true);
     *
     * @param {boolean} [resetScenes=false] - If `true` the pins and tweens (if existent) of all scenes will be reset.
     * @returns {null} Null to unset handler variables.
     */


    this.destroy = function (resetScenes) {
      window.clearTimeout(_refreshTimeout);
      var i = _sceneObjects.length;

      while (i--) {
        _sceneObjects[i].destroy(resetScenes);
      }

      _options.container.removeEventListener("resize", onChange);

      _options.container.removeEventListener("scroll", onChange);

      _util.cAF(_updateTimeout);

      log(3, "destroyed " + NAMESPACE + " (reset: " + (resetScenes ? "true" : "false") + ")");
      return null;
    }; // INIT


    construct();
    return Controller;
  }; // store pagewide controller options


  var CONTROLLER_OPTIONS = {
    defaults: {
      container: window,
      vertical: true,
      globalSceneOptions: {},
      loglevel: 2,
      refreshInterval: 100
    }
  };
  /*
   * method used to add an option to ScrollMagic Scenes.
   */

  ScrollMagic.Controller.addOption = function (name, defaultValue) {
    CONTROLLER_OPTIONS.defaults[name] = defaultValue;
  }; // instance extension function for plugins


  ScrollMagic.Controller.extend = function (extension) {
    var oldClass = this;

    ScrollMagic.Controller = function () {
      oldClass.apply(this, arguments);
      this.$super = _util.extend({}, this); // copy parent state

      return extension.apply(this, arguments) || this;
    };

    _util.extend(ScrollMagic.Controller, oldClass); // copy properties


    ScrollMagic.Controller.prototype = oldClass.prototype; // copy prototype

    ScrollMagic.Controller.prototype.constructor = ScrollMagic.Controller; // restore constructor
  };
  /**
   * A Scene defines where the controller should react and how.
   *
   * @class
   *
   * @example
   * // create a standard scene and add it to a controller
   * new ScrollMagic.Scene()
   *		.addTo(controller);
   *
   * // create a scene with custom options and assign a handler to it.
   * var scene = new ScrollMagic.Scene({
   * 		duration: 100,
   *		offset: 200,
   *		triggerHook: "onEnter",
   *		reverse: false
   * });
   *
   * @param {object} [options] - Options for the Scene. The options can be updated at any time.  
   Instead of setting the options for each scene individually you can also set them globally in the controller as the controllers `globalSceneOptions` option. The object accepts the same properties as the ones below.  
   When a scene is added to the controller the options defined using the Scene constructor will be overwritten by those set in `globalSceneOptions`.
   * @param {(number|function)} [options.duration=0] - The duration of the scene. 
   If `0` tweens will auto-play when reaching the scene start point, pins will be pinned indefinetly starting at the start position.  
   A function retuning the duration value is also supported. Please see `Scene.duration()` for details.
   * @param {number} [options.offset=0] - Offset Value for the Trigger Position. If no triggerElement is defined this will be the scroll distance from the start of the page, after which the scene will start.
   * @param {(string|object)} [options.triggerElement=null] - Selector or DOM object that defines the start of the scene. If undefined the scene will start right at the start of the page (unless an offset is set).
   * @param {(number|string)} [options.triggerHook="onCenter"] - Can be a number between 0 and 1 defining the position of the trigger Hook in relation to the viewport.  
   Can also be defined using a string:
   ** `"onEnter"` => `1`
   ** `"onCenter"` => `0.5`
   ** `"onLeave"` => `0`
   * @param {boolean} [options.reverse=true] - Should the scene reverse, when scrolling up?
   * @param {number} [options.loglevel=2] - Loglevel for debugging. Note that logging is disabled in the minified version of ScrollMagic.
   ** `0` => silent
   ** `1` => errors
   ** `2` => errors, warnings
   ** `3` => errors, warnings, debuginfo
   * 
   */


  ScrollMagic.Scene = function (options) {
    /*
    	 * ----------------------------------------------------------------
    	 * settings
    	 * ----------------------------------------------------------------
    	 */
    var NAMESPACE = 'ScrollMagic.Scene',
        SCENE_STATE_BEFORE = 'BEFORE',
        SCENE_STATE_DURING = 'DURING',
        SCENE_STATE_AFTER = 'AFTER',
        DEFAULT_OPTIONS = SCENE_OPTIONS.defaults;
    /*
    	 * ----------------------------------------------------------------
    	 * private vars
    	 * ----------------------------------------------------------------
    	 */

    var Scene = this,
        _options = _util.extend({}, DEFAULT_OPTIONS, options),
        _state = SCENE_STATE_BEFORE,
        _progress = 0,
        _scrollOffset = {
      start: 0,
      end: 0
    },
        // reflects the controllers's scroll position for the start and end of the scene respectively
    _triggerPos = 0,
        _enabled = true,
        _durationUpdateMethod,
        _controller;
    /**
     * Internal constructor function of the ScrollMagic Scene
     * @private
     */


    var construct = function construct() {
      for (var key in _options) {
        // check supplied options
        if (!DEFAULT_OPTIONS.hasOwnProperty(key)) {
          log(2, "WARNING: Unknown option \"" + key + "\"");
          delete _options[key];
        }
      } // add getters/setters for all possible options


      for (var optionName in DEFAULT_OPTIONS) {
        addSceneOption(optionName);
      } // validate all options


      validateOption();
    };
    /*
     * ----------------------------------------------------------------
     * Event Management
     * ----------------------------------------------------------------
     */


    var _listeners = {};
    /**
     * Scene start event.  
     * Fires whenever the scroll position its the starting point of the scene.  
     * It will also fire when scrolling back up going over the start position of the scene. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
     *
     * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
     *
     * @event ScrollMagic.Scene#start
     *
     * @example
     * scene.on("start", function (event) {
     * 	console.log("Hit start point of scene.");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.progress - Reflects the current progress of the scene
     * @property {string} event.state - The current state of the scene `"BEFORE"` or `"DURING"`
     * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
     */

    /**
     * Scene end event.  
     * Fires whenever the scroll position its the ending point of the scene.  
     * It will also fire when scrolling back up from after the scene and going over its end position. If you want something to happen only when scrolling down/right, use the scrollDirection parameter passed to the callback.
     *
     * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
     *
     * @event ScrollMagic.Scene#end
     *
     * @example
     * scene.on("end", function (event) {
     * 	console.log("Hit end point of scene.");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.progress - Reflects the current progress of the scene
     * @property {string} event.state - The current state of the scene `"DURING"` or `"AFTER"`
     * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
     */

    /**
     * Scene enter event.  
     * Fires whenever the scene enters the "DURING" state.  
     * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene enters its active scroll timeframe, regardless of the scroll-direction.
     *
     * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
     *
     * @event ScrollMagic.Scene#enter
     *
     * @example
     * scene.on("enter", function (event) {
     * 	console.log("Scene entered.");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.progress - Reflects the current progress of the scene
     * @property {string} event.state - The current state of the scene - always `"DURING"`
     * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
     */

    /**
     * Scene leave event.  
     * Fires whenever the scene's state goes from "DURING" to either "BEFORE" or "AFTER".  
     * Keep in mind that it doesn't matter if the scene plays forward or backward: This event always fires when the scene leaves its active scroll timeframe, regardless of the scroll-direction.
     *
     * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
     *
     * @event ScrollMagic.Scene#leave
     *
     * @example
     * scene.on("leave", function (event) {
     * 	console.log("Scene left.");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.progress - Reflects the current progress of the scene
     * @property {string} event.state - The current state of the scene `"BEFORE"` or `"AFTER"`
     * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
     */

    /**
     * Scene update event.  
     * Fires whenever the scene is updated (but not necessarily changes the progress).
     *
     * @event ScrollMagic.Scene#update
     *
     * @example
     * scene.on("update", function (event) {
     * 	console.log("Scene updated.");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.startPos - The starting position of the scene (in relation to the conainer)
     * @property {number} event.endPos - The ending position of the scene (in relation to the conainer)
     * @property {number} event.scrollPos - The current scroll position of the container
     */

    /**
     * Scene progress event.  
     * Fires whenever the progress of the scene changes.
     *
     * For details on this event and the order in which it is fired, please review the {@link Scene.progress} method.
     *
     * @event ScrollMagic.Scene#progress
     *
     * @example
     * scene.on("progress", function (event) {
     * 	console.log("Scene progress changed to " + event.progress);
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {number} event.progress - Reflects the current progress of the scene
     * @property {string} event.state - The current state of the scene `"BEFORE"`, `"DURING"` or `"AFTER"`
     * @property {string} event.scrollDirection - Indicates which way we are scrolling `"PAUSED"`, `"FORWARD"` or `"REVERSE"`
     */

    /**
     * Scene change event.  
     * Fires whenvever a property of the scene is changed.
     *
     * @event ScrollMagic.Scene#change
     *
     * @example
     * scene.on("change", function (event) {
     * 	console.log("Scene Property \"" + event.what + "\" changed to " + event.newval);
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {string} event.what - Indicates what value has been changed
     * @property {mixed} event.newval - The new value of the changed property
     */

    /**
     * Scene shift event.  
     * Fires whenvever the start or end **scroll offset** of the scene change.
     * This happens explicitely, when one of these values change: `offset`, `duration` or `triggerHook`.
     * It will fire implicitly when the `triggerElement` changes, if the new element has a different position (most cases).
     * It will also fire implicitly when the size of the container changes and the triggerHook is anything other than `onLeave`.
     *
     * @event ScrollMagic.Scene#shift
     * @since 1.1.0
     *
     * @example
     * scene.on("shift", function (event) {
     * 	console.log("Scene moved, because the " + event.reason + " has changed.)");
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {string} event.reason - Indicates why the scene has shifted
     */

    /**
     * Scene destroy event.  
     * Fires whenvever the scene is destroyed.
     * This can be used to tidy up custom behaviour used in events.
     *
     * @event ScrollMagic.Scene#destroy
     * @since 1.1.0
     *
     * @example
     * scene.on("enter", function (event) {
     *        // add custom action
     *        $("#my-elem").left("200");
     *      })
     *      .on("destroy", function (event) {
     *        // reset my element to start position
     *        if (event.reset) {
     *          $("#my-elem").left("0");
     *        }
     *      });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {boolean} event.reset - Indicates if the destroy method was called with reset `true` or `false`.
     */

    /**
     * Scene add event.  
     * Fires when the scene is added to a controller.
     * This is mostly used by plugins to know that change might be due.
     *
     * @event ScrollMagic.Scene#add
     * @since 2.0.0
     *
     * @example
     * scene.on("add", function (event) {
     * 	console.log('Scene was added to a new controller.');
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     * @property {boolean} event.controller - The controller object the scene was added to.
     */

    /**
     * Scene remove event.  
     * Fires when the scene is removed from a controller.
     * This is mostly used by plugins to know that change might be due.
     *
     * @event ScrollMagic.Scene#remove
     * @since 2.0.0
     *
     * @example
     * scene.on("remove", function (event) {
     * 	console.log('Scene was removed from its controller.');
     * });
     *
     * @property {object} event - The event Object passed to each callback
     * @property {string} event.type - The name of the event
     * @property {Scene} event.target - The Scene object that triggered this event
     */

    /**
     * Add one ore more event listener.  
     * The callback function will be fired at the respective event, and an object containing relevant data will be passed to the callback.
     * @method ScrollMagic.Scene#on
     *
     * @example
     * function callback (event) {
     * 		console.log("Event fired! (" + event.type + ")");
     * }
     * // add listeners
     * scene.on("change update progress start end enter leave", callback);
     *
     * @param {string} names - The name or names of the event the callback should be attached to.
     * @param {function} callback - A function that should be executed, when the event is dispatched. An event object will be passed to the callback.
     * @returns {Scene} Parent object for chaining.
     */

    this.on = function (names, callback) {
      if (_util.type.Function(callback)) {
        names = names.trim().split(' ');
        names.forEach(function (fullname) {
          var nameparts = fullname.split('.'),
              eventname = nameparts[0],
              namespace = nameparts[1];

          if (eventname != "*") {
            // disallow wildcards
            if (!_listeners[eventname]) {
              _listeners[eventname] = [];
            }

            _listeners[eventname].push({
              namespace: namespace || '',
              callback: callback
            });
          }
        });
      } else {
        log(1, "ERROR when calling '.on()': Supplied callback for '" + names + "' is not a valid function!");
      }

      return Scene;
    };
    /**
     * Remove one or more event listener.
     * @method ScrollMagic.Scene#off
     *
     * @example
     * function callback (event) {
     * 		console.log("Event fired! (" + event.type + ")");
     * }
     * // add listeners
     * scene.on("change update", callback);
     * // remove listeners
     * scene.off("change update", callback);
     *
     * @param {string} names - The name or names of the event that should be removed.
     * @param {function} [callback] - A specific callback function that should be removed. If none is passed all callbacks to the event listener will be removed.
     * @returns {Scene} Parent object for chaining.
     */


    this.off = function (names, callback) {
      if (!names) {
        log(1, "ERROR: Invalid event name supplied.");
        return Scene;
      }

      names = names.trim().split(' ');
      names.forEach(function (fullname, key) {
        var nameparts = fullname.split('.'),
            eventname = nameparts[0],
            namespace = nameparts[1] || '',
            removeList = eventname === '*' ? Object.keys(_listeners) : [eventname];
        removeList.forEach(function (remove) {
          var list = _listeners[remove] || [],
              i = list.length;

          while (i--) {
            var listener = list[i];

            if (listener && (namespace === listener.namespace || namespace === '*') && (!callback || callback == listener.callback)) {
              list.splice(i, 1);
            }
          }

          if (!list.length) {
            delete _listeners[remove];
          }
        });
      });
      return Scene;
    };
    /**
     * Trigger an event.
     * @method ScrollMagic.Scene#trigger
     *
     * @example
     * this.trigger("change");
     *
     * @param {string} name - The name of the event that should be triggered.
     * @param {object} [vars] - An object containing info that should be passed to the callback.
     * @returns {Scene} Parent object for chaining.
     */


    this.trigger = function (name, vars) {
      if (name) {
        var nameparts = name.trim().split('.'),
            eventname = nameparts[0],
            namespace = nameparts[1],
            listeners = _listeners[eventname];
        log(3, 'event fired:', eventname, vars ? "->" : '', vars || '');

        if (listeners) {
          listeners.forEach(function (listener, key) {
            if (!namespace || namespace === listener.namespace) {
              listener.callback.call(Scene, new ScrollMagic.Event(eventname, listener.namespace, Scene, vars));
            }
          });
        }
      } else {
        log(1, "ERROR: Invalid event name supplied.");
      }

      return Scene;
    }; // set event listeners


    Scene.on("change.internal", function (e) {
      if (e.what !== "loglevel" && e.what !== "tweenChanges") {
        // no need for a scene update scene with these options...
        if (e.what === "triggerElement") {
          updateTriggerElementPosition();
        } else if (e.what === "reverse") {
          // the only property left that may have an impact on the current scene state. Everything else is handled by the shift event.
          Scene.update();
        }
      }
    }).on("shift.internal", function (e) {
      updateScrollOffset();
      Scene.update(); // update scene to reflect new position
    });
    /**
     * Send a debug message to the console.
     * @private
     * but provided publicly with _log for plugins
     *
     * @param {number} loglevel - The loglevel required to initiate output for the message.
     * @param {...mixed} output - One or more variables that should be passed to the console.
     */

    var log = this._log = function (loglevel, output) {
      if (_options.loglevel >= loglevel) {
        Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ") ->");

        _util.log.apply(window, arguments);
      }
    };
    /**
     * Add the scene to a controller.  
     * This is the equivalent to `Controller.addScene(scene)`.
     * @method ScrollMagic.Scene#addTo
     *
     * @example
     * // add a scene to a ScrollMagic Controller
     * scene.addTo(controller);
     *
     * @param {ScrollMagic.Controller} controller - The controller to which the scene should be added.
     * @returns {Scene} Parent object for chaining.
     */


    this.addTo = function (controller) {
      if (!(controller instanceof ScrollMagic.Controller)) {
        log(1, "ERROR: supplied argument of 'addTo()' is not a valid ScrollMagic Controller");
      } else if (_controller != controller) {
        // new controller
        if (_controller) {
          // was associated to a different controller before, so remove it...
          _controller.removeScene(Scene);
        }

        _controller = controller;
        validateOption();
        updateDuration(true);
        updateTriggerElementPosition(true);
        updateScrollOffset();

        _controller.info("container").addEventListener('resize', onContainerResize);

        controller.addScene(Scene);
        Scene.trigger("add", {
          controller: _controller
        });
        log(3, "added " + NAMESPACE + " to controller");
        Scene.update();
      }

      return Scene;
    };
    /**
     * **Get** or **Set** the current enabled state of the scene.  
     * This can be used to disable this scene without removing or destroying it.
     * @method ScrollMagic.Scene#enabled
     *
     * @example
     * // get the current value
     * var enabled = scene.enabled();
     *
     * // disable the scene
     * scene.enabled(false);
     *
     * @param {boolean} [newState] - The new enabled state of the scene `true` or `false`.
     * @returns {(boolean|Scene)} Current enabled state or parent object for chaining.
     */


    this.enabled = function (newState) {
      if (!arguments.length) {
        // get
        return _enabled;
      } else if (_enabled != newState) {
        // set
        _enabled = !!newState;
        Scene.update(true);
      }

      return Scene;
    };
    /**
     * Remove the scene from the controller.  
     * This is the equivalent to `Controller.removeScene(scene)`.
     * The scene will not be updated anymore until you readd it to a controller.
     * To remove the pin or the tween you need to call removeTween() or removePin() respectively.
     * @method ScrollMagic.Scene#remove
     * @example
     * // remove the scene from its controller
     * scene.remove();
     *
     * @returns {Scene} Parent object for chaining.
     */


    this.remove = function () {
      if (_controller) {
        _controller.info("container").removeEventListener('resize', onContainerResize);

        var tmpParent = _controller;
        _controller = undefined;
        tmpParent.removeScene(Scene);
        Scene.trigger("remove");
        log(3, "removed " + NAMESPACE + " from controller");
      }

      return Scene;
    };
    /**
     * Destroy the scene and everything.
     * @method ScrollMagic.Scene#destroy
     * @example
     * // destroy the scene without resetting the pin and tween to their initial positions
     * scene = scene.destroy();
     *
     * // destroy the scene and reset the pin and tween
     * scene = scene.destroy(true);
     *
     * @param {boolean} [reset=false] - If `true` the pin and tween (if existent) will be reset.
     * @returns {null} Null to unset handler variables.
     */


    this.destroy = function (reset) {
      Scene.trigger("destroy", {
        reset: reset
      });
      Scene.remove();
      Scene.off("*.*");
      log(3, "destroyed " + NAMESPACE + " (reset: " + (reset ? "true" : "false") + ")");
      return null;
    };
    /**
     * Updates the Scene to reflect the current state.  
     * This is the equivalent to `Controller.updateScene(scene, immediately)`.  
     * The update method calculates the scene's start and end position (based on the trigger element, trigger hook, duration and offset) and checks it against the current scroll position of the container.  
     * It then updates the current scene state accordingly (or does nothing, if the state is already correct) – Pins will be set to their correct position and tweens will be updated to their correct progress.
     * This means an update doesn't necessarily result in a progress change. The `progress` event will be fired if the progress has indeed changed between this update and the last.  
     * _**NOTE:** This method gets called constantly whenever ScrollMagic detects a change. The only application for you is if you change something outside of the realm of ScrollMagic, like moving the trigger or changing tween parameters._
     * @method ScrollMagic.Scene#update
     * @example
     * // update the scene on next tick
     * scene.update();
     *
     * // update the scene immediately
     * scene.update(true);
     *
     * @fires Scene.update
     *
     * @param {boolean} [immediately=false] - If `true` the update will be instant, if `false` it will wait until next update cycle (better performance).
     * @returns {Scene} Parent object for chaining.
     */


    this.update = function (immediately) {
      if (_controller) {
        if (immediately) {
          if (_controller.enabled() && _enabled) {
            var scrollPos = _controller.info("scrollPos"),
                newProgress;

            if (_options.duration > 0) {
              newProgress = (scrollPos - _scrollOffset.start) / (_scrollOffset.end - _scrollOffset.start);
            } else {
              newProgress = scrollPos >= _scrollOffset.start ? 1 : 0;
            }

            Scene.trigger("update", {
              startPos: _scrollOffset.start,
              endPos: _scrollOffset.end,
              scrollPos: scrollPos
            });
            Scene.progress(newProgress);
          } else if (_pin && _state === SCENE_STATE_DURING) {
            updatePinState(true); // unpin in position
          }
        } else {
          _controller.updateScene(Scene, false);
        }
      }

      return Scene;
    };
    /**
     * Updates dynamic scene variables like the trigger element position or the duration.
     * This method is automatically called in regular intervals from the controller. See {@link ScrollMagic.Controller} option `refreshInterval`.
     * 
     * You can call it to minimize lag, for example when you intentionally change the position of the triggerElement.
     * If you don't it will simply be updated in the next refresh interval of the container, which is usually sufficient.
     *
     * @method ScrollMagic.Scene#refresh
     * @since 1.1.0
     * @example
     * scene = new ScrollMagic.Scene({triggerElement: "#trigger"});
     * 
     * // change the position of the trigger
     * $("#trigger").css("top", 500);
     * // immediately let the scene know of this change
     * scene.refresh();
     *
     * @fires {@link Scene.shift}, if the trigger element position or the duration changed
     * @fires {@link Scene.change}, if the duration changed
     *
     * @returns {Scene} Parent object for chaining.
     */


    this.refresh = function () {
      updateDuration();
      updateTriggerElementPosition(); // update trigger element position

      return Scene;
    };
    /**
     * **Get** or **Set** the scene's progress.  
     * Usually it shouldn't be necessary to use this as a setter, as it is set automatically by scene.update().  
     * The order in which the events are fired depends on the duration of the scene:
     *  1. Scenes with `duration == 0`:  
     *  Scenes that have no duration by definition have no ending. Thus the `end` event will never be fired.  
     *  When the trigger position of the scene is passed the events are always fired in this order:  
     *  `enter`, `start`, `progress` when scrolling forward  
     *  and  
     *  `progress`, `start`, `leave` when scrolling in reverse
     *  2. Scenes with `duration > 0`:  
     *  Scenes with a set duration have a defined start and end point.  
     *  When scrolling past the start position of the scene it will fire these events in this order:  
     *  `enter`, `start`, `progress`  
     *  When continuing to scroll and passing the end point it will fire these events:  
     *  `progress`, `end`, `leave`  
     *  When reversing through the end point these events are fired:  
     *  `enter`, `end`, `progress`  
     *  And when continuing to scroll past the start position in reverse it will fire:  
     *  `progress`, `start`, `leave`  
     *  In between start and end the `progress` event will be called constantly, whenever the progress changes.
     * 
     * In short:  
     * `enter` events will always trigger **before** the progress update and `leave` envents will trigger **after** the progress update.  
     * `start` and `end` will always trigger at their respective position.
     * 
     * Please review the event descriptions for details on the events and the event object that is passed to the callback.
     * 
     * @method ScrollMagic.Scene#progress
     * @example
     * // get the current scene progress
     * var progress = scene.progress();
     *
     * // set new scene progress
     * scene.progress(0.3);
     *
     * @fires {@link Scene.enter}, when used as setter
     * @fires {@link Scene.start}, when used as setter
     * @fires {@link Scene.progress}, when used as setter
     * @fires {@link Scene.end}, when used as setter
     * @fires {@link Scene.leave}, when used as setter
     *
     * @param {number} [progress] - The new progress value of the scene `[0-1]`.
     * @returns {number} `get` -  Current scene progress.
     * @returns {Scene} `set` -  Parent object for chaining.
     */


    this.progress = function (progress) {
      if (!arguments.length) {
        // get
        return _progress;
      } else {
        // set
        var doUpdate = false,
            oldState = _state,
            scrollDirection = _controller ? _controller.info("scrollDirection") : 'PAUSED',
            reverseOrForward = _options.reverse || progress >= _progress;

        if (_options.duration === 0) {
          // zero duration scenes
          doUpdate = _progress != progress;
          _progress = progress < 1 && reverseOrForward ? 0 : 1;
          _state = _progress === 0 ? SCENE_STATE_BEFORE : SCENE_STATE_DURING;
        } else {
          // scenes with start and end
          if (progress < 0 && _state !== SCENE_STATE_BEFORE && reverseOrForward) {
            // go back to initial state
            _progress = 0;
            _state = SCENE_STATE_BEFORE;
            doUpdate = true;
          } else if (progress >= 0 && progress < 1 && reverseOrForward) {
            _progress = progress;
            _state = SCENE_STATE_DURING;
            doUpdate = true;
          } else if (progress >= 1 && _state !== SCENE_STATE_AFTER) {
            _progress = 1;
            _state = SCENE_STATE_AFTER;
            doUpdate = true;
          } else if (_state === SCENE_STATE_DURING && !reverseOrForward) {
            updatePinState(); // in case we scrolled backwards mid-scene and reverse is disabled => update the pin position, so it doesn't move back as well.
          }
        }

        if (doUpdate) {
          // fire events
          var eventVars = {
            progress: _progress,
            state: _state,
            scrollDirection: scrollDirection
          },
              stateChanged = _state != oldState;

          var trigger = function trigger(eventName) {
            // tmp helper to simplify code
            Scene.trigger(eventName, eventVars);
          };

          if (stateChanged) {
            // enter events
            if (oldState !== SCENE_STATE_DURING) {
              trigger("enter");
              trigger(oldState === SCENE_STATE_BEFORE ? "start" : "end");
            }
          }

          trigger("progress");

          if (stateChanged) {
            // leave events
            if (_state !== SCENE_STATE_DURING) {
              trigger(_state === SCENE_STATE_BEFORE ? "start" : "end");
              trigger("leave");
            }
          }
        }

        return Scene;
      }
    };
    /**
     * Update the start and end scrollOffset of the container.
     * The positions reflect what the controller's scroll position will be at the start and end respectively.
     * Is called, when:
     *   - Scene event "change" is called with: offset, triggerHook, duration 
     *   - scroll container event "resize" is called
     *   - the position of the triggerElement changes
     *   - the controller changes -> addTo()
     * @private
     */


    var updateScrollOffset = function updateScrollOffset() {
      _scrollOffset = {
        start: _triggerPos + _options.offset
      };

      if (_controller && _options.triggerElement) {
        // take away triggerHook portion to get relative to top
        _scrollOffset.start -= _controller.info("size") * _options.triggerHook;
      }

      _scrollOffset.end = _scrollOffset.start + _options.duration;
    };
    /**
     * Updates the duration if set to a dynamic function.
     * This method is called when the scene is added to a controller and in regular intervals from the controller through scene.refresh().
     * 
     * @fires {@link Scene.change}, if the duration changed
     * @fires {@link Scene.shift}, if the duration changed
     *
     * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
     * @private
     */


    var updateDuration = function updateDuration(suppressEvents) {
      // update duration
      if (_durationUpdateMethod) {
        var varname = "duration";

        if (changeOption(varname, _durationUpdateMethod.call(Scene)) && !suppressEvents) {
          // set
          Scene.trigger("change", {
            what: varname,
            newval: _options[varname]
          });
          Scene.trigger("shift", {
            reason: varname
          });
        }
      }
    };
    /**
     * Updates the position of the triggerElement, if present.
     * This method is called ...
     *  - ... when the triggerElement is changed
     *  - ... when the scene is added to a (new) controller
     *  - ... in regular intervals from the controller through scene.refresh().
     * 
     * @fires {@link Scene.shift}, if the position changed
     *
     * @param {boolean} [suppressEvents=false] - If true the shift event will be suppressed.
     * @private
     */


    var updateTriggerElementPosition = function updateTriggerElementPosition(suppressEvents) {
      var elementPos = 0,
          telem = _options.triggerElement;

      if (_controller && (telem || _triggerPos > 0)) {
        // either an element exists or was removed and the triggerPos is still > 0
        if (telem) {
          // there currently a triggerElement set
          if (telem.parentNode) {
            // check if element is still attached to DOM
            var controllerInfo = _controller.info(),
                containerOffset = _util.get.offset(controllerInfo.container),
                // container position is needed because element offset is returned in relation to document, not in relation to container.
            param = controllerInfo.vertical ? "top" : "left"; // which param is of interest ?
            // if parent is spacer, use spacer position instead so correct start position is returned for pinned elements.


            while (telem.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
              telem = telem.parentNode;
            }

            var elementOffset = _util.get.offset(telem);

            if (!controllerInfo.isDocument) {
              // container is not the document root, so substract scroll Position to get correct trigger element position relative to scrollcontent
              containerOffset[param] -= _controller.scrollPos();
            }

            elementPos = elementOffset[param] - containerOffset[param];
          } else {
            // there was an element, but it was removed from DOM
            log(2, "WARNING: triggerElement was removed from DOM and will be reset to", undefined);
            Scene.triggerElement(undefined); // unset, so a change event is triggered
          }
        }

        var changed = elementPos != _triggerPos;
        _triggerPos = elementPos;

        if (changed && !suppressEvents) {
          Scene.trigger("shift", {
            reason: "triggerElementPosition"
          });
        }
      }
    };
    /**
     * Trigger a shift event, when the container is resized and the triggerHook is > 1.
     * @private
     */


    var onContainerResize = function onContainerResize(e) {
      if (_options.triggerHook > 0) {
        Scene.trigger("shift", {
          reason: "containerResize"
        });
      }
    };

    var _validate = _util.extend(SCENE_OPTIONS.validate, {
      // validation for duration handled internally for reference to private var _durationMethod
      duration: function duration(val) {
        if (_util.type.String(val) && val.match(/^(\.|\d)*\d+%$/)) {
          // percentage value
          var perc = parseFloat(val) / 100;

          val = function val() {
            return _controller ? _controller.info("size") * perc : 0;
          };
        }

        if (_util.type.Function(val)) {
          // function
          _durationUpdateMethod = val;

          try {
            val = parseFloat(_durationUpdateMethod());
          } catch (e) {
            val = -1; // will cause error below
          }
        } // val has to be float


        val = parseFloat(val);

        if (!_util.type.Number(val) || val < 0) {
          if (_durationUpdateMethod) {
            _durationUpdateMethod = undefined;
            throw ["Invalid return value of supplied function for option \"duration\":", val];
          } else {
            throw ["Invalid value for option \"duration\":", val];
          }
        }

        return val;
      }
    });
    /**
     * Checks the validity of a specific or all options and reset to default if neccessary.
     * @private
     */


    var validateOption = function validateOption(check) {
      check = arguments.length ? [check] : Object.keys(_validate);
      check.forEach(function (optionName, key) {
        var value;

        if (_validate[optionName]) {
          // there is a validation method for this option
          try {
            // validate value
            value = _validate[optionName](_options[optionName]);
          } catch (e) {
            // validation failed -> reset to default
            value = DEFAULT_OPTIONS[optionName];
            var logMSG = _util.type.String(e) ? [e] : e;

            if (_util.type.Array(logMSG)) {
              logMSG[0] = "ERROR: " + logMSG[0];
              logMSG.unshift(1); // loglevel 1 for error msg

              log.apply(this, logMSG);
            } else {
              log(1, "ERROR: Problem executing validation callback for option '" + optionName + "':", e.message);
            }
          } finally {
            _options[optionName] = value;
          }
        }
      });
    };
    /**
     * Helper used by the setter/getters for scene options
     * @private
     */


    var changeOption = function changeOption(varname, newval) {
      var changed = false,
          oldval = _options[varname];

      if (_options[varname] != newval) {
        _options[varname] = newval;
        validateOption(varname); // resets to default if necessary

        changed = oldval != _options[varname];
      }

      return changed;
    }; // generate getters/setters for all options


    var addSceneOption = function addSceneOption(optionName) {
      if (!Scene[optionName]) {
        Scene[optionName] = function (newVal) {
          if (!arguments.length) {
            // get
            return _options[optionName];
          } else {
            if (optionName === "duration") {
              // new duration is set, so any previously set function must be unset
              _durationUpdateMethod = undefined;
            }

            if (changeOption(optionName, newVal)) {
              // set
              Scene.trigger("change", {
                what: optionName,
                newval: _options[optionName]
              });

              if (SCENE_OPTIONS.shifts.indexOf(optionName) > -1) {
                Scene.trigger("shift", {
                  reason: optionName
                });
              }
            }
          }

          return Scene;
        };
      }
    };
    /**
     * **Get** or **Set** the duration option value.
     * As a setter it also accepts a function returning a numeric value.  
     * This is particularly useful for responsive setups.
     *
     * The duration is updated using the supplied function every time `Scene.refresh()` is called, which happens periodically from the controller (see ScrollMagic.Controller option `refreshInterval`).  
     * _**NOTE:** Be aware that it's an easy way to kill performance, if you supply a function that has high CPU demand.  
     * Even for size and position calculations it is recommended to use a variable to cache the value. (see example)  
     * This counts double if you use the same function for multiple scenes._
     *
     * @method ScrollMagic.Scene#duration
     * @example
     * // get the current duration value
     * var duration = scene.duration();
     *
     * // set a new duration
     * scene.duration(300);
     *
     * // use a function to automatically adjust the duration to the window height.
     * var durationValueCache;
     * function getDuration () {
     *   return durationValueCache;
     * }
     * function updateDuration (e) {
     *   durationValueCache = window.innerHeight;
     * }
     * $(window).on("resize", updateDuration); // update the duration when the window size changes
     * $(window).triggerHandler("resize"); // set to initial value
     * scene.duration(getDuration); // supply duration method
     *
     * @fires {@link Scene.change}, when used as setter
     * @fires {@link Scene.shift}, when used as setter
     * @param {(number|function)} [newDuration] - The new duration of the scene.
     * @returns {number} `get` -  Current scene duration.
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** or **Set** the offset option value.
     * @method ScrollMagic.Scene#offset
     * @example
     * // get the current offset
     * var offset = scene.offset();
     *
     * // set a new offset
     * scene.offset(100);
     *
     * @fires {@link Scene.change}, when used as setter
     * @fires {@link Scene.shift}, when used as setter
     * @param {number} [newOffset] - The new offset of the scene.
     * @returns {number} `get` -  Current scene offset.
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** or **Set** the triggerElement option value.
     * Does **not** fire `Scene.shift`, because changing the trigger Element doesn't necessarily mean the start position changes. This will be determined in `Scene.refresh()`, which is automatically triggered.
     * @method ScrollMagic.Scene#triggerElement
     * @example
     * // get the current triggerElement
     * var triggerElement = scene.triggerElement();
     *
     * // set a new triggerElement using a selector
     * scene.triggerElement("#trigger");
     * // set a new triggerElement using a DOM object
     * scene.triggerElement(document.getElementById("trigger"));
     *
     * @fires {@link Scene.change}, when used as setter
     * @param {(string|object)} [newTriggerElement] - The new trigger element for the scene.
     * @returns {(string|object)} `get` -  Current triggerElement.
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** or **Set** the triggerHook option value.
     * @method ScrollMagic.Scene#triggerHook
     * @example
     * // get the current triggerHook value
     * var triggerHook = scene.triggerHook();
     *
     * // set a new triggerHook using a string
     * scene.triggerHook("onLeave");
     * // set a new triggerHook using a number
     * scene.triggerHook(0.7);
     *
     * @fires {@link Scene.change}, when used as setter
     * @fires {@link Scene.shift}, when used as setter
     * @param {(number|string)} [newTriggerHook] - The new triggerHook of the scene. See {@link Scene} parameter description for value options.
     * @returns {number} `get` -  Current triggerHook (ALWAYS numerical).
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** or **Set** the reverse option value.
     * @method ScrollMagic.Scene#reverse
     * @example
     * // get the current reverse option
     * var reverse = scene.reverse();
     *
     * // set new reverse option
     * scene.reverse(false);
     *
     * @fires {@link Scene.change}, when used as setter
     * @param {boolean} [newReverse] - The new reverse setting of the scene.
     * @returns {boolean} `get` -  Current reverse option value.
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** or **Set** the loglevel option value.
     * @method ScrollMagic.Scene#loglevel
     * @example
     * // get the current loglevel
     * var loglevel = scene.loglevel();
     *
     * // set new loglevel
     * scene.loglevel(3);
     *
     * @fires {@link Scene.change}, when used as setter
     * @param {number} [newLoglevel] - The new loglevel setting of the scene. `[0-3]`
     * @returns {number} `get` -  Current loglevel.
     * @returns {Scene} `set` -  Parent object for chaining.
     */

    /**
     * **Get** the associated controller.
     * @method ScrollMagic.Scene#controller
     * @example
     * // get the controller of a scene
     * var controller = scene.controller();
     *
     * @returns {ScrollMagic.Controller} Parent controller or `undefined`
     */


    this.controller = function () {
      return _controller;
    };
    /**
     * **Get** the current state.
     * @method ScrollMagic.Scene#state
     * @example
     * // get the current state
     * var state = scene.state();
     *
     * @returns {string} `"BEFORE"`, `"DURING"` or `"AFTER"`
     */


    this.state = function () {
      return _state;
    };
    /**
     * **Get** the current scroll offset for the start of the scene.  
     * Mind, that the scrollOffset is related to the size of the container, if `triggerHook` is bigger than `0` (or `"onLeave"`).  
     * This means, that resizing the container or changing the `triggerHook` will influence the scene's start offset.
     * @method ScrollMagic.Scene#scrollOffset
     * @example
     * // get the current scroll offset for the start and end of the scene.
     * var start = scene.scrollOffset();
     * var end = scene.scrollOffset() + scene.duration();
     * console.log("the scene starts at", start, "and ends at", end);
     *
     * @returns {number} The scroll offset (of the container) at which the scene will trigger. Y value for vertical and X value for horizontal scrolls.
     */


    this.scrollOffset = function () {
      return _scrollOffset.start;
    };
    /**
     * **Get** the trigger position of the scene (including the value of the `offset` option).  
     * @method ScrollMagic.Scene#triggerPosition
     * @example
     * // get the scene's trigger position
     * var triggerPosition = scene.triggerPosition();
     *
     * @returns {number} Start position of the scene. Top position value for vertical and left position value for horizontal scrolls.
     */


    this.triggerPosition = function () {
      var pos = _options.offset; // the offset is the basis

      if (_controller) {
        // get the trigger position
        if (_options.triggerElement) {
          // Element as trigger
          pos += _triggerPos;
        } else {
          // return the height of the triggerHook to start at the beginning
          pos += _controller.info("size") * Scene.triggerHook();
        }
      }

      return pos;
    };

    var _pin, _pinOptions;

    Scene.on("shift.internal", function (e) {
      var durationChanged = e.reason === "duration";

      if (_state === SCENE_STATE_AFTER && durationChanged || _state === SCENE_STATE_DURING && _options.duration === 0) {
        // if [duration changed after a scene (inside scene progress updates pin position)] or [duration is 0, we are in pin phase and some other value changed].
        updatePinState();
      }

      if (durationChanged) {
        updatePinDimensions();
      }
    }).on("progress.internal", function (e) {
      updatePinState();
    }).on("add.internal", function (e) {
      updatePinDimensions();
    }).on("destroy.internal", function (e) {
      Scene.removePin(e.reset);
    });
    /**
     * Update the pin state.
     * @private
     */

    var updatePinState = function updatePinState(forceUnpin) {
      if (_pin && _controller) {
        var containerInfo = _controller.info(),
            pinTarget = _pinOptions.spacer.firstChild; // may be pin element or another spacer, if cascading pins


        if (!forceUnpin && _state === SCENE_STATE_DURING) {
          // during scene or if duration is 0 and we are past the trigger
          // pinned state
          if (_util.css(pinTarget, "position") != "fixed") {
            // change state before updating pin spacer (position changes due to fixed collapsing might occur.)
            _util.css(pinTarget, {
              "position": "fixed"
            }); // update pin spacer


            updatePinDimensions();
          }

          var fixedPos = _util.get.offset(_pinOptions.spacer, true),
              // get viewport position of spacer
          scrollDistance = _options.reverse || _options.duration === 0 ? containerInfo.scrollPos - _scrollOffset.start // quicker
          : Math.round(_progress * _options.duration * 10) / 10; // if no reverse and during pin the position needs to be recalculated using the progress
          // add scrollDistance


          fixedPos[containerInfo.vertical ? "top" : "left"] += scrollDistance; // set new values

          _util.css(_pinOptions.spacer.firstChild, {
            top: fixedPos.top,
            left: fixedPos.left
          });
        } else {
          // unpinned state
          var newCSS = {
            position: _pinOptions.inFlow ? "relative" : "absolute",
            top: 0,
            left: 0
          },
              change = _util.css(pinTarget, "position") != newCSS.position;

          if (!_pinOptions.pushFollowers) {
            newCSS[containerInfo.vertical ? "top" : "left"] = _options.duration * _progress;
          } else if (_options.duration > 0) {
            // only concerns scenes with duration
            if (_state === SCENE_STATE_AFTER && parseFloat(_util.css(_pinOptions.spacer, "padding-top")) === 0) {
              change = true; // if in after state but havent updated spacer yet (jumped past pin)
            } else if (_state === SCENE_STATE_BEFORE && parseFloat(_util.css(_pinOptions.spacer, "padding-bottom")) === 0) {
              // before
              change = true; // jumped past fixed state upward direction
            }
          } // set new values


          _util.css(pinTarget, newCSS);

          if (change) {
            // update pin spacer if state changed
            updatePinDimensions();
          }
        }
      }
    };
    /**
     * Update the pin spacer and/or element size.
     * The size of the spacer needs to be updated whenever the duration of the scene changes, if it is to push down following elements.
     * @private
     */


    var updatePinDimensions = function updatePinDimensions() {
      if (_pin && _controller && _pinOptions.inFlow) {
        // no spacerresize, if original position is absolute
        var after = _state === SCENE_STATE_AFTER,
            before = _state === SCENE_STATE_BEFORE,
            during = _state === SCENE_STATE_DURING,
            vertical = _controller.info("vertical"),
            pinTarget = _pinOptions.spacer.firstChild,
            // usually the pined element but can also be another spacer (cascaded pins)
        marginCollapse = _util.isMarginCollapseType(_util.css(_pinOptions.spacer, "display")),
            css = {}; // set new size
        // if relsize: spacer -> pin | else: pin -> spacer


        if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
          if (during) {
            _util.css(_pin, {
              "width": _util.get.width(_pinOptions.spacer)
            });
          } else {
            _util.css(_pin, {
              "width": "100%"
            });
          }
        } else {
          // minwidth is needed for cascaded pins.
          css["min-width"] = _util.get.width(vertical ? _pin : pinTarget, true, true);
          css.width = during ? css["min-width"] : "auto";
        }

        if (_pinOptions.relSize.height) {
          if (during) {
            // the only padding the spacer should ever include is the duration (if pushFollowers = true), so we need to substract that.
            _util.css(_pin, {
              "height": _util.get.height(_pinOptions.spacer) - (_pinOptions.pushFollowers ? _options.duration : 0)
            });
          } else {
            _util.css(_pin, {
              "height": "100%"
            });
          }
        } else {
          // margin is only included if it's a cascaded pin to resolve an IE9 bug
          css["min-height"] = _util.get.height(vertical ? pinTarget : _pin, true, !marginCollapse); // needed for cascading pins

          css.height = during ? css["min-height"] : "auto";
        } // add space for duration if pushFollowers is true


        if (_pinOptions.pushFollowers) {
          css["padding" + (vertical ? "Top" : "Left")] = _options.duration * _progress;
          css["padding" + (vertical ? "Bottom" : "Right")] = _options.duration * (1 - _progress);
        }

        _util.css(_pinOptions.spacer, css);
      }
    };
    /**
     * Updates the Pin state (in certain scenarios)
     * If the controller container is not the document and we are mid-pin-phase scrolling or resizing the main document can result to wrong pin positions.
     * So this function is called on resize and scroll of the document.
     * @private
     */


    var updatePinInContainer = function updatePinInContainer() {
      if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
        updatePinState();
      }
    };
    /**
     * Updates the Pin spacer size state (in certain scenarios)
     * If container is resized during pin and relatively sized the size of the pin might need to be updated...
     * So this function is called on resize of the container.
     * @private
     */


    var updateRelativePinSpacer = function updateRelativePinSpacer() {
      if (_controller && _pin && // well, duh
      _state === SCENE_STATE_DURING && ( // element in pinned state?
      // is width or height relatively sized, but not in relation to body? then we need to recalc.
      (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) && _util.get.width(window) != _util.get.width(_pinOptions.spacer.parentNode) || _pinOptions.relSize.height && _util.get.height(window) != _util.get.height(_pinOptions.spacer.parentNode))) {
        updatePinDimensions();
      }
    };
    /**
     * Is called, when the mousewhel is used while over a pinned element inside a div container.
     * If the scene is in fixed state scroll events would be counted towards the body. This forwards the event to the scroll container.
     * @private
     */


    var onMousewheelOverPin = function onMousewheelOverPin(e) {
      if (_controller && _pin && _state === SCENE_STATE_DURING && !_controller.info("isDocument")) {
        // in pin state
        e.preventDefault();

        _controller._setScrollPos(_controller.info("scrollPos") - ((e.wheelDelta || e[_controller.info("vertical") ? "wheelDeltaY" : "wheelDeltaX"]) / 3 || -e.detail * 30));
      }
    };
    /**
     * Pin an element for the duration of the tween.  
     * If the scene duration is 0 the element will only be unpinned, if the user scrolls back past the start position.  
     * Make sure only one pin is applied to an element at the same time.
     * An element can be pinned multiple times, but only successively.
     * _**NOTE:** The option `pushFollowers` has no effect, when the scene duration is 0._
     * @method ScrollMagic.Scene#setPin
     * @example
     * // pin element and push all following elements down by the amount of the pin duration.
     * scene.setPin("#pin");
     *
     * // pin element and keeping all following elements in their place. The pinned element will move past them.
     * scene.setPin("#pin", {pushFollowers: false});
     *
     * @param {(string|object)} element - A Selector targeting an element or a DOM object that is supposed to be pinned.
     * @param {object} [settings] - settings for the pin
     * @param {boolean} [settings.pushFollowers=true] - If `true` following elements will be "pushed" down for the duration of the pin, if `false` the pinned element will just scroll past them.  
     Ignored, when duration is `0`.
     * @param {string} [settings.spacerClass="scrollmagic-pin-spacer"] - Classname of the pin spacer element, which is used to replace the element.
     *
     * @returns {Scene} Parent object for chaining.
     */


    this.setPin = function (element, settings) {
      var defaultSettings = {
        pushFollowers: true,
        spacerClass: "scrollmagic-pin-spacer"
      };
      settings = _util.extend({}, defaultSettings, settings); // validate Element

      element = _util.get.elements(element)[0];

      if (!element) {
        log(1, "ERROR calling method 'setPin()': Invalid pin element supplied.");
        return Scene; // cancel
      } else if (_util.css(element, "position") === "fixed") {
        log(1, "ERROR calling method 'setPin()': Pin does not work with elements that are positioned 'fixed'.");
        return Scene; // cancel
      }

      if (_pin) {
        // preexisting pin?
        if (_pin === element) {
          // same pin we already have -> do nothing
          return Scene; // cancel
        } else {
          // kill old pin
          Scene.removePin();
        }
      }

      _pin = element;
      var parentDisplay = _pin.parentNode.style.display,
          boundsParams = ["top", "left", "bottom", "right", "margin", "marginLeft", "marginRight", "marginTop", "marginBottom"];
      _pin.parentNode.style.display = 'none'; // hack start to force css to return stylesheet values instead of calculated px values.

      var inFlow = _util.css(_pin, "position") != "absolute",
          pinCSS = _util.css(_pin, boundsParams.concat(["display"])),
          sizeCSS = _util.css(_pin, ["width", "height"]);

      _pin.parentNode.style.display = parentDisplay; // hack end.

      if (!inFlow && settings.pushFollowers) {
        log(2, "WARNING: If the pinned element is positioned absolutely pushFollowers will be disabled.");
        settings.pushFollowers = false;
      }

      window.setTimeout(function () {
        // wait until all finished, because with responsive duration it will only be set after scene is added to controller
        if (_pin && _options.duration === 0 && settings.pushFollowers) {
          log(2, "WARNING: pushFollowers =", true, "has no effect, when scene duration is 0.");
        }
      }, 0); // create spacer and insert

      var spacer = _pin.parentNode.insertBefore(document.createElement('div'), _pin),
          spacerCSS = _util.extend(pinCSS, {
        position: inFlow ? "relative" : "absolute",
        boxSizing: "content-box",
        mozBoxSizing: "content-box",
        webkitBoxSizing: "content-box"
      });

      if (!inFlow) {
        // copy size if positioned absolutely, to work for bottom/right positioned elements.
        _util.extend(spacerCSS, _util.css(_pin, ["width", "height"]));
      }

      _util.css(spacer, spacerCSS);

      spacer.setAttribute(PIN_SPACER_ATTRIBUTE, "");

      _util.addClass(spacer, settings.spacerClass); // set the pin Options


      _pinOptions = {
        spacer: spacer,
        relSize: {
          // save if size is defined using % values. if so, handle spacer resize differently...
          width: sizeCSS.width.slice(-1) === "%",
          height: sizeCSS.height.slice(-1) === "%",
          autoFullWidth: sizeCSS.width === "auto" && inFlow && _util.isMarginCollapseType(pinCSS.display)
        },
        pushFollowers: settings.pushFollowers,
        inFlow: inFlow // stores if the element takes up space in the document flow

      };

      if (!_pin.___origStyle) {
        _pin.___origStyle = {};
        var pinInlineCSS = _pin.style,
            copyStyles = boundsParams.concat(["width", "height", "position", "boxSizing", "mozBoxSizing", "webkitBoxSizing"]);
        copyStyles.forEach(function (val) {
          _pin.___origStyle[val] = pinInlineCSS[val] || "";
        });
      } // if relative size, transfer it to spacer and make pin calculate it...


      if (_pinOptions.relSize.width) {
        _util.css(spacer, {
          width: sizeCSS.width
        });
      }

      if (_pinOptions.relSize.height) {
        _util.css(spacer, {
          height: sizeCSS.height
        });
      } // now place the pin element inside the spacer	


      spacer.appendChild(_pin); // and set new css

      _util.css(_pin, {
        position: inFlow ? "relative" : "absolute",
        margin: "auto",
        top: "auto",
        left: "auto",
        bottom: "auto",
        right: "auto"
      });

      if (_pinOptions.relSize.width || _pinOptions.relSize.autoFullWidth) {
        _util.css(_pin, {
          boxSizing: "border-box",
          mozBoxSizing: "border-box",
          webkitBoxSizing: "border-box"
        });
      } // add listener to document to update pin position in case controller is not the document.


      window.addEventListener('scroll', updatePinInContainer);
      window.addEventListener('resize', updatePinInContainer);
      window.addEventListener('resize', updateRelativePinSpacer); // add mousewheel listener to catch scrolls over fixed elements

      _pin.addEventListener("mousewheel", onMousewheelOverPin);

      _pin.addEventListener("DOMMouseScroll", onMousewheelOverPin);

      log(3, "added pin"); // finally update the pin to init

      updatePinState();
      return Scene;
    };
    /**
     * Remove the pin from the scene.
     * @method ScrollMagic.Scene#removePin
     * @example
     * // remove the pin from the scene without resetting it (the spacer is not removed)
     * scene.removePin();
     *
     * // remove the pin from the scene and reset the pin element to its initial position (spacer is removed)
     * scene.removePin(true);
     *
     * @param {boolean} [reset=false] - If `false` the spacer will not be removed and the element's position will not be reset.
     * @returns {Scene} Parent object for chaining.
     */


    this.removePin = function (reset) {
      if (_pin) {
        if (_state === SCENE_STATE_DURING) {
          updatePinState(true); // force unpin at position
        }

        if (reset || !_controller) {
          // if there's no controller no progress was made anyway...
          var pinTarget = _pinOptions.spacer.firstChild; // usually the pin element, but may be another spacer (cascaded pins)...

          if (pinTarget.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
            // copy margins to child spacer
            var style = _pinOptions.spacer.style,
                values = ["margin", "marginLeft", "marginRight", "marginTop", "marginBottom"],
                margins = {};
            values.forEach(function (val) {
              margins[val] = style[val] || "";
            });

            _util.css(pinTarget, margins);
          }

          _pinOptions.spacer.parentNode.insertBefore(pinTarget, _pinOptions.spacer);

          _pinOptions.spacer.parentNode.removeChild(_pinOptions.spacer);

          if (!_pin.parentNode.hasAttribute(PIN_SPACER_ATTRIBUTE)) {
            // if it's the last pin for this element -> restore inline styles
            // TODO: only correctly set for first pin (when cascading) - how to fix?
            _util.css(_pin, _pin.___origStyle);

            delete _pin.___origStyle;
          }
        }

        window.removeEventListener('scroll', updatePinInContainer);
        window.removeEventListener('resize', updatePinInContainer);
        window.removeEventListener('resize', updateRelativePinSpacer);

        _pin.removeEventListener("mousewheel", onMousewheelOverPin);

        _pin.removeEventListener("DOMMouseScroll", onMousewheelOverPin);

        _pin = undefined;
        log(3, "removed pin (reset: " + (reset ? "true" : "false") + ")");
      }

      return Scene;
    };

    var _cssClasses,
        _cssClassElems = [];

    Scene.on("destroy.internal", function (e) {
      Scene.removeClassToggle(e.reset);
    });
    /**
     * Define a css class modification while the scene is active.  
     * When the scene triggers the classes will be added to the supplied element and removed, when the scene is over.
     * If the scene duration is 0 the classes will only be removed if the user scrolls back past the start position.
     * @method ScrollMagic.Scene#setClassToggle
     * @example
     * // add the class 'myclass' to the element with the id 'my-elem' for the duration of the scene
     * scene.setClassToggle("#my-elem", "myclass");
     *
     * // add multiple classes to multiple elements defined by the selector '.classChange'
     * scene.setClassToggle(".classChange", "class1 class2 class3");
     *
     * @param {(string|object)} element - A Selector targeting one or more elements or a DOM object that is supposed to be modified.
     * @param {string} classes - One or more Classnames (separated by space) that should be added to the element during the scene.
     *
     * @returns {Scene} Parent object for chaining.
     */

    this.setClassToggle = function (element, classes) {
      var elems = _util.get.elements(element);

      if (elems.length === 0 || !_util.type.String(classes)) {
        log(1, "ERROR calling method 'setClassToggle()': Invalid " + (elems.length === 0 ? "element" : "classes") + " supplied.");
        return Scene;
      }

      if (_cssClassElems.length > 0) {
        // remove old ones
        Scene.removeClassToggle();
      }

      _cssClasses = classes;
      _cssClassElems = elems;
      Scene.on("enter.internal_class leave.internal_class", function (e) {
        var toggle = e.type === "enter" ? _util.addClass : _util.removeClass;

        _cssClassElems.forEach(function (elem, key) {
          toggle(elem, _cssClasses);
        });
      });
      return Scene;
    };
    /**
     * Remove the class binding from the scene.
     * @method ScrollMagic.Scene#removeClassToggle
     * @example
     * // remove class binding from the scene without reset
     * scene.removeClassToggle();
     *
     * // remove class binding and remove the changes it caused
     * scene.removeClassToggle(true);
     *
     * @param {boolean} [reset=false] - If `false` and the classes are currently active, they will remain on the element. If `true` they will be removed.
     * @returns {Scene} Parent object for chaining.
     */


    this.removeClassToggle = function (reset) {
      if (reset) {
        _cssClassElems.forEach(function (elem, key) {
          _util.removeClass(elem, _cssClasses);
        });
      }

      Scene.off("start.internal_class end.internal_class");
      _cssClasses = undefined;
      _cssClassElems = [];
      return Scene;
    }; // INIT


    construct();
    return Scene;
  }; // store pagewide scene options


  var SCENE_OPTIONS = {
    defaults: {
      duration: 0,
      offset: 0,
      triggerElement: undefined,
      triggerHook: 0.5,
      reverse: true,
      loglevel: 2
    },
    validate: {
      offset: function offset(val) {
        val = parseFloat(val);

        if (!_util.type.Number(val)) {
          throw ["Invalid value for option \"offset\":", val];
        }

        return val;
      },
      triggerElement: function triggerElement(val) {
        val = val || undefined;

        if (val) {
          var elem = _util.get.elements(val)[0];

          if (elem && elem.parentNode) {
            val = elem;
          } else {
            throw ["Element defined in option \"triggerElement\" was not found:", val];
          }
        }

        return val;
      },
      triggerHook: function triggerHook(val) {
        var translate = {
          "onCenter": 0.5,
          "onEnter": 1,
          "onLeave": 0
        };

        if (_util.type.Number(val)) {
          val = Math.max(0, Math.min(parseFloat(val), 1)); //  make sure its betweeen 0 and 1
        } else if (val in translate) {
          val = translate[val];
        } else {
          throw ["Invalid value for option \"triggerHook\": ", val];
        }

        return val;
      },
      reverse: function reverse(val) {
        return !!val; // force boolean
      },
      loglevel: function loglevel(val) {
        val = parseInt(val);

        if (!_util.type.Number(val) || val < 0 || val > 3) {
          throw ["Invalid value for option \"loglevel\":", val];
        }

        return val;
      }
    },
    // holder for  validation methods. duration validation is handled in 'getters-setters.js'
    shifts: ["duration", "offset", "triggerHook"] // list of options that trigger a `shift` event

  };
  /*
   * method used to add an option to ScrollMagic Scenes.
   * TODO: DOC (private for dev)
   */

  ScrollMagic.Scene.addOption = function (name, defaultValue, validationCallback, shifts) {
    if (!(name in SCENE_OPTIONS.defaults)) {
      SCENE_OPTIONS.defaults[name] = defaultValue;
      SCENE_OPTIONS.validate[name] = validationCallback;

      if (shifts) {
        SCENE_OPTIONS.shifts.push(name);
      }
    } else {
      ScrollMagic._util.log(1, "[static] ScrollMagic.Scene -> Cannot add Scene option '" + name + "', because it already exists.");
    }
  }; // instance extension function for plugins
  // TODO: DOC (private for dev)


  ScrollMagic.Scene.extend = function (extension) {
    var oldClass = this;

    ScrollMagic.Scene = function () {
      oldClass.apply(this, arguments);
      this.$super = _util.extend({}, this); // copy parent state

      return extension.apply(this, arguments) || this;
    };

    _util.extend(ScrollMagic.Scene, oldClass); // copy properties


    ScrollMagic.Scene.prototype = oldClass.prototype; // copy prototype

    ScrollMagic.Scene.prototype.constructor = ScrollMagic.Scene; // restore constructor
  };
  /**
   * TODO: DOCS (private for dev)
   * @class
   * @private
   */


  ScrollMagic.Event = function (type, namespace, target, vars) {
    vars = vars || {};

    for (var key in vars) {
      this[key] = vars[key];
    }

    this.type = type;
    this.target = this.currentTarget = target;
    this.namespace = namespace || '';
    this.timeStamp = this.timestamp = Date.now();
    return this;
  };
  /*
   * TODO: DOCS (private for dev)
   */


  var _util = ScrollMagic._util = function (window) {
    var U = {},
        i;
    /**
     * ------------------------------
     * internal helpers
     * ------------------------------
     */
    // parse float and fall back to 0.

    var floatval = function floatval(number) {
      return parseFloat(number) || 0;
    }; // get current style IE safe (otherwise IE would return calculated values for 'auto')


    var _getComputedStyle = function _getComputedStyle(elem) {
      return elem.currentStyle ? elem.currentStyle : window.getComputedStyle(elem);
    }; // get element dimension (width or height)


    var _dimension = function _dimension(which, elem, outer, includeMargin) {
      elem = elem === document ? window : elem;

      if (elem === window) {
        includeMargin = false;
      } else if (!_type.DomElement(elem)) {
        return 0;
      }

      which = which.charAt(0).toUpperCase() + which.substr(1).toLowerCase();
      var dimension = (outer ? elem['offset' + which] || elem['outer' + which] : elem['client' + which] || elem['inner' + which]) || 0;

      if (outer && includeMargin) {
        var style = _getComputedStyle(elem);

        dimension += which === 'Height' ? floatval(style.marginTop) + floatval(style.marginBottom) : floatval(style.marginLeft) + floatval(style.marginRight);
      }

      return dimension;
    }; // converts 'margin-top' into 'marginTop'


    var _camelCase = function _camelCase(str) {
      return str.replace(/^[^a-z]+([a-z])/g, '$1').replace(/-([a-z])/g, function (g) {
        return g[1].toUpperCase();
      });
    };
    /**
     * ------------------------------
     * external helpers
     * ------------------------------
     */
    // extend obj – same as jQuery.extend({}, objA, objB)


    U.extend = function (obj) {
      obj = obj || {};

      for (i = 1; i < arguments.length; i++) {
        if (!arguments[i]) {
          continue;
        }

        for (var key in arguments[i]) {
          if (arguments[i].hasOwnProperty(key)) {
            obj[key] = arguments[i][key];
          }
        }
      }

      return obj;
    }; // check if a css display type results in margin-collapse or not


    U.isMarginCollapseType = function (str) {
      return ["block", "flex", "list-item", "table", "-webkit-box"].indexOf(str) > -1;
    }; // implementation of requestAnimationFrame
    // based on https://gist.github.com/paulirish/1579671


    var lastTime = 0,
        vendors = ['ms', 'moz', 'webkit', 'o'];
    var _requestAnimationFrame = window.requestAnimationFrame;
    var _cancelAnimationFrame = window.cancelAnimationFrame; // try vendor prefixes if the above doesn't work

    for (i = 0; !_requestAnimationFrame && i < vendors.length; ++i) {
      _requestAnimationFrame = window[vendors[i] + 'RequestAnimationFrame'];
      _cancelAnimationFrame = window[vendors[i] + 'CancelAnimationFrame'] || window[vendors[i] + 'CancelRequestAnimationFrame'];
    } // fallbacks


    if (!_requestAnimationFrame) {
      _requestAnimationFrame = function _requestAnimationFrame(callback) {
        var currTime = new Date().getTime(),
            timeToCall = Math.max(0, 16 - (currTime - lastTime)),
            id = window.setTimeout(function () {
          callback(currTime + timeToCall);
        }, timeToCall);
        lastTime = currTime + timeToCall;
        return id;
      };
    }

    if (!_cancelAnimationFrame) {
      _cancelAnimationFrame = function _cancelAnimationFrame(id) {
        window.clearTimeout(id);
      };
    }

    U.rAF = _requestAnimationFrame.bind(window);
    U.cAF = _cancelAnimationFrame.bind(window);
    var loglevels = ["error", "warn", "log"],
        console = window.console || {};

    console.log = console.log || function () {}; // no console log, well - do nothing then...
    // make sure methods for all levels exist.


    for (i = 0; i < loglevels.length; i++) {
      var method = loglevels[i];

      if (!console[method]) {
        console[method] = console.log; // prefer .log over nothing
      }
    }

    U.log = function (loglevel) {
      if (loglevel > loglevels.length || loglevel <= 0) loglevel = loglevels.length;
      var now = new Date(),
          time = ("0" + now.getHours()).slice(-2) + ":" + ("0" + now.getMinutes()).slice(-2) + ":" + ("0" + now.getSeconds()).slice(-2) + ":" + ("00" + now.getMilliseconds()).slice(-3),
          method = loglevels[loglevel - 1],
          args = Array.prototype.splice.call(arguments, 1),
          func = Function.prototype.bind.call(console[method], console);
      args.unshift(time);
      func.apply(console, args);
    };
    /**
     * ------------------------------
     * type testing
     * ------------------------------
     */


    var _type = U.type = function (v) {
      return Object.prototype.toString.call(v).replace(/^\[object (.+)\]$/, "$1").toLowerCase();
    };

    _type.String = function (v) {
      return _type(v) === 'string';
    };

    _type.Function = function (v) {
      return _type(v) === 'function';
    };

    _type.Array = function (v) {
      return Array.isArray(v);
    };

    _type.Number = function (v) {
      return !_type.Array(v) && v - parseFloat(v) + 1 >= 0;
    };

    _type.DomElement = function (o) {
      return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === "object" ? o instanceof HTMLElement : //DOM2
      o && _typeof(o) === "object" && o !== null && o.nodeType === 1 && typeof o.nodeName === "string";
    };
    /**
     * ------------------------------
     * DOM Element info
     * ------------------------------
     */
    // always returns a list of matching DOM elements, from a selector, a DOM element or an list of elements or even an array of selectors


    var _get = U.get = {};

    _get.elements = function (selector) {
      var arr = [];

      if (_type.String(selector)) {
        try {
          selector = document.querySelectorAll(selector);
        } catch (e) {
          // invalid selector
          return arr;
        }
      }

      if (_type(selector) === 'nodelist' || _type.Array(selector)) {
        for (var i = 0, ref = arr.length = selector.length; i < ref; i++) {
          // list of elements
          var elem = selector[i];
          arr[i] = _type.DomElement(elem) ? elem : _get.elements(elem); // if not an element, try to resolve recursively
        }
      } else if (_type.DomElement(selector) || selector === document || selector === window) {
        arr = [selector]; // only the element
      }

      return arr;
    }; // get scroll top value


    _get.scrollTop = function (elem) {
      return elem && typeof elem.scrollTop === 'number' ? elem.scrollTop : window.pageYOffset || 0;
    }; // get scroll left value


    _get.scrollLeft = function (elem) {
      return elem && typeof elem.scrollLeft === 'number' ? elem.scrollLeft : window.pageXOffset || 0;
    }; // get element height


    _get.width = function (elem, outer, includeMargin) {
      return _dimension('width', elem, outer, includeMargin);
    }; // get element width


    _get.height = function (elem, outer, includeMargin) {
      return _dimension('height', elem, outer, includeMargin);
    }; // get element position (optionally relative to viewport)


    _get.offset = function (elem, relativeToViewport) {
      var offset = {
        top: 0,
        left: 0
      };

      if (elem && elem.getBoundingClientRect) {
        // check if available
        var rect = elem.getBoundingClientRect();
        offset.top = rect.top;
        offset.left = rect.left;

        if (!relativeToViewport) {
          // clientRect is by default relative to viewport...
          offset.top += _get.scrollTop();
          offset.left += _get.scrollLeft();
        }
      }

      return offset;
    };
    /**
     * ------------------------------
     * DOM Element manipulation
     * ------------------------------
     */


    U.addClass = function (elem, classname) {
      if (classname) {
        if (elem.classList) elem.classList.add(classname);else elem.className += ' ' + classname;
      }
    };

    U.removeClass = function (elem, classname) {
      if (classname) {
        if (elem.classList) elem.classList.remove(classname);else elem.className = elem.className.replace(new RegExp('(^|\\b)' + classname.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
      }
    }; // if options is string -> returns css value
    // if options is array -> returns object with css value pairs
    // if options is object -> set new css values


    U.css = function (elem, options) {
      if (_type.String(options)) {
        return _getComputedStyle(elem)[_camelCase(options)];
      } else if (_type.Array(options)) {
        var obj = {},
            style = _getComputedStyle(elem);

        options.forEach(function (option, key) {
          obj[option] = style[_camelCase(option)];
        });
        return obj;
      } else {
        for (var option in options) {
          var val = options[option];

          if (val == parseFloat(val)) {
            // assume pixel for seemingly numerical values
            val += 'px';
          }

          elem.style[_camelCase(option)] = val;
        }
      }
    };

    return U;
  }(window || {});

  ScrollMagic.Scene.prototype.addIndicators = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling addIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');

    return this;
  };

  ScrollMagic.Scene.prototype.removeIndicators = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeIndicators() due to missing Plugin \'debug.addIndicators\'. Please make sure to include plugins/debug.addIndicators.js');

    return this;
  };

  ScrollMagic.Scene.prototype.setTween = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');

    return this;
  };

  ScrollMagic.Scene.prototype.removeTween = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeTween() due to missing Plugin \'animation.gsap\'. Please make sure to include plugins/animation.gsap.js');

    return this;
  };

  ScrollMagic.Scene.prototype.setVelocity = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling setVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');

    return this;
  };

  ScrollMagic.Scene.prototype.removeVelocity = function () {
    ScrollMagic._util.log(1, '(ScrollMagic.Scene) -> ERROR calling removeVelocity() due to missing Plugin \'animation.velocity\'. Please make sure to include plugins/animation.velocity.js');

    return this;
  };

  return ScrollMagic;
});
/*!
 * ScrollMagic v2.0.7 (2019-05-07)
 * The javascript library for magical scroll interactions.
 * (c) 2019 Jan Paepke (@janpaepke)
 * Project Website: http://scrollmagic.io
 * 
 * @version 2.0.7
 * @license Dual licensed under MIT license and GPL.
 * @author Jan Paepke - e-mail@janpaepke.de
 *
 * @file ScrollMagic GSAP Animation Plugin.
 *
 * requires: GSAP ~1.14
 * Powered by the Greensock Animation Platform (GSAP): http://www.greensock.com/js
 * Greensock License info at http://www.greensock.com/licensing/
 */

/**
 * This plugin is meant to be used in conjunction with the Greensock Animation Plattform.  
 * It offers an easy API to trigger Tweens or synchronize them to the scrollbar movement.
 *
 * Both the `lite` and the `max` versions of the GSAP library are supported.  
 * The most basic requirement is `TweenLite`.
 * 
 * To have access to this extension, please include `plugins/animation.gsap.js`.
 * @requires {@link http://greensock.com/gsap|GSAP ~1.14.x}
 * @mixin animation.GSAP
 */


(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ScrollMagic', 'TweenMax', 'TimelineMax'], factory);
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    // Loads whole gsap package onto global scope.
    require('gsap');

    factory(require('scrollmagic'), TweenMax, TimelineMax);
  } else {
    // Browser globals
    factory(root.ScrollMagic || root.jQuery && root.jQuery.ScrollMagic, root.TweenMax || root.TweenLite, root.TimelineMax || root.TimelineLite);
  }
})(this, function (ScrollMagic, Tween, Timeline) {
  "use strict";

  var NAMESPACE = "animation.gsap";
  var console = window.console || {},
      err = Function.prototype.bind.call(console.error || console.log || function () {}, console);

  if (!ScrollMagic) {
    err("(" + NAMESPACE + ") -> ERROR: The ScrollMagic main module could not be found. Please make sure it's loaded before this plugin or use an asynchronous loader like requirejs.");
  }

  if (!Tween) {
    err("(" + NAMESPACE + ") -> ERROR: TweenLite or TweenMax could not be found. Please make sure GSAP is loaded before ScrollMagic or use an asynchronous loader like requirejs.");
  }
  /*
   * ----------------------------------------------------------------
   * Extensions for Scene
   * ----------------------------------------------------------------
   */

  /**
   * Every instance of ScrollMagic.Scene now accepts an additional option.  
   * See {@link ScrollMagic.Scene} for a complete list of the standard options.
   * @memberof! animation.GSAP#
   * @method new ScrollMagic.Scene(options)
   * @example
   * var scene = new ScrollMagic.Scene({tweenChanges: true});
   *
   * @param {object} [options] - Options for the Scene. The options can be updated at any time.
   * @param {boolean} [options.tweenChanges=false] - Tweens Animation to the progress target instead of setting it.  
   												  Does not affect animations where duration is `0`.
   */

  /**
   * **Get** or **Set** the tweenChanges option value.  
   * This only affects scenes with a duration. If `tweenChanges` is `true`, the progress update when scrolling will not be immediate, but instead the animation will smoothly animate to the target state.  
   * For a better understanding, try enabling and disabling this option in the [Scene Manipulation Example](../examples/basic/scene_manipulation.html).
   * @memberof! animation.GSAP#
   * @method Scene.tweenChanges
   * 
   * @example
   * // get the current tweenChanges option
   * var tweenChanges = scene.tweenChanges();
   *
   * // set new tweenChanges option
   * scene.tweenChanges(true);
   *
   * @fires {@link Scene.change}, when used as setter
   * @param {boolean} [newTweenChanges] - The new tweenChanges setting of the scene.
   * @returns {boolean} `get` -  Current tweenChanges option value.
   * @returns {Scene} `set` -  Parent object for chaining.
   */
  // add option (TODO: DOC (private for dev))


  ScrollMagic.Scene.addOption("tweenChanges", // name
  false, // default
  function (val) {
    // validation callback
    return !!val;
  }); // extend scene

  ScrollMagic.Scene.extend(function () {
    var Scene = this,
        _tween;

    var log = function log() {
      if (Scene._log) {
        // not available, when main source minified
        Array.prototype.splice.call(arguments, 1, 0, "(" + NAMESPACE + ")", "->");

        Scene._log.apply(this, arguments);
      }
    }; // set listeners


    Scene.on("progress.plugin_gsap", function () {
      updateTweenProgress();
    });
    Scene.on("destroy.plugin_gsap", function (e) {
      Scene.removeTween(e.reset);
    });
    /**
     * Update the tween progress to current position.
     * @private
     */

    var updateTweenProgress = function updateTweenProgress() {
      if (_tween) {
        var progress = Scene.progress(),
            state = Scene.state();

        if (_tween.repeat && _tween.repeat() === -1) {
          // infinite loop, so not in relation to progress
          if (state === 'DURING' && _tween.paused()) {
            _tween.play();
          } else if (state !== 'DURING' && !_tween.paused()) {
            _tween.pause();
          }
        } else if (progress != _tween.progress()) {
          // do we even need to update the progress?
          // no infinite loop - so should we just play or go to a specific point in time?
          if (Scene.duration() === 0) {
            // play the animation
            if (progress > 0) {
              // play from 0 to 1
              _tween.play();
            } else {
              // play from 1 to 0
              _tween.reverse();
            }
          } else {
            // go to a specific point in time
            if (Scene.tweenChanges() && _tween.tweenTo) {
              // go smooth
              _tween.tweenTo(progress * _tween.duration());
            } else {
              // just hard set it
              _tween.progress(progress).pause();
            }
          }
        }
      }
    };
    /**
     * Add a tween to the scene.  
     * If you want to add multiple tweens, add them into a GSAP Timeline object and supply it instead (see example below).  
     * 
     * If the scene has a duration, the tween's duration will be projected to the scroll distance of the scene, meaning its progress will be synced to scrollbar movement.  
     * For a scene with a duration of `0`, the tween will be triggered when scrolling forward past the scene's trigger position and reversed, when scrolling back.  
     * To gain better understanding, check out the [Simple Tweening example](../examples/basic/simple_tweening.html).
     *
     * Instead of supplying a tween this method can also be used as a shorthand for `TweenMax.to()` (see example below).
     * @memberof! animation.GSAP#
     *
     * @example
     * // add a single tween directly
     * scene.setTween(TweenMax.to("obj"), 1, {x: 100});
     *
     * // add a single tween via variable
     * var tween = TweenMax.to("obj"), 1, {x: 100};
     * scene.setTween(tween);
     *
     * // add multiple tweens, wrapped in a timeline.
     * var timeline = new TimelineMax();
     * var tween1 = TweenMax.from("obj1", 1, {x: 100});
     * var tween2 = TweenMax.to("obj2", 1, {y: 100});
     * timeline
     *		.add(tween1)
     *		.add(tween2);
     * scene.addTween(timeline);
     *
     * // short hand to add a TweenMax.to() tween
     * scene.setTween("obj3", 0.5, {y: 100});
     *
     * // short hand to add a TweenMax.to() tween for 1 second
     * // this is useful, when the scene has a duration and the tween duration isn't important anyway
     * scene.setTween("obj3", {y: 100});
     *
     * @param {(object|string)} TweenObject - A TweenMax, TweenLite, TimelineMax or TimelineLite object that should be animated in the scene. Can also be a Dom Element or Selector, when using direct tween definition (see examples).
     * @param {(number|object)} duration - A duration for the tween, or tween parameters. If an object containing parameters are supplied, a default duration of 1 will be used.
     * @param {object} params - The parameters for the tween
     * @returns {Scene} Parent object for chaining.
     */


    Scene.setTween = function (TweenObject, duration, params) {
      var newTween;

      if (arguments.length > 1) {
        if (arguments.length < 3) {
          params = duration;
          duration = 1;
        }

        TweenObject = Tween.to(TweenObject, duration, params);
      }

      try {
        // wrap Tween into a Timeline Object if available to include delay and repeats in the duration and standardize methods.
        if (Timeline) {
          newTween = new Timeline({
            smoothChildTiming: true
          }).add(TweenObject);
        } else {
          newTween = TweenObject;
        }

        newTween.pause();
      } catch (e) {
        log(1, "ERROR calling method 'setTween()': Supplied argument is not a valid TweenObject");
        return Scene;
      }

      if (_tween) {
        // kill old tween?
        Scene.removeTween();
      }

      _tween = newTween; // some properties need to be transferred it to the wrapper, otherwise they would get lost.

      if (TweenObject.repeat && TweenObject.repeat() === -1) {
        // TweenMax or TimelineMax Object?
        _tween.repeat(-1);

        _tween.yoyo(TweenObject.yoyo());
      } // Some tween validations and debugging helpers


      if (Scene.tweenChanges() && !_tween.tweenTo) {
        log(2, "WARNING: tweenChanges will only work if the TimelineMax object is available for ScrollMagic.");
      } // check if there are position tweens defined for the trigger and warn about it :)


      if (_tween && Scene.controller() && Scene.triggerElement() && Scene.loglevel() >= 2) {
        // controller is needed to know scroll direction.
        var triggerTweens = Tween.getTweensOf(Scene.triggerElement()),
            vertical = Scene.controller().info("vertical");
        triggerTweens.forEach(function (value, index) {
          var tweenvars = value.vars.css || value.vars,
              condition = vertical ? tweenvars.top !== undefined || tweenvars.bottom !== undefined : tweenvars.left !== undefined || tweenvars.right !== undefined;

          if (condition) {
            log(2, "WARNING: Tweening the position of the trigger element affects the scene timing and should be avoided!");
            return false;
          }
        });
      } // warn about tween overwrites, when an element is tweened multiple times


      if (parseFloat(TweenLite.version) >= 1.14) {
        // onOverwrite only present since GSAP v1.14.0
        var list = _tween.getChildren ? _tween.getChildren(true, true, false) : [_tween],
            // get all nested tween objects
        newCallback = function newCallback() {
          log(2, "WARNING: tween was overwritten by another. To learn how to avoid this issue see here: https://github.com/janpaepke/ScrollMagic/wiki/WARNING:-tween-was-overwritten-by-another");
        };

        for (var i = 0, thisTween, oldCallback; i < list.length; i++) {
          /*jshint loopfunc: true */
          thisTween = list[i];

          if (oldCallback !== newCallback) {
            // if tweens is added more than once
            oldCallback = thisTween.vars.onOverwrite;

            thisTween.vars.onOverwrite = function () {
              if (oldCallback) {
                oldCallback.apply(this, arguments);
              }

              newCallback.apply(this, arguments);
            };
          }
        }
      }

      log(3, "added tween");
      updateTweenProgress();
      return Scene;
    };
    /**
     * Remove the tween from the scene.  
     * This will terminate the control of the Scene over the tween.
     *
     * Using the reset option you can decide if the tween should remain in the current state or be rewound to set the target elements back to the state they were in before the tween was added to the scene.
     * @memberof! animation.GSAP#
     *
     * @example
     * // remove the tween from the scene without resetting it
     * scene.removeTween();
     *
     * // remove the tween from the scene and reset it to initial position
     * scene.removeTween(true);
     *
     * @param {boolean} [reset=false] - If `true` the tween will be reset to its initial values.
     * @returns {Scene} Parent object for chaining.
     */


    Scene.removeTween = function (reset) {
      if (_tween) {
        if (reset) {
          _tween.progress(0).pause();
        }

        _tween.kill();

        _tween = undefined;
        log(3, "removed tween (reset: " + (reset ? "true" : "false") + ")");
      }

      return Scene;
    };
  });
});
/* Code plugins */

/****************************************************************
 * CODE ajaxCart
 ****************************************************************/


!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'ajaxCart';
  /**
   * @param jQuery Element Wrapping container div
   * @return ajaxCart_plugin
   */

  var ajaxCart_plugin = function ajaxCart_plugin($element, options) {
    // Scope it
    var self = this;
    self.$body = $('body');
    self.$element = self.$body.find('[data-ajax-cart]');
    self.xhrCount = 0; // Set default options

    var defaults = {
      cart_image_size: "100x100_crop_center",
      notification_image_size: "100x",
      onAddShowNotification: true,
      onAddShowCart: true,
      renderCart: true
    };
    var metaOptions = self.$element.data('ajax-cart');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init ajaxCart:', self.$element, self.options);
    } // Find containers


    self.$cartForm = self.$element.find('[data-ajax-cart-form]');
    self.$ajaxCartWrapper = self.$element.find('[data-ajax-cart-wrapper]');
    self.$ajaxCartContainer__products = self.$ajaxCartWrapper.find('[data-ajax-cart-container="products"]');
    self.$ajaxCartContainer__totals = self.$ajaxCartWrapper.find('[data-ajax-cart-container="totals"]');
    self.$ajaxCartContainer__actions = self.$ajaxCartWrapper.find('[data-ajax-cart-container="actions"]');
    self.$ajaxCartTemplate__warnings = $('[data-ajax-cart-template="warnings"]').html();
    self.$ajaxCartTemplate__notifications = $('[data-ajax-cart-template="notifications"]').html();
    self.$ajaxCartTemplate__products = self.$ajaxCartContainer__products.children();
    self.$ajaxCartTemplate__totals = self.$ajaxCartContainer__totals.children();
    self.$ajaxCartTemplate__actions = self.$ajaxCartContainer__actions.children();
    self.$cartContainer__totals = $('[data-cart-container="totals"]');
    self.$cartContainer__products = $('[data-cart-container="products"]');
    self.$cartContainer__emptyMessage = $('[data-ajax-cart-empty-message]');
    self.$cartIconLink = $('[data-ajax-cart-link]');
    self.$cartIconWrapper = $('[data-ajax-cart-icon-wrapper]');
    self.$cartIconQuantity = self.$cartIconWrapper.find('[data-ajax-cart-icon-quantity]'); // Get the cart

    self.getCart(false); // Handle click events

    self.handleEvents();
  };
  /**
   * Handle events
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.handleEvents = function () {
    var self = this; // Catch click on Add to cart buttons

    self.$body.on('click', '[data-ajax-cart-add-button]', function (event) {
      event.preventDefault(); // Add product to cart

      if (window.location.href.indexOf('products') > -1) {
        if (inventoryQuantity > 0) {
          self.addToCart($(this));
        } else {
          self.showWarning('This product is temporary unavailable.');
        }
      } else {
        self.addToCart($(this));
      }
    });
    self.$body.on('click', '[data-ajax-cart-kit-add]', function (event) {
      event.preventDefault();
      var $form = $(event.target).closest('form');
      var addData = $form.serialize(); // Add product to cart

      self.handleAddToCart(addData, $form);
    }); // Catch click on Add to cart (in product popup)

    self.$body.on('click', '[data-ajax-cart-add-button-popup]', function (event) {
      event.preventDefault(); // Close product popup before submitting product to cart

      if (typeof closeProductPopup === 'function') {
        var $el = $('[data-product-popup-show].is-open');
        closeProductPopup($el);
      } // Add product to cart


      if (window.location.href.indexOf('products') > -1) {
        self.addToCart($(this));
      }
    }); // Catch click on Add to cart (in accessories buy box)

    self.$body.on('click', '[data-ajax-cart-add-button-tile]', function (event) {
      event.preventDefault(); // Add product to cart

      if (window.location.href.indexOf('products') > -1 || window.location.href.indexOf('wohnungen') > -1 || window.location.href.indexOf('apartments') > -1) {
        self.addToCart($(this));
      }
    }); // Catch click on Add to cart buttons in multiple products section - "Shop Popular Accessories"

    self.$body.on('click', '[data-ajax-cart-add-pop-acc]', function (event) {
      event.preventDefault(); // Add product to cart

      if (window.location.href.indexOf('products') > -1) {
        if (inventoryQuantity > 0) {
          self.addToCart($(this));
        } else {
          self.showWarning('This product is temporary unavailable.');
        }
      } else {
        self.addToCart($(this));
      }
    }); //Catch click on recommendations Add to Cart (slider in ajax cart)

    $(".ajax-cart-recommendations-wrapper").on('click', function (event) {
      event.preventDefault(); // Determine product to be added

      if (event.target && event.target.id == 'ajax-cart-recommendation-atc') {
        var addData = {
          id: $(event.target).data('ajax-variant-id'),
          quantity: 1
        }; // Add product to cart

        self.addRecommendationToCart(addData);
      }
    }); // Catch click on Shop at Amazon button

    self.$body.on('click', '[data-amazon-link]', function (event) {
      event.preventDefault(); // Add product to cart

      self.redirectToAmazon($(this));
    }); // Catch click on quantity modifiers in ajax cart

    self.$ajaxCartContainer__products.on('click', '[data-ajax-cart-quantity-modifier]', function (event) {
      self.handleQuantityUpate(event);
    }); // Catch click on quantity modifiers on the cart page

    self.$body.on('click', '[data-ajax-cart-quantity-modifier]', function (event) {
      self.handleQuantityUpate(event);
    }); // Catch change of quantity in ajax cart

    self.$ajaxCartContainer__products.on('change keyup blur', '[data-ajax-cart-quantity-value]', function (event) {
      self.handleQuantityUpate(event);
    }); // Catch change of quantity on the cart page

    self.$body.on('change keyup blur', '[data-ajax-cart-quantity-value]', function (event) {
      self.handleQuantityUpate(event);
    }); // Prevent clickthrough on wrapper

    self.$ajaxCartWrapper.on('click', function (event) {
      event.stopPropagation();
    }); // Catch click on product remove in ajax cart

    self.$ajaxCartContainer__products.on('click', '[data-ajax-cart-template-element="remove"]', function (event) {
      event.preventDefault();
      var $productRow = $(this).closest('[data-ajax-cart-template-element="row"]').slideUp(300);
      self.removeProduct($productRow);
    }); // Catch click on product remove on cart page

    self.$cartContainer__products.on('click', '[data-ajax-cart-template-element="remove"]', function (event) {
      event.preventDefault(); // Find the product row

      var $productRow = $(this).closest('[data-cart-line]'); // Make ajax call to remove this product

      self.removeProduct($productRow); // Slide the product out of view

      $productRow.slideUp(300, function () {
        // Remove the row
        $productRow.remove();
      });
    });
  };
  /**
   * Remove a product row
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.removeProduct = function ($row) {
    var self = this; // Set quantity input to 0

    $row.find('[data-ajax-cart-quantity-value]').val(0); // Find product id

    var variantInputId = $row.find('[data-ajax-cart-quantity-id]').val();
    var postData = {
      id: variantInputId,
      quantity: 0
    };

    if ($.code.debug) {
      console.log('Update ajaxCart:', postData);
    } // Post the updates


    self.postAjaxCartUpdates(postData);
  };
  /**
   * Modify quantity in cart
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.handleQuantityUpate = function (event) {
    event.preventDefault();
    var self = this;
    var $trigger = $(event.currentTarget);
    var $wrapper = $trigger.closest('[data-ajax-cart-quantity-modifiers]');
    var currentQuantityMax = $wrapper.data("productQuantityMax"); // Find quantity input

    var $quantityInput = $wrapper.find('[data-ajax-cart-quantity-value]');
    var $variantInput = $wrapper.find('[data-ajax-cart-quantity-id]'); // if triggered by +/- button

    if ($trigger.data('ajax-cart-quantity-modifier')) {
      // Update quantity
      var oldQuantity = parseInt($quantityInput.val());
      var newQuantity = Math.max(oldQuantity + parseInt($trigger.data('ajax-cart-quantity-modifier')), 1);

      if (newQuantity > currentQuantityMax) {
        var errorText = translationQuantityExceeded;
        errorText = errorText.replace('{{ qty }}', currentQuantityMax);

        if ($wrapper.parent().find('.cart-drawer-quantity__error').length < 1) {
          $wrapper.parent().append('<p class="cart-drawer-quantity__error">' + errorText + '</p>');
          setTimeout(function () {
            $('.cart-drawer-quantity__error').slideUp('slow');
            $('.cart-drawer-quantity__error').remove();
          }, 3000);
        }

        newQuantity = currentQuantityMax;
        $quantityInput.val(newQuantity);
      } else {
        var postData = {
          id: $variantInput.val(),
          quantity: newQuantity
        };

        if ($.code.debug) {
          console.log('Update ajaxCart:', postData);
        }

        if ($trigger.data('ajax-cart-quantity-modifier') === -1) {
          // Post the form
          self.postAjaxCartUpdates(postData);
        } else {
          var addedProductId = parseInt(postData.id);
          var idsMaxUnits = [];
          Shopify.getCart(function (cart) {
            $.each(cart.items, function (index, item) {
              if (item.product_type === 'Security System' && item.quantity >= 2) {
                idsMaxUnits.push(item.id);
              }
            });

            if (idsMaxUnits.includes(addedProductId)) {
              var errorText = translationQuantityExceeded;
              errorText = errorText.replace('{{ qty }}', currentQuantityMax);

              if ($wrapper.parent().find('.cart-drawer-quantity__error').length < 1) {
                $wrapper.parent().append('<p class="cart-drawer-quantity__error">' + errorText + '</p>');
                setTimeout(function () {
                  $('.cart-drawer-quantity__error').slideUp('slow');
                  $('.cart-drawer-quantity__error').remove();
                }, 3000);
              }
            } else {
              // Post the form
              self.postAjaxCartUpdates(postData);
            }
          });
        }
      }
    } else {
      // if triggered by manual input
      var newQuantity = parseInt($quantityInput.val());

      if (newQuantity > currentQuantityMax) {
        var errorText = translationQuantityExceeded;
        errorText = errorText.replace('{{ qty }}', currentQuantityMax);

        if ($wrapper.parent().find('.cart-drawer-quantity__error').length < 1) {
          $wrapper.parent().append('<p class="cart-drawer-quantity__error">' + errorText + '</p>');
          setTimeout(function () {
            $('.cart-drawer-quantity__error').slideUp('slow');
            $('.cart-drawer-quantity__error').remove();
          }, 3000);
        }

        newQuantity = currentQuantityMax;
        $quantityInput.val(newQuantity);
      } else {
        var postData = {
          id: $variantInput.val(),
          quantity: newQuantity
        };

        if ($.code.debug) {
          console.log('Update ajaxCart:', postData);
        }

        if (newQuantity <= currentQuantityMax) {
          // Post the form
          self.postAjaxCartUpdates(postData);
        } else {
          var addedProductId = parseInt(postData.id);
          var idsMaxUnits = [];
          Shopify.getCart(function (cart) {
            $.each(cart.items, function (index, item) {
              if (item.product_type === 'Security System' && item.quantity >= 2) {
                idsMaxUnits.push(item.id);
              }
            });

            if (idsMaxUnits.includes(addedProductId)) {
              var errorText = translationQuantityExceeded;
              errorText = errorText.replace('{{ qty }}', currentQuantityMax);

              if ($wrapper.parent().find('.cart-drawer-quantity__error').length < 1) {
                $wrapper.parent().append('<p class="cart-drawer-quantity__error">' + errorText + '</p>');
                setTimeout(function () {
                  $('.cart-drawer-quantity__error').slideUp('slow');
                  $('.cart-drawer-quantity__error').remove();
                }, 3000);
              }
            } else {
              // Post the form
              self.postAjaxCartUpdates(postData);
            }
          });
        }
      }
    }
  };
  /**
   * Show a notification of the added product
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.showAddToCartNotification = function (item) {
    var self = this;

    if (!self.options.onAddShowNotification) {
      return;
    } // Close currently opened fancybox (like Quickshops etc)


    $.fancybox.close(); // Clone the notification template

    var $html = $(self.$ajaxCartTemplate__notifications).clone(); // Fill the template with data

    var $response_html = self.fillTemplate($html, item, self.options.notification_image_size); // Show the notification

    $.fancybox.open($response_html, {
      hideScrollbar: false,
      hash: false,
      touch: false,
      autoFocus: false,
      backFocus: false,
      baseClass: "ajax-cart-notification-popup fancybox-notification"
    });
  };
  /**
   * Update Cart Icon Quantity
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateCartIconQuantity = function (newQuantity) {
    var self = this; // Update counter badge text and data attribute

    self.$cartIconQuantity.text(newQuantity).data('ajax-cart-icon-quantity', newQuantity); // Remove hidden to make it in/visible

    if (newQuantity > 0) {
      self.$cartIconWrapper.removeClass('hidden');
    } else {
      self.$cartIconWrapper.addClass('hidden');
    }
  };
  /**
   * Fill Template
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.fillTemplate = function ($html, data, imageSize) {
    var self = this;
    var $linkEl = $html.find('[data-ajax-cart-template-element="item-link"]');
    var $modifierEl = $html.find('[data-ajax-cart-quantity-modifiers]');
    var maxQuantity = 10;
    var linkUrl = '';

    if (data.properties && data.properties._maxQuantity) {
      maxQuantity = data.properties._maxQuantity;
    } // Fill data in template


    if (data.title) {
      $html.find('[data-ajax-cart-template-element="title"]').html(data.title.replace(/ *\[[^)]*\] */g, " ").trim());
    }

    $html.find('[data-ajax-cart-template-element="warning"]').html(data.warning);
    $html.find('[data-ajax-cart-template-element="quantity"]').html(data.quantity);
    $html.find('[data-ajax-cart-template-element="vendor"]').html(data.vendor);
    $html.find('[data-ajax-cart-template-element="total"]').html(Shopify.formatMoney(data.total_price));
    $html.find('[data-ajax-cart-template-element="discounts"]').html(Shopify.formatMoney(data.discounts));

    if (data.variant_options && data.variant_options[0] === 'Default Title') {
      var linkStr = data.url.split('?');
      linkUrl = linkStr[0];
    } else {
      linkUrl = data.url;
    }

    $linkEl.attr('href', linkUrl);
    $html.find('[data-ajax-cart-template-element="remove"]').attr('href', '/cart/change?quantity=0&id=' + data.id);
    $html.find('[data-ajax-cart-template-element="price"]').html(Shopify.formatMoney(data.final_price));
    $html.find('[data-ajax-cart-quantity-value]').attr("value", data.quantity);
    $html.find('[data-ajax-cart-quantity-id]').attr("value", data.variant_id);
    $modifierEl.attr("data-product-quantity-max", maxQuantity); // if (data.quantity >= maxQuantity) {
    // var errorText = translationQuantityExceeded;
    // errorText = errorText.replace('{{ qty }}', maxQuantity);
    // $modifierEl.parent().append('<p class="cart-drawer-quantity__error">' + errorText + '</p>');
    // setTimeout(function(){
    //   $('.cart-drawer-quantity__error').slideUp();
    // }, 5000);
    // }

    if (data.discounts == 0) {
      $html.find('[data-ajax-cart-template-element="discounts"]').removeClass('hidden');
    } // Resize the image


    if (data.image) {
      var newSrc = Shopify.resizeImage(data.image, imageSize);
      $html.find('[data-ajax-cart-template-element="image"] img').attr('src', newSrc);
    }

    return $html;
  };
  /**
   * Show cart warning
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.showWarning = function (warning) {
    var self = this; // Close currently opened fancybox (like Quickshops etc)

    $.fancybox.close(); // Create the warning (must be wrapped in a single div for fancyBox)

    var warning_html = warning.replace('All 1 ', 'All ').replace('[', '- ').replace(']', '');
    var warningObj = {
      warning: warning_html
    }; // Clone the warning template

    var $html = $(self.$ajaxCartTemplate__warnings).clone(); // Fill the template with data

    var $response_html = self.fillTemplate($html, warningObj, self.options.notification_image_size); // Show the notification

    $.fancybox.open($response_html, {
      hash: false,
      touch: false,
      baseClass: "ajax-cart-warning-popup"
    });
  };
  /**
   * Add product to cart
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.addToCart = function ($el) {
    var self = this; // Find the form

    var $form = $el.closest('form');
    var orderedQuantity = $form.find('[data-ajax-cart-quantity]').val();

    if (isNaN(parseFloat(orderedQuantity))) {
      return;
    }

    var addData = $form.serialize();
    var addObject = JSON.parse('{"' + addData.replace(/&/g, '","').replace(/=/g, '":"') + '"}', function (key, value) {
      return key === "" ? value : decodeURIComponent(value);
    });
    var addedProductId = parseInt(addObject.id);
    var idsMaxUnits = [];
    Shopify.getCart(function (cart) {
      $.each(cart.items, function (index, item) {
        if (item.product_type === 'Security System' && item.quantity >= 2) {
          idsMaxUnits.push(item.id);
        }
      });

      if (idsMaxUnits.includes(addedProductId)) {
        self.showWarning(alarm_max_limit_message);
      } else {
        self.handleAddToCart(addData, $form);
      }
    });

    if ($.code.debug) {
      console.log('Add to Cart:', addData, orderedQuantity);
    }
  };
  /**
   * Shop at Amazon redirect for OOS products
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.redirectToAmazon = function ($el) {
    var self = this; // Find the form

    var clickedEl = document.querySelector('[data-amazon-link]');
    var amazonLink = clickedEl.dataset.amazonLink;

    if ($.code.debug) {
      console.log('Amazon link:', amazonLink);
    }

    window.open(amazonLink, '_blank');
  };
  /**
   * Handle recommended product add to cart Ajax
   *
   * @return void
   * @access public 
   */


  ajaxCart_plugin.prototype.addRecommendationToCart = function (addData) {
    var self = this; // Sequence number for the current invocation of function

    var seqNumber = ++self.xhrCount;
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: addData,
      dataType: 'json',
      success: function success(data) {
        if ($.code.debug) {
          console.log('Recommendation Add to Cart ' + seqNumber + ' success:', data);
        } // If this is the last ajax Call


        if (seqNumber === self.xhrCount) {
          self.getCart(self.options.onAddShowCart);
        } // Track add to cart in Kenshoo


        try {
          kenshoo.trackConversion('3609', '32ce12ef-f320-4195-b470-53ca439cbfff', {
            conversionType: 'add_to_cart'
          });
        } catch (e) {
          if ($.code.debug) {
            console.log('REC - Add to Cart event (kenshoo) did not fire', e);
          }
        } // Amazon display pixels


        if (window.location.hostname.indexOf('en-uk') > -1) {
          try {
            document.body.appendChild(_pix_add_cart);
          } catch (e) {
            console.log('REC - Amazon display pixels did not fire', e);
          }
        }
      },
      error: function error(XMLHttpRequest) {
        if ($.code.debug) {
          console.log('Recommendation Add to Cart unsuccessful:', XMLHttpRequest);
        }
      }
    });
  };
  /**
   * Handle add to cart Ajax
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.handleAddToCart = function (addData, formInfo) {
    var self = this; // Sequence number for the current invocation of function

    var seqNumber = ++self.xhrCount;
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: addData,
      dataType: 'json',
      beforeSend: function beforeSend() {
        if ($.code.debug) {
          console.log('Send to Cart: ' + seqNumber, addData);
        }
      },
      error: function error(XMLHttpRequest) {
        if ($.code.debug) {
          console.log('Add to Cart error:', XMLHttpRequest);
        } // Show a warning


        var responseJSON = XMLHttpRequest.responseJSON;
        self.showWarning(responseJSON.description);
      }
    }).done(function (data) {
      var currentQuantityMax = formInfo.find('[data-product="quantity"]').data("productQuantityMax");

      if (data.quantity >= currentQuantityMax && data.product_type !== 'Security System') {
        formInfo.find('[data-ajax-cart-add-button]').attr("disabled", true);
        formInfo.find('.quantity-error').removeClass('is-hidden');
      }

      if ($.code.debug) {
        console.log('Add to Cart ' + seqNumber + ' success:', data);
      } // If this is the last ajax Call


      if (seqNumber === self.xhrCount) {
        // Show the notification
        // self.showAddToCartNotification(data);
        self.getCart(self.options.onAddShowCart);
        var d = new Date().getTime();

        if (sessionStorage.getItem('atc_time') === null) {
          sessionStorage.setItem("atc_time", d);
        }
      } // Track add to cart in Kenshoo


      try {
        kenshoo.trackConversion('3609', '32ce12ef-f320-4195-b470-53ca439cbfff', {
          conversionType: 'add_to_cart'
        });
      } catch (e) {
        if ($.code.debug) {
          console.log('Add to Cart event (kenshoo) did not fire', e);
        }
      } // Amazon display pixels


      if (window.location.hostname.indexOf('en-uk') > -1) {
        try {
          document.body.appendChild(_pix_add_cart);
        } catch (e) {
          console.log('Amazon display pixels did not fire', e);
        }
      }
    });
  };
  /**
   * Post cart updates;
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.postAjaxCartUpdates = function (data) {
    var self = this; // Sequence number for the current invocation of function

    var seqNumber = ++self.xhrCount;
    $.ajax({
      type: "POST",
      url: '/cart/change.js',
      data: data,
      dataType: 'json',
      success: function success(cart) {
        if ($.code.debug) {
          console.log('Cart update ' + seqNumber + ' success:', cart);
        } // If this is the last ajax Call


        if (seqNumber === self.xhrCount) {
          self.updateCart(cart);
        }
      },
      error: function error(cart) {
        // If ( $.code.debug ) { console.log( 'Add to Cart always:', data ); }
        if (seqNumber === self.xhrCount) {
          // Get the cart
          self.getCart(self.options.onAddShowCart);
        }
      }
    });
  };
  /**
   * Update the cart
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateCart = function (cart) {
    var self = this; // If we're on the cart page, with the cart-form still visible but no products in it (user removed the last product)

    if (window.location.href.indexOf('/cart') > -1 && $('#cartform').length && cart.item_count == 0) {
      // Reload the page to show the ampty cart message
      window.location.reload(true);
      return;
    }

    self.updateAjaxCartProducts(cart.items);
    self.updateAjaxCartTotals(cart);
    self.updateAjaxCartActions(cart);
    self.updateCartProducts(cart.items);
    self.updateCartRecommendations();
    self.updateCartTotals(cart);
    self.updateCartIconQuantity(cart.item_count);

    if ($.code.debug) {
      console.table(cart.items, ["title", "quantity", "id"]);
    }
  };
  /**
   * Render the cart
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.getCart = function (openTheCart) {
    var self = this;
    Shopify.getCart(function (cart) {
      if ($.code.debug) {
        console.log('ajaxCart:', cart);
      }

      self.updateCart(cart);

      if (openTheCart) {
        self.openCart();
      }
    });
  };
  /**
   * Update the ajax cart products
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateAjaxCartProducts = function (cartProducts) {
    var self = this;
    var productCount = 0;
    self.$ajaxCartContainer__products.empty();
    $.each(cartProducts, function (i, productData) {
      productCount = productCount + 1; // Clone the product template

      var $html = self.$ajaxCartTemplate__products.clone(); // Fill the template with data

      var $product_html = self.fillTemplate($html, productData, self.options.cart_image_size); // Add product to container

      self.$ajaxCartContainer__products.append($product_html);
    });

    if (productCount === 0) {
      self.$cartContainer__emptyMessage.attr('hidden', false);
    } else {
      self.$cartContainer__emptyMessage.attr('hidden', true);
    }
  };
  /**
   * Update the cart page products
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateCartProducts = function (cartProducts) {
    var self = this;
    self.$cartContainer__products.find('[data-cart-line]').each(function () {
      var $row = $(this);
      var row_data = false; // Get row ID

      var rowId = $row.data('cart-line'); // Get data for this row from cart data

      $.each(cartProducts, function (index, item_data) {
        if (item_data.variant_id == rowId) {
          row_data = item_data;
          return false;
        }
      }); // Update row data

      if (row_data) {
        $row.find('[data-ajax-cart-quantity-value]').val(row_data.quantity);
        $row.find('[data-ajax-cart-template-element="line-price"]').html(Shopify.formatMoney(row_data.final_line_price)); // Product does not exist in cart
      } else {
        $row.remove();
      }
    });
  };
  /**
   * Update the ajax cart recommendations
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateCartRecommendations = function () {
    var self = this;
    var cartRecommendations = document.querySelector('.ajax-cart-recommendations-wrapper');

    if (Shopify.designMode === undefined) {
      if (cartRecommendations !== undefined) {
        $('[data-cart-rec-loader').fadeOut(100);
        $('.cart-recommendations__loading-dots').fadeIn(300);
        fetch('/?section_id=ajax-cart-recommendations').then(function (response) {
          return response.text();
        }).then(function (text) {
          setTimeout(function () {
            cartRecommendations.innerHTML = text;
            initCartRecommendationsSlider();
          }, 200);
        }).catch(function (e) {
          if ($.code.debug) {
            console.log('Recommendations Update event failed', e);
          }
        });
      }
    }
  };
  /**
   * Update the ajax cart totals
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateAjaxCartTotals = function (cart) {
    var self = this; // Clone the total template

    var $html = self.$ajaxCartTemplate__totals.clone(); // Fill the template with data

    var $ajax_cart_totals_html = self.fillTemplate($html, cart); // Render the Total

    self.$ajaxCartContainer__totals.empty().append($ajax_cart_totals_html);
  };
  /**
   * Update the ajax cart Actions
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateAjaxCartActions = function (cart) {
    var self = this;

    if (cart.item_count > 0) {
      self.$ajaxCartContainer__actions.show();
    } else {
      self.$ajaxCartContainer__actions.hide();
    }
  };
  /**
   * Update the cart page totals
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.updateCartTotals = function (cart) {
    var self = this;
    self.$cartContainer__totals.find('[data-ajax-cart-template-element="total"]').html(Shopify.formatMoney(cart.total_price));
    self.$cartContainer__totals.find('[data-ajax-cart-template-element="discounts"]').html(Shopify.formatMoney(cart.discounts));
  };
  /**
   * Open the cart
   *
   * @return void
   * @access public
   */


  ajaxCart_plugin.prototype.openCart = function ($el) {
    var self = this; // Open the dropdown

    $('body').addClass('ajax-cart__is-open'); // self.$cartIconLink.toggleElementClass('addTheClass');
  };
  /**
   * ajaxCart plugin
   *
   * @return jQuery objects
   */


  $.fn.ajaxCart = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new ajaxCart_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE ajaxPagination
 *
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'ajaxPagination';
  /**
   * @param jQuery Element Wrapping container div
   * @return ajaxPagination_plugin
   */

  var ajaxPagination_plugin = function ajaxPagination_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Set default options

    var defaults = {};
    var metaOptions = self.$element.data('ajax-pagination');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init ajaxPagination:', self.$element, self.options);
    } // Find containers


    self.$target = self.$element.find('[data-ajax-pagination-target]:first'); // Init event handlers

    self.handleEvents();
  };
  /**
   * Handle events
   *
   * @return void
   * @access public
   */


  ajaxPagination_plugin.prototype.handleEvents = function () {
    var self = this; // Catch click on ajax pagination link

    self.$element.on('click', '[data-ajax-pagination-link]', function (event) {
      event.preventDefault(); // Load the page link

      self.loadPage($(this));
    }); // Catch click on products with data-ajax-pagination-item.
    // This will store the collection page that contains this product in history
    // so browsing back from the PDP will always show the page where you left

    self.$element.on('click', '[data-ajax-pagination-item]', function (event) {
      event.preventDefault(); // Store the clicked link

      var productUrl = $(this).attr('href'); // Store the page nr this product belongs to in return_page

      var return_page = $(this).data('ajax-pagination-item'); // Replace the page parameter in the current url with return_page

      var currentUrl = replaceUrlParam(document.location.href, 'page', return_page); // Remove the view parameter from the url

      var historyUrl = currentUrl.replace('&view=ajax-pagination', '').replace('?view=ajax-pagination', '?'); // Replace the current url in history so the user can browse back to the page containg the viewed product

      history.replaceState({}, "", historyUrl); // Open the clicked link

      document.location = productUrl;
    });
  };
  /**
   * Create a loading animation on the link wrappers
   *
   * @return void
   * @access public
   */


  ajaxPagination_plugin.prototype.loadingAnimation = function ($wrapper) {
    $wrapper.slideUp(function () {
      $wrapper.remove();
    });
  };
  /**
   * Load the next/previous collection page
   *
   * @return void
   * @access public
   */


  ajaxPagination_plugin.prototype.loadPage = function ($el) {
    var self = this; // Get the url to load

    var url = $el.attr('href'); // Check if we're paging forward or backward

    var paginationDirection = $el.data('ajax-pagination-link'); // Show loading animation

    var $wrapper = $el.closest('[data-ajax-pagination-link-wrapper]');
    self.loadingAnimation($wrapper); // Load the url

    $.ajax({
      url: url,
      data: {
        view: 'ajax-pagination'
      },
      success: function success(response) {
        var stateObj = {};
        var $html; // When loading previous page

        if (paginationDirection === '-') {
          // Get the elements from the html, remove the next button
          $html = $(response).find('[data-ajax-pagination-link-wrapper="+"]').remove().end().find('[data-ajax-pagination-target]:first').children().hide(); // Prepend elements to the beginning of the target

          self.$target.prepend($html);
        } else {
          // Remove the view parameter from the url
          var historyUrl = url.replace('&view=ajax-pagination', '').replace('?view=ajax-pagination', '?'); // Set the url in history so the user can browse back

          history.pushState(stateObj, "", historyUrl); // Get the elements from the html, remove the previous button

          $html = $(response).find('[data-ajax-pagination-link-wrapper="-"]').remove().end().find('[data-ajax-pagination-target]:first').children().hide(); // Append elements to the end of the target

          self.$target.append($html);
        } // Slide new elements down


        $html.slideDown();
      }
    });
  };
  /**
   * ajaxPagination plugin
   *
   * @return jQuery objects
   */


  $.fn.ajaxPagination = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new ajaxPagination_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE collapsible
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'collapsible';
  /**
   * @param jQuery Element Wrapping container div
   * @return collapsible_plugin
   */

  var collapsible_plugin = function collapsible_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Set default options

    var defaults = {
      jsAnimation: false,
      // Open and close animation by JS, if false provide custom css to handle the .collapsible__is-open state
      openOnHover: false,
      // Open Parents on mouseOver and close on mouseLeave
      closeOnMouseleave: false,
      // Close all Parents when mouse leaves the Wrapper
      closeSiblings: false,
      // Close sibling Parents when opening a Parent - value must be a screen width! When >= screenwidth, Parents will close
      closeAll: false // Close all other Parents in wrapper when opening a Parent

    }; // Get options from element data

    var dataOptions = self.$element.data('collapsible-wrapper'); // Merge data options with default options

    self.options = $.extend({}, defaults, dataOptions);

    if ($.code.debug) {
      console.log('Init collapsible:', self.$element, self.options);
    } // Start the collapsible


    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */


  collapsible_plugin.prototype.init = function () {
    var self = this; // Catch custom events on Parents [data-collapsible-parent] and on the element itself

    self.$element.on({
      'collapsibleOpen': function collapsibleOpen(event) {
        self.open($(event.target));
      },
      'collapsibleClose': function collapsibleClose(event) {
        self.close($(event.target));
      }
    }).on({
      'collapsibleOpen': function collapsibleOpen(event) {
        self.open($(event.target));
      },
      'collapsibleClose': function collapsibleClose(event) {
        self.close($(event.target));
      }
    }, '[data-collapsible-parent]'); // Catch click on Triggers [data-collapsible-trigger]

    self.$element.on({
      click: function click(event) {
        event.stopPropagation();
        var $parent = $(this).closest('[data-collapsible-parent]'); // If Parent is closed - open it

        if (!$parent.hasClass('collapsible__is-open')) {
          event.preventDefault();
          $parent.trigger('collapsibleOpen');
        } else {
          // Else if Parent is not a link, close it
          var $trigger = $(this);

          if (!$trigger.is('a')) {
            $parent.trigger('collapsibleClose');
          } // Else follow the link

        }
      }
    }, '[data-collapsible-trigger]').not('[data-collapsible-wrapper] [data-collapsible-trigger]'); // Catch click on Trigger Icon [data-collapsible-trigger-icon]

    self.$element.on({
      click: function click(event) {
        event.stopPropagation();
        event.preventDefault();
        var $parent = $(this).closest('[data-collapsible-parent]'); // If Parent is closed - open it

        if (!$parent.hasClass('collapsible__is-open')) {
          // Self.open( $parent );
          $parent.trigger('collapsibleOpen');
        } else {
          // Else close it
          $parent.trigger('collapsibleClose');
        }

        return false;
      }
    }, '[data-collapsible-trigger-icon]').not('[data-collapsible-wrapper] [data-collapsible-icon]'); // Catch hover on [data-collapsible-parent]

    if (self.options.openOnHover) {
      self.$element.on({
        mouseenter: function mouseenter(event) {
          // No hover effects on touch devices
          if ($('html').hasClass('touch')) {
            return;
          }

          $(this).trigger('collapsibleOpen');
        },
        mouseleave: function mouseleave(event) {
          // No hover effects on touch devices
          if ($('html').hasClass('touch')) {
            return;
          }

          $(this).trigger('collapsibleClose');
        }
      }, '[data-collapsible-parent]').not('[data-collapsible-wrapper] [data-collapsible-parent]');
    } // Catch mouseleave on [data-collapsible-wrapper]


    if (self.options.closeOnMouseleave) {
      self.$element.on({
        mouseleave: function mouseleave() {
          self.reset();
        }
      });
    }
  };
  /**
   * open subnav
   *
   * @return void
   * @access public
   */


  collapsible_plugin.prototype.open = function ($parent) {
    var self = this; // Find target

    var $target = $parent.find('> [data-collapsible-target]:first');

    if ($target.length && self.options.jsAnimation) {
      // Animate target open
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target.stop().animate({
        maxHeight: totalHeight
      }, function () {
        // Toggle class on parent
        $parent.addClass('collapsible__is-open');
        $target.css({
          maxHeight: ''
        });
      });
    } else {
      // Toggle class on parent
      $parent.addClass('collapsible__is-open'); // Close siblings if Window Width >= self.options.closeSiblings

      if (self.options.closeSiblings > 0 && $.code.ww >= self.options.closeSiblings) {
        $parent.siblings().each(function (index, el) {
          self.close($(this));
        });
      }
    }
  };
  /**
   * close subnav
   *
   * @return void
   * @access public
   */


  collapsible_plugin.prototype.close = function ($parent) {
    var self = this; // Find target

    var $target = $parent.find('> [data-collapsible-target]:first');

    if ($target.length && self.options.jsAnimation) {
      // Animate target closed
      var totalHeight = 0;
      $target.children().each(function () {
        totalHeight = totalHeight + $(this).outerHeight(true);
      });
      $target.stop().css({
        maxHeight: totalHeight
      }).animate({
        maxHeight: 0
      }, function () {
        // Toggle class on parent and close all children
        $parent.removeClass('collapsible__is-open').find('.collapsible__is-open').removeClass('collapsible__is-open');
        $target.css({
          maxHeight: ''
        });
      });
    } else {
      // Toggle class on parent and close all children
      $parent.removeClass('collapsible__is-open').find('.collapsible__is-open').removeClass('collapsible__is-open');
    }
  };
  /**
   * reset navigation elements
   *
   * @return void
   * @access public
   */


  collapsible_plugin.prototype.reset = function () {
    var self = this;
    self.$element.find('[data-collapsible-trigger]').each(function (index, el) {
      var $parent = $(this).closest('[data-collapsible-parent]');

      if ($parent.hasClass('collapsible__is-open')) {
        $parent.trigger('collapsibleClose');
      }
    });
  };
  /**
   * collapsible plugin
   *
   * @return jQuery objects
   */


  $.fn.collapsible = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collapsible_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE collectionFilter
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'collectionFilter';
  /**
   * @param jQuery Element Wrapping container div
   * @return collectionFilter_plugin
   */

  var collectionFilter_plugin = function collectionFilter_plugin($element, options) {
    // scope it
    // Get needed elements
    var self = this;
    self.$element = $element;
    self.$filters = self.$element.data('filter-wrapper');
    self.$checkboxesContainer = self.$element.find('.collection-filter__group-checkbox');
    self.$collections = self.$element.parent().parent().find('[data-collection-wrapper]');
    self.$products = self.$collections.find('.product-link-wrapper'); // Get needed Global variables

    self.$filterClasses = self.$element.data('collection-filter-classes').split(',');
    self.$pointsNeeded = 0;
    self.$selectedTags = [];
    self.$checkedFilters = [];
    self.$paramObj = {};

    if ($.code.debug) {
      console.log('Init collectionFilter:', self.$element);
      console.log('Filters categories:', self.$filterClasses);
    } // Start the collectionFilter


    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.init = function () {
    var self = this; // Check Url params and check the correct checkbox.

    self.initLinkedProducts();
    self.readUrlParams(); // Loop all Filter input[type"checkbox"]'s

    self.$checkboxesContainer.each(function (i, checkbox) {
      // Connect onChange to Filter input[type"checkbox"]'s
      $(checkbox).on('change', function (event) {
        // Limit deselect functionality to UK store
        if (window.location.href.indexOf("en-uk") > -1) {
          if (event.target.dataset.filterClass === 'bundles') {
            $('[data-filter-wrapper="category"]').find('input').prop('checked', false);
          } else if (event.target.dataset.filterClass === 'category') {
            $('[data-filter-wrapper="bundles"]').find('input').prop('checked', false);
          }
        } // Handle onChange event


        self.checkCheckedInputs();
        self.updateProductPoints();
        self.updateCollectionPoints();
        self.updateUrl();
      });
    });
    $(window).on('resize', function (event) {
      // Handle onChange event
      self.updateCollectionPoints();
    });
    self.initFilterSlider();
  };
  /**
   * Init Filter slider
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.initFilterSlider = function () {
    // Scope it
    var self = this;
    var templateWrapper = $("[data-collection-all='template-wrapper']"); // Handle trigger onclick

    $("[data-collection-all-filter='trigger']").on('click', function (event) {
      // Check if templateWrapper has class 'filters__open'
      if (templateWrapper.hasClass('filters__open')) {
        // If templateWrapper has class 'filters__open'
        // Remove class 'filters__open' from templateWrapper
        templateWrapper.removeClass('filters__open'); // Remove class 'no_scroll__lg' from body

        $('body').removeClass('no_scroll__max-lg');
      } else {
        // If templateWrapper doesn't have class 'filters__open'
        // Check if clicked trigger isn't the wrapper
        if ($(event.target).data('collection-all') != 'template-wrapper') {
          // If clicked trigger isn't the wrapper
          // Add class 'filters__open' to templateWrapper
          templateWrapper.addClass('filters__open'); // 'filters__open' will open/show up the filter mobile panel
          // Add class 'no_scroll__lg' to body

          $('body').addClass('no_scroll__max-lg'); // 'no_scroll__lg' will make body unscrollable when screen smaller lg
        }
      }
    }) // Make sure children don't open the filter
    .children().on('click', function (event) {
      event.stopPropagation();
    });
  };
  /**
   * Check Url paramString and check the correct checkbox.
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.readUrlParams = function () {
    var self = this;
    var paramArr = []; // Get filter params from URL

    if (window.location.search.length > 0) {
      paramArr = window.location.search.replace('?', '').split('&');
    }

    var filterValueCategory = []; // Fill self.$paramObj with the correct parameters

    paramArr.forEach(function (paramString, i) {
      // Split the paramString into the filterClass and filterValue
      var filterClass = paramString.split('=')[0];
      var filterValue = paramString.split('=')[1].split("+"); // Need to set category values in seperate array to be able to add bundles later on if needed

      if (filterClass == "category" || filterClass == "bundles") {
        filterValueCategory = filterValue;
      } // Check if filterClass is an actually a filterClass


      if (self.$filterClasses.indexOf(filterClass) != -1) {
        // If filterClass is an actually a filterClass
        // Set filterClass: filterValue in self.$paramObj
        self.$paramObj[filterClass] = filterValue; // if there is no sale on, but sale parameter is set in url, we turn on bundles
      } else if (filterValue == "sale") {
        // add bundles to the array
        filterValueCategory.push("bundles"); // create an updated set for the category filters

        self.$paramObj["bundles"] = ['true'];
      }
    }); // Check the checked checkboxes

    Object.keys(self.$paramObj).forEach(function (filterClass, i) {
      // For all filterClass values
      self.$paramObj[filterClass].forEach(function (value, i) {
        // If the categor-bundles object exist it will override the original category one
        if (filterClass == "category-bundles") {
          filterClass = "category";
        } // Find the correct input[type"checkbox"] and set checked to true


        if (filterClass === 'compatible') {
          $('[data-filter-tag="' + filterClass + ':' + value + '"]').prop('checked', true);

          if ($('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().hasClass('is-hidden')) {
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().toggleClass('is-hidden');
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().parent().find('.is-folded').children().toggleClass('is-hidden');
          }
        } else if (filterClass === 'category' && value === 'alarm-pack') {
          filterClass = 'compatible';
          $('[data-filter-tag="' + filterClass + ':' + value + '"]').prop('checked', true);
          console.log('filter class', filterClass);

          if ($('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().hasClass('is-hidden')) {
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().toggleClass('is-hidden');
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().parent().find('.is-folded').children().toggleClass('is-hidden');
          }
        } else if (filterClass === 'category' && value === 'alarm-camera-pack') {
          filterClass = 'compatible';
          $('[data-filter-tag="' + filterClass + ':' + value + '"]').prop('checked', true);
          console.log('filter class', filterClass);

          if ($('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().hasClass('is-hidden')) {
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().toggleClass('is-hidden');
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().parent().find('.is-folded').children().toggleClass('is-hidden');
          }
        } else if (filterClass === 'category' && value === 'alarm-camera-doorbell-pack') {
          filterClass = 'compatible';
          $('[data-filter-tag="' + filterClass + ':' + value + '"]').prop('checked', true);
          console.log('filter class', filterClass);

          if ($('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().hasClass('is-hidden')) {
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().toggleClass('is-hidden');
            $('[data-filter-tag="' + filterClass + ':' + value + '"]').parent().parent().find('.is-folded').children().toggleClass('is-hidden');
          }
        } else {
          $('[data-filter-finder=' + filterClass + value + ']').prop('checked', true);
        }
      });
    });
    self.checkCheckedInputs();
    self.updateProductPoints();
    self.updateCollectionPoints();
  };
  /**
   * check category inputs
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.checkCheckedInputs = function () {
    var self = this; // Get needed Local variables

    self.$pointsNeeded = 0;
    self.$selectedTags = []; // Check input[type"checkbox"]'s per filterClass

    self.$filterClasses.forEach(function (filterClass) {
      // clear params for current filterClass
      self.$paramObj[filterClass] = [];
      var hasCheckedCheckbox = false; // Check input[type"checkbox"]'s of current filterClass

      $('[data-filter-class=' + filterClass + ']').each(function (i, checkbox) {
        // Check if current input[type"checkbox"] is checked
        if ($(checkbox).prop('checked')) {
          // If current input[type"checkbox"] is checked
          self.$paramObj[filterClass].push($(checkbox).data('filter-tag').split(':')[1]); // Set hasCheckedCheckbox to true

          hasCheckedCheckbox = true; // Add selected tag to self.$selectedTags array

          self.$selectedTags.push($(checkbox).data('filter-tag'));
        }
      }); // If filterClass hasCheckedCheckbox

      if (hasCheckedCheckbox) {
        // Add a point to the amount of needed points
        self.$pointsNeeded += 1;
      }
    });
  };
  /**
   * check if products have the correct amount of points assigned
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.updateProductPoints = function () {
    var self = this; // Handle points for all products

    self.$products.each(function (i, productLink) {
      productLink = $(productLink);
      var newPoints = 0;
      var checkedCategories = [];
      var productTags = productLink.data('collection-product-tags'); // Iterate over all tags the product has (productTags)

      productTags.forEach(function (tag, i) {
        var tagCategorie = tag.split(':')[0]; // Check If tagCategorie is a checkedCategorie && if Tag is a seleclectedTag

        if (checkedCategories.indexOf(tagCategorie) == -1 && self.$selectedTags.indexOf(tag) != -1) {
          // If tagCategorie is a checkedCategorie && if Tag is a seleclectedTag
          checkedCategories.push(tagCategorie);
          newPoints += 1;
        }
      }); // Assign new amount of point to productLink data-collection-product-points

      productLink.attr('data-collection-product-points', newPoints); // Check if productLink has enough points to be displayed

      if (newPoints < self.$pointsNeeded) {
        // If productLink has enough points to be displayed
        productLink.removeClass('showing');
      } else {
        // If productLink doens't has enough points to be displayed
        productLink.addClass('showing');
      }
    });
  };
  /**
   * check if collection have the correct amount of points assigned
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.updateCollectionPoints = function () {
    var self = this;
    var collectionsShowing = false; // Iterate over collections

    self.$collections.each(function (i, collection) {
      collection = $(collection);
      var bannerImgMobile = collection.find('.banner-img-mobile');
      var modifier = 1;

      if (bannerImgMobile.length > 0) {
        // Check if window is smaller than 1024px
        if ($(window).width() < 1024) {
          // If window is SMALLER than 1024px
          // Add 'showing' to banner-img-mobile
          bannerImgMobile.addClass('showing');
        } else {
          // If window is BIGGER than 1024px
          // Remove 'showing' and 'IE-grid__' from banner-img-mobile
          self.removeClass(bannerImgMobile, 'IE-grid__');
          bannerImgMobile.removeClass('showing');
        }
      } // Handle linked products in collection


      self.handleLinkedProducts(collection); // Get showingProducts in the collection

      var showingProducts = collection.find('.showing:not(".banner-img-mobile")'); // Check if showingProducts

      if (showingProducts.length > 0) {
        // If collection contains showingProducts
        // Iterate over showingProducts
        showingProducts.each(function (index, element) {
          // Check if index == 3 (aka 4th grid position)
          if (index == 3 && bannerImgMobile.hasClass('showing')) {
            // If index == 3 (aka 4th grid position)
            // Assign bannerImgMobile that position by adding the 'IE-grid__' class
            bannerImgMobile.addClass('IE-grid__' + (index + modifier) + ''); // Modify the modifier

            modifier += 1;
          } // Remove old 'IE-grid__' class


          self.removeClass(element, 'IE-grid__'); // Add new 'IE-grid__' class

          $(element).addClass('IE-grid__' + (index + modifier) + '');
        }); // If collection contains showingProducts
        // Set collectionsShowing to true

        collectionsShowing = true; // Add 'showing' class to collection

        collection.addClass('showing');
      } else {
        // If collection doesn't contain showingProducts
        // Remove 'showing' class from collection
        collection.removeClass('showing');
      }
    }); // Check if none of the collections has showingProducts

    if (!collectionsShowing) {
      // If none of the collections has showingProducts
      // Show the '.no-products-text' by adding 'showing' class to '.no-products-text'
      $('.no-products-text').addClass('showing');
    } else {
      // If one of the collections has showingProducts
      // Hide the '.no-products-text' by removing 'showing' class from '.no-products-text'
      $('.no-products-text').removeClass('showing');
    }
  };
  /**
   * check if collection will show
   *
   * @return bool
   * @access public
   */


  collectionFilter_plugin.prototype.showCollection = function (collection) {
    var self = this; // Check if collection contains '.showing:not(".banner-img-mobile")'

    if (collection.find('.showing:not(".banner-img-mobile")').length != 0) {
      // If collection contains '.showing:not(".banner-img-mobile")'
      // Return true
      return true;
    } else {
      // If collection doesn't contain '.showing:not(".banner-img-mobile")'
      // Return false
      return false;
    }
  };
  /**
   * init Linked Products logic
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.initLinkedProducts = function () {
    var self = this; // Iterate over collections to check if linkedProducts

    self.$collections.each(function (i, collection) {
      collection = $(collection);
      var linkedProducts = collection.find('[data-collection-product-link]'); // Check if linkedProducts

      if (linkedProducts.length > 0) {
        // If linkedProducts Iterate over linkedProducts to check if linkedProductsCollection is showing
        linkedProducts.each(function (index, linkedProduct) {
          // Get linkedProduct tags
          var currentTags = $(linkedProduct).data('collection-product-tags'); // Get categoryTag

          var tagKey = $('[data-collection-filter-category-tag]').data('collection-filter-category-tag'); // Assign new tag

          var newTag = "" + tagKey + "" + collection.data('collection-wrapper') + ""; // Check if newTag isn't included in currentTags;

          if (currentTags.indexOf(newTag) == -1) {
            // If newTag isn't included in currentTags;
            // Add newTag to currentTags
            currentTags[currentTags.length] = newTag; // Remove other collection from currentTags

            currentTags['0'] = ''; // Set set currentTags as linkedProduct data attribute

            $(linkedProduct).attr('data-collection-product-tags', currentTags);
          }
        });
      }
    });
  };
  /**
   * handle Linked Products logic
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.handleLinkedProducts = function (collection) {
    var self = this; // Get linkedProducts from collection

    var linkedProducts = collection.find('[data-collection-product-link]'); // Check if linkedProducts in collection

    if (linkedProducts.length > 0) {
      // If linkedProducts in collection
      // Iterate over linkedProducts
      linkedProducts.each(function (index, linkedProduct) {
        // Remove 'IE-grid__' from linkedProduct
        self.removeClass(linkedProduct, 'IE-grid__'); // Get linkedCollectionHandle from linkedProduct

        var linkedCollectionHandle = $(linkedProduct).data('collection-product-link'); // Find data-collection-wrapper with the correct linkedCollectionHandle and
        // Check if collection is shown

        if (self.showCollection($('[data-collection-wrapper=' + linkedCollectionHandle + ']'))) {
          // If collection is shown
          // Add 'cant_be_showing' class to linkedProduct
          $(linkedProduct).addClass('cant_be_showing'); // 'cant_be_showing' class makes sure that even 'showing' class is added product won't show
        } else {
          // If collection isn't shown
          // Remove 'cant_be_showing' class from linkedProduct
          $(linkedProduct).removeClass('cant_be_showing');
        }
      });
    }
  };
  /**
   * remove class
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.removeClass = function (element, classnamePart) {
    var self = this;
    var newClasses = []; // Get all classes

    var currentClasses = $(element).attr('class').split(' '); // Iterate over current_classes

    currentClasses.forEach(function (classname) {
      // Check if classname doesn't contain classnamePart
      if (classname.indexOf(classnamePart) == -1) {
        // If classname doesn't contain classnamePart
        // Add classname to newClasses
        newClasses.push(classname);
      }
    }); // Fill element attribute class with newClasses

    $(element).attr('class', newClasses.join(' '));
  };
  /**
   * update Url to match filters
   *
   * @return void
   * @access public
   */


  collectionFilter_plugin.prototype.updateUrl = function () {
    var self = this;
    var URL = window.location.href.split("?")[0];
    var filter_URL = "";
    var isFirstUrlParam = true; // Iterate over the keys in the paramObj

    Object.keys(self.$paramObj).forEach(function (key, i) {
      // Check if this key has content
      if (self.$paramObj[key].length > 0) {
        // If this key has content
        // Check if the 1st parameter
        if (isFirstUrlParam) {
          // If the 1st parameter
          // Set isFirstUrlParam to false
          isFirstUrlParam = false; // Assign filter url

          filter_URL = ["?", filter_URL, key, "=", self.$paramObj[key].join("+")].join('');
        } else {
          // If isn't the 1st parameter
          // Assign filter url
          filter_URL = [filter_URL, "&", key, "=", self.$paramObj[key].join("+")].join('');
        }
      }
    }); // Assign URL with filters

    URL = '' + URL + filter_URL + ''; // Set URL in addressbar

    window.history.replaceState(history.state, '', URL);
  };
  /**
   * collectionFilter plugin
   *
   * @return jQuery objects
   */


  $.fn.collectionFilter = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionFilter_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };

  $('.js-enable-second-level').click(function () {
    $(this).parent().find('.js-checkbox-label__second_level').toggleClass('is-hidden');
    $(this).parent().find('.is-folded').children().toggleClass('is-hidden');
  });
}(jQuery, document, window);
/****************************************************************
* CODE collectionNav
****************************************************************/

!function ($, document, window, undefined) {
  /**
  * Plugin name
  */
  var _pluginName = 'collectionNav';
  /**
  * @param jQuery Element Wrapping container div
  * @return collectionNav_plugin
  */

  var collectionNav_plugin = function collectionNav_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element;
    self.storageId = 'CodeCollectionNav'; // get current values

    self.sort_by = getParameterByName('sort_by');
    self.view = getParameterByName('view');
    self.page = parseInt(getParameterByName('page')); // collection sorter

    self.$element.find('[data-sort-collection]').each(function () {
      // set to current sorting
      var sortingData = $(this).data('sort-collection');

      if (sortingData.current != 'undefined') {
        $(this).find('[value="' + sortingData.current + '"]').prop('selected', true);
      }
    }); // init collection sorter

    self.$element.on('change', '[data-sort-collection]', function (event) {
      // on change, reload with sorting parameter
      event.preventDefault();
      var sortingData = $(this).data('sort-collection');
      var newSorting = $(this).val();
      self.sort_by = ''; // reset paging

      self.page = '';

      if (newSorting != sortingData.default) {
        self.sort_by = newSorting;
      }

      self.goToUrl();
    }); // init collection grid/list view

    self.$element.on('change', '[data-collection-view]', function (event) {
      // on change, reload page with viewing parameter
      event.preventDefault();
      var newView = $(this).val();
      self.view = newView;
      self.goToUrl();
    }); // init collection paging

    self.$element.on('click', '[data-collection-nav-paging] a', function (event) {
      event.preventDefault(); // on change, reload page with page parameter

      var newPageUrl = $(this).attr('href');
      self.page = parseInt(getParameterByName('page', newPageUrl));
      self.goToUrl();
    }); // THIS DOES NOT WORK WITH FILTERED COLLECTIONS

    if ($.code.localStorage) {
      // get stored collection objects from localstorage
      self.getCollectionsNav(); // find links that point to this collection

      self.$element.find('[data-collection-nav-link]').each(function () {
        // get url of collection
        var url = $(this).data('collection-nav-link'); // check if localstorage contains params for this url

        var urlData = self.collectionsParams[url];

        if (!urlData) {
          return;
        } // create new url


        var newUrl;

        if (urlData && urlData.view) {
          newUrl = self.addtoUrl(url, 'view', urlData.view);
        }

        if (urlData && urlData.sort_by) {
          newUrl = self.addtoUrl(newUrl, 'sort_by', urlData.sort_by);
        }

        if (urlData && urlData.page) {
          newUrl = self.addtoUrl(newUrl, 'page', urlData.page);
        } // update href with newUrl


        if (newUrl) {
          $(this).attr('href', newUrl);
        }
      });
    }
  };
  /**
   * Toggle nav
   */


  collectionNav_plugin.prototype.addtoUrl = function (url, param, val) {
    var q = '';

    if (val) {
      if (url.indexOf('?') < 0) {
        q = '?';
      } else {
        q = '&';
      }

      url += q + param + '=' + val;
    }

    return url;
  };
  /**
   * Go To Url
   */


  collectionNav_plugin.prototype.goToUrl = function () {
    var self = this;
    var path = window.location.pathname;
    var url = window.location.protocol + "//" + window.location.host + path;
    self.storeCollectionsNav(path); // create new url

    var newUrl = self.addtoUrl(url, 'view', self.view);
    newUrl = self.addtoUrl(newUrl, 'sort_by', self.sort_by);
    newUrl = self.addtoUrl(newUrl, 'page', self.page); // go to url

    window.location = newUrl;
  };
  /**
   * get collections nav objects
   */


  collectionNav_plugin.prototype.getCollectionsNav = function () {
    var self = this;

    if ($.code.localStorage) {
      // get stored collection objects from localstorage
      self.collectionsParams = {};
      var storedCollectionsParams = localStorage.getItem(self.storageId);

      if (storedCollectionsParams) {
        self.collectionsParams = JSON.parse(storedCollectionsParams);
      }
    }
  };
  /**
   * Store collections nav objects
   */


  collectionNav_plugin.prototype.storeCollectionsNav = function (url) {
    var self = this;

    if ($.code.localStorage) {
      // get stored collection objects from localstorage
      self.getCollectionsNav(); // add current / update the collection object in collection objects

      self.collectionsParams[url] = {
        page: self.page,
        view: self.view,
        sort_by: self.sort_by
      }; // store the collection objects

      localStorage.setItem(self.storageId, JSON.stringify(self.collectionsParams));
    }
  };
  /**
  * collectionNav plugin
  *
  * @return jQuery objects
  */


  $.fn.collectionNav = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionNav_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE compare
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'compare';
  /**
   * @param jQuery Element Wrapping container div
   * @return compare_plugin
   */

  var compare_plugin = function compare_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.$strings = $('[data-compare-strings]').data('compare-strings');
    self.$selects = $element.find('[data-custom-select="wrapper"]');
    self.$currentProductData; // Set default options

    var defaults = {}; // Get options from element data

    var dataOptions = self.$element.data('compare-wrapper'); // Merge data options with default options

    self.options = $.extend({}, defaults, dataOptions);

    if ($.code.debug) {
      console.log('Init compare:', self.$element, self.options);
    } // Start the compare


    self.init();
    $(document).on('shopify:section:load', function (event) {
      self.init();
    });
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */


  compare_plugin.prototype.init = function () {
    var self = this; // Fix selects position absolutes

    self.resizeMobileSelects(); // Connect window resize

    $(window).on('resize', function (e) {
      self.resizeMobileSelects();
    }); // Connect selects events

    $('[data-custom-select="wrapper"]').on({
      click: function click(event) {
        var wrapper = $(this);
        var target = $(event.target);

        if (wrapper.hasClass('dropdown__open')) {
          if (target.data('custom-select-value') != undefined) {
            self.$currentProductData = target.find('#select-value').html();
            wrapper.find('[data-custom-select="selected"] > div ').html(target.html()).find('#select-value').html(self.$currentProductData);
            wrapper.find('[data-custom-select="selected"]').trigger('change');
          }

          wrapper.removeClass('dropdown__open');
        } else {
          if ($.code.ww < 440) {} else {
            wrapper.addClass('dropdown__open');
          }
        }
      },
      mouseleave: function mouseleave(event) {
        var wrapper = $(this);
        wrapper.removeClass('dropdown__open');
      }
    }); // Connect select changes

    $('[data-custom-select="selected"]').on({
      change: function change(event) {
        self.assingCells(this);
        self.resizeMobileSelects();
      }
    });
    $('[data-custom-select="selected"]').each(function (i, element) {
      self.$currentProductData = $(element).find('#select-value').html();
      self.assingCells(element);
    }); // Connect mobile select changes

    $('.mobile-selector_dropdown').on('change', function (event) {
      var selectedProductHandle = $(this).find('.mobile-product-selector').val();
      var wrapper = $(this).closest('[data-custom-select="wrapper"]');
      var selectedProduct = wrapper.find('[data-product-handle="' + selectedProductHandle + '"]');
      selectedProduct.click();
      self.$currentProductData = selectedProduct.find('#select-value').html();
      wrapper.find('[data-custom-select="selected"] > div ').html(selectedProduct.html()).find('#select-value').html(self.$currentProductData);
      wrapper.find('[data-custom-select="selected"]').trigger('change');
    });
  };
  /**
  * assign Cells
  *
  * @return void
  * @access public
  */


  compare_plugin.prototype.assingCells = function (select) {
    var self = this;
    var column = $(select).parent().data('compare-product-select');
    var productData = self.$currentProductData;

    if (_typeof(productData) != _typeof({})) {
      productData = JSON.parse(productData);
    }

    Object.keys(productData).forEach(function (key, index) {
      var currentCell = $('[data-compare-product-' + key + '="' + column + '"]');

      switch (key) {
        case 'image':
          var styles = {
            'background-image': 'url("' + productData[key] + '")',
            'background-size': 'contain',
            'padding-bottom': '100%'
          };
          currentCell.css(styles);
          break;

        case 'available-colours':
          var coloursArr = productData[key].split('-').sort().reverse();
          var colourSwatchesArr = [];
          coloursArr.forEach(function (colour, index) {
            var colourSwatch = '<div class="color-swatch ' + colour + '"></div>';
            colourSwatchesArr.push(colourSwatch);
          });
          currentCell.html(colourSwatchesArr.join(''));
          break;

        case 'colours':
          var coloursArr = productData[key].split('-').sort().reverse();
          var colourSwatchesArr = [];
          coloursArr.forEach(function (colour, index) {
            var colourSwatch = '<div class="color-swatch ' + colour + '"></div>';
            colourSwatchesArr.push(colourSwatch);
          });
          currentCell.html(colourSwatchesArr.join(''));
          break;

        case 'horizontal-field-of-view':
          if (productData[key] != undefined && productData[key] != '') {
            var icon = $('[data-compare-icons=' + key + ']').html().replace('[[REPLACE]]', '' + productData[key] + '°');
            currentCell.html(icon);
          } else {
            currentCell.html(productData[key]);
          }

          break;

        case 'internet-connection':
          var iconsArr = ['<div class="internet-connection__icons-wrapper">'];
          var check = false;

          if (productData[key].toLowerCase().indexOf('wifi') != -1) {
            iconsArr.push($('[data-compare-icons="wifi"]').html());
            check = true;
          }

          iconsArr.push('</div>');

          if (check) {
            iconsArr.push(productData[key]);
            currentCell.html(iconsArr.join(''));
          } else {
            currentCell.html(productData[key]);
          }

          break;

        case 'wifi-connectivity':
          var iconsArr = ['<div class="wifi-connectivity__icons-wrapper">'];
          var check = false;

          if (productData[key].toLowerCase().indexOf('wifi') != -1) {
            iconsArr.push($('[data-compare-icons="wifi"]').html());
            check = true;
          }

          iconsArr.push('</div>');

          if (check) {
            iconsArr.push(productData[key]);
            currentCell.html(iconsArr.join(''));
          } else {
            currentCell.html(productData[key]);
          }

          break;

        case 'privacy-zones':
          var iconsArr = ['<div class="motion-zones__icons-wrapper">'];
          var check = false;

          if (productData[key].toLowerCase().indexOf('privacy zones') != -1) {
            iconsArr.push($('[data-compare-icons="motion-zones"]').html());
            check = true;
          }

          iconsArr.push('</div>');

          if (check) {
            iconsArr.push(productData[key]);
            currentCell.html(iconsArr.join(''));
          } else {
            currentCell.html(productData[key]);
          }

          break;

        case 'installation':
          if (productData[key] != undefined && productData[key] != '') {
            var icon = $('[data-compare-icons=' + key + ']').html();
            var replacer = false;

            if (productData[key].indexOf('60') != -1) {
              replacer = '60';
            } else if (productData[key].indexOf('15') != -1) {
              replacer = '15';
            } else if (productData[key].indexOf('10') != -1) {
              replacer = '10';
            } else if (productData[key].indexOf('5') != -1) {
              replacer = '5';
            }

            if (replacer) {
              icon = icon.replace('[[REPLACE]]', replacer).concat('<p>' + productData[key].replace(replacer, '') + '<p/>');
              currentCell.html(icon);
              break;
            } else {
              currentCell.html(productData[key]);
              break;
            }
          }

          currentCell.html('');
          break;

        case 'faceplate-finishes-colours':
          var colors = productData[key].split(',');
          var colorSwatch = $('[data-compare-icons="color-swatches"]').html();
          var colorSwatches = [];
          colors.forEach(function (color) {
            var swatch = colorSwatch;
            colorSwatches.push(swatch.replace('[[REPLACE]]', color));
          });
          currentCell.html(colorSwatches.join(''));
          break;

        case 'cta':
          if (productData["available"] == "true") {
            currentCell.html('<a class="button button__primary" href="' + productData[key] + '">' + self.$strings[key] + '</a>');
          } else {
            currentCell.html('<a class="button button__secondary" href="' + productData[key] + '">' + self.$strings["cta_secondary"] + '</a>');
          }

          break;

        default:
          if (productData[key].toLowerCase() != 'blank') {
            if (productData[key].toLowerCase().indexOf('[[') != -1) {
              currentCell.html($('[data-compare-icons=' + productData[key].replace('[[', '').replace(']]', '') + ']').html());
            } else {
              currentCell.html(productData[key]);
            }
          }

      }
    });
  };
  /**
  * resize Mobile Selects
  *
  * @return void
  * @access public
  */


  compare_plugin.prototype.resizeMobileSelects = function () {
    var self = this;
    var minheight = 0;
    self.$selects.each(function (i, elem) {
      var newHeight = $(elem).find('[data-custom-select-value]').outerHeight(true);

      if (newHeight > minheight) {
        minheight = newHeight;
      }
    });
    self.$selects.parent().css('height', minheight + parseInt(self.$selects.parent().css('padding-top')));
  };
  /**
   * compare plugin
   *
   * @return jQuery objects
   */


  $.fn.compare = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new compare_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE Country Popup
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'countryPopup';
  /**
   * @param jQuery Element Wrapping container div
   * @return countryPopup_plugin
   */

  var countryPopup_plugin = function countryPopup_plugin($element, options) {
    // scope
    var self = this;
    self.$element = $element;
    var country_popup_wrapper_identifier = "#country-message";
    self.country_popup_wrapper = self.$element.find(country_popup_wrapper_identifier);
    self.button_stay = self.country_popup_wrapper.find('[data-country-message-stay]'); // guard: check country popup exists

    if (self.country_popup_wrapper.length == 0) {
      return;
    } // guard: check fancybox object exists


    if (_typeof($.fancybox) != 'object') {
      return;
    } // get options


    var defaults = {
      'current_country_code': '',
      'location_api_url': '',
      'location_field_name': '',
      'popup_messages': {}
    };
    var metaOptions = self.country_popup_wrapper.data('country-message-options');
    self.options = $.extend({}, defaults, metaOptions); // set country popup cookie identifier

    self.country_popup_cookie_identifier = "country_popup"; // set fancybox

    self.fancybox = $.fancybox;

    if ($.code.debug) {
      console.log('Init country popup:', self.country_popup_wrapper, self.options);
    } // init country popup


    self.init(); // section loaded reload popup

    $(document).on('shopify:section:load', function (e) {
      if (e.detail.sectionId == "site-country-popup") {
        self.fancybox.close();
        self.init();
      }
    });
  };
  /**
   * Init the country popup plugin
   *
   * @return void
   */


  countryPopup_plugin.prototype.init = function () {
    // scope
    var self = this; // if country popup days is set to zero, remove cookie if exists

    if (parseInt(self.options.expires_in_days) == 0) {
      Cookies.remove(self.country_popup_cookie_identifier);
    } // Get element


    self.countryPopupCookie = Cookies.get(self.country_popup_cookie_identifier); // Render country popup if given

    if (!self.mayRenderCountryPopup()) {
      return false;
    } // get country location


    self.getLocation(function () {
      // render the country popup
      self.renderCountryPopup();
    }); // button close popup

    $(self.button_stay).on('click', function () {
      self.closeCountryPopup();
    });
  };
  /**
   * Check if the country popup may be rendered and that there is a message to show
   *
   * @return boolean
   */


  countryPopup_plugin.prototype.mayRenderCountryPopup = function () {
    // scope
    var self = this; // guard: check if popup cookie is set

    if (self.countryPopupCookie) {
      return false;
    } // guard: check if there are messages given


    if (self.options.popup_messages.length == 0) {
      return false;
    }

    return true;
  };
  /**
   * Get country location from cookie or GeoAPI
   *
   * @return string country_code
   */


  countryPopup_plugin.prototype.getLocation = function (callback) {
    // scope
    var self = this; // get country code from cookie

    self.country_code = Cookies.get(self.country_popup_cookie_identifier + '-country_code'); // if country code is given, return the code

    if (self.country_code) {
      return callback();
    } // get country code from api, if done call the callback


    self.getCountryCodeFromAPI().done(function (country_code) {
      self.setCountryCode(country_code);
      return callback();
    });
    return self.country_code;
  };
  /**
   * Get country code from API service
   *
   * @return string country_code
   */


  countryPopup_plugin.prototype.getCountryCodeFromAPI = function () {
    // scope
    var self = this;
    var default_api_url = '//extreme-ip-lookup.com/json/';
    var country_code_api = self.options.location_api_url || default_api_url;
    var country_code_fieldname_identifier = self.options.location_field_name || 'country_code'; // guard: get country code api url from options

    if (country_code_api == '') {
      return self;
    } // guard: get country code field name


    if (country_code_fieldname_identifier == '') {
      return self;
    } // get country coude from api


    return $.getJSON(country_code_api).then(function (response) {
      if (typeof response[country_code_fieldname_identifier] != "undefined" && response[country_code_fieldname_identifier] != '') {
        return response[country_code_fieldname_identifier];
      }
    });
  };
  /**
   * Render the country popup
   *
   * @return string country_code
   */


  countryPopup_plugin.prototype.setCountryCode = function (country_code) {
    // scope
    var self = this; // guard: check country code is given

    if (typeof country_code == "undefined" || country_code == '') {
      return '';
    } // set the country code


    self.country_code = country_code; // create a cookie with the country code

    var inOneHourMinutes = new Date(new Date().getTime() + 60 * 1000);
    Cookies.set(self.country_popup_cookie_identifier + '-country_code', country_code, {
      expires: inOneHourMinutes
    });
    return country_code;
  };
  /**
   * Internal function for when calling done from a cookie state
   * @param  callback
   * @return object
   */


  countryPopup_plugin.prototype.done = function (callback) {
    // scope
    var self = this;

    if ((typeof calback === "undefined" ? "undefined" : _typeof(calback)) == "object") {
      callback(self.country_code);
    }

    return self;
  };
  /**
   * Render the country popup
   *
   * @return string country_code
   */


  countryPopup_plugin.prototype.renderCountryPopup = function () {
    // scope
    var self = this; // check country code is given

    if (self.country_code == '' || self.options.current_country_code == '') {
      return;
    } // guard: if the given country_Code is the same as the shop country code then skip!


    if (self.country_code == self.options.current_country_code) {
      return;
    }

    var countryData; // get the data by country code if available

    if (typeof self.options.popup_messages[self.country_code] != 'undefined') {
      countryData = self.options.popup_messages[self.country_code]; // if country option does not exists shop ROW
    } else if (typeof self.options.popup_messages['ROW'] != 'undefined') {
      countryData = self.options.popup_messages['ROW']; // guard: no country data to render
    } else {
      return;
    } // populate the wrapper with the country data


    $(self.country_popup_wrapper).find('[data-country-message-title]').text(countryData.country_title || '');
    $(self.country_popup_wrapper).find('[data-country-message-name-title]').text(countryData.country_name || '');
    $(self.country_popup_wrapper).find('[data-country-message-text]').text(countryData.country_body || '');
    $(self.country_popup_wrapper).find('[data-country-message-url]').attr("href", countryData.country_url || '');
    $(self.country_popup_wrapper).find('[data-country-message-label]').text(countryData.country_button || '');
    $(self.country_popup_wrapper).find('[data-country-message-stay]').val(countryData.country_stay || ''); // open fancybox

    self.fancybox.open(self.country_popup_wrapper, {
      afterClose: function afterClose() {
        self.closeCountryPopup();
      }
    }); // set enable cookie

    Cookies.set(self.country_popup_cookie_identifier, true, {
      expires: self.options.expires_in_days
    });
  };
  /**
   * Close country popup
   *
   * @return void
   */


  countryPopup_plugin.prototype.closeCountryPopup = function () {
    // scope
    var self = this;
    Cookies.set(self.country_popup_cookie_identifier, false, {
      expires: self.options.expires_in_days
    });
    self.fancybox.close();
  };
  /**
   * countryPopup plugin
   *
   * @return jQuery objects
   */


  $.fn.countryPopup = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new countryPopup_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE Filters
 ****************************************************************/

var storageUrlId = 'CodeFilterBackUrl';
!function ($, document, window, undefined) {
  /**
   * Plugin name
   *
   * @var string
   */
  var _pluginName = 'collectionFiltering';
  /**
   * Constructor collectionFiltering_plugin
   *
   * @param jQuery Element Wrapping container div
   * @return collectionFiltering_plugin
   */

  var collectionFiltering_plugin = function collectionFiltering_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.storagePanesId = false;
    self.storageUrlId = false; // Create local storage ID's

    if ($.code.localStorage) {
      self.storagePanesId = 'CodeFilterPanesState';
      self.storageUrlId = storageUrlId;
    } // Init


    self.init();
  };
  /**
   * init
   *
   * @access public
   * @return void
   */


  collectionFiltering_plugin.prototype.init = function () {
    var self = this; // Create ajax url from current url

    var path = window.location.pathname;
    path = path.substr(path.indexOf('collections'));
    var ajaxFilterUrl = "/" + path + '?view=filters-ajax';

    if ($.code.debug) {
      console.log('Filter init:', window.location.protocol + "//" + window.location.host + ajaxFilterUrl);
    } // Find the filter wrapper


    self.$filterWrapper = $('#filters [data-filter-wrapper]'); // Get filter data from ajax

    $.get(ajaxFilterUrl).done(function (dataReceived) {
      // Remove comments
      dataReceived = dataReceived.replace(/<!--[\s\S]*?-->/g, ""); // Render filters

      self.render(dataReceived);
    }); // Catch change of radio inputs

    self.$element.on('change', 'input[type="checkbox"]', function () {
      // uncheck all others in this list
      $(this).closest('[data-key-filter]').find('input[type="checkbox"]').not(this).prop('checked', false); // Update url url parameters.

      self.updateUrl();
    }); // catch click on 'remove a filter'.

    self.$element.on('click', '[data-remove-tag]', function (event) {
      event.preventDefault(); // uncheck the checkbox

      var removeTagValue = $(this).data('remove-tag');
      self.$element.find('.filter-pane input[type="checkbox"][value="' + removeTagValue + '"]').prop('checked', false); // update url

      self.updateUrl();
    }); // catch click on 'clear all'

    self.$element.on('click', '[data-filter-clear_all]', function (event) {
      event.preventDefault(); // uncheck all radio's

      self.$element.find('.filter-pane input[type="checkbox"]').prop('checked', false); // update url to nothing

      self.updateUrl();
    }); // If localstorage

    if ($.code.localStorage) {
      // Catch click on open/close filter panes
      self.$element.on('click', '[data-collapsible-trigger], [data-collapsible-trigger-icon]', function () {
        // get current state
        self.filterState = {};
        self.$element.find('[data-filter]').each(function (i, el) {
          var name = $(el).data('filter');
          self.filterState[name] = $(el).hasClass('collapsible__is-open');
        });
        self.$element.find('[data-filter-list]').each(function (i, el) {
          var name = $(el).data('filter-list');
          self.filterState[name] = $(el).hasClass('collapsible__is-open');
        }); // Store state in localstorage

        localStorage.setItem(self.storagePanesId, JSON.stringify(self.filterState));
      });
    }
  };
  /**
   * Render filters
   *
   * @access public
   * @return void
   */


  collectionFiltering_plugin.prototype.render = function (html) {
    var self = this;

    if ($.code.debug) {
      console.log('Filter data received:', $(html));
    }

    if (!$(html).children().length) {
      return;
    }

    var $filterHtml = $(html).children(); // get options from html

    self.options = $filterHtml.data('filter-options'); // Remove existing filters

    self.$filterWrapper.find('.filter-ajax').remove(); // Add filters html to pane

    self.$filterWrapper.append($filterHtml); // set state of collapsible panes from local storage

    self.setTabState(); // Show the element

    self.$element.find('.filter-load-wrapper:first').removeClass('filter-load-wrapper');
  };
  /**
   * Get state of Tabs
   *
   * @access public
   * @return void
   */


  collectionFiltering_plugin.prototype.setTabState = function () {
    var self = this; // Get tabs state from localstorage

    var backLinkData = localStorage.getItem(self.storagePanesId);

    if ($.code.localStorage && backLinkData) {
      self.filterState = JSON.parse(backLinkData); // Apply state to tabs

      $.each(self.filterState, function (name, isOpen) {
        var $pane = self.$element.find('[data-filter="' + name + '"]');

        if (name.indexOf('-list') > -1) {
          $pane = self.$element.find('[data-filter-list="' + name + '"]');
        }

        if (isOpen) {
          // Open the tab
          $pane.addClass('collapsible__is-open');
        } else {
          // Unless checked checkboxes
          if ($pane.find('input:checked').length > 0) {
            $pane.addClass('collapsible__is-open');
          } else {
            // Close the tab
            $pane.removeClass('collapsible__is-open');
          }
        }
      });
    }
  };
  /**
   * Update URL
   * Update the url with a given query.
   *
   * @access public
   * @return void
   */


  collectionFiltering_plugin.prototype.updateUrl = function () {
    var self = this; // Loop over the checked radios to build url Query

    var urlQuery = []; // loop all checked inputs

    self.$element.find('.filter-pane input[type="checkbox"]:checked').each(function () {
      var value = $(this).val();

      if (urlQuery.indexOf(value) === -1) {
        urlQuery.push(value);
      }
    });
    urlQuery = urlQuery.join('+'); // Create path from current url

    var path = window.location.pathname;
    path = path.substr(path.indexOf('collections'));
    var paths = path.split("/");
    var page = 1;
    var current_page = getParameterByName('page');

    if (current_page != page) {
      page = current_page;
    }

    var view = 'grid';
    var current_view = getParameterByName('view');

    if (current_view != view) {
      view = current_view;
    }

    var sort_by = 'grid';
    var current_sort_by = getParameterByName('sort_by');

    if (current_sort_by != sort_by) {
      sort_by = current_sort_by;
    }

    if ($.code.localStorage) {
      // Store Url in storage so the Product Detail Page Back link can use it
      localStorage.setItem(self.storageUrlId, JSON.stringify({
        url: urlQuery,
        collection: paths[1],
        page: page,
        view: view,
        sort_by: sort_by
      }));
    } // create new url


    var filterUrl = "/" + paths[0] + '/' + paths[1] + '/' + urlQuery; // add view and sort_by to url (ignore paging)

    filterUrl = self.addtoUrl(filterUrl, 'view', view);
    filterUrl = self.addtoUrl(filterUrl, 'sort_by', sort_by);

    if ($.code.debug) {
      console.log('Filter update Url:', window.location.protocol + "//" + window.location.host + filterUrl);
    }

    window.location.href = filterUrl;
  };
  /**
   * Add param to url
   *
   * @return {string} [url]
   */


  collectionFiltering_plugin.prototype.addtoUrl = function (url, param, val) {
    var q = '';

    if (val) {
      if (url.indexOf('?') < 0) {
        q = '?';
      } else {
        q = '&';
      }

      url += q + param + '=' + val;
    }

    return url;
  };
  /**
   * collectionFiltering plugin
   *
   * @return jQuery objects
   */


  $.fn.collectionFiltering = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new collectionFiltering_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
$(document).ready(function () {
  // Init filters
  $('#filters').collectionFiltering(); // Get filter url data

  var backLinkData = localStorage.getItem(storageUrlId);

  if (backLinkData) {
    backLinkData = JSON.parse(backLinkData); // Find backlink on product detail page

    var $backLink = $('[data-filter="backlink"]'); // if we are on product detail page

    if ($backLink.length) {
      var backUrl = $backLink.attr('href');
      var backUrlCollection = backUrl.replace('/collections/', ''); // If backlink goes to the collection we filtered last time, apply the filtering and paging to the url

      if (backUrlCollection == backLinkData.collection) {
        var pager = '';

        if (backLinkData.page > 1) {
          pager = '?page=' + backLinkData.page;
        } // change url of product backlink to include the filter parameters


        $backLink.attr('href', '/' + backLinkData.url + pager);
      }
    }
  } // if we are on a collection page


  if ($('#filters').length) {
    var current_page = getParameterByName('page') || 1; // if data exists

    if (backLinkData) {
      // get page from data
      var page = parseInt(backLinkData.page); // if we changed page

      if (current_page != page) {
        // Store Url in storage so the Product Detail Page Back link can use it
        localStorage.setItem(storageUrlId, JSON.stringify({
          url: backLinkData.url,
          collection: backLinkData.collection,
          page: current_page
        }));
      }
    } else {
      var path = window.location.pathname;
      path = path.substr(path.indexOf('collections'));
      var paths = path.split("/");
      var page_current = getParameterByName('page');
      var collection = paths[1]; // Store Url in storage so the Product Detail Page Back link can use it

      localStorage.setItem(storageUrlId, JSON.stringify({
        url: path,
        collection: collection,
        page: page_current
      }));
    }
  }
}).on('shopify:section:load', function (e) {
  var $parentSection = $('#shopify-section-' + e.detail.sectionId); // Filter: init

  if ($parentSection.hasClass('filter-section')) {
    $('#filters').collectionFiltering('init');
  }
});
/**
 * Minified by jsDelivr using UglifyJS v3.3.25.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */

!function (e) {
  var n = !1;

  if ("function" == typeof define && define.amd && (define(e), n = !0), "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && (module.exports = e(), n = !0), !n) {
    var o = window.Cookies,
        t = window.Cookies = e();

    t.noConflict = function () {
      return window.Cookies = o, t;
    };
  }
}(function () {
  function g() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e];

      for (var t in o) {
        n[t] = o[t];
      }
    }

    return n;
  }

  return function e(l) {
    function C(e, n, o) {
      var t;

      if ("undefined" != typeof document) {
        if (1 < arguments.length) {
          if ("number" == typeof (o = g({
            path: "/"
          }, C.defaults, o)).expires) {
            var r = new Date();
            r.setMilliseconds(r.getMilliseconds() + 864e5 * o.expires), o.expires = r;
          }

          o.expires = o.expires ? o.expires.toUTCString() : "";

          try {
            t = JSON.stringify(n), /^[\{\[]/.test(t) && (n = t);
          } catch (e) {}

          n = l.write ? l.write(n, e) : encodeURIComponent(String(n)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), e = (e = (e = encodeURIComponent(String(e))).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)).replace(/[\(\)]/g, escape);
          var i = "";

          for (var c in o) {
            o[c] && (i += "; " + c, !0 !== o[c] && (i += "=" + o[c]));
          }

          return document.cookie = e + "=" + n + i;
        }

        e || (t = {});

        for (var a = document.cookie ? document.cookie.split("; ") : [], s = /(%[0-9A-Z]{2})+/g, f = 0; f < a.length; f++) {
          var p = a[f].split("="),
              d = p.slice(1).join("=");
          this.json || '"' !== d.charAt(0) || (d = d.slice(1, -1));

          try {
            var u = p[0].replace(s, decodeURIComponent);
            if (d = l.read ? l.read(d, u) : l(d, u) || d.replace(s, decodeURIComponent), this.json) try {
              d = JSON.parse(d);
            } catch (e) {}

            if (e === u) {
              t = d;
              break;
            }

            e || (t[u] = d);
          } catch (e) {}
        }

        return t;
      }
    }

    return (C.set = C).get = function (e) {
      return C.call(C, e);
    }, C.getJSON = function () {
      return C.apply({
        json: !0
      }, [].slice.call(arguments));
    }, C.defaults = {}, C.remove = function (e, n) {
      C(e, "", g(n, {
        expires: -1
      }));
    }, C.withConverter = e, C;
  }(function () {});
});
/****************************************************************
 * CODE mediaAccordion
 ****************************************************************/

/**
 * Keeps a Swiper gallery and an accordion in sync in both directions:
 * opening a row slides its paired slide into view, and changing slide opens the
 * paired row. Exactly one row is open at a time.
 *
 * This does not own the Swiper or the collapsible. swiperLoader still owns the
 * gallery and collapsible still owns open/close; this only wires the two
 * together, so their own behaviour (arrows, bullets, swipe, animation) is
 * unchanged.
 *
 * Expected markup (see snippets/media-accordion.liquid):
 *
 *   [data-media-accordion]
 *     [data-swiper]                                   <- swiperLoader
 *       .swiper-container > .swiper-wrapper
 *         .swiper-slide[data-media-accordion-slide="0"]
 *     [data-collapsible-wrapper]                      <- collapsible
 *       [data-collapsible-parent][data-media-accordion-slide="0"]
 *
 * Pairing is by the explicit data-media-accordion-slide index rather than DOM
 * order, because a block can produce a row without a slide (a title but no
 * image). Such a row never moves the gallery, but it does still close the others.
 *
 * Two details of collapsible drive the design here:
 *
 *   - It only toggles `collapsible__is-open` inside its animation callback, so
 *     for the length of the animation the class does not reflect the row's real
 *     state. Anything reading it has to consider `:animated` too.
 *   - A row's `collapsibleOpen` reaches handlers bound to the row (this plugin)
 *     before it bubbles to the wrapper where collapsible acts on it, so this
 *     plugin must not open a row in response to that row's own event.
 */

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'mediaAccordion';
  var SLIDE_ATTR = 'data-media-accordion-slide';
  var OPEN_CLASS = 'collapsible__is-open';
  /**
   * @param jQuery Element Wrapping container div
   * @return mediaAccordion_plugin
   */

  var mediaAccordion_plugin = function mediaAccordion_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element;
    self.$gallery = $element.find('[data-swiper]').first(); // Every row, and the subset that is paired with a slide. A block with a
    // title but no image produces an unpaired row: it cannot move the gallery,
    // but it still has to take part in "only one row open at a time".

    self.$allRows = $element.find('[data-collapsible-parent]');
    self.$rows = self.$allRows.filter('[' + SLIDE_ATTR + ']'); // Index of the row currently treated as open. Single source of truth.

    self.currentIndex = null; // True while setIndex is applying a change, so the collapsibleOpen and
    // slideChange it causes are ignored instead of re-entering.

    self.isSyncing = false;

    if ($.code.debug) {
      console.log('Init mediaAccordion:', self.$element, 'rows:', self.$rows.length);
    } // Nothing to sync without a gallery and at least two paired rows.


    if (!self.$gallery.length || self.$rows.length < 2) {
      return;
    }

    self.init();
  };
  /**
   * Get the Swiper instance owned by swiperLoader
   *
   * @return Swiper|null
   * @access public
   */


  mediaAccordion_plugin.prototype.getSwiper = function () {
    var self = this;
    var instance = self.$gallery.data('plugin_swiperLoader');
    return instance ? instance.swiperInst : null;
  };
  /**
   * Slide index paired with a row
   *
   * @return number
   * @access public
   */


  mediaAccordion_plugin.prototype.indexOfRow = function ($row) {
    return parseInt($row.attr(SLIDE_ATTR), 10);
  };
  /**
   * Row paired with a slide index
   *
   * @return jQuery object
   * @access public
   */


  mediaAccordion_plugin.prototype.rowForIndex = function (index) {
    var self = this;
    return self.$rows.filter('[' + SLIDE_ATTR + '="' + index + '"]').first();
  };
  /**
   * Position of a paired index in Swiper's slide list.
   *
   * Read from the markup rather than assumed to equal the index, so the pairing
   * survives Swiper adding or reordering slides.
   *
   * @return number  -1 when the index has no slide
   * @access public
   */


  mediaAccordion_plugin.prototype.slidePositionForIndex = function (index) {
    var self = this;
    var swiper = self.getSwiper();

    if (!swiper || !swiper.slides) {
      return -1;
    }

    for (var position = 0; position < swiper.slides.length; position++) {
      if ($(swiper.slides[position]).attr(SLIDE_ATTR) === String(index)) {
        return position;
      }
    }

    return -1;
  };
  /**
   * Paired index of a position in Swiper's slide list
   *
   * @return number  NaN when the slide is not paired
   * @access public
   */


  mediaAccordion_plugin.prototype.indexForSlidePosition = function (position) {
    var self = this;
    var swiper = self.getSwiper();

    if (!swiper || !swiper.slides || !swiper.slides[position]) {
      return NaN;
    }

    return parseInt($(swiper.slides[position]).attr(SLIDE_ATTR), 10);
  };
  /**
   * Is a row open, or on its way to being open?
   *
   * collapsible only adds and removes `collapsible__is-open` inside its
   * animation callback, so for the length of the animation a row that is
   * opening still has no class and a row that is closing still has one. Reading
   * the class alone therefore misses rows that are mid-flight, which is what
   * allowed two rows to end up open at once: a row that was still opening was
   * skipped by "close the others", then finished and added its class.
   *
   * @return boolean
   * @access public
   */


  mediaAccordion_plugin.prototype.isRowActive = function ($row) {
    var $target = $row.find('> [data-collapsible-target]').first();
    return $row.hasClass(OPEN_CLASS) || $target.is(':animated');
  };
  /**
   * Collapse every row except one.
   *
   * Only rows that are open or opening are touched. Skipping the ones that are
   * genuinely closed matters: collapsible's close() sets max-height to the
   * measured height before animating it to 0, so closing an already-closed row
   * flashes it open.
   *
   * @return void
   * @access public
   */


  mediaAccordion_plugin.prototype.closeOtherRows = function ($row) {
    var self = this;
    self.$allRows.not($row).each(function () {
      var $other = $(this);

      if (self.isRowActive($other)) {
        $other.trigger('collapsibleClose');
      }
    });
  };
  /**
   * Align the gallery with an index, if it is not already there
   *
   * @return void
   * @access public
   */


  mediaAccordion_plugin.prototype.goToIndex = function (index, speed) {
    var self = this;
    var swiper = self.getSwiper();

    if (!swiper) {
      return;
    }

    var position = self.slidePositionForIndex(index);

    if (position < 0 || position === swiper.activeIndex) {
      return;
    }

    self.$gallery.swiperLoader('goToSlide', position, speed);
  };
  /**
   * Move both the accordion and the gallery to an index.
   *
   * Both directions funnel through here. Two things keep them from feeding each
   * other: the no-op when the index has not changed, and `isSyncing`. Opening a
   * row and moving the gallery both fire the events this plugin listens to, and
   * both fire synchronously from inside this method, so the flag swallows the
   * echo. Without it a re-entrant call could reach `goToIndex` with a stale
   * index and send the gallery back a slide.
   *
   * @param number  index
   * @param number  speed         transition speed, defaults to the gallery's
   * @param boolean isRowOpening  true when the caller is reacting to the row
   *                              already being opened by collapsible, so this
   *                              must not open it a second time
   * @return void
   * @access public
   */


  mediaAccordion_plugin.prototype.setIndex = function (index, speed, isRowOpening) {
    var self = this;

    if (isNaN(index) || index === self.currentIndex || self.isSyncing) {
      return;
    } // An unpaired slide (a block with an image but no title) has no row. Leave
    // the accordion untouched and keep currentIndex where it was.


    var $row = self.rowForIndex(index);

    if (!$row.length) {
      return;
    }

    self.isSyncing = true;
    self.currentIndex = index;
    self.closeOtherRows($row); // Only open the row when something other than the row itself started this.
    // A row's own collapsibleOpen reaches this plugin before it bubbles to
    // collapsible, so triggering it again here would open it twice. Re-opening a
    // row that is already fully open is worse than redundant: with no inline
    // max-height, open() animates down from the CSS fallback (10000px) to the
    // measured height, which reads as a jump.

    if (!isRowOpening && !self.isRowActive($row)) {
      $row.trigger('collapsibleOpen');
    }

    self.goToIndex(index, speed);
    self.isSyncing = false;
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */


  mediaAccordion_plugin.prototype.init = function () {
    var self = this; // Adopt the starting row: whichever is flagged "Open by default", else the
    // first paired one. Any other row that starts open in the markup has its
    // class stripped rather than being animated closed, because it was never
    // opened by the user and there is nothing to animate from.

    var $start = self.$rows.filter('.' + OPEN_CLASS).first();

    if (!$start.length) {
      $start = self.$rows.first();
    }

    self.$allRows.not($start).removeClass(OPEN_CLASS);
    self.currentIndex = self.indexOfRow($start); // Set up before the listeners are attached, so none of this echoes back.

    if (!$start.hasClass(OPEN_CLASS)) {
      $start.trigger('collapsibleOpen');
    }

    self.goToIndex(self.currentIndex, 0); // Accordion -> gallery. Listening on the collapsible's own event rather
    // than a click covers the trigger, the chevron icon and programmatic opens.
    // collapsible opens the row itself, hence isRowOpening.

    self.$allRows.on('collapsibleOpen', function () {
      var $row = $(this);
      var index = self.indexOfRow($row); // An unpaired row still collapses the others, but leaves the gallery
      // alone -- it has no slide to show. currentIndex is cleared so the next
      // slide change or paired row is not mistaken for a no-op.

      if (isNaN(index)) {
        self.closeOtherRows($row);
        self.currentIndex = null;
        return;
      }

      self.setIndex(index, undefined, true);
    }); // Gallery -> accordion. Covers arrows, pagination bullets and swipes.

    var swiper = self.getSwiper();

    if (swiper) {
      swiper.on('slideChange', function () {
        self.setIndex(self.indexForSlidePosition(swiper.activeIndex));
      });
    }
  };
  /**
   * mediaAccordion plugin
   *
   * @return jQuery objects
   */


  $.fn.mediaAccordion = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new mediaAccordion_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
  /**
   * Re-init after the Shopify theme editor swaps a section's markup.
   *
   * The editor replaces the section element wholesale when blocks are added,
   * reordered or removed, which throws away the instance stored on the old
   * node. The new node carries no guard data, so this is a fresh init rather
   * than a double one. Outside the theme editor these events never fire.
   */


  $(document).on('shopify:section:load', function (event) {
    $('[data-media-accordion]', event.target).mediaAccordion();
  });
}(jQuery, document, window);
/****************************************************************
 * CODE product
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'product';
  /**
   * @param jQuery Element Wrapping container div
   * @return product_plugin
   */

  var product_plugin = function product_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Create product Options

    var defaultOptions = {
      onMasterSelectChange: {
        updateSpecs: true,
        // On variant change, update the specs
        updateVariantImagesInSwiper: true,
        // On variant change, show the image of the variant
        triggerOnPageLoad: true // Trigger a variant change when the PDP is loaded with a variant parameter to show the image of the variant

      },
      easyzoom: {
        loadingNotice: "",
        errorNotice: ""
      },
      fancybox: {
        hash: false,
        backFocus: false,
        baseClass: "product-detail-popup",
        thumbs: {
          autoStart: true,
          hideOnClose: true
        }
      }
    };
    var metaOptions = self.$element.data('product-options');
    self.options = $.extend({}, defaultOptions, metaOptions);

    if ($.code.debug) {
      console.log('Init product:', self.$element, self.options);
    }

    self.$element.find('[data-product="form"]').each(function () {
      var $form = $(this); // find quantity element

      var $quantityInput = $form.find('[data-product="quantity"]'); // find min quantity

      var currentQuantity = parseInt($quantityInput.val());
      var currentQuantityMax = $quantityInput.data("productQuantityMax"); // catch blur of quantity

      $form.on('input', '[data-product="quantity"]', function (event) {
        currentQuantity = parseInt($quantityInput.val()); // if quantity is to little

        if (currentQuantity < 1) {
          currentQuantity = 1;
        }

        if (currentQuantity > currentQuantityMax) {
          currentQuantity = currentQuantityMax;
          $('.quantity-error').removeClass('is-hidden');
        }

        $quantityInput.val(currentQuantity).trigger('change');
      }); // catch click on plus

      $form.on('click', '[data-product="plus"]', function (event) {
        event.preventDefault();
        currentQuantity += 1;

        if (currentQuantity > currentQuantityMax) {
          currentQuantity = currentQuantityMax;
          $('.quantity-error').removeClass('is-hidden');
        }

        $quantityInput.val(currentQuantity).trigger('change');
      }); // catch click on minus

      $form.on('click', '[data-product="minus"]', function (event) {
        event.preventDefault();
        currentQuantity -= 1;

        if (currentQuantity < 1) {
          currentQuantity = 1;
        }

        $quantityInput.val(currentQuantity).trigger('change');
      });
    }); // Get elements

    self.productImagesSwiper = $('.product-images-slider');
    self.productImagesSwiperNav = $('.product-images-slider-nav');
    self.$specsWrapper = self.$element.find('[data-product-specs-wrapper]');
    self.$specs = self.$element.find('[data-product-specs]');
    self.specs_data = self.$specs.data('product-specs'); // Check compare price to conditionally load savings and sale badges if offer is variant specific

    var comp_price = $('[data-compare-price]').first().text().trim();

    if (comp_price === '') {
      $('[data-savings-badge]').addClass('hide');
    }

    if (self.productImagesSwiper.length) {
      // Init product Swipers
      self.initProductSwipers();

      if ($('.product-images-slider-sale').length > -1 && comp_price !== '') {
        $('.product-images-slider-sale').find('.swiper-slide').first().find('figure').before('<span class="offer-sale" data-pdp-img-sale-badge>' + saleLabel + '</span>');
      } // $('.product-images-slider-sale').find('.swiper-slide').first().find('figure').before('<span class="offer-sale">sale</span>');

    } else {
      if ($('.product-images-slider-sale').length > -1) {
        $('.product-images-slider-sale figure').before('<span class="offer-sale" data-pdp-img-sale-badge>' + saleLabel + '</span>');
      } // Init productzoom on product image


      self.initProductZoom(); // Init productzoom popup gallery

      self.initProductFancyboxGallery();
    } // Capture masterSelectChange from slate variants.js


    self.$element.on('masterSelectChange', function (event) {
      if ($.code.debug) {
        console.log('masterSelectChange:', event.variant);
      } // Get variant id from event


      var variant_id = event.variant.id; // Update the specs

      if (self.options.onMasterSelectChange.updateSpecs) {
        self.updateSpecs(variant_id);
      } // Tell slideshow to go to slide i


      if (self.options.onMasterSelectChange.updateVariantImagesInSwiper) {
        self.goToVariant(variant_id);
      } // Toggle Sale badge if not all variants are on sale


      if (!(event.variant.compare_at_price > event.variant.price)) {
        $('.product-images-slider-sale').find('.offer-sale').addClass('hide');
      }
    });
    var amazonLink = self.$element.find('[data-amazon-link]');
    var nostockMessage = self.$element.find('.product__nostock-text--show');

    if (nostockMessage.length) {
      nostockMessage.show();
    }
  };
  /**
   * Init the product zoom
   *
   * @return void
   * @access public
   */


  product_plugin.prototype.initProductZoom = function () {
    var self = this; // Init easyzoom

    self.$element.find('[data-product-easy-zoom]').each(function () {
      $(this).easyZoom(self.options.easyzoom);
    });
  };
  /**
   * Update Product Specs
   *
   * @return void
   * @access public
   */


  product_plugin.prototype.updateSpecs = function (currentVariantId) {
    var self = this;

    if (!self.$specs.length || !self.specs_data.specs || !self.specs_data.row_template || !self.specs_data.divider) {
      return;
    } // Loop the specs


    $.each(self.specs_data.specs, function (index, value) {
      var variantSpecs = value.split(self.specs_data.divider);
      var variantId = variantSpecs[0].split(':')[1];

      if (variantId == currentVariantId) {
        var rowHtml = self.specs_data.row_template;
        var specHtml = ''; // Loop the specs to create html from the template

        $.each(variantSpecs, function (i, specs) {
          var pair = variantSpecs[i];
          var key = pair.split(':')[0];
          var value = pair.split(':')[1]; // Skip the variant ID

          if (key == 'variant_id') {
            return;
          }

          specHtml = specHtml + rowHtml.replace('[key]', key).replace('[value]', value);
        }); // Insert the html

        self.$specs.html(specHtml); // break the loop

        return false;
      }
    });
  };
  /**
   * Init the product fancybox Image popup slideshow
   *
   * @return void
   * @access public
   */


  product_plugin.prototype.initProductFancyboxGallery = function () {
    ;
    var self = this; // Init fancybox on all Product images, except for slide duplicates

    self.$element.find("[data-fancybox]").not('.swiper-slide-duplicate [data-fancybox]').fancybox(self.options.fancybox);
  };
  /**
   * Init the product slideshow
   *
   * @return void
   * @access public
   */


  product_plugin.prototype.initProductSwipers = function () {
    var self = this;
    var swiperOptions = {}; // If thumbnails must be a swiper

    if (typeof self.productImagesSwiperNav.data('swiper-options') != 'undefined') {
      // Init thumbnail Swiper
      self.productImagesSwiperNav.swiperLoader(); // Get the thumbnail Swiper Instance

      var productImagesSwiperNavInstance = self.productImagesSwiperNav.find('.swiper-container:first')[0].swiper; // Set thumbnail instance as thumbs in options for Product image Swiper

      swiperOptions = {
        thumbs: {
          swiper: productImagesSwiperNavInstance
        }
      };
    } else {
      // Find all thumbnails
      var $thumbs = self.productImagesSwiperNav.find('[data-product-thumb]'); // Catch click on a thumbnail

      self.productImagesSwiperNav.on('click', '[data-product-thumb]', function () {
        var slideIndex = $thumbs.index($(this)); // Tell Product images Swiper to show that image

        self.productImagesSwiper.swiperLoader('goToSlide', slideIndex);
      });
    } // Init Product images Swiper


    self.productImagesSwiper.swiperLoader(swiperOptions); // Get Swiper options for gotovariant

    self.swiperOptions = self.productImagesSwiper.data('swiper-options'); // Get the Product image Swiper Instance

    self.productImagesSwiperInstance = self.productImagesSwiper.find('.swiper-container:first')[0].swiper; // If the PDP is loaded with a variant parameter, show the image of the variant

    if (self.options.onMasterSelectChange.triggerOnPageLoad && window.location.href.indexOf('variant') === -1 && typeof alarmPack === 'undefined') {
      // Find the current variant
      var sel = document.querySelector('[name="id"]');
      var currentVariantId = sel.options[sel.selectedIndex].value;
      var allVariants = self.$element.find('[name="id"]')[0].childElementCount;

      if (allVariants > 1) {
        self.goToVariant(currentVariantId, 0);
      }
    } // Init productzoom on product image


    self.initProductZoom(); // Init productzoom popup gallery

    self.initProductFancyboxGallery();
  };
  /**
   * Slideshow GoToVariant
   *
   * @return void
   * @access public
   */


  product_plugin.prototype.goToVariant = function (variantId, speed) {
    var self = this;

    if (typeof self.productImagesSwiperInstance == 'undefined') {
      return;
    }
    /*
      * Search all thumbs and slides in a hidden dom element
      * parse the ones matching the current variant ID them into an array
      * Shoot array to function to reload the slider with new images
    */


    var $thumbnails = $('.js-all-thumbs').find('[data-product-thumb]');
    var newThumbs = [];
    $thumbnails.each(function () {
      var id = $(this).data('product-variant-image');
      var thumbHTML = $(this)[0].outerHTML; // If this slide has the variantId

      if (id == variantId) {
        newThumbs.push(thumbHTML);
      }
    });
    self.productImagesSwiperNav.swiperLoader('newSlides', newThumbs); // Find all slides in a hidden dom element

    var $mainImages = $('.js-all-slides').find('[data-product-variant-image]');
    var newSlides = [];
    $mainImages.each(function () {
      var id = $(this).data('product-variant-image');
      var slideHTML = $(this)[0].outerHTML; // If this slide has the variantId

      if (id == variantId) {
        newSlides.push(slideHTML);
      }
    });
    self.productImagesSwiper.swiperLoader('newSlides', newSlides);
    self.initProductZoom();
  };
  /**
   * product plugin
   *
   * @return jQuery objects
   */


  $.fn.product = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new product_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  }; // EMWA form code to handle a small UX hack


  $('.newsletter-section .contact-form').submit(function (event) {
    var $contact_input = $('.newsletter__input');
    var $product_handle = $('.contact-form__product-handle').val().replaceAll(' ', '-').replaceAll(',', '').replaceAll('(', '').replaceAll(')', '');
    var $replace_content = '+' + $product_handle + '@';
    var $input_val = $contact_input.val().replace('@', $replace_content);
    $contact_input.val($input_val).addClass('is-sending');
    return true;
  });
}(jQuery, document, window);
/****************************************************************
 * CODE relatedProducts
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'relatedProducts';
  /**
   * @param jQuery Element Wrapping container div
   * @return relatedProducts_plugin
   */

  var relatedProducts_plugin = function relatedProducts_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element;
    self.xhrCount = 0; // Set default options

    var defaults = {
      view: 'product-related',
      // view for liquid files collection.product-related.liquid and product.product-related.liquid
      max: 5,
      // max products
      currentHandle: '',
      // handle of the current product
      relatedMetaHandles: '',
      // array of product handles
      relatedSameCollectionHandles: '',
      // array of product handles
      relatedPrimaryTag: '',
      // tag to filter primary collection
      relatedPrimaryCollection: '',
      // primary collection handle
      relatedSecondaryTag: '',
      // tag to filter secondary collection
      relatedSecondaryCollection: '',
      // secondary collection handle
      columnClasses: '',
      // classes for no-slider columns
      wrapper: '' // jQuery selector to show hide wrapper

    }; // Get options from html element

    var metaOptions = self.$element.data('relatedProducts');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log(self.options);
    }

    ; // Create the ajax url for the Primary collection
    // This uses collection.product-related.liquid

    if (self.options.relatedPrimaryCollection != '' && self.options.relatedPrimaryTag != '') {
      self.options.relatedPrimaryCollectionUrl = '/collections/' + self.options.relatedPrimaryCollection + '/' + self.options.relatedPrimaryTag + '?view=' + self.options.view;
    } // Create the ajax url for the Secondary collection
    // This uses collection.product-related.liquid


    if (self.options.relatedSecondaryCollection != '' && self.options.relatedSecondaryTag != '') {
      self.options.relatedSecondaryCollectionUrl = '/collections/' + self.options.relatedSecondaryCollection + '/' + self.options.relatedSecondaryTag + '?view=' + self.options.view;
    } // Create array for Metafield related products


    var relatedProducts_Metafield = [];

    if (Array.isArray(self.options.relatedMetaHandles)) {
      relatedProducts_Metafield = self.options.relatedMetaHandles;
    } // Create array for products from the same collection (without tag filtering)


    var relatedProducts_SameCollection = [];

    if (Array.isArray(self.options.relatedSameCollectionHandles)) {
      relatedProducts_SameCollection = self.options.relatedSameCollectionHandles;
    }

    var ajax1, ajax2; // Get an array of collection products filtered by relatedPrimaryTag (only first 1000 of this collection)

    if (typeof self.options.relatedPrimaryCollectionUrl != 'undefined') {
      ajax1 = $.ajax(self.options.relatedPrimaryCollectionUrl);
    } // Get an array of all products filtered by tag (only first 1000 of all_products)


    if (typeof self.options.relatedSecondaryCollectionUrl != 'undefined') {
      ajax2 = $.ajax(self.options.relatedSecondaryCollectionUrl);
    }

    if ($.code.debug) {
      console.log('Init relatedProducts:', self.$element, self.options);
    } // Find wrapper element


    self.$wrapper = $(self.options.wrapper);
    self.$container = self.$element.find('[data-related-products-container]');

    if (!self.$wrapper.length) {
      self.$wrapper = self.$element;
    }

    $.when(ajax1, ajax2).done(function (a1, a2) {
      var relatedProducts_PrimaryCollection = [];
      var relatedProducts_SecondaryCollection = [];

      if (typeof a1 != 'undefined') {
        relatedProducts_PrimaryCollection = a1[0].split(',');
      }

      if (typeof a2 != 'undefined') {
        relatedProducts_SecondaryCollection = a2[0].split(',');
      } // Concat all arrays and remove duplicates


      var relatedProductHandles = [].concat(relatedProducts_Metafield, relatedProducts_PrimaryCollection, relatedProducts_SecondaryCollection, relatedProducts_SameCollection); // Make the product handles unique, regardless of the collection prefix

      var relatedProductHandles_unique = [];
      var testArr = [];
      $.each(relatedProductHandles, function (index, handle) {
        var shortHandle = handle; // Remove collection prefix from handle

        if (handle.indexOf('|') > -1) {
          var res = handle.split('|');
          shortHandle = res[1];
        } // if shortHandle is not in testarray and not the current product


        if ($.inArray(shortHandle, testArr) == -1 && shortHandle !== self.options.currentHandle) {
          // Add shortHandle to testarray
          testArr.push(shortHandle); // Add real handle to unique array

          relatedProductHandles_unique.push(handle);
        }
      }); // Remove products > max items

      var relatedProductHandles_arr = relatedProductHandles_unique.slice(0, self.options.max);

      if ($.code.debug) {
        console.log('relatedProducts_Metafield ' + self.options.wrapper, relatedProducts_Metafield);
        console.log('relatedProducts_PrimaryCollection ' + self.options.wrapper, self.options.relatedPrimaryCollectionUrl, relatedProducts_PrimaryCollection);
        console.log('relatedProducts_SecondaryCollection ' + self.options.wrapper, self.options.relatedSecondaryCollectionUrl, relatedProducts_SecondaryCollection);
        console.log('relatedProducts_SameCollection ' + self.options.wrapper, relatedProducts_SameCollection);
        console.log('relatedProductHandles ' + self.options.wrapper, relatedProductHandles_arr);
      } // create empty array to hold our items


      var responseArray = []; // map product urls to array

      var productsArray = $.map(relatedProductHandles_arr, function (handle, i) {
        var collectionHandle = 'all';
        var shortHandle = handle; // Split the collection|product_handle

        if (handle.indexOf('|') > -1) {
          var res = handle.split('|');
          collectionHandle = res[0];
          shortHandle = res[1];
        }

        var productUrl = '/collections/' + collectionHandle + '/products/' + shortHandle; // Store the relation

        var relation = '';

        if ($.inArray(handle, relatedProducts_SecondaryCollection) > -1) {
          relation = 'secondary collection';
        }

        if ($.inArray(handle, relatedProducts_PrimaryCollection) > -1) {
          relation = 'primary collection';
        }

        if ($.inArray(handle, relatedProducts_SameCollection) > -1) {
          relation = 'same collection';
        }

        if ($.inArray(handle, relatedProducts_Metafield) > -1) {
          relation = 'metafield';
        } // Related product original object


        return {
          index: i,
          collectionHandle: collectionHandle,
          relation: relation,
          url: productUrl
        };
      }); // create deferred ajax request to pass product urls to

      var ajax_request = function ajax_request(product) {
        var deferred = $.Deferred();
        $.ajax({
          url: product.url + '?view=' + self.options.view,
          success: function success(data) {
            // mark the ajax call as completed
            deferred.resolve(data).done(function (data) {
              // Related product response/final object
              responseArray[product.index] = {
                index: product.index,
                collectionHandle: product.collectionHandle,
                relation: product.relation,
                html: data
              };

              if ($.code.debug) {
                console.log(data);
              }

              ;
            });
          },
          error: function error(_error) {
            // mark the ajax call as completed
            deferred.reject(_error);
          }
        });
        return deferred.promise();
      }; // define looper


      var looper = $.Deferred().resolve(); // go through each product url and call the ajax function

      $.when.apply($, $.map(productsArray, function (product, i) {
        looper = looper.then(function () {
          // trigger ajax call with product data
          return ajax_request(product);
        });
        return looper;
      })).done(function () {
        // All ajax calls have completed
        if ($.code.debug) {
          console.log('Related products original array', productsArray);
          console.log('Related products ajax response array', responseArray);
        } // empty the container


        self.$container.empty();

        for (var index = 0; index < responseArray.length; index++) {
          var element = responseArray[index];

          if (typeof element != 'undefined') {
            // Create element
            var $element = $(element.html).attr('data-related-by', element.relation); // Add to container

            self.$container.append($element);
          }
        }

        self.render(); // add .active class to the current product block

        var currenProductHandle = window.location.href.split('/products/')[1];
        setTimeout(function () {
          $('[data-handle="' + currenProductHandle + '"]').addClass('active');
        }, 2000);
      });
    });
  };
  /**
   * Render products
   *
   * @return void
   * @access public
   */


  relatedProducts_plugin.prototype.render = function () {
    var self = this;

    if (self.$container.children().length > 0) {
      // Show the wrapper
      self.$wrapper.show();
    } else {
      // Hide the wrapper
      self.$wrapper.remove();
      return;
    } // Init Swiper


    var $swiperWrapper = self.$container.closest('[data-swiper-options]');

    if ($swiperWrapper.length) {
      // Add classes
      self.$container.children().addClass('swiper-slide'); // Start swiper

      $swiperWrapper.swiperLoader();
    } else {
      self.$container.children().addClass(self.options.columnClasses);
    }
  };
  /**
   * relatedProducts plugin
   *
   * @return jQuery objects
   */


  $.fn.relatedProducts = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new relatedProducts_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE enhancedSearch
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'enhancedSearch';
  /**
   * @param jQuery Element Wrapping container div
   * @return enhancedSearch_plugin
   */

  var enhancedSearch_plugin = function enhancedSearch_plugin($element, options) {
    // Scope it
    var self = this; // Find elements

    self.$element = $element;
    self.$input = self.$element.find('input[type="search"]');
    self.type = self.$element.data('enhanced-search'); // Set options

    var defaults = {
      wildcard: true,
      livesearch: true,
      show_all: "See all results"
    };
    var metaOptions = self.$element.data('enhanced-search');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init Enhanced Search:', self.$element, self.options);
    }

    if (self.options.wildcard) {
      self.initWildcard();
    }

    if (self.options.livesearch) {
      self.initLiveSearch();
    }
  };
  /**
   * Search with product dropdown
   */


  enhancedSearch_plugin.prototype.initLiveSearch = function () {
    var self = this; // Current Ajax request.

    var currentAjaxRequest = null; // Grabbing text input.

    var $input = self.$element.find('input[name="q"]'); // Create a list

    var $dropdown = $('<ul class="search-dropdown-results" data-enhanced-search="results"></ul>'); // Adding a list for showing search results.

    $($dropdown).appendTo(self.$element); // Listening to keyup and change on the text field within these search forms.

    $input.attr('autocomplete', 'off').on('keyup change', function () {
      // What are the search terms
      var terms = self.$element.serialize().replace('+', '*+') + '*'.trim(); // Create search URL

      var searchURL = '/search?' + terms; // If that's a new term and it contains at least 2 characters.

      if (terms.length > 2 && terms != $input.attr('data-old-terms')) {
        // Saving old query.
        $input.attr('data-old-terms', terms); // Killing any Ajax request that's currently being processed.

        if (currentAjaxRequest != null) currentAjaxRequest.abort(); // Pulling results.

        currentAjaxRequest = $.getJSON(searchURL + '&view=json', function (data) {
          // Reset results.
          $dropdown.empty(); // If we have no results.

          if (data.results_count == 0) {
            self.closeDropdown();
          } else {
            // If we have results.
            $.each(data.results, function (index, item) {
              var link = $('<a></a>').attr('href', item.url);

              if (item.image != '') {
                link.append('<span class="thumbnail"><img src="' + item.image + '" /></span>');
              } else {
                link.append('<span class="thumbnail no-image"></span>');
              }

              link.append('<span class="title">' + item.title + '</span>');
              link.wrap('<li></li>');
              $dropdown.append(link.parent());
            });
            $dropdown.append('<li class="search-show_all"><a href="' + searchURL + '">' + self.options.show_all + ' (' + data.results_count + ')</a></li>');
            self.openDropdown();
          }
        });
      }
    });
    $input.keydown(function (e) {
      if (!self.dropdownVisible) {
        // on key arrow down and if results are filled
        if (e.which == 40 && self.$element.find('[data-enhanced-search="results"]').children().length) {
          self.openDropdown();
        } else {
          return;
        }
      }

      var i = $dropdown.find('.is-active').index();

      switch (e.which) {
        case 38:
          // up
          i--;
          break;

        case 40:
          // down
          i++;
          break;

        case 27:
          self.closeDropdown();
          break;

        case 13:
          // enter
          if ($dropdown.find('li.is-active').length) {
            e.preventDefault();
            var url = $dropdown.find('li.is-active a').attr('href');
            document.location.href = url;
          }

          break;

        default:
          return;
        // exit this handler for other keys
      }

      $dropdown.find('li:eq(' + i + ')').addClass('is-active').siblings('.is-active').removeClass('is-active'); // e.preventDefault(); // prevent the default action (scroll / move caret)
    }); // Clicking outside makes the results disappear.

    $('body').on('click', function () {
      self.closeDropdown();
    });
  };
  /**
   * Open livesearch dropdown
   */


  enhancedSearch_plugin.prototype.openDropdown = function () {
    var self = this;
    self.$element.find('[data-enhanced-search="results"]').addClass('search-dropdown__is-open');
    self.dropdownVisible = true;
  };
  /**
   * Close livesearch dropdown
   */


  enhancedSearch_plugin.prototype.closeDropdown = function () {
    var self = this;
    self.$element.find('[data-enhanced-search="results"]').removeClass('search-dropdown__is-open');
    self.dropdownVisible = false;
  };
  /**
   * search with automatic Wildcard
   */


  enhancedSearch_plugin.prototype.initWildcard = function () {
    var self = this; // on submit form

    self.$element.on('submit', function (e) {
      if ($.code.debug) {
        console.log('Enhanced Search:', self.type);
      } // prevent default


      e.preventDefault(); // What are the search terms

      var terms = self.$element.serialize(); // prevent double **

      if (terms.indexOf('*') == -1) {
        terms = terms.replace('+', '*+') + '*'.trim();
      } // submit form


      location.href = '/search?' + terms;
    });
  };
  /**
   * enhancedSearch plugin
   *
   * @return jQuery objects
   */


  $.fn.enhancedSearch = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new enhancedSearch_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE swiperLoader
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'swiperLoader';
  /**
   * @param jQuery Element Wrapping container div
   * @return swiperLoader_plugin
   */

  var swiperLoader_plugin = function swiperLoader_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element; // For more options, check https://idangero.us/swiper/api/

    var defaults = {
      loop: false,
      initialSlide: 0,
      // Index number of initial slide.
      speed: 300,
      // Duration of transition between slides (in ms)
      direction: 'horizontal',
      // Could be 'horizontal' or 'vertical' (for vertical slider).
      autoHeight: false,
      // Set to true and slider wrapper will adopt its height to the height of the currently active slide
      roundLengths: true,
      // Set to true to round values of slides width and height to prevent blurry texts on usual resolution screens (if you have such)
      effect: 'slide',
      // Transition effect. Could be "slide", "fade", "cube", "coverflow" or "flip"
      spaceBetween: 0,
      // Distance between slides in px.
      slidesPerView: 1,
      // Number of slides per view (slides visible at the same time on slider's container).
      centeredSlides: false,
      // 	If true, then active slide will be centered, not always on the left side.
      centerInsufficientSlides: false,
      // When enabled it center slides if the amount of slides less than `slidesPerView`. Not intended to be used loop mode
      grabCursor: false,
      // This option may a little improve desktop usability. If true, user will see the "grab" cursor when hover on Swiper
      touchEventsTarget: 'wrapper',
      // Target element to listen touch events on. Can be 'container' (to listen for touch events on swiper-container) or 'wrapper' (to listen for touch events on swiper-wrapper)
      watchOverflow: true,
      // When enabled Swiper will be disabled and hide navigation buttons on case there are not enough slides for sliding
      shortSwipes: true,
      // Set to false if you want to disable short swipes
      threshold: 10,
      // Threshold value in px. If "touch distance" will be lower than this value then swiper will not move
      navigation: {
        nextEl: '.swiper-button-next',
        //	string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "next" button after click on it
        prevEl: '.swiper-button-prev',
        // string / HTMLElement	null	String with CSS selector or HTML element of the element that will work like "prev" button after click on it
        hideOnClick: false,
        //	Toggle navigation buttons visibility after click on Slider's container
        disabledClass: 'swiper-button-disabled',
        // CSS class name added to navigation button when it becomes disabled
        hiddenClass: 'swiper-button-hidden' // CSS class name added to navigation button when it becomes hidden

      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        //String with type of pagination. Can be "bullets", "fraction", "progressbar" or "custom"
        bulletElement: 'span',
        //	Defines which HTML tag will be use to represent single pagination bullet. Only for bullets pagination type.
        hideOnClick: false,
        // Toggle (hide/true) pagination container visibility after click on Slider's container
        clickable: true //	If true then clicking on pagination button will cause transition to appropriate slide. Only for bullets pagination type

      },
      scrollbar: {
        el: '.swiper-scrollbar',
        hide: true,
        //	Hide scrollbar automatically after user interaction
        draggable: true,
        //	Set to true to enable make scrollbar draggable that allows you to control slider position
        snapOnRelease: true,
        //	Set to false to unsnap slider position to slides when you release scrollbar
        dragSize: 'auto',
        // string/number	Size of scrollbar draggable element in px
        lockClass: 'swiper-scrollbar-lock',
        //	Scrollbar element additional CSS class when it is disabled
        dragClass: 'swiper-scrollbar-drag' //	Scrollbar draggable element CSS class

      }
    }; // get options from element

    var metaOptions = self.$element.data('swiper-options');
    self.options = $.extend({}, defaults, metaOptions, options);

    if ($.code.debug) {
      console.log('Init swiper:', self.$element, self.options);
    }

    if ($.code.themeEditor) {
      $(document).on('shopify:section:load', function (event) {
        self.refreshSwiper();
      }).on('shopify:section:unload', function (event) {
        self.refreshSwiper();
      }).on('shopify:section:select', function (event) {
        self.refreshSwiper();
      }).on('shopify:section:deselect', function (event) {
        self.refreshSwiper();
      }).on('shopify:section:reorder', function (event) {
        self.refreshSwiper();
      }).on('shopify:block:select', function (event) {
        self.refreshSwiper();
      }).on('shopify:block:deselect', function (event) {
        self.refreshSwiper();
      });
    }

    self.init();
  };
  /**
   * Init Plugin
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.init = function () {
    var self = this;
    self.$element.removeClass('row');
    self.$sliderContainer = self.$element.find('.swiper-container:first'); // Add elements from options

    if (self.options.scrollbar) {
      self.$sliderContainer.append('<div class="swiper-scrollbar"></div>');
    } // a .swiper-navigation has been added to align nav arrows based on image/video inside the slide, instead of the full height slide.


    if (self.options.navigation) {
      self.$sliderContainer.append('<div class="swiper-navigation"><div class="swiper-button-prev"></div><div class="swiper-button-next"></div></div>');
    }

    if (self.options.pagination) {
      self.$sliderContainer.append('<div class="swiper-pagination"></div>');
    } // start the swiper


    self.swiperInst = new Swiper(self.$sliderContainer[0], self.options); // check if the swiper has video's inside

    var videos = $(self.$sliderContainer[0]).find('[data-video]');
    var videoPlayButtons = $(self.$sliderContainer[0]).find('[data-video-play-button]');

    if (videos.length > 0) {
      // reset all videos on slide change
      self.swiperInst.on('slideChange', function () {
        videos.each(function (index, video) {
          video.pause();
          video.currentTime = 0;
          video.load();
          $('[data-video-wrapper]').removeClass('is-playing');
        });
      }); // connect all the playButtons onclick events

      videoPlayButtons.each(function (index, element) {
        $(element).on('click', function (e) {
          var id = $(this).data('video-play-button');
          var video = $('[data-video="' + id + '"]');
          video.each(function (index, element) {
            element.muted = false;
            element.volume = 1;
            $(element).removeClass('hidden');

            if (!$(element).parent().hasClass('swiper-slide-duplicate')) {
              element.muted = true;
              element.volume = 0;
            }

            element.play();
          });
        });
      }); // connect all video events

      videos.each(function (index, element) {
        $(element).on('click', function (e) {
          var id = $(this).data('video');
          var video = $('[data-video="' + id + '"]');
          video.each(function (index, element) {
            element.pause();
          });
        }).on('play', function (e) {
          var video = $(this);
          var id = video.data('video');
          var playButton = $('[data-video-play-button="' + id + '"]');
          playButton.hide();
        }).on('pause', function (e) {
          var video = $(this);
          var id = video.data('video');
          var video = $('[data-video="' + id + '"]');
          video.each(function (index, element) {
            element.pause();
          });
          var playButton = $('[data-video-play-button="' + id + '"]');
          playButton.show();
        }).on('ended', function (e) {
          var video = $(this);
          var id = video.data('video');
          var playButton = $('[data-video-play-button="' + id + '"]');
          playButton.show();
        });
      });
    } // Custom next navigation (must be [data-swiper] > [data-swiper-nav="next"])


    self.$element.on('click', '[data-swiper-nav="next"]', function () {
      self.swiperInst.slideNext();
    }); // Custom prev navigation (must be [data-swiper] > [data-swiper-nav="prev"])

    self.$element.on('click', '[data-swiper-nav="prev"]', function () {
      self.swiperInst.slidePrev();
    });
  };
  /**
   * Update Swiper
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.refreshSwiper = function () {
    var self = this;

    if (self.swiperInst != undefined) {
      setTimeout(function () {
        self.swiperInst.update();
      }, 1000);
    }
  };
  /**
   * Resize Swiper
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.resizeSwiper = function () {
    var self = this;

    if (self.swiperInst != undefined) {
      self.swiperInst.updateSize();
    }
  };
  /**
   * Empty and Add new slides Swiper
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.newSlides = function ($newSlides) {
    var self = this;

    if (self.swiperInst != undefined) {
      self.swiperInst.removeAllSlides();
      $newSlides.forEach(function (element) {
        return self.swiperInst.appendSlide(element);
      });
      self.swiperInst.updateSize();
    }
  };
  /**
   * Edit slide
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.editSlide = function ($slide) {
    var self = this;
    var index = $(self.swiperInst.slides).index($slide);
    self.goToSlide(index - 1);
  };
  /**
   * Go To slide
   *
   * @return void
   * @access public
   */


  swiperLoader_plugin.prototype.goToSlide = function (index, speed) {
    var self = this; // If no speed is defined, use the speed from options (speed can be 0)

    if (!speed && speed !== 0) {
      speed = self.options.speed;
    } // slide to index


    if (self.options.loop) {
      self.swiperInst.slideToLoop(index, speed);
    } else {
      self.swiperInst.slideTo(index, speed);
    }
  };
  /**
   * swiperLoader plugin
   *
   * @return jQuery objects
   */


  $.fn.swiperLoader = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new swiperLoader_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE swiperTabsLoader
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'swiperTabsLoader';
  /**
   * @param jQuery Element Wrapping container div
   * @return swiperTabsLoader_plugin
   */

  var swiperTabsLoader_plugin = function swiperTabsLoader_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element;
    self.$element.removeClass('row'); // For more options, check https://idangero.us/swiper/api/

    var defaults = {
      loop: false,
      initialSlide: 0,
      // Index number of initial slide.
      speed: 500,
      // Duration of transition between slides (in ms)
      direction: 'horizontal',
      // Could be 'horizontal' or 'vertical' (for vertical slider).
      autoHeight: false,
      // Set to true and slider wrapper will adopt its height to the height of the currently active slide
      roundLengths: true,
      // Set to true to round values of slides width and height to prevent blurry texts on usual resolution screens (if you have such)
      effect: 'fade',
      // Transition effect. Could be "slide", "fade", "cube", "coverflow" or "flip"
      spaceBetween: 0,
      // Distance between slides in px.
      slidesPerView: 1,
      // Number of slides per view (slides visible at the same time on slider's container).
      centeredSlides: false,
      // 	If true, then active slide will be centered, not always on the left side.
      centerInsufficientSlides: false,
      // When enabled it center slides if the amount of slides less than `slidesPerView`. Not intended to be used loop mode
      grabCursor: false,
      // This option may a little improve desktop usability. If true, user will see the "grab" cursor when hover on Swiper
      touchEventsTarget: 'wrapper',
      // Target element to listen touch events on. Can be 'container' (to listen for touch events on swiper-container) or 'wrapper' (to listen for touch events on swiper-wrapper)
      watchOverflow: true,
      // When enabled Swiper will be disabled and hide navigation buttons on case there are not enough slides for sliding
      shortSwipes: true,
      // Set to false if you want to disable short swipes
      threshold: 10 // Threshold value in px. If "touch distance" will be lower than this value then swiper will not move

    }; // get options from element

    var metaOptions = self.$element.data('swiper-options');
    self.options = $.extend({}, defaults, metaOptions, options);

    if ($.code.debug) {
      console.log('Init swiper with tabs:', self.$element, self.options);
    }

    self.$tabs = $element.find('[data-swiper-tabs]');
    self.$sliderContainer = self.$element.find('.swiper-container:first');
    self.$nextButton = self.$element.find('[data-swiper-nav="next"]');
    self.$prevButton = self.$element.find('[data-swiper-nav="prev"]'); // start the swiper

    self.swiperInst = new Swiper(self.$sliderContainer[0], self.options);
    self.handleButtonVisibility();
    self.swiperInst.on('slideChange', function () {
      var index = self.swiperInst.activeIndex; // add active to correct tab

      self.$tabs.removeClass('active');
      self.$element.find('[data-swiper-tabs=' + index + ']').addClass('active');
      self.handleButtonVisibility();
    }); // Set 1st tab

    self.$element.find('[data-swiper-tabs=' + self.options.initialSlide + ']').addClass('active'); // Custom tabs navigation

    self.$tabs.on('click', function () {
      self.goToSlide($(this).data('swiper-tabs'));
    }); // Custom next navigation (must be [data-swiper] > [data-swiper-nav="next"])

    self.$nextButton.on('click', function () {
      self.swiperInst.slideNext();
    }); // Custom prev navigation (must be [data-swiper] > [data-swiper-nav="prev"])

    self.$prevButton.on('click', function () {
      self.swiperInst.slidePrev();
    });
  };
  /**
  * Handle buttons visibility
  *
  * @return void
  * @access public
  */


  swiperTabsLoader_plugin.prototype.handleButtonVisibility = function ($slide) {
    var self = this;

    if (!self.options.loop) {
      // check if first slide and hide previous button
      if (self.swiperInst.isBeginning) {
        self.$prevButton.addClass('swiper-button-disabled');
      } else {
        self.$prevButton.removeClass('swiper-button-disabled');
      } // check if last slide and hide next button


      if (self.swiperInst.isEnd) {
        self.$nextButton.addClass('swiper-button-disabled');
      } else {
        self.$nextButton.removeClass('swiper-button-disabled');
      }
    }
  };
  /**
   * Edit slide
   *
   * @return void
   * @access public
   */


  swiperTabsLoader_plugin.prototype.editSlide = function ($slide) {
    var self = this;
    var index = $(self.swiperInst.slides).index($slide);
    self.goToSlide(index - 1);
  };
  /**
   * Go To slide
   *
   * @return void
   * @access public
   */


  swiperTabsLoader_plugin.prototype.goToSlide = function (index, speed) {
    var self = this; // If no speed is defined, use the speed from options (speed can be 0)

    if (!speed && speed !== 0) {
      speed = self.options.speed;
    } // slide to index


    if (self.options.loop) {
      self.swiperInst.slideToLoop(index, speed);
    } else {
      self.swiperInst.slideTo(index, speed);
    }
  };
  /**
   * swiperTabsLoader plugin
   *
   * @return jQuery objects
   */


  $.fn.swiperTabsLoader = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new swiperTabsLoader_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE tabs
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'tabs';
  /**
   * @param jQuery Element Wrapping container div
   * @return tabs_plugin
   */

  var tabs_plugin = function tabs_plugin($element, options) {
    // Scope it
    var self = this;
    self.$element = $element; // Get options

    var defaults = {};
    var metaOptions = self.$element.data('tabs');
    self.options = $.extend({}, defaults, metaOptions);

    if ($.code.debug) {
      console.log('Init tabs:', self.$element, self.options);
    } // Start the tabs


    self.init();
  };
  /**
   * Init
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.init = function () {
    var self = this;
    self.$tabsContent = self.$element.find('[data-tabs-content]');
    self.$tabsNav = self.$element.find('[data-tabs-nav]');

    if (self.options.create) {
      self.createTabs();
    } // Catch click on desktop tab navigation


    self.$tabsNav.on({
      click: function click(event) {
        event.preventDefault();

        if (!$(this).is('.is-active')) {
          $(this).trigger('open');
        }
      },
      open: function open() {
        var title = $(this).data('tabs-link'); // Close the active tab and open the clicked tab after that

        self.closeActiveTab(title, self.openTab(title)); // Open the clicked tag link

        self.openTabNavLink(title);
      }
    }, '[data-tabs-link]'); // Catch click on mobile tab navigation

    self.$tabsContent.on('click', '[data-tabs-link]', function (event) {
      var title = $(this).data('tabs-link');

      if ($(this).hasClass('is-active')) {
        // Close the tab and link in content
        self.closeTab(title);
      } else {
        // Open the tab and link in content
        self.openTab(title);
      }
    }); // Catch open tab by url hash

    if (window.location.hash) {
      var hash = window.location.hash.substring(1);
      self.$tabsNav.find('[data-tabs-link="' + hash + '"]').trigger('open');
    } else {
      self.$tabsNav.find('[data-tabs-link]:first').trigger('open');
    }
  };
  /**
   * create tabs
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.createTabs = function () {
    var self = this;
    self.$tabsContent.find('h2').each(function (i, tabDivider) {
      // Get tab title from h2
      var tabTitle = $(tabDivider).text();
      var tabLink = tabTitle.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, ''); // Make tab html

      var $parent = $(tabDivider).closest('.tabs-content-pane');
      var $link = $('<div class="tabs-content-link" data-tabs-link="' + tabLink + '"><span>' + tabTitle + '</span></div>');
      $parent.attr('data-tabs-content-pane', tabLink);
      $link.insertBefore($parent);
      $(tabDivider).remove(); // Add to tab nav

      self.$tabsNav.find('ol').append('<li class="tabs-nav-item" data-tabs-link="' + tabLink + '"><a href="#' + tabLink + '">' + tabTitle + '</a></li>');
    });
  };
  /**
   * close tab
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.closeActiveTab = function (title, callback) {
    var self = this;
    var $activeTab = self.$tabsNav.find('.is-active').not('[data-tabs-link="' + title + '"]'); // If there is an active tab

    if ($activeTab.length) {
      // Get title
      var activeTitle = $activeTab.data('tabs-link'); // Don't reopen self

      if (activeTitle == title) {
        return;
      }

      self.closeTab(activeTitle);
      self.closeTabNavLink(activeTitle);
    }

    if (typeof callback == 'function') {
      callback();
    }
  };
  /**
   * close tab
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.closeTab = function (title) {
    var self = this; // Close the tab

    self.$tabsContent.find('[data-tabs-content-pane="' + title + '"]').removeClass('is-active'); // Close the tablink in content (on mobile)

    self.$tabsContent.find('[data-tabs-link="' + title + '"]').removeClass('is-active');
  };
  /**
   * close link in tab nav
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.closeTabNavLink = function (title) {
    var self = this; // Close the tablink in nav

    self.$tabsNav.find('[data-tabs-link="' + title + '"]').removeClass('is-active');
  };
  /**
   * open tab
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.openTab = function (title) {
    var self = this; // Open new tab

    self.$tabsContent.find('[data-tabs-content-pane="' + title + '"]').addClass('is-active'); // Close the tablink in content (on mobile)

    self.$tabsContent.find('[data-tabs-link="' + title + '"]').addClass('is-active');
  };
  /**
   * open tablink in Nav
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.openTabNavLink = function (title) {
    var self = this; // Open new tab

    self.$tabsNav.find('[data-tabs-link="' + title + '"]').addClass('is-active');
  };
  /**
   * Reset the tab navigation and tabs
   *
   * @return void
   * @access public
   */


  tabs_plugin.prototype.reset = function () {
    var self = this; // If there is no active tab in navigation or content

    if (self.$tabsNav.find('.is-active').length == 0 || self.$tabsContent.find('.is-active').length == 0) {
      // Remove all active classes
      self.$element.find('.is-active').removeClass('is-active'); // open the first tab in navigation

      self.$tabsNav.find('[data-tabs-link]').first().trigger('click');
    }
  };
  /**
   * tabs plugin
   *
   * @return jQuery objects
   */


  $.fn.tabs = function (options) {
    // Put args in array
    var args = Array.prototype.slice.call(arguments, 1); // Initialize the items

    return this.each(function () {
      // Store the element the plugin is set on
      var $element = $(this); // Guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // If plugin was not innited

      if (!instance) {
        // Init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new tabs_plugin($element, options));
      } else {
        // If instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/****************************************************************
 * CODE toggleElementClass
 ****************************************************************/

!function ($, document, window, undefined) {
  /**
   * Plugin name
   */
  var _pluginName = 'toggleElementClass';
  /**
   * @param jQuery Element Wrapping container div
   * @return toggleElementClass_plugin
   */

  var toggleElementClass_plugin = function toggleElementClass_plugin($element, options) {
    // scope it
    var self = this;
    self.$element = $element;

    if ($.code.debug) {
      console.log('Init toggleElementClass:', self.$element);
    } // Catch click on element


    self.$element.on("click", function (event) {
      self.getOptions(self.$element);

      if (!self.$target.length || !self.options.class) {
        return;
      }

      self.handleEvents(event);
      self.toggleTheClass();
    });
  };
  /**
   * get options
   *
   * @return void
   * @access public
   */


  toggleElementClass_plugin.prototype.getOptions = function ($element) {
    var self = this;

    if (self.options) {
      return;
    }

    var defaults = {
      target: "body",
      stopPropagation: true,
      preventDefault: true
    };
    var metaOptions = $element.data('toggle-element-class');
    self.options = $.extend({}, defaults, metaOptions);
    self.$target = $(self.options.target);
  };
  /**
   * Handle events
   *
   * @return void
   * @access public
   */


  toggleElementClass_plugin.prototype.handleEvents = function (event) {
    var self = this;

    if (self.options.preventDefault) {
      event.preventDefault();
    }

    if (self.options.stopPropagation) {
      event.stopPropagation();
    }
  };
  /**
   * Toggle the Class
   *
   * @return void
   * @access public
   */


  toggleElementClass_plugin.prototype.toggleTheClass = function () {
    var self = this;

    if (self.$target.hasClass(self.options.class)) {
      // if class is set, remove it
      self.removeTheClass();
    } else {
      // if class is not set, add it
      self.addTheClass();
    }
  };
  /**
   * Add the Class
   *
   * @return void
   * @access public
   */


  toggleElementClass_plugin.prototype.addTheClass = function () {
    var self = this; // Get the options again in case this is called from outside

    self.getOptions(self.$element);
    self.$target.addClass(self.options.class);
  };
  /**
   * Remove the Class
   *
   * @return void
   * @access public
   */


  toggleElementClass_plugin.prototype.removeTheClass = function () {
    var self = this; // Get the options again in case this is called from outside

    self.getOptions(self.$element);
    self.$target.removeClass(self.options.class);
  };
  /**
   * toggleElementClass plugin
   *
   * @return jQuery objects
   */


  $.fn.toggleElementClass = function (options) {
    // put args in array
    var args = Array.prototype.slice.call(arguments, 1); // initialize the items

    return this.each(function () {
      // store the element the plugin is set on
      var $element = $(this); // guard if plugin was already initted

      var instance = $element.data('plugin_' + _pluginName); // if plugin was not innited

      if (!instance) {
        // init plugin on element and set guard data on element
        $element.data('plugin_' + _pluginName, new toggleElementClass_plugin($element, options));
      } else {
        // if instance already created call method from plugin
        if (typeof options === 'string') {
          instance[options].apply(instance, args);
        }
      }
    });
  };
}(jQuery, document, window);
/* Ring plugins */

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}

if (!NodeList.prototype.forEach && Array.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
/**
 *  Compare chart script
 *  ------------------------------------------
 *  Responsible for adding primary and secondary filtering logic to the compare page
 */


var PRIMARY_NAV_ITEM_ACTIVE_CLASS = 'compare__nav-item--active';
var SECONDARY_NAV_ITEM_ACTIVE_CLASS = 'compare__nav-item--active';

var CompareChart = /*#__PURE__*/function () {
  function CompareChart() {
    _classCallCheck(this, CompareChart);

    this.element = document.querySelector('[data-compare-charts]'); // Desktop

    this.primaryNav = this.element.querySelector('[data-primary-filter-nav]');
    this.primaryNavGroups = this.primaryNav.querySelectorAll('li[data-nav-has-children]');
    this.secondaryNav = this.element.querySelector('[data-secondary-filter-nav]');
    this.secondaryNavLinks = this.secondaryNav.querySelectorAll('[data-secondary-filter-category]');
    this.displayDifferencesLink = this.element.querySelector('[data-display-differences]');
    this.productSlider = null;
    this.contentRows = this.element.querySelector('[data-compare-content-rows]');
    this.stickyFooter = this.element.querySelector('[data-product-sticky-footer]');
    this.stickyFooterSlider = null;
    this.colImgs = document.querySelectorAll('[data-gif-figure]');

    if (this.primaryNav.hasAttribute('data-has-subnavigation')) {
      this.toggleSubNavButtons = this.primaryNav.querySelectorAll('[data-toggle-subnav]');
    } // Mobile


    this.mobileProductSelectBoxes = this.element.querySelectorAll('[data-mobile-product-select]');
    this.mobileProductSelectBoxOne = this.element.querySelector('[data-mobile-product-select="1"]');
    this.mobileProductSelectBoxTwo = this.element.querySelector('[data-mobile-product-select="2"]');
    this.mobileProductDropdown = this.element.querySelector('[data-mobile-product-dropdown]');
    this.productCompareBoxSelected = null;
    this.currentSelectedId = null;
    this.freshlySelectedId = null; // Init plugin

    this.init();
  }

  _createClass(CompareChart, [{
    key: "init",
    value: function init() {
      // Primary nav links event listeners
      var primaryNavLinks = this.primaryNav.querySelectorAll('[data-primary-filter-id]:not([data-nav-has-children])');

      var _iterator = _createForOfIteratorHelper(primaryNavLinks),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var primaryNavLink = _step.value;
          primaryNavLink.addEventListener('click', this.handlePrimaryFilterClick.bind(this), false);
        } // Primary nav grouped links event listeners

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var _iterator2 = _createForOfIteratorHelper(this.primaryNavGroups),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var primaryNavGroup = _step2.value;
          primaryNavGroup.addEventListener('click', this.handlePrimaryNavGroupClick.bind(this), false);
        } // Eventlistener for clicking outside of sub nav to close it

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      if (this.primaryNav.hasAttribute('data-has-subnavigation')) {
        this.element.querySelector('.compare__content-wrapper').addEventListener('click', this.handleOutsideSubNavClick.bind(this), false);
      } // Secondary nav links event listeners


      var _iterator3 = _createForOfIteratorHelper(this.secondaryNavLinks),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var secondaryNavLink = _step3.value;
          secondaryNavLink.addEventListener('click', this.handleSecondaryFilterClick.bind(this), false);
        } // Display differences button click event listener

      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this.displayDifferencesLink.addEventListener('change', this.handleDisplayDifferencesClick.bind(this), false); // Color picker event listeners

      var colorPickers = this.contentRows.querySelectorAll('[data-color-picker]');

      if (colorPickers) {
        var _iterator4 = _createForOfIteratorHelper(colorPickers),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var colorPicker = _step4.value;
            var colorPickerInputs = colorPicker.querySelectorAll('input');

            var _iterator5 = _createForOfIteratorHelper(colorPickerInputs),
                _step5;

            try {
              for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                var colorPickerInput = _step5.value;
                colorPickerInput.addEventListener('change', this.handleColorPickerInputChange.bind(this), false);
              }
            } catch (err) {
              _iterator5.e(err);
            } finally {
              _iterator5.f();
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }
      } // Initiate the desktop product slider (disabled for now)
      // this.initProductSlider(this.contentRows.querySelector('[data-compare-content-category] .compare__swiper')) 
      // Add listener for mobile product compare selection (both one and two)


      var _iterator6 = _createForOfIteratorHelper(this.mobileProductSelectBoxes),
          _step6;

      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var mobileProductSelectBox = _step6.value;
          var productSelectionLinks = mobileProductSelectBox.querySelectorAll('.compare__nav-title');

          var _iterator9 = _createForOfIteratorHelper(productSelectionLinks),
              _step9;

          try {
            for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
              var productSelectionLink = _step9.value;
              productSelectionLink.addEventListener('click', this.handleMobileProductSelectClick.bind(this), false);
              productSelectionLink.compareBoxSelected = mobileProductSelectBox.getAttribute('data-mobile-product-select');
            }
          } catch (err) {
            _iterator9.e(err);
          } finally {
            _iterator9.f();
          }
        } // Make sure the mobile product compare selection boxes are equal height..

      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }

      this.equalizeProductSelectBoxesHeight(); // Add listener for mobile product dropdown selection (which will show after selecting the compare dropdown)

      var productDropdownLinks = this.mobileProductDropdown.querySelectorAll('.compare__nav-title');

      var _iterator7 = _createForOfIteratorHelper(productDropdownLinks),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var productDropdownLink = _step7.value;
          productDropdownLink.addEventListener('click', this.handleMobileProductDropdownClick.bind(this), false);
        } // Small hack to make sure to hide third item for mobile / tablet portrait (on initial load)

      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);

      if (vw < 768) {
        this.hideProductsMobileInitialLoad();
      } // Gif Toggle


      var _iterator8 = _createForOfIteratorHelper(this.colImgs),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var colImg = _step8.value;
          colImg.addEventListener('click', this.handleGifToggle.bind(this), false);
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
  }, {
    key: "initProductSlider",
    value: function initProductSlider() {
      var _this = this,
          _Swiper;

      var el = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var slidePrevNextHooksEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var disableSwipe = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var noSwipingClass = '';

      if (disableSwipe) {
        noSwipingClass = 'no-swiping';
      }

      this.productSlider = new Swiper(el !== null ? el : '.compare__swiper', (_Swiper = {
        speed: 400,
        spaceBetween: 100,
        pagination: false,
        slidesPerView: 4
      }, _defineProperty(_Swiper, "spaceBetween", 0), _defineProperty(_Swiper, "centerInsufficientSlides", true), _defineProperty(_Swiper, "scrollbar", false), _defineProperty(_Swiper, "noSwipingClass", noSwipingClass), _defineProperty(_Swiper, "noSwiping", disableSwipe), _defineProperty(_Swiper, "shortSwipes", true), _defineProperty(_Swiper, "navigation", {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
        hideOnClick: false,
        disabledClass: 'swiper-button-disabled',
        hiddenClass: 'swiper-button-hidden'
      }), _defineProperty(_Swiper, "breakpointsInverse", true), _defineProperty(_Swiper, "breakpoints", {
        320: {
          navigation: false,
          centerInsufficientSlides: false,
          slidesPerView: 2
        },
        1024: {
          centerInsufficientSlides: true,
          slidesPerView: 3
        },
        1280: {
          centerInsufficientSlides: true,
          slidesPerView: 4
        }
      }), _defineProperty(_Swiper, "on", {
        slidePrevTransitionStart: function slidePrevTransitionStart() {
          if (_this.stickyFooterSlider && slidePrevNextHooksEnabled === true) {
            _this.stickyFooterSlider.slidePrev();
          }
        },
        slideNextTransitionStart: function slideNextTransitionStart() {
          if (_this.stickyFooterSlider && slidePrevNextHooksEnabled === true) {
            _this.stickyFooterSlider.slideNext();
          }
        }
      }), _Swiper));
    }
  }, {
    key: "initStickyFooterSlider",
    value: function initStickyFooterSlider() {
      this.stickyFooterSlider = new Swiper('[data-product-sticky-footer-slider]', {
        spaceBetween: 0,
        slidesPerView: 4,
        centerInsufficientSlides: true,
        freeMode: true,
        breakpointsInverse: true,
        scrollbar: false,
        navigation: false,
        breakpoints: {
          320: {
            navigation: false,
            centerInsufficientSlides: false,
            slidesPerView: 2
          },
          1024: {
            centerInsufficientSlides: true,
            slidesPerView: 3
          },
          1280: {
            centerInsufficientSlides: true,
            slidesPerView: 4
          }
        }
      });
    }
  }, {
    key: "handlePrimaryFilterClick",
    value: function handlePrimaryFilterClick(e) {
      // Get closest a element (should the image be clicked and not the a)
      var linkEl = e.target.closest('li'); // When deselecting - check if this not the last selected product - if so do nothing and always keep one primary nav

      if (linkEl.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS) && this.primaryNav.querySelectorAll(".".concat(PRIMARY_NAV_ITEM_ACTIVE_CLASS, ":not([data-nav-has-children])")).length === 1) {
        return;
      } // Temporary fix: do not select more than four products


      if (!linkEl.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS) && this.primaryNav.querySelectorAll(".".concat(PRIMARY_NAV_ITEM_ACTIVE_CLASS, ":not([data-nav-has-children])")).length >= 4) {
        return;
      } // Toggle active state class of the link item


      linkEl.classList.toggle(PRIMARY_NAV_ITEM_ACTIVE_CLASS); // Get product id from clicked link element

      var productId = linkEl.getAttribute('data-primary-filter-id'); // Hide or unhide content product row

      var contentProductRows = this.contentRows.querySelectorAll("[data-compare-content-id=\"".concat(productId, "\"]"));

      var _iterator10 = _createForOfIteratorHelper(contentProductRows),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var productRow = _step10.value;
          productRow.hidden = !linkEl.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS);
        } // Hide or unhide footer product row

      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      var footerProductRows = this.stickyFooter.querySelectorAll("[data-compare-content-id=\"".concat(productId, "\"]"));

      var _iterator11 = _createForOfIteratorHelper(footerProductRows),
          _step11;

      try {
        for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
          var _productRow = _step11.value;
          _productRow.hidden = !linkEl.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS);
        } // Check if display differences is selected, if so rerun the comparison script

      } catch (err) {
        _iterator11.e(err);
      } finally {
        _iterator11.f();
      }

      if (this.displayDifferencesLink.checked) {
        this.compareDifferences();
      }
    }
  }, {
    key: "handlePrimaryNavGroupClick",
    value: function handlePrimaryNavGroupClick(e) {
      // Get closest a element (should the image be clicked and not the a)
      var linkEl = e.target.closest('li'); // Make sure to only approach groups, not li within li

      if (linkEl.parentNode.hasAttribute('data-subnav')) {
        return;
      }

      var subMenu = linkEl.querySelector('[data-subnav]');
      linkEl.classList.toggle('compare__nav-item--open');

      if (subMenu) {
        subMenu.hidden = !subMenu.hidden;
      }

      this.checkForParentActiveState();
    }
  }, {
    key: "handleOutsideSubNavClick",
    value: function handleOutsideSubNavClick(e) {
      // Check if there is a nav group currently open, if so close it
      var _iterator12 = _createForOfIteratorHelper(this.primaryNavGroups),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var primaryNavGroup = _step12.value;

          if (primaryNavGroup.classList.contains('compare__nav-item--open')) {
            primaryNavGroup.classList.remove('compare__nav-item--open');
            var subMenu = primaryNavGroup.querySelector('[data-subnav]');

            if (subMenu) {
              subMenu.hidden = !subMenu.hidden;
            }

            this.checkForParentActiveState();
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }
    }
  }, {
    key: "handleSecondaryFilterClick",
    value: function handleSecondaryFilterClick(e) {
      // Get closest a element (should the image be clicked and not the a)    
      var linkEl = e.target.closest('a'); // Get the category from the clicked link element

      var clickedCategory = linkEl.getAttribute('data-secondary-filter-category'); // Remove all secondary filter active classes except for the one clicked

      var _iterator13 = _createForOfIteratorHelper(this.secondaryNavLinks),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var secondaryNavLink = _step13.value;

          // Add or remove active nav item class
          if (secondaryNavLink.getAttribute('data-secondary-filter-category') === clickedCategory) {
            secondaryNavLink.classList.add(SECONDARY_NAV_ITEM_ACTIVE_CLASS);
          } else {
            secondaryNavLink.classList.remove(SECONDARY_NAV_ITEM_ACTIVE_CLASS);
          }
        } // Loop through content rows to check which one should be hidden/shown

      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      var contentRows = this.contentRows.querySelectorAll('[data-compare-content-category]');

      var _iterator14 = _createForOfIteratorHelper(contentRows),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var contentRow = _step14.value;

          // Unhide the content row of the selected category
          if (contentRow.getAttribute('data-compare-content-category') === clickedCategory) {
            contentRow.hidden = false; // Initiate product slider(s) for this tab (currently disabled)
            // for(const [i, sliderEl] of contentRow.querySelectorAll('.compare__swiper').entries()) {
            //   const disableSwipe = contentRow.getAttribute('data-compare-content-category') === 'installation'
            //   this.initProductSlider(sliderEl, i === 0, disableSwipe)
            // }
            // Check if the product sticky footer needs to be displayed

            this.stickyFooter.hidden = !contentRow.hasAttribute('data-enable-sticky-product-footer'); // Destroy if there is a current sticky footer slider (currently disabled)
            // if(this.stickyFooterSlider) {
            //   this.stickyFooterSlider.destroy()
            // }
            // Init sticky footer slider
            // this.initStickyFooterSlider() 
          } else {
            contentRow.hidden = true;
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }
    }
  }, {
    key: "checkForParentActiveState",
    value: function checkForParentActiveState() {
      // Loop through all primary nav groups and check if any of children have active state
      var _iterator15 = _createForOfIteratorHelper(this.primaryNavGroups),
          _step15;

      try {
        for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
          var primaryNavGroup = _step15.value;
          primaryNavGroup.classList.remove(PRIMARY_NAV_ITEM_ACTIVE_CLASS);

          var _iterator16 = _createForOfIteratorHelper(primaryNavGroup.querySelectorAll('[data-subnav] li')),
              _step16;

          try {
            for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
              var primaryNavLink = _step16.value;

              if (primaryNavLink.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS)) {
                primaryNavGroup.classList.add(PRIMARY_NAV_ITEM_ACTIVE_CLASS);
              }
            }
          } catch (err) {
            _iterator16.e(err);
          } finally {
            _iterator16.f();
          }
        }
      } catch (err) {
        _iterator15.e(err);
      } finally {
        _iterator15.f();
      }
    }
  }, {
    key: "handleDisplayDifferencesClick",
    value: function handleDisplayDifferencesClick(e) {
      var showDifferences = e.target.checked;
      this.compareDifferences(showDifferences);
    }
  }, {
    key: "compareDifferences",
    value: function compareDifferences() {
      var showDifferences = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      // If deselecting the checkbox make sure to remove all deactived classes from secondary menu
      if (showDifferences === false) {
        var _iterator17 = _createForOfIteratorHelper(this.secondaryNavLinks),
            _step17;

        try {
          for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
            var secondaryNavLink = _step17.value;

            if (secondaryNavLink.classList.contains('compare__nav-item--deactivated')) {
              secondaryNavLink.classList.remove('compare__nav-item--deactivated');
            }
          }
        } catch (err) {
          _iterator17.e(err);
        } finally {
          _iterator17.f();
        }

        return;
      } // Check all category groups for differences on ACTIVE productRows


      var _iterator18 = _createForOfIteratorHelper(this.element.querySelectorAll('[data-compare-content-category]')),
          _step18;

      try {
        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
          var categoryGroup = _step18.value;
          var rowsHaveDifferences = false;
          var productRows = categoryGroup.querySelectorAll('[data-compare-content-id]:not([hidden])');

          var _iterator19 = _createForOfIteratorHelper(productRows),
              _step19;

          try {
            for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
              var productRow = _step19.value;

              if (productRow.hidden === false && productRows[0].innerHTML.trim() !== productRow.innerHTML.trim()) {
                rowsHaveDifferences = true;
              }
            } // If there are no row differences in this category group make sure to deactivate the related secondary link

          } catch (err) {
            _iterator19.e(err);
          } finally {
            _iterator19.f();
          }

          if (!rowsHaveDifferences) {
            var _secondaryNavLink = this.secondaryNav.querySelector("a[data-secondary-filter-category=\"".concat(categoryGroup.getAttribute('data-compare-content-category'), "\"]"));

            if (_secondaryNavLink) {
              if (_secondaryNavLink.classList.contains('compare__nav-item--deactivated')) {
                _secondaryNavLink.classList.remove('compare__nav-item--deactivated');
              }

              _secondaryNavLink.classList.add('compare__nav-item--deactivated');
            }
          }
        }
      } catch (err) {
        _iterator18.e(err);
      } finally {
        _iterator18.f();
      }
    }
  }, {
    key: "handleColorPickerInputChange",
    value: function handleColorPickerInputChange(e) {
      // If you click an active color swatch nothing needs to happen
      if (e.target.parentNode.classList.contains('checked')) return; // Hide all variant images

      e.target.closest('[data-device-color-options]').querySelectorAll('[data-variant-img-index-id]').forEach(function (el) {
        return el.hidden = true;
      }); // Get index from radio input

      var selectedIndex = e.target.getAttribute('data-color-swatch-index-id'); // Show variant image for selected index swatch

      e.target.closest('[data-device-color-options]').querySelector("[data-variant-img-index-id=\"".concat(selectedIndex, "\"]")).hidden = false; // Remove all active states from radios

      e.target.closest('[data-color-picker]').querySelectorAll('label').forEach(function (e) {
        return e.classList.remove('checked');
      }); // Add active state to selected radio

      e.target.closest('label').classList.toggle('checked');
    }
  }, {
    key: "hideProductsMobileInitialLoad",
    value: function hideProductsMobileInitialLoad() {
      var contentCategories = this.element.querySelectorAll('[data-compare-content-category]');

      var _iterator20 = _createForOfIteratorHelper(contentCategories),
          _step20;

      try {
        for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
          var contentCategory = _step20.value;
          var wrappers = contentCategory.querySelectorAll('.compare__product-info-wrapper');

          var _iterator22 = _createForOfIteratorHelper(wrappers),
              _step22;

          try {
            for (_iterator22.s(); !(_step22 = _iterator22.n()).done;) {
              var wrapper = _step22.value;
              var contentProductRows = wrapper.querySelectorAll('[data-compare-content-id]:not([hidden])');

              var _iterator23 = _createForOfIteratorHelper(contentProductRows.entries()),
                  _step23;

              try {
                for (_iterator23.s(); !(_step23 = _iterator23.n()).done;) {
                  var _step23$value = _slicedToArray(_step23.value, 2),
                      i = _step23$value[0],
                      productRow = _step23$value[1];

                  if (i > 1) {
                    productRow.hidden = true;
                  }
                }
              } catch (err) {
                _iterator23.e(err);
              } finally {
                _iterator23.f();
              }
            }
          } catch (err) {
            _iterator22.e(err);
          } finally {
            _iterator22.f();
          }
        }
      } catch (err) {
        _iterator20.e(err);
      } finally {
        _iterator20.f();
      }

      var stickyFooterRows = this.stickyFooter.querySelectorAll('[data-compare-content-id]:not([hidden])');

      var _iterator21 = _createForOfIteratorHelper(stickyFooterRows.entries()),
          _step21;

      try {
        for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
          var _step21$value = _slicedToArray(_step21.value, 2),
              _i2 = _step21$value[0],
              stickyFooterRow = _step21$value[1];

          if (_i2 > 1) {
            stickyFooterRow.hidden = true;
          }
        }
      } catch (err) {
        _iterator21.e(err);
      } finally {
        _iterator21.f();
      }
    }
  }, {
    key: "handleMobileProductSelectClick",
    value: function handleMobileProductSelectClick(e) {
      e.preventDefault();
      var linkEl = e.target.closest('li'); // Add the compare box selected (one or two) to a variable so we can use it later on to determine what to update

      this.productCompareBoxSelected = e.currentTarget.compareBoxSelected; // Check if another selectbox is already open, if so close that one first

      var mobileProductDropdownOpen = false;

      var _iterator24 = _createForOfIteratorHelper(this.mobileProductSelectBoxes),
          _step24;

      try {
        for (_iterator24.s(); !(_step24 = _iterator24.n()).done;) {
          var productSelect = _step24.value;
          var item = productSelect.querySelector('[data-primary-filter-id]:not([hidden])');

          if (item.classList.contains(PRIMARY_NAV_ITEM_ACTIVE_CLASS) && item.getAttribute('data-primary-filter-id') != linkEl.getAttribute('data-primary-filter-id')) {
            item.classList.remove(PRIMARY_NAV_ITEM_ACTIVE_CLASS);
            mobileProductDropdownOpen = true;
          }
        } // Toggle active class

      } catch (err) {
        _iterator24.e(err);
      } finally {
        _iterator24.f();
      }

      linkEl.classList.toggle(PRIMARY_NAV_ITEM_ACTIVE_CLASS); // Show selection popup if its not open already

      if (!mobileProductDropdownOpen) {
        this.mobileProductDropdown.hidden = !this.mobileProductDropdown.hidden;
      } // Disable already selected products in dropdown options


      var selectBoxOneProductId = this.mobileProductSelectBoxOne.querySelector('[data-primary-filter-id]:not([hidden])').getAttribute('data-primary-filter-id');
      var selectBoxTwoProductId = this.mobileProductSelectBoxTwo.querySelector('[data-primary-filter-id]:not([hidden])').getAttribute('data-primary-filter-id');

      var _iterator25 = _createForOfIteratorHelper(this.mobileProductDropdown.querySelectorAll('[data-primary-filter-id]')),
          _step25;

      try {
        for (_iterator25.s(); !(_step25 = _iterator25.n()).done;) {
          var productRow = _step25.value;
          var productId = productRow.getAttribute('data-primary-filter-id');
          productRow.classList.remove('selection-disabled');

          if (productId == selectBoxOneProductId || productId == selectBoxTwoProductId) {
            productRow.classList.add('selection-disabled');
          }
        } // Save current selected product id

      } catch (err) {
        _iterator25.e(err);
      } finally {
        _iterator25.f();
      }

      this.currentSelectedId = linkEl.getAttribute('data-primary-filter-id');
    }
  }, {
    key: "handleMobileProductDropdownClick",
    value: function handleMobileProductDropdownClick(e) {
      e.preventDefault();
      var linkEl = e.target.closest('li'); // Check which new product id to use in comparison chart

      this.freshlySelectedId = linkEl.getAttribute('data-primary-filter-id'); // Hide selection popup

      this.mobileProductDropdown.hidden = true; // Update product selection new product info in the compare box

      var _iterator26 = _createForOfIteratorHelper(this.mobileProductSelectBoxes),
          _step26;

      try {
        for (_iterator26.s(); !(_step26 = _iterator26.n()).done;) {
          var mobileProductSelectBox = _step26.value;

          if (mobileProductSelectBox.getAttribute('data-mobile-product-select') === this.productCompareBoxSelected) {
            mobileProductSelectBox.querySelector("[data-primary-filter-id=\"".concat(this.currentSelectedId, "\"]")).hidden = true;
            mobileProductSelectBox.querySelector("[data-primary-filter-id=\"".concat(this.freshlySelectedId, "\"]")).hidden = false;
          }
        } // Update content rows + sticky footer with new product info

      } catch (err) {
        _iterator26.e(err);
      } finally {
        _iterator26.f();
      }

      this.contentRows.querySelectorAll("[data-compare-content-id=\"".concat(this.currentSelectedId, "\"]")).forEach(function (contentRow) {
        return contentRow.hidden = true;
      });
      this.contentRows.querySelectorAll("[data-compare-content-id=\"".concat(this.freshlySelectedId, "\"]")).forEach(function (contentRow) {
        return contentRow.hidden = false;
      });
      this.stickyFooter.querySelector("[data-compare-content-id=\"".concat(this.currentSelectedId, "\"]")).hidden = true;
      this.stickyFooter.querySelector("[data-compare-content-id=\"".concat(this.freshlySelectedId, "\"]")).hidden = false; // Check if the the compare selection matches the ordering. If not: apply a row reverse css class

      var selectBoxOneProductId = this.mobileProductSelectBoxOne.querySelector('[data-primary-filter-id]:not([hidden])').getAttribute('data-primary-filter-id');
      var contentRowOneProductId = this.contentRows.querySelector('[data-compare-content-id]:not([hidden])').getAttribute('data-compare-content-id');
      this.contentRows.querySelectorAll('.compare__product-info-wrapper').forEach(function (wrapper) {
        return wrapper.classList.remove('compare__product-info--reverse');
      });
      this.stickyFooter.querySelectorAll('.swiper-wrapper').forEach(function (wrapper) {
        return wrapper.classList.remove('swiper-rows-reverse');
      });

      if (selectBoxOneProductId != contentRowOneProductId) {
        this.contentRows.querySelectorAll('.compare__product-info-wrapper').forEach(function (wrapper) {
          return wrapper.classList.add('compare__product-info--reverse');
        });
        this.stickyFooter.querySelectorAll('.swiper-wrapper').forEach(function (wrapper) {
          return wrapper.classList.add('swiper-rows-reverse');
        });
      } // Reset current product id and compare box selected


      this.currentSelectedId = null;
      this.productCompareBoxSelected = null; // Make sure the mobile product compare selection boxes are equal height..

      this.equalizeProductSelectBoxesHeight();
    }
  }, {
    key: "equalizeProductSelectBoxesHeight",
    value: function equalizeProductSelectBoxesHeight() {
      var selectBoxHeights = _toConsumableArray(this.element.querySelectorAll('[data-mobile-product-select-boxes] [data-primary-filter-id]:not([hidden]) .compare__nav-title')).map(function (el) {
        return el.clientHeight;
      });

      var maxBoxHeight = Math.max.apply(Math, _toConsumableArray(selectBoxHeights));

      if (maxBoxHeight !== null && !isNaN(maxBoxHeight)) {
        var _iterator27 = _createForOfIteratorHelper(this.element.querySelectorAll('[data-mobile-product-select-boxes] [data-primary-filter-id]:not([hidden]) .compare__nav-title')),
            _step27;

        try {
          for (_iterator27.s(); !(_step27 = _iterator27.n()).done;) {
            var selectBox = _step27.value;
            // We need to substract padding unfortunately because JS cant find element height without padding
            selectBox.style.height = "".concat(maxBoxHeight - parseFloat(getComputedStyle(selectBox).paddingTop) * 2, "px");
          }
        } catch (err) {
          _iterator27.e(err);
        } finally {
          _iterator27.f();
        }
      }
    }
  }, {
    key: "handleGifToggle",
    value: function handleGifToggle(e) {
      var parentElement = e.target.closest('[data-gif-figure]');
      var targetImg = parentElement.querySelector('.img__gif');
      var imgSrc = targetImg.src;
      var imgAlt = targetImg.getAttribute('data-alt');

      if (!parentElement.classList.contains('is__play')) {
        parentElement.classList.add('is__play');
        targetImg.setAttribute('src', imgAlt);
        targetImg.setAttribute('data-alt', imgSrc);
      } else {
        parentElement.classList.remove('is__play');
        targetImg.setAttribute('src', imgAlt);
        targetImg.setAttribute('data-alt', imgSrc);
      }
    }
  }]);

  return CompareChart;
}();
/**
 *  Generic video component
 *  ------------------------------------------
 *  Responsible for handling video blocks
 */


var VideoBlock = /*#__PURE__*/function () {
  function VideoBlock(element) {
    _classCallCheck(this, VideoBlock);

    this.element = element;
    this.type = this.element.getAttribute('data-video-element');
    this.playButton = this.element.querySelector('[data-play-button]');

    if (this.type == 'video') {
      this.video = this.element.querySelector('video');
      this.videoIsPlaying = false;
      this.placeholderImg = this.element.querySelector('[data-placeholder-image]');
    } else if (this.type == 'gif') {
      this.image = this.element.querySelector('img');
    }

    this.init();
  }

  _createClass(VideoBlock, [{
    key: "init",
    value: function init() {
      if (this.playButton) {
        this.playButton.addEventListener('click', this.handlePlayClick.bind(this), false);
      }

      if (this.type == 'video' && this.video) {
        this.video.addEventListener('click', this.handleVideoClick.bind(this), false);
      }

      if (this.type == 'gif') {
        this.image.addEventListener('click', this.toggleGifState.bind(this), false);
      }
    }
  }, {
    key: "handlePlayClick",
    value: function handlePlayClick(e) {
      e.preventDefault();

      if (this.type == 'video') {
        this.handlePlayVideoClick();
      } else if (this.type == 'gif') {
        this.toggleGifState();
      }
    }
  }, {
    key: "handlePlayVideoClick",
    value: function handlePlayVideoClick() {
      this.video.play();
      this.videoIsPlaying = true;
      this.element.classList.toggle('is__play');
    }
  }, {
    key: "handleVideoClick",
    value: function handleVideoClick(e) {
      e.preventDefault();

      if (this.videoIsPlaying) {
        this.video.pause();
        this.videoIsPlaying = false;
        this.element.classList.toggle('is__play');
      }
    }
  }, {
    key: "toggleGifState",
    value: function toggleGifState(e) {
      this.element.classList.toggle('is__play');
      this.image.src = this.element.classList.contains('is__play') ? this.image.getAttribute('data-gif') : this.image.getAttribute('data-img');
    }
  }]);

  return VideoBlock;
}();
/**
 *  Banner video script
 *  ------------------------------------------
 *  Responsible for handling banner video on pmp-banner.liquid
 */


var BannerVideo = /*#__PURE__*/function () {
  function BannerVideo() {
    _classCallCheck(this, BannerVideo);

    this.videoFull = document.querySelector('[data-banner-video-high-res]');
    this.playButton = document.querySelector('[data-video-play-button]');
    this.bannerContent = document.querySelector('[data-banner-content]');
    this.videoOverlay = document.querySelector('[data-banner-overlay]');
    this.bannerImage = document.querySelector('[data-banner-image]'); // Check wether to use preview video or not

    this.hasPreviewVideo = false;

    if (document.querySelector('[data-banner-video-preview]')) {
      this.hasPreviewVideo = true;
      this.videoPreview = document.getElementById('hero-video-preview');
    }

    this.init();
  }

  _createClass(BannerVideo, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      this.playButton.addEventListener('click', this.handlePlayVideoClick.bind(this), false);
      this.videoFull.addEventListener('pause', function (event) {
        if (_this2.hasPreviewVideo) {
          _this2.bannerContent.hidden = false;
          _this2.videoOverlay.hidden = false;
        }
      });
      this.videoFull.addEventListener('play', function (event) {
        if (_this2.hasPreviewVideo) {
          _this2.bannerContent.hidden = true;
          _this2.videoOverlay.hidden = true;
        }
      });
    }
  }, {
    key: "handlePlayVideoClick",
    value: function handlePlayVideoClick() {
      this.videoFull.style.display = 'block';
      this.videoFull.play();
      this.videoFull.setAttribute('controls', 'controls');
      this.bannerContent.hidden = true;
      this.videoOverlay.hidden = true;

      if (this.hasPreviewVideo) {
        this.videoPreview.style.display = 'none';
      }

      if (this.bannerImage) {
        this.bannerImage.style.display = 'none';
      }
    }
  }]);

  return BannerVideo;
}();
/**
 *  PDP video script
 *  ------------------------------------------
 *  Responsible for handling videos on PDP's
 */


var PdpVideo = /*#__PURE__*/function () {
  function PdpVideo(videoWrapper) {
    _classCallCheck(this, PdpVideo);

    this.pdpVideoWrapper = videoWrapper;
    this.video = this.pdpVideoWrapper.querySelector('[data-video]');
    this.controls = this.pdpVideoWrapper.querySelector('[data-video-play]');
    this.init();
  }

  _createClass(PdpVideo, [{
    key: "init",
    value: function init() {
      var _this3 = this;

      this.pdpVideoWrapper.addEventListener('click', function () {
        _this3.controlVideo();
      });
      this.video.addEventListener('ended', function () {
        _this3.controlVideo(true);
      });
    }
  }, {
    key: "controlVideo",
    value: function controlVideo(ended) {
      var pause = this.pdpVideoWrapper.classList.contains('is-playing');

      if (ended) {
        this.pdpVideoWrapper.classList.remove('is-playing');
      } else {
        if (pause) {
          this.video.pause();
          this.pdpVideoWrapper.classList.remove('is-playing');
        } else {
          this.video.play();
          this.pdpVideoWrapper.classList.add('is-playing');
        }
      }
    }
  }]);

  return PdpVideo;
}();

var SCENE_DURATION = 2200;
var SCENE_OFFSET = 400;
var CATEGORY_ICON_SELECTOR = '.interactive-house__category-icon';
var CATEGORY_ICON_LINK_SELECTOR = '.interactive-house__category-icon-link';
var TOGGLED_STATE_CLASS = 'toggled-state';

var InteractiveHouse = /*#__PURE__*/function () {
  function InteractiveHouse(selector) {
    _classCallCheck(this, InteractiveHouse);

    this.selector = selector;
    this.element = document.querySelector(selector);
    this.scene = null; // Initialize scrollmagic controller

    this.controller = new ScrollMagic.Controller();
    this.scrollAnimation = new TimelineMax();
    this.init();
  }

  _createClass(InteractiveHouse, [{
    key: "init",
    value: function init() {
      // Setting scroll animations for the interactive house stage
      this.setScrollAnimation(); // Building the scene for scrollmagic

      this.buildScene(); // Scrollbar fix for smoother scrolling
      // const scrollbar = Scrollbar.init(document.querySelector('main'))
      // scrollbar.addListener(() => {
      //   this.scene.refresh()
      // })
      // Add event listener for product icon clicks (desktop)

      var productIcons = this.element.querySelectorAll('[data-product]');

      var _iterator28 = _createForOfIteratorHelper(productIcons),
          _step28;

      try {
        for (_iterator28.s(); !(_step28 = _iterator28.n()).done;) {
          var productIcon = _step28.value;
          productIcon.addEventListener('click', this.handleProductIconClick.bind(this), false);
        } // Add event listener for product icon clicks (mobile)

      } catch (err) {
        _iterator28.e(err);
      } finally {
        _iterator28.f();
      }

      var hotspotIcons = this.element.querySelectorAll('[data-hotspot]');

      var _iterator29 = _createForOfIteratorHelper(hotspotIcons),
          _step29;

      try {
        for (_iterator29.s(); !(_step29 = _iterator29.n()).done;) {
          var hotspotIcon = _step29.value;
          hotspotIcon.addEventListener('click', this.handleHotspotIconClick.bind(this), false);
        } // Add event listener for nav icon clicks
        // const navIcons = this.element.querySelectorAll('[data-nav]')
        // for (const navIcon of navIcons) {
        //   navIcon.addEventListener('click', this.handleNavIconClick.bind(this), false)
        // }

      } catch (err) {
        _iterator29.e(err);
      } finally {
        _iterator29.f();
      }
    }
  }, {
    key: "setScrollAnimation",
    value: function setScrollAnimation() {
      var _this4 = this;

      this.scrollAnimation.set('.interactive-house__stage', {
        autoAlpha: 1
      }).to('[data-interactive-house-empty]', 1, {
        autoAlpha: 1,
        ease: Power1.easeInOut,
        delay: 0.5,
        onReverseComplete: function onReverseComplete() {
          return _this4.hideAllProductThumbnails();
        },
        onComplete: function onComplete() {
          _this4.hideAllProductThumbnails();
        }
      }, 'trans1').to('[data-interactive-house-text-intro]', 0, {
        autoAlpha: 1,
        ease: Power1.easeInOut,
        delay: 0.5
      }, 'trans1').to('[data-interactive-house-empty]', 1, {
        autoAlpha: 1,
        ease: Power1.easeInOut
      }, 'trans2').to('[data-interactive-house-doorbells]', 1, {
        autoAlpha: 1,
        ease: Power1.easeInOut,
        delay: 0.3,
        onReverseComplete: function onReverseComplete() {
          return _this4.hideAllProductThumbnails();
        },
        onComplete: function onComplete() {
          _this4.hideAllProductThumbnails();
        }
      }, 'trans2').from('[data-interactive-house-text-intro]', 0.5, {
        opacity: 1,
        yPercent: 0
      }, 'trans2').to('[data-interactive-house-text-intro]', 0.5, {
        opacity: 0,
        yPercent: -10,
        ease: Power1.easeInOut
      }, 'trans2').fromTo('[data-interactive-house-text-doorbells]', 0.5, {
        opacity: 0,
        yPercent: 10
      }, {
        opacity: 1,
        yPercent: 0,
        ease: Power1.easeInOut,
        delay: 0.4,
        onReverseComplete: function onReverseComplete() {
          return _this4.toggleNavItem('intro');
        },
        onComplete: function onComplete() {
          return _this4.toggleNavItem('doorbells');
        }
      }, 'trans2').to('[data-interactive-house-doorbells]', 1, {
        autoAlpha: 0,
        ease: Power1.easeInOut,
        onComplete: function onComplete() {
          return _this4.hideAllProductThumbnails();
        }
      }, 'trans3').to('[data-interactive-house-security-cams]', 1, {
        autoAlpha: 1,
        ease: Power1.easeInOut,
        delay: 0.3,
        onReverseComplete: function onReverseComplete() {
          return _this4.hideAllProductThumbnails();
        },
        onComplete: function onComplete() {
          return _this4.hideAllProductThumbnails();
        }
      }, 'trans3').to('[data-interactive-house-text-doorbells]', 0.5, {
        autoAlpha: 0,
        yPercent: -10,
        ease: Power1.easeInOut
      }, 'trans3').fromTo('[data-interactive-house-text-security-cams]', 0.5, {
        opacity: 0,
        yPercent: 10
      }, {
        opacity: 1,
        yPercent: 0,
        ease: Power1.easeInOut,
        delay: 0.4,
        onReverseComplete: function onReverseComplete() {
          return _this4.toggleNavItem('doorbells');
        },
        onComplete: function onComplete() {
          return _this4.toggleNavItem('security-cams');
        }
      }, 'trans3').to('[data-interactive-house-security-cams]', 1, {
        autoAlpha: 0,
        ease: Power1.easeInOut
      }, 'trans4').to('[data-interactive-house-security-system]', 1, {
        autoAlpha: 1,
        ease: Power1.easeInOut,
        delay: 0.3,
        onReverseComplete: function onReverseComplete() {
          return _this4.hideAllProductThumbnails();
        },
        onComplete: function onComplete() {
          return _this4.hideAllProductThumbnails();
        }
      }, 'trans4').to('[data-interactive-house-text-security-cams]', 0.5, {
        autoAlpha: 0,
        yPercent: -10,
        ease: Power1.easeInOut
      }, 'trans4').fromTo('[data-interactive-house-text-security-system]', 0.5, {
        opacity: 0,
        yPercent: 10
      }, {
        opacity: 1,
        yPercent: 0,
        ease: Power1.easeInOut,
        delay: 0.4,
        onReverseComplete: function onReverseComplete() {
          return _this4.toggleNavItem('security-cams');
        },
        onComplete: function onComplete() {
          return _this4.toggleNavItem('security-system');
        }
      }, 'trans4');
      this.scrollAnimation.eventCallback('onComplete', function () {
        // Hide thumbnails popups
        var _iterator30 = _createForOfIteratorHelper(_this4.element.querySelectorAll('[data-interactive-house-product-thumbnail]')),
            _step30;

        try {
          for (_iterator30.s(); !(_step30 = _iterator30.n()).done;) {
            var thumbnail = _step30.value;
            thumbnail.hidden = true;
          } // scene.removePin(true);
          // window.scrollBy(0, -1750); 

        } catch (err) {
          _iterator30.e(err);
        } finally {
          _iterator30.f();
        }
      });
    }
  }, {
    key: "buildScene",
    value: function buildScene() {
      this.scene = new ScrollMagic.Scene({
        triggerElement: this.selector,
        duration: SCENE_DURATION
      }).setPin('.interactive-house__stage').addTo(this.controller).setTween(this.scrollAnimation);
      this.scene.offset(SCENE_OFFSET);
      this.toggleNavItem('intro'); // change behaviour of controller to animate scroll instead of jump

      this.controller.scrollTo(function (newpos) {
        TweenMax.to(window, 0.5, {
          scrollTo: {
            y: newpos
          }
        });
      }); // Callbacks per scene (for active state in nav bullets)
      // new ScrollMagic.Scene({
      //     triggerElement: "[data-interactive-house-doorbells]"
      //   })
      //   .setClassToggle('[data-nav="doorbells"]', "active")
      //   .addTo(this.controller);
      // new ScrollMagic.Scene({
      //     triggerElement: "[data-interactive-house-security-cams]"
      //   })
      //   .setClassToggle('[data-nav="security-cams"]', "active")
      //   .addTo(this.controller);
      // new ScrollMagic.Scene({
      //     triggerElement: "[data-interactive-house-security-system]"
      //   })
      //   .setClassToggle('[data-nav="security-systems"]', "active")
      //   .addTo(this.controller);
    }
  }, {
    key: "handleProductIconClick",
    value: function handleProductIconClick(event) {
      event.preventDefault(); // Get closest a element (should the image be clicked and not the a)

      var linkEl = event.target.closest(CATEGORY_ICON_LINK_SELECTOR); // Get the data-product-id from linkEl attr

      var productId = linkEl.dataset.product;
      if (!productId) return;
      this.showHideProductThumbnail(productId, linkEl, event);
    }
  }, {
    key: "handleHotspotIconClick",
    value: function handleHotspotIconClick(event) {
      // Get closest a element (should the image be clicked and not the a)
      var linkEl = event.target.closest('[data-hotspot]'); // Get the data-product-id from linkEl attr

      var productId = linkEl.dataset.hotspot;
      if (!productId) return;
      this.showHideProductThumbnail(productId, linkEl, event, 'mobile');
    } // handleNavIconClick(event) {
    //   event.preventDefault()
    //   // Get closest a element (should the image be clicked and not the a)
    //   const linkEl = event.target.closest('[data-nav]')
    //   this.controller.scrollTo(`#scroll-${linkEl.dataset.nav}`)
    //   console.log('123',linkEl.dataset.nav)
    //   console.log('234', this.element.querySelector(`[data-interactive-house-${linkEl.dataset.nav}]`))
    // }

  }, {
    key: "showHideProductThumbnail",
    value: function showHideProductThumbnail(productId, linkEl, event) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'desktop';

      // Hide all other product thumbnails 
      var _iterator31 = _createForOfIteratorHelper(this.element.querySelectorAll('[data-interactive-house-product-thumbnail]')),
          _step31;

      try {
        for (_iterator31.s(); !(_step31 = _iterator31.n()).done;) {
          var thumbnail = _step31.value;

          if (thumbnail.dataset.interactiveHouseProductThumbnail !== productId) {
            thumbnail.hidden = true;
          }
        } // De-toggle states for all product icons
        // Add a toggle-state class on product icon for styling purposes

      } catch (err) {
        _iterator31.e(err);
      } finally {
        _iterator31.f();
      }

      var iconEl = linkEl.parentElement.querySelector(CATEGORY_ICON_SELECTOR);
      var deselectProduct = false;

      if (iconEl) {
        if (iconEl.classList.contains(TOGGLED_STATE_CLASS)) {
          deselectProduct = true;
        } else {
          var _iterator32 = _createForOfIteratorHelper(this.element.querySelectorAll(CATEGORY_ICON_SELECTOR)),
              _step32;

          try {
            for (_iterator32.s(); !(_step32 = _iterator32.n()).done;) {
              var productIcon = _step32.value;

              if (productIcon.dataset.product !== productId) {
                productIcon.classList.remove(TOGGLED_STATE_CLASS);
              }
            }
          } catch (err) {
            _iterator32.e(err);
          } finally {
            _iterator32.f();
          }
        }

        iconEl.classList.toggle(TOGGLED_STATE_CLASS);
      } // Find related product thumbnail element


      var productThumbnail = this.element.querySelector("[data-interactive-house-product-thumbnail=\"".concat(productId, "\"]"));
      if (!productThumbnail) return; // Show or hide the thumbnail

      productThumbnail.hidden = !productThumbnail.hidden; // No need to execute rest of the code when hiding productThumbnail

      if (productThumbnail.hidden === true) return; // Get viewport width

      var viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0); // Set client cursor x pos

      var cursorXPos = event.clientX; // Update position absolute left/right/top values for product thumbnail based on event cursor click, different for desktop/mobile

      if (type == 'desktop') {
        if (typeof productThumbnail.dataset.thumbnailAlignedLeft !== 'undefined') {
          cursorXPos = cursorXPos - productThumbnail.offsetWidth * 1.32;
        }

        if (viewportWidth > 1600) {
          cursorXPos = cursorXPos - (viewportWidth - 1600) / 2;
        }

        var heightDivider = typeof productThumbnail.dataset.heightDivider !== 'undefined' ? productThumbnail.dataset.heightDivider : 2.7;
        productThumbnail.style.left = "".concat(cursorXPos, "px");
        productThumbnail.style.top = "".concat(event.clientY / heightDivider, "px");
      } else if (type == 'mobile') {
        cursorXPos = cursorXPos - productThumbnail.offsetWidth / 2; // Make sure the product thumbnail does not go outside the screen

        if (cursorXPos + productThumbnail.offsetWidth > viewportWidth) {
          cursorXPos = viewportWidth - 195;
        } // Get distance of stage wrapper in browser window for correct product thumbnail top placement


        var distanceReduce = 0;
        var wrapperEl = document.querySelector('.interactive-house__sketch');

        if (wrapperEl) {
          var rect = wrapperEl.getBoundingClientRect();

          if (rect.top) {
            distanceReduce += rect.top - 15; // minus 15 for some icon spacing
          }
        }

        productThumbnail.style.left = "".concat(cursorXPos, "px");
        productThumbnail.style.top = "".concat(event.clientY - distanceReduce, "px");
      }
    } // Hide product thumbnails 

  }, {
    key: "hideAllProductThumbnails",
    value: function hideAllProductThumbnails() {
      var _iterator33 = _createForOfIteratorHelper(this.element.querySelectorAll('[data-interactive-house-product-thumbnail]')),
          _step33;

      try {
        for (_iterator33.s(); !(_step33 = _iterator33.n()).done;) {
          var thumbnail = _step33.value;
          thumbnail.hidden = true;
        } // De-toggle states for all product icons

      } catch (err) {
        _iterator33.e(err);
      } finally {
        _iterator33.f();
      }

      var _iterator34 = _createForOfIteratorHelper(this.element.querySelectorAll(CATEGORY_ICON_SELECTOR)),
          _step34;

      try {
        for (_iterator34.s(); !(_step34 = _iterator34.n()).done;) {
          var productIcon = _step34.value;
          productIcon.classList.remove(TOGGLED_STATE_CLASS);
        }
      } catch (err) {
        _iterator34.e(err);
      } finally {
        _iterator34.f();
      }
    } // Toggle nav item based on name of section

  }, {
    key: "toggleNavItem",
    value: function toggleNavItem(name) {
      if (name === null || typeof this.element.querySelector("[data-nav-wrapper] [data-nav=\"".concat(name, "\"]")) === 'undefined') {
        return;
      }

      var navItems = this.element.querySelectorAll('[data-nav-wrapper] [data-nav]');

      var _iterator35 = _createForOfIteratorHelper(navItems),
          _step35;

      try {
        for (_iterator35.s(); !(_step35 = _iterator35.n()).done;) {
          var navItem = _step35.value;
          navItem.classList.remove('active');
        }
      } catch (err) {
        _iterator35.e(err);
      } finally {
        _iterator35.f();
      }

      if (name !== null && typeof this.element.querySelector("[data-nav-wrapper] [data-nav=\"".concat(name, "\"]")) !== 'undefined') {
        this.element.querySelector("[data-nav-wrapper] [data-nav=\"".concat(name, "\"]")).classList.add('active');
      }
    }
  }]);

  return InteractiveHouse;
}();
/**
 *  Sticky nav script
 *  ------------------------------------------
 *  Responsible for handling sticky navigation on sticky-nav.liquid
 * 
 *  Note: Contains code related to the sticky filters feature on the Offers page. 
 *  To avoid future conflicts, refactoring is needed to extract sticky filters into a standalone feature, independent of sticky nav. 
 */


var ANCHOR_ACTIVE_CLASS = 'active';
var MOBILE_NAV_OPEN_CLASS = 'sticky-nav__mobile-nav-opened';
var TABLET_BREAKPOINT = 768;

var StickyNav = /*#__PURE__*/function () {
  function StickyNav() {
    _classCallCheck(this, StickyNav);

    this.headerOffsetPx = -150; // Default offset from header menu

    this.stickyNavWrapper = document.querySelector('[data-sticky-nav]');
    this.stickyNavItems = document.querySelector('[data-sticky-nav-items]');
    this.stickyFilters = document.querySelector('[data-sticky-filters]'); // Offers page sticky filters

    this.toggleMobileNav = document.querySelector('[data-toggle-mobile-nav]');
    this.pageWrapper = document.querySelector('.page-wrapper');
    this.viewportWidth = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    this.init();
  }

  _createClass(StickyNav, [{
    key: "init",
    value: function init() {
      var _this5 = this;

      if (typeof this.stickyNavWrapper === 'undefined') return; // Add class to .page-wrapper

      this.pageWrapper.classList.add('with-sticky-nav'); // Check for announcement bar (announcebar only shows on top on desktop)

      if (this.viewportWidth >= TABLET_BREAKPOINT && document.querySelector('#announcement-bar')) {
        this.headerOffsetPx -= 50;
      } // Offers page sticky filters - account for header offset


      if (this.viewportWidth >= TABLET_BREAKPOINT && document.querySelector('.sticky-filters')) {
        this.headerOffsetPx -= 40;
      } // Activate anchor when scrolling through page


      window.addEventListener('scroll', this.handleWindowScroll.bind(this), false); // Loop through all anchor links in sticky nav and add click event listener

      this.stickyNavWrapper.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.addEventListener('click', _this5.handleAnchorClick.bind(_this5), false);
      }); // Do not run if in the context of sticky filters

      if (this.toggleMobileNav != undefined) {
        // Toggle mobile nav dropdown
        this.toggleMobileNav.addEventListener('click', this.handleToggleMobileNav.bind(this), false);
      }
    }
  }, {
    key: "handleWindowScroll",
    value: function handleWindowScroll(e) {
      var _this6 = this;

      this.stickyNavWrapper.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        var element = document.getElementById(anchor.href.split('#')[1]);
        if (element === null) return;

        var elTopPos = element.getBoundingClientRect().top + window.pageYOffset + _this6.headerOffsetPx;

        var elBottomBos = element.getBoundingClientRect().bottom + window.pageYOffset + _this6.headerOffsetPx; // Check if the window scroll is currently in the anchored block range - then add active class


        if (window.pageYOffset >= elTopPos + _this6.headerOffsetPx && window.pageYOffset <= elBottomBos) {
          // Offers page sticky filters - horizontally scroll active filter into view
          if (document.querySelector('.sticky-filters')) {
            _this6.stickyFilters.scrollLeft = anchor.closest('li').offsetLeft - 32;
            $(anchor).parents('li').siblings().children('a').removeClass('active');
          }

          anchor.classList.add(ANCHOR_ACTIVE_CLASS);
        } else if (anchor.classList.contains(ANCHOR_ACTIVE_CLASS)) {
          anchor.classList.remove(ANCHOR_ACTIVE_CLASS);
        }
      });
    }
  }, {
    key: "handleAnchorClick",
    value: function handleAnchorClick(e) {
      var _this7 = this;

      e.preventDefault();
      var anchor = e.target;
      var offsetPx = this.headerOffsetPx; // Adjust for smaller screens

      if (this.viewportWidth < TABLET_BREAKPOINT) {
        if (this.stickyFilters != 'undefined') {
          offsetPx = -170; // for sticky filters
        } else {
          offsetPx = -130;
        }
      }

      var element = document.getElementById(anchor.href.split('#')[1]);
      var yAxisOffset = element.getBoundingClientRect().top + window.pageYOffset + offsetPx;
      window.scrollTo({
        top: yAxisOffset,
        behavior: 'smooth'
      }); // Remove active classes from all links

      this.stickyNavWrapper.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
        anchor.classList.remove(ANCHOR_ACTIVE_CLASS); // also for sticky filters 

        if (_this7.stickyFilters != 'undefined') {
          $(anchor).parents('li').siblings().children('a').removeClass('active');
        }
      });

      if (this.viewportWidth < TABLET_BREAKPOINT) {
        // Toggle dropdown nav state
        this.toggleMobileNavDropdown();
      } // Set active class to clicked anchor


      anchor.classList.add(ANCHOR_ACTIVE_CLASS); // handle sticky filter horizontal scroll and active anchor

      if (this.stickyFilters != 'undefined') {
        this.stickyFilters.scrollLeft = anchor.closest('li').offsetLeft - 32;
        $(anchor).parents('li').siblings().children('a').removeClass('active');
      }
    }
  }, {
    key: "handleToggleMobileNav",
    value: function handleToggleMobileNav(e) {
      this.toggleMobileNavDropdown();
    }
  }, {
    key: "toggleMobileNavDropdown",
    value: function toggleMobileNavDropdown() {
      // do not run for sticky filters section
      if (this.toggleMobileNav != undefined) {
        // Toggle opened class
        this.toggleMobileNav.classList.toggle(MOBILE_NAV_OPEN_CLASS); // Show or hide sticky nav items dropdown

        this.stickyNavItems.style.display = window.getComputedStyle(this.stickyNavItems).display === 'block' ? 'none' : 'block';
      }
    }
  }]);

  return StickyNav;
}();

var countdownTimer = /*#__PURE__*/function () {
  function countdownTimer() {
    _classCallCheck(this, countdownTimer);

    this.countdownBar = document.querySelector('.announcement-bar__countdown-timer');
    this.clockWrapper = document.querySelector('.countdown-timer__clock');
    this.countdownEndDate = this.clockWrapper.getAttribute('data-countdown-end-date');
    this.countdownShowDays = this.clockWrapper.getAttribute('data-display-days');
    this.init();
  }

  _createClass(countdownTimer, [{
    key: "init",
    value: function init() {
      // Display Days
      var showDays = this.countdownShowDays; // Declare the UI elements

      var dayBoxOne = document.getElementById('day-1');
      var dayBoxTwo = document.getElementById('day-2');
      var hourBoxOne = document.getElementById('hour-1');
      var hourBoxTwo = document.getElementById('hour-2');
      var minuteBoxOne = document.getElementById('minute-1');
      var minuteBoxTwo = document.getElementById('minute-2');
      var secondBoxOne = document.getElementById('second-1');
      var secondBoxTwo = document.getElementById('second-2');
      var counterBoxes = [dayBoxOne, dayBoxTwo, hourBoxOne, hourBoxTwo, minuteBoxOne, minuteBoxTwo, secondBoxOne, secondBoxTwo]; //Convert date for iOS

      function convertDateForIos(date) {
        date = date.replace(/ /g, "T");
        date = new Date(date).getTime();
        return date;
      } // Get countdown end date


      var endDate = this.countdownEndDate; // Get Countdown End timestamp

      var endTimestamp = convertDateForIos(endDate); // Get store timezone

      var shopTimezone = '';

      if (window.location.hostname.indexOf('en-uk') > -1) {
        shopTimezone = 'Europe/London';
      } else {
        shopTimezone = 'Europe/Berlin';
      } // Calculations for time


      var _second = 1000,
          _minute = _second * 60,
          _hour = _minute * 60,
          _day = _hour * 24; // Add leading zero when the number goeas into single digits


      var addLeadingZeros = function addLeadingZeros(number) {
        return number < 10 ? "0" + number : number;
      }; // Run countdown timer


      var timer = setInterval(function updateTimer() {
        // Lock the timezone and get a timestamp of the users time
        var timezoneLockedNowDate = new Date().toLocaleString('en-US', {
          timeZone: shopTimezone
        });
        var formattedNowDate = new Date(timezoneLockedNowDate);
        var nowTimestamp = formattedNowDate.getTime(); // Calculate time remaining

        var timeLeft = endTimestamp - nowTimestamp; // Break loop and set counters to 0 when countdown ends

        if (timeLeft < 0) {
          clearInterval(timer);
          counterBoxes.forEach(function (element) {
            element.innerHTML = "0";
          });
          return;
        } // If displaying days


        if (showDays == 'true') {
          var days = Math.floor(timeLeft / _day);
          days = addLeadingZeros(days);
          var split_days = (days + "").split('');
          dayBoxOne.innerHTML = split_days[0];
          dayBoxTwo.innerHTML = split_days[1];

          var hours = Math.floor(timeLeft % _day) / _hour; // if displaying days set limit on hour counter to 24

        } else {
          var hours = Math.floor(timeLeft / _hour); // otherwise output total hours remaining - the countdown should not be longer than 4 days (96h) 
        } // Timer calculations


        hours = addLeadingZeros(hours);
        var minutes = Math.floor(timeLeft % _hour / _minute);
        minutes = addLeadingZeros(minutes);
        var seconds = Math.floor(timeLeft % _minute / _second);
        seconds = addLeadingZeros(seconds); // Split digits to be displayed seperately

        var split_hours = (hours + "").split('');
        var split_minutes = (minutes + "").split('');
        var split_seconds = (seconds + "").split(''); // Update UI

        hourBoxOne.innerHTML = split_hours[0];
        hourBoxTwo.innerHTML = split_hours[1];
        minuteBoxOne.innerHTML = split_minutes[0];
        minuteBoxTwo.innerHTML = split_minutes[1];
        secondBoxOne.innerHTML = split_seconds[0];
        secondBoxTwo.innerHTML = split_seconds[1]; //Repeat

        return updateTimer;
      }(), 1000);
    }
  }]);

  return countdownTimer;
}();
/**
 * EEC-2003 - PDP Sticky ATC/Scroll Navigation A/B test
 
const body = document.body;
const pdpNavTestActive = "optimizely-test-pdp-nav";
const header = document.getElementById("header");
const announcementBar = document.getElementById("announcement-bar");
const scrollUp = "scroll-up";
const scrollDown = "scroll-down";
let lastScroll = 0;
const stickyAtcBar = document.querySelector(".sticky-atc-bar");
const atfContainer = document.querySelector(".product-detail-section");
const stickyAtcBarID = document.getElementById('sticky-atc-bar');

window.addEventListener("scroll", () => {

  // Hotfix for duplication of atc events through sticky nav
  if (!body.classList.contains(pdpNavTestActive)) {
    stickyAtcBarID.remove();
  }

  // SCROLL NAV
  var currentScroll = window.scrollY;
  //Top of viewport
  if (currentScroll <= 66) {
    body.classList.remove(scrollUp);
    return;
  }
  if (currentScroll > lastScroll && !body.classList.contains(scrollDown)) {
    // user scrolls down
    body.classList.remove(scrollUp);
    body.classList.add(scrollDown);
  } else if (currentScroll < lastScroll && body.classList.contains(scrollDown)) {
    // user scrolls up
    body.classList.remove(scrollDown);
    body.classList.add(scrollUp);
  }
  // set new scroll position
  lastScroll = window.scrollY;

  if (body.classList.contains(pdpNavTestActive)){
    // STICKY ATC BAR
    var barHeight = document.querySelector(".sticky-atc-bar").offsetHeight;
    // Display bottom bar when user scrolls down
    if (atfContainer.getBoundingClientRect().y < -500) {
      stickyAtcBar.classList.add("sticky-bar-active");
      document.getElementById('solvvy-widget-iframe').style.bottom = `${barHeight}px`;
    } else {
      stickyAtcBar.classList.remove("sticky-bar-active");
      document.getElementById('solvvy-widget-iframe').style.bottom = 0;
    }
  }
  
});

*/

/****************************************************************
 * CODE init
 ****************************************************************/


$.code.init = function () {
  // Disable scroll to when url hash is supplied
  if (window.location.hash) {
    scroll(0, 0); // void some browsers issue

    setTimeout(function () {
      scroll(0, 0);
    }, 1);
  } // Set debugging flag


  $.code.debug = false; // Set global variables

  $.code.setVars(); // Handle window resizing

  $.code.windowResizeHandler();
  /**
   * init plugins
   */
  // Init ajax cart

  $('body').ajaxCart(); // Init Swipers

  $('[data-swiper]').swiperLoader(); // Init product events

  $('[data-section-type="product"]').product(); // Init collapsible panes

  $('[data-collapsible-wrapper]').collapsible(); // Init media + accordion sync (needs swiperLoader and collapsible above)

  $('[data-media-accordion]').mediaAccordion(); // Init enhanced search

  $('[data-enhanced-search]').enhancedSearch(); // Init collection navigation

  $('body').collectionNav(); // Init Ajax pagination

  $('[data-ajax-pagination]').ajaxPagination(); // Init class togglers

  $('[data-toggle-element-class]').toggleElementClass(); // Init related products

  $('[data-related-products]').relatedProducts(); // Init tabs

  $('[data-tabs]').tabs(); // Init country popup

  $('body').countryPopup(); // Init collection/all Filters

  $('[data-colection-filter-wrapper]').collectionFilter(); // Init swiper with tabs

  $('[data-swiper-tabs]').swiperTabsLoader(); // Init compare

  $('[data-compare-page="wrapper"]').compare(); // Init announcement bar countdown timer

  if (document.querySelector('[data-countdown-timer]')) {
    new countdownTimer();
  } // Init new compare charts


  if (document.querySelector('[data-compare-charts]')) {
    new CompareChart();
  } // Generic video component


  var _iterator36 = _createForOfIteratorHelper(document.querySelectorAll('[data-video-element]')),
      _step36;

  try {
    for (_iterator36.s(); !(_step36 = _iterator36.n()).done;) {
      var videoEl = _step36.value;
      new VideoBlock(videoEl);
    } // Init homepage interactive house scroller

  } catch (err) {
    _iterator36.e(err);
  } finally {
    _iterator36.f();
  }

  if (document.querySelector('[data-interactive-house-scroller]')) {
    new InteractiveHouse('#interactive-house-scroller');
  } // Init sticky nav


  if (document.querySelector('[data-sticky-nav]')) {
    new StickyNav();
  } // Init banner video


  if (document.querySelector('[data-banner-video-high-res]')) {
    new BannerVideo();
  }

  var _iterator37 = _createForOfIteratorHelper(document.querySelectorAll('[data-video-wrapper]')),
      _step37;

  try {
    for (_iterator37.s(); !(_step37 = _iterator37.n()).done;) {
      var pdpVideoEl = _step37.value;
      new PdpVideo(pdpVideoEl);
    } // Scroll to element on page load

  } catch (err) {
    _iterator37.e(err);
  } finally {
    _iterator37.f();
  }

  var $scrollEl = $('[data-scroll-here]');

  if ($scrollEl.length) {
    $('html, body').animate({
      scrollTop: $scrollEl.offset().top
    }, 1000);
  } // Scroll to window location hash if provided


  if (window.location.hash) {
    setTimeout(function () {
      $('html, body').animate({
        scrollTop: $(window.location.hash).offset().top + 'px'
      }, 500, 'swing');
    }, 200);
  } // Scroll smoothly to div id when anchor is clicked
  // Do not use this for sticky nav component ([data-sticky-anchor])


  $('a[href*=\\#]:not([data-sticky-anchor]):not([data-kit-nostock-amazon-link])').on('click', function (e) {
    e.preventDefault();
    $('html,body').animate({
      scrollTop: $(this.hash).offset().top
    }, 500, 'swing'); // update the URL in location bar

    if ($.attr(this, 'href').length) {
      window.location.hash = $.attr(this, 'href').substring($.attr(this, 'href').indexOf("#") + 1);
    }
  }); // Execute alarm block

  alarmBlock();
};
/**
 * Quiz section on PMP
 */


$('.pmp-quiz .quiz-button').click(function () {
  var quizans = $(this).attr('data-quiz-ans');
  $('.pmp-quiz-main').removeClass('active');
  $('.pmp-quiz').find('[data-quiz-id="' + quizans + '"]').addClass('active');
});
/**
 * Interactive houses on PMP
 */

$('[data-interactive-icon]').click(function () {
  $(this).closest('.products-wrapper').find('.product').removeClass('active');
  $(this).addClass('active');
  var interactiveProduct = $(this).attr('data-interactive-icon');
  $(this).closest('.interactive-house-section').find('.product-overlay').removeClass('active');
  $(this).closest('.interactive-house-section').find('.product-overlay[data-interactive-product="' + interactiveProduct + '"]').addClass('active');
});
/********** Interactive Banners **********/

var shopAllInteractiveBannerBackground = $('#shop-all-interactive-banner-bg');
var shopAllInteractiveBannerContent = $('.pmp-banner-collections .interactive-banner-content');
var homeInteractiveBannerBackground = $('.interactive-banner-hp-bg-mobile, .interactive-video-banner-bg');
var homeInteractiveBannerContent = $('.pmp-banner-homepage .interactive-banner-content');
var interactiveBannerTouchpoints = $('.interactive-touchpoint'); // Interactive touchpoint fade-in sequence

function touchpointFadeInSequence(icon, delay) {
  setTimeout(function () {
    $(icon).each(function (i) {
      (function (self) {
        setTimeout(function () {
          $(self).show();
        }, i * 150);
      })(this);
    });
  }, delay);
}

; // Shop All Products page interactive banner

$('[data-interactive-banner-icon]').click(function () {
  var interactiveProduct = $(this).attr('data-interactive-banner-icon');
  var interactivePopup = $('.product-overlay[data-interactive-banner-product="' + interactiveProduct + '"]');
  $(interactivePopup).show().removeClass('not-active').addClass('active');
  $(interactiveBannerTouchpoints).hide();
  $('.interactive-banner').addClass('active-state');

  if ($(window).width() > 1024) {
    $(shopAllInteractiveBannerBackground).removeClass();
    $(shopAllInteractiveBannerBackground).addClass('zoom-' + interactiveProduct);
    $(shopAllInteractiveBannerContent).fadeOut(300);
  } else {
    $(shopAllInteractiveBannerBackground).addClass('darken');
  }
}); // Homepage interactive banner

$('[data-interactive-banner-hp-icon]').click(function () {
  var interactiveProductHome = $(this).attr('data-interactive-banner-hp-icon');
  var interactivePopupHome = $('.product-overlay[data-interactive-banner-hp-product="' + interactiveProductHome + '"]');
  $(interactivePopupHome).show().removeClass('not-active').addClass('active');
  $('.interactive-banner').addClass('active-state');

  if ($(window).width() < 1024) {
    $(homeInteractiveBannerBackground).addClass('darken');
    $(interactiveBannerTouchpoints).fadeOut(300);
  } else if ($(window).width() < 1300) {
    $(interactiveBannerTouchpoints).fadeOut(400);
    $(homeInteractiveBannerContent).fadeOut(300);
  } else {
    $(interactiveBannerTouchpoints).fadeOut(400);
  }
}); // Close popup and return to initial  state

function closeInteractiveBannerPopup(i, p) {
  $(p).removeClass('active').addClass('not-active');
  setTimeout(function () {
    $(p).removeClass('not-active').hide();
  }, 1000);

  if ($(window).width() > 1024) {
    $(homeInteractiveBannerContent).delay(200).fadeIn(500);
    $(shopAllInteractiveBannerBackground).removeClass('zoom-' + i).addClass('zoom-out');
    $(shopAllInteractiveBannerContent).delay(500).fadeIn(500);
    touchpointFadeInSequence($('.active-state [data-interactive-banner-icon]'), 650);
    touchpointFadeInSequence($('.active-state [data-interactive-banner-hp-icon]'), 200);
  } else {
    $(shopAllInteractiveBannerBackground).removeClass('darken');
    $(homeInteractiveBannerBackground).removeClass('darken');
    touchpointFadeInSequence($('.active-state [data-interactive-banner-icon]'), 250);
    touchpointFadeInSequence($('.active-state [data-interactive-banner-hp-icon]'), 300);
  }

  $('.interactive-banner').removeClass('active-state');
} // Close popup when clicking cross icon


$('.icon-close-interactive-popup').click(function () {
  var activeProduct = $('.product-overlay.active').attr('data-interactive-banner-product');
  var activePopup = $('.product-overlay.active');
  closeInteractiveBannerPopup(activeProduct, activePopup);
}); // Close popup when clicking outside of it

$([homeInteractiveBannerBackground, shopAllInteractiveBannerBackground]).each(function () {
  $(this).mouseup(function (e) {
    var activeProduct = $('.product-overlay.active').attr('data-interactive-banner-product');
    var activePopup = $('.product-overlay.active');

    if (!activePopup.is(e.target) && activePopup.has(e.target).length === 0) {
      closeInteractiveBannerPopup(activeProduct, activePopup);
    }
  });
});
/************** Security Around Home ***************/

$('.security-icon').click(function () {
  var category = $(this).attr('data-id');
  var active_img = $(this).attr('active-img');
  var inactive_img = $('.security-icon.active').attr('inactive-img');
  var img_inactive_class_name = ".img-overlay-" + $('.security-icon.active').attr('data-id');
  $('.security-icon.active').find('.img').css({
    backgroundImage: 'url(' + inactive_img + ')'
  });
  $('.security-icon').removeClass('active');
  $('.security-icons').find('[data-id="' + category + '"]').addClass('active');
  $('.security-icons').find('[data-id="' + category + '"]').find('.img').css({
    backgroundImage: 'url(' + active_img + ')'
  });
  $(img_inactive_class_name).removeClass('active');
  $('.security-around-home').find('[data-id="' + category + '"]').addClass('active');
});
/**
 * Video play - PMP video on mobile
 */

$('.play-btn').click(function (e) {
  var video_block = $(e.target).closest('.video-in-iphone');
  var vid = video_block.find('video');
  vid.get()[0].play();
  $(e.target).hide();
  l;
});
$('.video-in-iphone.mobile #video').click(function (e) {
  $(this).get(0).pause();
  $(this).siblings('.play-btn').children('.icon-play').show();
});
/** 
 * PDP Recommendation cards slider
 */

function initRecommendationsSlider() {
  // Swiper data
  var mySwiper = new Swiper('.recommendations-slider', {
    loop: false,
    init: true,
    centerInsufficientSlides: true,
    observer: true,
    speed: 400,
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: 30,
    breakpoints: {
      1024: {
        slidesPerGroup: 3,
        slidesPerView: 3
      },
      767: {
        slidesPerGroup: 2,
        slidesPerView: 2
      },
      560: {
        slidesPerGroup: 1,
        slidesPerView: 1.1
      }
    },
    on: {
      init: function init() {
        $('.product-recommendations__loading-dots').hide();
        $('.recommendations-slider').fadeIn(1000);
      }
    }
  });
}

var productRecommendationsSection = document.querySelector('.product-recommendations'); // init only if there is a recommendations section on the specific PDP

if (productRecommendationsSection !== null) {
  var url = productRecommendationsSection.dataset.url;
  fetch(url).then(function (response) {
    return response.text();
  }).then(function (text) {
    var html = document.createElement('div');
    html.innerHTML = text;
    var recommendations = html.querySelector('.product-recommendations');

    if (recommendations && recommendations.innerHTML.trim().length) {
      productRecommendationsSection.innerHTML = recommendations.innerHTML;
    } // init swiper after recommendations have been populated


    initRecommendationsSlider();
  }).catch(function (e) {
    console.error(e);
  });
}

;
/**
 * Empty Cart Recommendations Slider
 */

var mySwiper = new Swiper('.empty-cart-recommendations-slider', {
  loop: false,
  init: true,
  centerInsufficientSlides: true,
  observer: true,
  speed: 400,
  slidesPerView: 4,
  slidesPerGroup: 4,
  spaceBetween: 30,
  breakpoints: {
    1024: {
      slidesPerGroup: 3,
      slidesPerView: 3
    },
    767: {
      slidesPerGroup: 2,
      slidesPerView: 2
    },
    560: {
      slidesPerGroup: 1,
      slidesPerView: 1.1
    }
  }
});
/**
 * UGC page Video slider
 */

var mySwiper = new Swiper('.ugc-video-slider', {
  loop: false,
  centerInsufficientSlides: true,
  speed: 400,
  slidesPerView: 4,
  slidesPerGroup: 4,
  spaceBetween: 30,
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    hideOnClick: true
  },
  breakpoints: {
    1024: {
      slidesPerGroup: 3,
      slidesPerView: 3
    },
    767: {
      slidesPerGroup: 2,
      slidesPerView: 2
    },
    560: {
      slidesPerGroup: 1,
      slidesPerView: 1
    }
  }
});
/**
 * Three graphics slider section on PMP
 */

var mySwiper = new Swiper('.graphics-container', {
  speed: 400,
  spaceBetween: 100,
  slidesPerView: 3,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true
  },
  breakpoints: {
    767: {
      centeredSlides: true,
      slidesPerView: 1.3,
      spaceBetween: 10
    }
  }
});
/**
 * Card slider
 */

var mySwiper = new Swiper('.cards-slider', {
  loop: false,
  speed: 400,
  slidesPerView: 3,
  slidesPerGroup: 3,
  spaceBetween: 30,
  keyboard: {
    enabled: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    hideOnClick: true
  },
  breakpoints: {
    767: {
      slidesPerGroup: 2,
      slidesPerView: 2
    },
    560: {
      slidesPerGroup: 1,
      slidesPerView: 1.3
    }
  }
});
var mySwiper = new Swiper('.quotes-slider', {
  loop: false,
  speed: 400,
  direction: "vertical",
  mousewheel: true,
  slidesPerView: 1,
  spaceBetween: 30,
  keyboard: {
    enabled: true
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    hideOnClick: true
  }
});
/**
 * Protect plans coverage plans houses (switch button)
 */

if ($('[data-coverage-house]').length > 0) {
  var switchLeft = function switchLeft() {
    switchBtnRight.classList.remove('active-case');
    switchBtnLeft.classList.add('active-case');
    activeSwitch.style.right = '50%';
  };

  var switchRight = function switchRight() {
    switchBtnRight.classList.add('active-case');
    switchBtnLeft.classList.remove('active-case');
    activeSwitch.style.right = '0%';
  };

  var switchImagesButtonChange = function switchImagesButtonChange() {
    if ($('.switch-button-case.left').hasClass('active-case')) {
      $('.content.basic-plan').show();
      $('.content.plus-plan').hide();
    } else if ($('.switch-button-case.right').hasClass('active-case')) {
      $('.content.basic-plan').hide();
      $('.content.plus-plan').show();
    }
  };

  var switchButton = document.querySelector('.switch-button');
  var switchBtnRight = document.querySelector('.switch-button-case.right');
  var switchBtnLeft = document.querySelector('.switch-button-case.left');
  var activeSwitch = document.querySelector('.active-switch');
  switchBtnLeft.addEventListener('click', function () {
    switchLeft();
  }, false);
  switchBtnRight.addEventListener('click', function () {
    switchRight();
  }, false);
  $('.switch-button-case').click(function (e) {
    switchImagesButtonChange();
  });
  switchImagesButtonChange();
  $(document).ready(function () {
    $("a").on('click', function (event) {
      if (this.hash !== "") {
        event.preventDefault();
        var hash = this.hash;
        $('html, body').animate({
          scrollTop: $(hash).offset().top
        }, 800, function () {
          window.location.hash = hash;
        });
      }
    });
  });
}
/**
 * Product Stripe dropdown
 */


$('.product-stripe__heading i').click(function () {
  var toggleClass = $(this).closest('.product-stripe__product').find('.product-stripe__dropdown').hasClass('show');
  $('.product-stripe__heading').removeClass('active');
  $('.product-stripe__dropdown').removeClass('show');
  $(this).closest('.product-stripe__heading').toggleClass('active', !toggleClass);
  $(this).closest('.product-stripe__product').find('.product-stripe__dropdown').toggleClass('show', !toggleClass);
});
/**
 * Testimonials
 */
// show testimonials

var activeCategory = $('.testimonials-categories').attr('data-active-category');
$('.testimonials-categories .category[data-category="' + activeCategory + '"]').addClass('active');
$('.testimonials-wrapper [data-testimonial-category="' + activeCategory + '"]').addClass('show'); // Show the testimonials when clicking on another category

$('.testimonials-categories .category').click(function () {
  var category = $(this).attr('data-category');
  $('.testimonials-categories .category').removeClass('active');
  $(this).addClass('active');
  $(this).closest('.testimonials-section').find('[data-testimonial-category').removeClass('show');
  $(this).closest('.testimonials-section').find('[data-testimonial-category="' + category + '"]').addClass('show');
});
$('.testimonials-categories').insertBefore('.testimonials-wrapper');
/**
 * Functions to be called after window resizing is finished
 */

$.code.onWindowResize = function () {
  var self = this; // Get new global window width

  $.code.ww = $(window).width(); // Change Responsive Video src

  responsiveVideoSetSize(); // Adjust header offset for longer announcement bars

  adjustAnnouncementOffset();
};
/**
 * Handle window resizing
 */


$.code.windowResizeHandler = function () {
  // Call window resize functions 200ms after window stops being resized
  var timeoutOffset = false;
  $(window).resize(function () {
    if (timeoutOffset !== false) {
      clearTimeout(timeoutOffset);
    }

    timeoutOffset = setTimeout(function () {
      $.code.onWindowResize();
    }, 200);
  });
};
/**
 * Set global variables
 */


$.code.setVars = function () {
  var self = this;

  if (window.location.host.indexOf('localhost') > -1 || window.location.host.indexOf('myshopify') > -1) {
    $.code.debug = true;
  }

  if ($.code.debug) {
    console.log('Init CODE js with debugging');
  } // Get window width


  $.code.onWindowResize(); // Check for localstorage

  $.code.localStorage = $.code.localStorageTest(); // Set if page is in theme editor

  if (Shopify.designMode) {
    $.code.themeEditor = true;
    $('body').addClass('theme-editor');

    if ($.code.debug) {
      console.log('Theme editor active');
    }
  }
};
/**
 * Test for localStorage
 */


$.code.localStorageTest = function () {
  var test = 'test';

  try {
    localStorage.setItem(test, test);
    localStorage.removeItem(test);
    return true;
  } catch (e) {
    return false;
  }
};
/**
 * Download Files
 */


$('[data-download-files]').on('click', function (event) {
  $('[data-download-files]').html('Assembling List');
  /*
  Get a list of all files within the Shopify Admin (/admin/settings/files)
  This needs to be run within the Chrome Browser. Paste into the debug console and run...
  A text file will download when done.
  */

  var counter = 0;
  var fileCounter = 0;
  var fileArray = [];

  var saveList = function saveList(fileArray) {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    var blob = new Blob(["\uFEFF", fileArray.join('\n')], {
      type: 'text/plain'
    }),
        link = window.URL.createObjectURL(blob);
    a.href = link;
    a.download = 'file-urls-list' + '.txt';
    console.log(fileCounter, ' files added to file.');
    console.log(counter, ' iterations');
    a.click();
    $('[data-download-files]').html('Assembling Done<br>Click to Download again.');
    window.URL.revokeObjectURL(link);
  };

  var getFiles = function getFiles(url) {
    fetch(url).then(function (response) {
      response.text().then(function (text) {
        var parser = new DOMParser();
        var htmlDoc = parser.parseFromString(text, 'text/html');
        var fields = htmlDoc.getElementsByTagName('img');

        for (var i = 0; i < fields.length; i++) {
          var source = fields[i].src.replace('_60x60', '');
          fileArray.push(source);
          fileCounter += 1;
        }

        ;
      });
    });
  };

  var adminUrls = ['https://ring-uk.myshopify.com/admin/settings/files?limit=250', 'https://ring-uk.myshopify.com/admin/settings/files?limit=250&after=eyJsYXN0X2lkIjoyMDE3NDY1Mzk4MDc2NSwibGFzdF92YWx1ZSI6IjIwMjEtMDEtMjcgMTQ6MzM6NTguMDAwMDAwIn0%3D', 'https://ring-uk.myshopify.com/admin/settings/files?limit=250&after=eyJsYXN0X2lkIjo5NDQyODgwODgwNzMzLCJsYXN0X3ZhbHVlIjoiMjAyMC0wNS0wNCAwODowNToyOS4wMDAwMDAifQ%3D%3D', 'https://ring-uk.myshopify.com/admin/settings/files?limit=250&after=eyJsYXN0X2lkIjo5NDM5NzI2MDc1OTk3LCJsYXN0X3ZhbHVlIjoiMjAyMC0wMy0zMCAxNjozMzoyOS4wMDAwMDAifQ%3D%3D', 'https://ring-uk.myshopify.com/admin/settings/files?limit=250&after=eyJsYXN0X2lkIjo5Mzk1ODc0OTU1MzU3LCJsYXN0X3ZhbHVlIjoiMjAxOS0wMy0xNSAxMToxMjo1MC4wMDAwMDAifQ%3D%3D'];

  for (var i = 0; i < adminUrls.length; i++) {
    var url = adminUrls[i];
    getFiles(url);
    counter += 1;
  }

  ;

  if (counter === 5) {
    saveList(fileArray);
  }
});
/**
 * Initialize CODE JS
 */

$.code.init();
/**
 * shopify Theme editor Events
 */

if ($.code.themeEditor) {
  $(document).on('shopify:section:load', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId; // Re-init featured product

    if ($parentSection.hasClass('product-featured-section')) {
      $('[data-section-type="product"]', $parentSection).product();
    } // Re-init swiper


    if ($parentSection.hasClass('swiper-section')) {
      $('[data-swiper]', $parentSection).swiperLoader();
    }
  }).on('shopify:section:reorder', function (e) {}).on('shopify:section:unload', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;
  }).on('shopify:block:select', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId; // Edit swiper slide

    if ($parentSection.hasClass('swiper-section')) {
      var $slide = $(e.target);
      $('[data-swiper]', $parentSection).swiperLoader('editSlide', $slide);
    }
  }).on('shopify:block:deselect', function (e) {
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);
    var blockId = e.detail.blockId;
  });
} // Legacy country selector page, to be deleted soon


$('.country-selector-title').bind({
  click: function click() {
    $(this).parent().toggleClass('on');
    $(this).toggleClass('on');
  }
}); // temporarily remove shopify analytics

var shopifyAnalyticsTag = document.querySelector('.analytics');

if (shopifyAnalyticsTag) {
  shopifyAnalyticsTag.remove();
} // video mute function


$('.js-tab-button__mute').bind({
  click: function click() {
    var self = $(this);
    var videoId = $(this).data('button-mute');
    var video = self.prev('.js-tab-video__mute');

    if (self.hasClass('is-muted')) {
      video.prop('muted', false);
      self.toggleClass('is-muted', false);
    } else {
      video.prop('muted', true);
      self.toggleClass('is-muted', true);
    }
  }
}); // Privacy page videos (protect plan sections)

$(window).on('scroll', function () {
  $('video.privacy-protect-video').each(function () {
    // check if the video is in the viewport to autoplay and remove the play button
    if ($(this).visible()) {
      $(this)[0].play();
      $(this).siblings('#video-overlay').removeClass('playing');
    } // check if video is ended and show the play button and first frame of the video


    $(this).on('ended', function () {
      $(this)[0].currentTime = 0;
      $(this).siblings('#video-overlay').addClass('playing');
    });
  });
}); //  video onclick play

$('[data-onclick-toggle-play]').bind({
  click: function click() {
    var self = $(this);
    var videoId = self.data('onclick-toggle-play');
    var video = $('#' + videoId);
    console.log(!video[0].paused);
    var elem = document.getElementById(videoId);
    elem.addEventListener("ended", function () {
      elem.currentTime = 0;
      self.addClass('playing');
    });

    if (!video[0].paused) {
      video[0].pause();
      video.prop('muted', true);
      self.toggleClass('playing');
    } else {
      video.prop('muted', false);
      video[0].play();
      self.toggleClass('playing');
    }
  }
}); // show offline message for chat icon

$(".js-kustomer-offline-icon").hover(function () {
  $(".js-offline-message").show();
}, function () {
  $(".js-offline-message").hide();
}); // Cookie getter

function getCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");

    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);

      if (c_end == -1) {
        c_end = document.cookie.length;
      }

      return unescape(document.cookie.substring(c_start, c_end));
    }
  }

  return "";
} // Implement a hover swap of featured image for product variant color swatches


$('label.color-swatch').mouseenter(function () {
  var imgUrl = $(this).data('featured-image');

  if ($(window).width() > 1024) {
    var featuredImage = $(this).closest('.primary-image').find('img');
    $(featuredImage).attr('src', imgUrl);
  } else {
    var featuredImage = $(this).closest('.primary-image').find('picture source');
    $(featuredImage).attr('srcset', imgUrl);
  }
}).mouseleave(function () {
  var originalImage = $(this).closest('.primary-image').find('img');
  var originalSrc = $(originalImage).data('original-src');

  if ($(window).width() > 1024) {
    $(originalImage).attr('src', originalSrc);
  } else {
    var responsiveImage = $(this).closest('.primary-image').find('picture source[media="(max-width: 1024px)"]');
    $(responsiveImage).attr('srcset', originalSrc);
  }
});
$('.color-label').click(function () {
  var originalSrc = $(originalImage).data('original-src');
  $(originalImage).attr('srcset', originalSrc);
  window.location.href = originalSrc;
}); // Country select page mobile accordion functionality

$('.region_title').bind({
  click: function click() {
    $(this).parent().toggleClass('on');
    $(this).toggleClass('on');
  }
}); // Show and hide Alarm Ireland content for visitors

function alarmBlock() {
  var country = "";
  var visitCountry = getCookie('_shopify_country');
  var chosenCountry = getCookie('chosen_country');

  if (chosenCountry) {
    country = chosenCountry;
  } else {
    country = visitCountry;
  }

  var modalClosed = sessionStorage.getItem('modalClosed');
  var AlarmCountries = ['Ireland', 'IE', 'Germany', 'DE', 'Austria', 'AT', 'Netherlands', 'NL', 'Belgium', 'BE', 'France', 'FR', 'Luxembourg', 'LU', 'Monaco', 'MC', 'Switzerland', 'CH', 'Spain', 'ES', 'Sweden', 'SE', 'Norway', 'NO', 'Finland', 'FI', 'Denmark', 'DK', 'Iceland', 'IS', 'United+Kingdom', 'GB']; // Added ireland only for coming soon button on PDP, since german launch was delayed

  var IrelandOnly = ['Ireland', 'IE'];

  if ($.inArray(country, AlarmCountries) === -1) {
    if (modalClosed === "true") {
      $('.js-alarm-unavailable-messaging:not(.js-modal)').removeClass('is-hidden');
    } else {
      $('.js-alarm-unavailable-messaging').removeClass('is-hidden');
    }
  }

  if ($.inArray(country, AlarmCountries) > -1) {
    $('.js-alarm-available-messaging').removeClass('is-hidden');
  }
} // Closes modal and saves a boolean in session storage.


function modalClose() {
  $('.js-modal').addClass('is-closing');
  $('.js-modal__container').addClass('is-closing');
  sessionStorage.setItem('modalClosed', 'true');
  setTimeout(function () {
    $('.js-modal').hide();
  }, 400);
} // AOS (Animate on scroll)
// if(typeof AOS !== null) {
//   AOS.init({
//     disable: 'mobile',
//     easing: 'ease-in-out',
//     once: true
//   });
// }


$(document).ready(function () {
  // if (window.location.hash.length > 0) {
  //   var cleanHash = window.location.hash.substring(1).split('?')[0];
  //   $('[data-kit-builder-wrapper]').removeClass('selected');
  //   var selector = '[data-selected-product="' + cleanHash + '"]';
  //
  //   switch (cleanHash) {
  //     // Alarm Pack S
  //     case 'alarm-security-5-piece-kit-gen-2':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-5-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Pack M
  //     case 'alarm-security-7-piece-kit-gen-2':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-7-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Pack L
  //     case 'alarm-security-10-piece-kit-gen-2':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-10-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Pack M - siren
  //     case 'alarm-security-8-piece-kit-gen-2':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-8-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Pack L - siren
  //     case 'alarm-security-11-piece-kit-gen-2':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-11-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Pack XL
  //     case 'alarm-security-13-piece-kit-gen-2':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-13-piece-kit-gen-2"]').click();
  //       break;
  //     // Alarm Stick Up Cam Pack M
  //     case 'alarm-stick-up-cam-pack-m':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-stick-up-cam-pack-m"]').click();
  //       break;
  //     // Alarm Stick Up Cam Pack L
  //     case 'alarm-stick-up-cam-pack-l':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-stick-up-cam-pack-l"]').click();
  //       break;
  //     // Alarm Stick Up Cam Pack M - siren
  //     case 'alarm-stick-up-cam-siren-pack-m':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-stick-up-cam-siren-pack-m"]').click();
  //       break;
  //     // Alarm Stick Up Cam Pack L - siren
  //     case 'alarm-stick-up-cam-siren-pack-l':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-stick-up-cam-siren-pack-l"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack S
  //     case 'alarm-security-5-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-5-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack M
  //     case 'alarm-security-7-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack L
  //     case 'alarm-security-10-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack M - siren
  //     case 'alarm-security-8-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack L - siren
  //     case 'alarm-security-11-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Pack XL
  //     case 'alarm-security-13-piece-kit-gen-2-indoor-cam':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-security-13-piece-kit-gen-2-indoor-cam"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack S
  //     case 'alarm-black-indoor-cam-pack-s':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-pack-s"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack M
  //     case 'alarm-black-indoor-cam-pack-m':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-pack-m"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack L
  //     case 'alarm-black-indoor-cam-pack-l':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-pack-l"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack M - siren
  //     case 'alarm-black-indoor-cam-siren-pack-m':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-siren-pack-m"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack L - siren
  //     case 'alarm-black-indoor-cam-siren-pack-l':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-siren-pack-l"]').click();
  //       break;
  //     // Alarm Indoor Camera Black Pack XL
  //     case 'alarm-black-indoor-cam-siren-pack-xl':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-black-indoor-cam-siren-pack-xl"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack S
  //     case 'alarm-doorbell-camera-pack-s':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-pack-s"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack M
  //     case 'alarm-doorbell-camera-pack-m':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-pack-m"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack L
  //     case 'alarm-doorbell-camera-pack-l':
  //       $('[data-select-nosiren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-pack-l"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack M - siren
  //     case 'alarm-doorbell-camera-siren-pack-m':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-siren-pack-m"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack L - siren
  //     case 'alarm-doorbell-camera-siren-pack-l':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-siren-pack-l"]').click();
  //       break;
  //     // Alarm Doorbell Camera Pack XL
  //     case 'alarm-doorbell-camera-siren-pack-xl':
  //       $('[data-select-siren]').click();
  //       $('[data-selected-product="alarm-doorbell-camera-siren-pack-xl"]').click();
  //       break;
  //   }
  // } else {
  var $firstOptionProduct = $('[data-kit-builder-wrapper]').first();
  var optionAvailable = $firstOptionProduct.data('available');
  var optionAmazonLink = $firstOptionProduct.data('external-link');
  var optionTitle = $firstOptionProduct.data('selected-title');
  var optionCta = $firstOptionProduct.data('cta-type');
  var optionDualCta = $firstOptionProduct.data('dual-cta');

  if (optionAvailable === false) {
    if (optionCta === 'amazon') {
      $('[data-kit-product-title]').text(optionTitle);
      $('[data-kit-nostock-amazon-link]').attr('href', optionAmazonLink);
      $('[data-kit-nostock-amazon]').removeClass('is-hidden');
      $('.cta-type-amazon').removeClass('is-hidden');
      $('.cta-type-amazon').attr('data-amazon-link', optionAmazonLink);
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    } else if (optionCta === 'soldout') {
      $('.cta-type-soldout').removeClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    } else if (optionCta === 'unavailable') {
      $('[data-kit-nostock]').removeClass('is-hidden');
      $('.cta-type-unavailable').removeClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    } else if (optionCta === 'comingsoon') {
      $('.cta-type-comingsoon').removeClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    }
  } else if (optionAvailable === true && optionCta === 'amazon') {
    // when redirect to Amazon setting is turned on during promo periods (DE)
    $('.cta-type-amazon').removeClass('is-hidden');
    $('.cta-type-amazon').attr('data-amazon-link', optionAmazonLink);
    $('.cta-type-cart-secondary').removeClass('is-hidden');
  } else if (optionAvailable === true && optionDualCta === true && optionAmazonLink !== "") {
    // when Dual CTAs are active
    $('.cta-type-cart').removeClass('is-hidden');
    $('[data-dual-cta-test-amazon-button]').removeClass('is-hidden');
    $('[data-dual-cta-test-amazon-button]').attr('href', optionAmazonLink);
  } else {
    $('.cta-type-cart').removeClass('is-hidden');
  }

  var cleanPath = window.location.pathname.split('/products/')[1];
  $('[data-kit-builder-wrapper]').removeClass('selected');
  var selector = '[data-selected-product="' + cleanPath + '"]';

  switch (cleanPath) {
    // Alarm Pack S
    case 'alarm-security-5-piece-kit-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-5-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack M

    case 'alarm-security-7-piece-kit-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack L

    case 'alarm-security-10-piece-kit-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack M - siren

    case 'alarm-security-8-piece-kit-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack L - siren

    case 'alarm-security-11-piece-kit-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack XL

    case 'alarm-security-13-piece-kit-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-13-piece-kit-gen-2"]').click();
      break;
    // Alarm Stick Up Cam Pack M

    case 'alarm-stick-up-cam-pack-m':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-stick-up-cam-pack-m"]').click();
      break;
    // Alarm Stick Up Cam Pack L

    case 'alarm-stick-up-cam-pack-l':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-stick-up-cam-pack-l"]').click();
      break;
    // Alarm Stick Up Cam Pack M - siren

    case 'alarm-stick-up-cam-siren-pack-m':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-stick-up-cam-siren-pack-m"]').click();
      break;
    // Alarm Stick Up Cam Pack L - siren

    case 'alarm-stick-up-cam-siren-pack-l':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-stick-up-cam-siren-pack-l"]').click();
      break;
    // Alarm Indoor Camera Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack M - siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack L - siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack XL

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Cam Plus Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-5-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack M - siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack L - siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack XL - siren

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-plus':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-13-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Camera Black Pack S

    case 'alarm-black-indoor-cam-pack-s':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-pack-s"]').click();
      break;
    // Alarm Indoor Camera Black Pack M

    case 'alarm-black-indoor-cam-pack-m':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-pack-m"]').click();
      break;
    // Alarm Indoor Camera Black Pack L

    case 'alarm-black-indoor-cam-pack-l':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-pack-l"]').click();
      break;
    // Alarm Indoor Camera Black Pack M - siren

    case 'alarm-black-indoor-cam-siren-pack-m':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-m"]').click();
      break;
    // Alarm Indoor Camera Black Pack L - siren

    case 'alarm-black-indoor-cam-siren-pack-l':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-l"]').click();
      break;
    // Alarm Indoor Camera Black Pack XL

    case 'alarm-black-indoor-cam-siren-pack-xl':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-xl"]').click();
      break;
    // Alarm Doorbell Camera Pack S

    case 'alarm-doorbell-camera-pack-s':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-doorbell-camera-pack-s"]').click();
      break;
    // Alarm Doorbell Camera Pack M

    case 'alarm-doorbell-camera-pack-m':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-doorbell-camera-pack-m"]').click();
      break;
    // Alarm Doorbell Camera Pack L

    case 'alarm-doorbell-camera-pack-l':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-doorbell-camera-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack M - siren

    case 'alarm-doorbell-camera-siren-pack-m':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-m"]').click();
      break;
    // Alarm Doorbell Camera Pack L - siren

    case 'alarm-doorbell-camera-siren-pack-l':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack XL

    case 'alarm-doorbell-camera-siren-pack-xl':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-xl"]').click();
      break;
    // Alarm Doorbell Camera Pack S 2024

    case 'alarm-5-pc-security-kit-battery-doorbell-bundle':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-5-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack M 2024

    case 'alarm-7-pc-security-kit-battery-doorbell-bundle':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-7-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack L 2024

    case 'alarm-10-pc-security-kit-battery-doorbell-bundle':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-10-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack M - siren 2024

    case 'alarm-8-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-8-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack L - siren 2024

    case 'alarm-11-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-11-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack XL - siren 2024

    case 'alarm-13-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-13-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-nosiren]').click();
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack M - siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack L - siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack XL - siren

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-select-siren]').click();
      $('[data-selected-product="alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
  } // $('[data-kit-builder-wrapper].selected').removeClass('expanded');
  // $('[data-kit-builder-wrapper].selected').find('[data-product-panel]').slideUp();
  // $('[data-kit-builder-wrapper].selected').find('[data-collapsible-trigger-icon] i').removeClass('la-angle-up').addClass('la-angle-down');
  // }

});
$('[data-kit-builder-wrapper]').on('click', function (e) {
  var selectedProduct = $(this).data('selected-product');
  var selectedTitle = $(this).data('selected-title');
  var available = $(this).data('available');
  var amazonLink = $(this).data('external-link');
  var cta = $(this).data('cta-type');
  var dualCta = $(this).data('dual-cta'); // var newHash = '#' + selectedProduct;

  $('.button__funnel').addClass('is-hidden');
  $('.kit__nostock-text').addClass('is-hidden');
  $('.product-kit-notification--soon').addClass('is-hidden');

  if (available === false) {
    if (cta === 'amazon') {
      $('[data-kit-product-title]').text(selectedTitle);
      $('[data-kit-nostock-amazon-link]').attr('href', amazonLink);
      $('[data-kit-nostock-amazon]').removeClass('is-hidden');
      $('.cta-type-amazon').removeClass('is-hidden');
      $('.cta-type-amazon').attr('data-amazon-link', amazonLink);
      $('.cta-type-cart-secondary').addClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    } else if (cta === 'soldout') {
      $('.cta-type-soldout').removeClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    } else if (cta === 'unavailable') {
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
      $('[data-kit-nostock]').removeClass('is-hidden');
      $('.cta-type-unavailable').removeClass('is-hidden');
    } else if (cta === 'comingsoon') {
      $('.cta-type-comingsoon').removeClass('is-hidden');
      $('[data-dual-cta-test-amazon-button]').addClass('is-hidden');
    }
  } else if (available === true && cta === 'amazon') {
    // when redirect to Amazon setting is turned on during promo periods (DE)
    $('.cta-type-amazon').removeClass('is-hidden');
    $('.cta-type-amazon').attr('data-amazon-link', amazonLink);
    $('.cta-type-cart-secondary').removeClass('is-hidden');
  } else if (available === true && dualCta === true && amazonLink !== "") {
    // when Dual CTAs are active
    $('.cta-type-cart').removeClass('is-hidden');
    $('[data-dual-cta-test-amazon-button]').attr('href', amazonLink);
    $('[data-dual-cta-test-amazon-button]').removeClass('is-hidden');
  } else {
    $('.cta-type-cart').removeClass('is-hidden');
  } // history.pushState(null, null, newHash);


  if ($(this).hasClass('selected') && $(this).hasClass('expanded')) {// $(this).removeClass('expanded');
    // $(this).find('[data-product-panel]').slideUp();
    // $('[data-kit-builder-wrapper]').find('[data-collapsible-trigger-icon] i').removeClass('la-angle-up').addClass('la-angle-down');
  } else if ($(this).hasClass('selected') && !$(this).hasClass('expanded')) {
    $(this).addClass('expanded');
    $(this).find('[data-product-panel]').slideDown();
    $(this).find('[data-collapsible-trigger-icon] i').removeClass('la-angle-down').addClass('la-angle-up');
  } else {
    $('[data-kit-builder-wrapper]').removeClass('selected');
    $('[data-kit-builder-wrapper]').find('[data-product-panel]').slideUp();
    $('[data-kit-builder-wrapper]').find('[data-collapsible-trigger-icon] i').removeClass('la-angle-up').addClass('la-angle-down');
    $(this).addClass('selected expanded');
    $(this).find('[data-product-panel]').slideDown();
    $(this).find('[data-collapsible-trigger-icon] i').removeClass('la-angle-down').addClass('la-angle-up');
  }

  $('input[data-kit-builder-product]').attr('checked', false);
  $(this).find('input[data-kit-builder-product]').attr('checked', true);

  if ($('label.color-swatch-idc').length > 0) {
    $(this).find('label.color-swatch-idc').removeClass('checked');
    $(this).find('label.color-swatch-idc').first().addClass('checked');
    $(this).find('.indoor-cam-addon img').attr('src', 'https://cdn.shopify.com/s/files/1/2418/9735/products/IDC_front_150x150@3x.png?v=1642603774');
  }

  $(this)[0].scrollIntoView({
    behavior: "smooth",
    block: "end",
    inline: "nearest"
  });
  var handle = $(this).data('selected-product');
  var imageSelector = '[data-selected-product-image="' + handle + '"]';
  $('.product-single-image').addClass('is-hidden');

  if ($('.product-single-image').length > 0) {
    $(imageSelector).removeClass('is-hidden');
  } else if ($('[data-product-thumb]').length > 0) {
    $('[data-product-thumb]').addClass('is-hidden');
    $(imageSelector).removeClass('is-hidden');
    var mainIndex = $(imageSelector).first().data('thumb-index');
    mainIndex -= 1;
    var swiper = document.querySelector('.swiper-container-horizontal').swiper;
    swiper.slideTo(mainIndex, false, false);
  }
});
$('[data-select-siren]').on('click', function () {
  $('.kit-builder-item-siren').removeClass('selected');
  $(this).addClass('selected');
  var currentSelected = $('.kit-builder-item.selected');
  currentSelected.removeClass('selected');

  switch (currentSelected.data('selected-product')) {
    // Alarm Pack S
    case 'alarm-security-5-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack M

    case 'alarm-security-7-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack L

    case 'alarm-security-10-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2"]').click();
      break;
    // Alarm Stick Up Cam Pack M

    case 'alarm-stick-up-cam-pack-m':
      $('[data-selected-product="alarm-stick-up-cam-siren-pack-m"]').click();
      break;
    // Alarm Stick Up Cam Pack L

    case 'alarm-stick-up-cam-pack-l':
      $('[data-selected-product="alarm-stick-up-cam-siren-pack-l"]').click();
      break;
    // Alarm Indoor Camera Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Cam Plus Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Camera Black Pack S

    case 'alarm-black-indoor-cam-pack-s':
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-m"]').click();
      break;
    // Alarm Indoor Camera Black Pack M

    case 'alarm-black-indoor-cam-pack-m':
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-m"]').click();
      break;
    // Alarm Indoor Camera Black Pack L

    case 'alarm-black-indoor-cam-pack-l':
      $('[data-selected-product="alarm-black-indoor-cam-siren-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack S

    case 'alarm-doorbell-camera-pack-s':
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-m"]').click();
      break;
    // Alarm Doorbell Camera Pack M

    case 'alarm-doorbell-camera-pack-m':
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-m"]').click();
      break;
    // Alarm Doorbell Camera Pack L

    case 'alarm-doorbell-camera-pack-l':
      $('[data-selected-product="alarm-doorbell-camera-siren-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack S 2024

    case 'alarm-5-pc-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-8-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack M 2024

    case 'alarm-7-pc-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-11-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack L 2024

    case 'alarm-10-pc-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-13-pc-siren-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack S

    case 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack M

    case 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack L

    case 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
  }

  $('.siren').show();
  $('.no-siren').hide();
  window.scrollTo(0, 0);
});
$('[data-select-nosiren]').on('click', function () {
  $('.kit-builder-item-siren').removeClass('selected');
  $(this).addClass('selected');
  var currentSelected = $('.kit-builder-item.selected');
  currentSelected.removeClass('selected');

  switch (currentSelected.data('selected-product')) {
    // Alarm Pack M with Siren
    case 'alarm-security-8-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack L with Siren

    case 'alarm-security-11-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2"]').click();
      break;
    // Alarm Pack XL with Siren

    case 'alarm-security-13-piece-kit-gen-2':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2"]').click();
      break;
    // Alarm Stick Up Cam Pack M with Siren

    case 'alarm-stick-up-cam-siren-pack-m':
      $('[data-selected-product="alarm-stick-up-cam-pack-m"]').click();
      break;
    // Alarm Stick Up Cam Pack L with Siren

    case 'alarm-stick-up-cam-siren-pack-l':
      $('[data-selected-product="alarm-stick-up-cam-pack-l"]').click();
      break;
    // Alarm Indoor Camera Pack M with Siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack L with Siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Camera Pack XL with Siren

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2"]').click();
      break;
    // Alarm Indoor Cam Plus Pack M with Siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack L with Siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Cam Plus Pack XL with Siren

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-plus':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-plus"]').click();
      break;
    // Alarm Indoor Camera Black Pack M with Siren

    case 'alarm-black-indoor-cam-siren-pack-m':
      $('[data-selected-product="alarm-black-indoor-cam-pack-m"]').click();
      break;
    // Alarm Indoor Camera Black Pack L with Siren

    case 'alarm-black-indoor-cam-siren-pack-l':
      $('[data-selected-product="alarm-black-indoor-cam-pack-l"]').click();
      break;
    // Alarm Indoor Camera Black Pack XL

    case 'alarm-black-indoor-cam-siren-pack-xl':
      $('[data-selected-product="alarm-black-indoor-cam-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack M with Siren

    case 'alarm-doorbell-camera-siren-pack-m':
      $('[data-selected-product="alarm-doorbell-camera-pack-m"]').click();
      break;
    // Alarm Doorbell Camera Pack L with Siren

    case 'alarm-doorbell-camera-siren-pack-l':
      $('[data-selected-product="alarm-doorbell-camera-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack XL with Siren

    case 'alarm-doorbell-camera-siren-pack-xl':
      $('[data-selected-product="alarm-doorbell-camera-pack-l"]').click();
      break;
    // Alarm Doorbell Camera Pack M - siren 2024

    case 'alarm-8-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-5-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack L - siren 2024

    case 'alarm-11-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-7-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm Doorbell Camera Pack XL - siren 2024

    case 'alarm-13-pc-siren-security-kit-battery-doorbell-bundle':
      $('[data-selected-product="alarm-10-pc-security-kit-battery-doorbell-bundle"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack M - siren

    case 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack L - siren

    case 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
    // Alarm + RPP + Indoor Camera Pack XL - siren

    case 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2-rpp':
      $('[data-selected-product="alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2-rpp"]').click();
      break;
  }

  $('.siren').hide();
  $('.no-siren').show();
  window.scrollTo(0, 0);
});

if (window.innerWidth > 768 && typeof alarmPack !== 'undefined') {
  var adjustHeight = $('.product-col-order').height();
  $('.product-primary').height(adjustHeight);

  if (window.location.hash.length > 0) {
    $('.product-primary').height(adjustHeight + 500);
  }
} // Fancybox popup for hero video


$('[data-hero-video-popup]').fancybox({
  src: "#hero-video-content",
  type: "inline",
  arrows: false,
  touch: false
}); // Fancybox popup for Energy label images

$('[data-energy-label-popup]').fancybox({
  src: "#energy-label-content",
  type: "inline",
  arrows: false,
  touch: false
}); // Fancybox popup for battery use Longfin

$('[data-battery-details-popup]').fancybox({
  src: "#battery-details-content",
  type: "inline",
  arrows: false,
  touch: false
}); // Fancybox popup for Alarm + Subs commitment confirmation

$('[data-confirm-subscription-popup]').fancybox({
  src: "#subscription-confirmation-content",
  type: "inline",
  arrows: false,
  touch: false
}); // Hide announce bar while scrolling on mobile

var announceBarExists = $('#announcement-bar').length > 0;

if (announceBarExists) {
  $(window).on('scroll', function () {
    var $announceBar = $('#announcement-bar');
    var $mobileMenu = $('#header');
    var $pageWrapper = $('.page-wrapper');

    if ($(window).scrollTop() > $announceBar.outerHeight()) {
      $mobileMenu.addClass('header--fixed');
      $pageWrapper.addClass('has-fixed-nav-mobile');
    } else {
      $mobileMenu.removeClass('header--fixed');
      $pageWrapper.removeClass('has-fixed-nav-mobile');
    }
  });
} // assign header offset for longer announcement bar text


function adjustAnnouncementOffset() {
  var $announceHeight = $('#announcement-bar').outerHeight();

  if ($.code.ww > 1024 && $announceHeight === 76) {
    $('#header').addClass('offset-xl');
  } else if ($.code.ww > 1024 && $announceHeight === 50) {
    $('#header').removeClass('offset-xl');
  }
}

;
adjustAnnouncementOffset(); // Sticky nav show on scroll after product-wrapper
// Update - excluding sticky filters on offers page, that will be developed into a standalone feature

var stickyNav = $('.sticky-nav:not(.sticky-filters)');

if (stickyNav.length > 0) {
  // Determine what kind of page it is and thus change the selector class
  var wrapperClassSelector = $('.product-wrapper').length > 0 ? '.product-wrapper' : '.pmp-banner-section';
  $(window).on('scroll', function () {
    // Check if we can find the wrapper html
    if (!$(wrapperClassSelector)) return;
    var scrollTop = $(window).scrollTop(),
        elementOffset = $(wrapperClassSelector).offset().top,
        height = $(wrapperClassSelector).outerHeight(),
        distance = elementOffset + height - 116;

    if (scrollTop > 300 && scrollTop > distance) {
      // Announce bar messes up the white space in combination with transform -100%
      if (announceBarExists) {
        stickyNav.addClass('sticky-nav--show');
      }

      setTimeout(function () {
        stickyNav.addClass('sticky-nav--opened');
      }, 200);
      $('.header-wrapper, .header-small').addClass('no-box-shadow');
    } else {
      if (announceBarExists) {
        stickyNav.removeClass('sticky-nav--show');
      }

      setTimeout(function () {
        stickyNav.removeClass('sticky-nav--opened');
      }, 200);
      $('.header-wrapper, .header-small').removeClass('no-box-shadow');
    }
  });
} // Mimic add to cart click from sticky nav menu


$('[data-sticky-atc]').on('click', function (e) {
  e.preventDefault();
  $('[data-ajax-cart-add-button]').trigger('click');
});

if (window.location.href.indexOf('products') > -1) {
  $('[data-media-play]').on('click', function () {
    var playerSlider = $(this).prev();

    if ($(playerSlider).hasClass('external_video')) {
      $(playerSlider)[0].src += "&autoplay=1";
    } else {
      $(playerSlider)[0].play();
    }

    $(this).hide();
  });
} // Product popular accesoires box product popup: OPEN


$('[data-product-popup-toggle]').on('click', function (e) {
  var variantId = $(this).data('product-popup-toggle');
  if (variantId === null) return;
  $("[data-product-popup-show=\"".concat(variantId, "\"")).addClass('is-open has-padding');
  $('body').addClass('no-scroll');
}); // Product popular accesoires box product popup: CLOSE ON CROSS

$('[data-product-popup-close]').on('click', function (e) {
  e.preventDefault();
  var $el = $('[data-product-popup-show].is-open');
  closeProductPopup($el);
}); // Product popular accesoires box product popup: CLOSE ON ESC KEY

$(document).keyup(function (e) {
  if (e.keyCode == 27 && $('[data-product-popup-show]').hasClass('is-open')) {
    var $el = $('[data-product-popup-show].is-open');
    closeProductPopup($el);
  }
}); // Function to close product popup (called several times)

function closeProductPopup($el) {
  if (typeof $el === 'undefined') return;
  $el.removeClass('is-open');
  setTimeout(function () {
    $el.removeClass('has-padding');
    $('body').removeClass('no-scroll');
  }, 200);
} // Close product popup on outside click


$('html').click(function (e) {
  if (!$('.product-pop-acc__popup.is-open').length) return;

  if ($(e.target).hasClass('product-pop-acc__popup') && $(e.target).hasClass('is-open')) {
    var $el = $('[data-product-popup-show].is-open');
    closeProductPopup($el);
  }

  ;
});
$('[data-show-rest]').on('click', function () {
  var text = $('[data-show-rest]').text().trim();
  var showLess = $('[data-show-rest]').data('less-text');
  var showMore = $('[data-show-rest]').data('more-text');
  $('.block-hidden-articles').slideToggle();
  $('[data-show-rest]').text(text == showMore ? showLess : showMore);
});
$(window).scroll(function (e) {
  if ($(window).scrollTop() >= ($(document).height() - $(window).height()) * 0.5) {
    try {
      versaTagObj.onready(function () {
        versaTagObj.setConditionalParam("scroll_rate", "percent_50");
        versaTagObj.generateRequest();
      });
      $(this).off(e);
    } catch (e) {
      console.log(e);
    }
  }
});

var selectIDC = function selectIDC(handleIDC, colorValue) {
  if (colorValue === 'Black') {
    $('.indoor-cam-addon img').attr('src', 'https://cdn.shopify.com/s/files/1/2418/9735/products/IDCBlack_front2_1000x1000_c7fed1e4-794a-4571-87df-98c7977dd0aa_150x150@3x.png?v=1642603774');
  } else {
    $('.indoor-cam-addon img').attr('src', 'https://cdn.shopify.com/s/files/1/2418/9735/products/IDC_front_150x150@3x.png?v=1642603774');
  }

  $('input[data-kit-builder-product]').attr('checked', false);
  $("[data-selected-product=\"".concat(handleIDC, "\"]")).find('[data-kit-builder-product]').attr("checked", true);
  var url = new URL(window.location.href);

  if (colorValue === 'Black') {
    url.searchParams.set('variant', 'black');
  } else {
    url.searchParams.delete('variant');
  }

  history.pushState('', '', url);
  var handle = $("[data-selected-product=\"".concat(handleIDC, "\"]")).data('selected-product');
  var imageSelector = '[data-selected-product-image="' + handle + '"]';

  if ($('.product-single-image').length > 0) {
    $(imageSelector).removeClass('is-hidden');
  } else if ($('[data-product-thumb]').length > 0) {
    $('[data-product-thumb]').addClass('is-hidden');
    $(imageSelector).removeClass('is-hidden');
    var mainIndex = $(imageSelector).first().data('thumb-index');
    mainIndex -= 1;
    var swiper = document.querySelector('.swiper-container-horizontal').swiper;
    swiper.slideTo(mainIndex, false, false);
  }
};

$('label.color-swatch-idc').on('click', function (e) {
  e.stopImmediatePropagation();
  $('label.color-swatch-idc').removeClass('checked');
  $(this).addClass('checked');
  var mainProduct = $(this).data('main-product');
  var colorValue = $(this).attr('value');

  if (mainProduct === 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-pack-s', colorValue);
  } else if (mainProduct === 'alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-5-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  } else if (mainProduct === 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-pack-m', colorValue);
  } else if (mainProduct === 'alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-7-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  } else if (mainProduct === 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-pack-l', colorValue);
  } else if (mainProduct === 'alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-10-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  } else if (mainProduct === 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-siren-pack-m', colorValue);
  } else if (mainProduct === 'alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-8-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  } else if (mainProduct === 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-siren-pack-l', colorValue);
  } else if (mainProduct === 'alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-11-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  } else if (mainProduct === 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'Black') {
    selectIDC('alarm-black-indoor-cam-siren-pack-xl', colorValue);
  } else if (mainProduct === 'alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2' && colorValue === 'White') {
    selectIDC('alarm-security-13-piece-kit-gen-2-indoor-cam-gen-2', colorValue);
  }
});
$(document).ready(function () {
  if (window.location.search.indexOf('black') > -1) {
    $('.kit-builder-item.selected').find('label.color-swatch-idc').click();
  }
});
/********** Responsive Video **********/
//get all responsive videos

var responsiveVideo = document.querySelectorAll('#responsive-video'); //set video src and poster

function setResponsiveVideoSource(element, src, poster) {
  element.setAttribute('src', src);
  element.setAttribute('poster', poster);
} //determine screen size and select mobile, tablet, or desktop video src and poster/fallback


function whichSizeVideo(element, src) {
  var currentSrc = element.getAttribute('src');
  var desktopSrc = src.dataset.desktopVid;
  var tabletSrc = src.dataset.tabletVid;
  var mobileSrc = src.dataset.mobileVid;
  var currentPoster = element.getAttribute('poster');
  var desktopPoster = element.dataset.desktopPoster;
  var tabletPoster = element.dataset.tabletPoster;
  var mobilePoster = element.dataset.mobilePoster;

  if ($.code.ww > 1024 && desktopSrc != currentSrc && desktopPoster != currentPoster) {
    setResponsiveVideoSource(element, desktopSrc, desktopPoster);
  } else if ($.code.ww > 768 && $.code.ww < 1024 && tabletSrc != currentSrc && tabletPoster != currentPoster) {
    setResponsiveVideoSource(element, tabletSrc, tabletPoster);
  } else if ($.code.ww < 767 && mobileSrc != currentSrc && mobilePoster != currentPoster) {
    setResponsiveVideoSource(element, mobileSrc, mobilePoster);
  }
} //init only if page has responsive videos


function responsiveVideoSetSize() {
  if (responsiveVideo !== undefined) {
    responsiveVideo.forEach(function (element, index) {
      whichSizeVideo(element, //element
      element //src locations
      );
    });
  }
}

responsiveVideoSetSize(); //PROMO EMAIL POPUP

if ($("#promo-email-popup").length > 0) {
  // Convert hours to milliseconds 
  // Cookie Getter
  var getCookieValue = function getCookieValue(cookieName) {
    var cookie = document.cookie.split('; ').find(function (cookie) {
      return cookie.startsWith(cookieName + '=');
    });
    return cookie ? cookie.split('=')[1] : null;
  }; // Cookie Setter


  var setCookie = function setCookie(cookieName, cookieValue, expirationMilliseconds) {
    var expirationDate = new Date();
    expirationDate.setTime(expirationDate.getTime() + expirationMilliseconds);
    var cookieString = cookieName + '=' + cookieValue + '; expires=' + expirationDate.toUTCString() + '; path=/';
    document.cookie = cookieString;
  }; // Fancybox Popup


  var initPromoEmailPopup = function initPromoEmailPopup(delay) {
    setTimeout(function () {
      $.fancybox.open({
        src: '#promo-email-content',
        type: 'inline',
        beforeClose: function beforeClose() {
          // Set the 'popupClosed' cookie when the popup is closed
          var lastClosedTime = new Date().getTime();
          setCookie(popupClosedCookieName, lastClosedTime, popupCooldown);
        },
        afterClose: function afterClose() {
          // Set the 'popupSubmitted' cookie after the form is submitted
          var formSubmitted = $('#contact_form').data('submitted');

          if (formSubmitted) {
            setCookie(popupSubmittedCookieName, 1, 365 * 24 * 60 * 60 * 1000); // 1 year expiration
          }
        }
      });
    }, delay);
  };

  var popupSubmittedCookieName = 'promoPopupSubmitted';
  var popupClosedCookieName = 'promoPopupClosed';
  var popupAutoClose = $('#promo-email-popup').data('popup-autoclose') * 1000; // Convert seconds to milliseconds

  if (window.location.href.indexOf("?customer_posted=true") > -1) {
    var popupDelay = 0;
    setTimeout(function () {
      $.fancybox.close();
    }, popupAutoClose);
  } else {
    var popupDelay = $('#promo-email-popup').data('popup-delay') * 1000;
  }

  var popupCooldown = $('#promo-email-popup').data('popup-cooldown') * 60 * 60 * 1000;
  $(document).ready(function () {
    var popupSubmittedValue = getCookieValue(popupSubmittedCookieName);

    if (!popupSubmittedValue) {
      var popupClosedValue = getCookieValue(popupClosedCookieName);

      if (!popupClosedValue || popupClosedValue && new Date().getTime() - popupClosedValue >= popupCooldown) {
        initPromoEmailPopup(popupDelay);
      }
    }
  });
} //Ring Home module accordion image changes


var subsModuleTrigger = $('.accordion-frame [data-collapsible-trigger]');
var subsModuleActiveImage = $('[data-ring-home-module-img]');
subsModuleTrigger.on('click', function () {
  var $target = $(this).parent().siblings('.collapsible__is-open').children('[data-collapsible-target]'); // Animate target closed

  var totalHeight = 0;
  $target.children().each(function () {
    totalHeight = totalHeight + $(this).outerHeight(true);
  });
  $target.stop().css({
    maxHeight: totalHeight
  }).animate({
    maxHeight: 0
  }, function () {
    // Toggle class on parent and close all children
    $(this).parent().removeClass('collapsible__is-open').find('.collapsible__is-open').removeClass('collapsible__is-open');
    $target.css({
      maxHeight: ''
    });
  });
  var newImageUrl = $(this).data("img-src");
  subsModuleActiveImage.attr('src', newImageUrl);
});